(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("prop-types"), require("react"), require("styled-components"), require("react-dom"), require("react-resize-detector"), require("animejs"), require("react-transition-group"), require("markdown-to-jsx"));
	else if(typeof define === 'function' && define.amd)
		define(["prop-types", "react", "styled-components", "react-dom", "react-resize-detector", "animejs", "react-transition-group", "markdown-to-jsx"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("prop-types"), require("react"), require("styled-components"), require("react-dom"), require("react-resize-detector"), require("animejs"), require("react-transition-group"), require("markdown-to-jsx")) : factory(root["prop-types"], root["react"], root["styled-components"], root["react-dom"], root["react-resize-detector"], root["animejs"], root["react-transition-group"], root["markdown-to-jsx"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE__0__, __WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__, __WEBPACK_EXTERNAL_MODULE__23__, __WEBPACK_EXTERNAL_MODULE__82__, __WEBPACK_EXTERNAL_MODULE__88__, __WEBPACK_EXTERNAL_MODULE__245__, __WEBPACK_EXTERNAL_MODULE__260__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "./";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 158);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var validateFormat =  false ? undefined : function (format) {
  if (format === undefined) {
    throw new Error('invariant(...): Second argument must be a string.');
  }
};
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments to provide
 * information about what broke and what you were expecting.
 *
 * The invariant message will be stripped in production, but the invariant will
 * remain to ensure logic does not differ in production.
 */

function invariant(condition, format) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  validateFormat(format);

  if (!condition) {
    var error;

    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return String(args[argIndex++]);
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // Skip invariant's own stack frame.

    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
/**
 * Simple, lightweight module assisting with the detection and context of
 * Worker. Helps avoid circular dependencies and allows code to reason about
 * whether or not they are in a Worker, even if they never include the main
 * `ReactWorker` dependency.
 */

var ExecutionEnvironment = {
  canUseDOM: canUseDOM,
  canUseWorkers: typeof Worker !== 'undefined',
  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
  canUseViewport: canUseDOM && !!window.screen,
  isInWorker: !canUseDOM // For now, this is true - might change in the future.

};
module.exports = ExecutionEnvironment;

/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export API */
/* unused harmony export addWhitelistedStyleProp */
/* unused harmony export addWhitelistedTransformProp */
/* unused harmony export addWhitelistedInterpolationParam */
/* unused harmony export validateStyles */
/* unused harmony export validateTransform */
/* unused harmony export validateInterpolation */
/* unused harmony export generateNewNodeTag */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return generateNewAnimationId; });
/* unused harmony export assertNativeAnimatedModule */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return shouldUseNativeDriver; });
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _exports_NativeModules__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(35);
/* harmony import */ var _NativeEventEmitter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */





var NativeAnimatedModule = _exports_NativeModules__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].NativeAnimatedModule;
var __nativeAnimatedNodeTagCount = 1;
/* used for animated nodes */

var __nativeAnimationIdCount = 1;
/* used for started animations */

var nativeEventEmitter;
/**
 * Simple wrappers around NativeAnimatedModule to provide flow and autocmplete support for
 * the native module methods
 */

var API = {
  createAnimatedNode: function createAnimatedNode(tag, config) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.createAnimatedNode(tag, config);
  },
  startListeningToAnimatedNodeValue: function startListeningToAnimatedNodeValue(tag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.startListeningToAnimatedNodeValue(tag);
  },
  stopListeningToAnimatedNodeValue: function stopListeningToAnimatedNodeValue(tag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.stopListeningToAnimatedNodeValue(tag);
  },
  connectAnimatedNodes: function connectAnimatedNodes(parentTag, childTag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.connectAnimatedNodes(parentTag, childTag);
  },
  disconnectAnimatedNodes: function disconnectAnimatedNodes(parentTag, childTag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.disconnectAnimatedNodes(parentTag, childTag);
  },
  startAnimatingNode: function startAnimatingNode(animationId, nodeTag, config, endCallback) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.startAnimatingNode(animationId, nodeTag, config, endCallback);
  },
  stopAnimation: function stopAnimation(animationId) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.stopAnimation(animationId);
  },
  setAnimatedNodeValue: function setAnimatedNodeValue(nodeTag, value) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.setAnimatedNodeValue(nodeTag, value);
  },
  setAnimatedNodeOffset: function setAnimatedNodeOffset(nodeTag, offset) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.setAnimatedNodeOffset(nodeTag, offset);
  },
  flattenAnimatedNodeOffset: function flattenAnimatedNodeOffset(nodeTag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.flattenAnimatedNodeOffset(nodeTag);
  },
  extractAnimatedNodeOffset: function extractAnimatedNodeOffset(nodeTag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.extractAnimatedNodeOffset(nodeTag);
  },
  connectAnimatedNodeToView: function connectAnimatedNodeToView(nodeTag, viewTag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.connectAnimatedNodeToView(nodeTag, viewTag);
  },
  disconnectAnimatedNodeFromView: function disconnectAnimatedNodeFromView(nodeTag, viewTag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.disconnectAnimatedNodeFromView(nodeTag, viewTag);
  },
  dropAnimatedNode: function dropAnimatedNode(tag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.dropAnimatedNode(tag);
  },
  addAnimatedEventToView: function addAnimatedEventToView(viewTag, eventName, eventMapping) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.addAnimatedEventToView(viewTag, eventName, eventMapping);
  },
  removeAnimatedEventFromView: function removeAnimatedEventFromView(viewTag, eventName, animatedNodeTag) {
    assertNativeAnimatedModule();
    NativeAnimatedModule.removeAnimatedEventFromView(viewTag, eventName, animatedNodeTag);
  }
};
/**
 * Styles allowed by the native animated implementation.
 *
 * In general native animated implementation should support any numeric property that doesn't need
 * to be updated through the shadow view hierarchy (all non-layout properties).
 */

var STYLES_WHITELIST = {
  opacity: true,
  transform: true,

  /* ios styles */
  shadowOpacity: true,
  shadowRadius: true,

  /* legacy android transform properties */
  scaleX: true,
  scaleY: true,
  translateX: true,
  translateY: true
};
var TRANSFORM_WHITELIST = {
  translateX: true,
  translateY: true,
  scale: true,
  scaleX: true,
  scaleY: true,
  rotate: true,
  rotateX: true,
  rotateY: true,
  perspective: true
};
var SUPPORTED_INTERPOLATION_PARAMS = {
  inputRange: true,
  outputRange: true,
  extrapolate: true,
  extrapolateRight: true,
  extrapolateLeft: true
};

function addWhitelistedStyleProp(prop) {
  STYLES_WHITELIST[prop] = true;
}

function addWhitelistedTransformProp(prop) {
  TRANSFORM_WHITELIST[prop] = true;
}

function addWhitelistedInterpolationParam(param) {
  SUPPORTED_INTERPOLATION_PARAMS[param] = true;
}

function validateTransform(configs) {
  configs.forEach(function (config) {
    if (!TRANSFORM_WHITELIST.hasOwnProperty(config.property)) {
      throw new Error("Property '" + config.property + "' is not supported by native animated module");
    }
  });
}

function validateStyles(styles) {
  for (var key in styles) {
    if (!STYLES_WHITELIST.hasOwnProperty(key)) {
      throw new Error("Style property '" + key + "' is not supported by native animated module");
    }
  }
}

function validateInterpolation(config) {
  for (var key in config) {
    if (!SUPPORTED_INTERPOLATION_PARAMS.hasOwnProperty(key)) {
      throw new Error("Interpolation property '" + key + "' is not supported by native animated module");
    }
  }
}

function generateNewNodeTag() {
  return __nativeAnimatedNodeTagCount++;
}

function generateNewAnimationId() {
  return __nativeAnimationIdCount++;
}

function assertNativeAnimatedModule() {
  fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default()(NativeAnimatedModule, 'Native animated module is not available');
}

var _warnedMissingNativeAnimated = false;

function shouldUseNativeDriver(config) {
  if (config.useNativeDriver && !NativeAnimatedModule) {
    if (!_warnedMissingNativeAnimated) {
      console.warn('Animated: `useNativeDriver` is not supported because the native ' + 'animated module is missing. Falling back to JS-based animation. To ' + 'resolve this, add `RCTAnimation` module to this app, or remove ' + '`useNativeDriver`. ' + 'More info: https://github.com/facebook/react-native/issues/11094#issuecomment-263240420');
      _warnedMissingNativeAnimated = true;
    }

    return false;
  }

  return config.useNativeDriver || false;
}

var NativeAnimatedHelper = {
  API: API,
  addWhitelistedStyleProp: addWhitelistedStyleProp,
  addWhitelistedTransformProp: addWhitelistedTransformProp,
  addWhitelistedInterpolationParam: addWhitelistedInterpolationParam,
  validateStyles: validateStyles,
  validateTransform: validateTransform,
  validateInterpolation: validateInterpolation,
  generateNewNodeTag: generateNewNodeTag,
  generateNewAnimationId: generateNewAnimationId,
  assertNativeAnimatedModule: assertNativeAnimatedModule,
  shouldUseNativeDriver: shouldUseNativeDriver,

  get nativeEventEmitter() {
    if (!nativeEventEmitter) {
      nativeEventEmitter = new _NativeEventEmitter__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"](NativeAnimatedModule);
    }

    return nativeEventEmitter;
  }

};

/* harmony default export */ __webpack_exports__["a"] = (NativeAnimatedHelper);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_1__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



 // Note(vjeux): this would be better as an interface but flow doesn't
// support them yet

var AnimatedNode =
/*#__PURE__*/
function () {
  function AnimatedNode() {}

  var _proto = AnimatedNode.prototype;

  _proto.__attach = function __attach() {};

  _proto.__detach = function __detach() {
    if (this.__isNative && this.__nativeTag != null) {
      _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].API.dropAnimatedNode(this.__nativeTag);
      this.__nativeTag = undefined;
    }
  };

  _proto.__getValue = function __getValue() {};

  _proto.__getAnimatedValue = function __getAnimatedValue() {
    return this.__getValue();
  };

  _proto.__addChild = function __addChild(child) {};

  _proto.__removeChild = function __removeChild(child) {};

  _proto.__getChildren = function __getChildren() {
    return [];
  }
  /* Methods and props used by native Animated impl */
  ;

  _proto.__makeNative = function __makeNative() {
    if (!this.__isNative) {
      throw new Error('This node cannot be made a "native" animated node');
    }
  };

  _proto.__getNativeTag = function __getNativeTag() {
    _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].assertNativeAnimatedModule();
    fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_1___default()(this.__isNative, 'Attempt to get native tag from node not marked as "native"');

    if (this.__nativeTag == null) {
      var nativeTag = _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].generateNewNodeTag();
      _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].API.createAnimatedNode(nativeTag, this.__getNativeConfig());
      this.__nativeTag = nativeTag;
    }

    return this.__nativeTag;
  };

  _proto.__getNativeConfig = function __getNativeConfig() {
    throw new Error('This JS animated node type cannot be used as native animated node');
  };

  _proto.toJSON = function toJSON() {
    return this.__getValue();
  };

  return AnimatedNode;
}();

/* harmony default export */ __webpack_exports__["a"] = (AnimatedNode);

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ICON_PADDING; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return iconPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return iconDefaultProps; });
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(0);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable */


const ICON_PADDING = "2px";

const iconPropTypes = {
  className: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  color: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string,
  size: prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.string, prop_types__WEBPACK_IMPORTED_MODULE_0___default.a.number]) };


const iconDefaultProps = {
  className: '',
  color: "currentColor",
  size: "24px" };

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/modules/getBoundingClientRect/index.js
var getBoundingClientRect = __webpack_require__(30);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/modules/unitlessNumbers/index.js
var unitlessNumbers = __webpack_require__(49);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-dom/dangerousStyleValue/index.js
/* eslint-disable */

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * From React 16.0.0
 * 
 */

/**
 * Convert a value into the proper css writable value. The style name `name`
 * should be logical (no hyphens), as specified
 * in `CSSProperty.isUnitlessNumber`.
 *
 * @param {string} name CSS property name such as `topMargin`.
 * @param {*} value CSS property value such as `10px`.
 * @return {string} Normalized style value with dimensions applied.
 */

function dangerousStyleValue(name, value, isCustomProperty) {
  // Note that we've removed escapeTextForBrowser() calls here since the
  // whole string will be escaped when the attribute is injected into
  // the markup. If you provide unsafe user data here they can inject
  // arbitrary CSS which may be problematic (I couldn't repro this):
  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
  // This is not an XSS hole but instead a potential CSS injection issue
  // which has lead to a greater discussion about how we're going to
  // trust URLs moving forward. See #2115901
  var isEmpty = value == null || typeof value === 'boolean' || value === '';

  if (isEmpty) {
    return '';
  }

  if (!isCustomProperty && typeof value === 'number' && value !== 0 && !(unitlessNumbers["a" /* default */].hasOwnProperty(name) && unitlessNumbers["a" /* default */][name])) {
    return value + 'px'; // Presumes implicit 'px' suffix for unitless numbers
  }

  return ('' + value).trim();
}

/* harmony default export */ var react_dom_dangerousStyleValue = (dangerousStyleValue);
// EXTERNAL MODULE: ./node_modules/hyphenate-style-name/index.js
var hyphenate_style_name = __webpack_require__(45);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-dom/setValueForStyles/index.js
/* eslint-disable */

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * From React 16.3.0
 * 
 */



/**
 * Sets the value for multiple styles on a node.  If a value is specified as
 * '' (empty string), the corresponding style property will be unset.
 *
 * @param {DOMElement} node
 * @param {object} styles
 */

function setValueForStyles(node, styles, getStack) {
  var style = node.style;

  for (var styleName in styles) {
    if (!styles.hasOwnProperty(styleName)) {
      continue;
    }

    var isCustomProperty = styleName.indexOf('--') === 0;

    if (false) {}

    var styleValue = react_dom_dangerousStyleValue(styleName, styles[styleName], isCustomProperty);

    if (styleName === 'float') {
      styleName = 'cssFloat';
    }

    if (isCustomProperty) {
      var name = isCustomProperty ? styleName : Object(hyphenate_style_name["default"])(styleName);
      style.setProperty(name, styleValue);
    } else {
      style[styleName] = styleValue;
    }
  }
}

/* harmony default export */ var react_dom_setValueForStyles = (setValueForStyles);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/UIManager/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var UIManager_getRect = function getRect(node) {
  // Unlike the DOM's getBoundingClientRect, React Native layout measurements
  // for "height" and "width" ignore scale transforms.
  // https://developer.mozilla.org/en-US/docs/Web/API/CSS_Object_Model/Determining_the_dimensions_of_elements
  var _getBoundingClientRec = Object(getBoundingClientRect["a" /* default */])(node),
      x = _getBoundingClientRec.x,
      y = _getBoundingClientRec.y,
      top = _getBoundingClientRec.top,
      left = _getBoundingClientRec.left;

  var width = node.offsetWidth;
  var height = node.offsetHeight;
  return {
    x: x,
    y: y,
    width: width,
    height: height,
    top: top,
    left: left
  };
};

var _measureLayout = function measureLayout(node, relativeToNativeNode, callback) {
  var relativeNode = relativeToNativeNode || node && node.parentNode;

  if (node && relativeNode) {
    setTimeout(function () {
      var relativeRect = Object(getBoundingClientRect["a" /* default */])(relativeNode);

      var _getRect = UIManager_getRect(node),
          height = _getRect.height,
          left = _getRect.left,
          top = _getRect.top,
          width = _getRect.width;

      var x = left - relativeRect.left;
      var y = top - relativeRect.top;
      callback(x, y, width, height, left, top);
    }, 0);
  }
};

var focusableElements = {
  A: true,
  INPUT: true,
  SELECT: true,
  TEXTAREA: true
};
var UIManager = {
  blur: function blur(node) {
    try {
      node.blur();
    } catch (err) {}
  },
  focus: function focus(node) {
    try {
      var name = node.nodeName; // A tabIndex of -1 allows element to be programmatically focused but
      // prevents keyboard focus, so we don't want to set the value on elements
      // that support keyboard focus by default.

      if (node.getAttribute('tabIndex') == null && focusableElements[name] == null) {
        node.setAttribute('tabIndex', '-1');
      }

      node.focus();
    } catch (err) {}
  },
  measure: function measure(node, callback) {
    _measureLayout(node, null, callback);
  },
  measureInWindow: function measureInWindow(node, callback) {
    if (node) {
      setTimeout(function () {
        var _getRect2 = UIManager_getRect(node),
            height = _getRect2.height,
            left = _getRect2.left,
            top = _getRect2.top,
            width = _getRect2.width;

        callback(left, top, width, height);
      }, 0);
    }
  },
  measureLayout: function measureLayout(node, relativeToNativeNode, onFail, onSuccess) {
    _measureLayout(node, relativeToNativeNode, onSuccess);
  },
  updateView: function updateView(node, props, component
  /* only needed to surpress React errors in development */
  ) {
    for (var prop in props) {
      if (!Object.prototype.hasOwnProperty.call(props, prop)) {
        continue;
      }

      var value = props[prop];

      switch (prop) {
        case 'style':
          {
            react_dom_setValueForStyles(node, value, component._reactInternalInstance);
            break;
          }

        case 'class':
        case 'className':
          {
            node.setAttribute('class', value);
            break;
          }

        case 'text':
        case 'value':
          // native platforms use `text` prop to replace text input value
          node.value = value;
          break;

        default:
          node.setAttribute(prop, value);
      }
    }
  },
  configureNextLayoutAnimation: function configureNextLayoutAnimation(config, onAnimationDidEnd) {
    onAnimationDidEnd();
  },
  // mocks
  setLayoutAnimationEnabledExperimental: function setLayoutAnimationEnabledExperimental() {}
};
/* harmony default export */ var exports_UIManager = __webpack_exports__["a"] = (UIManager);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Svg", function() { return Svg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Circle", function() { return Circle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ClipPath", function() { return ClipPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Defs", function() { return Defs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Ellipse", function() { return Ellipse; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ForeignObject", function() { return ForeignObject; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return G; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Image", function() { return Image; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Line", function() { return Line; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LinearGradient", function() { return LinearGradient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Marker", function() { return Marker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Mask", function() { return Mask; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Path", function() { return Path; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Pattern", function() { return Pattern; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Polygon", function() { return Polygon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Polyline", function() { return Polyline; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RadialGradient", function() { return RadialGradient; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Rect", function() { return Rect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Stop", function() { return Stop; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Symbol", function() { return Symbol; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Text", function() { return Text; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextPath", function() { return TextPath; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TSpan", function() { return TSpan; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Use", function() { return Use; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_native_web__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(83);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/**
 * Copyright (c) 2017 Chris Baker <mail.chris.baker@gmail.com>
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 *
 */




const createReactElement =
  react_native_web__WEBPACK_IMPORTED_MODULE_1__["unstable_createElement"] || react__WEBPACK_IMPORTED_MODULE_0__["createElement"];

function createElement(name, type) {
  class CreateElement extends react__WEBPACK_IMPORTED_MODULE_0__["Component"] {
    render() {
      return createReactElement(type, this.props, this.props.children);
    }
  }

  CreateElement.displayName = name;

  CreateElement.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.node,
  };

  CreateElement.defaultProps = {
    children: undefined,
  };

  return CreateElement;
}

const Svg = createElement("Svg", "svg");

/* harmony default export */ __webpack_exports__["default"] = (Svg);
Svg.Svg = Svg; // stay consistent with the old require based api

const Circle = createElement("Circle", "circle");
Svg.Circle = Circle;

const ClipPath = createElement("ClipPath", "clipPath");
Svg.ClipPath = ClipPath;

const Defs = createElement("Defs", "defs");
Svg.Defs = Defs;

const Ellipse = createElement("Ellipse", "ellipse");
Svg.Ellipse = Ellipse;

const ForeignObject = createElement("ForeignObject", "foreignObject");
Svg.ForeignObject = ForeignObject;

const G = createElement("G", "g");
Svg.G = G;

const Image = createElement("Image", "image");
Svg.Image = Image;

const Line = createElement("Line", "line");
Svg.Line = Line;

const LinearGradient = createElement("LinearGradient", "linearGradient");
Svg.LinearGradient = LinearGradient;

const Marker = createElement("Marker", "marker");
Svg.Marker = Marker;

const Mask = createElement("Mask", "mask");
Svg.Mask = Mask;

const Path = createElement("Path", "path");
Svg.Path = Path;

const Pattern = createElement("Pattern", "pattern");
Svg.Pattern = Pattern;

const Polygon = createElement("Polygon", "polygon");
Svg.Polygon = Polygon;

const Polyline = createElement("Polyline", "polyline");
Svg.Polyline = Polyline;

const RadialGradient = createElement("RadialGradient", "radialGradient");
Svg.RadialGradient = RadialGradient;

const Rect = createElement("Rect", "rect");
Svg.Rect = Rect;

const Stop = createElement("Stop", "stop");
Svg.Stop = Stop;

const Symbol = createElement("Symbol", "symbol");
Svg.Symbol = Symbol;

const Text = createElement("Text", "text");
Svg.Text = Text;

const TextPath = createElement("TextPath", "textPath");
Svg.TextPath = TextPath;

const TSpan = createElement("TSpan", "tspan");
Svg.TSpan = TSpan;

const Use = createElement("Use", "use");
Svg.Use = Use;


/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _AnimatedInterpolation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18);
/* harmony import */ var _AnimatedWithChildren__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13);
/* harmony import */ var _exports_InteractionManager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24);
/* harmony import */ var _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }






var NativeAnimatedAPI = _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].API;
var _uniqueId = 1;
/**
 * Animated works by building a directed acyclic graph of dependencies
 * transparently when you render your Animated components.
 *
 *               new Animated.Value(0)
 *     .interpolate()        .interpolate()    new Animated.Value(1)
 *         opacity               translateY      scale
 *          style                         transform
 *         View#234                         style
 *                                         View#123
 *
 * A) Top Down phase
 * When an Animated.Value is updated, we recursively go down through this
 * graph in order to find leaf nodes: the views that we flag as needing
 * an update.
 *
 * B) Bottom Up phase
 * When a view is flagged as needing an update, we recursively go back up
 * in order to build the new value that it needs. The reason why we need
 * this two-phases process is to deal with composite props such as
 * transform which can receive values from multiple parents.
 */

function _flush(rootNode) {
  var animatedStyles = new Set();

  function findAnimatedStyles(node) {
    if (typeof node.update === 'function') {
      animatedStyles.add(node);
    } else {
      node.__getChildren().forEach(findAnimatedStyles);
    }
  }

  findAnimatedStyles(rootNode);
  animatedStyles.forEach(function (animatedStyle) {
    return animatedStyle.update();
  });
}
/**
 * Standard value for driving animations.  One `Animated.Value` can drive
 * multiple properties in a synchronized fashion, but can only be driven by one
 * mechanism at a time.  Using a new mechanism (e.g. starting a new animation,
 * or calling `setValue`) will stop any previous ones.
 *
 * See http://facebook.github.io/react-native/docs/animatedvalue.html
 */


var AnimatedValue =
/*#__PURE__*/
function (_AnimatedWithChildren) {
  _inheritsLoose(AnimatedValue, _AnimatedWithChildren);

  function AnimatedValue(value) {
    var _this;

    _this = _AnimatedWithChildren.call(this) || this;
    _this._startingValue = _this._value = value;
    _this._offset = 0;
    _this._animation = null;
    _this._listeners = {};
    return _this;
  }

  var _proto = AnimatedValue.prototype;

  _proto.__detach = function __detach() {
    this.stopAnimation();

    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  _proto.__getValue = function __getValue() {
    return this._value + this._offset;
  };

  _proto.__makeNative = function __makeNative() {
    _AnimatedWithChildren.prototype.__makeNative.call(this);

    if (Object.keys(this._listeners).length) {
      this._startListeningToNativeValueUpdates();
    }
  }
  /**
   * Directly set the value.  This will stop any animations running on the value
   * and update all the bound properties.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#setvalue
   */
  ;

  _proto.setValue = function setValue(value) {
    if (this._animation) {
      this._animation.stop();

      this._animation = null;
    }

    this._updateValue(value, !this.__isNative
    /* don't perform a flush for natively driven values */
    );

    if (this.__isNative) {
      NativeAnimatedAPI.setAnimatedNodeValue(this.__getNativeTag(), value);
    }
  }
  /**
   * Sets an offset that is applied on top of whatever value is set, whether via
   * `setValue`, an animation, or `Animated.event`.  Useful for compensating
   * things like the start of a pan gesture.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#setoffset
   */
  ;

  _proto.setOffset = function setOffset(offset) {
    this._offset = offset;

    if (this.__isNative) {
      NativeAnimatedAPI.setAnimatedNodeOffset(this.__getNativeTag(), offset);
    }
  }
  /**
   * Merges the offset value into the base value and resets the offset to zero.
   * The final output of the value is unchanged.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#flattenoffset
   */
  ;

  _proto.flattenOffset = function flattenOffset() {
    this._value += this._offset;
    this._offset = 0;

    if (this.__isNative) {
      NativeAnimatedAPI.flattenAnimatedNodeOffset(this.__getNativeTag());
    }
  }
  /**
   * Sets the offset value to the base value, and resets the base value to zero.
   * The final output of the value is unchanged.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#extractoffset
   */
  ;

  _proto.extractOffset = function extractOffset() {
    this._offset += this._value;
    this._value = 0;

    if (this.__isNative) {
      NativeAnimatedAPI.extractAnimatedNodeOffset(this.__getNativeTag());
    }
  }
  /**
   * Adds an asynchronous listener to the value so you can observe updates from
   * animations.  This is useful because there is no way to
   * synchronously read the value because it might be driven natively.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#addlistener
   */
  ;

  _proto.addListener = function addListener(callback) {
    var id = String(_uniqueId++);
    this._listeners[id] = callback;

    if (this.__isNative) {
      this._startListeningToNativeValueUpdates();
    }

    return id;
  }
  /**
   * Unregister a listener. The `id` param shall match the identifier
   * previously returned by `addListener()`.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#removelistener
   */
  ;

  _proto.removeListener = function removeListener(id) {
    delete this._listeners[id];

    if (this.__isNative && Object.keys(this._listeners).length === 0) {
      this._stopListeningForNativeValueUpdates();
    }
  }
  /**
   * Remove all registered listeners.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#removealllisteners
   */
  ;

  _proto.removeAllListeners = function removeAllListeners() {
    this._listeners = {};

    if (this.__isNative) {
      this._stopListeningForNativeValueUpdates();
    }
  };

  _proto._startListeningToNativeValueUpdates = function _startListeningToNativeValueUpdates() {
    var _this2 = this;

    if (this.__nativeAnimatedValueListener) {
      return;
    }

    NativeAnimatedAPI.startListeningToAnimatedNodeValue(this.__getNativeTag());
    this.__nativeAnimatedValueListener = _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"].nativeEventEmitter.addListener('onAnimatedValueUpdate', function (data) {
      if (data.tag !== _this2.__getNativeTag()) {
        return;
      }

      _this2._updateValue(data.value, false
      /* flush */
      );
    });
  };

  _proto._stopListeningForNativeValueUpdates = function _stopListeningForNativeValueUpdates() {
    if (!this.__nativeAnimatedValueListener) {
      return;
    }

    this.__nativeAnimatedValueListener.remove();

    this.__nativeAnimatedValueListener = null;
    NativeAnimatedAPI.stopListeningToAnimatedNodeValue(this.__getNativeTag());
  }
  /**
   * Stops any running animation or tracking. `callback` is invoked with the
   * final value after stopping the animation, which is useful for updating
   * state to match the animation position with layout.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#stopanimation
   */
  ;

  _proto.stopAnimation = function stopAnimation(callback) {
    this.stopTracking();
    this._animation && this._animation.stop();
    this._animation = null;
    callback && callback(this.__getValue());
  }
  /**
   * Stops any animation and resets the value to its original.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#resetanimation
   */
  ;

  _proto.resetAnimation = function resetAnimation(callback) {
    this.stopAnimation(callback);
    this._value = this._startingValue;
  }
  /**
   * Interpolates the value before updating the property, e.g. mapping 0-1 to
   * 0-10.
   */
  ;

  _proto.interpolate = function interpolate(config) {
    return new _AnimatedInterpolation__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](this, config);
  }
  /**
   * Typically only used internally, but could be used by a custom Animation
   * class.
   *
   * See http://facebook.github.io/react-native/docs/animatedvalue.html#animate
   */
  ;

  _proto.animate = function animate(animation, callback) {
    var _this3 = this;

    var handle = null;

    if (animation.__isInteraction) {
      handle = _exports_InteractionManager__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].createInteractionHandle();
    }

    var previousAnimation = this._animation;
    this._animation && this._animation.stop();
    this._animation = animation;
    animation.start(this._value, function (value) {
      // Natively driven animations will never call into that callback, therefore we can always
      // pass flush = true to allow the updated value to propagate to native with setNativeProps
      _this3._updateValue(value, true
      /* flush */
      );
    }, function (result) {
      _this3._animation = null;

      if (handle !== null) {
        _exports_InteractionManager__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].clearInteractionHandle(handle);
      }

      callback && callback(result);
    }, previousAnimation, this);
  }
  /**
   * Typically only used internally.
   */
  ;

  _proto.stopTracking = function stopTracking() {
    this._tracking && this._tracking.__detach();
    this._tracking = null;
  }
  /**
   * Typically only used internally.
   */
  ;

  _proto.track = function track(tracking) {
    this.stopTracking();
    this._tracking = tracking;
  };

  _proto._updateValue = function _updateValue(value, flush) {
    this._value = value;

    if (flush) {
      _flush(this);
    }

    for (var _key in this._listeners) {
      this._listeners[_key]({
        value: this.__getValue()
      });
    }
  };

  _proto.__getNativeConfig = function __getNativeConfig() {
    return {
      type: 'value',
      value: this._value,
      offset: this._offset
    };
  };

  return AnimatedValue;
}(_AnimatedWithChildren__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]);

/* harmony default export */ __webpack_exports__["a"] = (AnimatedValue);

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "elevation", function() { return elevation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "elevationTransition", function() { return elevationTransition; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElevationTransition", function() { return getElevationTransition; });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_0__);


const elevationTransitionDuration = `0.3s`;
const elevationTransitionCurve = `cubic-bezier(0.4, 0.0, 0.2, 1)`;

const shadowColorTransparent1 = `rgba(0, 0, 0, 0.05)`;
const shadowColorTransparent2 = `rgba(0, 0, 0, 0.13)`;

const elevationBaseShadow = `0px 0px 3px ${shadowColorTransparent1}`;
const transparentBorder = Object(styled_components__WEBPACK_IMPORTED_MODULE_0__["css"])(["border:2px solid rgba(0,0,0,0);"]);


const greyBorder = Object(styled_components__WEBPACK_IMPORTED_MODULE_0__["css"])(["border:2px solid #f1f1f1;"]);



function elevation(level, border = true) {
  switch (level) {
    case -1:
      return Object(styled_components__WEBPACK_IMPORTED_MODULE_0__["css"])(["box-shadow:inset 0px 1px 2px ", ",", ";", ""],
      shadowColorTransparent2, elevationBaseShadow,
      border ? transparentBorder : ``);


    case 0:
      return Object(styled_components__WEBPACK_IMPORTED_MODULE_0__["css"])(["box-shadow:0px 0px 0px ", ",0px 0px 0px ", ";", ""],
      shadowColorTransparent1,
      shadowColorTransparent2,
      border ? greyBorder : ``);


    case 1:
      return Object(styled_components__WEBPACK_IMPORTED_MODULE_0__["css"])(["box-shadow:0px 2px 5px ", ",", ";", ""],
      shadowColorTransparent2, elevationBaseShadow,
      border ? transparentBorder : ``);


    case 2:
      return Object(styled_components__WEBPACK_IMPORTED_MODULE_0__["css"])(["box-shadow:0px 4px 10px ", ",", ";", ""],
      shadowColorTransparent2, elevationBaseShadow,
      border ? transparentBorder : ``);


    case 3:
      return Object(styled_components__WEBPACK_IMPORTED_MODULE_0__["css"])(["box-shadow:0px 7px 15px ", ",", ";", ""],
      shadowColorTransparent2, elevationBaseShadow,
      border ? transparentBorder : ``);

    default:
      return Object(styled_components__WEBPACK_IMPORTED_MODULE_0__["css"])([""]);}

}

const elevationTransition = Object(styled_components__WEBPACK_IMPORTED_MODULE_0__["css"])(["transition:all ", " ", ";"],
elevationTransitionDuration, elevationTransitionCurve);


function getElevationTransition(border = true) {
  if (border) {
    return Object(styled_components__WEBPACK_IMPORTED_MODULE_0__["css"])(["transition:border ", " ", ",box-shadow ", " ", ";"],
    elevationTransitionDuration, elevationTransitionCurve,
    elevationTransitionDuration, elevationTransitionCurve);

  }
  return Object(styled_components__WEBPACK_IMPORTED_MODULE_0__["css"])(["transition:box-shadow ", " ", ";"],
  elevationTransitionDuration, elevationTransitionCurve);

}

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ darkBaseThemeWithLegacy; });
__webpack_require__.d(__webpack_exports__, "c", function() { return /* binding */ lightBaseThemeWithLegacy; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* binding */ lightBaseThemeWithLegacy; });

// EXTERNAL MODULE: ./src/theme/darkBaseTheme.ts
var darkBaseTheme = __webpack_require__(59);
var darkBaseTheme_default = /*#__PURE__*/__webpack_require__.n(darkBaseTheme);

// EXTERNAL MODULE: ./src/theme/lightBaseTheme.ts
var lightBaseTheme = __webpack_require__(63);
var lightBaseTheme_default = /*#__PURE__*/__webpack_require__.n(lightBaseTheme);

// CONCATENATED MODULE: ./src/theme/legacyTheme.js
/* eslint-disable */
const legacyTheme = {
  button: {
    size: {
      small: 40,
      medium: 48 },

    variant: {
      default: {
        backgroundColor: "rgba(51, 51, 51, 0.2)",
        backgroundColorHovered: "rgba(255, 255, 255, 1)",
        color: "inherit" },

      borderOnly: {
        backgroundColor: "rgba(51, 51, 51, 0.2)",
        backgroundColorHovered: "rgba(255, 255, 255, 1)" } } },



  input: {
    valueColor: "#333333",
    valueColorDisabled: "rgba(51, 51, 51, 0.25)",
    labelColor: "rgba(51, 51, 51, 0.5)",
    underlineColor: "rgba(51, 51, 51, 0.5)",
    errorColor: "#f44336" },

  checkbox: {
    checkedColor: "#666",
    borderColor: "#989898",
    borderColorFocus: "#333",
    borderColorChecked: "#989898" },

  inputSelect: {
    valueColor: "#333333",
    labelColor: "rgba(51, 51, 51, 0.5)",
    underlineColor: "rgba(51, 51, 51, 0.5)",
    iconColor: "rgba(51, 51, 51, 0.5)" },

  compactPaymentDisplay: {
    textColor: "#333333", //foreground
    iconColor: "#333333", //foreground
    paddingLeft: "16px" //L spacing
  },
  sectionHead: {
    textColor: "rgba(51, 51, 51, 0.75)", //Level 5
    lineColor: "rgba(51, 51, 51, 0.07)", // Level 1
    iconColor: "rgba(51, 51, 51, 0.75)" //Level 5
  } };


/* harmony default export */ var theme_legacyTheme = (legacyTheme);
// CONCATENATED MODULE: ./src/theme/index.js





const darkBaseThemeWithLegacy = {
  ...darkBaseTheme_default.a,
  ...theme_legacyTheme };


const lightBaseThemeWithLegacy = {
  ...lightBaseTheme_default.a,
  ...theme_legacyTheme };




/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _AnimatedNode__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var AnimatedWithChildren =
/*#__PURE__*/
function (_AnimatedNode) {
  _inheritsLoose(AnimatedWithChildren, _AnimatedNode);

  function AnimatedWithChildren() {
    var _this;

    _this = _AnimatedNode.call(this) || this;
    _this._children = [];
    return _this;
  }

  var _proto = AnimatedWithChildren.prototype;

  _proto.__makeNative = function __makeNative() {
    if (!this.__isNative) {
      this.__isNative = true;

      for (var _iterator = this._children, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var child = _ref;

        child.__makeNative();

        _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].API.connectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
      }
    }
  };

  _proto.__addChild = function __addChild(child) {
    if (this._children.length === 0) {
      this.__attach();
    }

    this._children.push(child);

    if (this.__isNative) {
      // Only accept "native" animated nodes as children
      child.__makeNative();

      _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].API.connectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
    }
  };

  _proto.__removeChild = function __removeChild(child) {
    var index = this._children.indexOf(child);

    if (index === -1) {
      console.warn("Trying to remove a child that doesn't exist");
      return;
    }

    if (this.__isNative && child.__isNative) {
      _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].API.disconnectAnimatedNodes(this.__getNativeTag(), child.__getNativeTag());
    }

    this._children.splice(index, 1);

    if (this._children.length === 0) {
      this.__detach();
    }
  };

  _proto.__getChildren = function __getChildren() {
    return this._children;
  };

  return AnimatedWithChildren;
}(_AnimatedNode__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* harmony default export */ __webpack_exports__["a"] = (AnimatedWithChildren);

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function modifiersFromObj(baseClass, modifiers) {
  var modifiersClasses = [];
  for (var modifier in modifiers) {
    modifiersClasses.push(createModifier(baseClass, modifier, modifiers[modifier]));
  }
  return modifiersClasses;
}

function createModifier(baseClass, modifierName, modifierValue) {
  if (!modifierValue || modifierValue === false) return '';
  var className = baseClass + '--' + modifierName;
  if (modifierValue && modifierValue !== true) {
    className += '-' + modifierValue;
  }
  return className;
}

function _block(blockName) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var allowedModifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var passedModifiers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};


  var classesSet = [];

  props.className && classesSet.push(props.className);

  classesSet.push(blockName);

  var modifiersFromProps = allowedModifiers.filter(function (modifierName) {
    return !!props[modifierName];
  }).map(function (modifierName) {
    return createModifier(blockName, modifierName, props[modifierName]);
  }),
      modifiersFromArguments = modifiersFromObj(blockName, passedModifiers);

  classesSet.push.apply(classesSet, _toConsumableArray(modifiersFromProps).concat(_toConsumableArray(modifiersFromArguments)));

  return classesSet.join(' ');
}

function _element(blockName, elementName) {
  var passedModifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};


  var elementClass = blockName + '__' + elementName,
      modifiersClasses = modifiersFromObj(elementClass, passedModifiers);

  return [elementClass].concat(_toConsumableArray(modifiersClasses)).join(' ');
}

exports.default = function (options) {
  return function (Component) {
    var _block2 = options.block,
        modifiers = options.modifiers;


    _extends(Component.prototype, {
      block: function block(passedModifiers) {
        return _block.call(this, _block2, this.props, modifiers, passedModifiers);
      },
      element: function element(elementName, passedModifiers) {
        return _element.call(this, _block2, elementName, passedModifiers);
      }
    });

    return Component;
  };
};

var Bem = exports.Bem = function Bem(blockName) {
  var _this = this;

  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var allowedModifiers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  _classCallCheck(this, Bem);

  this.block = function (passedModifiers) {
    return _block.call(null, _this.blockName, _this.props, _this.allowedModifiers, passedModifiers);
  };

  this.element = function (elementName, passedModifiers) {
    return _element.call(null, _this.blockName, elementName, passedModifiers);
  };

  this.blockName = blockName;
  this.props = props;
  this.allowedModifiers = allowedModifiers;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var emptyFunction = __webpack_require__(26);
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */


function printWarning(format) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var argIndex = 0;
  var message = 'Warning: ' + format.replace(/%s/g, function () {
    return args[argIndex++];
  });

  if (typeof console !== 'undefined') {
    console.error(message);
  }

  try {
    // --- Welcome to debugging React ---
    // This error was thrown as a convenience so that you can use this stack
    // to find the callsite that caused this warning to fire.
    throw new Error(message);
  } catch (x) {}
}

var warning =  false ? undefined : emptyFunction;
module.exports = warning;

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "getElementWidth", function() { return /* reexport */ helpers_getElementWidth; });
__webpack_require__.d(__webpack_exports__, "omitProps", function() { return /* reexport */ omitProps["default"]; });
__webpack_require__.d(__webpack_exports__, "isFunction", function() { return /* reexport */ isFunction["default"]; });
__webpack_require__.d(__webpack_exports__, "replaceColorOpacity", function() { return /* reexport */ replaceColorOpacity; });

// CONCATENATED MODULE: ./src/helpers/getElementWidth.js
/* eslint-disable */
function getElementWidth(element) {
  if (!element) {
    return 0;
  }

  const elementStyle = window.getComputedStyle(element);

  const safeParseFloat = str => {
    const float = parseFloat(str);

    return isFinite(float) ? float : 0;
  };

  const {
    paddingLeft,
    paddingRight,
    borderLeftWidth,
    borderRightWidth } =
  elementStyle;

  const paddingX = safeParseFloat(paddingLeft) + safeParseFloat(paddingRight);
  const borderX =
  safeParseFloat(borderLeftWidth) + safeParseFloat(borderRightWidth);

  const realWidth = element.offsetWidth - paddingX - borderX;

  return Math.max(0, realWidth); // Just to be sure that width is positive number;
}

/* harmony default export */ var helpers_getElementWidth = (getElementWidth);
// EXTERNAL MODULE: ./src/helpers/omitProps.jsx
var omitProps = __webpack_require__(70);

// EXTERNAL MODULE: ./src/helpers/isFunction.js
var isFunction = __webpack_require__(40);

// CONCATENATED MODULE: ./src/helpers/replaceThemeColorOpacity.js
// Help changing opacity in theme colors as HoverBackground: "rgba(255, 255, 255, 1)" or any rgba
// Usage: background-color: ${replaceColorOpacity(accentColor, 0.1)};

const replaceColorOpacity = (colorString, opacity) => {
  const newString = colorString.replace(/([\s\d.]+)\)/, opacity);
  return `${newString})`;
};
// CONCATENATED MODULE: ./src/helpers/index.js
/* eslint-disable */





/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var eye_1 = __webpack_require__(198);
Object.defineProperty(exports, "IconEye", { enumerable: true, get: function () { return eye_1.default; } });
var eyeOff_1 = __webpack_require__(199);
Object.defineProperty(exports, "IconEyeOff", { enumerable: true, get: function () { return eyeOff_1.default; } });
var ChevronIcon_1 = __webpack_require__(200);
Object.defineProperty(exports, "ChevronIcon", { enumerable: true, get: function () { return ChevronIcon_1.default; } });
var Close_1 = __webpack_require__(201);
Object.defineProperty(exports, "Close", { enumerable: true, get: function () { return Close_1.Close; } });
var Undo_1 = __webpack_require__(202);
Object.defineProperty(exports, "Undo", { enumerable: true, get: function () { return Undo_1.Undo; } });
var Heart_1 = __webpack_require__(100);
Object.defineProperty(exports, "Heart", { enumerable: true, get: function () { return Heart_1.Heart; } });
var InfoOutline_1 = __webpack_require__(203);
Object.defineProperty(exports, "InfoOutline", { enumerable: true, get: function () { return InfoOutline_1.InfoOutline; } });
var InProgress_1 = __webpack_require__(204);
Object.defineProperty(exports, "InProgress", { enumerable: true, get: function () { return InProgress_1.InProgress; } });
var FavoriteBtn_1 = __webpack_require__(205);
Object.defineProperty(exports, "FavoriteBtn", { enumerable: true, get: function () { return FavoriteBtn_1.FavoriteBtn; } });
var ProgressRing_1 = __webpack_require__(54);
Object.defineProperty(exports, "ProgressRing", { enumerable: true, get: function () { return ProgressRing_1.ProgressRing; } });
var Tick_1 = __webpack_require__(208);
Object.defineProperty(exports, "Tick", { enumerable: true, get: function () { return Tick_1.Tick; } });
var CircleTick_1 = __webpack_require__(209);
Object.defineProperty(exports, "CircleTick", { enumerable: true, get: function () { return CircleTick_1.CircleTick; } });
var AccountOutline_1 = __webpack_require__(210);
Object.defineProperty(exports, "AccountOutlineIcon", { enumerable: true, get: function () { return AccountOutline_1.AccountOutlineIcon; } });
var Bank_1 = __webpack_require__(211);
Object.defineProperty(exports, "BankIcon", { enumerable: true, get: function () { return Bank_1.BankIcon; } });
var Email_1 = __webpack_require__(212);
Object.defineProperty(exports, "EmailIcon", { enumerable: true, get: function () { return Email_1.EmailIcon; } });
var HappyFace_1 = __webpack_require__(213);
Object.defineProperty(exports, "HappyFaceIcon", { enumerable: true, get: function () { return HappyFace_1.HappyFaceIcon; } });
var HeartOutline_1 = __webpack_require__(214);
Object.defineProperty(exports, "HeartOutlineIcon", { enumerable: true, get: function () { return HeartOutline_1.HeartOutlineIcon; } });
var SignIn_1 = __webpack_require__(215);
Object.defineProperty(exports, "SignInIcon", { enumerable: true, get: function () { return SignIn_1.SignInIcon; } });
var CircleAttention_1 = __webpack_require__(216);
Object.defineProperty(exports, "CircleAttention", { enumerable: true, get: function () { return CircleAttention_1.CircleAttention; } });


/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _AnimatedWithChildren__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13);
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var normalize_css_color__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46);
/* harmony import */ var normalize_css_color__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(normalize_css_color__WEBPACK_IMPORTED_MODULE_2__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */

/* eslint no-bitwise: 0 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







var linear = function linear(t) {
  return t;
};
/**
 * Very handy helper to map input ranges to output ranges with an easing
 * function and custom behavior outside of the ranges.
 */


function createInterpolation(config) {
  if (config.outputRange && typeof config.outputRange[0] === 'string') {
    return createInterpolationFromStringOutputRange(config);
  }

  var outputRange = config.outputRange;
  checkInfiniteRange('outputRange', outputRange);
  var inputRange = config.inputRange;
  checkInfiniteRange('inputRange', inputRange);
  checkValidInputRange(inputRange);
  fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_1___default()(inputRange.length === outputRange.length, 'inputRange (' + inputRange.length + ') and outputRange (' + outputRange.length + ') must have the same length');
  var easing = config.easing || linear;
  var extrapolateLeft = 'extend';

  if (config.extrapolateLeft !== undefined) {
    extrapolateLeft = config.extrapolateLeft;
  } else if (config.extrapolate !== undefined) {
    extrapolateLeft = config.extrapolate;
  }

  var extrapolateRight = 'extend';

  if (config.extrapolateRight !== undefined) {
    extrapolateRight = config.extrapolateRight;
  } else if (config.extrapolate !== undefined) {
    extrapolateRight = config.extrapolate;
  }

  return function (input) {
    fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_1___default()(typeof input === 'number', 'Cannot interpolation an input which is not a number');
    var range = findRange(input, inputRange);
    return interpolate(input, inputRange[range], inputRange[range + 1], outputRange[range], outputRange[range + 1], easing, extrapolateLeft, extrapolateRight);
  };
}

function interpolate(input, inputMin, inputMax, outputMin, outputMax, easing, extrapolateLeft, extrapolateRight) {
  var result = input; // Extrapolate

  if (result < inputMin) {
    if (extrapolateLeft === 'identity') {
      return result;
    } else if (extrapolateLeft === 'clamp') {
      result = inputMin;
    } else if (extrapolateLeft === 'extend') {// noop
    }
  }

  if (result > inputMax) {
    if (extrapolateRight === 'identity') {
      return result;
    } else if (extrapolateRight === 'clamp') {
      result = inputMax;
    } else if (extrapolateRight === 'extend') {// noop
    }
  }

  if (outputMin === outputMax) {
    return outputMin;
  }

  if (inputMin === inputMax) {
    if (input <= inputMin) {
      return outputMin;
    }

    return outputMax;
  } // Input Range


  if (inputMin === -Infinity) {
    result = -result;
  } else if (inputMax === Infinity) {
    result = result - inputMin;
  } else {
    result = (result - inputMin) / (inputMax - inputMin);
  } // Easing


  result = easing(result); // Output Range

  if (outputMin === -Infinity) {
    result = -result;
  } else if (outputMax === Infinity) {
    result = result + outputMin;
  } else {
    result = result * (outputMax - outputMin) + outputMin;
  }

  return result;
}

function colorToRgba(input) {
  var int32Color = normalize_css_color__WEBPACK_IMPORTED_MODULE_2___default()(input);

  if (int32Color === null) {
    return input;
  }

  int32Color = int32Color || 0;
  var r = (int32Color & 0xff000000) >>> 24;
  var g = (int32Color & 0x00ff0000) >>> 16;
  var b = (int32Color & 0x0000ff00) >>> 8;
  var a = (int32Color & 0x000000ff) / 255;
  return "rgba(" + r + ", " + g + ", " + b + ", " + a + ")";
}

var stringShapeRegex = /[0-9\.-]+/g;
/**
 * Supports string shapes by extracting numbers so new values can be computed,
 * and recombines those values into new strings of the same shape.  Supports
 * things like:
 *
 *   rgba(123, 42, 99, 0.36) // colors
 *   -45deg                  // values with units
 */

function createInterpolationFromStringOutputRange(config) {
  var outputRange = config.outputRange;
  fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_1___default()(outputRange.length >= 2, 'Bad output range');
  outputRange = outputRange.map(colorToRgba);
  checkPattern(outputRange); // ['rgba(0, 100, 200, 0)', 'rgba(50, 150, 250, 0.5)']
  // ->
  // [
  //   [0, 50],
  //   [100, 150],
  //   [200, 250],
  //   [0, 0.5],
  // ]

  /* $FlowFixMe(>=0.18.0): `outputRange[0].match()` can return `null`. Need to
   * guard against this possibility.
   */

  var outputRanges = outputRange[0].match(stringShapeRegex).map(function () {
    return [];
  });
  outputRange.forEach(function (value) {
    /* $FlowFixMe(>=0.18.0): `value.match()` can return `null`. Need to guard
     * against this possibility.
     */
    value.match(stringShapeRegex).forEach(function (number, i) {
      outputRanges[i].push(+number);
    });
  });
  /* $FlowFixMe(>=0.18.0): `outputRange[0].match()` can return `null`. Need to
   * guard against this possibility.
   */

  var interpolations = outputRange[0].match(stringShapeRegex).map(function (value, i) {
    return createInterpolation(_objectSpread({}, config, {
      outputRange: outputRanges[i]
    }));
  }); // rgba requires that the r,g,b are integers.... so we want to round them, but we *dont* want to
  // round the opacity (4th column).

  var shouldRound = isRgbOrRgba(outputRange[0]);
  return function (input) {
    var i = 0; // 'rgba(0, 100, 200, 0)'
    // ->
    // 'rgba(${interpolations[0](input)}, ${interpolations[1](input)}, ...'

    return outputRange[0].replace(stringShapeRegex, function () {
      var val = +interpolations[i++](input);
      var rounded = shouldRound && i < 4 ? Math.round(val) : Math.round(val * 1000) / 1000;
      return String(rounded);
    });
  };
}

function isRgbOrRgba(range) {
  return typeof range === 'string' && range.startsWith('rgb');
}

function checkPattern(arr) {
  var pattern = arr[0].replace(stringShapeRegex, '');

  for (var i = 1; i < arr.length; ++i) {
    fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_1___default()(pattern === arr[i].replace(stringShapeRegex, ''), 'invalid pattern ' + arr[0] + ' and ' + arr[i]);
  }
}

function findRange(input, inputRange) {
  var i;

  for (i = 1; i < inputRange.length - 1; ++i) {
    if (inputRange[i] >= input) {
      break;
    }
  }

  return i - 1;
}

function checkValidInputRange(arr) {
  fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_1___default()(arr.length >= 2, 'inputRange must have at least 2 elements');

  for (var i = 1; i < arr.length; ++i) {
    fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_1___default()(arr[i] >= arr[i - 1],
    /* $FlowFixMe(>=0.13.0) - In the addition expression below this comment,
     * one or both of the operands may be something that doesn't cleanly
     * convert to a string, like undefined, null, and object, etc. If you really
     * mean this implicit string conversion, you can do something like
     * String(myThing)
     */
    'inputRange must be monotonically increasing ' + arr);
  }
}

function checkInfiniteRange(name, arr) {
  fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_1___default()(arr.length >= 2, name + ' must have at least 2 elements');
  fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_1___default()(arr.length !== 2 || arr[0] !== -Infinity || arr[1] !== Infinity,
  /* $FlowFixMe(>=0.13.0) - In the addition expression below this comment,
   * one or both of the operands may be something that doesn't cleanly convert
   * to a string, like undefined, null, and object, etc. If you really mean
   * this implicit string conversion, you can do something like
   * String(myThing)
   */
  name + 'cannot be ]-infinity;+infinity[ ' + arr);
}

var AnimatedInterpolation =
/*#__PURE__*/
function (_AnimatedWithChildren) {
  _inheritsLoose(AnimatedInterpolation, _AnimatedWithChildren);

  // Export for testing.
  function AnimatedInterpolation(parent, config) {
    var _this;

    _this = _AnimatedWithChildren.call(this) || this;
    _this._parent = parent;
    _this._config = config;
    _this._interpolation = createInterpolation(config);
    return _this;
  }

  var _proto = AnimatedInterpolation.prototype;

  _proto.__makeNative = function __makeNative() {
    this._parent.__makeNative();

    _AnimatedWithChildren.prototype.__makeNative.call(this);
  };

  _proto.__getValue = function __getValue() {
    var parentValue = this._parent.__getValue();

    fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_1___default()(typeof parentValue === 'number', 'Cannot interpolate an input which is not a number.');
    return this._interpolation(parentValue);
  };

  _proto.interpolate = function interpolate(config) {
    return new AnimatedInterpolation(this, config);
  };

  _proto.__attach = function __attach() {
    this._parent.__addChild(this);
  };

  _proto.__detach = function __detach() {
    this._parent.__removeChild(this);

    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  _proto.__transformDataType = function __transformDataType(range) {
    // Change the string array type to number array
    // So we can reuse the same logic in iOS and Android platform
    return range.map(function (value) {
      if (typeof value !== 'string') {
        return value;
      }

      if (/deg$/.test(value)) {
        var degrees = parseFloat(value) || 0;
        var radians = degrees * Math.PI / 180.0;
        return radians;
      } else {
        // Assume radians
        return parseFloat(value) || 0;
      }
    });
  };

  _proto.__getNativeConfig = function __getNativeConfig() {
    if (false) {}

    return {
      inputRange: this._config.inputRange,
      // Only the `outputRange` can contain strings so we don't need to transform `inputRange` here
      outputRange: this.__transformDataType(this._config.outputRange),
      extrapolateLeft: this._config.extrapolateLeft || this._config.extrapolate || 'extend',
      extrapolateRight: this._config.extrapolateRight || this._config.extrapolate || 'extend',
      type: 'interpolation'
    };
  };

  return AnimatedInterpolation;
}(_AnimatedWithChildren__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

AnimatedInterpolation.__createInterpolation = createInterpolation;
/* harmony default export */ __webpack_exports__["a"] = (AnimatedInterpolation);

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(1);
var factory = __webpack_require__(175);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(__webpack_require__(1));
const helpers_1 = __webpack_require__(16);
const styles_web_1 = __webpack_require__(180);
const useRipples_1 = __webpack_require__(181);
function withRipple(EnhancedComponent) {
    function RippleContainer({ children, onClick, rippleColor, ...restProps }) {
        const { ripples, addRippleEffect, removeRippleEffect } = useRipples_1.useRipples();
        const handleClick = react_1.useCallback((event) => {
            const { currentTarget } = event;
            const size = Math.max(currentTarget.offsetWidth, currentTarget.offsetHeight);
            const elementPosition = currentTarget.getBoundingClientRect();
            addRippleEffect({
                x: event.clientX - elementPosition.left - size / 2,
                y: event.clientY - elementPosition.top - size / 2,
                size,
            });
            if (helpers_1.isFunction(onClick)) {
                onClick(event);
            }
        }, [addRippleEffect, onClick]);
        return (react_1.default.createElement(styles_web_1.RippleSurface, Object.assign({ as: EnhancedComponent, onClick: handleClick }, restProps),
            children,
            Object.keys(ripples).map((key) => (react_1.default.createElement(styles_web_1.RippleEffect, { key: key, size: ripples[key].size, x: ripples[key].x, y: ripples[key].y, color: rippleColor, onAnimationEnd: () => {
                    removeRippleEffect(key);
                } })))));
    }
    return RippleContainer;
}
exports.default = withRipple;


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ eye; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ eyeOff; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ arrow["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ card; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ payPal; });
__webpack_require__.d(__webpack_exports__, "f", function() { return /* reexport */ sepa; });
__webpack_require__.d(__webpack_exports__, "g", function() { return /* reexport */ components_StraightFace; });

// UNUSED EXPORTS: IconTickCircle

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: ./src/components/icon/common.js
var common = __webpack_require__(7);

// CONCATENATED MODULE: ./src/components/icon/components/eye.jsx
/* eslint-disable */



const Eye = ({ className, color, size }) => /*#__PURE__*/
external_react_default.a.createElement("svg", {
  className: className,
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  style: {
    padding: common["a" /* ICON_PADDING */] } }, /*#__PURE__*/


external_react_default.a.createElement("path", {
  d: "M12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9ZM12 4.5C17 4.5 21.27 7.61 23 12C21.27 16.39 17 19.5 12 19.5C7 19.5 2.73 16.39 1 12C2.73 7.61 7 4.5 12 4.5ZM3.18 12C4.83 15.36 8.24 17.5 12 17.5C15.76 17.5 19.17 15.36 20.82 12C19.17 8.64 15.76 6.5 12 6.5C8.24 6.5 4.83 8.64 3.18 12Z",
  fill: color }));




Eye.propTypes = common["c" /* iconPropTypes */];
Eye.defaultProps = common["b" /* iconDefaultProps */];

/* harmony default export */ var eye = (Eye);
// CONCATENATED MODULE: ./src/components/icon/components/eyeOff.jsx
/* eslint-disable */



const EyeOff = ({ className, color, size }) => /*#__PURE__*/
external_react_default.a.createElement("svg", {
  className: className,
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  style: {
    padding: common["a" /* ICON_PADDING */] } }, /*#__PURE__*/


external_react_default.a.createElement("path", {
  d: "M2 5.27L3.28 4L20 20.72L18.73 22L15.65 18.92C14.5 19.3 13.28 19.5 12 19.5C7 19.5 2.73 16.39 1 12C1.69 10.24 2.79 8.69 4.19 7.46L2 5.27ZM12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.35 14.94 12.69 14.83 13L11 9.17C11.31 9.06 11.65 9 12 9ZM12 4.5C17 4.5 21.27 7.61 23 12C22.18 14.08 20.79 15.88 19 17.19L17.58 15.76C18.94 14.82 20.06 13.54 20.82 12C19.17 8.64 15.76 6.5 12 6.5C10.91 6.5 9.84 6.68 8.84 7L7.3 5.47C8.74 4.85 10.33 4.5 12 4.5ZM3.18 12C4.83 15.36 8.24 17.5 12 17.5C12.69 17.5 13.37 17.43 14 17.29L11.72 15C10.29 14.85 9.15 13.71 9 12.28L5.6 8.87C4.61 9.72 3.78 10.78 3.18 12Z",
  fill: color }));




EyeOff.propTypes = common["c" /* iconPropTypes */];
EyeOff.defaultProps = common["b" /* iconDefaultProps */];

/* harmony default export */ var eyeOff = (EyeOff);
// EXTERNAL MODULE: ./src/components/icon/components/arrow.jsx
var arrow = __webpack_require__(61);

// EXTERNAL MODULE: ./node_modules/react-native-svg-web/index.js
var react_native_svg_web = __webpack_require__(9);

// CONCATENATED MODULE: ./src/components/icon/components/card.jsx
/* eslint-disable */




const Card = ({ className, color, size }) => /*#__PURE__*/
external_react_default.a.createElement(react_native_svg_web["Svg"], {
  className: className,
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  style: {
    padding: common["a" /* ICON_PADDING */] } }, /*#__PURE__*/


external_react_default.a.createElement(react_native_svg_web["Path"], {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2 6C2 4.89543 2.89543 4 4 4H20C21.1046 4 22 4.89543 22 6V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V6ZM20 6H4V13H20V6ZM20 15H4V18L20 18V15ZM18 10C18 10.5523 17.5523 11 17 11H15C14.4477 11 14 10.5523 14 10V9C14 8.44772 14.4477 8 15 8H17C17.5523 8 18 8.44772 18 9V10Z",
  fill: color }));




Card.propTypes = common["c" /* iconPropTypes */];
Card.defaultProps = common["b" /* iconDefaultProps */];

/* harmony default export */ var card = (Card);
// CONCATENATED MODULE: ./src/components/icon/components/payPal.jsx
/* eslint-disable */



const PayPal = ({ className, color, size }) => /*#__PURE__*/
external_react_default.a.createElement("svg", {
  className: className,
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  style: {
    padding: common["a" /* ICON_PADDING */] } }, /*#__PURE__*/


external_react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.46272 2.81336C5.60318 1.91692 6.37581 1.25977 7.27951 1.25977H13.1475C15.2421 1.25977 17.2036 1.68938 18.3749 3.0231C18.8673 3.58451 19.2088 4.20585 19.3789 4.9296C19.5006 5.44742 19.5279 5.9884 19.4844 6.55901C21.0531 7.79161 21.1443 9.88371 20.8476 11.4072C20.4701 13.3456 19.607 14.7617 18.3255 15.6729C17.0652 16.569 15.5176 16.8929 13.9149 16.8929C13.8103 16.8929 13.7339 16.8972 13.678 16.9035L13.1058 20.535L13.1025 20.5521C13.0465 20.8413 12.9274 21.2199 12.6551 21.5438C12.3515 21.9049 11.9055 22.1366 11.365 22.1366H8.3115C7.42556 22.1366 6.75215 21.3453 6.88875 20.4727L6.95637 20.0442H4.50379C3.57889 20.0442 2.87532 19.2175 3.01857 18.3059L5.46272 2.81336ZM7.27182 18.0442L9.02639 6.92276L9.02664 6.9212C9.1591 6.07278 9.88995 5.45619 10.7396 5.45619H15.3389C16.091 5.45619 16.8153 5.51941 17.4814 5.66931C17.4694 5.56944 17.4528 5.47573 17.432 5.38723C17.3451 5.0178 17.1733 4.6862 16.8718 4.34244M17.2722 7.67807C16.7571 7.53517 16.1133 7.45619 15.3389 7.45619H10.9669L10.2899 11.7444H11.5558C13.1119 11.7444 14.3833 11.4293 15.3354 10.7606C16.1938 10.1577 16.8898 9.1992 17.2722 7.67807ZM18.8899 9.19765C18.3641 10.5875 17.5505 11.6488 16.485 12.3972C15.082 13.3827 13.3574 13.7444 11.5558 13.7444H9.97423L9.11435 19.1999L8.96654 20.1366H11.1439L11.7098 16.5452L11.7122 16.5324C11.8124 15.9888 12.0743 15.4872 12.5983 15.1822C13.0481 14.9203 13.5535 14.8929 13.9149 14.8929C15.2705 14.8929 16.36 14.6164 17.1665 14.0429C17.9518 13.4846 18.5851 12.5623 18.8845 11.0249C19.0191 10.3337 19.0225 9.71198 18.8899 9.19765ZM7.27182 18.0442H5.0846L7.41703 3.25977H13.1475C15.0949 3.25977 16.2925 3.68334 16.8718 4.34244",
  fill: color }));




PayPal.propTypes = common["c" /* iconPropTypes */];
PayPal.defaultProps = common["b" /* iconDefaultProps */];

/* harmony default export */ var payPal = (PayPal);
// CONCATENATED MODULE: ./src/components/icon/components/sepa.jsx
/* eslint-disable */



const Sepa = ({ className, color, size }) => /*#__PURE__*/
external_react_default.a.createElement("svg", {
  className: className,
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  viewBox: "0 0 1024 1024",
  fill: "none",
  style: {
    padding: common["a" /* ICON_PADDING */] } }, /*#__PURE__*/



external_react_default.a.createElement("path", {
  fill: color,
  d: "M500,119L833,309V458H167V309L500,119zM250,357V375H750V357L500,215L250,357zM250,708V500H333V708H250zM458,708V500H542V708H458zM667,708V500H750V708H667zM167,833V750H833V833H167z" }));




Sepa.propTypes = common["c" /* iconPropTypes */];
Sepa.defaultProps = common["b" /* iconDefaultProps */];

/* harmony default export */ var sepa = (Sepa);
// CONCATENATED MODULE: ./src/components/icon/components/tickCircle.jsx
/* eslint-disable */



const TickCircle = ({ className, color, size }) => /*#__PURE__*/
external_react_default.a.createElement("svg", {
  className: className,
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  style: {
    padding: common["a" /* ICON_PADDING */] } }, /*#__PURE__*/


external_react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 22C17.523 22 22 17.523 22 12C22 6.477 17.523 2 12 2C6.477 2 2 6.477 2 12C2 17.523 6.477 22 12 22ZM16.7071 10.7071C17.0976 10.3166 17.0976 9.68342 16.7071 9.29289C16.3166 8.90237 15.6834 8.90237 15.2929 9.29289L11 13.5858L8.70711 11.2929C8.31658 10.9024 7.68342 10.9024 7.29289 11.2929C6.90237 11.6834 6.90237 12.3166 7.29289 12.7071L11 16.4142L16.7071 10.7071Z",
  fill: color }));




TickCircle.propTypes = common["c" /* iconPropTypes */];
TickCircle.defaultProps = common["b" /* iconDefaultProps */];

/* harmony default export */ var tickCircle = (TickCircle);
// CONCATENATED MODULE: ./src/components/icon/components/StraightFace.jsx
/* eslint-disable */




const StraightFace = ({ className, size, color }) => /*#__PURE__*/
external_react_default.a.createElement("svg", {
  className: className,
  width: size,
  height: size,
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg" }, /*#__PURE__*/

external_react_default.a.createElement("path", {
  d: "M17 24C18.6562 24 20 22.6562 20 21C20 19.3438 18.6562 18 17 18C15.3438 18 14 19.3438 14 21C14 22.6562 15.3438 24 17 24Z",
  fill: color }), /*#__PURE__*/

external_react_default.a.createElement("path", {
  d: "M31 24C32.6562 24 34 22.6562 34 21C34 19.3438 32.6562 18 31 18C29.3438 18 28 19.3438 28 21C28 22.6562 29.3438 24 31 24Z",
  fill: color }), /*#__PURE__*/

external_react_default.a.createElement("path", {
  d: "M14 28V32H34V28H14Z",
  fill: color }), /*#__PURE__*/

external_react_default.a.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 44C35.0469 44 44 35.0469 44 24C44 12.9531 35.0469 4 24 4C12.9531 4 4 12.9531 4 24C4 35.0469 12.9531 44 24 44ZM24 40C32.8359 40 40 32.8359 40 24C40 15.1641 32.8359 8 24 8C15.1641 8 8 15.1641 8 24C8 32.8359 15.1641 40 24 40Z",
  fill: color }));




StraightFace.propTypes = {
  ...common["c" /* iconPropTypes */] };


StraightFace.defaultProps = {
  size: '48px',
  color: '#333333',
  className: '' };


/* harmony default export */ var components_StraightFace = (StraightFace);
// CONCATENATED MODULE: ./src/components/icon/index.js









/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Card = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const styles_1 = __webpack_require__(217);
exports.Card = ({ containerRef, children, defaultHoverBehavior, className, elevated, onClick, highlight, borderColor, loading, hasError, onContactButtonClick, }) => (react_1.default.createElement(styles_1.Container, { ref: containerRef, className: className, defaultHover: defaultHoverBehavior, elevated: elevated, onClick: onClick, highlight: highlight, borderColor: borderColor, loading: loading, hasError: hasError, onContactButtonClick: onContactButtonClick }, children));


/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__23__;

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: ./node_modules/react-native-web/node_modules/fbjs/lib/invariant.js
var invariant = __webpack_require__(3);
var invariant_default = /*#__PURE__*/__webpack_require__.n(invariant);

// EXTERNAL MODULE: ./node_modules/react-native-web/node_modules/fbjs/lib/ExecutionEnvironment.js
var ExecutionEnvironment = __webpack_require__(4);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/requestIdleCallback/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var _requestIdleCallback = function _requestIdleCallback(cb, options) {
  return setTimeout(function () {
    var start = Date.now();
    cb({
      didTimeout: false,
      timeRemaining: function timeRemaining() {
        return Math.max(0, 50 - (Date.now() - start));
      }
    });
  }, 1);
}; // $FlowFixMe (TimeoutID type is not recognized by eslint)


var _cancelIdleCallback = function _cancelIdleCallback(id) {
  clearTimeout(id);
};

var isSupported = ExecutionEnvironment["canUseDOM"] && typeof window.requestIdleCallback !== 'undefined';
var requestIdleCallback = isSupported ? window.requestIdleCallback : _requestIdleCallback;
var cancelIdleCallback = isSupported ? window.cancelIdleCallback : _cancelIdleCallback;
/* harmony default export */ var modules_requestIdleCallback = (requestIdleCallback);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/InteractionManager/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var InteractionManager = {
  Events: {
    interactionStart: 'interactionStart',
    interactionComplete: 'interactionComplete'
  },

  /**
   * Schedule a function to run after all interactions have completed.
   */
  runAfterInteractions: function runAfterInteractions(task) {
    var handle;
    var promise = new Promise(function (resolve) {
      handle = modules_requestIdleCallback(function () {
        if (task) {
          resolve(task());
        } else {
          resolve();
        }
      });
    });
    return {
      then: promise.then.bind(promise),
      done: promise.then.bind(promise),
      cancel: function cancel() {
        cancelIdleCallback(handle);
      }
    };
  },

  /**
   * Notify manager that an interaction has started.
   */
  createInteractionHandle: function createInteractionHandle() {
    return 1;
  },

  /**
   * Notify manager that an interaction has completed.
   */
  clearInteractionHandle: function clearInteractionHandle(handle) {
    invariant_default()(!!handle, 'Must provide a handle to clear.');
  },
  addListener: function addListener() {}
};
/* harmony default export */ var exports_InteractionManager = __webpack_exports__["a"] = (InteractionManager);

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ SonntagIcon_SonntagIcon; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: ./node_modules/react-native-svg-web/index.js
var react_native_svg_web = __webpack_require__(9);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: ./src/helpers/elevation/index.web.js
var index_web = __webpack_require__(11);

// CONCATENATED MODULE: ./src/components/SonntagIcon/styled.web.js



const StyledSVG = external_styled_components_default.a.svg.withConfig({ displayName: "styledweb__StyledSVG", componentId: "sc-1fm285b-0" })(["display:inline-block;vertical-align:middle;fill:", ";", " ", ""],


props => props.color || props.theme.colors.Foreground,
index_web["elevationTransition"],

({ color, hover }) =>
color !== hover &&
Object(external_styled_components_["css"])(["&:hover{transition:fill 0.3s;fill:", ";}"],


props => props.hover));




/* harmony default export */ var styled_web = (StyledSVG);
// CONCATENATED MODULE: ./src/components/SonntagIcon/SonntagIcon.jsx
function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}





const SonntagIcon = ({ iconPath, color, hover, size, ...rest }) => /*#__PURE__*/
external_react_default.a.createElement(styled_web, _extends({},
rest, {
  color: color,
  hover: hover,
  width: `${size}px`,
  height: `${size}px`,
  viewBox: "0 0 1024 1024",
  xmlns: "http://www.w3.org/2000/svg" }), /*#__PURE__*/

external_react_default.a.createElement(react_native_svg_web["Path"], { d: iconPath }));



SonntagIcon.propTypes = {
  iconPath: external_prop_types_default.a.string,
  color: external_prop_types_default.a.string,
  hover: external_prop_types_default.a.string,
  size: external_prop_types_default.a.number,
  className: external_prop_types_default.a.string };


SonntagIcon.defaultProps = {
  iconPath: '',
  color: '',
  hover: '',
  size: 24,
  className: '' };


/* harmony default export */ var SonntagIcon_SonntagIcon = (SonntagIcon);
// CONCATENATED MODULE: ./src/components/SonntagIcon/index.js


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}
/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */


var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);

emptyFunction.thatReturnsThis = function () {
  return this;
};

emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: ./src/hocs/withRipple/index.web.tsx
var index_web = __webpack_require__(20);
var index_web_default = /*#__PURE__*/__webpack_require__.n(index_web);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: ./src/components/SonntagIcon/index.js + 2 modules
var SonntagIcon = __webpack_require__(25);

// EXTERNAL MODULE: ./src/internalComponents/clickable/index.jsx
var clickable = __webpack_require__(67);

// EXTERNAL MODULE: ./src/helpers/index.js + 2 modules
var helpers = __webpack_require__(16);

// EXTERNAL MODULE: ./src/helpers/elevation/index.web.js
var elevation_index_web = __webpack_require__(11);

// CONCATENATED MODULE: ./src/components/Buttons/SonntagButtonV2/styled.js








const IconWrapper = external_styled_components_default.a.div.withConfig({ displayName: "styled__IconWrapper", componentId: "sc-9s3c5n-0" })(["margin:0 6px 0 0;display:flex;justify-content:center;align-items:center;width:24px;height:24px;", " & > svg{width:24px;height:24px;padding:0;fill:", ";}& *{fill:", ";}", ";"],






elevation_index_web["elevationTransition"],





({ theme, color }) => color || theme.colors.Foreground,



({ theme, color }) => color || theme.colors.Foreground,


({ onlyIcon }) => onlyIcon && Object(external_styled_components_["css"])(["margin:0 -6px;"]));




const ButtonView = Object(helpers["omitProps"])(
'fullWidth',
'outlined',
'size',
'theme',
'accentColor',
'withIcon',
'onlyIcon',
'solid')(
clickable["a" /* default */]);

const StyledButton = external_styled_components_default()(ButtonView).withConfig({ displayName: "styled__StyledButton", componentId: "sc-9s3c5n-1" })(["", ";position:relative;display:flex;justify-content:center;align-items:center;box-sizing:border-box;height:", ";background-color:", ";background-clip:", ";border-radius:", ";border-style:solid;border-width:2px;border-color:", ";min-width:0;color:", ";overflow:hidden;outline:none;padding:", ";", " &:hover:not(:disabled){cursor:pointer;background-color:", ";border-color:", ";background-clip:padding-box;", "}&:active:not(:disabled){text-decoration:none;", ";transition-duration:0s;background-color:", ";border-color:", ";background-clip:padding-box;}&:visited{text-decoration:none;}&:disabled{transition:none;transform:none;opacity:0.4;cursor:default;}", ";", ";", ";"],
props => Object(external_styled_components_["css"])(props.theme.typography.SmallHeadline),





({ size }) => size && size === 'small' && '32px' || '48px',
({ theme }) => theme.colors['Level 1'],
({ solid }) => solid ? 'border-box' : 'padding-box',
({ size }) => size && size === 'small' && '16px' || '24px',


({ theme }) => theme.colors['Level 1'],

({ theme }) => theme.colors.Foreground,


({ withIcon, size, onlyIcon }) => withIcon && size === 'small' && onlyIcon && '0 8px' ||
withIcon && size === 'small' && !onlyIcon && '0 8px 0 4px' ||
withIcon && !size && '0 16px' ||
!withIcon && size === 'small' && '0 16px' ||
'0 24px',

elevation_index_web["elevationTransition"],



({ theme }) => theme.colors.HoverBackground,
({ theme }) => theme.colors.HoverBackground,

Object(elevation_index_web["elevation"])(2, false),




Object(elevation_index_web["elevation"])(1, false),

({ theme }) => theme.colors.ElementBackground,
({ theme }) => theme.colors.ElementBackground,














({
  accentColor, theme, solid, outlined }) =>
accentColor && Object(external_styled_components_["css"])(["color:", ";background-color:", ";border-color:", ";& > svg,& *{fill:", ";}&:hover:not(:disabled){color:", ";background-color:", ";border-color:", ";& > svg,& *{fill:", ";}}&:active:not(:disabled){color:", ";background-color:", ";border-color:", ";& > svg,& *{fill:", ";}}"],
accentColor && solid && !outlined ? '#fff' : accentColor,
accentColor && solid && !outlined && accentColor ||
accentColor && outlined && !solid && 'transparent' ||
theme.colors['Level 1'],
(solid || outlined) && accentColor || theme.colors['Level 1'],


accentColor && solid && !outlined ? '#fff' : accentColor,



theme.colors.Foreground,
theme.colors.HoverBackground,
theme.colors.HoverBackground,


theme.colors.Foreground,




theme.colors.Foreground,
theme.colors.ElementBackground,
theme.colors.ElementBackground,

theme.colors.Foreground),




({ outlined }) => outlined && Object(external_styled_components_["css"])(["background-color:transparent;"]),



({ fullWidth }) => fullWidth && Object(external_styled_components_["css"])(["width:100%;"]));





const StyledSonntagIcon = external_styled_components_default()(SonntagIcon["default"]).withConfig({ displayName: "styled__StyledSonntagIcon", componentId: "sc-9s3c5n-2" })(["margin:0 6px 0 0;", ";"],


({ onlyIcon }) => onlyIcon && Object(external_styled_components_["css"])(["margin:0 -6px;"]));





const RippleContainer = external_styled_components_default.a.div.withConfig({ displayName: "styled__RippleContainer", componentId: "sc-9s3c5n-3" })(["width:100%;height:100%;position:absolute !important;top:0;left:0;"]);







const TruncationWrapper = external_styled_components_default.a.div.withConfig({ displayName: "styled__TruncationWrapper", componentId: "sc-9s3c5n-4" })(["vertical-align:center;display:-webkit-box;-webkit-line-clamp:1;-webkit-box-orient:vertical;overflow:hidden;"]);
// CONCATENATED MODULE: ./src/components/Buttons/SonntagButtonV2/SonntagButton.jsx
function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);} /* eslint-disable react/jsx-props-no-spreading */





const SonntagButton = ({
  className,
  size,
  outlined,
  fullWidth,
  iconPath,
  iconSvgCode,
  children,
  disabled,
  accentColor,
  iconColor,
  solid,
  ...props }) =>
{
  const RippleEffect = index_web_default()(RippleContainer);

  const renderIcon = Object(external_react_["useCallback"])(() => {
    if (!iconPath && !iconSvgCode) {
      return null;
    }
    if (iconPath && !iconSvgCode) {
      return /*#__PURE__*/(
        external_react_default.a.createElement(StyledSonntagIcon, {
          iconPath: iconPath,
          color: iconColor || !solid && accentColor,
          onlyIcon: !children }));


    }
    if (iconSvgCode && !iconPath) {
      const SvgIcon = iconSvgCode;
      return /*#__PURE__*/(
        external_react_default.a.createElement(IconWrapper, { color: iconColor || !solid && accentColor, onlyIcon: !children }, /*#__PURE__*/
        external_react_default.a.createElement(SvgIcon, { viewBox: "0 0 1000 1000" })));


    }
    return null;
  }, [iconPath, iconSvgCode, iconColor, solid, accentColor, children]);

  return /*#__PURE__*/(
    external_react_default.a.createElement(StyledButton, _extends({
      className: className,
      size: size,
      outlined: outlined,
      fullWidth: fullWidth,
      disabled: disabled,
      accentColor: accentColor,
      solid: solid,
      withIcon: (iconPath || iconSvgCode) && true,
      onlyIcon: !children },
    props),

    renderIcon(), /*#__PURE__*/
    external_react_default.a.createElement(TruncationWrapper, null, children),
    !disabled && /*#__PURE__*/external_react_default.a.createElement(RippleEffect, null)));


};

/* harmony default export */ var SonntagButtonV2_SonntagButton = (SonntagButton);
// CONCATENATED MODULE: ./src/components/Buttons/SonntagButtonV2/index.js


/* harmony default export */ var SonntagButtonV2 = __webpack_exports__["default"] = (SonntagButtonV2_SonntagButton);

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetgroverForm_Box; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bem_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);
/* harmony import */ var react_bem_classes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_bem_classes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(162);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_index_scss__WEBPACK_IMPORTED_MODULE_3__);
var _dec, _class, _class2, _temp; /* eslint-disable */




let





GetgroverForm_Box = (_dec = react_bem_classes__WEBPACK_IMPORTED_MODULE_2___default()({ block: 'getgroverForm_Box', modifiers: ['autoHeight', 'noBorder'] }), _dec(_class = (_temp = _class2 = class GetgroverForm_Box extends react__WEBPACK_IMPORTED_MODULE_0__["Component"] {














  constructor(props) {
    super(props);

    this.renderError = this.renderError.bind(this);
  }

  renderError() {
    const { error } = this.props;
    return !error ? null : /*#__PURE__*/
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: this.element('error') },
    error);

  }

  render() {
    const { label, error, active, inputName, children } = this.props;

    return /*#__PURE__*/(
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: this.block({
          active,
          error: !!error }) }, /*#__PURE__*/


      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("label", { className: this.element('box'), htmlFor: inputName }, /*#__PURE__*/
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: this.element('label'), dangerouslySetInnerHTML: { __html: label } }), /*#__PURE__*/
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: this.element('inputBox') },
      children)),


      this.renderError()));


  }}, _class2.propTypes = { active: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.bool, children: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.node, label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, error: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, inputName: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string }, _class2.defaultProps = { label: null, error: '', inputName: '', active: false }, _temp)) || _class);

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var GLOBAL = typeof window === 'undefined' ? global : window;

var setter = function(_setter, _clearer, array) {
  return function(callback, delta) {
    var id = _setter(function() {
      _clearer.call(this, id);
      callback.apply(this, arguments);
    }.bind(this), delta);

    if (!this[array]) {
      this[array] = [id];
    } else {
      this[array].push(id);
    }
    return id;
  };
};

var clearer = function(_clearer, array) {
  return function(id) {
    if (this[array]) {
      var index = this[array].indexOf(id);
      if (index !== -1) {
        this[array].splice(index, 1);
      }
    }
    _clearer(id);
  };
};

var _timeouts = 'TimerMixin_timeouts';
var _clearTimeout = clearer(GLOBAL.clearTimeout, _timeouts);
var _setTimeout = setter(GLOBAL.setTimeout, _clearTimeout, _timeouts);

var _intervals = 'TimerMixin_intervals';
var _clearInterval = clearer(GLOBAL.clearInterval, _intervals);
var _setInterval = setter(GLOBAL.setInterval, function() {/* noop */}, _intervals);

var _immediates = 'TimerMixin_immediates';
var _clearImmediate = clearer(GLOBAL.clearImmediate, _immediates);
var _setImmediate = setter(GLOBAL.setImmediate, _clearImmediate, _immediates);

var _rafs = 'TimerMixin_rafs';
var _cancelAnimationFrame = clearer(GLOBAL.cancelAnimationFrame, _rafs);
var _requestAnimationFrame = setter(GLOBAL.requestAnimationFrame, _cancelAnimationFrame, _rafs);

var TimerMixin = {
  componentWillUnmount: function() {
    this[_timeouts] && this[_timeouts].forEach(function(id) {
      GLOBAL.clearTimeout(id);
    });
    this[_timeouts] = null;
    this[_intervals] && this[_intervals].forEach(function(id) {
      GLOBAL.clearInterval(id);
    });
    this[_intervals] = null;
    this[_immediates] && this[_immediates].forEach(function(id) {
      GLOBAL.clearImmediate(id);
    });
    this[_immediates] = null;
    this[_rafs] && this[_rafs].forEach(function(id) {
      GLOBAL.cancelAnimationFrame(id);
    });
    this[_rafs] = null;
  },

  setTimeout: _setTimeout,
  clearTimeout: _clearTimeout,

  setInterval: _setInterval,
  clearInterval: _clearInterval,

  setImmediate: _setImmediate,
  clearImmediate: _clearImmediate,

  requestAnimationFrame: _requestAnimationFrame,
  cancelAnimationFrame: _cancelAnimationFrame,
};

module.exports = TimerMixin;

/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(52)))

/***/ }),
/* 30 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* global HTMLElement */
var getBoundingClientRect = function getBoundingClientRect(node) {
  if (node) {
    var isElement = node.nodeType === 1;
    /* Node.ELEMENT_NODE */

    if (isElement && typeof node.getBoundingClientRect === 'function') {
      return node.getBoundingClientRect();
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = (getBoundingClientRect);

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DismissingCard = void 0;
const react_1 = __importStar(__webpack_require__(1));
const react_resize_detector_1 = __importDefault(__webpack_require__(82));
const react_transition_group_1 = __webpack_require__(245);
const function_1 = __webpack_require__(74);
const Conditional_1 = __importDefault(__webpack_require__(99));
const DismissingCardContext_1 = __webpack_require__(55);
const UndoButton_1 = __webpack_require__(246);
const CircleDismissButton_1 = __webpack_require__(109);
const TimerDismissButton_1 = __webpack_require__(249);
const ConfirmCancellationButton_1 = __webpack_require__(250);
const styles_1 = __webpack_require__(42);
exports.DismissingCard = ({ className, children, onDismiss, hasUndo = true, hasCircleButton = false, dismissedText, undoButtonText, circleButtonPosition, backgroundColor, borderColor, hasTimeout, confirmCancellationButtonText, }) => {
    const [dismissed, setDismissed] = react_1.useState(false);
    const [leaveAnimation, setLeaveAnimation] = react_1.useState(false);
    const [height, setHeight] = react_1.useState(null);
    const contextValue = react_1.useMemo(() => ({
        dismiss: () => {
            setDismissed(true);
        },
        undo: () => {
            setDismissed(false);
        },
    }), []);
    const handleResize = react_1.useCallback((_, newHeight) => {
        setHeight(newHeight);
    }, []);
    const handleDismiss = react_1.useCallback(() => {
        setLeaveAnimation(true);
        if (onDismiss && function_1.isFunction(onDismiss)) {
            onDismiss();
        }
    }, [onDismiss]);
    return (react_1.default.createElement(DismissingCardContext_1.DismissingCardContext.Provider, { value: contextValue },
        react_1.default.createElement(react_transition_group_1.CSSTransition, { in: !leaveAnimation, enter: false, unmountOnExit: true, classNames: "dismissing-card", timeout: 300 },
            react_1.default.createElement(styles_1.Card, { className: className, dismissed: dismissed, height: height, backgroundColor: backgroundColor, borderColor: borderColor },
                react_1.default.createElement(styles_1.Content, null,
                    react_1.default.createElement(Conditional_1.default, { condition: !dismissed }, children),
                    react_1.default.createElement(Conditional_1.default, { condition: dismissed },
                        react_1.default.createElement(styles_1.DismissingContainer, { hasTimeout: hasTimeout },
                            react_1.default.createElement(styles_1.DismissedText, { hasTimeout: hasTimeout }, dismissedText),
                            hasTimeout ? (react_1.default.createElement(react_1.default.Fragment, null,
                                hasUndo ? react_1.default.createElement(UndoButton_1.UndoButton, null, undoButtonText) : null,
                                react_1.default.createElement(TimerDismissButton_1.TimerDismissButton, { onDismiss: handleDismiss }))) : (react_1.default.createElement(styles_1.ButtonsWrap, null,
                                hasUndo ? react_1.default.createElement(UndoButton_1.UndoButton, null, undoButtonText) : null,
                                react_1.default.createElement(ConfirmCancellationButton_1.ConfirmCancellationButton, { onDismiss: handleDismiss }, confirmCancellationButtonText))))),
                    react_1.default.createElement(react_resize_detector_1.default, { handleHeight: true, onResize: handleResize })),
                react_1.default.createElement(Conditional_1.default, { condition: hasCircleButton && !dismissed },
                    react_1.default.createElement(CircleDismissButton_1.CircleDismissButton, { position: circleButtonPosition }))))));
};


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
Object.defineProperty(exports, "__esModule", { value: true });
var useOverrides_1 = __webpack_require__(191);
Object.defineProperty(exports, "useOverrides", { enumerable: true, get: function () { return useOverrides_1.useOverrides; } });
var mergeOverrides_1 = __webpack_require__(192);
Object.defineProperty(exports, "mergeOverrides", { enumerable: true, get: function () { return mergeOverrides_1.mergeOverrides; } });
var getComponents_1 = __webpack_require__(98);
Object.defineProperty(exports, "getComponents", { enumerable: true, get: function () { return getComponents_1.getComponents; } });
__exportStar(__webpack_require__(193), exports);


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonColor = exports.Button = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const SonntagIcon_1 = __importDefault(__webpack_require__(25));
const withRipple_1 = __importDefault(__webpack_require__(20));
const styles_web_1 = __webpack_require__(108);
const types_web_1 = __webpack_require__(248);
Object.defineProperty(exports, "ButtonColor", { enumerable: true, get: function () { return types_web_1.ButtonColor; } });
const ButtonWithRippleEffect = withRipple_1.default(styles_web_1.Btn);
const renderIcon = (icon, iconPath) => {
    if (iconPath) {
        return react_1.default.createElement(SonntagIcon_1.default, { iconPath: iconPath, color: "currentColor" });
    }
    if (icon) {
        return icon;
    }
    return null;
};
exports.Button = ({ type = 'button', isDisabled = false, small = false, outlined = false, borderColor, color = types_web_1.ButtonColor.grey, fullWidth, icon, iconPath, children, rippleColor, ...rest }) => {
    return (react_1.default.createElement(ButtonWithRippleEffect, Object.assign({ role: "button", type: type, disabled: isDisabled, outlined: outlined, borderColor: borderColor, color: color, small: small, iconBtn: !!icon || !!iconPath, hasChildren: !!children, fullWidth: Boolean(children && fullWidth), rippleColor: rippleColor }, rest),
        react_1.default.createElement(styles_web_1.BtnContent, null,
            (!!icon || !!iconPath) && (react_1.default.createElement(styles_web_1.BtnIcon, { hasMargin: !!children, small: small }, renderIcon(icon, iconPath))),
            !!children && react_1.default.createElement(styles_web_1.BtnText, null, children))));
};


/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "c", function() { return /* reexport */ knob_Knob; });
__webpack_require__.d(__webpack_exports__, "e", function() { return /* reexport */ track; });
__webpack_require__.d(__webpack_exports__, "d", function() { return /* reexport */ selector_Selector; });
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ accentSelectorKnob; });
__webpack_require__.d(__webpack_exports__, "b", function() { return /* reexport */ rentalPlanSelector_AccentSelectorPoints; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: ./node_modules/react-bem-classes/index.js
var react_bem_classes = __webpack_require__(14);
var react_bem_classes_default = /*#__PURE__*/__webpack_require__.n(react_bem_classes);

// EXTERNAL MODULE: ./node_modules/react-draggable/dist/react-draggable.js
var react_draggable = __webpack_require__(81);
var react_draggable_default = /*#__PURE__*/__webpack_require__.n(react_draggable);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(36);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// EXTERNAL MODULE: ./src/components/rentalPlanSelector/selector/index.scss
var selector = __webpack_require__(167);

// CONCATENATED MODULE: ./src/components/rentalPlanSelector/constants.js
const knobDiamiter = 64;
const constants_planSectionWidth = 83;
const planSectionMinimalWidth = 50;
const planSectionHeight = 48;
const planContainerWidth = 30;
const planContainerHeight = 30;
const constants_knobShift = (constants_planSectionWidth - knobDiamiter) / 2;
const trackPaddingSize = knobDiamiter / 2;
// EXTERNAL MODULE: ./src/helpers/index.js + 2 modules
var helpers = __webpack_require__(16);

// CONCATENATED MODULE: ./src/components/rentalPlanSelector/selector/index.jsx
var _dec, _class, _class2, _temp; /* eslint-disable no-lonely-if */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable no-unused-vars */
/* eslint-disable react/sort-comp */
/* eslint-disable react/no-deprecated */
/* eslint-disable import/no-extraneous-dependencies */










let




selector_Selector = (_dec = react_bem_classes_default()({ block: 'ggSelector' }), _dec(_class = (_temp = _class2 = class Selector extends external_react_["Component"] {


  constructor(props) {
    super(props);this.






























    calculateSizeCallback = () => {
      this.setState({
        isInited: true,
        ...this.calculateSizeState() });

    };this.domElement = null;const currentIndex = Selector.isControlledSelector(props.pointIndex) ? props.pointIndex : props.defaultPointIndex;this.state = { currentIndex, forcedPosition: null, isDragging: false, isHoverable: props.isHoverable, planSectionWidth: planSectionMinimalWidth, knobShift: constants_knobShift, isInited: false };this.setDomElement = this.setDomElement.bind(this);this.isShortVersion = this.isShortVersion.bind(this);this.calculateSizeState = this.calculateSizeState.bind(this);this.calculateKnobPosition = this.calculateKnobPosition.bind(this);this.getDraggableBounds = this.getDraggableBounds.bind(this);this.dragHandler = this.dragHandler.bind(this);this.dragStopHandler = this.dragStopHandler.bind(this);this.dragStartHandler = this.dragStartHandler.bind(this);this.selectNewPoint = this.selectNewPoint.bind(this);this.selectNewPointIfHoverable = this.selectNewPointIfHoverable.bind(this);this.toggleHoverable = this.toggleHoverable.bind(this);this.getCurrentPointIndex = this.getCurrentPointIndex.bind(this);}

  componentDidMount() {
    this.calculateSizeCallback();
    window.addEventListener('resize', this.calculateSizeCallback);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.calculateSizeCallback);
  }

  componentWillReceiveProps(nextProps) {
    const { pointIndex, points } = this.props;
    const { pointIndex: nextPointIndex, points: nextPoints } = nextProps;
    if (Selector.isControlledSelector(nextPointIndex) && pointIndex !== nextPointIndex) {
      this.setState({
        currentIndex: nextPointIndex,
        ...this.calculateSizeState(nextPointIndex) });

    }

    if (points.length !== nextPoints.length) {
      this.setState({
        currentIndex: nextPointIndex,
        ...this.calculateSizeState(nextPointIndex, nextPoints) });

    }
  }

  setDomElement(element) {
    this.domElement = element;
  }

  isShortVersion() {
    const { points } = this.props;
    return points.length <= 2;
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.points.length !== this.props.points.length) {
      this.calculateSizeCallback();
    }
  }

  calculateSizeState(nextPointIndex, nextPoints) {
    const points = nextPoints || this.props.points;
    const currentIndex =
    nextPointIndex !== undefined ? nextPointIndex : this.state.currentIndex;

    const container = this.domElement;

    if (container) {
      const containerWidth = Object(helpers["getElementWidth"])(container);
      const numberOfPoints = (points || []).length;
      let planSectionWidth;
      let knobShift;

      if (this.isShortVersion()) {
        planSectionWidth = containerWidth / Math.max(numberOfPoints, 1);
        planSectionWidth = Math.max(planSectionWidth, planSectionMinimalWidth);

        knobShift = (planSectionWidth - knobDiamiter) / 2;
      } else {
        planSectionWidth =
        (containerWidth - 2 * trackPaddingSize) / Math.max(numberOfPoints - 1, 1);
        planSectionWidth = Math.max(planSectionWidth, planSectionMinimalWidth);

        knobShift = (planSectionWidth - knobDiamiter) / 2;
      }

      return {
        planSectionWidth,
        knobShift,
        forcedPosition: this.calculateKnobPosition(
        currentIndex,
        knobShift,
        planSectionWidth) };


    }

    const { planSectionWidth, knobShift, forcedPosition } = this.state;

    return {
      planSectionWidth,
      knobShift,
      forcedPosition };

  }

  calculateKnobPosition(index, knobShift, planSectionWidth) {
    const result = { x: 0, y: 0 };

    if (this.isShortVersion()) {
      result.x = knobShift + planSectionWidth * index;
      return result;
    }

    if (index !== 0) {
      result.x =
      knobShift +
      planSectionWidth / 2 +
      trackPaddingSize +
      (index - 1) * planSectionWidth;
    }

    return result;
  }

  getDraggableBounds() {
    const { planSectionWidth } = this.state;
    const { points } = this.props;

    let right = 0;

    if (this.isShortVersion()) {
      right = points.length * planSectionWidth - knobDiamiter;
    } else {
      right = (points.length - 1) * planSectionWidth;
    }

    return {
      top: 0,
      left: 0,
      right,
      bottom: 0 };

  }

  dragHandler(e, data) {
    const { onPointSelected, points } = this.props;
    const { knobShift, planSectionWidth } = this.calculateSizeState();
    const pointIndex = this.state.currentIndex;
    const newPointIndex = this.getCurrentPointIndex(data.x);

    this.setState({
      currentIndex: newPointIndex,
      isDragging: true,
      knobShift,
      planSectionWidth });


    if (onPointSelected && pointIndex !== newPointIndex) {
      onPointSelected(points[newPointIndex]);
    }
  }

  dragStopHandler() {
    const { preventKnobUnpress } = this.props;
    const { currentIndex, isDragging } = this.state;
    const { knobShift, planSectionWidth } = this.calculateSizeState();

    if (isDragging) {
      this.setState({
        forcedPosition: this.calculateKnobPosition(
        currentIndex,
        knobShift,
        planSectionWidth),

        isDragging: false,
        knobShift,
        planSectionWidth });

    } else {
      // just click on the knob
      if (!preventKnobUnpress) this.toggleHoverable();
    }
  }

  dragStartHandler() {
    this.setState({
      forcedPosition: null });

  }

  selectNewPoint(point) {
    const { onPointSelected, points, shouldBlockPointSelection } = this.props;
    const { knobShift, planSectionWidth } = this.calculateSizeState();
    const prevIndex = this.state.currentIndex;
    const selectedIndex = points.indexOf(point);

    if (prevIndex !== selectedIndex && !shouldBlockPointSelection) {
      if (onPointSelected) {
        onPointSelected(point);
      }

      this.setState({
        forcedPosition: this.calculateKnobPosition(
        selectedIndex,
        knobShift,
        planSectionWidth),

        currentIndex: selectedIndex,
        planSectionWidth,
        knobShift });

    }
  }

  selectNewPointIfHoverable(point) {
    const { isHoverable, isDragging } = this.state;

    if (isHoverable && !isDragging) {
      this.selectNewPoint(point);
    }
  }

  toggleHoverable() {
    this.setState(prevState => ({ isHoverable: !prevState.isHoverable }));
  }

  getCurrentPointIndex(x) {
    const { points } = this.props;
    const { planSectionWidth } = this.state;

    const currentIndex = points.findIndex((point, i) => {
      if (this.isShortVersion()) {
        return x < (i + 1) * planSectionWidth;
      }

      return x < i * planSectionWidth + planSectionWidth / 2;
    });

    return Math.max(currentIndex, 0);
  }

  render() {
    const {
      className,
      points,
      defaultPointIndex,
      renderTrack,
      renderKnob,
      preventKnobDrag,
      plusSign } =
    this.props;
    const { currentIndex, forcedPosition, isDragging, isHoverable, isInited } = this.state;

    const bounds = this.getDraggableBounds();

    const currentPoint = points[currentIndex] || points[defaultPointIndex] || {};

    return /*#__PURE__*/(
      external_react_default.a.createElement("div", { className: classnames_default()(this.block(), className) }, /*#__PURE__*/
      external_react_default.a.createElement("div", { className: this.element('container'), ref: this.setDomElement },
      renderTrack({
        points,
        pointHoverHandler: this.selectNewPointIfHoverable,
        pointClickHandler: this.selectNewPoint,
        isShortVersion: this.isShortVersion(),
        plusSign }),


      isInited && /*#__PURE__*/
      external_react_default.a.createElement(react_draggable_default.a, {
        axis: "x",
        position: forcedPosition,
        bounds: bounds,
        onStart: this.dragStartHandler,
        onStop: this.dragStopHandler,
        onDrag: this.dragHandler,
        disabled: preventKnobDrag }, /*#__PURE__*/

      external_react_default.a.createElement("div", {
        className: this.element('knob-container', {
          animated: !isDragging }) },


      renderKnob({
        isPressed: !isHoverable && !isDragging,
        point: currentPoint,
        plusSign }))))));







  }}, _class2.isControlledSelector = pointIndex => typeof pointIndex === 'number', _temp)) || _class);


selector_Selector.propTypes = {
  className: external_prop_types_default.a.string,
  points: external_prop_types_default.a.arrayOf(
  external_prop_types_default.a.shape({
    label: external_prop_types_default.a.string,
    value: external_prop_types_default.a.number })).

  isRequired,
  defaultPointIndex: external_prop_types_default.a.number,
  pointIndex: external_prop_types_default.a.number,
  onPointSelected: external_prop_types_default.a.func.isRequired,
  renderTrack: external_prop_types_default.a.func.isRequired,
  renderKnob: external_prop_types_default.a.func.isRequired,
  isHoverable: external_prop_types_default.a.bool,
  preventKnobUnpress: external_prop_types_default.a.bool,
  shouldBlockPointSelection: external_prop_types_default.a.bool,
  preventKnobDrag: external_prop_types_default.a.bool,
  plusSign: external_prop_types_default.a.bool };


selector_Selector.defaultProps = {
  className: null,
  defaultPointIndex: 0,
  pointIndex: 0,
  isHoverable: true,
  preventKnobUnpress: false,
  shouldBlockPointSelection: false,
  preventKnobDrag: false,
  plusSign: false };
// EXTERNAL MODULE: ./src/components/rentalPlanSelector/knob/index.scss
var knob = __webpack_require__(168);

// CONCATENATED MODULE: ./src/components/rentalPlanSelector/knob/index.jsx
var knob_dec, knob_class;function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);} /* eslint-disable import/no-extraneous-dependencies */





let




knob_Knob = (knob_dec = react_bem_classes_default()({ block: 'ggKnob' }), knob_dec(knob_class = class Knob extends external_react_["Component"] {
  render() {
    const {
      label,
      value,
      isPressed,
      accentColor,
      accentTextColor,
      className,
      plusSign,
      ...rest } =
    this.props;

    const additionalStyles = {
      backgroundColor: accentColor };


    const additionalTextStyles = {
      color: accentTextColor };


    const knobClassList = classnames_default()(
    this.block({
      pressed: isPressed }),

    className);


    return /*#__PURE__*/(
      external_react_default.a.createElement("span", _extends({ className: knobClassList, style: additionalStyles }, rest), /*#__PURE__*/
      external_react_default.a.createElement("span", {
        className: this.element('value', {
          withAccentColor: Boolean(accentColor) }),

        style: additionalTextStyles },

      value,
      plusSign && /*#__PURE__*/external_react_default.a.createElement("span", null, "+")), /*#__PURE__*/


      external_react_default.a.createElement("span", {
        className: this.element('label', {
          withAccentColor: Boolean(accentColor) }),

        style: additionalTextStyles },

      label)));



  }}) || knob_class);


knob_Knob.propTypes = {
  label: external_prop_types_default.a.string,
  value: external_prop_types_default.a.number,
  isPressed: external_prop_types_default.a.bool,
  accentColor: external_prop_types_default.a.string,
  accentTextColor: external_prop_types_default.a.string,
  className: external_prop_types_default.a.string,
  plusSign: external_prop_types_default.a.bool };


knob_Knob.defaultProps = {
  label: '',
  value: '',
  isPressed: false,
  accentColor: null,
  accentTextColor: null,
  className: null,
  plusSign: false };
// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// CONCATENATED MODULE: ./src/components/rentalPlanSelector/track/styles.js



const minWidth = planSectionMinimalWidth / 2;

const GgTrack = external_styled_components_default.a.div.withConfig({ displayName: "styles__GgTrack", componentId: "sc-1xv7fjf-0" })(["display:flex;overflow:hidden;height:", "px;padding:0 ", "px;box-sizing:border-box;flex:1 0 auto;border-radius:", "px;cursor:pointer;letter-spacing:0.05em;border:2px solid ", ";"],


planSectionHeight,
trackPaddingSize,


planSectionHeight,


({ theme }) => `${theme.colors['Level 1']}`);


const PointSection = external_styled_components_default.a.div.withConfig({ displayName: "styles__PointSection", componentId: "sc-1xv7fjf-1" })(["flex:1 1 auto;min-width:", "px;height:100%;display:flex;align-items:center;justify-content:center;overflow:hidden;cursor:pointer;user-select:none;mix-blend-mode:normal;&:first-child,&:last-child{min-width:", ";flex-grow:", ";overflow:", ";justify-content:", ";}&:first-child{justify-content:flex-start;}&:last-child{justify-content:flex-end;}"],

planSectionMinimalWidth,










props => props.shortVersion ? 'initial' : minWidth,
props => props.shortVersion ? 1 : 0.5,
props => props.shortVersion ? 'initial' : 'visible',
props => props.shortVersion ? 'center' : 'unset');









const Point = external_styled_components_default.a.div.withConfig({ displayName: "styles__Point", componentId: "sc-1xv7fjf-2" })(["width:", "px;height:", "px;border-radius:50%;display:flex;align-items:center;justify-content:center;overflow:hidden;background-color:", ";&--firstChild{transform:", ";}&--lastChild{transform:", ";}"],
planContainerWidth,
planContainerHeight,





props => props.hasAccentColors ? props.backgroundColor : 'none',

props => props.shortVersion ? 'initial' : 'translateX(-50%)',


props => props.shortVersion ? 'initial' : 'translateX(50%)');



const Value = external_styled_components_default.a.div.withConfig({ displayName: "styles__Value", componentId: "sc-1xv7fjf-3" })(["box-sizing:content-box;text-overflow:ellipsis;overflow:hidden;", ";line-height:18px;text-align:center;color:", ";color:", ";"],



props => Object(external_styled_components_["css"])(props.theme.typography.SmallCapsHeadline),


({ theme }) => `${theme.colors['Level 4']}`,
props => props.hasAccentColors ? props.textColor : `${props.theme.colors['Level 4']}`);
// CONCATENATED MODULE: ./src/components/rentalPlanSelector/track/index.jsx





const Track = ({
  onPointClick,
  onPointHover,
  points,
  pointAccentColors,
  shortVersion,
  plusSign }) =>
{
  const { backgroundColor, textColor } = pointAccentColors;
  return /*#__PURE__*/(
    external_react_default.a.createElement(GgTrack, { shortVersion: shortVersion },
    points &&
    points.map((point) => /*#__PURE__*/
    external_react_default.a.createElement(PointSection, {
      key: point.planId,
      onClick: () => onPointClick(point),
      onMouseOver: () => onPointHover(point),
      onFocus: () => onPointHover(point) }, /*#__PURE__*/

    external_react_default.a.createElement(Point, {
      hasAccentColors: point.hasAccentColors,
      backgroundColor: backgroundColor,
      shortVersion: shortVersion }, /*#__PURE__*/

    external_react_default.a.createElement(Value, { hasAccentColors: point.hasAccentColors, textColor: textColor },
    point.value,
    plusSign && /*#__PURE__*/external_react_default.a.createElement("span", null, "+")))))));






};

Track.propTypes = {
  onPointClick: external_prop_types_default.a.func,
  onPointHover: external_prop_types_default.a.func,
  pointAccentColors: external_prop_types_default.a.shape({
    backgroundColor: external_prop_types_default.a.string,
    textColor: external_prop_types_default.a.string }),

  points: external_prop_types_default.a.arrayOf(
  external_prop_types_default.a.shape({
    label: external_prop_types_default.a.string,
    value: external_prop_types_default.a.number })),


  plusSign: external_prop_types_default.a.bool };


Track.defaultProps = {
  className: null,
  points: [],
  onPointClick: () => {},
  onPointHover: () => {},
  pointAccentColors: {},
  plusSign: false };


/* harmony default export */ var track = (Track);
// CONCATENATED MODULE: ./src/components/rentalPlanSelector/accentSelectorKnob.js
/* eslint-disable */







const AccentSelectorKnob = ({
  points,
  defaultPointIndex,
  pointIndex,
  onPointSelected,
  accentColor,
  className }) => /*#__PURE__*/

external_react_default.a.createElement(selector_Selector, {
  className: className,
  points: points,
  pointIndex: pointIndex,
  defaultPointIndex: defaultPointIndex,
  onPointSelected: onPointSelected,
  renderTrack: ({
    points,
    pointHoverHandler,
    pointClickHandler,
    isShortVersion }) => /*#__PURE__*/

  external_react_default.a.createElement(track, {
    points: points,
    onPointHover: pointHoverHandler,
    onPointClick: pointClickHandler,
    shortVersion: isShortVersion }),


  renderKnob: ({ point, isPressed }) => /*#__PURE__*/
  external_react_default.a.createElement(knob_Knob, {
    value: point.value,
    label: point.label,
    accentColor: accentColor,
    isPressed: isPressed }) });





AccentSelectorKnob.propTypes = {
  className: external_prop_types_default.a.string,
  accentColor: external_prop_types_default.a.string,
  points: external_prop_types_default.a.array,
  defaultPointIndex: external_prop_types_default.a.number,
  pointIndex: external_prop_types_default.a.number,
  onPointSelected: external_prop_types_default.a.func };


AccentSelectorKnob.defaultProps = {
  className: null,
  accentColor: null,
  points: [],
  defaultPointIndex: 0,
  // eslint-disable-next-line no-console
  onPointSelected: point => console.log(`Selected point`, point) };


/* harmony default export */ var accentSelectorKnob = (AccentSelectorKnob);
// CONCATENATED MODULE: ./src/components/rentalPlanSelector/AccentSelectorPoints.jsx
/* eslint-disable no-shadow */
/* eslint-disable react/no-did-update-set-state */
/* eslint-disable react/destructuring-assignment */







class AccentSelectorPoints_AccentSelectorPoints extends external_react_["Component"] {
  constructor(props) {
    super(props);this.














    checkAllPointsHaveAccentColor = () => {
      const { points } = this.props;

      return points.reduce((result, point) => result && point.hasAccentColors, true);
    };this.state = { allPointsHaveAccentColor: this.checkAllPointsHaveAccentColor() };}componentDidUpdate(prevProps) {if (prevProps.points !== this.props.points) {this.setState({ allPointsHaveAccentColor: this.checkAllPointsHaveAccentColor() });}}

  render() {
    const {
      points,
      defaultPointIndex,
      pointIndex,
      onPointSelected,
      pointAccentColors,
      className,
      isHoverable,
      preventKnobUnpress,
      shouldBlockPointSelection,
      preventKnobDrag,
      plusSign } =
    this.props;

    return /*#__PURE__*/(
      external_react_default.a.createElement(selector_Selector, {
        className: className,
        points: points,
        pointIndex: pointIndex,
        defaultPointIndex: defaultPointIndex,
        onPointSelected: onPointSelected,
        isHoverable: isHoverable,
        preventKnobDrag: preventKnobDrag,
        preventKnobUnpress: preventKnobUnpress,
        shouldBlockPointSelection: shouldBlockPointSelection,
        plusSign: plusSign,
        renderTrack: ({
          points,
          pointHoverHandler,
          pointClickHandler,
          isShortVersion,
          plusSign }) =>
        {
          const { allPointsHaveAccentColor } = this.state;

          return /*#__PURE__*/(
            external_react_default.a.createElement(track, {
              pointAccentColors: allPointsHaveAccentColor ? {} : pointAccentColors,
              points: points,
              onPointHover: pointHoverHandler,
              onPointClick: pointClickHandler,
              shortVersion: isShortVersion,
              plusSign: plusSign }));


        },
        renderKnob: ({ point, isPressed, plusSign }) => {
          const { backgroundColor, textColor } = pointAccentColors;

          return /*#__PURE__*/(
            external_react_default.a.createElement(knob_Knob, {
              value: point.value,
              label: point.label,
              accentColor: point.hasAccentColors ? backgroundColor : null,
              accentTextColor: point.hasAccentColors ? textColor : null,
              isPressed: isPressed,
              plusSign: plusSign }));


        } }));


  }}


/* harmony default export */ var rentalPlanSelector_AccentSelectorPoints = (AccentSelectorPoints_AccentSelectorPoints);

AccentSelectorPoints_AccentSelectorPoints.propTypes = {
  className: external_prop_types_default.a.string,
  pointAccentColors: external_prop_types_default.a.shape({
    backgroundColor: external_prop_types_default.a.string,
    textColor: external_prop_types_default.a.string }),

  points: external_prop_types_default.a.arrayOf(external_prop_types_default.a.shape({})),
  defaultPointIndex: external_prop_types_default.a.number,
  pointIndex: external_prop_types_default.a.number,
  onPointSelected: external_prop_types_default.a.func,
  isHoverable: external_prop_types_default.a.bool,
  preventKnobUnpress: external_prop_types_default.a.bool,
  shouldBlockPointSelection: external_prop_types_default.a.bool,
  preventKnobDrag: external_prop_types_default.a.bool,
  plusSign: external_prop_types_default.a.bool };


AccentSelectorPoints_AccentSelectorPoints.defaultProps = {
  className: null,
  pointAccentColors: {},
  points: [],
  defaultPointIndex: 0,
  pointIndex: 0,
  onPointSelected: () => {},
  isHoverable: true,
  preventKnobUnpress: false,
  shouldBlockPointSelection: false,
  preventKnobDrag: false,
  plusSign: false };
// CONCATENATED MODULE: ./src/components/rentalPlanSelector/index.js








/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _UIManager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(8);
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
 // NativeModules shim

var NativeModules = {
  UIManager: _UIManager__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]
};
/* harmony default export */ __webpack_exports__["a"] = (NativeModules);

/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if ( true && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {}
}());


/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */




// Important note: start() and stop() will only be called at most once.
// Once an animation has been stopped or finished its course, it will
// not be reused.
var Animation =
/*#__PURE__*/
function () {
  function Animation() {}

  var _proto = Animation.prototype;

  _proto.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {};

  _proto.stop = function stop() {
    if (this.__nativeId) {
      _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].API.stopAnimation(this.__nativeId);
    }
  };

  _proto.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
    // Subclasses that have corresponding animation implementation done in native
    // should override this method
    throw new Error('This animation type cannot be offloaded to native');
  } // Helper function for subclasses to make sure onEnd is only called once.
  ;

  _proto.__debouncedOnEnd = function __debouncedOnEnd(result) {
    var onEnd = this.__onEnd;
    this.__onEnd = null;
    onEnd && onEnd(result);
  };

  _proto.__startNativeAnimation = function __startNativeAnimation(animatedValue) {
    animatedValue.__makeNative();

    this.__nativeId = _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].generateNewAnimationId();
    _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"].API.startAnimatingNode(this.__nativeId, animatedValue.__getNativeTag(), this.__getNativeAnimationConfig(), this.__debouncedOnEnd.bind(this));
  };

  return Animation;
}();

/* harmony default export */ __webpack_exports__["a"] = (Animation);

/***/ }),
/* 38 */
/***/ (function(module, exports) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// CONCATENATED MODULE: ./node_modules/react-input-mask/es/constants/index.js
var defaultCharsRules = {
  '9': '[0-9]',
  'a': '[A-Za-z]',
  '*': '[A-Za-z0-9]'
};
var defaultMaskChar = '_';
// CONCATENATED MODULE: ./node_modules/react-input-mask/es/utils/parseMask.js

/* harmony default export */ var parseMask = (function (mask, maskChar, charsRules) {
  if (maskChar === undefined) {
    maskChar = defaultMaskChar;
  }

  if (charsRules == null) {
    charsRules = defaultCharsRules;
  }

  if (!mask || typeof mask !== 'string') {
    return {
      maskChar: maskChar,
      charsRules: charsRules,
      mask: null,
      prefix: null,
      lastEditablePos: null,
      permanents: []
    };
  }

  var str = '';
  var prefix = '';
  var permanents = [];
  var isPermanent = false;
  var lastEditablePos = null;
  mask.split('').forEach(function (character) {
    if (!isPermanent && character === '\\') {
      isPermanent = true;
    } else {
      if (isPermanent || !charsRules[character]) {
        permanents.push(str.length);

        if (str.length === permanents.length - 1) {
          prefix += character;
        }
      } else {
        lastEditablePos = str.length + 1;
      }

      str += character;
      isPermanent = false;
    }
  });
  return {
    maskChar: maskChar,
    charsRules: charsRules,
    prefix: prefix,
    mask: str,
    lastEditablePos: lastEditablePos,
    permanents: permanents
  };
});
// CONCATENATED MODULE: ./node_modules/react-input-mask/es/utils/environment.js
function isAndroidBrowser() {
  var windows = new RegExp('windows', 'i');
  var firefox = new RegExp('firefox', 'i');
  var android = new RegExp('android', 'i');
  var ua = navigator.userAgent;
  return !windows.test(ua) && !firefox.test(ua) && android.test(ua);
}
function isWindowsPhoneBrowser() {
  var windows = new RegExp('windows', 'i');
  var phone = new RegExp('phone', 'i');
  var ua = navigator.userAgent;
  return windows.test(ua) && phone.test(ua);
}
function isAndroidFirefox() {
  var windows = new RegExp('windows', 'i');
  var firefox = new RegExp('firefox', 'i');
  var android = new RegExp('android', 'i');
  var ua = navigator.userAgent;
  return !windows.test(ua) && firefox.test(ua) && android.test(ua);
}
function isIOS() {
  var windows = new RegExp('windows', 'i');
  var ios = new RegExp('(ipod|iphone|ipad)', 'i');
  var ua = navigator.userAgent;
  return !windows.test(ua) && ios.test(ua);
}
// CONCATENATED MODULE: ./node_modules/react-input-mask/es/utils/string.js
function isPermanentChar(maskOptions, pos) {
  return maskOptions.permanents.indexOf(pos) !== -1;
}
function isAllowedChar(maskOptions, pos, character) {
  var mask = maskOptions.mask,
      charsRules = maskOptions.charsRules;

  if (!character) {
    return false;
  }

  if (isPermanentChar(maskOptions, pos)) {
    return mask[pos] === character;
  }

  var ruleChar = mask[pos];
  var charRule = charsRules[ruleChar];
  return new RegExp(charRule).test(character);
}
function isEmpty(maskOptions, value) {
  return value.split('').every(function (character, i) {
    return isPermanentChar(maskOptions, i) || !isAllowedChar(maskOptions, i, character);
  });
}
function getFilledLength(maskOptions, value) {
  var maskChar = maskOptions.maskChar,
      prefix = maskOptions.prefix;

  if (!maskChar) {
    while (value.length > prefix.length && isPermanentChar(maskOptions, value.length - 1)) {
      value = value.slice(0, value.length - 1);
    }

    return value.length;
  }

  var filledLength = prefix.length;

  for (var i = value.length; i >= prefix.length; i--) {
    var character = value[i];
    var isEnteredCharacter = !isPermanentChar(maskOptions, i) && isAllowedChar(maskOptions, i, character);

    if (isEnteredCharacter) {
      filledLength = i + 1;
      break;
    }
  }

  return filledLength;
}
function isFilled(maskOptions, value) {
  return getFilledLength(maskOptions, value) === maskOptions.mask.length;
}
function formatValue(maskOptions, value) {
  var maskChar = maskOptions.maskChar,
      mask = maskOptions.mask,
      prefix = maskOptions.prefix;

  if (!maskChar) {
    value = insertString(maskOptions, '', value, 0);

    if (value.length < prefix.length) {
      value = prefix;
    }

    while (value.length < mask.length && isPermanentChar(maskOptions, value.length)) {
      value += mask[value.length];
    }

    return value;
  }

  if (value) {
    var emptyValue = formatValue(maskOptions, '');
    return insertString(maskOptions, emptyValue, value, 0);
  }

  for (var i = 0; i < mask.length; i++) {
    if (isPermanentChar(maskOptions, i)) {
      value += mask[i];
    } else {
      value += maskChar;
    }
  }

  return value;
}
function clearRange(maskOptions, value, start, len) {
  var end = start + len;
  var maskChar = maskOptions.maskChar,
      mask = maskOptions.mask,
      prefix = maskOptions.prefix;
  var arrayValue = value.split('');

  if (!maskChar) {
    // remove any permanent chars after clear range, they will be added back by foramtValue
    for (var i = end; i < arrayValue.length; i++) {
      if (isPermanentChar(maskOptions, i)) {
        arrayValue[i] = '';
      }
    }

    start = Math.max(prefix.length, start);
    arrayValue.splice(start, end - start);
    value = arrayValue.join('');
    return formatValue(maskOptions, value);
  }

  return arrayValue.map(function (character, i) {
    if (i < start || i >= end) {
      return character;
    }

    if (isPermanentChar(maskOptions, i)) {
      return mask[i];
    }

    return maskChar;
  }).join('');
}
function insertString(maskOptions, value, insertStr, insertPos) {
  var mask = maskOptions.mask,
      maskChar = maskOptions.maskChar,
      prefix = maskOptions.prefix;
  var arrayInsertStr = insertStr.split('');
  var isInputFilled = isFilled(maskOptions, value);

  var isUsablePosition = function isUsablePosition(pos, character) {
    return !isPermanentChar(maskOptions, pos) || character === mask[pos];
  };

  var isUsableCharacter = function isUsableCharacter(character, pos) {
    return !maskChar || !isPermanentChar(maskOptions, pos) || character !== maskChar;
  };

  if (!maskChar && insertPos > value.length) {
    value += mask.slice(value.length, insertPos);
  }

  arrayInsertStr.every(function (insertCharacter) {
    while (!isUsablePosition(insertPos, insertCharacter)) {
      if (insertPos >= value.length) {
        value += mask[insertPos];
      }

      if (!isUsableCharacter(insertCharacter, insertPos)) {
        return true;
      }

      insertPos++; // stop iteration if maximum value length reached

      if (insertPos >= mask.length) {
        return false;
      }
    }

    var isAllowed = isAllowedChar(maskOptions, insertPos, insertCharacter) || insertCharacter === maskChar;

    if (!isAllowed) {
      return true;
    }

    if (insertPos < value.length) {
      if (maskChar || isInputFilled || insertPos < prefix.length) {
        value = value.slice(0, insertPos) + insertCharacter + value.slice(insertPos + 1);
      } else {
        value = value.slice(0, insertPos) + insertCharacter + value.slice(insertPos);
        value = formatValue(maskOptions, value);
      }
    } else if (!maskChar) {
      value += insertCharacter;
    }

    insertPos++; // stop iteration if maximum value length reached

    return insertPos < mask.length;
  });
  return value;
}
function getInsertStringLength(maskOptions, value, insertStr, insertPos) {
  var mask = maskOptions.mask,
      maskChar = maskOptions.maskChar;
  var arrayInsertStr = insertStr.split('');
  var initialInsertPos = insertPos;

  var isUsablePosition = function isUsablePosition(pos, character) {
    return !isPermanentChar(maskOptions, pos) || character === mask[pos];
  };

  arrayInsertStr.every(function (insertCharacter) {
    while (!isUsablePosition(insertPos, insertCharacter)) {
      insertPos++; // stop iteration if maximum value length reached

      if (insertPos >= mask.length) {
        return false;
      }
    }

    var isAllowed = isAllowedChar(maskOptions, insertPos, insertCharacter) || insertCharacter === maskChar;

    if (isAllowed) {
      insertPos++;
    } // stop iteration if maximum value length reached


    return insertPos < mask.length;
  });
  return insertPos - initialInsertPos;
}
// CONCATENATED MODULE: ./node_modules/react-input-mask/es/utils/defer.js
/* harmony default export */ var defer = (function (fn) {
  var defer = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function () {
    return setTimeout(fn, 0);
  };

  return defer(fn);
});
// CONCATENATED MODULE: ./node_modules/react-input-mask/es/index.js
function _instanceof(left, right) { if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) { return right[Symbol.hasInstance](left); } else { return left instanceof right; } }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

// https://github.com/sanniassin/react-input-mask






var es_InputElement =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(InputElement, _React$Component);

  function InputElement(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    es_initialiseProps.call(_assertThisInitialized(_this));

    var mask = props.mask,
        maskChar = props.maskChar,
        formatChars = props.formatChars,
        defaultValue = props.defaultValue,
        value = props.value,
        alwaysShowMask = props.alwaysShowMask;
    _this.hasValue = value != null;
    _this.maskOptions = parseMask(mask, maskChar, formatChars);

    if (defaultValue == null) {
      defaultValue = '';
    }

    if (value == null) {
      value = defaultValue;
    }

    value = _this.getStringValue(value);

    if (_this.maskOptions.mask && (alwaysShowMask || value)) {
      value = formatValue(_this.maskOptions, value);
    }

    _this.value = value;
    return _this;
  }

  var _proto = InputElement.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.isAndroidBrowser = isAndroidBrowser();
    this.isWindowsPhoneBrowser = isWindowsPhoneBrowser();
    this.isAndroidFirefox = isAndroidFirefox();

    if (this.maskOptions.mask && this.getInputValue() !== this.value) {
      this.setInputValue(this.value);
    }
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var oldMaskOptions = this.maskOptions;
    this.hasValue = nextProps.value != null;
    this.maskOptions = parseMask(nextProps.mask, nextProps.maskChar, nextProps.formatChars);

    if (!this.maskOptions.mask) {
      this.backspaceOrDeleteRemoval = null;
      this.lastCursorPos = null;
      return;
    }

    var isMaskChanged = this.maskOptions.mask && this.maskOptions.mask !== oldMaskOptions.mask;
    var showEmpty = nextProps.alwaysShowMask || this.isFocused();
    var newValue = this.hasValue ? this.getStringValue(nextProps.value) : this.value;

    if (!oldMaskOptions.mask && !this.hasValue) {
      newValue = this.getInputValue();
    }

    if (isMaskChanged || this.maskOptions.mask && (newValue || showEmpty)) {
      newValue = formatValue(this.maskOptions, newValue);

      if (isMaskChanged) {
        var pos = this.lastCursorPos;
        var filledLen = getFilledLength(this.maskOptions, newValue);

        if (pos === null || filledLen < pos) {
          if (isFilled(this.maskOptions, newValue)) {
            pos = filledLen;
          } else {
            pos = this.getRightEditablePos(filledLen);
          }

          this.setCursorPos(pos);
        }
      }
    }

    if (this.maskOptions.mask && isEmpty(this.maskOptions, newValue) && !showEmpty && (!this.hasValue || !nextProps.value)) {
      newValue = '';
    }

    this.value = newValue;
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.maskOptions.mask && this.getInputValue() !== this.value) {
      this.setInputValue(this.value);
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    var _props = this.props,
        mask = _props.mask,
        alwaysShowMask = _props.alwaysShowMask,
        maskChar = _props.maskChar,
        formatChars = _props.formatChars,
        inputRef = _props.inputRef,
        props = _objectWithoutProperties(_props, ["mask", "alwaysShowMask", "maskChar", "formatChars", "inputRef"]);

    if (this.maskOptions.mask) {
      if (!props.disabled && !props.readOnly) {
        var handlersKeys = ['onChange', 'onKeyDown', 'onPaste', 'onMouseDown'];
        handlersKeys.forEach(function (key) {
          props[key] = _this2[key];
        });
      }

      if (props.value != null) {
        props.value = this.value;
      }
    }

    return external_react_default.a.createElement("input", _extends({
      ref: this.handleRef
    }, props, {
      onFocus: this.onFocus,
      onBlur: this.onBlur
    }));
  };

  return InputElement;
}(external_react_default.a.Component);

var es_initialiseProps = function _initialiseProps() {
  var _this3 = this;

  Object.defineProperty(this, "lastCursorPos", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: null
  });
  Object.defineProperty(this, "focused", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: false
  });
  Object.defineProperty(this, "isDOMElement", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(element) {
      return (typeof HTMLElement === "undefined" ? "undefined" : _typeof(HTMLElement)) === 'object' ? _instanceof(element, HTMLElement) // DOM2
      : element.nodeType === 1 && typeof element.nodeName === 'string';
    }
  });
  Object.defineProperty(this, "getInputDOMNode", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      var input = _this3.input;

      if (!input) {
        return null;
      }

      if (_this3.isDOMElement(input)) {
        return input;
      } // React 0.13


      return external_react_default.a.findDOMNode(input);
    }
  });
  Object.defineProperty(this, "getInputValue", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      var input = _this3.getInputDOMNode();

      if (!input) {
        return null;
      }

      return input.value;
    }
  });
  Object.defineProperty(this, "setInputValue", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(_value) {
      var input = _this3.getInputDOMNode();

      if (!input) {
        return;
      }

      _this3.value = _value;
      input.value = _value;
    }
  });
  Object.defineProperty(this, "getLeftEditablePos", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(pos) {
      for (var i = pos; i >= 0; --i) {
        if (!isPermanentChar(_this3.maskOptions, i)) {
          return i;
        }
      }

      return null;
    }
  });
  Object.defineProperty(this, "getRightEditablePos", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(pos) {
      var mask = _this3.maskOptions.mask;

      for (var i = pos; i < mask.length; ++i) {
        if (!isPermanentChar(_this3.maskOptions, i)) {
          return i;
        }
      }

      return null;
    }
  });
  Object.defineProperty(this, "setCursorToEnd", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      var filledLen = getFilledLength(_this3.maskOptions, _this3.value);

      var pos = _this3.getRightEditablePos(filledLen);

      if (pos !== null) {
        _this3.setCursorPos(pos);
      }
    }
  });
  Object.defineProperty(this, "setSelection", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(start, len) {
      if (len === void 0) {
        len = 0;
      }

      var input = _this3.getInputDOMNode();

      if (!input) {
        return;
      }

      var end = start + len;

      if ('selectionStart' in input && 'selectionEnd' in input) {
        input.selectionStart = start;
        input.selectionEnd = end;
      } else {
        var range = input.createTextRange();
        range.collapse(true);
        range.moveStart('character', start);
        range.moveEnd('character', end - start);
        range.select();
      }
    }
  });
  Object.defineProperty(this, "getSelection", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      var input = _this3.getInputDOMNode();

      var start = 0;
      var end = 0;

      if ('selectionStart' in input && 'selectionEnd' in input) {
        start = input.selectionStart;
        end = input.selectionEnd;
      } else {
        var range = document.selection.createRange();

        if (range.parentElement() === input) {
          start = -range.moveStart('character', -input.value.length);
          end = -range.moveEnd('character', -input.value.length);
        }
      }

      return {
        start: start,
        end: end,
        length: end - start
      };
    }
  });
  Object.defineProperty(this, "getCursorPos", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      return _this3.getSelection().start;
    }
  });
  Object.defineProperty(this, "setCursorPos", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(pos) {
      _this3.setSelection(pos, 0);

      defer(function () {
        _this3.setSelection(pos, 0);
      });
      _this3.lastCursorPos = pos;
    }
  });
  Object.defineProperty(this, "isFocused", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value() {
      return _this3.focused;
    }
  });
  Object.defineProperty(this, "getStringValue", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(_value2) {
      return !_value2 && _value2 !== 0 ? '' : _value2 + '';
    }
  });
  Object.defineProperty(this, "onKeyDown", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      _this3.backspaceOrDeleteRemoval = null;

      if (typeof _this3.props.onKeyDown === 'function') {
        _this3.props.onKeyDown(event);
      }

      var key = event.key,
          ctrlKey = event.ctrlKey,
          metaKey = event.metaKey,
          defaultPrevented = event.defaultPrevented;

      if (ctrlKey || metaKey || defaultPrevented) {
        return;
      }

      if (key === 'Backspace' || key === 'Delete') {
        var selection = _this3.getSelection();

        var canRemove = key === 'Backspace' && selection.end > 0 || key === 'Delete' && _this3.value.length > selection.start;

        if (!canRemove) {
          return;
        }

        _this3.backspaceOrDeleteRemoval = {
          key: key,
          selection: _this3.getSelection()
        };
      }
    }
  });
  Object.defineProperty(this, "onChange", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      var beforePasteState = _this3.beforePasteState;
      var _this3$maskOptions = _this3.maskOptions,
          mask = _this3$maskOptions.mask,
          maskChar = _this3$maskOptions.maskChar,
          lastEditablePos = _this3$maskOptions.lastEditablePos,
          prefix = _this3$maskOptions.prefix;

      var value = _this3.getInputValue();

      if (beforePasteState) {
        _this3.beforePasteState = null;

        _this3.pasteText(beforePasteState.value, value, beforePasteState.selection, event);

        return;
      }

      var oldValue = _this3.value;

      var input = _this3.getInputDOMNode(); // autofill replaces whole value, ignore old one
      // https://github.com/sanniassin/react-input-mask/issues/113
      //
      // input.matches throws exception if selector isn't supported


      try {
        if (typeof input.matches === 'function' && input.matches(':-webkit-autofill')) {
          oldValue = '';
        }
      } catch (e) {}

      var selection = _this3.getSelection();

      var cursorPos = selection.end;
      var maskLen = mask.length;
      var valueLen = value.length;
      var oldValueLen = oldValue.length;
      var clearedValue;
      var enteredString;

      if (_this3.backspaceOrDeleteRemoval) {
        var deleteFromRight = _this3.backspaceOrDeleteRemoval.key === 'Delete';
        value = _this3.value;
        selection = _this3.backspaceOrDeleteRemoval.selection;
        cursorPos = selection.start;
        _this3.backspaceOrDeleteRemoval = null;

        if (selection.length) {
          value = clearRange(_this3.maskOptions, value, selection.start, selection.length);
        } else if (selection.start < prefix.length || !deleteFromRight && selection.start === prefix.length) {
          cursorPos = prefix.length;
        } else {
          var editablePos = deleteFromRight ? _this3.getRightEditablePos(cursorPos) : _this3.getLeftEditablePos(cursorPos - 1);

          if (editablePos !== null) {
            if (!maskChar) {
              value = value.substr(0, getFilledLength(_this3.maskOptions, value));
            }

            value = clearRange(_this3.maskOptions, value, editablePos, 1);
            cursorPos = editablePos;
          }
        }
      } else if (valueLen > oldValueLen) {
        var enteredStringLen = valueLen - oldValueLen;
        var startPos = selection.end - enteredStringLen;
        enteredString = value.substr(startPos, enteredStringLen);

        if (startPos < lastEditablePos && (enteredStringLen !== 1 || enteredString !== mask[startPos])) {
          cursorPos = _this3.getRightEditablePos(startPos);
        } else {
          cursorPos = startPos;
        }

        value = value.substr(0, startPos) + value.substr(startPos + enteredStringLen);
        clearedValue = clearRange(_this3.maskOptions, value, startPos, maskLen - startPos);
        clearedValue = insertString(_this3.maskOptions, clearedValue, enteredString, cursorPos);
        value = insertString(_this3.maskOptions, oldValue, enteredString, cursorPos);

        if (enteredStringLen !== 1 || cursorPos >= prefix.length && cursorPos < lastEditablePos) {
          cursorPos = Math.max(getFilledLength(_this3.maskOptions, clearedValue), cursorPos);

          if (cursorPos < lastEditablePos) {
            cursorPos = _this3.getRightEditablePos(cursorPos);
          }
        } else if (cursorPos < lastEditablePos) {
          cursorPos++;
        }
      } else if (valueLen < oldValueLen) {
        var removedLen = maskLen - valueLen;
        enteredString = value.substr(0, selection.end);
        var clearOnly = enteredString === oldValue.substr(0, selection.end);
        clearedValue = clearRange(_this3.maskOptions, oldValue, selection.end, removedLen);

        if (maskChar) {
          value = insertString(_this3.maskOptions, clearedValue, enteredString, 0);
        }

        clearedValue = clearRange(_this3.maskOptions, clearedValue, selection.end, maskLen - selection.end);
        clearedValue = insertString(_this3.maskOptions, clearedValue, enteredString, 0);

        if (!clearOnly) {
          cursorPos = Math.max(getFilledLength(_this3.maskOptions, clearedValue), cursorPos);

          if (cursorPos < lastEditablePos) {
            cursorPos = _this3.getRightEditablePos(cursorPos);
          }
        } else if (cursorPos < prefix.length) {
          cursorPos = prefix.length;
        }
      }

      value = formatValue(_this3.maskOptions, value);

      _this3.setInputValue(value);

      if (typeof _this3.props.onChange === 'function') {
        _this3.props.onChange(event);
      }

      if (_this3.isWindowsPhoneBrowser) {
        defer(function () {
          _this3.setSelection(cursorPos, 0);
        });
      } else {
        _this3.setCursorPos(cursorPos);
      }
    }
  });
  Object.defineProperty(this, "onFocus", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      _this3.focused = true;

      if (_this3.maskOptions.mask) {
        if (!_this3.value) {
          var prefix = _this3.maskOptions.prefix;
          var value = formatValue(_this3.maskOptions, prefix);
          var inputValue = formatValue(_this3.maskOptions, value); // do not use this.getInputValue and this.setInputValue as this.input
          // can be undefined at this moment if autoFocus attribute is set

          var isInputValueChanged = inputValue !== event.target.value;

          if (isInputValueChanged) {
            event.target.value = inputValue;
          }

          _this3.value = inputValue;

          if (isInputValueChanged && typeof _this3.props.onChange === 'function') {
            _this3.props.onChange(event);
          }

          _this3.setCursorToEnd();
        } else if (getFilledLength(_this3.maskOptions, _this3.value) < _this3.maskOptions.mask.length) {
          _this3.setCursorToEnd();
        }
      }

      if (typeof _this3.props.onFocus === 'function') {
        _this3.props.onFocus(event);
      }
    }
  });
  Object.defineProperty(this, "onBlur", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      _this3.focused = false;

      if (_this3.maskOptions.mask && !_this3.props.alwaysShowMask && isEmpty(_this3.maskOptions, _this3.value)) {
        var inputValue = '';

        var isInputValueChanged = inputValue !== _this3.getInputValue();

        if (isInputValueChanged) {
          _this3.setInputValue(inputValue);
        }

        if (isInputValueChanged && typeof _this3.props.onChange === 'function') {
          _this3.props.onChange(event);
        }
      }

      if (typeof _this3.props.onBlur === 'function') {
        _this3.props.onBlur(event);
      }
    }
  });
  Object.defineProperty(this, "onMouseDown", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      // tiny unintentional mouse movements can break cursor
      // position on focus, so we have to restore it in that case
      //
      // https://github.com/sanniassin/react-input-mask/issues/108
      if (!_this3.focused && document.addEventListener) {
        _this3.mouseDownX = event.clientX;
        _this3.mouseDownY = event.clientY;
        _this3.mouseDownTime = new Date().getTime();

        var mouseUpHandler = function mouseUpHandler(mouseUpEvent) {
          document.removeEventListener('mouseup', mouseUpHandler);

          if (!_this3.focused) {
            return;
          }

          var deltaX = Math.abs(mouseUpEvent.clientX - _this3.mouseDownX);
          var deltaY = Math.abs(mouseUpEvent.clientY - _this3.mouseDownY);
          var axisDelta = Math.max(deltaX, deltaY);

          var timeDelta = new Date().getTime() - _this3.mouseDownTime;

          if (axisDelta <= 10 && timeDelta <= 200 || axisDelta <= 5 && timeDelta <= 300) {
            _this3.setCursorToEnd();
          }
        };

        document.addEventListener('mouseup', mouseUpHandler);
      }

      if (typeof _this3.props.onMouseDown === 'function') {
        _this3.props.onMouseDown(event);
      }
    }
  });
  Object.defineProperty(this, "onPaste", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(event) {
      if (typeof _this3.props.onPaste === 'function') {
        _this3.props.onPaste(event);
      } // we need raw pasted text, but event.clipboardData
      // may not work in Android browser, so we clean input
      // to get raw text in onChange handler


      if (!event.defaultPrevented) {
        _this3.beforePasteState = {
          value: _this3.getInputValue(),
          selection: _this3.getSelection()
        };

        _this3.setInputValue('');
      }
    }
  });
  Object.defineProperty(this, "pasteText", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(_value3, text, selection, event) {
      var cursorPos = selection.start;

      if (selection.length) {
        _value3 = clearRange(_this3.maskOptions, _value3, cursorPos, selection.length);
      }

      var textLen = getInsertStringLength(_this3.maskOptions, _value3, text, cursorPos);
      _value3 = insertString(_this3.maskOptions, _value3, text, cursorPos);
      cursorPos += textLen;
      cursorPos = _this3.getRightEditablePos(cursorPos) || cursorPos;

      _this3.setInputValue(_value3);

      if (event && typeof _this3.props.onChange === 'function') {
        _this3.props.onChange(event);
      }

      _this3.setCursorPos(cursorPos);
    }
  });
  Object.defineProperty(this, "handleRef", {
    configurable: true,
    enumerable: true,
    writable: true,
    value: function value(ref) {
      _this3.input = ref;

      if (typeof _this3.props.inputRef === 'function') {
        _this3.props.inputRef(ref);
      }
    }
  });
};

/* harmony default export */ var es = __webpack_exports__["a"] = (es_InputElement);

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
function isFunction(func) {
  return typeof func === 'function';
}

/* harmony default export */ __webpack_exports__["default"] = (isFunction);

/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isPrefixedValue;
var regex = /-webkit-|-moz-|-ms-/;

function isPrefixedValue(value) {
  return typeof value === 'string' && regex.test(value);
}
module.exports = exports['default'];

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmCancelButton = exports.ButtonsWrap = exports.TimerProgress = exports.TimerDismissButton = exports.CircleDismissButton = exports.UndoButton = exports.DismissedText = exports.DismissingContainer = exports.Content = exports.Card = void 0;
const styled_components_1 = __importStar(__webpack_require__(2));
const ProgressRing_1 = __webpack_require__(54);
const Button_1 = __webpack_require__(33);
const styles_1 = __webpack_require__(108);
const Card_1 = __webpack_require__(22);
const cardPaddingInPx = 16;
exports.Card = styled_components_1.default(Card_1.Card) `
    padding: ${cardPaddingInPx}px;
    position: relative;
    overflow: hidden;
    box-sizing: content-box;
    transition-duration: 300ms;
    margin-bottom: ${({ theme }) => theme.spacers.M};

    ${({ height, theme, backgroundColor }) => styled_components_1.css `
        height: ${height ? `${height}px` : 'auto'};
        background-color: ${backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.colors.ElementBackground};
    `}

    ${(props) => props.dismissed
    ? styled_components_1.css `
                  border-color: transparent;
                  background-color: ${props.theme.colors['Level 1']};
              `
    : ''};

    &.dismissing-card-exit {
        opacity: 1;
    }

    &.dismissing-card-exit-active,
    &.dismissing-card-exit-done {
        opacity: 0;
    }
`;
exports.Content = styled_components_1.default.div ``;
exports.DismissingContainer = styled_components_1.default.div `
    ${(props) => props.hasTimeout
    ? styled_components_1.css `
                  display: flex;
                  align-items: center;
              `
    : ''};
`;
exports.DismissedText = styled_components_1.default.p `
    flex: 1 1 auto;
    align-self: flex-start;
    color: ${(props) => props.hasTimeout ? props.theme.colors['Level 4'] : props.theme.colors['Level 5']};
    ${(props) => styled_components_1.css(props.theme.typography.Paragraph)};
    line-height: 32px;
`;
exports.UndoButton = styled_components_1.default(Button_1.Button) `
    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 8px;

    ${styles_1.BtnText} {
        line-height: 24px;
        color: ${(props) => props.theme.colors['Level 5']};
        ${(props) => styled_components_1.css(props.theme.typography.Paragraph)};
    }

    ${styles_1.BtnIcon} {
        max-width: unset;
    }
`;
exports.CircleDismissButton = styled_components_1.default(Button_1.Button) `
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 12px;
    padding: 0;
    min-width: auto;

    display: flex;
    align-items: center;
    justify-content: center;

    position: absolute;

    ${(props) => {
    var _a, _b, _c, _d;
    return styled_components_1.css `
        top: ${(_b = (_a = props.$position) === null || _a === void 0 ? void 0 : _a.top) !== null && _b !== void 0 ? _b : cardPaddingInPx}px;
        right: ${(_d = (_c = props.$position) === null || _c === void 0 ? void 0 : _c.right) !== null && _d !== void 0 ? _d : cardPaddingInPx}px;
    `;
}}
`;
exports.TimerDismissButton = styled_components_1.default(Button_1.Button) `
    width: 32px;
    height: 32px;
    border: 0;
    padding: 0;

    ${styles_1.BtnIcon} {
        max-width: unset;
        margin: 0;
    }
`;
exports.TimerProgress = styled_components_1.default(ProgressRing_1.ProgressRing) `
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
`;
exports.ButtonsWrap = styled_components_1.default.div `
    display: flex;
    margin-top: ${({ theme }) => theme.spacers.XL};
`;
exports.ConfirmCancelButton = styled_components_1.default(Button_1.Button) `
    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 8px;

    ${styles_1.BtnText} {
        line-height: 24px;
        color: ${({ theme }) => theme.colors.negative};
        ${(props) => styled_components_1.css(props.theme.typography.Paragraph)};
    }

    ${styles_1.BtnIcon} {
        max-width: unset;
    }
`;


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.feedbackIconMap = exports.Feedback = exports.Steps = void 0;
const AngryFace_1 = __importDefault(__webpack_require__(251));
const SadFace_1 = __importDefault(__webpack_require__(252));
const StraightFace_1 = __importDefault(__webpack_require__(253));
const HappyFace_1 = __importDefault(__webpack_require__(254));
const StarstruckFace_1 = __importDefault(__webpack_require__(255));
var Steps;
(function (Steps) {
    Steps["Emoji"] = "Emoji";
    Steps["Reason"] = "Reason";
    Steps["Conclusion"] = "Conclusion";
})(Steps = exports.Steps || (exports.Steps = {}));
var Feedback;
(function (Feedback) {
    Feedback["Horrible"] = "Horrible";
    Feedback["Bad"] = "Bad";
    Feedback["Okay"] = "Okay";
    Feedback["Great"] = "Great";
    Feedback["Awesome"] = "Awesome";
})(Feedback = exports.Feedback || (exports.Feedback = {}));
exports.feedbackIconMap = {
    [Feedback.Horrible]: AngryFace_1.default,
    [Feedback.Bad]: SadFace_1.default,
    [Feedback.Okay]: StraightFace_1.default,
    [Feedback.Great]: HappyFace_1.default,
    [Feedback.Awesome]: StarstruckFace_1.default,
};


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const palette = {
    torchRed: {
        100: '#FE1251',
        120: '#BA264D',
        75: '#FE4D7C',
        50: '#FE88A8',
        25: '#FFC4D3',
        15: '#FFDBE5',
        7: '#FFEEF3',
    },
    electricBlue: {
        100: '#022AFF',
        120: '#182D99',
        75: '#415FFF',
        50: '#8094FF',
        25: '#C0CAFF',
        15: '#D9DFFF',
        7: '#EDF0FF',
    },
    business: {
        100: '#022AFF',
        120: '#182D99',
        75: '#415FFF',
        50: '#848BA4',
        25: '#C1C5D1',
        15: '#DADCE4',
        7: '#EEEFF2',
    },
    yolk: {
        100: '#FFC700',
        120: '#EDA210',
        75: '#FFD540',
        50: '#FFE380',
        25: '#FFF1BF',
        15: '#FFF7D9',
        7: '#FFFBED',
    },
    broccoli: {
        100: '#53B023',
        120: '#47961E',
        75: '#7EC45A',
        50: '#A9D791',
        25: '#D4EBC8',
        15: '#E5F3DE',
        7: '#F3F9F0',
    },
    eggplant: {
        100: '#62319E',
        120: '#492577',
        75: '#8964B6',
        50: '#B098CE',
        25: '#D8CBE7',
        15: '#E7E0F0',
        7: '#F4F1F8',
    },
    tomato: {
        100: '#EF432D',
        120: '#B33222',
        75: '#F37261',
        50: '#F7A196',
        25: '#FBD0CA',
        15: '#FDE3E0',
        7: '#FEF2F0',
    },
    grey: {
        100: '#333333',
        120: '#262626',
        75: '#666666',
        50: '#999999',
        25: '#CCCCCC',
        15: '#E0E0E0',
        7: '#F1F1F1',
    },
};
exports.default = palette;


/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* eslint-disable no-var, prefer-template */
var uppercasePattern = /[A-Z]/g
var msPattern = /^ms-/
var cache = {}

function toHyphenLower(match) {
  return '-' + match.toLowerCase()
}

function hyphenateStyleName(name) {
  if (cache.hasOwnProperty(name)) {
    return cache[name]
  }

  var hName = name.replace(uppercasePattern, toHyphenLower)
  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
}

/* harmony default export */ __webpack_exports__["default"] = (hyphenateStyleName);


/***/ }),
/* 46 */
/***/ (function(module, exports) {

/*
 * Copyright (c) 2015-present, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 */

function normalizeColor(color) {
  var match;

  if (typeof color === 'number') {
    if (color >>> 0 === color && color >= 0 && color <= 0xffffffff) {
      return color;
    }
    return null;
  }

  // Ordered based on occurrences on Facebook codebase
  if ((match = matchers.hex6.exec(color))) {
    return parseInt(match[1] + 'ff', 16) >>> 0;
  }

  if (names.hasOwnProperty(color)) {
    return names[color];
  }

  if ((match = matchers.rgb.exec(color))) {
    return (
        parse255(match[1]) << 24 | // r
        parse255(match[2]) << 16 | // g
        parse255(match[3]) << 8 | // b
        0x000000ff // a
      ) >>> 0;
  }

  if ((match = matchers.rgba.exec(color))) {
    return (
        parse255(match[1]) << 24 | // r
        parse255(match[2]) << 16 | // g
        parse255(match[3]) << 8 | // b
        parse1(match[4]) // a
      ) >>> 0;
  }

  if ((match = matchers.hex3.exec(color))) {
    return parseInt(
        match[1] + match[1] + // r
        match[2] + match[2] + // g
        match[3] + match[3] + // b
        'ff', // a
        16
      ) >>> 0;
  }

  // https://drafts.csswg.org/css-color-4/#hex-notation
  if ((match = matchers.hex8.exec(color))) {
    return parseInt(match[1], 16) >>> 0;
  }

  if ((match = matchers.hex4.exec(color))) {
    return parseInt(
        match[1] + match[1] + // r
        match[2] + match[2] + // g
        match[3] + match[3] + // b
        match[4] + match[4], // a
        16
      ) >>> 0;
  }

  if ((match = matchers.hsl.exec(color))) {
    return (
        hslToRgb(
          parse360(match[1]), // h
          parsePercentage(match[2]), // s
          parsePercentage(match[3]) // l
        ) |
        0x000000ff // a
      ) >>> 0;
  }

  if ((match = matchers.hsla.exec(color))) {
    return (
        hslToRgb(
          parse360(match[1]), // h
          parsePercentage(match[2]), // s
          parsePercentage(match[3]) // l
        ) |
        parse1(match[4]) // a
      ) >>> 0;
  }

  return null;
}

function hue2rgb(p, q, t) {
  if (t < 0) {
    t += 1;
  }
  if (t > 1) {
    t -= 1;
  }
  if (t < 1 / 6) {
    return p + (q - p) * 6 * t;
  }
  if (t < 1 / 2) {
    return q;
  }
  if (t < 2 / 3) {
    return p + (q - p) * (2 / 3 - t) * 6;
  }
  return p;
}

function hslToRgb(h, s, l) {
  var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
  var p = 2 * l - q;
  var r = hue2rgb(p, q, h + 1 / 3);
  var g = hue2rgb(p, q, h);
  var b = hue2rgb(p, q, h - 1 / 3);

  return (
    Math.round(r * 255) << 24 |
    Math.round(g * 255) << 16 |
    Math.round(b * 255) << 8
  );
}

// var INTEGER = '[-+]?\\d+';
var NUMBER = '[-+]?\\d*\\.?\\d+';
var PERCENTAGE = NUMBER + '%';

function toArray(arrayLike) {
  return Array.prototype.slice.call(arrayLike, 0);
}

function call() {
  return '\\(\\s*(' + toArray(arguments).join(')\\s*,\\s*(') + ')\\s*\\)';
}

var matchers = {
  rgb: new RegExp('rgb' + call(NUMBER, NUMBER, NUMBER)),
  rgba: new RegExp('rgba' + call(NUMBER, NUMBER, NUMBER, NUMBER)),
  hsl: new RegExp('hsl' + call(NUMBER, PERCENTAGE, PERCENTAGE)),
  hsla: new RegExp('hsla' + call(NUMBER, PERCENTAGE, PERCENTAGE, NUMBER)),
  hex3: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex4: /^#([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#([0-9a-fA-F]{6})$/,
  hex8: /^#([0-9a-fA-F]{8})$/,
};

function parse255(str) {
  var int = parseInt(str, 10);
  if (int < 0) {
    return 0;
  }
  if (int > 255) {
    return 255;
  }
  return int;
}

function parse360(str) {
  var int = parseFloat(str);
  return (((int % 360) + 360) % 360) / 360;
}

function parse1(str) {
  var num = parseFloat(str);
  if (num < 0) {
    return 0;
  }
  if (num > 1) {
    return 255;
  }
  return Math.round(num * 255);
}

function parsePercentage(str) {
  // parseFloat conveniently ignores the final %
  var int = parseFloat(str, 10);
  if (int < 0) {
    return 0;
  }
  if (int > 100) {
    return 1;
  }
  return int / 100;
}

var names = {
  transparent: 0x00000000,

  // http://www.w3.org/TR/css3-color/#svg-color
  aliceblue: 0xf0f8ffff,
  antiquewhite: 0xfaebd7ff,
  aqua: 0x00ffffff,
  aquamarine: 0x7fffd4ff,
  azure: 0xf0ffffff,
  beige: 0xf5f5dcff,
  bisque: 0xffe4c4ff,
  black: 0x000000ff,
  blanchedalmond: 0xffebcdff,
  blue: 0x0000ffff,
  blueviolet: 0x8a2be2ff,
  brown: 0xa52a2aff,
  burlywood: 0xdeb887ff,
  burntsienna: 0xea7e5dff,
  cadetblue: 0x5f9ea0ff,
  chartreuse: 0x7fff00ff,
  chocolate: 0xd2691eff,
  coral: 0xff7f50ff,
  cornflowerblue: 0x6495edff,
  cornsilk: 0xfff8dcff,
  crimson: 0xdc143cff,
  cyan: 0x00ffffff,
  darkblue: 0x00008bff,
  darkcyan: 0x008b8bff,
  darkgoldenrod: 0xb8860bff,
  darkgray: 0xa9a9a9ff,
  darkgreen: 0x006400ff,
  darkgrey: 0xa9a9a9ff,
  darkkhaki: 0xbdb76bff,
  darkmagenta: 0x8b008bff,
  darkolivegreen: 0x556b2fff,
  darkorange: 0xff8c00ff,
  darkorchid: 0x9932ccff,
  darkred: 0x8b0000ff,
  darksalmon: 0xe9967aff,
  darkseagreen: 0x8fbc8fff,
  darkslateblue: 0x483d8bff,
  darkslategray: 0x2f4f4fff,
  darkslategrey: 0x2f4f4fff,
  darkturquoise: 0x00ced1ff,
  darkviolet: 0x9400d3ff,
  deeppink: 0xff1493ff,
  deepskyblue: 0x00bfffff,
  dimgray: 0x696969ff,
  dimgrey: 0x696969ff,
  dodgerblue: 0x1e90ffff,
  firebrick: 0xb22222ff,
  floralwhite: 0xfffaf0ff,
  forestgreen: 0x228b22ff,
  fuchsia: 0xff00ffff,
  gainsboro: 0xdcdcdcff,
  ghostwhite: 0xf8f8ffff,
  gold: 0xffd700ff,
  goldenrod: 0xdaa520ff,
  gray: 0x808080ff,
  green: 0x008000ff,
  greenyellow: 0xadff2fff,
  grey: 0x808080ff,
  honeydew: 0xf0fff0ff,
  hotpink: 0xff69b4ff,
  indianred: 0xcd5c5cff,
  indigo: 0x4b0082ff,
  ivory: 0xfffff0ff,
  khaki: 0xf0e68cff,
  lavender: 0xe6e6faff,
  lavenderblush: 0xfff0f5ff,
  lawngreen: 0x7cfc00ff,
  lemonchiffon: 0xfffacdff,
  lightblue: 0xadd8e6ff,
  lightcoral: 0xf08080ff,
  lightcyan: 0xe0ffffff,
  lightgoldenrodyellow: 0xfafad2ff,
  lightgray: 0xd3d3d3ff,
  lightgreen: 0x90ee90ff,
  lightgrey: 0xd3d3d3ff,
  lightpink: 0xffb6c1ff,
  lightsalmon: 0xffa07aff,
  lightseagreen: 0x20b2aaff,
  lightskyblue: 0x87cefaff,
  lightslategray: 0x778899ff,
  lightslategrey: 0x778899ff,
  lightsteelblue: 0xb0c4deff,
  lightyellow: 0xffffe0ff,
  lime: 0x00ff00ff,
  limegreen: 0x32cd32ff,
  linen: 0xfaf0e6ff,
  magenta: 0xff00ffff,
  maroon: 0x800000ff,
  mediumaquamarine: 0x66cdaaff,
  mediumblue: 0x0000cdff,
  mediumorchid: 0xba55d3ff,
  mediumpurple: 0x9370dbff,
  mediumseagreen: 0x3cb371ff,
  mediumslateblue: 0x7b68eeff,
  mediumspringgreen: 0x00fa9aff,
  mediumturquoise: 0x48d1ccff,
  mediumvioletred: 0xc71585ff,
  midnightblue: 0x191970ff,
  mintcream: 0xf5fffaff,
  mistyrose: 0xffe4e1ff,
  moccasin: 0xffe4b5ff,
  navajowhite: 0xffdeadff,
  navy: 0x000080ff,
  oldlace: 0xfdf5e6ff,
  olive: 0x808000ff,
  olivedrab: 0x6b8e23ff,
  orange: 0xffa500ff,
  orangered: 0xff4500ff,
  orchid: 0xda70d6ff,
  palegoldenrod: 0xeee8aaff,
  palegreen: 0x98fb98ff,
  paleturquoise: 0xafeeeeff,
  palevioletred: 0xdb7093ff,
  papayawhip: 0xffefd5ff,
  peachpuff: 0xffdab9ff,
  peru: 0xcd853fff,
  pink: 0xffc0cbff,
  plum: 0xdda0ddff,
  powderblue: 0xb0e0e6ff,
  purple: 0x800080ff,
  rebeccapurple: 0x663399ff,
  red: 0xff0000ff,
  rosybrown: 0xbc8f8fff,
  royalblue: 0x4169e1ff,
  saddlebrown: 0x8b4513ff,
  salmon: 0xfa8072ff,
  sandybrown: 0xf4a460ff,
  seagreen: 0x2e8b57ff,
  seashell: 0xfff5eeff,
  sienna: 0xa0522dff,
  silver: 0xc0c0c0ff,
  skyblue: 0x87ceebff,
  slateblue: 0x6a5acdff,
  slategray: 0x708090ff,
  slategrey: 0x708090ff,
  snow: 0xfffafaff,
  springgreen: 0x00ff7fff,
  steelblue: 0x4682b4ff,
  tan: 0xd2b48cff,
  teal: 0x008080ff,
  thistle: 0xd8bfd8ff,
  tomato: 0xff6347ff,
  turquoise: 0x40e0d0ff,
  violet: 0xee82eeff,
  wheat: 0xf5deb3ff,
  white: 0xffffffff,
  whitesmoke: 0xf5f5f5ff,
  yellow: 0xffff00ff,
  yellowgreen: 0x9acd32ff,
};

function rgba(colorInt) {
  var r = Math.round(((colorInt & 0xff000000) >>> 24));
  var g = Math.round(((colorInt & 0x00ff0000) >>> 16));
  var b = Math.round(((colorInt & 0x0000ff00) >>> 8));
  var a = ((colorInt & 0x000000ff) >>> 0) / 255;
  return {
    r: r,
    g: g,
    b: b,
    a: a,
  };
};

normalizeColor.rgba = rgba;

module.exports = normalizeColor;


/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _AnimatedValue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/* harmony import */ var _AnimatedWithChildren__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13);
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_2__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var _uniqueId = 1;
/**
 * 2D Value for driving 2D animations, such as pan gestures. Almost identical
 * API to normal `Animated.Value`, but multiplexed.
 *
 * See http://facebook.github.io/react-native/docs/animatedvaluexy.html
 */

var AnimatedValueXY =
/*#__PURE__*/
function (_AnimatedWithChildren) {
  _inheritsLoose(AnimatedValueXY, _AnimatedWithChildren);

  function AnimatedValueXY(valueIn) {
    var _this;

    _this = _AnimatedWithChildren.call(this) || this;
    var value = valueIn || {
      x: 0,
      y: 0
    }; // fixme: shouldn't need `: any`

    if (typeof value.x === 'number' && typeof value.y === 'number') {
      _this.x = new _AnimatedValue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](value.x);
      _this.y = new _AnimatedValue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"](value.y);
    } else {
      fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_2___default()(value.x instanceof _AnimatedValue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"] && value.y instanceof _AnimatedValue__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"], 'AnimatedValueXY must be initialized with an object of numbers or ' + 'AnimatedValues.');
      _this.x = value.x;
      _this.y = value.y;
    }

    _this._listeners = {};
    return _this;
  }
  /**
   * Directly set the value. This will stop any animations running on the value
   * and update all the bound properties.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#setvalue
   */


  var _proto = AnimatedValueXY.prototype;

  _proto.setValue = function setValue(value) {
    this.x.setValue(value.x);
    this.y.setValue(value.y);
  }
  /**
   * Sets an offset that is applied on top of whatever value is set, whether
   * via `setValue`, an animation, or `Animated.event`. Useful for compensating
   * things like the start of a pan gesture.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#setoffset
   */
  ;

  _proto.setOffset = function setOffset(offset) {
    this.x.setOffset(offset.x);
    this.y.setOffset(offset.y);
  }
  /**
   * Merges the offset value into the base value and resets the offset to zero.
   * The final output of the value is unchanged.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#flattenoffset
   */
  ;

  _proto.flattenOffset = function flattenOffset() {
    this.x.flattenOffset();
    this.y.flattenOffset();
  }
  /**
   * Sets the offset value to the base value, and resets the base value to
   * zero. The final output of the value is unchanged.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#extractoffset
   */
  ;

  _proto.extractOffset = function extractOffset() {
    this.x.extractOffset();
    this.y.extractOffset();
  };

  _proto.__getValue = function __getValue() {
    return {
      x: this.x.__getValue(),
      y: this.y.__getValue()
    };
  }
  /**
   * Stops any animation and resets the value to its original.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#resetanimation
   */
  ;

  _proto.resetAnimation = function resetAnimation(callback) {
    this.x.resetAnimation();
    this.y.resetAnimation();
    callback && callback(this.__getValue());
  }
  /**
   * Stops any running animation or tracking. `callback` is invoked with the
   * final value after stopping the animation, which is useful for updating
   * state to match the animation position with layout.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#stopanimation
   */
  ;

  _proto.stopAnimation = function stopAnimation(callback) {
    this.x.stopAnimation();
    this.y.stopAnimation();
    callback && callback(this.__getValue());
  }
  /**
   * Adds an asynchronous listener to the value so you can observe updates from
   * animations.  This is useful because there is no way to synchronously read
   * the value because it might be driven natively.
   *
   * Returns a string that serves as an identifier for the listener.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#addlistener
   */
  ;

  _proto.addListener = function addListener(callback) {
    var _this2 = this;

    var id = String(_uniqueId++);

    var jointCallback = function jointCallback(_ref) {
      var number = _ref.value;
      callback(_this2.__getValue());
    };

    this._listeners[id] = {
      x: this.x.addListener(jointCallback),
      y: this.y.addListener(jointCallback)
    };
    return id;
  }
  /**
   * Unregister a listener. The `id` param shall match the identifier
   * previously returned by `addListener()`.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#removelistener
   */
  ;

  _proto.removeListener = function removeListener(id) {
    this.x.removeListener(this._listeners[id].x);
    this.y.removeListener(this._listeners[id].y);
    delete this._listeners[id];
  }
  /**
   * Remove all registered listeners.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#removealllisteners
   */
  ;

  _proto.removeAllListeners = function removeAllListeners() {
    this.x.removeAllListeners();
    this.y.removeAllListeners();
    this._listeners = {};
  }
  /**
   * Converts `{x, y}` into `{left, top}` for use in style.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#getlayout
   */
  ;

  _proto.getLayout = function getLayout() {
    return {
      left: this.x,
      top: this.y
    };
  }
  /**
   * Converts `{x, y}` into a useable translation transform.
   *
   * See http://facebook.github.io/react-native/docs/animatedvaluexy.html#gettranslatetransform
   */
  ;

  _proto.getTranslateTransform = function getTranslateTransform() {
    return [{
      translateX: this.x
    }, {
      translateY: this.y
    }];
  };

  return AnimatedValueXY;
}(_AnimatedWithChildren__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]);

/* harmony default export */ __webpack_exports__["a"] = (AnimatedValueXY);

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(169);
} else {}


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var unitlessNumbers = {
  animationIterationCount: true,
  borderImageOutset: true,
  borderImageSlice: true,
  borderImageWidth: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexOrder: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  fontWeight: true,
  gridRow: true,
  gridColumn: true,
  lineClamp: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,
  // SVG-related
  fillOpacity: true,
  floodOpacity: true,
  stopOpacity: true,
  strokeDasharray: true,
  strokeDashoffset: true,
  strokeMiterlimit: true,
  strokeOpacity: true,
  strokeWidth: true,
  // transform types
  scale: true,
  scaleX: true,
  scaleY: true,
  scaleZ: true,
  // RN properties
  shadowOpacity: true
};
/**
 * Support style names that may come passed in prefixed by adding permutations
 * of vendor prefixes.
 */

var prefixes = ['ms', 'Moz', 'O', 'Webkit'];

var prefixKey = function prefixKey(prefix, key) {
  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
};

Object.keys(unitlessNumbers).forEach(function (prop) {
  prefixes.forEach(function (prefix) {
    unitlessNumbers[prefixKey(prefix, prop)] = unitlessNumbers[prop];
  });
});
/* harmony default export */ __webpack_exports__["a"] = (unitlessNumbers);

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _bezier__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(154);
/* harmony import */ var _bezier__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_bezier__WEBPACK_IMPORTED_MODULE_0__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var _ease;
/**
 * The `Easing` module implements common easing functions. This module is used
 * by [Animate.timing()](docs/animate.html#timing) to convey physically
 * believable motion in animations.
 *
 * You can find a visualization of some common easing functions at
 * http://easings.net/
 *
 * ### Predefined animations
 *
 * The `Easing` module provides several predefined animations through the
 * following methods:
 *
 * - [`back`](docs/easing.html#back) provides a simple animation where the
 *   object goes slightly back before moving forward
 * - [`bounce`](docs/easing.html#bounce) provides a bouncing animation
 * - [`ease`](docs/easing.html#ease) provides a simple inertial animation
 * - [`elastic`](docs/easing.html#elastic) provides a simple spring interaction
 *
 * ### Standard functions
 *
 * Three standard easing functions are provided:
 *
 * - [`linear`](docs/easing.html#linear)
 * - [`quad`](docs/easing.html#quad)
 * - [`cubic`](docs/easing.html#cubic)
 *
 * The [`poly`](docs/easing.html#poly) function can be used to implement
 * quartic, quintic, and other higher power functions.
 *
 * ### Additional functions
 *
 * Additional mathematical functions are provided by the following methods:
 *
 * - [`bezier`](docs/easing.html#bezier) provides a cubic bezier curve
 * - [`circle`](docs/easing.html#circle) provides a circular function
 * - [`sin`](docs/easing.html#sin) provides a sinusoidal function
 * - [`exp`](docs/easing.html#exp) provides an exponential function
 *
 * The following helpers are used to modify other easing functions.
 *
 * - [`in`](docs/easing.html#in) runs an easing function forwards
 * - [`inOut`](docs/easing.html#inout) makes any easing function symmetrical
 * - [`out`](docs/easing.html#out) runs an easing function backwards
 */


var Easing =
/*#__PURE__*/
function () {
  function Easing() {}

  /**
   * A stepping function, returns 1 for any positive value of `n`.
   */
  Easing.step0 = function step0(n) {
    return n > 0 ? 1 : 0;
  }
  /**
   * A stepping function, returns 1 if `n` is greater than or equal to 1.
   */
  ;

  Easing.step1 = function step1(n) {
    return n >= 1 ? 1 : 0;
  }
  /**
   * A linear function, `f(t) = t`. Position correlates to elapsed time one to
   * one.
   *
   * http://cubic-bezier.com/#0,0,1,1
   */
  ;

  Easing.linear = function linear(t) {
    return t;
  }
  /**
   * A simple inertial interaction, similar to an object slowly accelerating to
   * speed.
   *
   * http://cubic-bezier.com/#.42,0,1,1
   */
  ;

  Easing.ease = function ease(t) {
    if (!_ease) {
      _ease = Easing.bezier(0.42, 0, 1, 1);
    }

    return _ease(t);
  }
  /**
   * A quadratic function, `f(t) = t * t`. Position equals the square of elapsed
   * time.
   *
   * http://easings.net/#easeInQuad
   */
  ;

  Easing.quad = function quad(t) {
    return t * t;
  }
  /**
   * A cubic function, `f(t) = t * t * t`. Position equals the cube of elapsed
   * time.
   *
   * http://easings.net/#easeInCubic
   */
  ;

  Easing.cubic = function cubic(t) {
    return t * t * t;
  }
  /**
   * A power function. Position is equal to the Nth power of elapsed time.
   *
   * n = 4: http://easings.net/#easeInQuart
   * n = 5: http://easings.net/#easeInQuint
   */
  ;

  Easing.poly = function poly(n) {
    return function (t) {
      return Math.pow(t, n);
    };
  }
  /**
   * A sinusoidal function.
   *
   * http://easings.net/#easeInSine
   */
  ;

  Easing.sin = function sin(t) {
    return 1 - Math.cos(t * Math.PI / 2);
  }
  /**
   * A circular function.
   *
   * http://easings.net/#easeInCirc
   */
  ;

  Easing.circle = function circle(t) {
    return 1 - Math.sqrt(1 - t * t);
  }
  /**
   * An exponential function.
   *
   * http://easings.net/#easeInExpo
   */
  ;

  Easing.exp = function exp(t) {
    return Math.pow(2, 10 * (t - 1));
  }
  /**
   * A simple elastic interaction, similar to a spring oscillating back and
   * forth.
   *
   * Default bounciness is 1, which overshoots a little bit once. 0 bounciness
   * doesn't overshoot at all, and bounciness of N > 1 will overshoot about N
   * times.
   *
   * http://easings.net/#easeInElastic
   */
  ;

  Easing.elastic = function elastic(bounciness) {
    if (bounciness === void 0) {
      bounciness = 1;
    }

    var p = bounciness * Math.PI;
    return function (t) {
      return 1 - Math.pow(Math.cos(t * Math.PI / 2), 3) * Math.cos(t * p);
    };
  }
  /**
   * Use with `Animated.parallel()` to create a simple effect where the object
   * animates back slightly as the animation starts.
   *
   * Wolfram Plot:
   *
   * - http://tiny.cc/back_default (s = 1.70158, default)
   */
  ;

  Easing.back = function back(s) {
    if (s === undefined) {
      s = 1.70158;
    }

    return function (t) {
      return t * t * ((s + 1) * t - s);
    };
  }
  /**
   * Provides a simple bouncing effect.
   *
   * http://easings.net/#easeInBounce
   */
  ;

  Easing.bounce = function bounce(t) {
    if (t < 1 / 2.75) {
      return 7.5625 * t * t;
    }

    if (t < 2 / 2.75) {
      t -= 1.5 / 2.75;
      return 7.5625 * t * t + 0.75;
    }

    if (t < 2.5 / 2.75) {
      t -= 2.25 / 2.75;
      return 7.5625 * t * t + 0.9375;
    }

    t -= 2.625 / 2.75;
    return 7.5625 * t * t + 0.984375;
  }
  /**
   * Provides a cubic bezier curve, equivalent to CSS Transitions'
   * `transition-timing-function`.
   *
   * A useful tool to visualize cubic bezier curves can be found at
   * http://cubic-bezier.com/
   */
  ;

  Easing.bezier = function bezier(x1, y1, x2, y2) {
    return _bezier__WEBPACK_IMPORTED_MODULE_0___default()(x1, y1, x2, y2);
  }
  /**
   * Runs an easing function forwards.
   */
  ;

  Easing.in = function _in(easing) {
    return easing;
  }
  /**
   * Runs an easing function backwards.
   */
  ;

  Easing.out = function out(easing) {
    return function (t) {
      return 1 - easing(1 - t);
    };
  }
  /**
   * Makes any easing function symmetrical. The easing function will run
   * forwards for half of the duration, then backwards for the rest of the
   * duration.
   */
  ;

  Easing.inOut = function inOut(easing) {
    return function (t) {
      if (t < 0.5) {
        return easing(t * 2) / 2;
      }

      return 1 - easing((1 - t) * 2) / 2;
    };
  };

  return Easing;
}();

/* harmony default export */ __webpack_exports__["a"] = (Easing);

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (arr, predicate, ctx) {
	if (typeof Array.prototype.findIndex === 'function') {
		return arr.findIndex(predicate, ctx);
	}

	if (typeof predicate !== 'function') {
		throw new TypeError('predicate must be a function');
	}

	var list = Object(arr);
	var len = list.length;

	if (len === 0) {
		return -1;
	}

	for (var i = 0; i < len; i++) {
		if (predicate.call(ctx, list[i], i, list)) {
			return i;
		}
	}

	return -1;
};


/***/ }),
/* 52 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || new Function("return this")();
} catch (e) {
	// This works if the window reference is available
	if (typeof window === "object") g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomFromSeed = __webpack_require__(184);

var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var alphabet;
var previousSeed;

var shuffled;

function reset() {
    shuffled = false;
}

function setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if (alphabet !== ORIGINAL) {
            alphabet = ORIGINAL;
            reset();
        }
        return;
    }

    if (_alphabet_ === alphabet) {
        return;
    }

    if (_alphabet_.length !== ORIGINAL.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    }

    var unique = _alphabet_.split('').filter(function(item, ind, arr){
       return ind !== arr.lastIndexOf(item);
    });

    if (unique.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    }

    alphabet = _alphabet_;
    reset();
}

function characters(_alphabet_) {
    setCharacters(_alphabet_);
    return alphabet;
}

function setSeed(seed) {
    randomFromSeed.seed(seed);
    if (previousSeed !== seed) {
        reset();
        previousSeed = seed;
    }
}

function shuffle() {
    if (!alphabet) {
        setCharacters(ORIGINAL);
    }

    var sourceArray = alphabet.split('');
    var targetArray = [];
    var r = randomFromSeed.nextValue();
    var characterIndex;

    while (sourceArray.length > 0) {
        r = randomFromSeed.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}

function getShuffled() {
    if (shuffled) {
        return shuffled;
    }
    shuffled = shuffle();
    return shuffled;
}

/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */
function lookup(index) {
    var alphabetShuffled = getShuffled();
    return alphabetShuffled[index];
}

function get () {
  return alphabet || ORIGINAL;
}

module.exports = {
    get: get,
    characters: characters,
    seed: setSeed,
    lookup: lookup,
    shuffled: getShuffled
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressRing = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const ProgressRing_styles_1 = __webpack_require__(207);
exports.ProgressRing = ({ diameter, stroke, progress, color, className, animationDuration, }) => {
    const radius = diameter / 2;
    const normalizedRadius = radius - stroke / 2;
    const circumference = normalizedRadius * 2 * Math.PI;
    const strokeDashoffset = circumference - (progress / 100) * circumference;
    return (react_1.default.createElement("svg", { className: className, height: diameter, width: diameter, viewBox: `0 0 ${diameter} ${diameter}`, fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement(ProgressRing_styles_1.ProgressCircle, { stroke: color, fill: "transparent", strokeWidth: stroke, strokeDasharray: `${circumference} ${circumference}`, style: { strokeDashoffset }, r: normalizedRadius, cx: radius, cy: radius, animationDuration: animationDuration })));
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.DismissingCardContext = void 0;
const react_1 = __webpack_require__(1);
const defaultValue = {
    dismiss: () => { },
    undo: () => { },
};
exports.DismissingCardContext = react_1.createContext(defaultValue);


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __webpack_require__(1);
const types_1 = __webpack_require__(43);
const defaultReasonStep = {
    title: '',
    subtitle: '',
    placeholder: '',
    submitButton: '',
};
const defaultContext = {
    feedback: types_1.Feedback.Awesome,
    reason: '',
    copyConfig: {
        steps: {
            [types_1.Steps.Emoji]: {
                title: '',
                subtitle: '',
                firstLabel: '',
                lastLabel: '',
            },
            [types_1.Steps.Reason]: {
                [types_1.Feedback.Horrible]: defaultReasonStep,
                [types_1.Feedback.Bad]: defaultReasonStep,
                [types_1.Feedback.Okay]: defaultReasonStep,
                [types_1.Feedback.Great]: defaultReasonStep,
                [types_1.Feedback.Awesome]: defaultReasonStep,
            },
            [types_1.Steps.Conclusion]: {
                title: '',
                subtitle: '',
            },
        },
        undoButtonText: '',
        dismissedText: '',
    },
    reasonRequired: false,
    setReason: () => { },
    handleFeedback: () => { },
    handleDismiss: () => { },
    handleSubmit: () => { },
};
const FeedbackCardContext = react_1.createContext(defaultContext);
exports.default = FeedbackCardContext;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarkdownParser = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const markdown_to_jsx_1 = __importDefault(__webpack_require__(260));
const styles_1 = __webpack_require__(261);
exports.MarkdownParser = ({ children, options, titleColor, paragraphColor, ...restProps }) => {
    const { overrides = {}, ...restOptions } = options !== null && options !== void 0 ? options : {};
    return (react_1.default.createElement(markdown_to_jsx_1.default, Object.assign({}, restProps, { options: {
            ...restOptions,
            overrides: {
                ...overrides,
                h1: {
                    component: styles_1.StyledHeadline,
                    props: {
                        titleColor,
                        className: 'Headline',
                    },
                },
                h2: {
                    component: styles_1.StyledSubHeadline,
                    props: {
                        titleColor,
                        className: 'SubHeadline',
                    },
                },
                h3: {
                    component: styles_1.StyledSmallHeadline,
                    props: {
                        titleColor,
                        className: 'SmallHeadline',
                    },
                },
                h4: {
                    component: styles_1.StyledSmallCapsHeadline,
                    props: {
                        titleColor,
                        className: 'SmallCapsHeadline',
                    },
                },
                p: {
                    component: styles_1.StyledParagraph,
                    props: {
                        paragraphColor,
                        className: 'Paragraph',
                    },
                },
            },
        } }), children));
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Action = void 0;
const react_1 = __importStar(__webpack_require__(1));
const styled_components_1 = __webpack_require__(2);
const withRipple_1 = __importDefault(__webpack_require__(20));
const darkBaseTheme_1 = __importDefault(__webpack_require__(59));
const Circle_1 = __webpack_require__(278);
const Container_web_1 = __webpack_require__(280);
const styles_web_1 = __webpack_require__(78);
const RippleEffect = withRipple_1.default(styles_web_1.RippleContainer);
exports.Action = ({ href, target, className, onClick, title, description, withDelimiter = false, icon, disabled = false, textColor, descriptionColor, circleBorderColor, circleColor, hasAdditionalButton, additionalButtonText, hasCircleBadge, circleBadgeColor, circleBadgeBorderColor, circleBadgeIcon, circleBadgeText, circleBadgeTextColor, }) => {
    const theme = react_1.useContext(styled_components_1.ThemeContext);
    return (react_1.default.createElement(Container_web_1.Container, { className: className, href: href, onClick: onClick, disabled: disabled, target: target },
        react_1.default.createElement(styles_web_1.Content, { isTransparent: disabled, hasDescription: Boolean(description), hasDelimiter: Boolean(withDelimiter) },
            react_1.default.createElement(Circle_1.Circle, { icon: icon, borderColor: circleBorderColor, color: circleColor, hasBadge: hasCircleBadge, badgeColor: circleBadgeColor, badgeBorderColor: circleBadgeBorderColor, badgeIcon: circleBadgeIcon, badgeText: circleBadgeText, badgeTextColor: circleBadgeTextColor }),
            react_1.default.createElement(styles_web_1.Title, { color: textColor }, title),
            description && react_1.default.createElement(styles_web_1.Description, { color: descriptionColor }, description),
            hasAdditionalButton ? (react_1.default.createElement(styles_web_1.AdditionalButton, { small: true, outlined: true, color: theme.colors.secondary, borderColor: theme.colors.secondaryBackground, isDisabled: disabled, rippleColor: darkBaseTheme_1.default.colors['Level 2'] }, additionalButtonText)) : (react_1.default.createElement(styles_web_1.ArrowRightIcon, { color: theme.colors['Level 3'] })),
            withDelimiter && react_1.default.createElement(styles_web_1.Delimiter, null),
            !disabled && react_1.default.createElement(RippleEffect, null))));
};


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const palette_1 = __importDefault(__webpack_require__(44));
const spacers_1 = __importDefault(__webpack_require__(89));
const typography_web_1 = __importDefault(__webpack_require__(90));
const brandColors_1 = __importDefault(__webpack_require__(91));
const darkBaseTheme = {
    spacers: spacers_1.default,
    typography: typography_web_1.default,
    brandColors: brandColors_1.default,
    colors: {
        Foreground: 'rgba(255, 255, 255, 1)',
        Background: 'rgba(34, 35, 41, 1)',
        ElementBackground: 'rgba(47, 48, 55, 1)',
        HoverBackground: 'rgba(90, 90, 94, 1)',
        BusinessBlue: 'rgba(10, 24, 73, 1)',
        'Level 1': 'rgba(255, 255, 255, 0.07)',
        'Level 2': 'rgba(255, 255, 255, 0.17)',
        'Level 3': 'rgba(255, 255, 255, 0.28)',
        'Level 4': 'rgba(255, 255, 255, 0.5)',
        'Level 5': 'rgba(255, 255, 255, 0.75)',
        Color1: palette_1.default.torchRed[100],
        Color1_75: palette_1.default.torchRed[75],
        Color1_50: palette_1.default.torchRed[50],
        Color1_25: palette_1.default.torchRed[25],
        Color1_15: palette_1.default.torchRed[15],
        Color1_07: '#5F2836',
        Color2: palette_1.default.electricBlue[100],
        Color2_75: palette_1.default.electricBlue[75],
        Color2_50: palette_1.default.electricBlue[50],
        Color2_25: palette_1.default.electricBlue[25],
        Color2_15: palette_1.default.electricBlue[15],
        Color2_07: '#2B2E3B',
        primary: palette_1.default.torchRed[100],
        secondary: palette_1.default.grey[15],
        positive: palette_1.default.broccoli[100],
        caution: palette_1.default.yolk[100],
        negative: palette_1.default.tomato[100],
        primaryBackground: '#5F2836',
        secondaryBackground: palette_1.default.grey[100],
        positiveBackground: '#31382D',
        cautionBackground: '#4F472E',
        negativeBackground: '#4A302C',
    },
};
exports.default = darkBaseTheme;


/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetgroverTypography; });
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(161);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_index_scss__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bem_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);
/* harmony import */ var react_bem_classes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_bem_classes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
var _dec, _class, _class2, _temp; /* eslint-disable */




let




GetgroverTypography = (_dec = react_bem_classes__WEBPACK_IMPORTED_MODULE_2___default()({ block: 'getgroverTypography' }), _dec(_class = (_temp = _class2 = class GetgroverTypography extends react__WEBPACK_IMPORTED_MODULE_1__["Component"] {














  render() {
    const {
      tag: TextComponent,
      styleMixin,
      styleModifiers,
      className,
      children,
      html } =
    this.props;
    const newStyleMixin = styleMixin || TextComponent;
    const cn = [
    this.element('element'),
    newStyleMixin && this.element(newStyleMixin, styleModifiers),
    className].

    filter(t => !!t).
    join(' ');

    return !html ? /*#__PURE__*/
    react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(TextComponent, { className: cn },
    children) : /*#__PURE__*/


    react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(TextComponent, {
      className: cn,
      dangerouslySetInnerHTML: { __html: html } });


  }}, _class2.propTypes = { tag: prop_types__WEBPACK_IMPORTED_MODULE_3__["string"], styleMixin: prop_types__WEBPACK_IMPORTED_MODULE_3__["string"], styleModifiers: prop_types__WEBPACK_IMPORTED_MODULE_3__["object"], children: prop_types__WEBPACK_IMPORTED_MODULE_3__["node"], className: prop_types__WEBPACK_IMPORTED_MODULE_3__["object"], html: prop_types__WEBPACK_IMPORTED_MODULE_3__["string"] }, _class2.defaultProps = { tag: 'div', styleMixin: null, styleModifiers: {} }, _temp)) || _class);

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9);
/* harmony import */ var _common__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7);
/* eslint-disable */





const Arrow = ({ className, color, size }) => /*#__PURE__*/
react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react_native_svg__WEBPACK_IMPORTED_MODULE_1__["Svg"], {
  className: className,
  xmlns: "http://www.w3.org/2000/svg",
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  fill: "none",
  style: {
    padding: _common__WEBPACK_IMPORTED_MODULE_2__[/* ICON_PADDING */ "a"] } }, /*#__PURE__*/


react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react_native_svg__WEBPACK_IMPORTED_MODULE_1__["Path"], {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.29289 9.29289C7.68342 8.90237 8.31658 8.90237 8.70711 9.29289L12 12.5858L15.2929 9.29289C15.6834 8.90237 16.3166 8.90237 16.7071 9.29289C17.0976 9.68342 17.0976 10.3166 16.7071 10.7071L12 15.4142L7.29289 10.7071C6.90237 10.3166 6.90237 9.68342 7.29289 9.29289Z",
  fill: color }));




Arrow.propTypes = _common__WEBPACK_IMPORTED_MODULE_2__[/* iconPropTypes */ "c"];
Arrow.defaultProps = _common__WEBPACK_IMPORTED_MODULE_2__[/* iconDefaultProps */ "b"];

/* harmony default export */ __webpack_exports__["a"] = (Arrow);

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Note = void 0;
const react_1 = __importStar(__webpack_require__(1));
const styled_components_1 = __webpack_require__(2);
const SonntagIcon_1 = __importDefault(__webpack_require__(25));
const Conditional_1 = __importDefault(__webpack_require__(99));
const types_1 = __webpack_require__(195);
const NoteIcons = __importStar(__webpack_require__(196));
const styles_1 = __webpack_require__(197);
exports.Note = ({ className, type, data }) => {
    const theme = react_1.useContext(styled_components_1.ThemeContext);
    const text = types_1.isNextPaymentNote(data) ? data.date : data.text;
    const textColor = react_1.useMemo(() => {
        var _a;
        const textColorKeymap = {
            [types_1.NoteType.Attention]: '#F35757',
            [types_1.NoteType.Ended]: theme.colors['Level 4'],
            [types_1.NoteType.Paused]: theme.colors['Level 4'],
            [types_1.NoteType.NextPayment]: theme.colors['Level 5'],
            [types_1.NoteType.Processing]: theme.colors['Level 5'],
            [types_1.NoteType.Text]: theme.colors['Level 4'],
        };
        return (_a = textColorKeymap[type]) !== null && _a !== void 0 ? _a : theme.colors['Level 5'];
    }, [type, theme]);
    const icon = react_1.useMemo(() => {
        switch (type) {
            case types_1.NoteType.Attention: {
                return react_1.default.createElement(SonntagIcon_1.default, { iconPath: NoteIcons.ATTENTION, color: "#F35757" });
            }
            case types_1.NoteType.Ended: {
                return react_1.default.createElement(SonntagIcon_1.default, { iconPath: NoteIcons.ENDED, color: theme.colors['Level 4'] });
            }
            case types_1.NoteType.Paused: {
                return react_1.default.createElement(SonntagIcon_1.default, { iconPath: NoteIcons.PAUSED, color: theme.colors['Level 4'] });
            }
            case types_1.NoteType.NextPayment: {
                let iconPath = '';
                if (types_1.isNextPaymentNote(data)) {
                    iconPath =
                        data.paymentMethod.type === types_1.PaymentMethod.Paypal
                            ? NoteIcons.PAYPAL
                            : NoteIcons.CARD;
                }
                return react_1.default.createElement(SonntagIcon_1.default, { iconPath: iconPath, color: theme.colors.secondary });
            }
            case types_1.NoteType.Processing: {
                return react_1.default.createElement(styles_1.AnimatedInProgressIcon, { color: theme.colors.secondary });
            }
            case types_1.NoteType.Text:
                return null;
            default:
                return null;
        }
    }, [data, theme, type]);
    return (react_1.default.createElement(styles_1.Container, { className: className },
        react_1.default.createElement(Conditional_1.default, { condition: Boolean(icon) },
            react_1.default.createElement(styles_1.IconWrap, null, icon)),
        react_1.default.createElement(styles_1.Text, { color: textColor }, text)));
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const palette_1 = __importDefault(__webpack_require__(44));
const spacers_1 = __importDefault(__webpack_require__(89));
const typography_web_1 = __importDefault(__webpack_require__(90));
const brandColors_1 = __importDefault(__webpack_require__(91));
const lightBaseTheme = {
    spacers: spacers_1.default,
    typography: typography_web_1.default,
    brandColors: brandColors_1.default,
    colors: {
        Foreground: 'rgba(51, 51, 51, 1)',
        Background: 'rgba(255, 255, 255, 1)',
        ElementBackground: 'rgba(255, 255, 255, 1)',
        HoverBackground: 'rgba(255, 255, 255, 1)',
        BusinessBlue: 'rgba(10, 24, 73, 1)',
        'Level 1': 'rgba(51, 51, 51, 0.07)',
        'Level 2': 'rgba(51, 51, 51, 0.15)',
        'Level 3': 'rgba(51, 51, 51, 0.25)',
        'Level 4': 'rgba(51, 51, 51, 0.5)',
        'Level 5': 'rgba(51, 51, 51, 0.75)',
        Color1: palette_1.default.torchRed[100],
        Color1_75: palette_1.default.torchRed[75],
        Color1_50: palette_1.default.torchRed[50],
        Color1_25: palette_1.default.torchRed[25],
        Color1_15: palette_1.default.torchRed[15],
        Color1_07: palette_1.default.torchRed[7],
        Color2: palette_1.default.electricBlue[100],
        Color2_75: palette_1.default.electricBlue[75],
        Color2_50: palette_1.default.electricBlue[50],
        Color2_25: palette_1.default.electricBlue[25],
        Color2_15: palette_1.default.electricBlue[15],
        Color2_07: palette_1.default.electricBlue[7],
        primary: palette_1.default.torchRed[100],
        secondary: palette_1.default.grey[100],
        positive: palette_1.default.broccoli[100],
        caution: palette_1.default.yolk[100],
        negative: palette_1.default.tomato[100],
        primaryBackground: palette_1.default.torchRed[7],
        secondaryBackground: palette_1.default.grey[7],
        positiveBackground: palette_1.default.broccoli[15],
        cautionBackground: palette_1.default.yolk[15],
        negativeBackground: palette_1.default.tomato[7],
    },
};
exports.default = lightBaseTheme;


/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emitter_EventEmitter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(68);
/* harmony import */ var _RCTDeviceEventEmitter__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule NativeEventEmitter
 * 
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





/**
 * Abstract base class for implementing event-emitting modules. This implements
 * a subset of the standard EventEmitter node module API.
 */
var NativeEventEmitter =
/*#__PURE__*/
function (_EventEmitter) {
  _inheritsLoose(NativeEventEmitter, _EventEmitter);

  function NativeEventEmitter(nativeModule) {
    return _EventEmitter.call(this, _RCTDeviceEventEmitter__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"].sharedSubscriber) || this;
  }

  var _proto = NativeEventEmitter.prototype;

  _proto.addListener = function addListener(eventType, listener, context) {
    if (this._nativeModule != null) {
      this._nativeModule.addListener(eventType);
    }

    return _EventEmitter.prototype.addListener.call(this, eventType, listener, context);
  };

  _proto.removeAllListeners = function removeAllListeners(eventType) {
    fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default()(eventType, 'eventType argument is required.');
    var count = this.listeners(eventType).length;

    if (this._nativeModule != null) {
      this._nativeModule.removeListeners(count);
    }

    _EventEmitter.prototype.removeAllListeners.call(this, eventType);
  };

  _proto.removeSubscription = function removeSubscription(subscription) {
    if (this._nativeModule != null) {
      this._nativeModule.removeListeners(1);
    }

    _EventEmitter.prototype.removeSubscription.call(this, subscription);
  };

  return NativeEventEmitter;
}(_emitter_EventEmitter__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]);

/* harmony default export */ __webpack_exports__["a"] = (NativeEventEmitter);

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emitter_EventEmitter__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68);
/* harmony import */ var _emitter_EventSubscriptionVendor__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(66);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @format
 * 
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var __DEV__ = "production" !== 'production';

function checkNativeEventModule(eventType) {
  if (eventType) {
    if (eventType === 'appStateDidChange' || eventType === 'memoryWarning') {
      throw new Error('`' + eventType + '` event should be registered via the AppState module');
    }
  }
}
/**
 * Deprecated - subclass NativeEventEmitter to create granular event modules instead of
 * adding all event listeners directly to RCTDeviceEventEmitter.
 */


var RCTDeviceEventEmitter =
/*#__PURE__*/
function (_EventEmitter) {
  _inheritsLoose(RCTDeviceEventEmitter, _EventEmitter);

  function RCTDeviceEventEmitter() {
    var _this;

    var sharedSubscriber = new _emitter_EventSubscriptionVendor__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"]();
    _this = _EventEmitter.call(this, sharedSubscriber) || this;
    _this.sharedSubscriber = sharedSubscriber;
    return _this;
  }

  var _proto = RCTDeviceEventEmitter.prototype;

  _proto.addListener = function addListener(eventType, listener, context) {
    if (__DEV__) {
      checkNativeEventModule(eventType);
    }

    return _EventEmitter.prototype.addListener.call(this, eventType, listener, context);
  };

  _proto.removeAllListeners = function removeAllListeners(eventType) {
    if (__DEV__) {
      checkNativeEventModule(eventType);
    }

    _EventEmitter.prototype.removeAllListeners.call(this, eventType);
  };

  _proto.removeSubscription = function removeSubscription(subscription) {
    if (subscription.emitter !== this) {
      subscription.emitter.removeSubscription(subscription);
    } else {
      _EventEmitter.prototype.removeSubscription.call(this, subscription);
    }
  };

  return RCTDeviceEventEmitter;
}(_emitter_EventEmitter__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* harmony default export */ __webpack_exports__["a"] = (new RCTDeviceEventEmitter());

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3);
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0__);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule EventSubscriptionVendor
 * 
 */




/**
 * EventSubscriptionVendor stores a set of EventSubscriptions that are
 * subscribed to a particular event type.
 */
var EventSubscriptionVendor =
/*#__PURE__*/
function () {
  function EventSubscriptionVendor() {
    this._subscriptionsForType = {};
    this._currentSubscription = null;
  }
  /**
   * Adds a subscription keyed by an event type.
   *
   * @param {string} eventType
   * @param {EventSubscription} subscription
   */


  var _proto = EventSubscriptionVendor.prototype;

  _proto.addSubscription = function addSubscription(eventType, subscription) {
    fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_0___default()(subscription.subscriber === this, 'The subscriber of the subscription is incorrectly set.');

    if (!this._subscriptionsForType[eventType]) {
      this._subscriptionsForType[eventType] = [];
    }

    var key = this._subscriptionsForType[eventType].length;

    this._subscriptionsForType[eventType].push(subscription);

    subscription.eventType = eventType;
    subscription.key = key;
    return subscription;
  }
  /**
   * Removes a bulk set of the subscriptions.
   *
   * @param {?string} eventType - Optional name of the event type whose
   *   registered supscriptions to remove, if null remove all subscriptions.
   */
  ;

  _proto.removeAllSubscriptions = function removeAllSubscriptions(eventType) {
    if (eventType === undefined) {
      this._subscriptionsForType = {};
    } else {
      delete this._subscriptionsForType[eventType];
    }
  }
  /**
   * Removes a specific subscription. Instead of calling this function, call
   * `subscription.remove()` directly.
   *
   * @param {object} subscription
   */
  ;

  _proto.removeSubscription = function removeSubscription(subscription) {
    var eventType = subscription.eventType;
    var key = subscription.key;
    var subscriptionsForType = this._subscriptionsForType[eventType];

    if (subscriptionsForType) {
      delete subscriptionsForType[key];
    }
  }
  /**
   * Returns the array of subscriptions that are currently registered for the
   * given event type.
   *
   * Note: This array can be potentially sparse as subscriptions are deleted
   * from it when they are removed.
   *
   * TODO: This returns a nullable array. wat?
   *
   * @param {string} eventType
   * @returns {?array}
   */
  ;

  _proto.getSubscriptionsForType = function getSubscriptionsForType(eventType) {
    return this._subscriptionsForType[eventType];
  };

  return EventSubscriptionVendor;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventSubscriptionVendor);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_2__);
function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);} /* eslint-disable */




const resetButtonStyles = Object(styled_components__WEBPACK_IMPORTED_MODULE_2__["css"])(["border:none;margin:0;padding:0;width:auto;overflow:visible;background:transparent;color:inherit;font:inherit;line-height:normal;-webkit-font-smoothing:inherit;-moz-osx-font-smoothing:inherit;appearance:none;text-align:inherit;&::-moz-focus-inner{border:0;padding:0;}"]);






















class ClickableView extends react__WEBPACK_IMPORTED_MODULE_0___default.a.Component {





  render() {
    const { component, clickableRef, ...rest } = this.props;

    let Component;

    if (component) {
      Component = component;
    } else {
      Component = rest.href ? "a" : "button";
    }

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, _extends({}, rest, { ref: clickableRef }));
  }}ClickableView.propTypes = { component: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.element, clickableRef: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.func };


const Clickable = styled_components__WEBPACK_IMPORTED_MODULE_2___default()(ClickableView).withConfig({ displayName: "clickable__Clickable", componentId: "c5u6ij-0" })(["", ";"],
resetButtonStyles);


/* harmony default export */ __webpack_exports__["a"] = (Clickable);

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/emitter/EventSubscription.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule EventSubscription
 * 
 */


/**
 * EventSubscription represents a subscription to a particular event. It can
 * remove its own subscription.
 */
var EventSubscription =
/*#__PURE__*/
function () {
  /**
   * @param {EventSubscriptionVendor} subscriber the subscriber that controls
   *   this subscription.
   */
  function EventSubscription(subscriber) {
    this.subscriber = subscriber;
  }
  /**
   * Removes this subscription from the subscriber that controls it.
   */


  var _proto = EventSubscription.prototype;

  _proto.remove = function remove() {
    this.subscriber.removeSubscription(this);
  };

  return EventSubscription;
}();

/* harmony default export */ var emitter_EventSubscription = (EventSubscription);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/emitter/EmitterSubscription.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule EmitterSubscription
 * 
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }



/**
 * EmitterSubscription represents a subscription with listener and context data.
 */
var EmitterSubscription =
/*#__PURE__*/
function (_EventSubscription) {
  _inheritsLoose(EmitterSubscription, _EventSubscription);

  /**
   * @param {EventEmitter} emitter - The event emitter that registered this
   *   subscription
   * @param {EventSubscriptionVendor} subscriber - The subscriber that controls
   *   this subscription
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */
  function EmitterSubscription(emitter, subscriber, listener, context) {
    var _this;

    _this = _EventSubscription.call(this, subscriber) || this;
    _this.emitter = emitter;
    _this.listener = listener;
    _this.context = context;
    return _this;
  }
  /**
   * Removes this subscription from the emitter that registered it.
   * Note: we're overriding the `remove()` method of EventSubscription here
   * but deliberately not calling `super.remove()` as the responsibility
   * for removing the subscription lies with the EventEmitter.
   */


  var _proto = EmitterSubscription.prototype;

  _proto.remove = function remove() {
    this.emitter.removeSubscription(this);
  };

  return EmitterSubscription;
}(emitter_EventSubscription);

/* harmony default export */ var emitter_EmitterSubscription = (EmitterSubscription);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/vendor/react-native/emitter/EventSubscriptionVendor.js
var EventSubscriptionVendor = __webpack_require__(66);

// EXTERNAL MODULE: ./node_modules/react-native-web/node_modules/fbjs/lib/emptyFunction.js
var emptyFunction = __webpack_require__(26);
var emptyFunction_default = /*#__PURE__*/__webpack_require__.n(emptyFunction);

// EXTERNAL MODULE: ./node_modules/react-native-web/node_modules/fbjs/lib/invariant.js
var invariant = __webpack_require__(3);
var invariant_default = /*#__PURE__*/__webpack_require__.n(invariant);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/emitter/EventEmitter.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule EventEmitter
 * 
 * @typecheck
 */






/**
 * @class EventEmitter
 * @description
 * An EventEmitter is responsible for managing a set of listeners and publishing
 * events to them when it is told that such events happened. In addition to the
 * data for the given event it also sends a event control object which allows
 * the listeners/handlers to prevent the default behavior of the given event.
 *
 * The emitter is designed to be generic enough to support all the different
 * contexts in which one might want to emit events. It is a simple multicast
 * mechanism on top of which extra functionality can be composed. For example, a
 * more advanced emitter may use an EventHolder and EventFactory.
 */

var EventEmitter_EventEmitter =
/*#__PURE__*/
function () {
  /**
   * @constructor
   *
   * @param {EventSubscriptionVendor} subscriber - Optional subscriber instance
   *   to use. If omitted, a new subscriber will be created for the emitter.
   */
  function EventEmitter(subscriber) {
    this._subscriber = subscriber || new EventSubscriptionVendor["a" /* default */]();
  }
  /**
   * Adds a listener to be invoked when events of the specified type are
   * emitted. An optional calling context may be provided. The data arguments
   * emitted will be passed to the listener function.
   *
   * TODO: Annotate the listener arg's type. This is tricky because listeners
   *       can be invoked with varargs.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */


  var _proto = EventEmitter.prototype;

  _proto.addListener = function addListener(eventType, listener, context) {
    return this._subscriber.addSubscription(eventType, new emitter_EmitterSubscription(this, this._subscriber, listener, context));
  }
  /**
   * Similar to addListener, except that the listener is removed after it is
   * invoked once.
   *
   * @param {string} eventType - Name of the event to listen to
   * @param {function} listener - Function to invoke only once when the
   *   specified event is emitted
   * @param {*} context - Optional context object to use when invoking the
   *   listener
   */
  ;

  _proto.once = function once(eventType, listener, context) {
    var _this = this;

    return this.addListener(eventType, function () {
      _this.removeCurrentListener();

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      listener.apply(context, args);
    });
  }
  /**
   * Removes all of the registered listeners, including those registered as
   * listener maps.
   *
   * @param {?string} eventType - Optional name of the event whose registered
   *   listeners to remove
   */
  ;

  _proto.removeAllListeners = function removeAllListeners(eventType) {
    this._subscriber.removeAllSubscriptions(eventType);
  }
  /**
   * Provides an API that can be called during an eventing cycle to remove the
   * last listener that was invoked. This allows a developer to provide an event
   * object that can remove the listener (or listener map) during the
   * invocation.
   *
   * If it is called when not inside of an emitting cycle it will throw.
   *
   * @throws {Error} When called not during an eventing cycle
   *
   * @example
   *   var subscription = emitter.addListenerMap({
   *     someEvent: function(data, event) {
   *       console.log(data);
   *       emitter.removeCurrentListener();
   *     }
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   *   emitter.emit('someEvent', 'def'); // does not log anything
   */
  ;

  _proto.removeCurrentListener = function removeCurrentListener() {
    invariant_default()(!!this._currentSubscription, 'Not in an emitting cycle; there is no current subscription');
    this.removeSubscription(this._currentSubscription);
  }
  /**
   * Removes a specific subscription. Called by the `remove()` method of the
   * subscription itself to ensure any necessary cleanup is performed.
   */
  ;

  _proto.removeSubscription = function removeSubscription(subscription) {
    invariant_default()(subscription.emitter === this, 'Subscription does not belong to this emitter.');

    this._subscriber.removeSubscription(subscription);
  }
  /**
   * Returns an array of listeners that are currently registered for the given
   * event.
   *
   * @param {string} eventType - Name of the event to query
   * @returns {array}
   */
  ;

  _proto.listeners = function listeners(eventType) {
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);

    return subscriptions ? subscriptions.filter(emptyFunction_default.a.thatReturnsTrue).map(function (subscription) {
      return subscription.listener;
    }) : [];
  }
  /**
   * Emits an event of the given type with the given data. All handlers of that
   * particular type will be notified.
   *
   * @param {string} eventType - Name of the event to emit
   * @param {...*} Arbitrary arguments to be passed to each registered listener
   *
   * @example
   *   emitter.addListener('someEvent', function(message) {
   *     console.log(message);
   *   });
   *
   *   emitter.emit('someEvent', 'abc'); // logs 'abc'
   */
  ;

  _proto.emit = function emit(eventType) {
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);

    if (subscriptions) {
      for (var i = 0, l = subscriptions.length; i < l; i++) {
        var subscription = subscriptions[i]; // The subscription may have been removed during this event loop.

        if (subscription) {
          this._currentSubscription = subscription;
          subscription.listener.apply(subscription.context, Array.prototype.slice.call(arguments, 1));
        }
      }

      this._currentSubscription = null;
    }
  }
  /**
   * Removes the given listener for event of specific type.
   *
   * @param {string} eventType - Name of the event to emit
   * @param {function} listener - Function to invoke when the specified event is
   *   emitted
   *
   * @example
   *   emitter.removeListener('someEvent', function(message) {
   *     console.log(message);
   *   }); // removes the listener if already registered
   *
   */
  ;

  _proto.removeListener = function removeListener(eventType, listener) {
    var subscriptions = this._subscriber.getSubscriptionsForType(eventType);

    if (subscriptions) {
      for (var i = 0, l = subscriptions.length; i < l; i++) {
        var subscription = subscriptions[i]; // The subscription may have been removed during this event loop.
        // its listener matches the listener in method parameters

        if (subscription && subscription.listener === listener) {
          subscription.remove();
        }
      }
    }
  };

  return EventEmitter;
}();

/* harmony default export */ var emitter_EventEmitter = __webpack_exports__["a"] = (EventEmitter_EventEmitter);

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */
var performance = __webpack_require__(179);

var performanceNow;
/**
 * Detect if we can use `window.performance.now()` and gracefully fallback to
 * `Date.now()` if it doesn't exist. We need to support Firefox < 15 for now
 * because of Facebook's testing infrastructure.
 */

if (performance.now) {
  performanceNow = function performanceNow() {
    return performance.now();
  };
} else {
  performanceNow = function performanceNow() {
    return Date.now();
  };
}

module.exports = performanceNow;

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* eslint-disable */


/**
                            * Hoc for omit props
                            */
const omitProps = (...propsToOmit) => Component => {
  const withOmitedProps = props => {
    const filteredProps = {};

    Object.keys(props).forEach(propName => {
      if (!propsToOmit.includes(propName)) {
        filteredProps[propName] = props[propName];
      }
    });

    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Component, filteredProps);
  };

  withOmitedProps.displayName = `WithOmitedProps(${Component.displayName ||
  "Component"})`;

  return withOmitedProps;
};

/* harmony default export */ __webpack_exports__["default"] = (omitProps);

/***/ }),
/* 71 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 73 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.isFunction = void 0;
function isFunction(func) {
    return typeof func === 'function';
}
exports.isFunction = isFunction;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrimaryButton = exports.TextArea = exports.EmojiIcon = exports.LabelRow = exports.EmojiRow = exports.Paragraph = exports.Title = exports.Row = exports.Container = void 0;
const styled_components_1 = __importDefault(__webpack_require__(2));
const Button_1 = __webpack_require__(33);
exports.Container = styled_components_1.default.div `
    display: grid;
    gap: ${({ theme }) => theme.spacers.L};
`;
exports.Row = styled_components_1.default.div `
    display: flex;
    align-items: center;
    column-gap: ${({ theme }) => theme.spacers.M};
`;
exports.Title = styled_components_1.default.h2 `
    ${({ theme }) => theme.typography.SmallHeadline};
    color: ${({ theme }) => theme.colors.Foreground};
    padding-bottom: ${({ theme, thin }) => (thin ? '0' : theme.spacers.M)};
    padding-right: ${({ theme }) => theme.spacers.XL};
`;
exports.Paragraph = styled_components_1.default.p `
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors['Level 5']};
`;
exports.EmojiRow = styled_components_1.default(exports.Row) `
    justify-content: space-between;
`;
exports.LabelRow = styled_components_1.default(exports.Row) `
    justify-content: space-between;
    margin-top: ${({ theme }) => theme.spacers.S};
`;
exports.EmojiIcon = styled_components_1.default.div `
    width: 48px;
    height: 48px;
    cursor: pointer;
    border-radius: 24px;

    display: flex;
    align-items: center;
    justify-content: center;

    background-color: ${({ theme }) => theme.colors['Level 1']};

    &:hover {
        background-color: ${({ theme }) => theme.colors['Level 2']};
    }
`;
exports.TextArea = styled_components_1.default.textarea `
    ${({ theme }) => theme.typography.Paragraph};

    width: 100%;
    resize: none;
    box-sizing: border-box;
    padding: ${({ theme }) => theme.spacers.M};
    border-radius: ${({ theme }) => theme.spacers.S};
    color: ${({ theme }) => theme.colors['Level 5']};
    background-color: ${({ theme }) => theme.colors.ElementBackground};
    border: 1px solid ${({ theme }) => theme.colors['Level 1']};

    &:focus {
        outline: transparent;
    }
`;
exports.PrimaryButton = styled_components_1.default(Button_1.Button) ``;


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chip = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const styles_1 = __webpack_require__(266);
exports.Chip = ({ className, $background, label, ...rest }) => {
    if (!label || typeof label !== 'string') {
        return null;
    }
    return (react_1.default.createElement(styles_1.ChipWrapper, Object.assign({ className: className, "$background": $background }, rest),
        react_1.default.createElement(styles_1.ChipText, null, label)));
};


/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Hint_1 = __webpack_require__(270);
Object.defineProperty(exports, "Hint", { enumerable: true, get: function () { return Hint_1.Hint; } });
var DismissibleHint_1 = __webpack_require__(271);
Object.defineProperty(exports, "DismissibleHint", { enumerable: true, get: function () { return DismissibleHint_1.DismissibleHint; } });


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = exports.RippleContainer = exports.Delimiter = exports.AdditionalButton = exports.ArrowRightIcon = exports.Description = exports.Title = exports.CircleBadgeText = exports.CircleBadge = exports.Circle = exports.CircleContainer = exports.Link = exports.FunctionalButton = void 0;
const styled_components_1 = __importStar(__webpack_require__(2));
const ArrowRight_1 = __webpack_require__(279);
const Button_1 = __webpack_require__(33);
const elevation_1 = __webpack_require__(11);
const defaultSizeInPixels = 48;
exports.FunctionalButton = styled_components_1.default.button.attrs({ type: 'button' }) `
    /* Reset default browser styles */
    all: unset;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
    :disabled {
        cursor: default;
    }
`;
exports.Link = styled_components_1.default.a.attrs({ rel: 'noopener noreferrer' }) `
    /* Reset default browser styles */
    all: unset;
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
`;
exports.CircleContainer = styled_components_1.default.div `
    width: ${defaultSizeInPixels}px;
    height: ${defaultSizeInPixels}px;
    grid-area: icon;
    place-self: center left;
    position: relative;
`;
exports.Circle = styled_components_1.default.div `
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border-width: 2px;
    border-style: solid;
    border-color: ${(props) => { var _a; return (_a = props.borderColor) !== null && _a !== void 0 ? _a : 'transparent'; }};
    background-color: ${(props) => { var _a; return (_a = props.backgroundColor) !== null && _a !== void 0 ? _a : props.theme.colors.secondaryBackground; }};
    overflow: hidden;
    box-sizing: border-box;

    > *:nth-child(2) {
        z-index: 1;
    }
`;
exports.CircleBadge = styled_components_1.default.div `
    position: absolute;
    right: 0;
    bottom: 0;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    box-sizing: border-box;
    min-width: 20px;
    max-width: 100%;
    height: 20px;
    border-radius: 20px;
    border-style: solid;
    border-width: ${(props) => (props.borderColor ? 2 : 0)}px;
    border-color: ${(props) => { var _a; return (_a = props.borderColor) !== null && _a !== void 0 ? _a : 'transparent'; }};
    background-color: ${(props) => props.backgroundColor || props.theme.colors.ElementBackground};

    ${elevation_1.elevation(1, false)}
`;
exports.CircleBadgeText = styled_components_1.default.span `
    ${(props) => styled_components_1.css(props.theme.typography.SmallHeadline)}
    color: ${(props) => { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : props.theme.colors.Foreground; }};
    font-size: 12px;
    line-height: 20px;
    padding: 0 2px;

    overflow: hidden;
    white-space: nowrap;
    text-align: left;
    text-overflow: ellipsis;
`;
exports.Title = styled_components_1.default.p `
    ${(props) => styled_components_1.css(props.theme.typography.SmallHeadline)}
    color: ${(props) => { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : props.theme.colors.Foreground; }};

    grid-area: title;
    align-self: end;
    max-width: 100%;

    overflow: hidden;
    white-space: nowrap;
    text-align: left;
    text-overflow: ellipsis;
    margin: auto 0;
`;
exports.Description = styled_components_1.default.p `
    ${(props) => styled_components_1.css(props.theme.typography.TinyParagraph)}
    color: ${(props) => { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : props.theme.colors['Level 5']; }};

    margin: 0;
    grid-area: description;
    align-self: start;
    max-width: 100%;

    overflow: hidden;
    white-space: nowrap;
    text-align: left;
    text-overflow: ellipsis;
`;
exports.ArrowRightIcon = styled_components_1.default(ArrowRight_1.ArrowRightIcon) `
    grid-area: action-pointer;
    place-self: center end;
`;
exports.AdditionalButton = styled_components_1.default(Button_1.Button) `
    grid-area: action-pointer;
    place-self: center end;

    z-index: 1;

    &:hover {
        ${elevation_1.elevation(2, true)}
    }

    > * {
        font-weight: 500;
    }
`;
exports.Delimiter = styled_components_1.default.div `
    grid-area: delimiter;
    grid-column: 2 / -1;
    background-color: ${(props) => props.theme.colors['Level 1']};
`;
exports.RippleContainer = styled_components_1.default.div `
    grid-column: 1 / -1;
    grid-row: 1 / -2;
    border-radius: 4px;
`;
exports.Content = styled_components_1.default.div `
    position: relative;
    display: grid;
    grid-row-gap: 0;
    grid-column-gap: 8px;
    grid-template-columns: auto 1fr auto;
    grid-template-rows:
        12px
        auto
        5px
        auto
        12px
        ${(props) => (props.hasDelimiter ? 2 : 0)}px;
    grid-template-areas:
        '. . .'
        'icon title action-pointer'
        'icon . action-pointer'
        'icon description action-pointer'
        '. . .'
        'delimiter delimiter delimiter';

    ${(props) => props.isTransparent &&
    styled_components_1.css `
            ${exports.Circle}, ${exports.Title}, ${exports.Description}, ${exports.ArrowRightIcon} {
                opacity: 0.5;
            }
        `}

    ${(props) => !props.hasDescription &&
    styled_components_1.css `
            grid-template-rows:
                12px
                auto
                12px
                ${props.hasDelimiter ? 2 : 0}px;
            grid-template-areas:
                '. . .'
                'icon title action-pointer'
                '. . .'
                'delimiter delimiter delimiter';
        `}
`;


/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ Radio_Icon; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// CONCATENATED MODULE: ./src/components/Radio/Icon/styled.js
/* eslint-disable */


const InnerCircle = external_styled_components_default.a.rect.withConfig({ displayName: "styled__InnerCircle", componentId: "rsoe3u-0" })(["opacity:0;transition:all .2s;transform:scale(.8);transform-origin:center;&.active{opacity:1;transform:scale(1);}"]);











// CONCATENATED MODULE: ./src/components/Radio/Icon/Icon.jsx
function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);} /* eslint-disable */





class Icon_Checked extends external_react_["Component"] {












  render() {
    const { active, accentColor, borderColor, ...rest } = this.props;

    return /*#__PURE__*/(
      external_react_default.a.createElement("svg", _extends({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, rest), /*#__PURE__*/
      external_react_default.a.createElement("rect", { x: "1", y: "1", width: "22", height: "22", rx: "11", stroke: borderColor, strokeWidth: "2" }), /*#__PURE__*/
      external_react_default.a.createElement(InnerCircle, { className: `${active ? 'active' : ''}`, x: "6", y: "6", width: "12", height: "12", rx: "6", fill: accentColor })));


  }}Icon_Checked.propTypes = { accentColor: external_prop_types_["string"], borderColor: external_prop_types_["string"], active: external_prop_types_["bool"] };Icon_Checked.defaultProps = { accentColor: '#3D02FF', borderColor: '#F1F1F1', active: false };


/* harmony default export */ var Icon = (Icon_Checked);
// CONCATENATED MODULE: ./src/components/Radio/Icon/index.js
/* eslint-disable */


/* harmony default export */ var Radio_Icon = (Icon);
// CONCATENATED MODULE: ./src/components/Radio/styled.js
/* eslint-disable */


const Container = external_styled_components_default.a.div.withConfig({ displayName: "styled__Container", componentId: "wzxnye-0" })(["display:flex;flex-direction:column;"]);





// CONCATENATED MODULE: ./src/components/Radio/Item/styled.js
/* eslint-disable */




const styled_Container = external_styled_components_default.a.div.withConfig({ displayName: "styled__Container", componentId: "gu5fas-0" })(["display:flex;flex-direction:row;justify-content:flex-start;align-items:center;margin-bottom:8px;&:hover{cursor:pointer;}&:last-child{margin-bottom:0;}"]);













const styled_Icon = external_styled_components_default()(Radio_Icon).withConfig({ displayName: "styled__Icon", componentId: "gu5fas-1" })(["width:24px;height:24px;margin-right:16px;"]);





const Label = external_styled_components_default.a.label.withConfig({ displayName: "styled__Label", componentId: "gu5fas-2" })(["", " color:", ";cursor:inherit;"],
props => Object(external_styled_components_["css"])(props.theme.typography.Paragraph),
props => props.theme.colors.Foreground);




// CONCATENATED MODULE: ./src/components/Radio/Item/Item.jsx
/* eslint-disable */






const Item = ({ value, active, onClick, accentColor, borderColor }) => /*#__PURE__*/
external_react_default.a.createElement(styled_Container, { onClick: onClick }, /*#__PURE__*/
external_react_default.a.createElement(styled_Icon, {
  active: active,
  borderColor: borderColor,
  accentColor: accentColor }), /*#__PURE__*/

external_react_default.a.createElement(Label, null, value));



Item.propTypes = {
  value: external_prop_types_["string"],
  active: external_prop_types_["bool"],
  onClick: external_prop_types_["func"],
  accentColor: external_prop_types_["string"],
  borderColor: external_prop_types_["string"] };


/* harmony default export */ var Item_Item = (Item);
// CONCATENATED MODULE: ./src/components/Radio/Item/index.js


/* harmony default export */ var Radio_Item = (Item_Item);
// CONCATENATED MODULE: ./src/components/Radio/Radio.jsx
/* eslint-disable */







const { isArray } = Array;

class Radio_Radio extends external_react_["Component"] {
  constructor(props) {
    super(props);this.
















































    handleSelect = index => () => {
      const { shouldUseKeyValuePairs, keys, values } = this.state;
      const { onChange, withOnChangeBlocker, isChangeAllowed } = this.props;
      const value = values[index];
      const selected = { index, value };
      const key = shouldUseKeyValuePairs ? keys[index] : index;

      if (withOnChangeBlocker) {
        if (isChangeAllowed) {
          this.setState({ selected }, () => {
            onChange({
              ...this.state.selected,
              key });

          });
        }
      } else {
        this.setState({ selected }, () => {
          onChange({
            ...this.state.selected,
            key });

        });
      }
    };let _values = isArray(props.values) ? props.values : [];const { keyValuePairs, preselectedIndex } = props;const _shouldUseKeyValuePairs = Object.keys(keyValuePairs).length > 0;const _keys = _shouldUseKeyValuePairs ? Object.keys(keyValuePairs) : [...Array(_values.length).keys()];if (_shouldUseKeyValuePairs) {_values = Object.values(keyValuePairs);}this.state = { keys: _keys, shouldUseKeyValuePairs: _shouldUseKeyValuePairs, values: _values, selected: { index: preselectedIndex, value: _values[preselectedIndex] } };}

  render() {
    const {
      accentColor,
      borderColor,
      labelTag } =
    this.props;
    const { values, selected: { index } } = this.state;

    return /*#__PURE__*/(
      external_react_default.a.createElement(Container, null,
      values.map((value, i) => /*#__PURE__*/
      external_react_default.a.createElement(Radio_Item, {
        key: value,
        active: i === index,
        name: value,
        value: value,
        onClick: this.handleSelect(i),
        accentColor: accentColor,
        borderColor: borderColor,
        labelTag: labelTag }))));




  }}Radio_Radio.propTypes = { onChange: external_prop_types_["func"], values: external_prop_types_["array"], accentColor: external_prop_types_["string"], borderColor: external_prop_types_["string"], labelTag: external_prop_types_["string"], withOnChangeBlocker: external_prop_types_["bool"], isChangeAllowed: external_prop_types_["bool"], preselectedIndex: external_prop_types_["number"], keyValuePairs: Object(external_prop_types_["shape"])({}) };Radio_Radio.defaultProps = { onChange: () => {}, values: [], accentColor: '#3d02ff', borderColor: '#F1F1F1', labelTag: 'span', withOnChangeBlocker: false, isChangeAllowed: false, preselectedIndex: 0, keyValuePairs: {} };


/* harmony default export */ var components_Radio_Radio = (Radio_Radio);
// CONCATENATED MODULE: ./src/components/Radio/index.js






/* harmony default export */ var components_Radio = __webpack_exports__["b"] = (components_Radio_Radio);

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "default", function() { return /* reexport */ Subscription_Subscription; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: ./src/components/SonntagIcon/index.js + 2 modules
var SonntagIcon = __webpack_require__(25);

// EXTERNAL MODULE: ./packages/Note/index.tsx
var Note = __webpack_require__(62);

// EXTERNAL MODULE: ./src/hocs/withRipple/index.web.tsx
var index_web = __webpack_require__(20);
var index_web_default = /*#__PURE__*/__webpack_require__.n(index_web);

// CONCATENATED MODULE: ./src/components/Subscription/swapIconPath.js
/* harmony default export */ var swapIconPath = ('M500,28C626,28,741,79,823,162L958,28V428H557L742,244C680,182,595,142,500,142C310,142,156,296,156,486H42C42,233,247,28,500,28zM500,972C374,972,259,921,177,838L42,972V572H443L258,756C320,818,406,858,500,858C690,858,844,704,844,514H958C958,767,753,972,500,972z');
// EXTERNAL MODULE: ./packages/Card/index.tsx
var Card = __webpack_require__(22);

// EXTERNAL MODULE: ./src/helpers/elevation/index.web.js
var elevation_index_web = __webpack_require__(11);

// CONCATENATED MODULE: ./src/components/Subscription/styled.js





const Box = external_styled_components_default()(Card["Card"]).withConfig({ displayName: "styled__Box", componentId: "sc-9d7pkv-0" })(["display:flex;user-select:none;cursor:pointer;position:relative;"]);






const Details = external_styled_components_default.a.div.withConfig({ displayName: "styled__Details", componentId: "sc-9d7pkv-1" })(["overflow:hidden;flex:1 1 auto;padding-right:16px;display:flex;justify-content:center;flex-direction:column;"]);








const ImageContainer = external_styled_components_default.a.div.withConfig({ displayName: "styled__ImageContainer", componentId: "sc-9d7pkv-2" })(["height:96px;width:96px;flex-shrink:0;position:relative;overflow:hidden;display:flex;align-items:center;justify-content:center;", ""],









props => props.subdued && Object(external_styled_components_["css"])(["height:48px;width:48px;"]));





const ImagePlaceholder = external_styled_components_default.a.div.withConfig({ displayName: "styled__ImagePlaceholder", componentId: "sc-9d7pkv-3" })(["height:96px;width:96px;flex-shrink:0;border-radius:4px;background-color:", ";", ""],




props => props.theme.colors['Level 1'],

props => props.subdued && Object(external_styled_components_["css"])(["height:48px;width:48px;"]));





const Title = external_styled_components_default.a.span.withConfig({ displayName: "styled__Title", componentId: "sc-9d7pkv-4" })(["text-overflow:ellipsis;white-space:nowrap;overflow:hidden;color:", ";", " ", ""],




props => props.theme.colors.Foreground,
props => Object(external_styled_components_["css"])(props.theme.typography.SmallHeadline),

props => props.subdued && Object(external_styled_components_["css"])(["color:", ";"],
props.theme.colors['Level 4']));



const TitleWrapper = external_styled_components_default.a.div.withConfig({ displayName: "styled__TitleWrapper", componentId: "sc-9d7pkv-5" })(["display:flex;margin-bottom:", ";align-items:center;"],

props => props.theme.spacers.S);



const DotColor = external_styled_components_default.a.div.withConfig({ displayName: "styled__DotColor", componentId: "sc-9d7pkv-6" })(["width:16px;height:16px;flex:0 0 auto;border-radius:50%;box-sizing:border-box;", " ", ""],






Object(elevation_index_web["elevation"])(2, false),

props => Object(external_styled_components_["css"])(["background-color:", ";border:2px solid ", ";margin-left:", ";"],
props.dotColor,
props.theme.colors.ElementBackground,
props.theme.spacers.M));



const RippleContainer = external_styled_components_default.a.div.withConfig({ displayName: "styled__RippleContainer", componentId: "sc-9d7pkv-7" })(["border-radius:4px;width:100%;height:100%;position:absolute !important;top:0;left:0;"]);








const SwapIconWrap = external_styled_components_default.a.div.withConfig({ displayName: "styled__SwapIconWrap", componentId: "sc-9d7pkv-8" })(["position:absolute;right:8px;top:8px;height:32px;width:32px;border-radius:16px;background-color:", ";display:flex;flex-direction:row;justify-content:center;align-items:center;z-index:10;"],






props => props.theme.colors.secondaryBackground);
// CONCATENATED MODULE: ./src/components/Subscription/Subscription.jsx
/* eslint-disable react/jsx-props-no-spreading */











const RippleEffect = index_web_default()(RippleContainer);

function Subscription({
  onClick,
  noteData,
  title,
  img,
  subdued,
  className,
  dotColor,
  highlight,
  isBeingSwapped })
{
  const image = img || /*#__PURE__*/external_react_default.a.createElement(ImagePlaceholder, { subdued: subdued });
  const theme = Object(external_react_["useContext"])(external_styled_components_["ThemeContext"]);

  return /*#__PURE__*/(
    external_react_default.a.createElement(Box, { highlight: highlight, className: className, onClick: onClick, defaultHoverBehavior: true }, /*#__PURE__*/
    external_react_default.a.createElement(Details, null, /*#__PURE__*/
    external_react_default.a.createElement(TitleWrapper, null, /*#__PURE__*/
    external_react_default.a.createElement(Title, { subdued: subdued }, title),

    dotColor && !subdued && /*#__PURE__*/external_react_default.a.createElement(DotColor, { dotColor: dotColor })),

    noteData && /*#__PURE__*/external_react_default.a.createElement(Note["Note"], noteData)),


    isBeingSwapped && /*#__PURE__*/
    external_react_default.a.createElement(SwapIconWrap, null, /*#__PURE__*/
    external_react_default.a.createElement(SonntagIcon["default"], { iconPath: swapIconPath, size: 16, color: theme.colors.secondary })), /*#__PURE__*/



    external_react_default.a.createElement(ImageContainer, { subdued: subdued }, image), /*#__PURE__*/

    external_react_default.a.createElement(RippleEffect, null)));


}

Subscription.propTypes = {
  onClick: external_prop_types_default.a.func,
  subdued: external_prop_types_default.a.bool,
  title: external_prop_types_default.a.node.isRequired,
  img: external_prop_types_default.a.node,
  className: external_prop_types_default.a.string,
  dotColor: external_prop_types_default.a.string,
  noteData: external_prop_types_default.a.shape({
    type: external_prop_types_default.a.string,
    data: external_prop_types_default.a.shape({
      method: external_prop_types_default.a.node,
      date: external_prop_types_default.a.node,
      text: external_prop_types_default.a.node }),

    nextPaymentText: external_prop_types_default.a.node,
    color: external_prop_types_default.a.string }).
  isRequired,
  highlight: external_prop_types_default.a.bool,
  isBeingSwapped: external_prop_types_default.a.bool };


Subscription.defaultProps = {
  onClick: () => {},
  subdued: false,
  dotColor: null,
  img: null,
  className: '',
  highlight: false,
  isBeingSwapped: false };


/* harmony default export */ var Subscription_Subscription = (Subscription);
// CONCATENATED MODULE: ./src/components/Subscription/index.js


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
	 true ? module.exports = factory(__webpack_require__(23), __webpack_require__(1)) :
	undefined;
}(this, (function (ReactDOM,React) { 'use strict';

	ReactDOM = ReactDOM && ReactDOM.hasOwnProperty('default') ? ReactDOM['default'] : ReactDOM;
	React = React && React.hasOwnProperty('default') ? React['default'] : React;

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */

	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}

	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};

	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};

	var emptyFunction_1 = emptyFunction;

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */

	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */

	var validateFormat = function validateFormat(format) {};

	{
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}

	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);

	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }

	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}

	var invariant_1 = invariant;

	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */

	var warning = emptyFunction_1;

	{
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }

	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };

	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }

	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }

	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }

	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}

	var warning_1 = warning;

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	var ReactPropTypesSecret_1 = ReactPropTypesSecret;

	{
	  var invariant$1 = invariant_1;
	  var warning$1 = warning_1;
	  var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;
	  var loggedTypeFailures = {};
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant$1(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret$1);
	        } catch (ex) {
	          error = ex;
	        }
	        warning$1(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          warning$1(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}

	var checkPropTypes_1 = checkPropTypes;

	var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret_1) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant_1(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if ( true && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning_1(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction_1.thatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret_1);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      warning_1(false, 'Invalid argument supplied to oneOf, expected an instance of array.');
	      return emptyFunction_1.thatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      warning_1(false, 'Invalid argument supplied to oneOfType, expected an instance of array.');
	      return emptyFunction_1.thatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning_1(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction_1.thatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret_1) == null) {
	          return null;
	        }
	      }

	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = objectAssign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret_1);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes_1;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};

	var propTypes = createCommonjsModule(function (module) {
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */

	{
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;

	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };

	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = factoryWithTypeCheckers(isValidElement, throwOnDirectAccess);
	}
	});

	var classnames = createCommonjsModule(function (module) {
	/*!
	  Copyright (c) 2016 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */

	(function () {

		var hasOwn = {}.hasOwnProperty;

		function classNames () {
			var classes = [];

			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;

				var argType = typeof arg;

				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg)) {
					classes.push(classNames.apply(null, arg));
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}

			return classes.join(' ');
		}

		if ( true && module.exports) {
			module.exports = classNames;
		} else if (false) {} else {
			window.classNames = classNames;
		}
	}());
	});

	// @credits https://gist.github.com/rogozhnikoff/a43cfed27c41e4e68cdc
	function findInArray(array /*: Array<any> | TouchList*/, callback /*: Function*/) /*: any*/ {
	  for (var i = 0, length = array.length; i < length; i++) {
	    if (callback.apply(callback, [array[i], i, array])) return array[i];
	  }
	}

	function isFunction(func /*: any*/) /*: boolean*/ {
	  return typeof func === 'function' || Object.prototype.toString.call(func) === '[object Function]';
	}

	function isNum(num /*: any*/) /*: boolean*/ {
	  return typeof num === 'number' && !isNaN(num);
	}

	function int(a /*: string*/) /*: number*/ {
	  return parseInt(a, 10);
	}

	function dontSetMe(props /*: Object*/, propName /*: string*/, componentName /*: string*/) {
	  if (props[propName]) {
	    return new Error('Invalid prop ' + propName + ' passed to ' + componentName + ' - do not set this, set it on the child.');
	  }
	}

	var prefixes = ['Moz', 'Webkit', 'O', 'ms'];
	function getPrefix() /*: string*/ {
	  var prop /*: string*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';

	  // Checking specifically for 'window.document' is for pseudo-browser server-side
	  // environments that define 'window' as the global context.
	  // E.g. React-rails (see https://github.com/reactjs/react-rails/pull/84)
	  if (typeof window === 'undefined' || typeof window.document === 'undefined') return '';

	  var style = window.document.documentElement.style;

	  if (prop in style) return '';

	  for (var i = 0; i < prefixes.length; i++) {
	    if (browserPrefixToKey(prop, prefixes[i]) in style) return prefixes[i];
	  }

	  return '';
	}

	function browserPrefixToKey(prop /*: string*/, prefix /*: string*/) /*: string*/ {
	  return prefix ? '' + prefix + kebabToTitleCase(prop) : prop;
	}

	function kebabToTitleCase(str /*: string*/) /*: string*/ {
	  var out = '';
	  var shouldCapitalize = true;
	  for (var i = 0; i < str.length; i++) {
	    if (shouldCapitalize) {
	      out += str[i].toUpperCase();
	      shouldCapitalize = false;
	    } else if (str[i] === '-') {
	      shouldCapitalize = true;
	    } else {
	      out += str[i];
	    }
	  }
	  return out;
	}

	// Default export is the prefix itself, like 'Moz', 'Webkit', etc
	// Note that you may have to re-test for certain things; for instance, Chrome 50
	// can handle unprefixed `transform`, but not unprefixed `user-select`
	var browserPrefix = getPrefix();

	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }

	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	};

	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];

	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }

	  return target;
	};

	var inherits = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
	  }

	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	};

	var possibleConstructorReturn = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }

	  return call && (typeof call === "object" || typeof call === "function") ? call : self;
	};

	var slicedToArray = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;

	    try {
	      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);

	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }

	    return _arr;
	  }

	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if (Symbol.iterator in Object(arr)) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

	/*:: import type {ControlPosition, PositionOffsetControlPosition, MouseTouchEvent} from './types';*/


	var matchesSelectorFunc = '';
	function matchesSelector(el /*: Node*/, selector /*: string*/) /*: boolean*/ {
	  if (!matchesSelectorFunc) {
	    matchesSelectorFunc = findInArray(['matches', 'webkitMatchesSelector', 'mozMatchesSelector', 'msMatchesSelector', 'oMatchesSelector'], function (method) {
	      // $FlowIgnore: Doesn't think elements are indexable
	      return isFunction(el[method]);
	    });
	  }

	  // Might not be found entirely (not an Element?) - in that case, bail
	  // $FlowIgnore: Doesn't think elements are indexable
	  if (!isFunction(el[matchesSelectorFunc])) return false;

	  // $FlowIgnore: Doesn't think elements are indexable
	  return el[matchesSelectorFunc](selector);
	}

	// Works up the tree to the draggable itself attempting to match selector.
	function matchesSelectorAndParentsTo(el /*: Node*/, selector /*: string*/, baseNode /*: Node*/) /*: boolean*/ {
	  var node = el;
	  do {
	    if (matchesSelector(node, selector)) return true;
	    if (node === baseNode) return false;
	    node = node.parentNode;
	  } while (node);

	  return false;
	}

	function addEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
	  if (!el) {
	    return;
	  }
	  if (el.attachEvent) {
	    el.attachEvent('on' + event, handler);
	  } else if (el.addEventListener) {
	    el.addEventListener(event, handler, true);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = handler;
	  }
	}

	function removeEvent(el /*: ?Node*/, event /*: string*/, handler /*: Function*/) /*: void*/ {
	  if (!el) {
	    return;
	  }
	  if (el.detachEvent) {
	    el.detachEvent('on' + event, handler);
	  } else if (el.removeEventListener) {
	    el.removeEventListener(event, handler, true);
	  } else {
	    // $FlowIgnore: Doesn't think elements are indexable
	    el['on' + event] = null;
	  }
	}

	function outerHeight(node /*: HTMLElement*/) /*: number*/ {
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetTop which is including margin. See getBoundPosition
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height += int(computedStyle.borderTopWidth);
	  height += int(computedStyle.borderBottomWidth);
	  return height;
	}

	function outerWidth(node /*: HTMLElement*/) /*: number*/ {
	  // This is deliberately excluding margin for our calculations, since we are using
	  // offsetLeft which is including margin. See getBoundPosition
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width += int(computedStyle.borderLeftWidth);
	  width += int(computedStyle.borderRightWidth);
	  return width;
	}
	function innerHeight(node /*: HTMLElement*/) /*: number*/ {
	  var height = node.clientHeight;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  height -= int(computedStyle.paddingTop);
	  height -= int(computedStyle.paddingBottom);
	  return height;
	}

	function innerWidth(node /*: HTMLElement*/) /*: number*/ {
	  var width = node.clientWidth;
	  var computedStyle = node.ownerDocument.defaultView.getComputedStyle(node);
	  width -= int(computedStyle.paddingLeft);
	  width -= int(computedStyle.paddingRight);
	  return width;
	}

	// Get from offsetParent
	function offsetXYFromParent(evt /*: {clientX: number, clientY: number}*/, offsetParent /*: HTMLElement*/) /*: ControlPosition*/ {
	  var isBody = offsetParent === offsetParent.ownerDocument.body;
	  var offsetParentRect = isBody ? { left: 0, top: 0 } : offsetParent.getBoundingClientRect();

	  var x = evt.clientX + offsetParent.scrollLeft - offsetParentRect.left;
	  var y = evt.clientY + offsetParent.scrollTop - offsetParentRect.top;

	  return { x: x, y: y };
	}

	function createCSSTransform(controlPos /*: ControlPosition*/, positionOffset /*: PositionOffsetControlPosition*/) /*: Object*/ {
	  var translation = getTranslation(controlPos, positionOffset, 'px');
	  return defineProperty({}, browserPrefixToKey('transform', browserPrefix), translation);
	}

	function createSVGTransform(controlPos /*: ControlPosition*/, positionOffset /*: PositionOffsetControlPosition*/) /*: string*/ {
	  var translation = getTranslation(controlPos, positionOffset, '');
	  return translation;
	}
	function getTranslation(_ref2, positionOffset /*: PositionOffsetControlPosition*/, unitSuffix /*: string*/) /*: string*/ {
	  var x = _ref2.x,
	      y = _ref2.y;

	  var translation = 'translate(' + x + unitSuffix + ',' + y + unitSuffix + ')';
	  if (positionOffset) {
	    var defaultX = '' + (typeof positionOffset.x === 'string' ? positionOffset.x : positionOffset.x + unitSuffix);
	    var defaultY = '' + (typeof positionOffset.y === 'string' ? positionOffset.y : positionOffset.y + unitSuffix);
	    translation = 'translate(' + defaultX + ', ' + defaultY + ')' + translation;
	  }
	  return translation;
	}

	function getTouch(e /*: MouseTouchEvent*/, identifier /*: number*/) /*: ?{clientX: number, clientY: number}*/ {
	  return e.targetTouches && findInArray(e.targetTouches, function (t) {
	    return identifier === t.identifier;
	  }) || e.changedTouches && findInArray(e.changedTouches, function (t) {
	    return identifier === t.identifier;
	  });
	}

	function getTouchIdentifier(e /*: MouseTouchEvent*/) /*: ?number*/ {
	  if (e.targetTouches && e.targetTouches[0]) return e.targetTouches[0].identifier;
	  if (e.changedTouches && e.changedTouches[0]) return e.changedTouches[0].identifier;
	}

	// User-select Hacks:
	//
	// Useful for preventing blue highlights all over everything when dragging.

	// Note we're passing `document` b/c we could be iframed
	function addUserSelectStyles(doc /*: ?Document*/) {
	  if (!doc) return;
	  var styleEl = doc.getElementById('react-draggable-style-el');
	  if (!styleEl) {
	    styleEl = doc.createElement('style');
	    styleEl.type = 'text/css';
	    styleEl.id = 'react-draggable-style-el';
	    styleEl.innerHTML = '.react-draggable-transparent-selection *::-moz-selection {all: inherit;}\n';
	    styleEl.innerHTML += '.react-draggable-transparent-selection *::selection {all: inherit;}\n';
	    doc.getElementsByTagName('head')[0].appendChild(styleEl);
	  }
	  if (doc.body) addClassName(doc.body, 'react-draggable-transparent-selection');
	}

	function removeUserSelectStyles(doc /*: ?Document*/) {
	  try {
	    if (doc && doc.body) removeClassName(doc.body, 'react-draggable-transparent-selection');
	    // $FlowIgnore: IE
	    if (doc.selection) {
	      // $FlowIgnore: IE
	      doc.selection.empty();
	    } else {
	      window.getSelection().removeAllRanges(); // remove selection caused by scroll
	    }
	  } catch (e) {
	    // probably IE
	  }
	}

	function styleHacks() /*: Object*/ {
	  var childStyle /*: Object*/ = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

	  // Workaround IE pointer events; see #51
	  // https://github.com/mzabriskie/react-draggable/issues/51#issuecomment-103488278
	  return _extends({
	    touchAction: 'none'
	  }, childStyle);
	}

	function addClassName(el /*: HTMLElement*/, className /*: string*/) {
	  if (el.classList) {
	    el.classList.add(className);
	  } else {
	    if (!el.className.match(new RegExp('(?:^|\\s)' + className + '(?!\\S)'))) {
	      el.className += ' ' + className;
	    }
	  }
	}

	function removeClassName(el /*: HTMLElement*/, className /*: string*/) {
	  if (el.classList) {
	    el.classList.remove(className);
	  } else {
	    el.className = el.className.replace(new RegExp('(?:^|\\s)' + className + '(?!\\S)', 'g'), '');
	  }
	}

	/*:: import type Draggable from '../Draggable';*/
	/*:: import type {Bounds, ControlPosition, DraggableData, MouseTouchEvent} from './types';*/
	/*:: import type DraggableCore from '../DraggableCore';*/


	function getBoundPosition(draggable /*: Draggable*/, x /*: number*/, y /*: number*/) /*: [number, number]*/ {
	  // If no bounds, short-circuit and move on
	  if (!draggable.props.bounds) return [x, y];

	  // Clone new bounds
	  var bounds = draggable.props.bounds;

	  bounds = typeof bounds === 'string' ? bounds : cloneBounds(bounds);
	  var node = findDOMNode(draggable);

	  if (typeof bounds === 'string') {
	    var ownerDocument = node.ownerDocument;

	    var ownerWindow = ownerDocument.defaultView;
	    var boundNode = void 0;
	    if (bounds === 'parent') {
	      boundNode = node.parentNode;
	    } else {
	      boundNode = ownerDocument.querySelector(bounds);
	    }
	    if (!(boundNode instanceof ownerWindow.HTMLElement)) {
	      throw new Error('Bounds selector "' + bounds + '" could not find an element.');
	    }
	    var nodeStyle = ownerWindow.getComputedStyle(node);
	    var boundNodeStyle = ownerWindow.getComputedStyle(boundNode);
	    // Compute bounds. This is a pain with padding and offsets but this gets it exactly right.
	    bounds = {
	      left: -node.offsetLeft + int(boundNodeStyle.paddingLeft) + int(nodeStyle.marginLeft),
	      top: -node.offsetTop + int(boundNodeStyle.paddingTop) + int(nodeStyle.marginTop),
	      right: innerWidth(boundNode) - outerWidth(node) - node.offsetLeft + int(boundNodeStyle.paddingRight) - int(nodeStyle.marginRight),
	      bottom: innerHeight(boundNode) - outerHeight(node) - node.offsetTop + int(boundNodeStyle.paddingBottom) - int(nodeStyle.marginBottom)
	    };
	  }

	  // Keep x and y below right and bottom limits...
	  if (isNum(bounds.right)) x = Math.min(x, bounds.right);
	  if (isNum(bounds.bottom)) y = Math.min(y, bounds.bottom);

	  // But above left and top limits.
	  if (isNum(bounds.left)) x = Math.max(x, bounds.left);
	  if (isNum(bounds.top)) y = Math.max(y, bounds.top);

	  return [x, y];
	}

	function snapToGrid(grid /*: [number, number]*/, pendingX /*: number*/, pendingY /*: number*/) /*: [number, number]*/ {
	  var x = Math.round(pendingX / grid[0]) * grid[0];
	  var y = Math.round(pendingY / grid[1]) * grid[1];
	  return [x, y];
	}

	function canDragX(draggable /*: Draggable*/) /*: boolean*/ {
	  return draggable.props.axis === 'both' || draggable.props.axis === 'x';
	}

	function canDragY(draggable /*: Draggable*/) /*: boolean*/ {
	  return draggable.props.axis === 'both' || draggable.props.axis === 'y';
	}

	// Get {x, y} positions from event.
	function getControlPosition(e /*: MouseTouchEvent*/, touchIdentifier /*: ?number*/, draggableCore /*: DraggableCore*/) /*: ?ControlPosition*/ {
	  var touchObj = typeof touchIdentifier === 'number' ? getTouch(e, touchIdentifier) : null;
	  if (typeof touchIdentifier === 'number' && !touchObj) return null; // not the right touch
	  var node = findDOMNode(draggableCore);
	  // User can provide an offsetParent if desired.
	  var offsetParent = draggableCore.props.offsetParent || node.offsetParent || node.ownerDocument.body;
	  return offsetXYFromParent(touchObj || e, offsetParent);
	}

	// Create an data object exposed by <DraggableCore>'s events
	function createCoreData(draggable /*: DraggableCore*/, x /*: number*/, y /*: number*/) /*: DraggableData*/ {
	  var state = draggable.state;
	  var isStart = !isNum(state.lastX);
	  var node = findDOMNode(draggable);

	  if (isStart) {
	    // If this is our first move, use the x and y as last coords.
	    return {
	      node: node,
	      deltaX: 0, deltaY: 0,
	      lastX: x, lastY: y,
	      x: x, y: y
	    };
	  } else {
	    // Otherwise calculate proper values.
	    return {
	      node: node,
	      deltaX: x - state.lastX, deltaY: y - state.lastY,
	      lastX: state.lastX, lastY: state.lastY,
	      x: x, y: y
	    };
	  }
	}

	// Create an data exposed by <Draggable>'s events
	function createDraggableData(draggable /*: Draggable*/, coreData /*: DraggableData*/) /*: DraggableData*/ {
	  var scale = draggable.props.scale;
	  return {
	    node: coreData.node,
	    x: draggable.state.x + coreData.deltaX / scale,
	    y: draggable.state.y + coreData.deltaY / scale,
	    deltaX: coreData.deltaX / scale,
	    deltaY: coreData.deltaY / scale,
	    lastX: draggable.state.x,
	    lastY: draggable.state.y
	  };
	}

	// A lot faster than stringify/parse
	function cloneBounds(bounds /*: Bounds*/) /*: Bounds*/ {
	  return {
	    left: bounds.left,
	    top: bounds.top,
	    right: bounds.right,
	    bottom: bounds.bottom
	  };
	}

	function findDOMNode(draggable /*: Draggable | DraggableCore*/) /*: HTMLElement*/ {
	  var node = ReactDOM.findDOMNode(draggable);
	  if (!node) {
	    throw new Error('<DraggableCore>: Unmounted during event!');
	  }
	  // $FlowIgnore we can't assert on HTMLElement due to tests... FIXME
	  return node;
	}

	/*eslint no-console:0*/
	function log() {
	}

	/*:: import type {EventHandler, MouseTouchEvent} from './utils/types';*/


	// Simple abstraction for dragging events names.
	/*:: import type {Element as ReactElement} from 'react';*/
	var eventsFor = {
	  touch: {
	    start: 'touchstart',
	    move: 'touchmove',
	    stop: 'touchend'
	  },
	  mouse: {
	    start: 'mousedown',
	    move: 'mousemove',
	    stop: 'mouseup'
	  }
	};

	// Default to mouse events.
	var dragEventFor = eventsFor.mouse;

	/*:: type DraggableCoreState = {
	  dragging: boolean,
	  lastX: number,
	  lastY: number,
	  touchIdentifier: ?number
	};*/
	/*:: export type DraggableBounds = {
	  left: number,
	  right: number,
	  top: number,
	  bottom: number,
	};*/
	/*:: export type DraggableData = {
	  node: HTMLElement,
	  x: number, y: number,
	  deltaX: number, deltaY: number,
	  lastX: number, lastY: number,
	};*/
	/*:: export type DraggableEventHandler = (e: MouseEvent, data: DraggableData) => void;*/
	/*:: export type ControlPosition = {x: number, y: number};*/
	/*:: export type PositionOffsetControlPosition = {x: number|string, y: number|string};*/


	//
	// Define <DraggableCore>.
	//
	// <DraggableCore> is for advanced usage of <Draggable>. It maintains minimal internal state so it can
	// work well with libraries that require more control over the element.
	//

	/*:: export type DraggableCoreProps = {
	  allowAnyClick: boolean,
	  cancel: string,
	  children: ReactElement<any>,
	  disabled: boolean,
	  enableUserSelectHack: boolean,
	  offsetParent: HTMLElement,
	  grid: [number, number],
	  handle: string,
	  onStart: DraggableEventHandler,
	  onDrag: DraggableEventHandler,
	  onStop: DraggableEventHandler,
	  onMouseDown: (e: MouseEvent) => void,
	};*/

	var DraggableCore = function (_React$Component) {
	  inherits(DraggableCore, _React$Component);

	  function DraggableCore() {
	    var _ref;

	    var _temp, _this, _ret;

	    classCallCheck(this, DraggableCore);

	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }

	    return _ret = (_temp = (_this = possibleConstructorReturn(this, (_ref = DraggableCore.__proto__ || Object.getPrototypeOf(DraggableCore)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      dragging: false,
	      // Used while dragging to determine deltas.
	      lastX: NaN, lastY: NaN,
	      touchIdentifier: null
	    }, _this.handleDragStart = function (e) {
	      // Make it possible to attach event handlers on top of this one.
	      _this.props.onMouseDown(e);

	      // Only accept left-clicks.
	      if (!_this.props.allowAnyClick && typeof e.button === 'number' && e.button !== 0) return false;

	      // Get nodes. Be sure to grab relative document (could be iframed)
	      var thisNode = ReactDOM.findDOMNode(_this);
	      if (!thisNode || !thisNode.ownerDocument || !thisNode.ownerDocument.body) {
	        throw new Error('<DraggableCore> not mounted on DragStart!');
	      }
	      var ownerDocument = thisNode.ownerDocument;

	      // Short circuit if handle or cancel prop was provided and selector doesn't match.

	      if (_this.props.disabled || !(e.target instanceof ownerDocument.defaultView.Node) || _this.props.handle && !matchesSelectorAndParentsTo(e.target, _this.props.handle, thisNode) || _this.props.cancel && matchesSelectorAndParentsTo(e.target, _this.props.cancel, thisNode)) {
	        return;
	      }

	      // Set touch identifier in component state if this is a touch event. This allows us to
	      // distinguish between individual touches on multitouch screens by identifying which
	      // touchpoint was set to this element.
	      var touchIdentifier = getTouchIdentifier(e);
	      _this.setState({ touchIdentifier: touchIdentifier });

	      // Get the current drag point from the event. This is used as the offset.
	      var position = getControlPosition(e, touchIdentifier, _this);
	      if (position == null) return; // not possible but satisfies flow
	      var x = position.x,
	          y = position.y;

	      // Create an event object with all the data parents need to make a decision here.

	      var coreEvent = createCoreData(_this, x, y);

	      // Call event handler. If it returns explicit false, cancel.
	      log('calling', _this.props.onStart);
	      var shouldUpdate = _this.props.onStart(e, coreEvent);
	      if (shouldUpdate === false) return;

	      // Add a style to the body to disable user-select. This prevents text from
	      // being selected all over the page.
	      if (_this.props.enableUserSelectHack) addUserSelectStyles(ownerDocument);

	      // Initiate dragging. Set the current x and y as offsets
	      // so we know how much we've moved during the drag. This allows us
	      // to drag elements around even if they have been moved, without issue.
	      _this.setState({
	        dragging: true,

	        lastX: x,
	        lastY: y
	      });

	      // Add events to the document directly so we catch when the user's mouse/touch moves outside of
	      // this element. We use different events depending on whether or not we have detected that this
	      // is a touch-capable device.
	      addEvent(ownerDocument, dragEventFor.move, _this.handleDrag);
	      addEvent(ownerDocument, dragEventFor.stop, _this.handleDragStop);
	    }, _this.handleDrag = function (e) {

	      // Prevent scrolling on mobile devices, like ipad/iphone.
	      if (e.type === 'touchmove') e.preventDefault();

	      // Get the current drag point from the event. This is used as the offset.
	      var position = getControlPosition(e, _this.state.touchIdentifier, _this);
	      if (position == null) return;
	      var x = position.x,
	          y = position.y;

	      // Snap to grid if prop has been provided

	      if (Array.isArray(_this.props.grid)) {
	        var _deltaX = x - _this.state.lastX,
	            _deltaY = y - _this.state.lastY;

	        var _snapToGrid = snapToGrid(_this.props.grid, _deltaX, _deltaY);

	        var _snapToGrid2 = slicedToArray(_snapToGrid, 2);

	        _deltaX = _snapToGrid2[0];
	        _deltaY = _snapToGrid2[1];

	        if (!_deltaX && !_deltaY) return; // skip useless drag
	        x = _this.state.lastX + _deltaX, y = _this.state.lastY + _deltaY;
	      }

	      var coreEvent = createCoreData(_this, x, y);

	      // Call event handler. If it returns explicit false, trigger end.
	      var shouldUpdate = _this.props.onDrag(e, coreEvent);
	      if (shouldUpdate === false) {
	        try {
	          // $FlowIgnore
	          _this.handleDragStop(new MouseEvent('mouseup'));
	        } catch (err) {
	          // Old browsers
	          var event = ((document.createEvent('MouseEvents') /*: any*/) /*: MouseTouchEvent*/);
	          // I see why this insanity was deprecated
	          // $FlowIgnore
	          event.initMouseEvent('mouseup', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	          _this.handleDragStop(event);
	        }
	        return;
	      }

	      _this.setState({
	        lastX: x,
	        lastY: y
	      });
	    }, _this.handleDragStop = function (e) {
	      if (!_this.state.dragging) return;

	      var position = getControlPosition(e, _this.state.touchIdentifier, _this);
	      if (position == null) return;
	      var x = position.x,
	          y = position.y;

	      var coreEvent = createCoreData(_this, x, y);

	      var thisNode = ReactDOM.findDOMNode(_this);
	      if (thisNode) {
	        // Remove user-select hack
	        if (_this.props.enableUserSelectHack) removeUserSelectStyles(thisNode.ownerDocument);
	      }

	      // Reset the el.
	      _this.setState({
	        dragging: false,
	        lastX: NaN,
	        lastY: NaN
	      });

	      // Call event handler
	      _this.props.onStop(e, coreEvent);

	      if (thisNode) {
	        removeEvent(thisNode.ownerDocument, dragEventFor.move, _this.handleDrag);
	        removeEvent(thisNode.ownerDocument, dragEventFor.stop, _this.handleDragStop);
	      }
	    }, _this.onMouseDown = function (e) {
	      dragEventFor = eventsFor.mouse; // on touchscreen laptops we could switch back to mouse

	      return _this.handleDragStart(e);
	    }, _this.onMouseUp = function (e) {
	      dragEventFor = eventsFor.mouse;

	      return _this.handleDragStop(e);
	    }, _this.onTouchStart = function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;

	      return _this.handleDragStart(e);
	    }, _this.onTouchEnd = function (e) {
	      // We're on a touch device now, so change the event handlers
	      dragEventFor = eventsFor.touch;

	      return _this.handleDragStop(e);
	    }, _temp), possibleConstructorReturn(_this, _ret);
	  }

	  createClass(DraggableCore, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      // Remove any leftover event handlers. Remove both touch and mouse handlers in case
	      // some browser quirk caused a touch event to fire during a mouse move, or vice versa.
	      var thisNode = ReactDOM.findDOMNode(this);
	      if (thisNode) {
	        var ownerDocument = thisNode.ownerDocument;

	        removeEvent(ownerDocument, eventsFor.mouse.move, this.handleDrag);
	        removeEvent(ownerDocument, eventsFor.touch.move, this.handleDrag);
	        removeEvent(ownerDocument, eventsFor.mouse.stop, this.handleDragStop);
	        removeEvent(ownerDocument, eventsFor.touch.stop, this.handleDragStop);
	        if (this.props.enableUserSelectHack) removeUserSelectStyles(ownerDocument);
	      }
	    }

	    // Same as onMouseDown (start drag), but now consider this a touch device.

	  }, {
	    key: 'render',
	    value: function render() {
	      // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	      return React.cloneElement(React.Children.only(this.props.children), {
	        style: styleHacks(this.props.children.props.style),

	        // Note: mouseMove handler is attached to document so it will still function
	        // when the user drags quickly and leaves the bounds of the element.
	        onMouseDown: this.onMouseDown,
	        onTouchStart: this.onTouchStart,
	        onMouseUp: this.onMouseUp,
	        onTouchEnd: this.onTouchEnd
	      });
	    }
	  }]);
	  return DraggableCore;
	}(React.Component);

	DraggableCore.displayName = 'DraggableCore';
	DraggableCore.propTypes = {
	  /**
	   * `allowAnyClick` allows dragging using any mouse button.
	   * By default, we only accept the left button.
	   *
	   * Defaults to `false`.
	   */
	  allowAnyClick: propTypes.bool,

	  /**
	   * `disabled`, if true, stops the <Draggable> from dragging. All handlers,
	   * with the exception of `onMouseDown`, will not fire.
	   */
	  disabled: propTypes.bool,

	  /**
	   * By default, we add 'user-select:none' attributes to the document body
	   * to prevent ugly text selection during drag. If this is causing problems
	   * for your app, set this to `false`.
	   */
	  enableUserSelectHack: propTypes.bool,

	  /**
	   * `offsetParent`, if set, uses the passed DOM node to compute drag offsets
	   * instead of using the parent node.
	   */
	  offsetParent: function offsetParent(props /*: DraggableCoreProps*/, propName /*: $Keys<DraggableCoreProps>*/) {
	    if (props[propName] && props[propName].nodeType !== 1) {
	      throw new Error('Draggable\'s offsetParent must be a DOM Node.');
	    }
	  },

	  /**
	   * `grid` specifies the x and y that dragging should snap to.
	   */
	  grid: propTypes.arrayOf(propTypes.number),

	  /**
	   * `scale` specifies the scale of the area you are dragging inside of. It allows
	   * the drag deltas to scale correctly with how far zoomed in/out you are.
	   */
	  scale: propTypes.number,

	  /**
	   * `handle` specifies a selector to be used as the handle that initiates drag.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable handle=".handle">
	   *              <div>
	   *                  <div className="handle">Click me to drag</div>
	   *                  <div>This is some other content</div>
	   *              </div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  handle: propTypes.string,

	  /**
	   * `cancel` specifies a selector to be used to prevent drag initialization.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *           return(
	   *               <Draggable cancel=".cancel">
	   *                   <div>
	   *                     <div className="cancel">You can't drag from here</div>
	   *                     <div>Dragging here works fine</div>
	   *                   </div>
	   *               </Draggable>
	   *           );
	   *       }
	   *   });
	   * ```
	   */
	  cancel: propTypes.string,

	  /**
	   * Called when dragging starts.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onStart: propTypes.func,

	  /**
	   * Called while dragging.
	   * If this function returns the boolean false, dragging will be canceled.
	   */
	  onDrag: propTypes.func,

	  /**
	   * Called when dragging stops.
	   * If this function returns the boolean false, the drag will remain active.
	   */
	  onStop: propTypes.func,

	  /**
	   * A workaround option which can be passed if onMouseDown needs to be accessed,
	   * since it'll always be blocked (as there is internal use of onMouseDown)
	   */
	  onMouseDown: propTypes.func,

	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: dontSetMe,
	  style: dontSetMe,
	  transform: dontSetMe
	};
	DraggableCore.defaultProps = {
	  allowAnyClick: false, // by default only accept left click
	  cancel: null,
	  disabled: false,
	  enableUserSelectHack: true,
	  offsetParent: null,
	  handle: null,
	  grid: null,
	  transform: null,
	  onStart: function onStart() {},
	  onDrag: function onDrag() {},
	  onStop: function onStop() {},
	  onMouseDown: function onMouseDown() {}
	};

	/*:: import type {DraggableEventHandler} from './utils/types';*/
	/*:: import type {Element as ReactElement} from 'react';*/
	/*:: type DraggableState = {
	  dragging: boolean,
	  dragged: boolean,
	  x: number, y: number,
	  slackX: number, slackY: number,
	  isElementSVG: boolean
	};*/


	//
	// Define <Draggable>
	//

	/*:: export type DraggableProps = {
	  ...$Exact<DraggableCoreProps>,
	  axis: 'both' | 'x' | 'y' | 'none',
	  bounds: DraggableBounds | string | false,
	  defaultClassName: string,
	  defaultClassNameDragging: string,
	  defaultClassNameDragged: string,
	  defaultPosition: ControlPosition,
	  positionOffset: PositionOffsetControlPosition,
	  position: ControlPosition,
	  scale: number
	};*/

	var Draggable = function (_React$Component) {
	  inherits(Draggable, _React$Component);

	  function Draggable(props /*: DraggableProps*/) {
	    classCallCheck(this, Draggable);

	    var _this = possibleConstructorReturn(this, (Draggable.__proto__ || Object.getPrototypeOf(Draggable)).call(this, props));

	    _this.onDragStart = function (e, coreData) {

	      // Short-circuit if user's callback killed it.
	      var shouldStart = _this.props.onStart(e, createDraggableData(_this, coreData));
	      // Kills start event on core as well, so move handlers are never bound.
	      if (shouldStart === false) return false;

	      _this.setState({ dragging: true, dragged: true });
	    };

	    _this.onDrag = function (e, coreData) {
	      if (!_this.state.dragging) return false;

	      var uiData = createDraggableData(_this, coreData);

	      var newState /*: $Shape<DraggableState>*/ = {
	        x: uiData.x,
	        y: uiData.y
	      };

	      // Keep within bounds.
	      if (_this.props.bounds) {
	        // Save original x and y.
	        var _x = newState.x,
	            _y = newState.y;

	        // Add slack to the values used to calculate bound position. This will ensure that if
	        // we start removing slack, the element won't react to it right away until it's been
	        // completely removed.

	        newState.x += _this.state.slackX;
	        newState.y += _this.state.slackY;

	        // Get bound position. This will ceil/floor the x and y within the boundaries.

	        var _getBoundPosition = getBoundPosition(_this, newState.x, newState.y),
	            _getBoundPosition2 = slicedToArray(_getBoundPosition, 2),
	            newStateX = _getBoundPosition2[0],
	            newStateY = _getBoundPosition2[1];

	        newState.x = newStateX;
	        newState.y = newStateY;

	        // Recalculate slack by noting how much was shaved by the boundPosition handler.
	        newState.slackX = _this.state.slackX + (_x - newState.x);
	        newState.slackY = _this.state.slackY + (_y - newState.y);

	        // Update the event we fire to reflect what really happened after bounds took effect.
	        uiData.x = newState.x;
	        uiData.y = newState.y;
	        uiData.deltaX = newState.x - _this.state.x;
	        uiData.deltaY = newState.y - _this.state.y;
	      }

	      // Short-circuit if user's callback killed it.
	      var shouldUpdate = _this.props.onDrag(e, uiData);
	      if (shouldUpdate === false) return false;

	      _this.setState(newState);
	    };

	    _this.onDragStop = function (e, coreData) {
	      if (!_this.state.dragging) return false;

	      // Short-circuit if user's callback killed it.
	      var shouldStop = _this.props.onStop(e, createDraggableData(_this, coreData));
	      if (shouldStop === false) return false;

	      var newState /*: $Shape<DraggableState>*/ = {
	        dragging: false,
	        slackX: 0,
	        slackY: 0
	      };

	      // If this is a controlled component, the result of this operation will be to
	      // revert back to the old position. We expect a handler on `onDragStop`, at the least.
	      var controlled = Boolean(_this.props.position);
	      if (controlled) {
	        var _this$props$position = _this.props.position,
	            _x2 = _this$props$position.x,
	            _y2 = _this$props$position.y;

	        newState.x = _x2;
	        newState.y = _y2;
	      }

	      _this.setState(newState);
	    };

	    _this.state = {
	      // Whether or not we are currently dragging.
	      dragging: false,

	      // Whether or not we have been dragged before.
	      dragged: false,

	      // Current transform x and y.
	      x: props.position ? props.position.x : props.defaultPosition.x,
	      y: props.position ? props.position.y : props.defaultPosition.y,

	      // Used for compensating for out-of-bounds drags
	      slackX: 0, slackY: 0,

	      // Can only determine if SVG after mounting
	      isElementSVG: false
	    };

	    if (props.position && !(props.onDrag || props.onStop)) {
	      // eslint-disable-next-line no-console
	      console.warn('A `position` was applied to this <Draggable>, without drag handlers. This will make this ' + 'component effectively undraggable. Please attach `onDrag` or `onStop` handlers so you can adjust the ' + '`position` of this element.');
	    }
	    return _this;
	  }

	  createClass(Draggable, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      // Check to see if the element passed is an instanceof SVGElement
	      if (typeof window.SVGElement !== 'undefined' && ReactDOM.findDOMNode(this) instanceof window.SVGElement) {
	        this.setState({ isElementSVG: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps /*: Object*/) {
	      // Set x/y if position has changed
	      if (nextProps.position && (!this.props.position || nextProps.position.x !== this.props.position.x || nextProps.position.y !== this.props.position.y)) {
	        this.setState({ x: nextProps.position.x, y: nextProps.position.y });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.setState({ dragging: false }); // prevents invariant if unmounted while dragging
	    }
	  }, {
	    key: 'render',
	    value: function render() /*: ReactElement<any>*/ {
	      var _classNames;

	      var style = {},
	          svgTransform = null;

	      // If this is controlled, we don't want to move it - unless it's dragging.
	      var controlled = Boolean(this.props.position);
	      var draggable = !controlled || this.state.dragging;

	      var position = this.props.position || this.props.defaultPosition;
	      var transformOpts = {
	        // Set left if horizontal drag is enabled
	        x: canDragX(this) && draggable ? this.state.x : position.x,

	        // Set top if vertical drag is enabled
	        y: canDragY(this) && draggable ? this.state.y : position.y
	      };

	      // If this element was SVG, we use the `transform` attribute.
	      if (this.state.isElementSVG) {
	        svgTransform = createSVGTransform(transformOpts, this.props.positionOffset);
	      } else {
	        // Add a CSS transform to move the element around. This allows us to move the element around
	        // without worrying about whether or not it is relatively or absolutely positioned.
	        // If the item you are dragging already has a transform set, wrap it in a <span> so <Draggable>
	        // has a clean slate.
	        style = createCSSTransform(transformOpts, this.props.positionOffset);
	      }

	      var _props = this.props,
	          defaultClassName = _props.defaultClassName,
	          defaultClassNameDragging = _props.defaultClassNameDragging,
	          defaultClassNameDragged = _props.defaultClassNameDragged;


	      var children = React.Children.only(this.props.children);

	      // Mark with class while dragging
	      var className = classnames(children.props.className || '', defaultClassName, (_classNames = {}, defineProperty(_classNames, defaultClassNameDragging, this.state.dragging), defineProperty(_classNames, defaultClassNameDragged, this.state.dragged), _classNames));

	      // Reuse the child provided
	      // This makes it flexible to use whatever element is wanted (div, ul, etc)
	      return React.createElement(
	        DraggableCore,
	        _extends({}, this.props, { onStart: this.onDragStart, onDrag: this.onDrag, onStop: this.onDragStop }),
	        React.cloneElement(children, {
	          className: className,
	          style: _extends({}, children.props.style, style),
	          transform: svgTransform
	        })
	      );
	    }
	  }]);
	  return Draggable;
	}(React.Component);

	Draggable.displayName = 'Draggable';
	Draggable.propTypes = _extends({}, DraggableCore.propTypes, {

	  /**
	   * `axis` determines which axis the draggable can move.
	   *
	   *  Note that all callbacks will still return data as normal. This only
	   *  controls flushing to the DOM.
	   *
	   * 'both' allows movement horizontally and vertically.
	   * 'x' limits movement to horizontal axis.
	   * 'y' limits movement to vertical axis.
	   * 'none' limits all movement.
	   *
	   * Defaults to 'both'.
	   */
	  axis: propTypes.oneOf(['both', 'x', 'y', 'none']),

	  /**
	   * `bounds` determines the range of movement available to the element.
	   * Available values are:
	   *
	   * 'parent' restricts movement within the Draggable's parent node.
	   *
	   * Alternatively, pass an object with the following properties, all of which are optional:
	   *
	   * {left: LEFT_BOUND, right: RIGHT_BOUND, bottom: BOTTOM_BOUND, top: TOP_BOUND}
	   *
	   * All values are in px.
	   *
	   * Example:
	   *
	   * ```jsx
	   *   let App = React.createClass({
	   *       render: function () {
	   *         return (
	   *            <Draggable bounds={{right: 300, bottom: 300}}>
	   *              <div>Content</div>
	   *           </Draggable>
	   *         );
	   *       }
	   *   });
	   * ```
	   */
	  bounds: propTypes.oneOfType([propTypes.shape({
	    left: propTypes.number,
	    right: propTypes.number,
	    top: propTypes.number,
	    bottom: propTypes.number
	  }), propTypes.string, propTypes.oneOf([false])]),

	  defaultClassName: propTypes.string,
	  defaultClassNameDragging: propTypes.string,
	  defaultClassNameDragged: propTypes.string,

	  /**
	   * `defaultPosition` specifies the x and y that the dragged item should start at
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable defaultPosition={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  defaultPosition: propTypes.shape({
	    x: propTypes.number,
	    y: propTypes.number
	  }),
	  positionOffset: propTypes.shape({
	    x: propTypes.oneOfType([propTypes.number, propTypes.string]),
	    y: propTypes.oneOfType([propTypes.number, propTypes.string])
	  }),

	  /**
	   * `position`, if present, defines the current position of the element.
	   *
	   *  This is similar to how form elements in React work - if no `position` is supplied, the component
	   *  is uncontrolled.
	   *
	   * Example:
	   *
	   * ```jsx
	   *      let App = React.createClass({
	   *          render: function () {
	   *              return (
	   *                  <Draggable position={{x: 25, y: 25}}>
	   *                      <div>I start with transformX: 25px and transformY: 25px;</div>
	   *                  </Draggable>
	   *              );
	   *          }
	   *      });
	   * ```
	   */
	  position: propTypes.shape({
	    x: propTypes.number,
	    y: propTypes.number
	  }),

	  /**
	   * These properties should be defined on the child, not here.
	   */
	  className: dontSetMe,
	  style: dontSetMe,
	  transform: dontSetMe
	});
	Draggable.defaultProps = _extends({}, DraggableCore.defaultProps, {
	  axis: 'both',
	  bounds: false,
	  defaultClassName: 'react-draggable',
	  defaultClassNameDragging: 'react-draggable-dragging',
	  defaultClassNameDragged: 'react-draggable-dragged',
	  defaultPosition: { x: 0, y: 0 },
	  position: null,
	  scale: 1
	});

	// Previous versions of this lib exported <Draggable> as the root export. As to not break
	// them, or TypeScript, we export *both* as the root and as 'default'.
	// See https://github.com/mzabriskie/react-draggable/pull/254
	// and https://github.com/mzabriskie/react-draggable/issues/266
	Draggable.default = Draggable;
	Draggable.DraggableCore = DraggableCore;

	return Draggable;

})));
//# sourceMappingURL=react-draggable.js.map


/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__82__;

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, "createElement", function() { return /* reexport */ exports_createElement; });
__webpack_require__.d(__webpack_exports__, "findNodeHandle", function() { return /* reexport */ exports_findNodeHandle; });
__webpack_require__.d(__webpack_exports__, "render", function() { return /* reexport */ exports_render; });
__webpack_require__.d(__webpack_exports__, "unmountComponentAtNode", function() { return /* reexport */ unmountComponentAtNode; });
__webpack_require__.d(__webpack_exports__, "processColor", function() { return /* reexport */ exports_processColor; });
__webpack_require__.d(__webpack_exports__, "NativeModules", function() { return /* reexport */ NativeModules["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "TextPropTypes", function() { return /* reexport */ exports_TextPropTypes; });
__webpack_require__.d(__webpack_exports__, "ViewPropTypes", function() { return /* reexport */ exports_ViewPropTypes; });
__webpack_require__.d(__webpack_exports__, "AccessibilityInfo", function() { return /* reexport */ exports_AccessibilityInfo; });
__webpack_require__.d(__webpack_exports__, "Alert", function() { return /* reexport */ exports_Alert; });
__webpack_require__.d(__webpack_exports__, "Animated", function() { return /* reexport */ exports_Animated; });
__webpack_require__.d(__webpack_exports__, "AppRegistry", function() { return /* reexport */ AppRegistry_AppRegistry; });
__webpack_require__.d(__webpack_exports__, "AppState", function() { return /* reexport */ AppState_AppState; });
__webpack_require__.d(__webpack_exports__, "AsyncStorage", function() { return /* reexport */ AsyncStorage; });
__webpack_require__.d(__webpack_exports__, "BackHandler", function() { return /* reexport */ exports_BackHandler; });
__webpack_require__.d(__webpack_exports__, "Clipboard", function() { return /* reexport */ Clipboard; });
__webpack_require__.d(__webpack_exports__, "DeviceInfo", function() { return /* reexport */ exports_DeviceInfo; });
__webpack_require__.d(__webpack_exports__, "Dimensions", function() { return /* reexport */ Dimensions_Dimensions; });
__webpack_require__.d(__webpack_exports__, "Easing", function() { return /* reexport */ exports_Easing; });
__webpack_require__.d(__webpack_exports__, "I18nManager", function() { return /* reexport */ exports_I18nManager; });
__webpack_require__.d(__webpack_exports__, "InteractionManager", function() { return /* reexport */ InteractionManager["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "Keyboard", function() { return /* reexport */ exports_Keyboard; });
__webpack_require__.d(__webpack_exports__, "LayoutAnimation", function() { return /* reexport */ exports_LayoutAnimation; });
__webpack_require__.d(__webpack_exports__, "Linking", function() { return /* reexport */ exports_Linking; });
__webpack_require__.d(__webpack_exports__, "NativeEventEmitter", function() { return /* reexport */ exports_NativeEventEmitter; });
__webpack_require__.d(__webpack_exports__, "NetInfo", function() { return /* reexport */ exports_NetInfo; });
__webpack_require__.d(__webpack_exports__, "PanResponder", function() { return /* reexport */ exports_PanResponder; });
__webpack_require__.d(__webpack_exports__, "PixelRatio", function() { return /* reexport */ PixelRatio_PixelRatio; });
__webpack_require__.d(__webpack_exports__, "Platform", function() { return /* reexport */ exports_Platform; });
__webpack_require__.d(__webpack_exports__, "Share", function() { return /* reexport */ exports_Share; });
__webpack_require__.d(__webpack_exports__, "StyleSheet", function() { return /* reexport */ exports_StyleSheet; });
__webpack_require__.d(__webpack_exports__, "UIManager", function() { return /* reexport */ UIManager["a" /* default */]; });
__webpack_require__.d(__webpack_exports__, "Vibration", function() { return /* reexport */ exports_Vibration; });
__webpack_require__.d(__webpack_exports__, "ActivityIndicator", function() { return /* reexport */ exports_ActivityIndicator; });
__webpack_require__.d(__webpack_exports__, "Button", function() { return /* reexport */ exports_Button; });
__webpack_require__.d(__webpack_exports__, "CheckBox", function() { return /* reexport */ exports_CheckBox; });
__webpack_require__.d(__webpack_exports__, "FlatList", function() { return /* reexport */ exports_FlatList; });
__webpack_require__.d(__webpack_exports__, "Image", function() { return /* reexport */ exports_Image; });
__webpack_require__.d(__webpack_exports__, "ImageBackground", function() { return /* reexport */ exports_ImageBackground; });
__webpack_require__.d(__webpack_exports__, "KeyboardAvoidingView", function() { return /* reexport */ exports_KeyboardAvoidingView; });
__webpack_require__.d(__webpack_exports__, "ListView", function() { return /* reexport */ exports_ListView; });
__webpack_require__.d(__webpack_exports__, "Modal", function() { return /* reexport */ Modal; });
__webpack_require__.d(__webpack_exports__, "Picker", function() { return /* reexport */ exports_Picker; });
__webpack_require__.d(__webpack_exports__, "ProgressBar", function() { return /* reexport */ exports_ProgressBar; });
__webpack_require__.d(__webpack_exports__, "RefreshControl", function() { return /* reexport */ exports_RefreshControl; });
__webpack_require__.d(__webpack_exports__, "SafeAreaView", function() { return /* reexport */ exports_SafeAreaView; });
__webpack_require__.d(__webpack_exports__, "ScrollView", function() { return /* reexport */ exports_ScrollView; });
__webpack_require__.d(__webpack_exports__, "SectionList", function() { return /* reexport */ exports_SectionList; });
__webpack_require__.d(__webpack_exports__, "Slider", function() { return /* reexport */ Slider; });
__webpack_require__.d(__webpack_exports__, "StatusBar", function() { return /* reexport */ StatusBar; });
__webpack_require__.d(__webpack_exports__, "SwipeableFlatList", function() { return /* reexport */ exports_SwipeableFlatList; });
__webpack_require__.d(__webpack_exports__, "SwipeableListView", function() { return /* reexport */ exports_SwipeableListView; });
__webpack_require__.d(__webpack_exports__, "Switch", function() { return /* reexport */ exports_Switch; });
__webpack_require__.d(__webpack_exports__, "Text", function() { return /* reexport */ exports_Text; });
__webpack_require__.d(__webpack_exports__, "TextInput", function() { return /* reexport */ exports_TextInput; });
__webpack_require__.d(__webpack_exports__, "Touchable", function() { return /* reexport */ exports_Touchable; });
__webpack_require__.d(__webpack_exports__, "TouchableHighlight", function() { return /* reexport */ exports_TouchableHighlight; });
__webpack_require__.d(__webpack_exports__, "TouchableNativeFeedback", function() { return /* reexport */ TouchableNativeFeedback; });
__webpack_require__.d(__webpack_exports__, "TouchableOpacity", function() { return /* reexport */ exports_TouchableOpacity; });
__webpack_require__.d(__webpack_exports__, "TouchableWithoutFeedback", function() { return /* reexport */ exports_TouchableWithoutFeedback; });
__webpack_require__.d(__webpack_exports__, "View", function() { return /* reexport */ exports_View; });
__webpack_require__.d(__webpack_exports__, "VirtualizedList", function() { return /* reexport */ exports_VirtualizedList; });
__webpack_require__.d(__webpack_exports__, "YellowBox", function() { return /* reexport */ exports_YellowBox; });
__webpack_require__.d(__webpack_exports__, "ColorPropType", function() { return /* reexport */ exports_ColorPropType; });
__webpack_require__.d(__webpack_exports__, "EdgeInsetsPropType", function() { return /* reexport */ exports_EdgeInsetsPropType; });
__webpack_require__.d(__webpack_exports__, "PointPropType", function() { return /* reexport */ exports_PointPropType; });
__webpack_require__.d(__webpack_exports__, "DatePickerIOS", function() { return /* reexport */ DatePickerIOS; });
__webpack_require__.d(__webpack_exports__, "DrawerLayoutAndroid", function() { return /* reexport */ DrawerLayoutAndroid; });
__webpack_require__.d(__webpack_exports__, "ImageEditor", function() { return /* reexport */ ImageEditor; });
__webpack_require__.d(__webpack_exports__, "ImageStore", function() { return /* reexport */ ImageStore; });
__webpack_require__.d(__webpack_exports__, "InputAccessoryView", function() { return /* reexport */ InputAccessoryView; });
__webpack_require__.d(__webpack_exports__, "MaskedViewIOS", function() { return /* reexport */ MaskedViewIOS; });
__webpack_require__.d(__webpack_exports__, "NavigatorIOS", function() { return /* reexport */ NavigatorIOS; });
__webpack_require__.d(__webpack_exports__, "PickerIOS", function() { return /* reexport */ PickerIOS; });
__webpack_require__.d(__webpack_exports__, "ProgressBarAndroid", function() { return /* reexport */ ProgressBarAndroid; });
__webpack_require__.d(__webpack_exports__, "ProgressViewIOS", function() { return /* reexport */ ProgressViewIOS; });
__webpack_require__.d(__webpack_exports__, "SegmentedControlIOS", function() { return /* reexport */ SegmentedControlIOS; });
__webpack_require__.d(__webpack_exports__, "SnapshotViewIOS", function() { return /* reexport */ SnapshotViewIOS; });
__webpack_require__.d(__webpack_exports__, "TabBarIOS", function() { return /* reexport */ TabBarIOS; });
__webpack_require__.d(__webpack_exports__, "ToastAndroid", function() { return /* reexport */ ToastAndroid; });
__webpack_require__.d(__webpack_exports__, "ToolbarAndroid", function() { return /* reexport */ ToolbarAndroid; });
__webpack_require__.d(__webpack_exports__, "ViewPagerAndroid", function() { return /* reexport */ ViewPagerAndroid; });
__webpack_require__.d(__webpack_exports__, "WebView", function() { return /* reexport */ WebView; });
__webpack_require__.d(__webpack_exports__, "ActionSheetIOS", function() { return /* reexport */ ActionSheetIOS; });
__webpack_require__.d(__webpack_exports__, "AlertIOS", function() { return /* reexport */ AlertIOS; });
__webpack_require__.d(__webpack_exports__, "CameraRoll", function() { return /* reexport */ CameraRoll; });
__webpack_require__.d(__webpack_exports__, "DatePickerAndroid", function() { return /* reexport */ DatePickerAndroid; });
__webpack_require__.d(__webpack_exports__, "ImagePickerIOS", function() { return /* reexport */ ImagePickerIOS; });
__webpack_require__.d(__webpack_exports__, "PermissionsAndroid", function() { return /* reexport */ PermissionsAndroid; });
__webpack_require__.d(__webpack_exports__, "PushNotificationIOS", function() { return /* reexport */ PushNotificationIOS; });
__webpack_require__.d(__webpack_exports__, "Settings", function() { return /* reexport */ Settings; });
__webpack_require__.d(__webpack_exports__, "StatusBarIOS", function() { return /* reexport */ StatusBarIOS; });
__webpack_require__.d(__webpack_exports__, "Systrace", function() { return /* reexport */ Systrace; });
__webpack_require__.d(__webpack_exports__, "TimePickerAndroid", function() { return /* reexport */ TimePickerAndroid; });
__webpack_require__.d(__webpack_exports__, "TVEventHandler", function() { return /* reexport */ TVEventHandler; });
__webpack_require__.d(__webpack_exports__, "VibrationIOS", function() { return /* reexport */ VibrationIOS; });
__webpack_require__.d(__webpack_exports__, "DeviceEventEmitter", function() { return /* reexport */ DeviceEventEmitter; });

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/AccessibilityUtil/buttonLikeRoles.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var buttonLikeRoles = {
  // ARIA button behaves like native 'button' element
  button: true,
  // ARIA menuitem responds to Enter/Space like a button. Spec requires AT to
  // ignore ARIA roles of any children.
  // https://www.w3.org/WAI/GL/wiki/Using_ARIA_menus
  menuitem: true
};
/* harmony default export */ var AccessibilityUtil_buttonLikeRoles = (buttonLikeRoles);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/AccessibilityUtil/isDisabled.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var isDisabled_isDisabled = function isDisabled(props) {
  return props.disabled || Array.isArray(props.accessibilityStates) && props.accessibilityStates.indexOf('disabled') > -1;
};

/* harmony default export */ var AccessibilityUtil_isDisabled = (isDisabled_isDisabled);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/AccessibilityUtil/propsToAriaRole.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var accessibilityComponentTypeToRole = {
  button: 'button',
  none: 'presentation'
};
var accessibilityTraitsToRole = {
  adjustable: 'slider',
  button: 'button',
  header: 'heading',
  image: 'img',
  link: 'link',
  none: 'presentation',
  search: 'search',
  summary: 'region'
};
var accessibilityRoleToWebRole = {
  adjustable: 'slider',
  button: 'button',
  header: 'heading',
  image: 'img',
  imagebutton: null,
  keyboardkey: null,
  label: null,
  link: 'link',
  none: 'presentation',
  search: 'search',
  summary: 'region',
  text: null
};
/**
 * Provides compatibility with React Native's "accessibilityTraits" (iOS) and
 * "accessibilityComponentType" (Android), converting them to equivalent ARIA
 * roles.
 */

var propsToAriaRole = function propsToAriaRole(_ref) {
  var accessibilityComponentType = _ref.accessibilityComponentType,
      accessibilityRole = _ref.accessibilityRole,
      accessibilityTraits = _ref.accessibilityTraits;

  if (accessibilityRole) {
    var inferredRole = accessibilityRoleToWebRole[accessibilityRole];

    if (inferredRole !== null) {
      // ignore roles that don't map to web
      return inferredRole || accessibilityRole;
    }
  }

  if (accessibilityTraits) {
    var trait = Array.isArray(accessibilityTraits) ? accessibilityTraits[0] : accessibilityTraits;
    return accessibilityTraitsToRole[trait];
  }

  if (accessibilityComponentType) {
    return accessibilityComponentTypeToRole[accessibilityComponentType];
  }
};

/* harmony default export */ var AccessibilityUtil_propsToAriaRole = (propsToAriaRole);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/AccessibilityUtil/propsToAccessibilityComponent.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var roleComponents = {
  article: 'article',
  banner: 'header',
  complementary: 'aside',
  contentinfo: 'footer',
  form: 'form',
  link: 'a',
  list: 'ul',
  listitem: 'li',
  main: 'main',
  navigation: 'nav',
  region: 'section'
};
var emptyObject = {};

var propsToAccessibilityComponent_propsToAccessibilityComponent = function propsToAccessibilityComponent(props) {
  if (props === void 0) {
    props = emptyObject;
  }

  // special-case for "label" role which doesn't map to an ARIA role
  if (props.accessibilityRole === 'label') {
    return 'label';
  }

  var role = AccessibilityUtil_propsToAriaRole(props);

  if (role) {
    if (role === 'heading') {
      var level = props['aria-level'] || 1;
      return "h" + level;
    }

    return roleComponents[role];
  }
};

/* harmony default export */ var AccessibilityUtil_propsToAccessibilityComponent = (propsToAccessibilityComponent_propsToAccessibilityComponent);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/AccessibilityUtil/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var AccessibilityUtil = {
  buttonLikeRoles: AccessibilityUtil_buttonLikeRoles,
  isDisabled: AccessibilityUtil_isDisabled,
  propsToAccessibilityComponent: AccessibilityUtil_propsToAccessibilityComponent,
  propsToAriaRole: AccessibilityUtil_propsToAriaRole
};
/* harmony default export */ var modules_AccessibilityUtil = (AccessibilityUtil);
// EXTERNAL MODULE: ./node_modules/react-native-web/node_modules/fbjs/lib/ExecutionEnvironment.js
var ExecutionEnvironment = __webpack_require__(4);
var ExecutionEnvironment_default = /*#__PURE__*/__webpack_require__.n(ExecutionEnvironment);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/createCSSStyleSheet.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
 // $FlowFixMe: HTMLStyleElement is incorrectly typed - https://github.com/facebook/flow/issues/2696

function createCSSStyleSheet(id) {
  if (ExecutionEnvironment["canUseDOM"]) {
    var element = document.getElementById(id);

    if (element != null) {
      // $FlowFixMe: HTMLElement is incorrectly typed
      return element.sheet;
    } else {
      var _element = document.createElement('style');

      _element.setAttribute('id', id);

      var head = document.head;

      if (head) {
        head.insertBefore(_element, head.firstChild);
      }

      return _element.sheet;
    }
  } else {
    return null;
  }
}
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/modules/unitlessNumbers/index.js
var unitlessNumbers = __webpack_require__(49);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/isWebColor/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var isWebColor = function isWebColor(color) {
  return color === 'currentcolor' || color === 'currentColor' || color === 'inherit' || color.indexOf('var(') === 0;
};

/* harmony default export */ var modules_isWebColor = (isWebColor);
// EXTERNAL MODULE: ./node_modules/normalize-css-color/index.js
var normalize_css_color = __webpack_require__(46);
var normalize_css_color_default = /*#__PURE__*/__webpack_require__.n(normalize_css_color);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/processColor/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var processColor_processColor = function processColor(color) {
  if (color === undefined || color === null) {
    return color;
  } // convert number and hex


  var int32Color = normalize_css_color_default()(color);

  if (int32Color === undefined || int32Color === null) {
    return undefined;
  }

  int32Color = (int32Color << 24 | int32Color >>> 8) >>> 0;
  return int32Color;
};

/* harmony default export */ var exports_processColor = (processColor_processColor);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/normalizeColor/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var normalizeColor_normalizeColor = function normalizeColor(color, opacity) {
  if (opacity === void 0) {
    opacity = 1;
  }

  if (color == null) return;

  if (typeof color === 'string' && modules_isWebColor(color)) {
    return color;
  }

  var colorInt = exports_processColor(color);

  if (colorInt != null) {
    var r = colorInt >> 16 & 255;
    var g = colorInt >> 8 & 255;
    var b = colorInt & 255;
    var a = (colorInt >> 24 & 255) / 255;
    var alpha = (a * opacity).toFixed(2);
    return "rgba(" + r + "," + g + "," + b + "," + alpha + ")";
  }
};

/* harmony default export */ var modules_normalizeColor = (normalizeColor_normalizeColor);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/normalizeValueWithProperty.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var colorProps = {
  backgroundColor: true,
  borderColor: true,
  borderTopColor: true,
  borderRightColor: true,
  borderBottomColor: true,
  borderLeftColor: true,
  color: true,
  shadowColor: true,
  textDecorationColor: true,
  textShadowColor: true
};
function normalizeValueWithProperty(value, property) {
  var returnValue = value;

  if ((property == null || !unitlessNumbers["a" /* default */][property]) && typeof value === 'number') {
    returnValue = value + "px";
  } else if (property != null && colorProps[property]) {
    returnValue = modules_normalizeColor(value);
  }

  return returnValue;
}
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/resolveShadowValue.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var defaultOffset = {
  height: 0,
  width: 0
};

var resolveShadowValue_resolveShadowValue = function resolveShadowValue(style) {
  var shadowColor = style.shadowColor,
      shadowOffset = style.shadowOffset,
      shadowOpacity = style.shadowOpacity,
      shadowRadius = style.shadowRadius;

  var _ref = shadowOffset || defaultOffset,
      height = _ref.height,
      width = _ref.width;

  var offsetX = normalizeValueWithProperty(width);
  var offsetY = normalizeValueWithProperty(height);
  var blurRadius = normalizeValueWithProperty(shadowRadius || 0);
  var color = modules_normalizeColor(shadowColor || 'black', shadowOpacity);

  if (color != null && offsetX != null && offsetY != null && blurRadius != null) {
    return offsetX + " " + offsetY + " " + blurRadius + " " + color;
  }
};

/* harmony default export */ var StyleSheet_resolveShadowValue = (resolveShadowValue_resolveShadowValue);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/createCompileableStyle.js
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var createCompileableStyle_defaultOffset = {
  height: 0,
  width: 0
};

function boxShadowReducer(resolvedStyle, style) {
  var boxShadow = style.boxShadow;
  var shadow = StyleSheet_resolveShadowValue(style);

  if (shadow != null) {
    resolvedStyle.boxShadow = boxShadow ? boxShadow + ", " + shadow : shadow;
  }
}

function textShadowReducer(resolvedStyle, style) {
  var textShadowColor = style.textShadowColor,
      textShadowOffset = style.textShadowOffset,
      textShadowRadius = style.textShadowRadius;

  var _ref = textShadowOffset || createCompileableStyle_defaultOffset,
      height = _ref.height,
      width = _ref.width;

  var radius = textShadowRadius || 0;
  var offsetX = normalizeValueWithProperty(width);
  var offsetY = normalizeValueWithProperty(height);
  var blurRadius = normalizeValueWithProperty(radius);
  var color = normalizeValueWithProperty(textShadowColor, 'textShadowColor');

  if (color && (height !== 0 || width !== 0 || radius !== 0) && offsetX != null && offsetY != null && blurRadius != null) {
    resolvedStyle.textShadow = offsetX + " " + offsetY + " " + blurRadius + " " + color;
  }
}

var createCompileableStyle = function createCompileableStyle(styles) {
  var shadowColor = styles.shadowColor,
      shadowOffset = styles.shadowOffset,
      shadowOpacity = styles.shadowOpacity,
      shadowRadius = styles.shadowRadius,
      textShadowColor = styles.textShadowColor,
      textShadowOffset = styles.textShadowOffset,
      textShadowRadius = styles.textShadowRadius,
      nextStyles = _objectWithoutPropertiesLoose(styles, ["shadowColor", "shadowOffset", "shadowOpacity", "shadowRadius", "textShadowColor", "textShadowOffset", "textShadowRadius"]);

  if (shadowColor != null || shadowOffset != null || shadowOpacity != null || shadowRadius != null) {
    boxShadowReducer(nextStyles, styles);
  }

  if (textShadowColor != null || textShadowOffset != null || textShadowRadius != null) {
    textShadowReducer(nextStyles, styles);
  }

  return nextStyles;
};

/* harmony default export */ var StyleSheet_createCompileableStyle = (createCompileableStyle);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/createOrderedCSSStyleSheet.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var slice = Array.prototype.slice;
/**
 * Order-based insertion of CSS.
 *
 * Each rule is associated with a numerically defined group.
 * Groups are ordered within the style sheet according to their number, with the
 * lowest first.
 *
 * Groups are implemented using marker rules. The selector of the first rule of
 * each group is used only to encode the group number for hydration. An
 * alternative implementation could rely on CSSMediaRule, allowing groups to be
 * treated as a sub-sheet, but the Edge implementation of CSSMediaRule is
 * broken.
 * https://developer.mozilla.org/en-US/docs/Web/API/CSSMediaRule
 * https://gist.github.com/necolas/aa0c37846ad6bd3b05b727b959e82674
 */

function createOrderedCSSStyleSheet(sheet) {
  var groups = {};
  var selectors = {};
  /**
   * Hydrate approximate record from any existing rules in the sheet.
   */

  if (sheet != null) {
    var group;
    slice.call(sheet.cssRules).forEach(function (cssRule, i) {
      var cssText = cssRule.cssText; // Create record of existing selectors and rules

      if (cssText.indexOf('stylesheet-group') > -1) {
        group = decodeGroupRule(cssRule);
        groups[group] = {
          start: i,
          rules: [cssText]
        };
      } else {
        var selectorText = getSelectorText(cssText);

        if (selectorText != null) {
          selectors[selectorText] = true;
          groups[group].rules.push(cssText);
        }
      }
    });
  }

  function sheetInsert(sheet, group, text) {
    var orderedGroups = getOrderedGroups(groups);
    var groupIndex = orderedGroups.indexOf(group);
    var nextGroupIndex = groupIndex + 1;
    var nextGroup = orderedGroups[nextGroupIndex]; // Insert rule before the next group, or at the end of the stylesheet

    var position = nextGroup != null && groups[nextGroup].start != null ? groups[nextGroup].start : sheet.cssRules.length;
    var isInserted = insertRuleAt(sheet, text, position);

    if (isInserted) {
      // Set the starting index of the new group
      if (groups[group].start == null) {
        groups[group].start = position;
      } // Increment the starting index of all subsequent groups


      for (var i = nextGroupIndex; i < orderedGroups.length; i += 1) {
        var groupNumber = orderedGroups[i];
        var previousStart = groups[groupNumber].start;
        groups[groupNumber].start = previousStart + 1;
      }
    }

    return isInserted;
  }

  var OrderedCSSStyleSheet = {
    /**
     * The textContent of the style sheet.
     */
    getTextContent: function getTextContent() {
      return getOrderedGroups(groups).map(function (group) {
        var rules = groups[group].rules;
        return rules.join('\n');
      }).join('\n');
    },

    /**
     * Insert a rule into the style sheet
     */
    insert: function insert(cssText, groupValue) {
      var group = Number(groupValue); // Create a new group.

      if (groups[group] == null) {
        var markerRule = encodeGroupRule(group); // Create the internal record.

        groups[group] = {
          start: null,
          rules: [markerRule]
        }; // Update CSSOM.

        if (sheet != null) {
          sheetInsert(sheet, group, markerRule);
        }
      } // selectorText is more reliable than cssText for insertion checks. The
      // browser excludes vendor-prefixed properties and rewrites certain values
      // making cssText more likely to be different from what was inserted.


      var selectorText = getSelectorText(cssText);

      if (selectorText != null && selectors[selectorText] == null) {
        // Update the internal records.
        selectors[selectorText] = true;
        groups[group].rules.push(cssText); // Update CSSOM.

        if (sheet != null) {
          var isInserted = sheetInsert(sheet, group, cssText);

          if (!isInserted) {
            // Revert internal record change if a rule was rejected (e.g.,
            // unrecognized pseudo-selector)
            groups[group].rules.pop();
          }
        }
      }
    }
  };
  return OrderedCSSStyleSheet;
}
/**
 * Helper functions
 */

function encodeGroupRule(group) {
  return "[stylesheet-group=\"" + group + "\"]{}";
}

function decodeGroupRule(cssRule) {
  return Number(cssRule.selectorText.split(/["']/)[1]);
}

function getOrderedGroups(obj) {
  return Object.keys(obj).map(Number).sort(function (a, b) {
    return a > b ? 1 : -1;
  });
}

var pattern = /\s*([,])\s*/g;

function getSelectorText(cssText) {
  var selector = cssText.split('{')[0].trim();
  return selector !== '' ? selector.replace(pattern, '$1') : null;
}

function insertRuleAt(root, cssText, position) {
  try {
    // $FlowFixMe: Flow is missing CSSOM types needed to type 'root'.
    root.insertRule(cssText, position);
    return true;
  } catch (e) {
    // JSDOM doesn't support `CSSSMediaRule#insertRule`.
    // Also ignore errors that occur from attempting to insert vendor-prefixed selectors.
    return false;
  }
}
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/flattenArray/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
function flattenArray(array) {
  function flattenDown(array, result) {
    for (var i = 0; i < array.length; i++) {
      var value = array[i];

      if (Array.isArray(value)) {
        flattenDown(value, result);
      } else if (value != null && value !== false) {
        result.push(value);
      }
    }

    return result;
  }

  return flattenDown(array, []);
}

/* harmony default export */ var modules_flattenArray = (flattenArray);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/ReactNativePropRegistry/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var ReactNativePropRegistry_emptyObject = {};
var objects = {};
var ReactNativePropRegistry_prefix = 'r';
var uniqueID = 1;

var createKey = function createKey(id) {
  return ReactNativePropRegistry_prefix + "-" + id;
};

var ReactNativePropRegistry =
/*#__PURE__*/
function () {
  function ReactNativePropRegistry() {}

  ReactNativePropRegistry.register = function register(object) {
    var id = uniqueID++;

    if (false) {}

    var key = createKey(id);
    objects[key] = object;
    return id;
  };

  ReactNativePropRegistry.getByID = function getByID(id) {
    if (!id) {
      // Used in the style={[condition && id]} pattern,
      // we want it to be a no-op when the value is false or null
      return ReactNativePropRegistry_emptyObject;
    }

    var key = createKey(id);
    var object = objects[key];

    if (!object) {
      console.warn('Invalid style with id `' + id + '`. Skipping ...');
      return ReactNativePropRegistry_emptyObject;
    }

    return object;
  };

  return ReactNativePropRegistry;
}();


// EXTERNAL MODULE: ./node_modules/react-native-web/node_modules/fbjs/lib/invariant.js
var lib_invariant = __webpack_require__(3);
var invariant_default = /*#__PURE__*/__webpack_require__.n(lib_invariant);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/flattenStyle.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function getStyle(style) {
  if (typeof style === 'number') {
    return ReactNativePropRegistry.getByID(style);
  }

  return style;
}

function flattenStyle(style) {
  if (!style) {
    return undefined;
  }

  if (false) {}

  if (!Array.isArray(style)) {
    return getStyle(style);
  }

  var result = {};

  for (var i = 0, styleLength = style.length; i < styleLength; ++i) {
    var computedStyle = flattenStyle(style[i]);

    if (computedStyle) {
      for (var key in computedStyle) {
        var value = computedStyle[key];
        result[key] = value;
      }
    }
  }

  return result;
}

/* harmony default export */ var StyleSheet_flattenStyle = (flattenStyle);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/I18nManager/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var I18nManager_doLeftAndRightSwapInRTL = true;
var isPreferredLanguageRTL = false;
var isRTLAllowed = true;
var isRTLForced = false;

var I18nManager_isRTL = function isRTL() {
  if (isRTLForced) {
    return true;
  }

  return isRTLAllowed && isPreferredLanguageRTL;
};

var I18nManager_onDirectionChange = function onDirectionChange() {
  if (ExecutionEnvironment_default.a.canUseDOM) {
    if (document.documentElement && document.documentElement.setAttribute) {
      document.documentElement.setAttribute('dir', I18nManager_isRTL() ? 'rtl' : 'ltr');
    }
  }
};

var I18nManager = {
  allowRTL: function allowRTL(bool) {
    isRTLAllowed = bool;
    I18nManager_onDirectionChange();
  },
  forceRTL: function forceRTL(bool) {
    isRTLForced = bool;
    I18nManager_onDirectionChange();
  },
  setPreferredLanguageRTL: function setPreferredLanguageRTL(bool) {
    isPreferredLanguageRTL = bool;
    I18nManager_onDirectionChange();
  },
  swapLeftAndRightInRTL: function swapLeftAndRightInRTL(bool) {
    I18nManager_doLeftAndRightSwapInRTL = bool;
  },

  get doLeftAndRightSwapInRTL() {
    return I18nManager_doLeftAndRightSwapInRTL;
  },

  get isRTL() {
    return I18nManager_isRTL();
  }

};
/* harmony default export */ var exports_I18nManager = (I18nManager);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/multiplyStyleLengthValue/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var CSS_UNIT_RE = /^[+-]?\d*(?:\.\d+)?(?:[Ee][+-]?\d+)?(%|\w*)/;

var getUnit = function getUnit(str) {
  return str.match(CSS_UNIT_RE)[1];
};

var isNumeric = function isNumeric(n) {
  return !isNaN(parseFloat(n)) && isFinite(n);
};

var multiplyStyleLengthValue = function multiplyStyleLengthValue(value, multiple) {
  if (typeof value === 'string') {
    var number = parseFloat(value) * multiple;
    var unit = getUnit(value);
    return "" + number + unit;
  } else if (isNumeric(value)) {
    return value * multiple;
  }
};

/* harmony default export */ var modules_multiplyStyleLengthValue = (multiplyStyleLengthValue);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/i18nStyle.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var i18nStyle_emptyObject = {};
var borderTopLeftRadius = 'borderTopLeftRadius';
var borderTopRightRadius = 'borderTopRightRadius';
var borderBottomLeftRadius = 'borderBottomLeftRadius';
var borderBottomRightRadius = 'borderBottomRightRadius';
var borderLeftColor = 'borderLeftColor';
var borderLeftStyle = 'borderLeftStyle';
var borderLeftWidth = 'borderLeftWidth';
var borderRightColor = 'borderRightColor';
var borderRightStyle = 'borderRightStyle';
var borderRightWidth = 'borderRightWidth';
var right = 'right';
var marginLeft = 'marginLeft';
var marginRight = 'marginRight';
var paddingLeft = 'paddingLeft';
var paddingRight = 'paddingRight';
var i18nStyle_left = 'left'; // Map of LTR property names to their BiDi equivalent.

var PROPERTIES_FLIP = {
  borderTopLeftRadius: borderTopRightRadius,
  borderTopRightRadius: borderTopLeftRadius,
  borderBottomLeftRadius: borderBottomRightRadius,
  borderBottomRightRadius: borderBottomLeftRadius,
  borderLeftColor: borderRightColor,
  borderLeftStyle: borderRightStyle,
  borderLeftWidth: borderRightWidth,
  borderRightColor: borderLeftColor,
  borderRightStyle: borderLeftStyle,
  borderRightWidth: borderLeftWidth,
  left: right,
  marginLeft: marginRight,
  marginRight: marginLeft,
  paddingLeft: paddingRight,
  paddingRight: paddingLeft,
  right: i18nStyle_left
}; // Map of I18N property names to their LTR equivalent.

var PROPERTIES_I18N = {
  borderTopStartRadius: borderTopLeftRadius,
  borderTopEndRadius: borderTopRightRadius,
  borderBottomStartRadius: borderBottomLeftRadius,
  borderBottomEndRadius: borderBottomRightRadius,
  borderStartColor: borderLeftColor,
  borderStartStyle: borderLeftStyle,
  borderStartWidth: borderLeftWidth,
  borderEndColor: borderRightColor,
  borderEndStyle: borderRightStyle,
  borderEndWidth: borderRightWidth,
  end: right,
  marginStart: marginLeft,
  marginEnd: marginRight,
  paddingStart: paddingLeft,
  paddingEnd: paddingRight,
  start: i18nStyle_left
};
var PROPERTIES_VALUE = {
  clear: true,
  float: true,
  textAlign: true
}; // Invert the sign of a numeric-like value

var i18nStyle_additiveInverse = function additiveInverse(value) {
  return modules_multiplyStyleLengthValue(value, -1);
};

var i18nStyle_i18nStyle = function i18nStyle(originalStyle) {
  var doLeftAndRightSwapInRTL = exports_I18nManager.doLeftAndRightSwapInRTL,
      isRTL = exports_I18nManager.isRTL;
  var style = originalStyle || i18nStyle_emptyObject;
  var frozenProps = {};
  var nextStyle = {};

  for (var originalProp in style) {
    if (!Object.prototype.hasOwnProperty.call(style, originalProp)) {
      continue;
    }

    var originalValue = style[originalProp];
    var prop = originalProp;
    var value = originalValue; // BiDi flip properties

    if (PROPERTIES_I18N.hasOwnProperty(originalProp)) {
      // convert start/end
      var convertedProp = PROPERTIES_I18N[originalProp];
      prop = isRTL ? PROPERTIES_FLIP[convertedProp] : convertedProp;
    } else if (isRTL && doLeftAndRightSwapInRTL && PROPERTIES_FLIP[originalProp]) {
      prop = PROPERTIES_FLIP[originalProp];
    } // BiDi flip values


    if (PROPERTIES_VALUE.hasOwnProperty(originalProp)) {
      if (originalValue === 'start') {
        value = isRTL ? 'right' : 'left';
      } else if (originalValue === 'end') {
        value = isRTL ? 'left' : 'right';
      } else if (isRTL && doLeftAndRightSwapInRTL) {
        if (originalValue === 'left') {
          value = 'right';
        } else if (originalValue === 'right') {
          value = 'left';
        }
      }
    } // BiDi flip transitionProperty value


    if (prop === 'transitionProperty') {
      // BiDi flip properties
      if (PROPERTIES_I18N.hasOwnProperty(value)) {
        // convert start/end
        var convertedValue = PROPERTIES_I18N[originalValue];
        value = isRTL ? PROPERTIES_FLIP[convertedValue] : convertedValue;
      } else if (isRTL && doLeftAndRightSwapInRTL && PROPERTIES_FLIP[originalValue]) {
        value = PROPERTIES_FLIP[originalValue];
      }
    } // Create finalized style


    if (isRTL && prop === 'textShadowOffset') {
      nextStyle[prop] = value;
      nextStyle[prop].width = i18nStyle_additiveInverse(value.width);
    } else if (!frozenProps[prop]) {
      nextStyle[prop] = value;
    }

    if (PROPERTIES_I18N[originalProp]) {
      frozenProps[prop] = true;
    }
  }

  return nextStyle;
};

/* harmony default export */ var StyleSheet_i18nStyle = (i18nStyle_i18nStyle);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/constants.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var STYLE_ELEMENT_ID = 'react-native-stylesheet';
var STYLE_GROUPS = {
  reset: 0,
  modality: 0.1,
  classicReset: 0.5,
  classic: 1,
  atomic: 2.2,
  custom: {
    borderColor: 2,
    borderRadius: 2,
    borderStyle: 2,
    borderWidth: 2,
    display: 2,
    flex: 2,
    margin: 2,
    overflow: 2,
    overscrollBehavior: 2,
    padding: 2,
    marginHorizontal: 2.1,
    marginVertical: 2.1,
    paddingHorizontal: 2.1,
    paddingVertical: 2.1
  }
};
var STYLE_SHORT_FORM_EXPANSIONS = {
  borderColor: ['borderTopColor', 'borderRightColor', 'borderBottomColor', 'borderLeftColor'],
  borderRadius: ['borderTopLeftRadius', 'borderTopRightRadius', 'borderBottomRightRadius', 'borderBottomLeftRadius'],
  borderStyle: ['borderTopStyle', 'borderRightStyle', 'borderBottomStyle', 'borderLeftStyle'],
  borderWidth: ['borderTopWidth', 'borderRightWidth', 'borderBottomWidth', 'borderLeftWidth'],
  margin: ['marginTop', 'marginRight', 'marginBottom', 'marginLeft'],
  marginHorizontal: ['marginRight', 'marginLeft'],
  marginVertical: ['marginTop', 'marginBottom'],
  overflow: ['overflowX', 'overflowY'],
  overscrollBehavior: ['overscrollBehaviorX', 'overscrollBehaviorY'],
  padding: ['paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft'],
  paddingHorizontal: ['paddingRight', 'paddingLeft'],
  paddingVertical: ['paddingTop', 'paddingBottom']
};
var MONOSPACE_FONT_STACK = 'monospace,monospace';
var SYSTEM_FONT_STACK = 'system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Ubuntu,"Helvetica Neue",sans-serif';
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/createReactDOMStyle.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * The browser implements the CSS cascade, where the order of properties is a
 * factor in determining which styles to paint. React Native is different. It
 * gives giving precedence to the more specific style property. For example,
 * the value of `paddingTop` takes precedence over that of `padding`.
 *
 * This module creates mutally exclusive style declarations by expanding all of
 * React Native's supported shortform properties (e.g. `padding`) to their
 * longfrom equivalents.
 */

var createReactDOMStyle_emptyObject = {};
var supportsCSS3TextDecoration = !ExecutionEnvironment["canUseDOM"] || window.CSS != null && window.CSS.supports != null && (window.CSS.supports('text-decoration-line', 'none') || window.CSS.supports('-webkit-text-decoration-line', 'none'));
/**
 * Transform
 */
// { scale: 2 } => 'scale(2)'
// { translateX: 20 } => 'translateX(20px)'

var createReactDOMStyle_mapTransform = function mapTransform(transform) {
  var type = Object.keys(transform)[0];
  var value = normalizeValueWithProperty(transform[type], type);
  return type + "(" + value + ")";
}; // [1,2,3,4,5,6] => 'matrix3d(1,2,3,4,5,6)'


var convertTransformMatrix = function convertTransformMatrix(transformMatrix) {
  var matrix = transformMatrix.join(',');
  return "matrix3d(" + matrix + ")";
};

var resolveTransform = function resolveTransform(resolvedStyle, style) {
  var transform = style.transform;

  if (Array.isArray(style.transform)) {
    transform = style.transform.map(createReactDOMStyle_mapTransform).join(' ');
  } else if (style.transformMatrix) {
    transform = convertTransformMatrix(style.transformMatrix);
  }

  resolvedStyle.transform = transform;
};
/**
 * Reducer
 */


var createReactDOMStyle_createReactDOMStyle = function createReactDOMStyle(style) {
  if (!style) {
    return createReactDOMStyle_emptyObject;
  }

  var resolvedStyle = {};
  Object.keys(style).sort().forEach(function (prop) {
    var value = normalizeValueWithProperty(style[prop], prop); // Ignore everything else with a null value

    if (value == null) {
      return;
    }

    switch (prop) {
      // Ignore some React Native styles
      case 'aspectRatio':
      case 'elevation':
      case 'overlayColor':
      case 'resizeMode':
      case 'tintColor':
        {
          break;
        }
      // TODO: remove once this issue is fixed
      // https://github.com/rofrischmann/inline-style-prefixer/issues/159

      case 'backgroundClip':
        {
          if (value === 'text') {
            resolvedStyle.backgroundClip = value;
            resolvedStyle.WebkitBackgroundClip = value;
          }

          break;
        }
      // The 'flex' property value in React Native must be a positive integer,
      // 0, or -1.

      case 'flex':
        {
          if (value > 0) {
            resolvedStyle.flexGrow = value;
            resolvedStyle.flexShrink = 1;
            resolvedStyle.flexBasis = '0%';
          } else if (value === 0) {
            resolvedStyle.flexGrow = 0;
            resolvedStyle.flexShrink = 0;
            resolvedStyle.flexBasis = '0%';
          } else if (value === -1) {
            resolvedStyle.flexGrow = 0;
            resolvedStyle.flexShrink = 1;
            resolvedStyle.flexBasis = 'auto';
          }

          break;
        }

      case 'font':
        {
          resolvedStyle[prop] = value.replace('System', SYSTEM_FONT_STACK);
          break;
        }

      case 'fontFamily':
        {
          if (value.indexOf('System') > -1) {
            var stack = value.split(/,\s*/);
            stack[stack.indexOf('System')] = SYSTEM_FONT_STACK;
            resolvedStyle[prop] = stack.join(',');
          } else if (value === 'monospace') {
            resolvedStyle[prop] = MONOSPACE_FONT_STACK;
          } else {
            resolvedStyle[prop] = value;
          }

          break;
        }

      case 'fontVariant':
        {
          if (Array.isArray(value) && value.length > 0) {
            resolvedStyle.fontVariant = value.join(' ');
          }

          break;
        }

      case 'textAlignVertical':
        {
          resolvedStyle.verticalAlign = value === 'center' ? 'middle' : value;
          break;
        }

      case 'textDecorationLine':
        {
          // use 'text-decoration' for browsers that only support CSS2
          // text-decoration (e.g., IE, Edge)
          if (!supportsCSS3TextDecoration) {
            resolvedStyle.textDecoration = value;
          } else {
            resolvedStyle.textDecorationLine = value;
          }

          break;
        }

      case 'transform':
      case 'transformMatrix':
        {
          resolveTransform(resolvedStyle, style);
          break;
        }

      case 'writingDirection':
        {
          resolvedStyle.direction = value;
          break;
        }

      default:
        {
          var longFormProperties = STYLE_SHORT_FORM_EXPANSIONS[prop];

          if (longFormProperties) {
            longFormProperties.forEach(function (longForm, i) {
              // The value of any longform property in the original styles takes
              // precedence over the shortform's value.
              if (typeof style[longForm] === 'undefined') {
                resolvedStyle[longForm] = value;
              }
            });
          } else {
            resolvedStyle[prop] = Array.isArray(value) ? value.join(',') : value;
          }
        }
    }
  });
  return resolvedStyle;
};

/* harmony default export */ var StyleSheet_createReactDOMStyle = (createReactDOMStyle_createReactDOMStyle);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/hash/index.js
/* eslint-disable */

/**
 * JS Implementation of MurmurHash2
 *
 * @author <a href="mailto:gary.court@gmail.com">Gary Court</a>
 * @see http://github.com/garycourt/murmurhash-js
 * @author <a href="mailto:aappleby@gmail.com">Austin Appleby</a>
 * @see http://sites.google.com/site/murmurhash/
 *
 * @param {string} str ASCII only
 * @param {number} seed Positive integer only
 * @return {number} 32-bit positive integer hash
 */
function murmurhash2_32_gc(str, seed) {
  var l = str.length,
      h = seed ^ l,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;
    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;
  return h >>> 0;
}

var hash = function hash(str) {
  return murmurhash2_32_gc(str, 1).toString(36);
};

/* harmony default export */ var vendor_hash = (hash);
// EXTERNAL MODULE: ./node_modules/hyphenate-style-name/index.js
var hyphenate_style_name = __webpack_require__(45);

// EXTERNAL MODULE: ./node_modules/inline-style-prefixer/lib/createPrefixer.js
var createPrefixer = __webpack_require__(141);
var createPrefixer_default = /*#__PURE__*/__webpack_require__.n(createPrefixer);

// EXTERNAL MODULE: ./node_modules/inline-style-prefixer/lib/plugins/backgroundClip.js
var backgroundClip = __webpack_require__(142);
var backgroundClip_default = /*#__PURE__*/__webpack_require__.n(backgroundClip);

// EXTERNAL MODULE: ./node_modules/inline-style-prefixer/lib/plugins/crossFade.js
var crossFade = __webpack_require__(143);
var crossFade_default = /*#__PURE__*/__webpack_require__.n(crossFade);

// EXTERNAL MODULE: ./node_modules/inline-style-prefixer/lib/plugins/cursor.js
var cursor = __webpack_require__(144);
var cursor_default = /*#__PURE__*/__webpack_require__.n(cursor);

// EXTERNAL MODULE: ./node_modules/inline-style-prefixer/lib/plugins/filter.js
var filter = __webpack_require__(145);
var filter_default = /*#__PURE__*/__webpack_require__.n(filter);

// EXTERNAL MODULE: ./node_modules/inline-style-prefixer/lib/plugins/flex.js
var flex = __webpack_require__(146);
var flex_default = /*#__PURE__*/__webpack_require__.n(flex);

// EXTERNAL MODULE: ./node_modules/inline-style-prefixer/lib/plugins/flexboxIE.js
var flexboxIE = __webpack_require__(147);
var flexboxIE_default = /*#__PURE__*/__webpack_require__.n(flexboxIE);

// EXTERNAL MODULE: ./node_modules/inline-style-prefixer/lib/plugins/flexboxOld.js
var flexboxOld = __webpack_require__(148);
var flexboxOld_default = /*#__PURE__*/__webpack_require__.n(flexboxOld);

// EXTERNAL MODULE: ./node_modules/inline-style-prefixer/lib/plugins/gradient.js
var gradient = __webpack_require__(149);
var gradient_default = /*#__PURE__*/__webpack_require__.n(gradient);

// EXTERNAL MODULE: ./node_modules/inline-style-prefixer/lib/plugins/imageSet.js
var imageSet = __webpack_require__(150);
var imageSet_default = /*#__PURE__*/__webpack_require__.n(imageSet);

// EXTERNAL MODULE: ./node_modules/inline-style-prefixer/lib/plugins/position.js
var position = __webpack_require__(151);
var position_default = /*#__PURE__*/__webpack_require__.n(position);

// EXTERNAL MODULE: ./node_modules/inline-style-prefixer/lib/plugins/sizing.js
var sizing = __webpack_require__(152);
var sizing_default = /*#__PURE__*/__webpack_require__.n(sizing);

// EXTERNAL MODULE: ./node_modules/inline-style-prefixer/lib/plugins/transition.js
var transition = __webpack_require__(153);
var transition_default = /*#__PURE__*/__webpack_require__.n(transition);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/prefixStyles/static.js












var w = ['Webkit'];
var m = ['Moz'];
var ms = ['ms'];
var wm = ['Webkit', 'Moz'];
var wms = ['Webkit', 'ms'];
var wmms = ['Webkit', 'Moz', 'ms'];
/* harmony default export */ var prefixStyles_static = ({
  plugins: [backgroundClip_default.a, crossFade_default.a, cursor_default.a, filter_default.a, flex_default.a, flexboxIE_default.a, flexboxOld_default.a, gradient_default.a, imageSet_default.a, position_default.a, sizing_default.a, transition_default.a],
  prefixMap: {
    animation: w,
    animationDelay: w,
    animationDirection: w,
    animationFillMode: w,
    animationDuration: w,
    animationIterationCount: w,
    animationName: w,
    animationPlayState: w,
    animationTimingFunction: w,
    appearance: wm,
    userSelect: wmms,
    textEmphasisPosition: w,
    textEmphasis: w,
    textEmphasisStyle: w,
    textEmphasisColor: w,
    boxDecorationBreak: w,
    clipPath: w,
    maskImage: w,
    maskMode: w,
    maskRepeat: w,
    maskPosition: w,
    maskClip: w,
    maskOrigin: w,
    maskSize: w,
    maskComposite: w,
    mask: w,
    maskBorderSource: w,
    maskBorderMode: w,
    maskBorderSlice: w,
    maskBorderWidth: w,
    maskBorderOutset: w,
    maskBorderRepeat: w,
    maskBorder: w,
    maskType: w,
    textDecorationStyle: w,
    textDecorationSkip: w,
    textDecorationLine: w,
    textDecorationColor: w,
    filter: w,
    fontFeatureSettings: w,
    breakAfter: wmms,
    breakBefore: wmms,
    breakInside: wmms,
    columnCount: wm,
    columnFill: wm,
    columnGap: wm,
    columnRule: wm,
    columnRuleColor: wm,
    columnRuleStyle: wm,
    columnRuleWidth: wm,
    columns: wm,
    columnSpan: wm,
    columnWidth: wm,
    writingMode: wms,
    flex: wms,
    flexBasis: w,
    flexDirection: wms,
    flexGrow: w,
    flexFlow: wms,
    flexShrink: w,
    flexWrap: wms,
    alignContent: w,
    alignItems: w,
    alignSelf: w,
    justifyContent: w,
    order: w,
    transform: w,
    transformOrigin: w,
    transformOriginX: w,
    transformOriginY: w,
    backfaceVisibility: w,
    perspective: w,
    perspectiveOrigin: w,
    transformStyle: w,
    transformOriginZ: w,
    backdropFilter: w,
    fontKerning: w,
    scrollSnapType: wms,
    scrollSnapPointsX: wms,
    scrollSnapPointsY: wms,
    scrollSnapDestination: wms,
    scrollSnapCoordinate: wms,
    shapeImageThreshold: w,
    shapeImageMargin: w,
    shapeImageOutside: w,
    hyphens: wmms,
    flowInto: wms,
    flowFrom: wms,
    regionFragment: wms,
    textOrientation: w,
    textAlignLast: m,
    tabSize: m,
    wrapFlow: ms,
    wrapThrough: ms,
    wrapMargin: ms,
    touchAction: ms,
    gridTemplateColumns: ms,
    gridTemplateRows: ms,
    gridTemplateAreas: ms,
    gridTemplate: ms,
    gridAutoColumns: ms,
    gridAutoRows: ms,
    gridAutoFlow: ms,
    grid: ms,
    gridRowStart: ms,
    gridColumnStart: ms,
    gridRowEnd: ms,
    gridRow: ms,
    gridColumn: ms,
    gridColumnEnd: ms,
    gridColumnGap: ms,
    gridRowGap: ms,
    gridArea: ms,
    gridGap: ms,
    textSizeAdjust: ['ms', 'Webkit'],
    borderImage: w,
    borderImageOutset: w,
    borderImageRepeat: w,
    borderImageSlice: w,
    borderImageSource: w,
    borderImageWidth: w,
    transitionDelay: w,
    transitionDuration: w,
    transitionProperty: w,
    transitionTimingFunction: w
  }
});
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/prefixStyles/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var prefixAll = createPrefixer_default()(prefixStyles_static);
/* harmony default export */ var prefixStyles = (prefixAll);
var prefixInlineStyles = function prefixInlineStyles(style) {
  var prefixedStyles = prefixAll(style); // React@15 removed undocumented support for fallback values in
  // inline-styles. Revert array values to the standard CSS value

  Object.keys(prefixedStyles).forEach(function (prop) {
    var value = prefixedStyles[prop];

    if (Array.isArray(value)) {
      prefixedStyles[prop] = value[value.length - 1];
    }
  });
  return prefixedStyles;
};
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/compile.js
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function compile_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */





var compile_cache = {
  get: function get(property, value) {
    if (compile_cache[property] != null && compile_cache[property].hasOwnProperty(value) && compile_cache[property][value] != null) {
      return compile_cache[property][value];
    }
  },
  set: function set(property, value, object) {
    if (compile_cache[property] == null) {
      compile_cache[property] = {};
    }

    return compile_cache[property][value] = object;
  }
};
/**
 * Compile style to atomic CSS rules.
 */

function atomic(style) {
  return Object.keys(style).sort().reduce(function (acc, property) {
    var value = style[property];

    if (value != null) {
      var valueString = stringifyValueWithProperty(value, property);
      var cachedResult = compile_cache.get(property, valueString);

      if (cachedResult != null) {
        var identifier = cachedResult.identifier;
        acc[identifier] = cachedResult;
      } else {
        var _identifier = createIdentifier('r', property, value);

        var rules = createAtomicRules(_identifier, property, value);

        var _cachedResult = compile_cache.set(property, valueString, {
          property: property,
          value: stringifyValueWithProperty(value, property),
          identifier: _identifier,
          rules: rules
        });

        acc[_identifier] = _cachedResult;
      }
    }

    return acc;
  }, {});
}
/**
 * Compile simple style object to classic CSS rules.
 * No support for 'placeholderTextColor', 'scrollbarWidth', or 'pointerEvents'.
 */

function classic(style, name) {
  var _ref;

  var identifier = createIdentifier('css', name, style);

  var animationKeyframes = style.animationKeyframes,
      rest = compile_objectWithoutPropertiesLoose(style, ["animationKeyframes"]);

  var rules = [];
  var selector = "." + identifier;
  var animationName;

  if (animationKeyframes != null) {
    var _processKeyframesValu = processKeyframesValue(animationKeyframes),
        animationNames = _processKeyframesValu.animationNames,
        keyframesRules = _processKeyframesValu.rules;

    animationName = animationNames.join(',');
    rules.push.apply(rules, keyframesRules);
  }

  var block = createDeclarationBlock(_objectSpread({}, rest, {
    animationName: animationName
  }));
  rules.push("" + selector + block);
  return _ref = {}, _ref[identifier] = {
    identifier: identifier,
    rules: rules
  }, _ref;
}
/**
 * Compile simple style object to inline DOM styles.
 * No support for 'animationKeyframes', 'placeholderTextColor', 'scrollbarWidth', or 'pointerEvents'.
 */

function inline(style) {
  return prefixInlineStyles(StyleSheet_createReactDOMStyle(style));
}
/**
 * Create a value string that normalizes different input values with a common
 * output.
 */

function stringifyValueWithProperty(value, property) {
  // e.g., 0 => '0px', 'black' => 'rgba(0,0,0,1)'
  var normalizedValue = normalizeValueWithProperty(value, property);
  return typeof normalizedValue !== 'string' ? JSON.stringify(normalizedValue || '') : normalizedValue;
}
/**
 * Create the Atomic CSS rules needed for a given StyleSheet rule.
 * Translates StyleSheet declarations to CSS.
 */

function createAtomicRules(identifier, property, value) {
  var rules = [];
  var selector = "." + identifier; // Handle non-standard properties and object values that require multiple
  // CSS rules to be created.

  switch (property) {
    case 'animationKeyframes':
      {
        var _processKeyframesValu2 = processKeyframesValue(value),
            animationNames = _processKeyframesValu2.animationNames,
            keyframesRules = _processKeyframesValu2.rules;

        var block = createDeclarationBlock({
          animationName: animationNames.join(',')
        });
        rules.push.apply(rules, ["" + selector + block].concat(keyframesRules));
        break;
      }

    case 'placeholderTextColor':
      {
        var _block = createDeclarationBlock({
          color: value,
          opacity: 1
        });

        rules.push(selector + "::-webkit-input-placeholder" + _block, selector + "::-moz-placeholder" + _block, selector + ":-ms-input-placeholder" + _block, selector + "::placeholder" + _block);
        break;
      }
    // Polyfill for draft spec
    // https://drafts.csswg.org/css-scrollbars-1/

    case 'scrollbarWidth':
      {
        if (value === 'none') {
          rules.push(selector + "::-webkit-scrollbar{display:none}", selector + "{overflow:-moz-scrollbars-none;-ms-overflow-style:none;scrollbar-width:none;}");
        }

        break;
      }
    // See #513

    case 'pointerEvents':
      {
        var _createDeclarationBlo3;

        var finalValue = value;

        if (value === 'auto' || value === 'box-only') {
          finalValue = 'auto!important';

          if (value === 'box-only') {
            var _createDeclarationBlo;

            var _block3 = createDeclarationBlock((_createDeclarationBlo = {}, _createDeclarationBlo[property] = 'none', _createDeclarationBlo));

            rules.push(selector + ">*" + _block3);
          }
        } else if (value === 'none' || value === 'box-none') {
          finalValue = 'none!important';

          if (value === 'box-none') {
            var _createDeclarationBlo2;

            var _block4 = createDeclarationBlock((_createDeclarationBlo2 = {}, _createDeclarationBlo2[property] = 'auto', _createDeclarationBlo2));

            rules.push(selector + ">*" + _block4);
          }
        }

        var _block2 = createDeclarationBlock((_createDeclarationBlo3 = {}, _createDeclarationBlo3[property] = finalValue, _createDeclarationBlo3));

        rules.push("" + selector + _block2);
        break;
      }

    default:
      {
        var _createDeclarationBlo4;

        var _block5 = createDeclarationBlock((_createDeclarationBlo4 = {}, _createDeclarationBlo4[property] = value, _createDeclarationBlo4));

        rules.push("" + selector + _block5);
        break;
      }
  }

  return rules;
}
/**
 * Creates a CSS declaration block from a StyleSheet object.
 */


function createDeclarationBlock(style) {
  var domStyle = prefixStyles(StyleSheet_createReactDOMStyle(style));
  var declarationsString = Object.keys(domStyle).map(function (property) {
    var value = domStyle[property];
    var prop = Object(hyphenate_style_name["default"])(property); // The prefixer may return an array of values:
    // { display: [ '-webkit-flex', 'flex' ] }
    // to represent "fallback" declarations
    // { display: -webkit-flex; display: flex; }

    if (Array.isArray(value)) {
      return value.map(function (v) {
        return prop + ":" + v;
      }).join(';');
    } else {
      return prop + ":" + value;
    }
  }) // Once properties are hyphenated, this will put the vendor
  // prefixed and short-form properties first in the list.
  .sort().join(';');
  return "{" + declarationsString + ";}";
}
/**
 * An identifier is associated with a unique set of styles.
 */


function createIdentifier(prefix, name, value) {
  var hashedString = vendor_hash(name + stringifyValueWithProperty(value, name));
  return  false ? undefined : prefix + "-" + hashedString;
}
/**
 * Create individual CSS keyframes rules.
 */


function createKeyframes(keyframes) {
  var prefixes = ['-webkit-', ''];
  var identifier = createIdentifier('r', 'animation', keyframes);
  var steps = '{' + Object.keys(keyframes).map(function (stepName) {
    var rule = keyframes[stepName];
    var block = createDeclarationBlock(rule);
    return "" + stepName + block;
  }).join('') + '}';
  var rules = prefixes.map(function (prefix) {
    return "@" + prefix + "keyframes " + identifier + steps;
  });
  return {
    identifier: identifier,
    rules: rules
  };
}
/**
 * Create CSS keyframes rules and names from a StyleSheet keyframes object.
 */


function processKeyframesValue(keyframesValue) {
  if (typeof keyframesValue === 'number') {
    throw new Error('Invalid CSS keyframes type');
  }

  var animationNames = [];
  var rules = [];
  var value = Array.isArray(keyframesValue) ? keyframesValue : [keyframesValue];
  value.forEach(function (keyframes) {
    if (typeof keyframes === 'string') {
      // Support external animation libraries (identifiers only)
      animationNames.push(keyframes);
    } else {
      // Create rules for each of the keyframes
      var _createKeyframes = createKeyframes(keyframes),
          identifier = _createKeyframes.identifier,
          keyframesRules = _createKeyframes.rules;

      animationNames.push(identifier);
      rules.push.apply(rules, keyframesRules);
    }
  });
  return {
    animationNames: animationNames,
    rules: rules
  };
}
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/initialRules.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var resets = [// minimal top-level reset
'html{-ms-text-size-adjust:100%;-webkit-text-size-adjust:100%;-webkit-tap-highlight-color:rgba(0,0,0,0);}', 'body{margin:0;}', // minimal form pseudo-element reset
'button::-moz-focus-inner,input::-moz-focus-inner{border:0;padding:0;}', 'input::-webkit-inner-spin-button,input::-webkit-outer-spin-button,' + 'input::-webkit-search-cancel-button,input::-webkit-search-decoration,' + 'input::-webkit-search-results-button,input::-webkit-search-results-decoration{display:none;}'];
/* harmony default export */ var initialRules = (resets);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/modality.js
/**
 * Adapts focus styles based on the user's active input modality (i.e., how
 * they are interacting with the UI right now).
 *
 * Focus styles are only relevant when using the keyboard to interact with the
 * page. If we only show the focus ring when relevant, we can avoid user
 * confusion without compromising accessibility.
 *
 * The script uses two heuristics to determine whether the keyboard is being used:
 *
 * 1. a keydown event occurred immediately before a focus event;
 * 2. a focus event happened on an element which requires keyboard interaction (e.g., a text field);
 *
 * This software or document includes material copied from or derived from https://github.com/WICG/focus-visible.
 * Copyright © 2018 W3C® (MIT, ERCIM, Keio, Beihang).
 * W3C Software Notice and License: https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 * 
 */

var focusVisibleAttributeName = 'data-focusvisible-polyfill';
var modality_rule = ":focus:not([" + focusVisibleAttributeName + "]){outline: none;}";

var modality_modality = function modality(insertRule) {
  insertRule(modality_rule);

  if (!ExecutionEnvironment["canUseDOM"]) {
    return;
  }

  var hadKeyboardEvent = true;
  var hadFocusVisibleRecently = false;
  var hadFocusVisibleRecentlyTimeout = null;
  var inputTypesWhitelist = {
    text: true,
    search: true,
    url: true,
    tel: true,
    email: true,
    password: true,
    number: true,
    date: true,
    month: true,
    week: true,
    time: true,
    datetime: true,
    'datetime-local': true
  };
  /**
   * Helper function for legacy browsers and iframes which sometimes focus
   * elements like document, body, and non-interactive SVG.
   */

  function isValidFocusTarget(el) {
    if (el && el !== document && el.nodeName !== 'HTML' && el.nodeName !== 'BODY' && 'classList' in el && 'contains' in el.classList) {
      return true;
    }

    return false;
  }
  /**
   * Computes whether the given element should automatically trigger the
   * `focus-visible` attribute being added, i.e. whether it should always match
   * `:focus-visible` when focused.
   */


  function focusTriggersKeyboardModality(el) {
    var type = el.type;
    var tagName = el.tagName;
    var isReadOnly = el.readOnly;

    if (tagName === 'INPUT' && inputTypesWhitelist[type] && !isReadOnly) {
      return true;
    }

    if (tagName === 'TEXTAREA' && !isReadOnly) {
      return true;
    }

    if (el.isContentEditable) {
      return true;
    }

    return false;
  }
  /**
   * Add the `focus-visible` attribute to the given element if it was not added by
   * the author.
   */


  function addFocusVisibleAttribute(el) {
    if (el.hasAttribute(focusVisibleAttributeName)) {
      return;
    }

    el.setAttribute(focusVisibleAttributeName, true);
  }
  /**
   * Remove the `focus-visible` attribute from the given element if it was not
   * originally added by the author.
   */


  function removeFocusVisibleAttribute(el) {
    el.removeAttribute(focusVisibleAttributeName);
  }
  /**
   * Remove the `focus-visible` attribute from all elements in the document.
   */


  function removeAllFocusVisibleAttributes() {
    var list = document.querySelectorAll("[" + focusVisibleAttributeName + "]");

    for (var i = 0; i < list.length; i += 1) {
      removeFocusVisibleAttribute(list[i]);
    }
  }
  /**
   * Treat `keydown` as a signal that the user is in keyboard modality.
   * Apply `focus-visible` to any current active element and keep track
   * of our keyboard modality state with `hadKeyboardEvent`.
   */


  function onKeyDown(e) {
    if (e.key !== 'Tab' && (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey)) {
      return;
    }

    if (isValidFocusTarget(document.activeElement)) {
      addFocusVisibleAttribute(document.activeElement);
    }

    hadKeyboardEvent = true;
  }
  /**
   * If at any point a user clicks with a pointing device, ensure that we change
   * the modality away from keyboard.
   * This avoids the situation where a user presses a key on an already focused
   * element, and then clicks on a different element, focusing it with a
   * pointing device, while we still think we're in keyboard modality.
   * It also avoids the situation where a user presses on an element within a
   * previously keyboard-focused element (i.e., `e.target` is not the previously
   * focused element, but one of its descendants) and we need to remove the
   * focus ring because a `blur` event doesn't occur.
   */


  function onPointerDown(e) {
    if (hadKeyboardEvent === true) {
      removeAllFocusVisibleAttributes();
    }

    hadKeyboardEvent = false;
  }
  /**
   * On `focus`, add the `focus-visible` attribute to the target if:
   * - the target received focus as a result of keyboard navigation, or
   * - the event target is an element that will likely require interaction
   *   via the keyboard (e.g. a text box)
   */


  function onFocus(e) {
    // Prevent IE from focusing the document or HTML element.
    if (!isValidFocusTarget(e.target)) {
      return;
    }

    if (hadKeyboardEvent || focusTriggersKeyboardModality(e.target)) {
      addFocusVisibleAttribute(e.target);
    }
  }
  /**
   * On `blur`, remove the `focus-visible` attribute from the target.
   */


  function onBlur(e) {
    if (!isValidFocusTarget(e.target)) {
      return;
    }

    if (e.target.hasAttribute(focusVisibleAttributeName)) {
      // To detect a tab/window switch, we look for a blur event followed
      // rapidly by a visibility change.
      // If we don't see a visibility change within 100ms, it's probably a
      // regular focus change.
      hadFocusVisibleRecently = true;
      window.clearTimeout(hadFocusVisibleRecentlyTimeout);
      hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
        hadFocusVisibleRecently = false;
        window.clearTimeout(hadFocusVisibleRecentlyTimeout);
      }, 100);
      removeFocusVisibleAttribute(e.target);
    }
  }
  /**
   * If the user changes tabs, keep track of whether or not the previously
   * focused element had the focus-visible attribute.
   */


  function onVisibilityChange(e) {
    if (document.visibilityState === 'hidden') {
      // If the tab becomes active again, the browser will handle calling focus
      // on the element (Safari actually calls it twice).
      // If this tab change caused a blur on an element with focus-visible,
      // re-apply the attribute when the user switches back to the tab.
      if (hadFocusVisibleRecently) {
        hadKeyboardEvent = true;
      }

      addInitialPointerMoveListeners();
    }
  }
  /**
   * Add a group of listeners to detect usage of any pointing devices.
   * These listeners will be added when the polyfill first loads, and anytime
   * the window is blurred, so that they are active when the window regains
   * focus.
   */


  function addInitialPointerMoveListeners() {
    document.addEventListener('mousemove', onInitialPointerMove);
    document.addEventListener('mousedown', onInitialPointerMove);
    document.addEventListener('mouseup', onInitialPointerMove);
    document.addEventListener('pointermove', onInitialPointerMove);
    document.addEventListener('pointerdown', onInitialPointerMove);
    document.addEventListener('pointerup', onInitialPointerMove);
    document.addEventListener('touchmove', onInitialPointerMove);
    document.addEventListener('touchstart', onInitialPointerMove);
    document.addEventListener('touchend', onInitialPointerMove);
  }

  function removeInitialPointerMoveListeners() {
    document.removeEventListener('mousemove', onInitialPointerMove);
    document.removeEventListener('mousedown', onInitialPointerMove);
    document.removeEventListener('mouseup', onInitialPointerMove);
    document.removeEventListener('pointermove', onInitialPointerMove);
    document.removeEventListener('pointerdown', onInitialPointerMove);
    document.removeEventListener('pointerup', onInitialPointerMove);
    document.removeEventListener('touchmove', onInitialPointerMove);
    document.removeEventListener('touchstart', onInitialPointerMove);
    document.removeEventListener('touchend', onInitialPointerMove);
  }
  /**
   * When the polfyill first loads, assume the user is in keyboard modality.
   * If any event is received from a pointing device (e.g. mouse, pointer,
   * touch), turn off keyboard modality.
   * This accounts for situations where focus enters the page from the URL bar.
   */


  function onInitialPointerMove(e) {
    // Work around a Safari quirk that fires a mousemove on <html> whenever the
    // window blurs, even if you're tabbing out of the page. ¯\_(ツ)_/¯
    if (e.target.nodeName === 'HTML') {
      return;
    }

    hadKeyboardEvent = false;
    removeInitialPointerMoveListeners();
  }

  document.addEventListener('keydown', onKeyDown, true);
  document.addEventListener('mousedown', onPointerDown, true);
  document.addEventListener('pointerdown', onPointerDown, true);
  document.addEventListener('touchstart', onPointerDown, true);
  document.addEventListener('focus', onFocus, true);
  document.addEventListener('blur', onBlur, true);
  document.addEventListener('visibilitychange', onVisibilityChange, true);
  addInitialPointerMoveListeners();
};

/* harmony default export */ var StyleSheet_modality = (modality_modality);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/createStyleResolver.js
function createStyleResolver_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { createStyleResolver_defineProperty(target, key, source[key]); }); } return target; }

function createStyleResolver_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * WARNING: changes to this file in particular can cause significant changes to
 * the results of render performance benchmarks.
 */












var createStyleResolver_emptyObject = {};
function createStyleResolver() {
  var inserted, sheet, lookup;
  var resolved = {
    css: {},
    ltr: {},
    rtl: {},
    rtlNoSwap: {}
  };

  var init = function init() {
    inserted = {
      css: {},
      ltr: {},
      rtl: {},
      rtlNoSwap: {}
    };
    sheet = createOrderedCSSStyleSheet(createCSSStyleSheet(STYLE_ELEMENT_ID));
    lookup = {
      byClassName: {},
      byProp: {}
    };
    StyleSheet_modality(function (rule) {
      return sheet.insert(rule, STYLE_GROUPS.modality);
    });
    initialRules.forEach(function (rule) {
      sheet.insert(rule, STYLE_GROUPS.reset);
    });
  };

  init();

  function addToLookup(className, prop, value) {
    if (!lookup.byProp[prop]) {
      lookup.byProp[prop] = {};
    }

    lookup.byProp[prop][value] = className;
    lookup.byClassName[className] = {
      prop: prop,
      value: value
    };
  }

  function getClassName(prop, value) {
    var val = stringifyValueWithProperty(value, prop);
    var cache = lookup.byProp;
    return cache[prop] && cache[prop].hasOwnProperty(val) && cache[prop][val];
  }

  function _injectRegisteredStyle(id) {
    var doLeftAndRightSwapInRTL = exports_I18nManager.doLeftAndRightSwapInRTL,
        isRTL = exports_I18nManager.isRTL;
    var dir = isRTL ? doLeftAndRightSwapInRTL ? 'rtl' : 'rtlNoSwap' : 'ltr';

    if (!inserted[dir][id]) {
      var style = StyleSheet_createCompileableStyle(StyleSheet_i18nStyle(StyleSheet_flattenStyle(id)));
      var results = atomic(style);
      Object.keys(results).forEach(function (key) {
        var _results$key = results[key],
            identifier = _results$key.identifier,
            property = _results$key.property,
            rules = _results$key.rules,
            value = _results$key.value;
        addToLookup(identifier, property, value);
        rules.forEach(function (rule) {
          var group = STYLE_GROUPS.custom[property] || STYLE_GROUPS.atomic;
          sheet.insert(rule, group);
        });
      });
      inserted[dir][id] = true;
    }
  }
  /**
   * Resolves a React Native style object to DOM attributes
   */


  function resolve(style, classList) {
    var nextClassList = [];
    var props = {};

    if (!style && !classList) {
      return props;
    }

    if (Array.isArray(classList)) {
      modules_flattenArray(classList).forEach(function (identifier) {
        if (identifier) {
          if (inserted.css[identifier] == null && resolved.css[identifier] != null) {
            var item = resolved.css[identifier];
            item.rules.forEach(function (rule) {
              sheet.insert(rule, item.group);
            });
            inserted.css[identifier] = true;
          }

          nextClassList.push(identifier);
        }
      });
    }

    if (typeof style === 'number') {
      // fast and cachable
      _injectRegisteredStyle(style);

      var key = createCacheKey(style);
      props = _resolveStyle(style, key);
    } else if (!Array.isArray(style)) {
      // resolve a plain RN style object
      props = _resolveStyle(style);
    } else {
      // flatten the style array
      // cache resolved props when all styles are registered
      // otherwise fallback to resolving
      var flatArray = modules_flattenArray(style);
      var isArrayOfNumbers = true;
      var cacheKey = '';

      for (var i = 0; i < flatArray.length; i++) {
        var id = flatArray[i];

        if (typeof id !== 'number') {
          isArrayOfNumbers = false;
        } else {
          if (isArrayOfNumbers) {
            cacheKey += id + '-';
          }

          _injectRegisteredStyle(id);
        }
      }

      var _key = isArrayOfNumbers ? createCacheKey(cacheKey) : null;

      props = _resolveStyle(flatArray, _key);
    }

    nextClassList.push.apply(nextClassList, props.classList);
    var finalProps = {
      className: classListToString(nextClassList),
      classList: nextClassList
    };

    if (props.style) {
      finalProps.style = props.style;
    }

    return finalProps;
  }
  /**
   * Resolves a React Native style object to DOM attributes, accounting for
   * the existing styles applied to the DOM node.
   *
   * To determine the next style, some of the existing DOM state must be
   * converted back into React Native styles.
   */


  function resolveWithNode(rnStyleNext, node) {
    function getDeclaration(className) {
      return lookup.byClassName[className] || createStyleResolver_emptyObject;
    }

    var _getDOMStyleInfo = getDOMStyleInfo(node),
        rdomClassList = _getDOMStyleInfo.classList,
        rdomStyle = _getDOMStyleInfo.style; // Convert the DOM classList back into a React Native form
    // Preserves unrecognized class names.


    var _rdomClassList$reduce = rdomClassList.reduce(function (styleProps, className) {
      var _getDeclaration = getDeclaration(className),
          prop = _getDeclaration.prop,
          value = _getDeclaration.value;

      if (prop) {
        styleProps.style[prop] = value;
      } else {
        styleProps.classList.push(className);
      }

      return styleProps;
    }, {
      classList: [],
      style: {}
    }),
        rnClassList = _rdomClassList$reduce.classList,
        rnStyle = _rdomClassList$reduce.style; // Create next DOM style props from current and next RN styles


    var _resolve = resolve([StyleSheet_i18nStyle(rnStyle), rnStyleNext]),
        rdomClassListNext = _resolve.classList,
        rdomStyleNext = _resolve.style; // Final className
    // Add the current class names not managed by React Native


    var className = classListToString(rdomClassListNext.concat(rnClassList)); // Final style
    // Next class names take priority over current inline styles

    var style = createStyleResolver_objectSpread({}, rdomStyle);

    rdomClassListNext.forEach(function (className) {
      var _getDeclaration2 = getDeclaration(className),
          prop = _getDeclaration2.prop;

      if (style[prop]) {
        style[prop] = '';
      }
    }); // Next inline styles take priority over current inline styles

    Object.assign(style, rdomStyleNext);
    return {
      className: className,
      style: style
    };
  }
  /**
   * Resolves a React Native style object
   */


  function _resolveStyle(style, key) {
    var doLeftAndRightSwapInRTL = exports_I18nManager.doLeftAndRightSwapInRTL,
        isRTL = exports_I18nManager.isRTL;
    var dir = isRTL ? doLeftAndRightSwapInRTL ? 'rtl' : 'rtlNoSwap' : 'ltr'; // faster: memoized

    if (key != null && resolved[dir][key] != null) {
      return resolved[dir][key];
    }

    var flatStyle = StyleSheet_flattenStyle(style);
    var localizedStyle = StyleSheet_createCompileableStyle(StyleSheet_i18nStyle(flatStyle)); // slower: convert style object to props and cache

    var props = Object.keys(localizedStyle).sort().reduce(function (props, styleProp) {
      var value = localizedStyle[styleProp];

      if (value != null) {
        var className = getClassName(styleProp, value);

        if (className) {
          props.classList.push(className);
        } else {
          // Certain properties and values are not transformed by 'createReactDOMStyle' as they
          // require more complex transforms into multiple CSS rules. Here we assume that StyleManager
          // can bind these styles to a className, and prevent them becoming invalid inline-styles.
          if (styleProp === 'animationKeyframes' || styleProp === 'placeholderTextColor' || styleProp === 'pointerEvents' || styleProp === 'scrollbarWidth') {
            var _atomic;

            var a = atomic((_atomic = {}, _atomic[styleProp] = value, _atomic));
            Object.values(a).forEach(function (_ref) {
              var identifier = _ref.identifier,
                  rules = _ref.rules;
              props.classList.push(identifier);
              rules.forEach(function (rule) {
                sheet.insert(rule, STYLE_GROUPS.atomic);
              });
            });
          } else {
            if (!props.style) {
              props.style = {};
            } // 4x slower render


            props.style[styleProp] = value;
          }
        }
      }

      return props;
    }, {
      classList: []
    });

    if (props.style) {
      props.style = inline(props.style);
    }

    if (key != null) {
      resolved[dir][key] = props;
    }

    return props;
  }

  return {
    getStyleSheet: function getStyleSheet() {
      var textContent = sheet.getTextContent(); // Reset state on the server so critical css is always the result

      if (!ExecutionEnvironment["canUseDOM"]) {
        init();
      }

      return {
        id: STYLE_ELEMENT_ID,
        textContent: textContent
      };
    },
    createCSS: function createCSS(rules, group) {
      var result = {};
      Object.keys(rules).forEach(function (name) {
        var style = rules[name];
        var compiled = classic(style, name);
        Object.values(compiled).forEach(function (_ref2) {
          var identifier = _ref2.identifier,
              rules = _ref2.rules;
          resolved.css[identifier] = {
            group: group || STYLE_GROUPS.classic,
            rules: rules
          };
          result[name] = identifier;
        });
      });
      return result;
    },
    resolve: resolve,
    sheet: sheet,
    resolveWithNode: resolveWithNode
  };
}
/**
 * Misc helpers
 */

var createCacheKey = function createCacheKey(id) {
  var prefix = 'rn';
  return prefix + "-" + id;
};

var classListToString = function classListToString(list) {
  return list.join(' ').trim();
};
/**
 * Copies classList and style data from a DOM node
 */


var hyphenPattern = /-([a-z])/g;

var toCamelCase = function toCamelCase(str) {
  return str.replace(hyphenPattern, function (m) {
    return m[1].toUpperCase();
  });
};

var getDOMStyleInfo = function getDOMStyleInfo(node) {
  var nodeStyle = node.style;
  var classList = Array.prototype.slice.call(node.classList);
  var style = {}; // DOM style is a CSSStyleDeclaration
  // https://developer.mozilla.org/en-US/docs/Web/API/CSSStyleDeclaration

  for (var i = 0; i < nodeStyle.length; i += 1) {
    var property = nodeStyle.item(i);

    if (property) {
      // DOM style uses hyphenated prop names and may include vendor prefixes
      // Transform back into React DOM style.
      style[toCamelCase(property)] = nodeStyle.getPropertyValue(property);
    }
  }

  return {
    classList: classList,
    style: style
  };
};
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/styleResolver.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var styleResolver_styleResolver = createStyleResolver();
/* harmony default export */ var StyleSheet_styleResolver = (styleResolver_styleResolver);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/css.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * A simple (and dangerous) CSS system.
 * The order of CSS rule insertion is not guaranteed.
 * Avoiding combining 2 or more classes that modify the same property.
 */

var css = {
  /**
   * const classes = css.create({ base: {}, extra: {} })
   */
  create: function create(rules, group) {
    return StyleSheet_styleResolver.createCSS(rules, group);
  }
};
/* harmony default export */ var StyleSheet_css = (css);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/StyleSheet.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var absoluteFillObject = {
  position: 'absolute',
  left: 0,
  right: 0,
  top: 0,
  bottom: 0
};
var absoluteFill = ReactNativePropRegistry.register(absoluteFillObject);
var StyleSheet = {
  absoluteFill: absoluteFill,
  absoluteFillObject: absoluteFillObject,
  compose: function compose(style1, style2) {
    if (false) { var readableStyles, len; }

    if (style1 && style2) {
      return [style1, style2];
    } else {
      return style1 || style2;
    }
  },
  create: function create(styles) {
    var result = {};
    Object.keys(styles).forEach(function (key) {
      if (false) { var interopValidate, validate; }

      var id = styles[key] && ReactNativePropRegistry.register(styles[key]);
      result[key] = id;
    });
    return result;
  },
  flatten: StyleSheet_flattenStyle,
  hairlineWidth: 1
};
/* harmony default export */ var StyleSheet_StyleSheet = (StyleSheet);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StyleSheet/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

 // allow original component styles to be inspected in React Dev Tools

if (ExecutionEnvironment["canUseDOM"] && window.__REACT_DEVTOOLS_GLOBAL_HOOK__) {
  window.__REACT_DEVTOOLS_GLOBAL_HOOK__.resolveRNStyle = StyleSheet_StyleSheet.flatten;
}

/* harmony default export */ var exports_StyleSheet = (StyleSheet_StyleSheet);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/createDOMProps/index.js
function createDOMProps_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */





var createDOMProps_emptyObject = {}; // Reset styles for heading, link, and list DOM elements

var classes = StyleSheet_css.create({
  reset: {
    backgroundColor: 'transparent',
    color: 'inherit',
    font: 'inherit',
    listStyle: 'none',
    margin: 0,
    textAlign: 'inherit',
    textDecoration: 'none'
  },
  cursor: {
    cursor: 'pointer'
  }
}, STYLE_GROUPS.classicReset);
var pointerEventsStyles = exports_StyleSheet.create({
  auto: {
    pointerEvents: 'auto'
  },
  'box-none': {
    pointerEvents: 'box-none'
  },
  'box-only': {
    pointerEvents: 'box-only'
  },
  none: {
    pointerEvents: 'none'
  }
});

var createDOMProps_defaultStyleResolver = function defaultStyleResolver(style, classList) {
  return StyleSheet_styleResolver.resolve(style, classList);
};

var createDOMProps_createDOMProps = function createDOMProps(component, props, styleResolver) {
  if (!styleResolver) {
    styleResolver = createDOMProps_defaultStyleResolver;
  }

  if (!props) {
    props = createDOMProps_emptyObject;
  }

  var _props = props,
      accessibilityLabel = _props.accessibilityLabel,
      accessibilityLiveRegion = _props.accessibilityLiveRegion,
      accessibilityStates = _props.accessibilityStates,
      classList = _props.classList,
      deprecatedClassName = _props.className,
      importantForAccessibility = _props.importantForAccessibility,
      nativeID = _props.nativeID,
      placeholderTextColor = _props.placeholderTextColor,
      pointerEvents = _props.pointerEvents,
      providedStyle = _props.style,
      testID = _props.testID,
      accessible = _props.accessible,
      accessibilityComponentType = _props.accessibilityComponentType,
      accessibilityRole = _props.accessibilityRole,
      accessibilityTraits = _props.accessibilityTraits,
      domProps = createDOMProps_objectWithoutPropertiesLoose(_props, ["accessibilityLabel", "accessibilityLiveRegion", "accessibilityStates", "classList", "className", "importantForAccessibility", "nativeID", "placeholderTextColor", "pointerEvents", "style", "testID", "accessible", "accessibilityComponentType", "accessibilityRole", "accessibilityTraits"]);

  var disabled = modules_AccessibilityUtil.isDisabled(props);
  var role = modules_AccessibilityUtil.propsToAriaRole(props); // GENERAL ACCESSIBILITY

  if (importantForAccessibility === 'no-hide-descendants') {
    domProps['aria-hidden'] = true;
  }

  if (accessibilityLabel && accessibilityLabel.constructor === String) {
    domProps['aria-label'] = accessibilityLabel;
  }

  if (accessibilityLiveRegion && accessibilityLiveRegion.constructor === String) {
    domProps['aria-live'] = accessibilityLiveRegion === 'none' ? 'off' : accessibilityLiveRegion;
  }

  if (Array.isArray(accessibilityStates)) {
    for (var i = 0; i < accessibilityStates.length; i += 1) {
      domProps["aria-" + accessibilityStates[i]] = true;
    }
  }

  if (role && role.constructor === String) {
    domProps.role = role;
  } // DISABLED


  if (disabled) {
    domProps['aria-disabled'] = disabled;
    domProps.disabled = disabled;
  } // FOCUS
  // Assume that 'link' is focusable by default (uses <a>).
  // Assume that 'button' is not (uses <div role='button'>) but must be treated as such.


  var focusable = !disabled && importantForAccessibility !== 'no' && importantForAccessibility !== 'no-hide-descendants';

  if (role === 'link' || component === 'a' || component === 'button' || component === 'input' || component === 'select' || component === 'textarea') {
    if (accessible === false || !focusable) {
      domProps.tabIndex = '-1';
    } else {
      domProps['data-focusable'] = true;
    }
  } else if (modules_AccessibilityUtil.buttonLikeRoles[role] || role === 'textbox') {
    if (accessible !== false && focusable) {
      domProps['data-focusable'] = true;
      domProps.tabIndex = '0';
    }
  } else {
    if (accessible === true && focusable) {
      domProps['data-focusable'] = true;
      domProps.tabIndex = '0';
    }
  } // STYLE


  var reactNativeStyle = exports_StyleSheet.compose(pointerEvents && pointerEventsStyles[pointerEvents], exports_StyleSheet.compose(providedStyle, placeholderTextColor && {
    placeholderTextColor: placeholderTextColor
  })); // Additional style resets for interactive elements

  var needsCursor = (role === 'button' || role === 'link') && !disabled;
  var needsReset = component === 'a' || component === 'button' || component === 'li' || component === 'ul' || role === 'heading'; // Classic CSS styles

  var finalClassList = [deprecatedClassName, needsReset && classes.reset, needsCursor && classes.cursor, classList]; // Resolve styles

  var _styleResolver = styleResolver(reactNativeStyle, finalClassList),
      className = _styleResolver.className,
      style = _styleResolver.style;

  if (className != null && className !== '') {
    domProps.className = className;
  }

  if (style) {
    domProps.style = style;
  } // OTHER
  // Native element ID


  if (nativeID && nativeID.constructor === String) {
    domProps.id = nativeID;
  } // Link security
  // https://mathiasbynens.github.io/rel-noopener/
  // Note: using "noreferrer" doesn't impact referrer tracking for https
  // transfers (i.e., from https to https).


  if (component === 'a' && domProps.target === '_blank') {
    domProps.rel = (domProps.rel || '') + " noopener noreferrer";
  } // Automated test IDs


  if (testID && testID.constructor === String) {
    domProps['data-testid'] = testID;
  }

  return domProps;
};

/* harmony default export */ var modules_createDOMProps = (createDOMProps_createDOMProps);
// EXTERNAL MODULE: ./node_modules/react-dom/unstable-native-dependencies.js
var unstable_native_dependencies = __webpack_require__(48);
var unstable_native_dependencies_default = /*#__PURE__*/__webpack_require__.n(unstable_native_dependencies);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/modules/getBoundingClientRect/index.js
var getBoundingClientRect = __webpack_require__(30);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/normalizeNativeEvent/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var emptyArray = [];

var emptyFunction = function emptyFunction() {}; // Mobile Safari re-uses touch objects, so we copy the properties we want and normalize the identifier


var normalizeNativeEvent_normalizeTouches = function normalizeTouches(touches) {
  if (!touches) {
    return emptyArray;
  }

  return Array.prototype.slice.call(touches).map(function (touch) {
    var identifier = touch.identifier > 20 ? touch.identifier % 20 : touch.identifier;
    var rect;
    return {
      _normalized: true,
      clientX: touch.clientX,
      clientY: touch.clientY,
      force: touch.force,

      get locationX() {
        rect = rect || Object(getBoundingClientRect["a" /* default */])(touch.target);

        if (rect) {
          return touch.pageX - rect.left;
        }
      },

      get locationY() {
        rect = rect || Object(getBoundingClientRect["a" /* default */])(touch.target);

        if (rect) {
          return touch.pageY - rect.top;
        }
      },

      identifier: identifier,
      pageX: touch.pageX,
      pageY: touch.pageY,
      radiusX: touch.radiusX,
      radiusY: touch.radiusY,
      rotationAngle: touch.rotationAngle,
      screenX: touch.screenX,
      screenY: touch.screenY,
      target: touch.target,
      // normalize the timestamp
      // https://stackoverflow.com/questions/26177087/ios-8-mobile-safari-wrong-timestamp-on-touch-events
      timestamp: Date.now()
    };
  });
};

function normalizeTouchEvent(nativeEvent) {
  var changedTouches = normalizeNativeEvent_normalizeTouches(nativeEvent.changedTouches);
  var touches = normalizeNativeEvent_normalizeTouches(nativeEvent.touches);
  var preventDefault = typeof nativeEvent.preventDefault === 'function' ? nativeEvent.preventDefault.bind(nativeEvent) : emptyFunction;
  var stopImmediatePropagation = typeof nativeEvent.stopImmediatePropagation === 'function' ? nativeEvent.stopImmediatePropagation.bind(nativeEvent) : emptyFunction;
  var stopPropagation = typeof nativeEvent.stopPropagation === 'function' ? nativeEvent.stopPropagation.bind(nativeEvent) : emptyFunction;
  var singleChangedTouch = changedTouches[0];
  var event = {
    _normalized: true,
    bubbles: nativeEvent.bubbles,
    cancelable: nativeEvent.cancelable,
    changedTouches: changedTouches,
    defaultPrevented: nativeEvent.defaultPrevented,
    identifier: singleChangedTouch ? singleChangedTouch.identifier : undefined,

    get locationX() {
      return singleChangedTouch ? singleChangedTouch.locationX : undefined;
    },

    get locationY() {
      return singleChangedTouch ? singleChangedTouch.locationY : undefined;
    },

    pageX: singleChangedTouch ? singleChangedTouch.pageX : nativeEvent.pageX,
    pageY: singleChangedTouch ? singleChangedTouch.pageY : nativeEvent.pageY,
    preventDefault: preventDefault,
    stopImmediatePropagation: stopImmediatePropagation,
    stopPropagation: stopPropagation,
    target: nativeEvent.target,
    // normalize the timestamp
    // https://stackoverflow.com/questions/26177087/ios-8-mobile-safari-wrong-timestamp-on-touch-events
    timestamp: Date.now(),
    touches: touches,
    type: nativeEvent.type,
    which: nativeEvent.which
  };
  return event;
}

function normalizeMouseEvent(nativeEvent) {
  var rect;
  var touches = [{
    _normalized: true,
    clientX: nativeEvent.clientX,
    clientY: nativeEvent.clientY,
    force: nativeEvent.force,
    identifier: 0,

    get locationX() {
      rect = rect || Object(getBoundingClientRect["a" /* default */])(nativeEvent.target);

      if (rect) {
        return nativeEvent.pageX - rect.left;
      }
    },

    get locationY() {
      rect = rect || Object(getBoundingClientRect["a" /* default */])(nativeEvent.target);

      if (rect) {
        return nativeEvent.pageY - rect.top;
      }
    },

    pageX: nativeEvent.pageX,
    pageY: nativeEvent.pageY,
    screenX: nativeEvent.screenX,
    screenY: nativeEvent.screenY,
    target: nativeEvent.target,
    timestamp: Date.now()
  }];
  var preventDefault = typeof nativeEvent.preventDefault === 'function' ? nativeEvent.preventDefault.bind(nativeEvent) : emptyFunction;
  var stopImmediatePropagation = typeof nativeEvent.stopImmediatePropagation === 'function' ? nativeEvent.stopImmediatePropagation.bind(nativeEvent) : emptyFunction;
  var stopPropagation = typeof nativeEvent.stopPropagation === 'function' ? nativeEvent.stopPropagation.bind(nativeEvent) : emptyFunction;
  return {
    _normalized: true,
    bubbles: nativeEvent.bubbles,
    cancelable: nativeEvent.cancelable,
    changedTouches: touches,
    defaultPrevented: nativeEvent.defaultPrevented,
    identifier: touches[0].identifier,

    get locationX() {
      return touches[0].locationX;
    },

    get locationY() {
      return touches[0].locationY;
    },

    pageX: nativeEvent.pageX,
    pageY: nativeEvent.pageY,
    preventDefault: preventDefault,
    stopImmediatePropagation: stopImmediatePropagation,
    stopPropagation: stopPropagation,
    target: nativeEvent.target,
    timestamp: touches[0].timestamp,
    touches: nativeEvent.type === 'mouseup' ? emptyArray : touches,
    type: nativeEvent.type,
    which: nativeEvent.which
  };
} // TODO: how to best handle keyboard events?


function normalizeNativeEvent(nativeEvent) {
  if (!nativeEvent || nativeEvent._normalized) {
    return nativeEvent;
  }

  var eventType = nativeEvent.type || '';
  var mouse = eventType.indexOf('mouse') >= 0;

  if (mouse) {
    return normalizeMouseEvent(nativeEvent);
  } else {
    return normalizeTouchEvent(nativeEvent);
  }
}

/* harmony default export */ var modules_normalizeNativeEvent = (normalizeNativeEvent);
// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/ResponderEventPlugin/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
// based on https://github.com/facebook/react/pull/4303/files


var ResponderEventPlugin = unstable_native_dependencies_default.a.ResponderEventPlugin,
    ResponderTouchHistoryStore = unstable_native_dependencies_default.a.ResponderTouchHistoryStore; // On older versions of React (< 16.4) we have to inject the dependencies in
// order for the plugin to work properly in the browser. This version still
// uses `top*` strings to identify the internal event names.
// https://github.com/facebook/react/pull/12629

if (!ResponderEventPlugin.eventTypes.responderMove.dependencies) {
  var topMouseDown = 'topMouseDown';
  var topMouseMove = 'topMouseMove';
  var topMouseUp = 'topMouseUp';
  var topScroll = 'topScroll';
  var topSelectionChange = 'topSelectionChange';
  var topTouchCancel = 'topTouchCancel';
  var topTouchEnd = 'topTouchEnd';
  var topTouchMove = 'topTouchMove';
  var topTouchStart = 'topTouchStart';
  var endDependencies = [topTouchCancel, topTouchEnd, topMouseUp];
  var moveDependencies = [topTouchMove, topMouseMove];
  var startDependencies = [topTouchStart, topMouseDown];
  /**
   * Setup ResponderEventPlugin dependencies
   */

  ResponderEventPlugin.eventTypes.responderMove.dependencies = moveDependencies;
  ResponderEventPlugin.eventTypes.responderEnd.dependencies = endDependencies;
  ResponderEventPlugin.eventTypes.responderStart.dependencies = startDependencies;
  ResponderEventPlugin.eventTypes.responderRelease.dependencies = endDependencies;
  ResponderEventPlugin.eventTypes.responderTerminationRequest.dependencies = [];
  ResponderEventPlugin.eventTypes.responderGrant.dependencies = [];
  ResponderEventPlugin.eventTypes.responderReject.dependencies = [];
  ResponderEventPlugin.eventTypes.responderTerminate.dependencies = [];
  ResponderEventPlugin.eventTypes.moveShouldSetResponder.dependencies = moveDependencies;
  ResponderEventPlugin.eventTypes.selectionChangeShouldSetResponder.dependencies = [topSelectionChange];
  ResponderEventPlugin.eventTypes.scrollShouldSetResponder.dependencies = [topScroll];
  ResponderEventPlugin.eventTypes.startShouldSetResponder.dependencies = startDependencies;
}

var lastActiveTouchTimestamp = null; // The length of time after a touch that we ignore the browser's emulated mouse events
// https://developer.mozilla.org/en-US/docs/Web/API/Touch_events/Using_Touch_Events

var EMULATED_MOUSE_THERSHOLD_MS = 1000;
var originalExtractEvents = ResponderEventPlugin.extractEvents;

ResponderEventPlugin.extractEvents = function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
  var hasActiveTouches = ResponderTouchHistoryStore.touchHistory.numberActiveTouches > 0;
  var eventType = nativeEvent.type;
  var shouldSkipMouseAfterTouch = false;

  if (eventType.indexOf('touch') > -1) {
    lastActiveTouchTimestamp = Date.now();
  } else if (lastActiveTouchTimestamp && eventType.indexOf('mouse') > -1) {
    var now = Date.now();
    shouldSkipMouseAfterTouch = now - lastActiveTouchTimestamp < EMULATED_MOUSE_THERSHOLD_MS;
  }

  if ( // Filter out mousemove and mouseup events when a touch hasn't started yet
  (eventType === 'mousemove' || eventType === 'mouseup') && !hasActiveTouches || // Filter out events from wheel/middle and right click.
  nativeEvent.button === 1 || nativeEvent.button === 2 || // Filter out mouse events that browsers dispatch immediately after touch events end
  // Prevents the REP from calling handlers twice for touch interactions.
  // See #802 and #932.
  shouldSkipMouseAfterTouch) {
    return;
  }

  var normalizedEvent = modules_normalizeNativeEvent(nativeEvent);
  return originalExtractEvents.call(ResponderEventPlugin, topLevelType, targetInst, normalizedEvent, nativeEventTarget);
};

/* harmony default export */ var modules_ResponderEventPlugin = (ResponderEventPlugin);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/createElement/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */






Object(unstable_native_dependencies["injectEventPluginsByName"])({
  ResponderEventPlugin: modules_ResponderEventPlugin
});

var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
/**
 * Ensure event handlers receive an event of the expected shape. The 'button'
 * role – for accessibility reasons and functional equivalence to the native
 * button element – must also support synthetic keyboard activation of onclick,
 * and remove event handlers when disabled.
 */


var eventHandlerNames = {
  onBlur: true,
  onClick: true,
  onClickCapture: true,
  onContextMenu: true,
  onFocus: true,
  onResponderRelease: true,
  onTouchCancel: true,
  onTouchCancelCapture: true,
  onTouchEnd: true,
  onTouchEndCapture: true,
  onTouchMove: true,
  onTouchMoveCapture: true,
  onTouchStart: true,
  onTouchStartCapture: true
};

var createElement_adjustProps = function adjustProps(domProps) {
  var onClick = domProps.onClick,
      onResponderRelease = domProps.onResponderRelease,
      role = domProps.role;
  var isButtonLikeRole = modules_AccessibilityUtil.buttonLikeRoles[role];
  var isDisabled = modules_AccessibilityUtil.isDisabled(domProps);
  var isLinkRole = role === 'link';
  Object.keys(domProps).forEach(function (propName) {
    var prop = domProps[propName];
    var isEventHandler = typeof prop === 'function' && eventHandlerNames[propName];

    if (isEventHandler) {
      if (isButtonLikeRole && isDisabled) {
        domProps[propName] = undefined;
      } else {
        // TODO: move this out of the render path
        domProps[propName] = function (e) {
          e.nativeEvent = modules_normalizeNativeEvent(e.nativeEvent);
          return prop(e);
        };
      }
    }
  }); // Cancel click events if the responder system is being used on a link
  // element. Click events are not an expected part of the React Native API,
  // and browsers dispatch click events that cannot otherwise be cancelled from
  // preceding mouse events in the responder system.

  if (isLinkRole && onResponderRelease) {
    domProps.onClick = function (e) {
      if (!e.isDefaultPrevented() && !isModifiedEvent(e.nativeEvent) && !domProps.target) {
        e.preventDefault();
      }
    };
  } // Button-like roles should trigger 'onClick' if SPACE or ENTER keys are pressed.


  if (isButtonLikeRole && !isDisabled) {
    domProps.onKeyPress = function (e) {
      if (!e.isDefaultPrevented() && (e.which === 13 || e.which === 32)) {
        e.preventDefault();

        if (onClick) {
          onClick(e);
        }
      }
    };
  }
};

var createElement_createElement = function createElement(component, props) {
  // use equivalent platform elements where possible
  var accessibilityComponent;

  if (component && component.constructor === String) {
    accessibilityComponent = modules_AccessibilityUtil.propsToAccessibilityComponent(props);
  }

  var Component = accessibilityComponent || component;
  var domProps = modules_createDOMProps(Component, props);
  createElement_adjustProps(domProps);

  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  return external_react_default.a.createElement.apply(external_react_default.a, [Component, domProps].concat(children));
};

/* harmony default export */ var exports_createElement = (createElement_createElement);
// EXTERNAL MODULE: external "react-dom"
var external_react_dom_ = __webpack_require__(23);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/findNodeHandle/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var findNodeHandle_findNodeHandle = function findNodeHandle(component) {
  var node;

  try {
    node = Object(external_react_dom_["findDOMNode"])(component);
  } catch (e) {}

  return node;
};

/* harmony default export */ var exports_findNodeHandle = (findNodeHandle_findNodeHandle);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/render/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var exports_render = (external_react_dom_["render"]);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/unmountComponentAtNode/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var unmountComponentAtNode = (external_react_dom_["unmountComponentAtNode"]);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/NativeModules/index.js
var NativeModules = __webpack_require__(35);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/createStrictShapeTypeChecker/index.js
function createStrictShapeTypeChecker_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { createStrictShapeTypeChecker_defineProperty(target, key, source[key]); }); } return target; }

function createStrictShapeTypeChecker_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


function createStrictShapeTypeChecker(shapeTypes) {
  function checkType(isRequired, props, propName, componentName, location) {
    if (!props[propName]) {
      if (isRequired) {
        invariant_default()(false, "Required object `" + propName + "` was not specified in `" + componentName + "`.");
      }

      return;
    }

    var propValue = props[propName];
    var propType = typeof propValue;
    var locationName = location || '(unknown)';

    if (propType !== 'object') {
      invariant_default()(false, "Invalid " + locationName + " `" + propName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `object`."));
    } // We need to check all keys in case some are required but missing from
    // props.


    var allKeys = createStrictShapeTypeChecker_objectSpread({}, props[propName], shapeTypes);

    for (var _len = arguments.length, rest = new Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
      rest[_key - 5] = arguments[_key];
    }

    for (var _key2 in allKeys) {
      var checker = shapeTypes[_key2];

      if (!checker) {
        invariant_default()(false, "Invalid props." + propName + " key `" + _key2 + "` supplied to `" + componentName + "`." + '\nBad object: ' + JSON.stringify(props[propName], null, '  ') + '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  '));
      }

      var error = checker.apply(void 0, [propValue, _key2, componentName, location].concat(rest));

      if (error) {
        invariant_default()(false, error.message + '\nBad object: ' + JSON.stringify(props[propName], null, '  '));
      }
    }
  }

  function chainedCheckType(props, propName, componentName, location) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 4 ? _len2 - 4 : 0), _key3 = 4; _key3 < _len2; _key3++) {
      rest[_key3 - 4] = arguments[_key3];
    }

    return checkType.apply(void 0, [false, props, propName, componentName, location].concat(rest));
  }

  chainedCheckType.isRequired = checkType.bind(null, true);
  return chainedCheckType;
}

/* harmony default export */ var modules_createStrictShapeTypeChecker = (createStrictShapeTypeChecker);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/StyleSheetPropType/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



function StyleSheetPropType(shape) {
  var shapePropType = modules_createStrictShapeTypeChecker(shape);
  return function (props, propName, componentName, location) {
    var newProps = props;

    if (props[propName]) {
      // Just make a dummy prop object with only the flattened style
      newProps = {};
      var flatStyle = exports_StyleSheet.flatten(props[propName]); // Remove custom properties from check

      var nextStyle = Object.keys(flatStyle).reduce(function (acc, curr) {
        if (curr.indexOf('--') !== 0) {
          acc[curr] = flatStyle[curr];
        }

        return acc;
      }, {});
      newProps[propName] = nextStyle;
    }

    for (var _len = arguments.length, rest = new Array(_len > 4 ? _len - 4 : 0), _key = 4; _key < _len; _key++) {
      rest[_key - 4] = arguments[_key];
    }

    return shapePropType.apply(void 0, [newProps, propName, componentName, location].concat(rest));
  };
}

/* harmony default export */ var modules_StyleSheetPropType = (StyleSheetPropType);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/ColorPropType/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var ColorPropType_colorPropType = function colorPropType(isRequired, props, propName, componentName, location, propFullName) {
  var color = props[propName];

  if (color === undefined || color === null) {
    if (isRequired) {
      return new Error('Required ' + location + ' `' + (propFullName || propName) + '` was not specified in `' + componentName + '`.');
    }

    return;
  }

  if (typeof color === 'number') {
    // Developers should not use a number, but we are using the prop type
    // both for user provided colors and for transformed ones. This isn't ideal
    // and should be fixed but will do for now...
    return;
  }

  if (modules_normalizeColor(color) === null) {
    return new Error('Invalid ' + location + ' `' + (propFullName || propName) + '` supplied to `' + componentName + '`: ' + color + '\n' + "Valid color formats are\n  - '#f0f' (#rgb)\n  - '#f0fc' (#rgba)\n  - '#ff00ff' (#rrggbb)\n  - '#ff00ff00' (#rrggbbaa)\n  - 'rgb(255, 255, 255)'\n  - 'rgba(255, 255, 255, 1.0)'\n  - 'hsl(360, 100%, 100%)'\n  - 'hsla(360, 100%, 100%, 1.0)'\n  - 'transparent'\n  - 'red'\n  - 0xff00ff00 (0xrrggbbaa)\n");
  }
};

var ColorPropType;

if (false) {} else {
  ColorPropType = function ColorPropType() {};
}

/* harmony default export */ var exports_ColorPropType = (ColorPropType);
// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/AnimationPropTypes/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var animationDirectionEnum = ['alternate', 'alternate-reverse', 'normal', 'reverse'];
var animationFillModeEnum = ['none', 'forwards', 'backwards', 'both'];
var animationPlayStateEnum = ['paused', 'running'];
var AnimationPropTypes = {
  animationDelay: Object(external_prop_types_["oneOfType"])([external_prop_types_["string"], Object(external_prop_types_["arrayOf"])(external_prop_types_["string"])]),
  animationDirection: Object(external_prop_types_["oneOfType"])([Object(external_prop_types_["oneOf"])(animationDirectionEnum), Object(external_prop_types_["arrayOf"])(animationDirectionEnum)]),
  animationDuration: Object(external_prop_types_["oneOfType"])([external_prop_types_["string"], Object(external_prop_types_["arrayOf"])(external_prop_types_["string"])]),
  animationFillMode: Object(external_prop_types_["oneOfType"])([Object(external_prop_types_["oneOf"])(animationFillModeEnum), Object(external_prop_types_["arrayOf"])(animationFillModeEnum)]),
  animationIterationCount: Object(external_prop_types_["oneOfType"])([external_prop_types_["number"], Object(external_prop_types_["oneOf"])(['infinite']), Object(external_prop_types_["arrayOf"])(Object(external_prop_types_["oneOfType"])([external_prop_types_["number"], Object(external_prop_types_["oneOf"])(['infinite'])]))]),
  animationKeyframes: Object(external_prop_types_["oneOfType"])([external_prop_types_["string"], external_prop_types_["object"], Object(external_prop_types_["arrayOf"])(Object(external_prop_types_["oneOfType"])([external_prop_types_["string"], external_prop_types_["object"]]))]),
  animationPlayState: Object(external_prop_types_["oneOfType"])([Object(external_prop_types_["oneOf"])(animationPlayStateEnum), Object(external_prop_types_["arrayOf"])(animationPlayStateEnum)]),
  animationTimingFunction: Object(external_prop_types_["oneOfType"])([external_prop_types_["string"], Object(external_prop_types_["arrayOf"])(external_prop_types_["string"])]),
  transitionDelay: Object(external_prop_types_["oneOfType"])([external_prop_types_["string"], Object(external_prop_types_["arrayOf"])(external_prop_types_["string"])]),
  transitionDuration: Object(external_prop_types_["oneOfType"])([external_prop_types_["string"], Object(external_prop_types_["arrayOf"])(external_prop_types_["string"])]),
  transitionProperty: Object(external_prop_types_["oneOfType"])([external_prop_types_["string"], Object(external_prop_types_["arrayOf"])(external_prop_types_["string"])]),
  transitionTimingFunction: Object(external_prop_types_["oneOfType"])([external_prop_types_["string"], Object(external_prop_types_["arrayOf"])(external_prop_types_["string"])])
};
/* harmony default export */ var modules_AnimationPropTypes = (AnimationPropTypes);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/BorderPropTypes/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var numberOrString = Object(external_prop_types_["oneOfType"])([external_prop_types_["number"], external_prop_types_["string"]]);
var BorderStylePropType = Object(external_prop_types_["oneOf"])(['solid', 'dotted', 'dashed']);
var BorderPropTypes = {
  borderColor: exports_ColorPropType,
  borderBottomColor: exports_ColorPropType,
  borderEndColor: exports_ColorPropType,
  borderLeftColor: exports_ColorPropType,
  borderRightColor: exports_ColorPropType,
  borderStartColor: exports_ColorPropType,
  borderTopColor: exports_ColorPropType,
  borderRadius: numberOrString,
  borderBottomEndRadius: numberOrString,
  borderBottomLeftRadius: numberOrString,
  borderBottomRightRadius: numberOrString,
  borderBottomStartRadius: numberOrString,
  borderTopEndRadius: numberOrString,
  borderTopLeftRadius: numberOrString,
  borderTopRightRadius: numberOrString,
  borderTopStartRadius: numberOrString,
  borderStyle: BorderStylePropType,
  borderBottomStyle: BorderStylePropType,
  borderEndStyle: BorderStylePropType,
  borderLeftStyle: BorderStylePropType,
  borderRightStyle: BorderStylePropType,
  borderStartStyle: BorderStylePropType,
  borderTopStyle: BorderStylePropType
};
/* harmony default export */ var modules_BorderPropTypes = (BorderPropTypes);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/InteractionPropTypes/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var cursorEnum = ['auto', 'default', 'none', 'context-menu', 'help', 'pointer', 'progress', 'wait', 'cell', 'crosshair', 'text', 'vertical-text', 'alias', 'copy', 'move', 'no-drop', 'not-allowed', 'e-resize', 'n-resize', 'ne-resize', 'nw-resize', 's-resize', 'se-resize', 'sw-resize', 'w-resize', 'ew-resize', 'ns-resize', 'nesw-resize', 'nwse-resize', 'col-resize', 'row-resize', 'all-scroll', 'zoom-in', 'zoom-out', 'grab', 'grabbing '];
var touchActionEnum = ['auto', 'inherit', 'manipulation', 'none', 'pan-down', 'pan-left', 'pan-right', 'pan-up', 'pan-x', 'pan-y', 'pinch-zoom'];
var userSelectEnum = ['auto', 'text', 'none', 'contain', 'all'];
var InteractionPropTypes = {
  // https://developer.mozilla.org/en-US/docs/Web/CSS/cursor#Formal_syntax
  cursor: Object(external_prop_types_["oneOfType"])([external_prop_types_["string"], Object(external_prop_types_["oneOf"])(cursorEnum)]),
  // https://developer.mozilla.org/en-US/docs/Web/CSS/touch-action#Formal_syntax
  touchAction: Object(external_prop_types_["oneOf"])(touchActionEnum),
  // https://developer.mozilla.org/en-US/docs/Web/CSS/user-select#Formal_syntax_2
  userSelect: Object(external_prop_types_["oneOf"])(userSelectEnum),
  willChange: external_prop_types_["string"]
};
/* harmony default export */ var modules_InteractionPropTypes = (InteractionPropTypes);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/LayoutPropTypes/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var OverflowPropType = Object(external_prop_types_["oneOf"])(['auto', 'hidden', 'scroll', 'visible']);
var hiddenOrVisible = Object(external_prop_types_["oneOf"])(['hidden', 'visible']);
var LayoutPropTypes_numberOrString = Object(external_prop_types_["oneOfType"])([external_prop_types_["number"], external_prop_types_["string"]]);
var LayoutPropTypes = {
  alignContent: Object(external_prop_types_["oneOf"])(['center', 'flex-end', 'flex-start', 'space-around', 'space-between', 'stretch']),
  alignItems: Object(external_prop_types_["oneOf"])(['baseline', 'center', 'flex-end', 'flex-start', 'stretch']),
  alignSelf: Object(external_prop_types_["oneOf"])(['auto', 'baseline', 'center', 'flex-end', 'flex-start', 'stretch']),
  backfaceVisibility: hiddenOrVisible,
  borderWidth: LayoutPropTypes_numberOrString,
  borderBottomWidth: LayoutPropTypes_numberOrString,
  borderEndWidth: LayoutPropTypes_numberOrString,
  borderLeftWidth: LayoutPropTypes_numberOrString,
  borderRightWidth: LayoutPropTypes_numberOrString,
  borderStartWidth: LayoutPropTypes_numberOrString,
  borderTopWidth: LayoutPropTypes_numberOrString,
  bottom: LayoutPropTypes_numberOrString,
  boxSizing: external_prop_types_["string"],
  direction: Object(external_prop_types_["oneOf"])(['inherit', 'ltr', 'rtl']),
  display: external_prop_types_["string"],
  end: LayoutPropTypes_numberOrString,
  flex: external_prop_types_["number"],
  flexBasis: LayoutPropTypes_numberOrString,
  flexDirection: Object(external_prop_types_["oneOf"])(['column', 'column-reverse', 'row', 'row-reverse']),
  flexGrow: external_prop_types_["number"],
  flexShrink: external_prop_types_["number"],
  flexWrap: Object(external_prop_types_["oneOf"])(['nowrap', 'wrap', 'wrap-reverse']),
  height: LayoutPropTypes_numberOrString,
  justifyContent: Object(external_prop_types_["oneOf"])(['center', 'flex-end', 'flex-start', 'space-around', 'space-between', 'space-evenly']),
  left: LayoutPropTypes_numberOrString,
  margin: LayoutPropTypes_numberOrString,
  marginBottom: LayoutPropTypes_numberOrString,
  marginHorizontal: LayoutPropTypes_numberOrString,
  marginEnd: LayoutPropTypes_numberOrString,
  marginLeft: LayoutPropTypes_numberOrString,
  marginRight: LayoutPropTypes_numberOrString,
  marginStart: LayoutPropTypes_numberOrString,
  marginTop: LayoutPropTypes_numberOrString,
  marginVertical: LayoutPropTypes_numberOrString,
  maxHeight: LayoutPropTypes_numberOrString,
  maxWidth: LayoutPropTypes_numberOrString,
  minHeight: LayoutPropTypes_numberOrString,
  minWidth: LayoutPropTypes_numberOrString,
  order: external_prop_types_["number"],
  overflow: OverflowPropType,
  overflowX: OverflowPropType,
  overflowY: OverflowPropType,
  padding: LayoutPropTypes_numberOrString,
  paddingBottom: LayoutPropTypes_numberOrString,
  paddingHorizontal: LayoutPropTypes_numberOrString,
  paddingEnd: LayoutPropTypes_numberOrString,
  paddingLeft: LayoutPropTypes_numberOrString,
  paddingRight: LayoutPropTypes_numberOrString,
  paddingStart: LayoutPropTypes_numberOrString,
  paddingTop: LayoutPropTypes_numberOrString,
  paddingVertical: LayoutPropTypes_numberOrString,
  position: Object(external_prop_types_["oneOf"])(['absolute', 'fixed', 'relative', 'static', 'sticky']),
  right: LayoutPropTypes_numberOrString,
  start: LayoutPropTypes_numberOrString,
  top: LayoutPropTypes_numberOrString,
  visibility: hiddenOrVisible,
  width: LayoutPropTypes_numberOrString,
  zIndex: external_prop_types_["number"],

  /**
   * @platform unsupported
   */
  aspectRatio: external_prop_types_["number"],

  /**
   * @platform web
   */
  gridAutoColumns: external_prop_types_["string"],
  gridAutoFlow: external_prop_types_["string"],
  gridAutoRows: external_prop_types_["string"],
  gridColumnEnd: external_prop_types_["string"],
  gridColumnGap: external_prop_types_["string"],
  gridColumnStart: external_prop_types_["string"],
  gridRowEnd: external_prop_types_["string"],
  gridRowGap: external_prop_types_["string"],
  gridRowStart: external_prop_types_["string"],
  gridTemplateColumns: external_prop_types_["string"],
  gridTemplateRows: external_prop_types_["string"],
  gridTemplateAreas: external_prop_types_["string"]
};
/* harmony default export */ var modules_LayoutPropTypes = (LayoutPropTypes);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/ShadowPropTypes/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var ShadowPropTypes_numberOrString = Object(external_prop_types_["oneOfType"])([external_prop_types_["number"], external_prop_types_["string"]]);
var ShadowPropTypes = {
  shadowColor: exports_ColorPropType,
  shadowOffset: Object(external_prop_types_["shape"])({
    width: ShadowPropTypes_numberOrString,
    height: ShadowPropTypes_numberOrString
  }),
  shadowOpacity: external_prop_types_["number"],
  shadowRadius: ShadowPropTypes_numberOrString,
  shadowSpread: ShadowPropTypes_numberOrString
};
/* harmony default export */ var modules_ShadowPropTypes = (ShadowPropTypes);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/TransformPropTypes/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var TransformPropTypes_numberOrString = Object(external_prop_types_["oneOfType"])([external_prop_types_["number"], external_prop_types_["string"]]);
var TransformPropTypes = {
  perspective: Object(external_prop_types_["oneOfType"])([external_prop_types_["number"], external_prop_types_["string"]]),
  perspectiveOrigin: external_prop_types_["string"],
  transform: Object(external_prop_types_["arrayOf"])(Object(external_prop_types_["oneOfType"])([Object(external_prop_types_["shape"])({
    perspective: TransformPropTypes_numberOrString
  }), Object(external_prop_types_["shape"])({
    rotate: external_prop_types_["string"]
  }), Object(external_prop_types_["shape"])({
    rotateX: external_prop_types_["string"]
  }), Object(external_prop_types_["shape"])({
    rotateY: external_prop_types_["string"]
  }), Object(external_prop_types_["shape"])({
    rotateZ: external_prop_types_["string"]
  }), Object(external_prop_types_["shape"])({
    scale: external_prop_types_["number"]
  }), Object(external_prop_types_["shape"])({
    scaleX: external_prop_types_["number"]
  }), Object(external_prop_types_["shape"])({
    scaleY: external_prop_types_["number"]
  }), Object(external_prop_types_["shape"])({
    scaleZ: external_prop_types_["number"]
  }), Object(external_prop_types_["shape"])({
    scale3d: external_prop_types_["string"]
  }), Object(external_prop_types_["shape"])({
    skewX: external_prop_types_["string"]
  }), Object(external_prop_types_["shape"])({
    skewY: external_prop_types_["string"]
  }), Object(external_prop_types_["shape"])({
    translateX: TransformPropTypes_numberOrString
  }), Object(external_prop_types_["shape"])({
    translateY: TransformPropTypes_numberOrString
  }), Object(external_prop_types_["shape"])({
    translateZ: TransformPropTypes_numberOrString
  }), Object(external_prop_types_["shape"])({
    translate3d: external_prop_types_["string"]
  })])),
  transformOrigin: external_prop_types_["string"],
  transformStyle: Object(external_prop_types_["oneOf"])(['flat', 'preserve-3d'])
};
/* harmony default export */ var modules_TransformPropTypes = (TransformPropTypes);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/View/ViewStylePropTypes.js
function ViewStylePropTypes_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { ViewStylePropTypes_defineProperty(target, key, source[key]); }); } return target; }

function ViewStylePropTypes_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */








var stringOrNumber = Object(external_prop_types_["oneOfType"])([external_prop_types_["string"], external_prop_types_["number"]]);
var overscrollBehaviorType = Object(external_prop_types_["oneOf"])(['auto', 'contain', 'none']);

var ViewStylePropTypes = ViewStylePropTypes_objectSpread({}, modules_AnimationPropTypes, modules_BorderPropTypes, modules_InteractionPropTypes, modules_LayoutPropTypes, modules_ShadowPropTypes, modules_TransformPropTypes, {
  backgroundColor: exports_ColorPropType,
  opacity: external_prop_types_["number"],

  /**
   * @platform unsupported
   */
  elevation: external_prop_types_["number"],

  /**
   * @platform web
   */
  backdropFilter: external_prop_types_["string"],
  backgroundAttachment: external_prop_types_["string"],
  backgroundBlendMode: external_prop_types_["string"],
  backgroundClip: external_prop_types_["string"],
  backgroundImage: external_prop_types_["string"],
  backgroundOrigin: Object(external_prop_types_["oneOf"])(['border-box', 'content-box', 'padding-box']),
  backgroundPosition: external_prop_types_["string"],
  backgroundRepeat: external_prop_types_["string"],
  backgroundSize: external_prop_types_["string"],
  boxShadow: external_prop_types_["string"],
  clip: external_prop_types_["string"],
  filter: external_prop_types_["string"],
  outlineColor: exports_ColorPropType,
  outlineOffset: stringOrNumber,
  outlineStyle: external_prop_types_["string"],
  outlineWidth: stringOrNumber,
  overscrollBehavior: overscrollBehaviorType,
  overscrollBehaviorX: overscrollBehaviorType,
  overscrollBehaviorY: overscrollBehaviorType,
  scrollbarWidth: Object(external_prop_types_["oneOf"])(['auto', 'none']),
  scrollSnapAlign: external_prop_types_["string"],
  scrollSnapType: external_prop_types_["string"],
  WebkitMaskImage: external_prop_types_["string"],
  WebkitOverflowScrolling: Object(external_prop_types_["oneOf"])(['auto', 'touch'])
});

/* harmony default export */ var View_ViewStylePropTypes = (ViewStylePropTypes);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Text/TextStylePropTypes.js
function TextStylePropTypes_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { TextStylePropTypes_defineProperty(target, key, source[key]); }); } return target; }

function TextStylePropTypes_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var TextStylePropTypes_numberOrString = Object(external_prop_types_["oneOfType"])([external_prop_types_["number"], external_prop_types_["string"]]);

var TextStylePropTypes = TextStylePropTypes_objectSpread({}, View_ViewStylePropTypes, {
  color: exports_ColorPropType,
  fontFamily: external_prop_types_["string"],
  fontFeatureSettings: external_prop_types_["string"],
  fontSize: TextStylePropTypes_numberOrString,
  fontStyle: external_prop_types_["string"],
  fontWeight: external_prop_types_["string"],
  fontVariant: external_prop_types_["array"],
  letterSpacing: TextStylePropTypes_numberOrString,
  lineHeight: TextStylePropTypes_numberOrString,
  textAlign: Object(external_prop_types_["oneOf"])(['center', 'end', 'inherit', 'justify', 'justify-all', 'left', 'right', 'start']),
  textAlignVertical: external_prop_types_["string"],
  textDecorationColor: exports_ColorPropType,
  textDecorationLine: external_prop_types_["string"],
  textDecorationStyle: external_prop_types_["string"],
  textShadowColor: exports_ColorPropType,
  textShadowOffset: Object(external_prop_types_["shape"])({
    width: external_prop_types_["number"],
    height: external_prop_types_["number"]
  }),
  textShadowRadius: external_prop_types_["number"],
  textTransform: Object(external_prop_types_["oneOf"])(['capitalize', 'lowercase', 'none', 'uppercase']),
  writingDirection: Object(external_prop_types_["oneOf"])(['auto', 'ltr', 'rtl']),

  /* @platform web */
  textIndent: TextStylePropTypes_numberOrString,
  textOverflow: external_prop_types_["string"],
  textRendering: Object(external_prop_types_["oneOf"])(['auto', 'geometricPrecision', 'optimizeLegibility', 'optimizeSpeed']),
  unicodeBidi: Object(external_prop_types_["oneOf"])(['normal', 'bidi-override', 'embed', 'isolate', 'isolate-override', 'plaintext']),
  whiteSpace: external_prop_types_["string"],
  wordBreak: Object(external_prop_types_["oneOf"])(['normal', 'break-all', 'break-word', 'keep-all']),
  wordWrap: external_prop_types_["string"],
  MozOsxFontSmoothing: external_prop_types_["string"],
  WebkitFontSmoothing: external_prop_types_["string"]
});

/* harmony default export */ var Text_TextStylePropTypes = (TextStylePropTypes);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Text/TextPropTypes.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var TextPropTypes = {
  accessibilityComponentType: external_prop_types_["string"],
  accessibilityLabel: external_prop_types_["string"],
  accessibilityLiveRegion: Object(external_prop_types_["oneOf"])(['assertive', 'none', 'polite']),
  accessibilityRole: Object(external_prop_types_["oneOf"])(['button', 'header', 'heading', 'label', 'link', 'listitem', 'none', 'text']),
  accessibilityTraits: Object(external_prop_types_["oneOfType"])([external_prop_types_["array"], external_prop_types_["string"]]),
  accessible: external_prop_types_["bool"],
  children: external_prop_types_["any"],
  importantForAccessibility: Object(external_prop_types_["oneOf"])(['auto', 'no', 'no-hide-descendants', 'yes']),
  maxFontSizeMultiplier: external_prop_types_["number"],
  nativeID: external_prop_types_["string"],
  numberOfLines: external_prop_types_["number"],
  onBlur: external_prop_types_["func"],
  onFocus: external_prop_types_["func"],
  onLayout: external_prop_types_["func"],
  onPress: external_prop_types_["func"],
  selectable: external_prop_types_["bool"],
  style: modules_StyleSheetPropType(Text_TextStylePropTypes),
  testID: external_prop_types_["string"],
  // web extensions
  onContextMenu: external_prop_types_["func"],
  itemID: external_prop_types_["string"],
  itemRef: external_prop_types_["string"],
  itemProp: external_prop_types_["string"],
  itemScope: external_prop_types_["string"],
  itemType: external_prop_types_["string"]
};
/* harmony default export */ var Text_TextPropTypes = (TextPropTypes);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/TextPropTypes/index.js

/* harmony default export */ var exports_TextPropTypes = (Text_TextPropTypes);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/EdgeInsetsPropType/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var EdgeInsetsPropType = modules_createStrictShapeTypeChecker({
  top: external_prop_types_["number"],
  left: external_prop_types_["number"],
  bottom: external_prop_types_["number"],
  right: external_prop_types_["number"]
});
/* harmony default export */ var exports_EdgeInsetsPropType = (EdgeInsetsPropType);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/View/ViewPropTypes.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var stylePropType = modules_StyleSheetPropType(View_ViewStylePropTypes);
var ViewPropTypes = {
  accessibilityComponentType: external_prop_types_["string"],
  accessibilityLabel: external_prop_types_["string"],
  accessibilityLiveRegion: Object(external_prop_types_["oneOf"])(['assertive', 'none', 'polite']),
  accessibilityRole: external_prop_types_["string"],
  accessibilityStates: Object(external_prop_types_["arrayOf"])(Object(external_prop_types_["oneOf"])(['disabled', 'selected',
  /* web-only */
  'busy', 'checked', 'expanded', 'grabbed', 'invalid', 'pressed'])),
  accessibilityTraits: Object(external_prop_types_["oneOfType"])([external_prop_types_["array"], external_prop_types_["string"]]),
  accessible: external_prop_types_["bool"],
  children: external_prop_types_["any"],
  hitSlop: exports_EdgeInsetsPropType,
  importantForAccessibility: Object(external_prop_types_["oneOf"])(['auto', 'no', 'no-hide-descendants', 'yes']),
  nativeID: external_prop_types_["string"],
  onBlur: external_prop_types_["func"],
  onClick: external_prop_types_["func"],
  onClickCapture: external_prop_types_["func"],
  onFocus: external_prop_types_["func"],
  onLayout: external_prop_types_["func"],
  onMoveShouldSetResponder: external_prop_types_["func"],
  onMoveShouldSetResponderCapture: external_prop_types_["func"],
  onResponderGrant: external_prop_types_["func"],
  onResponderMove: external_prop_types_["func"],
  onResponderReject: external_prop_types_["func"],
  onResponderRelease: external_prop_types_["func"],
  onResponderTerminate: external_prop_types_["func"],
  onResponderTerminationRequest: external_prop_types_["func"],
  onStartShouldSetResponder: external_prop_types_["func"],
  onStartShouldSetResponderCapture: external_prop_types_["func"],
  onTouchCancel: external_prop_types_["func"],
  onTouchCancelCapture: external_prop_types_["func"],
  onTouchEnd: external_prop_types_["func"],
  onTouchEndCapture: external_prop_types_["func"],
  onTouchMove: external_prop_types_["func"],
  onTouchMoveCapture: external_prop_types_["func"],
  onTouchStart: external_prop_types_["func"],
  onTouchStartCapture: external_prop_types_["func"],
  pointerEvents: Object(external_prop_types_["oneOf"])(['auto', 'box-none', 'box-only', 'none']),
  style: stylePropType,
  testID: external_prop_types_["string"],
  // web extensions
  onContextMenu: external_prop_types_["func"],
  itemID: external_prop_types_["string"],
  itemRef: external_prop_types_["string"],
  itemProp: external_prop_types_["string"],
  itemScope: external_prop_types_["string"],
  itemType: external_prop_types_["string"],
  // compatibility with React Native
  accessibilityViewIsModal: external_prop_types_["bool"],
  collapsable: external_prop_types_["bool"],
  needsOffscreenAlphaCompositing: external_prop_types_["bool"],
  onAccessibilityTap: external_prop_types_["func"],
  onMagicTap: external_prop_types_["func"],
  removeClippedSubviews: external_prop_types_["bool"],
  renderToHardwareTextureAndroid: external_prop_types_["bool"],
  shouldRasterizeIOS: external_prop_types_["bool"],
  tvParallaxProperties: external_prop_types_["object"]
};
/* harmony default export */ var View_ViewPropTypes = (ViewPropTypes);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/ViewPropTypes/index.js

/* harmony default export */ var exports_ViewPropTypes = (View_ViewPropTypes);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/AccessibilityInfo/index.js
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
function AccessibilityInfo_emptyFunction() {}

var AccessibilityInfo = {
  /**
   * Query whether a screen reader is currently enabled.
   *
   * Returns a promise which resolves to a boolean.
   * The result is `true` when a screen reader is enabled and `false` otherwise.
   */
  fetch: function fetch() {
    return new Promise(function (resolve, reject) {
      resolve(true);
    });
  },

  /**
   * Add an event handler. Supported events:
   */
  addEventListener: function addEventListener(eventName, handler) {
    return {
      remove: AccessibilityInfo_emptyFunction
    };
  },

  /**
   * Set accessibility focus to a react component.
   */
  setAccessibilityFocus: function setAccessibilityFocus(reactTag) {},

  /**
   * Post a string to be announced by the screen reader.
   */
  announceForAccessibility: function announceForAccessibility(announcement) {},

  /**
   * Remove an event handler.
   */
  removeEventListener: function removeEventListener(eventName, handler) {
    return;
  }
};
/* harmony default export */ var exports_AccessibilityInfo = (AccessibilityInfo);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Alert/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var Alert =
/*#__PURE__*/
function () {
  function Alert() {}

  Alert.alert = function alert() {};

  return Alert;
}();

/* harmony default export */ var exports_Alert = (Alert);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedValue.js
var AnimatedValue = __webpack_require__(10);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/NativeAnimatedHelper.js
var NativeAnimatedHelper = __webpack_require__(5);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/AnimatedEvent.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */






var shouldUseNativeDriver = NativeAnimatedHelper["a" /* default */].shouldUseNativeDriver;

function attachNativeEvent(viewRef, eventName, argMapping) {
  // Find animated values in `argMapping` and create an array representing their
  // key path inside the `nativeEvent` object. Ex.: ['contentOffset', 'x'].
  var eventMappings = [];

  var traverse = function traverse(value, path) {
    if (value instanceof AnimatedValue["a" /* default */]) {
      value.__makeNative();

      eventMappings.push({
        nativeEventPath: path,
        animatedValueTag: value.__getNativeTag()
      });
    } else if (typeof value === 'object') {
      for (var _key in value) {
        traverse(value[_key], path.concat(_key));
      }
    }
  };

  invariant_default()(argMapping[0] && argMapping[0].nativeEvent, 'Native driven events only support animated values contained inside `nativeEvent`.'); // Assume that the event containing `nativeEvent` is always the first argument.

  traverse(argMapping[0].nativeEvent, []);
  var viewTag = exports_findNodeHandle(viewRef);
  eventMappings.forEach(function (mapping) {
    NativeAnimatedHelper["a" /* default */].API.addAnimatedEventToView(viewTag, eventName, mapping);
  });
  return {
    detach: function detach() {
      eventMappings.forEach(function (mapping) {
        NativeAnimatedHelper["a" /* default */].API.removeAnimatedEventFromView(viewTag, eventName, mapping.animatedValueTag);
      });
    }
  };
}

var AnimatedEvent_AnimatedEvent =
/*#__PURE__*/
function () {
  function AnimatedEvent(argMapping, config) {
    if (config === void 0) {
      config = {};
    }

    this._listeners = [];
    this._argMapping = argMapping;

    if (config.listener) {
      this.__addListener(config.listener);
    }

    this._callListeners = this._callListeners.bind(this);
    this._attachedEvent = null;
    this.__isNative = shouldUseNativeDriver(config);

    if (false) {}
  }

  var _proto = AnimatedEvent.prototype;

  _proto.__addListener = function __addListener(callback) {
    this._listeners.push(callback);
  };

  _proto.__removeListener = function __removeListener(callback) {
    this._listeners = this._listeners.filter(function (listener) {
      return listener !== callback;
    });
  };

  _proto.__attach = function __attach(viewRef, eventName) {
    invariant_default()(this.__isNative, 'Only native driven events need to be attached.');
    this._attachedEvent = attachNativeEvent(viewRef, eventName, this._argMapping);
  };

  _proto.__detach = function __detach(viewTag, eventName) {
    invariant_default()(this.__isNative, 'Only native driven events need to be detached.');
    this._attachedEvent && this._attachedEvent.detach();
  };

  _proto.__getHandler = function __getHandler() {
    var _this = this;

    if (this.__isNative) {
      return this._callListeners;
    }

    return function () {
      for (var _len = arguments.length, args = new Array(_len), _key2 = 0; _key2 < _len; _key2++) {
        args[_key2] = arguments[_key2];
      }

      var traverse = function traverse(recMapping, recEvt, key) {
        if (typeof recEvt === 'number' && recMapping instanceof AnimatedValue["a" /* default */]) {
          recMapping.setValue(recEvt);
        } else if (typeof recMapping === 'object') {
          for (var mappingKey in recMapping) {
            /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This
             * comment suppresses an error when upgrading Flow's support for
             * React. To see the error delete this comment and run Flow. */
            traverse(recMapping[mappingKey], recEvt[mappingKey], mappingKey);
          }
        }
      };

      if (!_this.__isNative) {
        _this._argMapping.forEach(function (mapping, idx) {
          traverse(mapping, args[idx], 'arg' + idx);
        });
      }

      _this._callListeners.apply(_this, args);
    };
  };

  _proto._callListeners = function _callListeners() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key3 = 0; _key3 < _len2; _key3++) {
      args[_key3] = arguments[_key3];
    }

    this._listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  };

  _proto._validateMapping = function _validateMapping() {
    var traverse = function traverse(recMapping, recEvt, key) {
      if (typeof recEvt === 'number') {
        invariant_default()(recMapping instanceof AnimatedValue["a" /* default */], 'Bad mapping of type ' + typeof recMapping + ' for key ' + key + ', event value must map to AnimatedValue');
        return;
      }

      invariant_default()(typeof recMapping === 'object', 'Bad mapping of type ' + typeof recMapping + ' for key ' + key);
      invariant_default()(typeof recEvt === 'object', 'Bad event of type ' + typeof recEvt + ' for key ' + key);

      for (var mappingKey in recMapping) {
        traverse(recMapping[mappingKey], recEvt[mappingKey], mappingKey);
      }
    };
  };

  return AnimatedEvent;
}();


/* harmony default export */ var Animated_AnimatedEvent = ({
  AnimatedEvent: AnimatedEvent_AnimatedEvent,
  attachNativeEvent: attachNativeEvent
});
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedInterpolation.js
var AnimatedInterpolation = __webpack_require__(18);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedWithChildren.js
var AnimatedWithChildren = __webpack_require__(13);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedAddition.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }






var AnimatedAddition_AnimatedAddition =
/*#__PURE__*/
function (_AnimatedWithChildren) {
  _inheritsLoose(AnimatedAddition, _AnimatedWithChildren);

  function AnimatedAddition(a, b) {
    var _this;

    _this = _AnimatedWithChildren.call(this) || this;
    _this._a = typeof a === 'number' ? new AnimatedValue["a" /* default */](a) : a;
    _this._b = typeof b === 'number' ? new AnimatedValue["a" /* default */](b) : b;
    return _this;
  }

  var _proto = AnimatedAddition.prototype;

  _proto.__makeNative = function __makeNative() {
    this._a.__makeNative();

    this._b.__makeNative();

    _AnimatedWithChildren.prototype.__makeNative.call(this);
  };

  _proto.__getValue = function __getValue() {
    return this._a.__getValue() + this._b.__getValue();
  };

  _proto.interpolate = function interpolate(config) {
    return new AnimatedInterpolation["a" /* default */](this, config);
  };

  _proto.__attach = function __attach() {
    this._a.__addChild(this);

    this._b.__addChild(this);
  };

  _proto.__detach = function __detach() {
    this._a.__removeChild(this);

    this._b.__removeChild(this);

    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  _proto.__getNativeConfig = function __getNativeConfig() {
    return {
      type: 'addition',
      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
    };
  };

  return AnimatedAddition;
}(AnimatedWithChildren["a" /* default */]);

/* harmony default export */ var nodes_AnimatedAddition = (AnimatedAddition_AnimatedAddition);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedDiffClamp.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function AnimatedDiffClamp_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





var AnimatedDiffClamp_AnimatedDiffClamp =
/*#__PURE__*/
function (_AnimatedWithChildren) {
  AnimatedDiffClamp_inheritsLoose(AnimatedDiffClamp, _AnimatedWithChildren);

  function AnimatedDiffClamp(a, min, max) {
    var _this;

    _this = _AnimatedWithChildren.call(this) || this;
    _this._a = a;
    _this._min = min;
    _this._max = max;
    _this._value = _this._lastValue = _this._a.__getValue();
    return _this;
  }

  var _proto = AnimatedDiffClamp.prototype;

  _proto.__makeNative = function __makeNative() {
    this._a.__makeNative();

    _AnimatedWithChildren.prototype.__makeNative.call(this);
  };

  _proto.interpolate = function interpolate(config) {
    return new AnimatedInterpolation["a" /* default */](this, config);
  };

  _proto.__getValue = function __getValue() {
    var value = this._a.__getValue();

    var diff = value - this._lastValue;
    this._lastValue = value;
    this._value = Math.min(Math.max(this._value + diff, this._min), this._max);
    return this._value;
  };

  _proto.__attach = function __attach() {
    this._a.__addChild(this);
  };

  _proto.__detach = function __detach() {
    this._a.__removeChild(this);

    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  _proto.__getNativeConfig = function __getNativeConfig() {
    return {
      type: 'diffclamp',
      input: this._a.__getNativeTag(),
      min: this._min,
      max: this._max
    };
  };

  return AnimatedDiffClamp;
}(AnimatedWithChildren["a" /* default */]);

/* harmony default export */ var nodes_AnimatedDiffClamp = (AnimatedDiffClamp_AnimatedDiffClamp);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedDivision.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function AnimatedDivision_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }






var AnimatedDivision_AnimatedDivision =
/*#__PURE__*/
function (_AnimatedWithChildren) {
  AnimatedDivision_inheritsLoose(AnimatedDivision, _AnimatedWithChildren);

  function AnimatedDivision(a, b) {
    var _this;

    _this = _AnimatedWithChildren.call(this) || this;
    _this._a = typeof a === 'number' ? new AnimatedValue["a" /* default */](a) : a;
    _this._b = typeof b === 'number' ? new AnimatedValue["a" /* default */](b) : b;
    return _this;
  }

  var _proto = AnimatedDivision.prototype;

  _proto.__makeNative = function __makeNative() {
    this._a.__makeNative();

    this._b.__makeNative();

    _AnimatedWithChildren.prototype.__makeNative.call(this);
  };

  _proto.__getValue = function __getValue() {
    var a = this._a.__getValue();

    var b = this._b.__getValue();

    if (b === 0) {
      console.error('Detected division by zero in AnimatedDivision');
    }

    return a / b;
  };

  _proto.interpolate = function interpolate(config) {
    return new AnimatedInterpolation["a" /* default */](this, config);
  };

  _proto.__attach = function __attach() {
    this._a.__addChild(this);

    this._b.__addChild(this);
  };

  _proto.__detach = function __detach() {
    this._a.__removeChild(this);

    this._b.__removeChild(this);

    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  _proto.__getNativeConfig = function __getNativeConfig() {
    return {
      type: 'division',
      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
    };
  };

  return AnimatedDivision;
}(AnimatedWithChildren["a" /* default */]);

/* harmony default export */ var nodes_AnimatedDivision = (AnimatedDivision_AnimatedDivision);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedModulo.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function AnimatedModulo_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





var AnimatedModulo_AnimatedModulo =
/*#__PURE__*/
function (_AnimatedWithChildren) {
  AnimatedModulo_inheritsLoose(AnimatedModulo, _AnimatedWithChildren);

  function AnimatedModulo(a, modulus) {
    var _this;

    _this = _AnimatedWithChildren.call(this) || this;
    _this._a = a;
    _this._modulus = modulus;
    return _this;
  }

  var _proto = AnimatedModulo.prototype;

  _proto.__makeNative = function __makeNative() {
    this._a.__makeNative();

    _AnimatedWithChildren.prototype.__makeNative.call(this);
  };

  _proto.__getValue = function __getValue() {
    return (this._a.__getValue() % this._modulus + this._modulus) % this._modulus;
  };

  _proto.interpolate = function interpolate(config) {
    return new AnimatedInterpolation["a" /* default */](this, config);
  };

  _proto.__attach = function __attach() {
    this._a.__addChild(this);
  };

  _proto.__detach = function __detach() {
    this._a.__removeChild(this);

    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  _proto.__getNativeConfig = function __getNativeConfig() {
    return {
      type: 'modulus',
      input: this._a.__getNativeTag(),
      modulus: this._modulus
    };
  };

  return AnimatedModulo;
}(AnimatedWithChildren["a" /* default */]);

/* harmony default export */ var nodes_AnimatedModulo = (AnimatedModulo_AnimatedModulo);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedMultiplication.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function AnimatedMultiplication_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }






var AnimatedMultiplication_AnimatedMultiplication =
/*#__PURE__*/
function (_AnimatedWithChildren) {
  AnimatedMultiplication_inheritsLoose(AnimatedMultiplication, _AnimatedWithChildren);

  function AnimatedMultiplication(a, b) {
    var _this;

    _this = _AnimatedWithChildren.call(this) || this;
    _this._a = typeof a === 'number' ? new AnimatedValue["a" /* default */](a) : a;
    _this._b = typeof b === 'number' ? new AnimatedValue["a" /* default */](b) : b;
    return _this;
  }

  var _proto = AnimatedMultiplication.prototype;

  _proto.__makeNative = function __makeNative() {
    this._a.__makeNative();

    this._b.__makeNative();

    _AnimatedWithChildren.prototype.__makeNative.call(this);
  };

  _proto.__getValue = function __getValue() {
    return this._a.__getValue() * this._b.__getValue();
  };

  _proto.interpolate = function interpolate(config) {
    return new AnimatedInterpolation["a" /* default */](this, config);
  };

  _proto.__attach = function __attach() {
    this._a.__addChild(this);

    this._b.__addChild(this);
  };

  _proto.__detach = function __detach() {
    this._a.__removeChild(this);

    this._b.__removeChild(this);

    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  _proto.__getNativeConfig = function __getNativeConfig() {
    return {
      type: 'multiplication',
      input: [this._a.__getNativeTag(), this._b.__getNativeTag()]
    };
  };

  return AnimatedMultiplication;
}(AnimatedWithChildren["a" /* default */]);

/* harmony default export */ var nodes_AnimatedMultiplication = (AnimatedMultiplication_AnimatedMultiplication);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedNode.js
var AnimatedNode = __webpack_require__(6);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedTransform.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function AnimatedTransform_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





var AnimatedTransform_AnimatedTransform =
/*#__PURE__*/
function (_AnimatedWithChildren) {
  AnimatedTransform_inheritsLoose(AnimatedTransform, _AnimatedWithChildren);

  function AnimatedTransform(transforms) {
    var _this;

    _this = _AnimatedWithChildren.call(this) || this;
    _this._transforms = transforms;
    return _this;
  }

  var _proto = AnimatedTransform.prototype;

  _proto.__makeNative = function __makeNative() {
    _AnimatedWithChildren.prototype.__makeNative.call(this);

    this._transforms.forEach(function (transform) {
      for (var key in transform) {
        var value = transform[key];

        if (value instanceof AnimatedNode["a" /* default */]) {
          value.__makeNative();
        }
      }
    });
  };

  _proto.__getValue = function __getValue() {
    return this._transforms.map(function (transform) {
      var result = {};

      for (var key in transform) {
        var value = transform[key];

        if (value instanceof AnimatedNode["a" /* default */]) {
          result[key] = value.__getValue();
        } else {
          result[key] = value;
        }
      }

      return result;
    });
  };

  _proto.__getAnimatedValue = function __getAnimatedValue() {
    return this._transforms.map(function (transform) {
      var result = {};

      for (var key in transform) {
        var value = transform[key];

        if (value instanceof AnimatedNode["a" /* default */]) {
          result[key] = value.__getAnimatedValue();
        } else {
          // All transform components needed to recompose matrix
          result[key] = value;
        }
      }

      return result;
    });
  };

  _proto.__attach = function __attach() {
    var _this2 = this;

    this._transforms.forEach(function (transform) {
      for (var key in transform) {
        var value = transform[key];

        if (value instanceof AnimatedNode["a" /* default */]) {
          value.__addChild(_this2);
        }
      }
    });
  };

  _proto.__detach = function __detach() {
    var _this3 = this;

    this._transforms.forEach(function (transform) {
      for (var key in transform) {
        var value = transform[key];

        if (value instanceof AnimatedNode["a" /* default */]) {
          value.__removeChild(_this3);
        }
      }
    });

    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  _proto.__getNativeConfig = function __getNativeConfig() {
    var transConfigs = [];

    this._transforms.forEach(function (transform) {
      for (var key in transform) {
        var value = transform[key];

        if (value instanceof AnimatedNode["a" /* default */]) {
          transConfigs.push({
            type: 'animated',
            property: key,
            nodeTag: value.__getNativeTag()
          });
        } else {
          transConfigs.push({
            type: 'static',
            property: key,
            value: value
          });
        }
      }
    });

    NativeAnimatedHelper["a" /* default */].validateTransform(transConfigs);
    return {
      type: 'transform',
      transforms: transConfigs
    };
  };

  return AnimatedTransform;
}(AnimatedWithChildren["a" /* default */]);

/* harmony default export */ var nodes_AnimatedTransform = (AnimatedTransform_AnimatedTransform);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedStyle.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function AnimatedStyle_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { AnimatedStyle_defineProperty(target, key, source[key]); }); } return target; }

function AnimatedStyle_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function AnimatedStyle_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }






var AnimatedStyle_flattenStyle = exports_StyleSheet.flatten;

var AnimatedStyle_AnimatedStyle =
/*#__PURE__*/
function (_AnimatedWithChildren) {
  AnimatedStyle_inheritsLoose(AnimatedStyle, _AnimatedWithChildren);

  function AnimatedStyle(style) {
    var _this;

    _this = _AnimatedWithChildren.call(this) || this;
    style = AnimatedStyle_flattenStyle(style) || {};

    if (style.transform) {
      style = AnimatedStyle_objectSpread({}, style, {
        transform: new nodes_AnimatedTransform(style.transform)
      });
    }

    _this._style = style;
    return _this;
  } // Recursively get values for nested styles (like iOS's shadowOffset)


  var _proto = AnimatedStyle.prototype;

  _proto._walkStyleAndGetValues = function _walkStyleAndGetValues(style) {
    var updatedStyle = {};

    for (var key in style) {
      var value = style[key];

      if (value instanceof AnimatedNode["a" /* default */]) {
        if (!value.__isNative) {
          // We cannot use value of natively driven nodes this way as the value we have access from
          // JS may not be up to date.
          updatedStyle[key] = value.__getValue();
        }
      } else if (value && !Array.isArray(value) && typeof value === 'object') {
        // Support animating nested values (for example: shadowOffset.height)
        updatedStyle[key] = this._walkStyleAndGetValues(value);
      } else {
        updatedStyle[key] = value;
      }
    }

    return updatedStyle;
  };

  _proto.__getValue = function __getValue() {
    return this._walkStyleAndGetValues(this._style);
  } // Recursively get animated values for nested styles (like iOS's shadowOffset)
  ;

  _proto._walkStyleAndGetAnimatedValues = function _walkStyleAndGetAnimatedValues(style) {
    var updatedStyle = {};

    for (var key in style) {
      var value = style[key];

      if (value instanceof AnimatedNode["a" /* default */]) {
        updatedStyle[key] = value.__getAnimatedValue();
      } else if (value && !Array.isArray(value) && typeof value === 'object') {
        // Support animating nested values (for example: shadowOffset.height)
        updatedStyle[key] = this._walkStyleAndGetAnimatedValues(value);
      }
    }

    return updatedStyle;
  };

  _proto.__getAnimatedValue = function __getAnimatedValue() {
    return this._walkStyleAndGetAnimatedValues(this._style);
  };

  _proto.__attach = function __attach() {
    for (var key in this._style) {
      var value = this._style[key];

      if (value instanceof AnimatedNode["a" /* default */]) {
        value.__addChild(this);
      }
    }
  };

  _proto.__detach = function __detach() {
    for (var key in this._style) {
      var value = this._style[key];

      if (value instanceof AnimatedNode["a" /* default */]) {
        value.__removeChild(this);
      }
    }

    _AnimatedWithChildren.prototype.__detach.call(this);
  };

  _proto.__makeNative = function __makeNative() {
    _AnimatedWithChildren.prototype.__makeNative.call(this);

    for (var key in this._style) {
      var value = this._style[key];

      if (value instanceof AnimatedNode["a" /* default */]) {
        value.__makeNative();
      }
    }
  };

  _proto.__getNativeConfig = function __getNativeConfig() {
    var styleConfig = {};

    for (var styleKey in this._style) {
      if (this._style[styleKey] instanceof AnimatedNode["a" /* default */]) {
        styleConfig[styleKey] = this._style[styleKey].__getNativeTag();
      } // Non-animated styles are set using `setNativeProps`, no need
      // to pass those as a part of the node config

    }

    NativeAnimatedHelper["a" /* default */].validateStyles(styleConfig);
    return {
      type: 'style',
      style: styleConfig
    };
  };

  return AnimatedStyle;
}(AnimatedWithChildren["a" /* default */]);

/* harmony default export */ var nodes_AnimatedStyle = (AnimatedStyle_AnimatedStyle);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedProps.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function AnimatedProps_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { AnimatedProps_defineProperty(target, key, source[key]); }); } return target; }

function AnimatedProps_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function AnimatedProps_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }








var AnimatedProps_AnimatedProps =
/*#__PURE__*/
function (_AnimatedNode) {
  AnimatedProps_inheritsLoose(AnimatedProps, _AnimatedNode);

  function AnimatedProps(props, callback) {
    var _this;

    _this = _AnimatedNode.call(this) || this;

    if (props.style) {
      props = AnimatedProps_objectSpread({}, props, {
        style: new nodes_AnimatedStyle(props.style)
      });
    }

    _this._props = props;
    _this._callback = callback;

    _this.__attach();

    return _this;
  }

  var _proto = AnimatedProps.prototype;

  _proto.__getValue = function __getValue() {
    var props = {};

    for (var key in this._props) {
      var value = this._props[key];

      if (value instanceof AnimatedNode["a" /* default */]) {
        if (!value.__isNative || value instanceof nodes_AnimatedStyle) {
          // We cannot use value of natively driven nodes this way as the value we have access from
          // JS may not be up to date.
          props[key] = value.__getValue();
        }
      } else if (value instanceof AnimatedEvent_AnimatedEvent) {
        props[key] = value.__getHandler();
      } else {
        props[key] = value;
      }
    }

    return props;
  };

  _proto.__getAnimatedValue = function __getAnimatedValue() {
    var props = {};

    for (var key in this._props) {
      var value = this._props[key];

      if (value instanceof AnimatedNode["a" /* default */]) {
        props[key] = value.__getAnimatedValue();
      }
    }

    return props;
  };

  _proto.__attach = function __attach() {
    for (var key in this._props) {
      var value = this._props[key];

      if (value instanceof AnimatedNode["a" /* default */]) {
        value.__addChild(this);
      }
    }
  };

  _proto.__detach = function __detach() {
    if (this.__isNative && this._animatedView) {
      this.__disconnectAnimatedView();
    }

    for (var key in this._props) {
      var value = this._props[key];

      if (value instanceof AnimatedNode["a" /* default */]) {
        value.__removeChild(this);
      }
    }

    _AnimatedNode.prototype.__detach.call(this);
  };

  _proto.update = function update() {
    this._callback();
  };

  _proto.__makeNative = function __makeNative() {
    if (!this.__isNative) {
      this.__isNative = true;

      for (var key in this._props) {
        var value = this._props[key];

        if (value instanceof AnimatedNode["a" /* default */]) {
          value.__makeNative();
        }
      }

      if (this._animatedView) {
        this.__connectAnimatedView();
      }
    }
  };

  _proto.setNativeView = function setNativeView(animatedView) {
    if (this._animatedView === animatedView) {
      return;
    }

    this._animatedView = animatedView;

    if (this.__isNative) {
      this.__connectAnimatedView();
    }
  };

  _proto.__connectAnimatedView = function __connectAnimatedView() {
    invariant_default()(this.__isNative, 'Expected node to be marked as "native"');
    var nativeViewTag = exports_findNodeHandle(this._animatedView);
    invariant_default()(nativeViewTag != null, 'Unable to locate attached view in the native tree');
    NativeAnimatedHelper["a" /* default */].API.connectAnimatedNodeToView(this.__getNativeTag(), nativeViewTag);
  };

  _proto.__disconnectAnimatedView = function __disconnectAnimatedView() {
    invariant_default()(this.__isNative, 'Expected node to be marked as "native"');
    var nativeViewTag = exports_findNodeHandle(this._animatedView);
    invariant_default()(nativeViewTag != null, 'Unable to locate attached view in the native tree');
    NativeAnimatedHelper["a" /* default */].API.disconnectAnimatedNodeFromView(this.__getNativeTag(), nativeViewTag);
  };

  _proto.__getNativeConfig = function __getNativeConfig() {
    var propsConfig = {};

    for (var propKey in this._props) {
      var value = this._props[propKey];

      if (value instanceof AnimatedNode["a" /* default */]) {
        propsConfig[propKey] = value.__getNativeTag();
      }
    }

    return {
      type: 'props',
      props: propsConfig
    };
  };

  return AnimatedProps;
}(AnimatedNode["a" /* default */]);

/* harmony default export */ var nodes_AnimatedProps = (AnimatedProps_AnimatedProps);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedTracking.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function AnimatedTracking_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { AnimatedTracking_defineProperty(target, key, source[key]); }); } return target; }

function AnimatedTracking_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function AnimatedTracking_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





var AnimatedTracking_AnimatedTracking =
/*#__PURE__*/
function (_AnimatedNode) {
  AnimatedTracking_inheritsLoose(AnimatedTracking, _AnimatedNode);

  function AnimatedTracking(value, parent, animationClass, animationConfig, callback) {
    var _this;

    _this = _AnimatedNode.call(this) || this;
    _this._value = value;
    _this._parent = parent;
    _this._animationClass = animationClass;
    _this._animationConfig = animationConfig;
    _this._useNativeDriver = Object(NativeAnimatedHelper["c" /* shouldUseNativeDriver */])(animationConfig);
    _this._callback = callback;

    _this.__attach();

    return _this;
  }

  var _proto = AnimatedTracking.prototype;

  _proto.__makeNative = function __makeNative() {
    this.__isNative = true;

    this._parent.__makeNative();

    _AnimatedNode.prototype.__makeNative.call(this);

    this._value.__makeNative();
  };

  _proto.__getValue = function __getValue() {
    return this._parent.__getValue();
  };

  _proto.__attach = function __attach() {
    this._parent.__addChild(this);

    if (this._useNativeDriver) {
      // when the tracking starts we need to convert this node to a "native node"
      // so that the parent node will be made "native" too. This is necessary as
      // if we don't do this `update` method will get called. At that point it
      // may be too late as it would mean the JS driver has already started
      // updating node values
      this.__makeNative();
    }
  };

  _proto.__detach = function __detach() {
    this._parent.__removeChild(this);

    _AnimatedNode.prototype.__detach.call(this);
  };

  _proto.update = function update() {
    this._value.animate(new this._animationClass(AnimatedTracking_objectSpread({}, this._animationConfig, {
      toValue: this._animationConfig.toValue.__getValue()
    })), this._callback);
  };

  _proto.__getNativeConfig = function __getNativeConfig() {
    var animation = new this._animationClass(AnimatedTracking_objectSpread({}, this._animationConfig, {
      // remove toValue from the config as it's a ref to Animated.Value
      toValue: undefined
    }));

    var animationConfig = animation.__getNativeAnimationConfig();

    return {
      type: 'tracking',
      animationId: Object(NativeAnimatedHelper["b" /* generateNewAnimationId */])(),
      animationConfig: animationConfig,
      toValue: this._parent.__getNativeTag(),
      value: this._value.__getNativeTag()
    };
  };

  return AnimatedTracking;
}(AnimatedNode["a" /* default */]);

/* harmony default export */ var nodes_AnimatedTracking = (AnimatedTracking_AnimatedTracking);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/nodes/AnimatedValueXY.js
var AnimatedValueXY = __webpack_require__(47);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/animations/DecayAnimation.js
var DecayAnimation = __webpack_require__(155);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/animations/SpringAnimation.js
var SpringAnimation = __webpack_require__(84);

// EXTERNAL MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/animations/TimingAnimation.js
var TimingAnimation = __webpack_require__(86);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/createAnimatedComponent.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function createAnimatedComponent_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }







function createAnimatedComponent(Component) {
  invariant_default()(typeof Component === 'string' || Component.prototype && Component.prototype.isReactComponent, '`createAnimatedComponent` does not support stateless functional components; ' + 'use a class component instead.');

  var AnimatedComponent =
  /*#__PURE__*/
  function (_React$Component) {
    createAnimatedComponent_inheritsLoose(AnimatedComponent, _React$Component);

    function AnimatedComponent(props) {
      var _this;

      _this = _React$Component.call(this, props) || this;
      _this._invokeAnimatedPropsCallbackOnMount = false;
      _this._eventDetachers = [];

      _this._animatedPropsCallback = function () {
        if (_this._component == null) {
          // AnimatedProps is created in will-mount because it's used in render.
          // But this callback may be invoked before mount in async mode,
          // In which case we should defer the setNativeProps() call.
          // React may throw away uncommitted work in async mode,
          // So a deferred call won't always be invoked.
          _this._invokeAnimatedPropsCallbackOnMount = true;
        } else if (AnimatedComponent.__skipSetNativeProps_FOR_TESTS_ONLY || typeof _this._component.setNativeProps !== 'function') {
          _this.forceUpdate();
        } else if (!_this._propsAnimated.__isNative) {
          _this._component.setNativeProps(_this._propsAnimated.__getAnimatedValue());
        } else {
          throw new Error('Attempting to run JS driven animation on animated ' + 'node that has been moved to "native" earlier by starting an ' + 'animation with `useNativeDriver: true`');
        }
      };

      _this._setComponentRef = _this._setComponentRef.bind(_assertThisInitialized(_assertThisInitialized(_this)));
      return _this;
    }

    var _proto = AnimatedComponent.prototype;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this._propsAnimated && this._propsAnimated.__detach();

      this._detachNativeEvents();
    };

    _proto.setNativeProps = function setNativeProps(props) {
      this._component.setNativeProps(props);
    };

    _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
      this._attachProps(this.props);
    };

    _proto.componentDidMount = function componentDidMount() {
      if (this._invokeAnimatedPropsCallbackOnMount) {
        this._invokeAnimatedPropsCallbackOnMount = false;

        this._animatedPropsCallback();
      }

      this._propsAnimated.setNativeView(this._component);

      this._attachNativeEvents();
    };

    _proto._attachNativeEvents = function _attachNativeEvents() {
      var _this2 = this;

      // Make sure to get the scrollable node for components that implement
      // `ScrollResponder.Mixin`.
      var scrollableNode = this._component.getScrollableNode ? this._component.getScrollableNode() : this._component;

      var _loop = function _loop(key) {
        var prop = _this2.props[key];

        if (prop instanceof AnimatedEvent_AnimatedEvent && prop.__isNative) {
          prop.__attach(scrollableNode, key);

          _this2._eventDetachers.push(function () {
            return prop.__detach(scrollableNode, key);
          });
        }
      };

      for (var key in this.props) {
        _loop(key);
      }
    };

    _proto._detachNativeEvents = function _detachNativeEvents() {
      this._eventDetachers.forEach(function (remove) {
        return remove();
      });

      this._eventDetachers = [];
    } // The system is best designed when setNativeProps is implemented. It is
    // able to avoid re-rendering and directly set the attributes that changed.
    // However, setNativeProps can only be implemented on leaf native
    // components. If you want to animate a composite component, you need to
    // re-render it. In this case, we have a fallback that uses forceUpdate.
    ;

    _proto._attachProps = function _attachProps(nextProps) {
      var oldPropsAnimated = this._propsAnimated;
      this._propsAnimated = new nodes_AnimatedProps(nextProps, this._animatedPropsCallback); // When you call detach, it removes the element from the parent list
      // of children. If it goes to 0, then the parent also detaches itself
      // and so on.
      // An optimization is to attach the new elements and THEN detach the old
      // ones instead of detaching and THEN attaching.
      // This way the intermediate state isn't to go to 0 and trigger
      // this expensive recursive detaching to then re-attach everything on
      // the very next operation.

      oldPropsAnimated && oldPropsAnimated.__detach();
    };

    _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(newProps) {
      this._attachProps(newProps);
    };

    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      if (this._component !== this._prevComponent) {
        this._propsAnimated.setNativeView(this._component);
      }

      if (this._component !== this._prevComponent || prevProps !== this.props) {
        this._detachNativeEvents();

        this._attachNativeEvents();
      }
    };

    _proto.render = function render() {
      var props = this._propsAnimated.__getValue();

      return external_react_default.a.createElement(Component, _extends({}, props, {
        ref: this._setComponentRef // The native driver updates views directly through the UI thread so we
        // have to make sure the view doesn't get optimized away because it cannot
        // go through the NativeViewHierarchyManager since it operates on the shadow
        // thread.
        ,
        collapsable: this._propsAnimated.__isNative ? false : props.collapsable
      }));
    };

    _proto._setComponentRef = function _setComponentRef(c) {
      this._prevComponent = this._component;
      this._component = c;
    } // A third party library can use getNode()
    // to get the node reference of the decorated component
    ;

    _proto.getNode = function getNode() {
      return this._component;
    };

    return AnimatedComponent;
  }(external_react_default.a.Component);

  AnimatedComponent.__skipSetNativeProps_FOR_TESTS_ONLY = false;
  var propTypes = Component.propTypes;
  AnimatedComponent.propTypes =  false ? undefined : {};
  return AnimatedComponent;
}

/* harmony default export */ var Animated_createAnimatedComponent = (createAnimatedComponent);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/AnimatedImplementation.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 * @preventMunge
 */


function AnimatedImplementation_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { AnimatedImplementation_defineProperty(target, key, source[key]); }); } return target; }

function AnimatedImplementation_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


















var AnimatedImplementation_add = function add(a, b) {
  return new nodes_AnimatedAddition(a, b);
};

var AnimatedImplementation_divide = function divide(a, b) {
  return new nodes_AnimatedDivision(a, b);
};

var AnimatedImplementation_multiply = function multiply(a, b) {
  return new nodes_AnimatedMultiplication(a, b);
};

var AnimatedImplementation_modulo = function modulo(a, modulus) {
  return new nodes_AnimatedModulo(a, modulus);
};

var AnimatedImplementation_diffClamp = function diffClamp(a, min, max) {
  return new nodes_AnimatedDiffClamp(a, min, max);
};

var _combineCallbacks = function _combineCallbacks(callback, config) {
  if (callback && config.onComplete) {
    return function () {
      config.onComplete && config.onComplete.apply(config, arguments);
      callback && callback.apply(void 0, arguments);
    };
  } else {
    return callback || config.onComplete;
  }
};

var AnimatedImplementation_maybeVectorAnim = function maybeVectorAnim(value, config, anim) {
  if (value instanceof AnimatedValueXY["a" /* default */]) {
    var configX = AnimatedImplementation_objectSpread({}, config);

    var configY = AnimatedImplementation_objectSpread({}, config);

    for (var key in config) {
      var _config$key = config[key],
          x = _config$key.x,
          y = _config$key.y;

      if (x !== undefined && y !== undefined) {
        configX[key] = x;
        configY[key] = y;
      }
    }

    var aX = anim(value.x, configX);
    var aY = anim(value.y, configY); // We use `stopTogether: false` here because otherwise tracking will break
    // because the second animation will get stopped before it can update.

    return parallel([aX, aY], {
      stopTogether: false
    });
  }

  return null;
};

var AnimatedImplementation_spring = function spring(value, config) {
  var _start = function start(animatedValue, configuration, callback) {
    callback = _combineCallbacks(callback, configuration);
    var singleValue = animatedValue;
    var singleConfig = configuration;
    singleValue.stopTracking();

    if (configuration.toValue instanceof AnimatedNode["a" /* default */]) {
      singleValue.track(new nodes_AnimatedTracking(singleValue, configuration.toValue, SpringAnimation["a" /* default */], singleConfig, callback));
    } else {
      singleValue.animate(new SpringAnimation["a" /* default */](singleConfig), callback);
    }
  };

  return AnimatedImplementation_maybeVectorAnim(value, config, spring) || {
    start: function start(callback) {
      _start(value, config, callback);
    },
    stop: function stop() {
      value.stopAnimation();
    },
    reset: function reset() {
      value.resetAnimation();
    },
    _startNativeLoop: function _startNativeLoop(iterations) {
      var singleConfig = AnimatedImplementation_objectSpread({}, config, {
        iterations: iterations
      });

      _start(value, singleConfig);
    },
    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return config.useNativeDriver || false;
    }
  };
};

var AnimatedImplementation_timing = function timing(value, config) {
  var _start2 = function start(animatedValue, configuration, callback) {
    callback = _combineCallbacks(callback, configuration);
    var singleValue = animatedValue;
    var singleConfig = configuration;
    singleValue.stopTracking();

    if (configuration.toValue instanceof AnimatedNode["a" /* default */]) {
      singleValue.track(new nodes_AnimatedTracking(singleValue, configuration.toValue, TimingAnimation["a" /* default */], singleConfig, callback));
    } else {
      singleValue.animate(new TimingAnimation["a" /* default */](singleConfig), callback);
    }
  };

  return AnimatedImplementation_maybeVectorAnim(value, config, timing) || {
    start: function start(callback) {
      _start2(value, config, callback);
    },
    stop: function stop() {
      value.stopAnimation();
    },
    reset: function reset() {
      value.resetAnimation();
    },
    _startNativeLoop: function _startNativeLoop(iterations) {
      var singleConfig = AnimatedImplementation_objectSpread({}, config, {
        iterations: iterations
      });

      _start2(value, singleConfig);
    },
    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return config.useNativeDriver || false;
    }
  };
};

var AnimatedImplementation_decay = function decay(value, config) {
  var _start3 = function start(animatedValue, configuration, callback) {
    callback = _combineCallbacks(callback, configuration);
    var singleValue = animatedValue;
    var singleConfig = configuration;
    singleValue.stopTracking();
    singleValue.animate(new DecayAnimation["a" /* default */](singleConfig), callback);
  };

  return AnimatedImplementation_maybeVectorAnim(value, config, decay) || {
    start: function start(callback) {
      _start3(value, config, callback);
    },
    stop: function stop() {
      value.stopAnimation();
    },
    reset: function reset() {
      value.resetAnimation();
    },
    _startNativeLoop: function _startNativeLoop(iterations) {
      var singleConfig = AnimatedImplementation_objectSpread({}, config, {
        iterations: iterations
      });

      _start3(value, singleConfig);
    },
    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return config.useNativeDriver || false;
    }
  };
};

var sequence = function sequence(animations) {
  var current = 0;
  return {
    start: function start(callback) {
      var onComplete = function onComplete(result) {
        if (!result.finished) {
          callback && callback(result);
          return;
        }

        current++;

        if (current === animations.length) {
          callback && callback(result);
          return;
        }

        animations[current].start(onComplete);
      };

      if (animations.length === 0) {
        callback && callback({
          finished: true
        });
      } else {
        animations[current].start(onComplete);
      }
    },
    stop: function stop() {
      if (current < animations.length) {
        animations[current].stop();
      }
    },
    reset: function reset() {
      animations.forEach(function (animation, idx) {
        if (idx <= current) {
          animation.reset();
        }
      });
      current = 0;
    },
    _startNativeLoop: function _startNativeLoop() {
      throw new Error('Loops run using the native driver cannot contain Animated.sequence animations');
    },
    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return false;
    }
  };
};

var parallel = function parallel(animations, config) {
  var doneCount = 0; // Make sure we only call stop() at most once for each animation

  var hasEnded = {};
  var stopTogether = !(config && config.stopTogether === false);
  var result = {
    start: function start(callback) {
      if (doneCount === animations.length) {
        callback && callback({
          finished: true
        });
        return;
      }

      animations.forEach(function (animation, idx) {
        var cb = function cb(endResult) {
          hasEnded[idx] = true;
          doneCount++;

          if (doneCount === animations.length) {
            doneCount = 0;
            callback && callback(endResult);
            return;
          }

          if (!endResult.finished && stopTogether) {
            result.stop();
          }
        };

        if (!animation) {
          cb({
            finished: true
          });
        } else {
          animation.start(cb);
        }
      });
    },
    stop: function stop() {
      animations.forEach(function (animation, idx) {
        !hasEnded[idx] && animation.stop();
        hasEnded[idx] = true;
      });
    },
    reset: function reset() {
      animations.forEach(function (animation, idx) {
        animation.reset();
        hasEnded[idx] = false;
        doneCount = 0;
      });
    },
    _startNativeLoop: function _startNativeLoop() {
      throw new Error('Loops run using the native driver cannot contain Animated.parallel animations');
    },
    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return false;
    }
  };
  return result;
};

var AnimatedImplementation_delay = function delay(time) {
  // Would be nice to make a specialized implementation
  return AnimatedImplementation_timing(new AnimatedValue["a" /* default */](0), {
    toValue: 0,
    delay: time,
    duration: 0
  });
};

var stagger = function stagger(time, animations) {
  return parallel(animations.map(function (animation, i) {
    return sequence([AnimatedImplementation_delay(time * i), animation]);
  }));
};

var loop = function loop(animation, _temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$iterations = _ref.iterations,
      iterations = _ref$iterations === void 0 ? -1 : _ref$iterations;

  var isFinished = false;
  var iterationsSoFar = 0;
  return {
    start: function start(callback) {
      var restart = function restart(result) {
        if (result === void 0) {
          result = {
            finished: true
          };
        }

        if (isFinished || iterationsSoFar === iterations || result.finished === false) {
          callback && callback(result);
        } else {
          iterationsSoFar++;
          animation.reset();
          animation.start(restart);
        }
      };

      if (!animation || iterations === 0) {
        callback && callback({
          finished: true
        });
      } else {
        if (animation._isUsingNativeDriver()) {
          animation._startNativeLoop(iterations);
        } else {
          restart(); // Start looping recursively on the js thread
        }
      }
    },
    stop: function stop() {
      isFinished = true;
      animation.stop();
    },
    reset: function reset() {
      iterationsSoFar = 0;
      isFinished = false;
      animation.reset();
    },
    _startNativeLoop: function _startNativeLoop() {
      throw new Error('Loops run using the native driver cannot contain Animated.loop animations');
    },
    _isUsingNativeDriver: function _isUsingNativeDriver() {
      return animation._isUsingNativeDriver();
    }
  };
};

function forkEvent(event, listener) {
  if (!event) {
    return listener;
  } else if (event instanceof AnimatedEvent_AnimatedEvent) {
    event.__addListener(listener);

    return event;
  } else {
    return function () {
      typeof event === 'function' && event.apply(void 0, arguments);
      listener.apply(void 0, arguments);
    };
  }
}

function unforkEvent(event, listener) {
  if (event && event instanceof AnimatedEvent_AnimatedEvent) {
    event.__removeListener(listener);
  }
}

var AnimatedImplementation_event = function event(argMapping, config) {
  var animatedEvent = new AnimatedEvent_AnimatedEvent(argMapping, config);

  if (animatedEvent.__isNative) {
    return animatedEvent;
  } else {
    return animatedEvent.__getHandler();
  }
};
/**
 * The `Animated` library is designed to make animations fluid, powerful, and
 * easy to build and maintain. `Animated` focuses on declarative relationships
 * between inputs and outputs, with configurable transforms in between, and
 * simple `start`/`stop` methods to control time-based animation execution.
 *
 * See http://facebook.github.io/react-native/docs/animated.html
 */


var AnimatedImplementation = {
  /**
   * Standard value class for driving animations.  Typically initialized with
   * `new Animated.Value(0);`
   *
   * See http://facebook.github.io/react-native/docs/animated.html#value
   */
  Value: AnimatedValue["a" /* default */],

  /**
   * 2D value class for driving 2D animations, such as pan gestures.
   *
   * See https://facebook.github.io/react-native/releases/next/docs/animatedvaluexy.html
   */
  ValueXY: AnimatedValueXY["a" /* default */],

  /**
   * Exported to use the Interpolation type in flow.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#interpolation
   */
  Interpolation: AnimatedInterpolation["a" /* default */],

  /**
   * Exported for ease of type checking. All animated values derive from this
   * class.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#node
   */
  Node: AnimatedNode["a" /* default */],

  /**
   * Animates a value from an initial velocity to zero based on a decay
   * coefficient.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#decay
   */
  decay: AnimatedImplementation_decay,

  /**
   * Animates a value along a timed easing curve. The Easing module has tons of
   * predefined curves, or you can use your own function.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#timing
   */
  timing: AnimatedImplementation_timing,

  /**
   * Animates a value according to an analytical spring model based on
   * damped harmonic oscillation.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#spring
   */
  spring: AnimatedImplementation_spring,

  /**
   * Creates a new Animated value composed from two Animated values added
   * together.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#add
   */
  add: AnimatedImplementation_add,

  /**
   * Creates a new Animated value composed by dividing the first Animated value
   * by the second Animated value.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#divide
   */
  divide: AnimatedImplementation_divide,

  /**
   * Creates a new Animated value composed from two Animated values multiplied
   * together.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#multiply
   */
  multiply: AnimatedImplementation_multiply,

  /**
   * Creates a new Animated value that is the (non-negative) modulo of the
   * provided Animated value.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#modulo
   */
  modulo: AnimatedImplementation_modulo,

  /**
   * Create a new Animated value that is limited between 2 values. It uses the
   * difference between the last value so even if the value is far from the
   * bounds it will start changing when the value starts getting closer again.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#diffclamp
   */
  diffClamp: AnimatedImplementation_diffClamp,

  /**
   * Starts an animation after the given delay.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#delay
   */
  delay: AnimatedImplementation_delay,

  /**
   * Starts an array of animations in order, waiting for each to complete
   * before starting the next. If the current running animation is stopped, no
   * following animations will be started.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#sequence
   */
  sequence: sequence,

  /**
   * Starts an array of animations all at the same time. By default, if one
   * of the animations is stopped, they will all be stopped. You can override
   * this with the `stopTogether` flag.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#parallel
   */
  parallel: parallel,

  /**
   * Array of animations may run in parallel (overlap), but are started in
   * sequence with successive delays.  Nice for doing trailing effects.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#stagger
   */
  stagger: stagger,

  /**
   * Loops a given animation continuously, so that each time it reaches the
   * end, it resets and begins again from the start.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#loop
   */
  loop: loop,

  /**
   * Takes an array of mappings and extracts values from each arg accordingly,
   * then calls `setValue` on the mapped outputs.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#event
   */
  event: AnimatedImplementation_event,

  /**
   * Make any React component Animatable.  Used to create `Animated.View`, etc.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#createanimatedcomponent
   */
  createAnimatedComponent: Animated_createAnimatedComponent,

  /**
   * Imperative API to attach an animated value to an event on a view. Prefer
   * using `Animated.event` with `useNativeDrive: true` if possible.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#attachnativeevent
   */
  attachNativeEvent: attachNativeEvent,

  /**
   * Advanced imperative API for snooping on animated events that are passed in
   * through props. Use values directly where possible.
   *
   * See http://facebook.github.io/react-native/docs/animated.html#forkevent
   */
  forkEvent: forkEvent,
  unforkEvent: unforkEvent,
  __PropsOnlyForTests: nodes_AnimatedProps
};
/* harmony default export */ var Animated_AnimatedImplementation = (AnimatedImplementation);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/UIManager/index.js + 2 modules
var UIManager = __webpack_require__(8);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/NativeMethodsMixin/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var NativeMethodsMixin = {
  /**
   * Removes focus from an input or view. This is the opposite of `focus()`.
   */
  blur: function blur() {
    UIManager["a" /* default */].blur(exports_findNodeHandle(this));
  },

  /**
   * Requests focus for the given input or view.
   * The exact behavior triggered will depend the type of view.
   */
  focus: function focus() {
    UIManager["a" /* default */].focus(exports_findNodeHandle(this));
  },

  /**
   * Determines the position and dimensions of the view
   */
  measure: function measure(callback) {
    UIManager["a" /* default */].measure(exports_findNodeHandle(this), callback);
  },

  /**
   * Determines the location of the given view in the window and returns the
   * values via an async callback. If the React root view is embedded in
   * another native view, this will give you the absolute coordinates. If
   * successful, the callback will be called be called with the following
   * arguments:
   *
   *  - x
   *  - y
   *  - width
   *  - height
   *
   * Note that these measurements are not available until after the rendering
   * has been completed.
   */
  measureInWindow: function measureInWindow(callback) {
    UIManager["a" /* default */].measureInWindow(exports_findNodeHandle(this), callback);
  },

  /**
   * Measures the view relative to another view (usually an ancestor)
   */
  measureLayout: function measureLayout(relativeToNativeNode, onSuccess, onFail) {
    UIManager["a" /* default */].measureLayout(exports_findNodeHandle(this), relativeToNativeNode, onFail, onSuccess);
  },

  /**
   * This function sends props straight to the underlying DOM node.
   * This works as if all styles were set as inline styles. Since a DOM node
   * may aleady be styled with class names and inline styles, we need to get
   * the initial styles from the DOM node and merge them with incoming props.
   */
  setNativeProps: function setNativeProps(nativeProps) {
    if (!nativeProps) {
      return;
    }

    var node = exports_findNodeHandle(this);

    if (node) {
      // Next state is determined by comparison to existing state (in the DOM).
      // Existing state has already gone through i18n transform
      var domProps = modules_createDOMProps(null, nativeProps, function (style) {
        return StyleSheet_styleResolver.resolveWithNode(style, node);
      });
      UIManager["a" /* default */].updateView(node, domProps, this);
    }
  }
};
/* harmony default export */ var modules_NativeMethodsMixin = (NativeMethodsMixin);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/applyNativeMethods/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var applyNativeMethods_applyNativeMethods = function applyNativeMethods(Component) {
  Object.keys(modules_NativeMethodsMixin).forEach(function (method) {
    if (!Component.prototype[method]) {
      Component.prototype[method] = modules_NativeMethodsMixin[method];
    }
  });
  return Component;
};

/* harmony default export */ var modules_applyNativeMethods = (applyNativeMethods_applyNativeMethods);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/AssetRegistry/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var assets = [];
function registerAsset(asset) {
  // `push` returns new array length, so the first asset will
  // get id 1 (not 0) to make the value truthy
  return assets.push(asset);
}
function getAssetByID(assetId) {
  return assets[assetId - 1];
}
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/ImageLoader/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var ImageLoader_id = 0;
var requests = {};
var ImageLoader = {
  abort: function abort(requestId) {
    var image = requests["" + requestId];

    if (image) {
      image.onerror = image.onload = image = null;
      delete requests["" + requestId];
    }
  },
  getSize: function getSize(uri, success, failure) {
    var complete = false;
    var interval = setInterval(callback, 16);
    var requestId = ImageLoader.load(uri, callback, errorCallback);

    function callback() {
      var image = requests["" + requestId];

      if (image) {
        var naturalHeight = image.naturalHeight,
            naturalWidth = image.naturalWidth;

        if (naturalHeight && naturalWidth) {
          success(naturalWidth, naturalHeight);
          complete = true;
        }
      }

      if (complete) {
        ImageLoader.abort(requestId);
        clearInterval(interval);
      }
    }

    function errorCallback() {
      if (typeof failure === 'function') {
        failure();
      }

      ImageLoader.abort(requestId);
      clearInterval(interval);
    }
  },
  load: function load(uri, onLoad, onError) {
    ImageLoader_id += 1;
    var image = new window.Image();
    image.onerror = onError;

    image.onload = function (e) {
      // avoid blocking the main thread
      var onDecode = function onDecode() {
        return onLoad(e);
      };

      if (typeof image.decode === 'function') {
        // Safari currently throws exceptions when decoding svgs.
        // We want to catch that error and allow the load handler
        // to be forwarded to the onLoad handler in this case
        image.decode().then(onDecode, onDecode);
      } else {
        setTimeout(onDecode, 0);
      }
    };

    image.src = uri;
    requests["" + ImageLoader_id] = image;
    return ImageLoader_id;
  },
  prefetch: function prefetch(uri) {
    return new Promise(function (resolve, reject) {
      ImageLoader.load(uri, resolve, reject);
    });
  }
};
/* harmony default export */ var modules_ImageLoader = (ImageLoader);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Image/ImageResizeMode.js
var ImageResizeMode = {
  center: 'center',
  contain: 'contain',
  cover: 'cover',
  none: 'none',
  repeat: 'repeat',
  stretch: 'stretch'
};
/* harmony default export */ var Image_ImageResizeMode = (ImageResizeMode);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Image/ImageUriCache.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var dataUriPattern = /^data:/;

var ImageUriCache =
/*#__PURE__*/
function () {
  function ImageUriCache() {}

  ImageUriCache.has = function has(uri) {
    var entries = ImageUriCache._entries;
    var isDataUri = dataUriPattern.test(uri);
    return isDataUri || Boolean(entries[uri]);
  };

  ImageUriCache.add = function add(uri) {
    var entries = ImageUriCache._entries;
    var lastUsedTimestamp = Date.now();

    if (entries[uri]) {
      entries[uri].lastUsedTimestamp = lastUsedTimestamp;
      entries[uri].refCount += 1;
    } else {
      entries[uri] = {
        lastUsedTimestamp: lastUsedTimestamp,
        refCount: 1
      };
    }
  };

  ImageUriCache.remove = function remove(uri) {
    var entries = ImageUriCache._entries;

    if (entries[uri]) {
      entries[uri].refCount -= 1;
    } // Free up entries when the cache is "full"


    ImageUriCache._cleanUpIfNeeded();
  };

  ImageUriCache._cleanUpIfNeeded = function _cleanUpIfNeeded() {
    var entries = ImageUriCache._entries;
    var imageUris = Object.keys(entries);

    if (imageUris.length + 1 > ImageUriCache._maximumEntries) {
      var leastRecentlyUsedKey;
      var leastRecentlyUsedEntry;
      imageUris.forEach(function (uri) {
        var entry = entries[uri];

        if ((!leastRecentlyUsedEntry || entry.lastUsedTimestamp < leastRecentlyUsedEntry.lastUsedTimestamp) && entry.refCount === 0) {
          leastRecentlyUsedKey = uri;
          leastRecentlyUsedEntry = entry;
        }
      });

      if (leastRecentlyUsedKey) {
        delete entries[leastRecentlyUsedKey];
      }
    }
  };

  return ImageUriCache;
}();

ImageUriCache._maximumEntries = 256;
ImageUriCache._entries = {};

// EXTERNAL MODULE: ./node_modules/debounce/index.js
var debounce = __webpack_require__(38);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/applyLayout/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var applyLayout_emptyObject = {};
var registry = {};
var applyLayout_id = 1;

var guid = function guid() {
  return "r-" + applyLayout_id++;
};

var resizeObserver;

if (ExecutionEnvironment["canUseDOM"]) {
  if (typeof window.ResizeObserver !== 'undefined') {
    resizeObserver = new window.ResizeObserver(function (entries) {
      entries.forEach(function (_ref) {
        var target = _ref.target;
        var instance = registry[target._layoutId];
        instance && instance._handleLayout();
      });
    });
  } else {
    if (false) {}

    var triggerAll = function triggerAll() {
      Object.keys(registry).forEach(function (key) {
        var instance = registry[key];

        instance._handleLayout();
      });
    };

    window.addEventListener('resize', debounce_default()(triggerAll, 16), false);
  }
}

var applyLayout_observe = function observe(instance) {
  var id = guid();
  registry[id] = instance;

  if (resizeObserver) {
    var node = exports_findNodeHandle(instance);

    if (node) {
      node._layoutId = id;
      resizeObserver.observe(node);
    }
  } else {
    instance._layoutId = id;

    instance._handleLayout();
  }
};

var applyLayout_unobserve = function unobserve(instance) {
  if (resizeObserver) {
    var node = exports_findNodeHandle(instance);

    if (node) {
      delete registry[node._layoutId];
      delete node._layoutId;
      resizeObserver.unobserve(node);
    }
  } else {
    delete registry[instance._layoutId];
    delete instance._layoutId;
  }
};

var safeOverride = function safeOverride(original, next) {
  if (original) {
    return function prototypeOverride() {
      /* eslint-disable prefer-rest-params */
      original.call(this, arguments);
      next.call(this, arguments);
      /* eslint-enable prefer-rest-params */
    };
  }

  return next;
};

var applyLayout_applyLayout = function applyLayout(Component) {
  var componentDidMount = Component.prototype.componentDidMount;
  var componentDidUpdate = Component.prototype.componentDidUpdate;
  var componentWillUnmount = Component.prototype.componentWillUnmount;
  Component.prototype.componentDidMount = safeOverride(componentDidMount, function componentDidMount() {
    this._layoutState = applyLayout_emptyObject;
    this._isMounted = true;

    if (this.props.onLayout) {
      applyLayout_observe(this);
    }
  });
  Component.prototype.componentDidUpdate = safeOverride(componentDidUpdate, function componentDidUpdate(prevProps) {
    if (this.props.onLayout && !prevProps.onLayout) {
      applyLayout_observe(this);
    } else if (!this.props.onLayout && prevProps.onLayout) {
      applyLayout_unobserve(this);
    }
  });
  Component.prototype.componentWillUnmount = safeOverride(componentWillUnmount, function componentWillUnmount() {
    this._isMounted = false;

    if (this.props.onLayout) {
      applyLayout_unobserve(this);
    }
  });

  Component.prototype._handleLayout = function () {
    var _this = this;

    var layout = this._layoutState;
    var onLayout = this.props.onLayout;

    if (onLayout) {
      this.measure(function (x, y, width, height) {
        if (_this._isMounted) {
          if (layout.x !== x || layout.y !== y || layout.width !== width || layout.height !== height) {
            _this._layoutState = {
              x: x,
              y: y,
              width: width,
              height: height
            };
            var nativeEvent = {
              layout: _this._layoutState
            };
            Object.defineProperty(nativeEvent, 'target', {
              enumerable: true,
              get: function get() {
                return exports_findNodeHandle(_this);
              }
            });
            onLayout({
              nativeEvent: nativeEvent,
              timeStamp: Date.now()
            });
          }
        }
      });
    }
  };

  return Component;
};

/* harmony default export */ var modules_applyLayout = (applyLayout_applyLayout);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/View/filterSupportedProps.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var filterSupportedProps_supportedProps = {
  accessibilityComponentType: true,
  accessibilityLabel: true,
  accessibilityLiveRegion: true,
  accessibilityRole: true,
  accessibilityStates: true,
  accessibilityTraits: true,
  accessible: true,
  children: true,
  disabled: true,
  importantForAccessibility: true,
  nativeID: true,
  onBlur: true,
  onContextMenu: true,
  onFocus: true,
  onMoveShouldSetResponder: true,
  onMoveShouldSetResponderCapture: true,
  onResponderEnd: true,
  onResponderGrant: true,
  onResponderMove: true,
  onResponderReject: true,
  onResponderRelease: true,
  onResponderStart: true,
  onResponderTerminate: true,
  onResponderTerminationRequest: true,
  onScrollShouldSetResponder: true,
  onScrollShouldSetResponderCapture: true,
  onSelectionChangeShouldSetResponder: true,
  onSelectionChangeShouldSetResponderCapture: true,
  onStartShouldSetResponder: true,
  onStartShouldSetResponderCapture: true,
  onTouchCancel: true,
  onTouchCancelCapture: true,
  onTouchEnd: true,
  onTouchEndCapture: true,
  onTouchMove: true,
  onTouchMoveCapture: true,
  onTouchStart: true,
  onTouchStartCapture: true,
  pointerEvents: true,
  style: true,
  testID: true,

  /* @platform web */
  onScroll: true,
  onWheel: true,
  // keyboard events
  onKeyDown: true,
  onKeyPress: true,
  onKeyUp: true,
  // mouse events (e.g, hover effects)
  onMouseDown: true,
  onMouseEnter: true,
  onMouseLeave: true,
  onMouseMove: true,
  onMouseOver: true,
  onMouseOut: true,
  onMouseUp: true,
  // unstable escape-hatches for web
  className: true,
  href: true,
  itemID: true,
  itemRef: true,
  itemProp: true,
  itemScope: true,
  itemType: true,
  onClick: true,
  onClickCapture: true,
  rel: true,
  target: true
};

var filterSupportedProps = function filterSupportedProps(props) {
  var safeProps = {};

  for (var prop in props) {
    if (props.hasOwnProperty(prop)) {
      if (filterSupportedProps_supportedProps[prop] || prop.indexOf('aria-') === 0 || prop.indexOf('data-') === 0) {
        safeProps[prop] = props[prop];
      }
    }
  }

  return safeProps;
};

/* harmony default export */ var View_filterSupportedProps = (filterSupportedProps);
// EXTERNAL MODULE: ./node_modules/react-native-web/node_modules/fbjs/lib/warning.js
var lib_warning = __webpack_require__(15);
var warning_default = /*#__PURE__*/__webpack_require__.n(lib_warning);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/View/index.js
function View_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */












var calculateHitSlopStyle = function calculateHitSlopStyle(hitSlop) {
  var hitStyle = {};

  for (var prop in hitSlop) {
    if (hitSlop.hasOwnProperty(prop)) {
      var value = hitSlop[prop];
      hitStyle[prop] = value > 0 ? -1 * value : 0;
    }
  }

  return hitStyle;
};

var View_View =
/*#__PURE__*/
function (_Component) {
  View_inheritsLoose(View, _Component);

  function View() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = View.prototype;

  _proto.render = function render() {
    var hitSlop = this.props.hitSlop;
    var supportedProps = View_filterSupportedProps(this.props);

    if (false) {}

    var isInAParentText = this.context.isInAParentText;
    supportedProps.classList = [this.props.className, View_classes.view];
    supportedProps.style = exports_StyleSheet.compose(isInAParentText && View_styles.inline, this.props.style);

    if (hitSlop) {
      var hitSlopStyle = calculateHitSlopStyle(hitSlop);
      var hitSlopChild = exports_createElement('span', {
        classList: [View_classes.hitSlop],
        style: hitSlopStyle
      });
      supportedProps.children = external_react_default.a.Children.toArray([hitSlopChild, supportedProps.children]);
    }

    return exports_createElement('div', supportedProps);
  };

  return View;
}(external_react_["Component"]);

View_View.displayName = 'View';
View_View.contextTypes = {
  isInAParentText: external_prop_types_["bool"]
};
View_View.propTypes =  false ? undefined : {};
var View_classes = StyleSheet_css.create({
  view: {
    alignItems: 'stretch',
    border: '0 solid black',
    boxSizing: 'border-box',
    display: 'flex',
    flexBasis: 'auto',
    flexDirection: 'column',
    flexShrink: 0,
    margin: 0,
    minHeight: 0,
    minWidth: 0,
    padding: 0,
    position: 'relative',
    zIndex: 0
  },
  // this zIndex-ordering positions the hitSlop above the View but behind
  // its children
  hitSlop: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: -1
  }
});
var View_styles = exports_StyleSheet.create({
  inline: {
    display: 'inline-flex'
  }
});
/* harmony default export */ var exports_View = (modules_applyLayout(modules_applyNativeMethods(View_View)));
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Image/index.js
function Image_extends() { Image_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Image_extends.apply(this, arguments); }

function Image_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { Image_defineProperty(target, key, source[key]); }); } return target; }

function Image_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Image_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Image_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
















var Image_emptyObject = {};
var STATUS_ERRORED = 'ERRORED';
var STATUS_LOADED = 'LOADED';
var STATUS_LOADING = 'LOADING';
var STATUS_PENDING = 'PENDING';
var STATUS_IDLE = 'IDLE';

var getImageState = function getImageState(uri, shouldDisplaySource) {
  return shouldDisplaySource ? STATUS_LOADED : uri ? STATUS_PENDING : STATUS_IDLE;
};

var Image_resolveAssetDimensions = function resolveAssetDimensions(source) {
  if (typeof source === 'number') {
    var _getAssetByID = getAssetByID(source),
        height = _getAssetByID.height,
        width = _getAssetByID.width;

    return {
      height: height,
      width: width
    };
  } else if (typeof source === 'object') {
    var _height = source.height,
        _width = source.width;
    return {
      height: _height,
      width: _width
    };
  }
};

var svgDataUriPattern = /^(data:image\/svg\+xml;utf8,)(.*)/;

var Image_resolveAssetUri = function resolveAssetUri(source) {
  var uri = '';

  if (typeof source === 'number') {
    // get the URI from the packager
    var asset = getAssetByID(source);
    var scale = asset.scales[0];
    var scaleSuffix = scale !== 1 ? "@" + scale + "x" : '';
    uri = asset ? asset.httpServerLocation + "/" + asset.name + scaleSuffix + "." + asset.type : '';
  } else if (typeof source === 'string') {
    uri = source;
  } else if (source && typeof source.uri === 'string') {
    uri = source.uri;
  }

  if (uri) {
    var match = uri.match(svgDataUriPattern); // inline SVG markup may contain characters (e.g., #, ") that need to be escaped

    if (match) {
      var prefix = match[1],
          svg = match[2];
      var encodedSvg = encodeURIComponent(svg);
      return "" + prefix + encodedSvg;
    }
  }

  return uri;
};

var filterId = 0;

var Image_createTintColorSVG = function createTintColorSVG(tintColor, id) {
  return tintColor && id != null ? external_react_default.a.createElement("svg", {
    style: {
      position: 'absolute',
      height: 0,
      visibility: 'hidden',
      width: 0
    }
  }, external_react_default.a.createElement("defs", null, external_react_default.a.createElement("filter", {
    id: "tint-" + id
  }, external_react_default.a.createElement("feFlood", {
    floodColor: "" + tintColor
  }), external_react_default.a.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "atop"
  })))) : null;
};

var Image_Image =
/*#__PURE__*/
function (_Component) {
  Image_inheritsLoose(Image, _Component);

  Image.getSize = function getSize(uri, success, failure) {
    modules_ImageLoader.getSize(uri, success, failure);
  };

  Image.prefetch = function prefetch(uri) {
    return modules_ImageLoader.prefetch(uri).then(function () {
      // Add the uri to the cache so it can be immediately displayed when used
      // but also immediately remove it to correctly reflect that it has no active references
      ImageUriCache.add(uri);
      ImageUriCache.remove(uri);
    });
  };

  Image.queryCache = function queryCache(uris) {
    var result = {};
    uris.forEach(function (u) {
      if (ImageUriCache.has(u)) {
        result[u] = 'disk/memory';
      }
    });
    return Promise.resolve(result);
  };

  function Image(props, context) {
    var _this;

    _this = _Component.call(this, props, context) || this; // If an image has been loaded before, render it immediately

    _this._filterId = 0;
    _this._imageRef = null;
    _this._imageRequestId = null;
    _this._imageState = null;
    _this._isMounted = false;

    _this._createLayoutHandler = function (resizeMode) {
      var onLayout = _this.props.onLayout;

      if (resizeMode === 'center' || resizeMode === 'repeat' || onLayout) {
        return function (e) {
          var layout = e.nativeEvent.layout;
          onLayout && onLayout(e);

          _this.setState(function () {
            return {
              layout: layout
            };
          });
        };
      }
    };

    _this._getBackgroundSize = function (resizeMode) {
      if (_this._imageRef && (resizeMode === 'center' || resizeMode === 'repeat')) {
        var _this$_imageRef = _this._imageRef,
            naturalHeight = _this$_imageRef.naturalHeight,
            naturalWidth = _this$_imageRef.naturalWidth;
        var _this$state$layout = _this.state.layout,
            height = _this$state$layout.height,
            width = _this$state$layout.width;

        if (naturalHeight && naturalWidth && height && width) {
          var scaleFactor = Math.min(1, width / naturalWidth, height / naturalHeight);
          var x = Math.ceil(scaleFactor * naturalWidth);
          var y = Math.ceil(scaleFactor * naturalHeight);
          return {
            backgroundSize: x + "px " + y + "px"
          };
        }
      }
    };

    _this._onError = function () {
      var _this$props = _this.props,
          onError = _this$props.onError,
          source = _this$props.source;

      _this._updateImageState(STATUS_ERRORED);

      if (onError) {
        onError({
          nativeEvent: {
            error: "Failed to load resource " + Image_resolveAssetUri(source) + " (404)"
          }
        });
      }

      _this._onLoadEnd();
    };

    _this._onLoad = function (e) {
      var _this$props2 = _this.props,
          onLoad = _this$props2.onLoad,
          source = _this$props2.source;
      var event = {
        nativeEvent: e
      };
      ImageUriCache.add(Image_resolveAssetUri(source));

      _this._updateImageState(STATUS_LOADED);

      if (onLoad) {
        onLoad(event);
      }

      _this._onLoadEnd();
    };

    _this._setImageRef = function (ref) {
      _this._imageRef = ref;
    };

    var uri = Image_resolveAssetUri(props.source);
    var shouldDisplaySource = ImageUriCache.has(uri);
    _this.state = {
      layout: {},
      shouldDisplaySource: shouldDisplaySource
    };
    _this._imageState = getImageState(uri, shouldDisplaySource);
    _this._filterId = filterId;
    filterId++;
    return _this;
  }

  var _proto = Image.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._imageState === STATUS_PENDING) {
      this._createImageLoader();
    } else if (this._imageState === STATUS_LOADED) {
      this._onLoad({
        target: this._imageRef
      });
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevUri = Image_resolveAssetUri(prevProps.source);
    var uri = Image_resolveAssetUri(this.props.source);
    var hasDefaultSource = this.props.defaultSource != null;

    if (prevUri !== uri) {
      ImageUriCache.remove(prevUri);
      var isPreviouslyLoaded = ImageUriCache.has(uri);
      isPreviouslyLoaded && ImageUriCache.add(uri);

      this._updateImageState(getImageState(uri, isPreviouslyLoaded), hasDefaultSource);
    } else if (hasDefaultSource && prevProps.defaultSource !== this.props.defaultSource) {
      this._updateImageState(this._imageState, hasDefaultSource);
    }

    if (this._imageState === STATUS_PENDING) {
      this._createImageLoader();
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    var uri = Image_resolveAssetUri(this.props.source);
    ImageUriCache.remove(uri);

    this._destroyImageLoader();

    this._isMounted = false;
  };

  _proto.render = function render() {
    var shouldDisplaySource = this.state.shouldDisplaySource;

    var _this$props3 = this.props,
        accessibilityLabel = _this$props3.accessibilityLabel,
        accessible = _this$props3.accessible,
        blurRadius = _this$props3.blurRadius,
        defaultSource = _this$props3.defaultSource,
        draggable = _this$props3.draggable,
        source = _this$props3.source,
        testID = _this$props3.testID,
        capInsets = _this$props3.capInsets,
        onError = _this$props3.onError,
        onLayout = _this$props3.onLayout,
        onLoad = _this$props3.onLoad,
        onLoadEnd = _this$props3.onLoadEnd,
        onLoadStart = _this$props3.onLoadStart,
        resizeMethod = _this$props3.resizeMethod,
        resizeMode = _this$props3.resizeMode,
        other = Image_objectWithoutPropertiesLoose(_this$props3, ["accessibilityLabel", "accessible", "blurRadius", "defaultSource", "draggable", "source", "testID", "capInsets", "onError", "onLayout", "onLoad", "onLoadEnd", "onLoadStart", "resizeMethod", "resizeMode"]);

    if (false) {}

    var selectedSource = shouldDisplaySource ? source : defaultSource;
    var displayImageUri = Image_resolveAssetUri(selectedSource);
    var imageSizeStyle = Image_resolveAssetDimensions(selectedSource);
    var backgroundImage = displayImageUri ? "url(\"" + displayImageUri + "\")" : null;

    var flatStyle = Image_objectSpread({}, exports_StyleSheet.flatten(this.props.style));

    var finalResizeMode = resizeMode || flatStyle.resizeMode || Image_ImageResizeMode.cover; // CSS filters

    var filters = [];
    var tintColor = flatStyle.tintColor;

    if (flatStyle.filter) {
      filters.push(flatStyle.filter);
    }

    if (blurRadius) {
      filters.push("blur(" + blurRadius + "px)");
    }

    if (flatStyle.shadowOffset) {
      var shadowString = StyleSheet_resolveShadowValue(flatStyle);

      if (shadowString) {
        filters.push("drop-shadow(" + shadowString + ")");
      }
    }

    if (flatStyle.tintColor) {
      filters.push("url(#tint-" + this._filterId + ")");
    } // these styles were converted to filters


    delete flatStyle.shadowColor;
    delete flatStyle.shadowOpacity;
    delete flatStyle.shadowOffset;
    delete flatStyle.shadowRadius;
    delete flatStyle.tintColor; // these styles are not supported on View

    delete flatStyle.overlayColor;
    delete flatStyle.resizeMode; // Accessibility image allows users to trigger the browser's image context menu

    var hiddenImage = displayImageUri ? exports_createElement('img', {
      alt: accessibilityLabel || '',
      classList: [Image_classes.accessibilityImage],
      draggable: draggable || false,
      ref: this._setImageRef,
      src: displayImageUri
    }) : null;
    return external_react_default.a.createElement(exports_View, Image_extends({}, other, {
      accessibilityLabel: accessibilityLabel,
      accessible: accessible,
      onLayout: this._createLayoutHandler(finalResizeMode),
      style: [Image_styles.root, this.context.isInAParentText && Image_styles.inline, imageSizeStyle, flatStyle],
      testID: testID
    }), external_react_default.a.createElement(exports_View, {
      style: [Image_styles.image, resizeModeStyles[finalResizeMode], this._getBackgroundSize(finalResizeMode), backgroundImage && {
        backgroundImage: backgroundImage
      }, filters.length > 0 && {
        filter: filters.join(' ')
      }]
    }), hiddenImage, Image_createTintColorSVG(tintColor, this._filterId));
  };

  _proto._createImageLoader = function _createImageLoader() {
    var source = this.props.source;

    this._destroyImageLoader();

    var uri = Image_resolveAssetUri(source);
    this._imageRequestId = modules_ImageLoader.load(uri, this._onLoad, this._onError);

    this._onLoadStart();
  };

  _proto._destroyImageLoader = function _destroyImageLoader() {
    if (this._imageRequestId) {
      modules_ImageLoader.abort(this._imageRequestId);
      this._imageRequestId = null;
    }
  };

  _proto._onLoadEnd = function _onLoadEnd() {
    var onLoadEnd = this.props.onLoadEnd;

    if (onLoadEnd) {
      onLoadEnd();
    }
  };

  _proto._onLoadStart = function _onLoadStart() {
    var _this$props4 = this.props,
        defaultSource = _this$props4.defaultSource,
        onLoadStart = _this$props4.onLoadStart;

    this._updateImageState(STATUS_LOADING, defaultSource != null);

    if (onLoadStart) {
      onLoadStart();
    }
  };

  _proto._updateImageState = function _updateImageState(status, hasDefaultSource) {
    if (hasDefaultSource === void 0) {
      hasDefaultSource = false;
    }

    this._imageState = status;
    var shouldDisplaySource = this._imageState === STATUS_LOADED || this._imageState === STATUS_LOADING && !hasDefaultSource; // only triggers a re-render when the image is loading and has no default image (to support PJPEG), loaded, or failed

    if (shouldDisplaySource !== this.state.shouldDisplaySource) {
      if (this._isMounted) {
        this.setState(function () {
          return {
            shouldDisplaySource: shouldDisplaySource
          };
        });
      }
    }
  };

  return Image;
}(external_react_["Component"]);

Image_Image.displayName = 'Image';
Image_Image.contextTypes = {
  isInAParentText: external_prop_types_["bool"]
};
Image_Image.defaultProps = {
  style: Image_emptyObject
};
Image_Image.propTypes =  false ? undefined : {};
var Image_classes = StyleSheet_css.create({
  accessibilityImage: Image_objectSpread({}, exports_StyleSheet.absoluteFillObject, {
    height: '100%',
    opacity: 0,
    width: '100%',
    zIndex: -1
  })
});
var Image_styles = exports_StyleSheet.create({
  root: {
    flexBasis: 'auto',
    overflow: 'hidden',
    zIndex: 0
  },
  inline: {
    display: 'inline-flex'
  },
  image: Image_objectSpread({}, exports_StyleSheet.absoluteFillObject, {
    backgroundColor: 'transparent',
    backgroundPosition: 'center',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    height: '100%',
    width: '100%',
    zIndex: -1
  })
});
var resizeModeStyles = exports_StyleSheet.create({
  center: {
    backgroundSize: 'auto'
  },
  contain: {
    backgroundSize: 'contain'
  },
  cover: {
    backgroundSize: 'cover'
  },
  none: {
    backgroundPosition: '0 0',
    backgroundSize: 'auto'
  },
  repeat: {
    backgroundPosition: '0 0',
    backgroundRepeat: 'repeat',
    backgroundSize: 'auto'
  },
  stretch: {
    backgroundSize: '100% 100%'
  }
});
/* harmony default export */ var exports_Image = (modules_applyNativeMethods(Image_Image));
// EXTERNAL MODULE: ./node_modules/create-react-class/index.js
var create_react_class = __webpack_require__(19);
var create_react_class_default = /*#__PURE__*/__webpack_require__.n(create_react_class);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/TextInputState/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * This class is responsible for coordinating the "focused"
 * state for TextInputs. All calls relating to the keyboard
 * should be funneled through here
 */

var TextInputState = {
  /**
   * Internal state
   */
  _currentlyFocusedNode: null,

  /**
   * Returns the ID of the currently focused text field, if one exists
   * If no text field is focused it returns null
   */
  currentlyFocusedField: function currentlyFocusedField() {
    if (document.activeElement !== this._currentlyFocusedNode) {
      this._currentlyFocusedNode = null;
    }

    return this._currentlyFocusedNode;
  },

  /**
   * @param {Object} TextInputID id of the text field to focus
   * Focuses the specified text field
   * noop if the text field was already focused
   */
  focusTextInput: function focusTextInput(textFieldNode) {
    if (textFieldNode !== null) {
      this._currentlyFocusedNode = textFieldNode;

      if (document.activeElement !== textFieldNode) {
        UIManager["a" /* default */].focus(textFieldNode);
      }
    }
  },

  /**
   * @param {Object} textFieldNode id of the text field to focus
   * Unfocuses the specified text field
   * noop if it wasn't focused
   */
  blurTextInput: function blurTextInput(textFieldNode) {
    if (textFieldNode !== null) {
      this._currentlyFocusedNode = null;

      if (document.activeElement === textFieldNode) {
        UIManager["a" /* default */].blur(textFieldNode);
      }
    }
  }
};
/* harmony default export */ var modules_TextInputState = (TextInputState);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/dismissKeyboard/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var dismissKeyboard_dismissKeyboard = function dismissKeyboard() {
  modules_TextInputState.blurTextInput(modules_TextInputState.currentlyFocusedField());
};

/* harmony default export */ var modules_dismissKeyboard = (dismissKeyboard_dismissKeyboard);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Dimensions/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var win = ExecutionEnvironment["canUseDOM"] ? window : {
  devicePixelRatio: undefined,
  innerHeight: undefined,
  innerWidth: undefined,
  screen: {
    height: undefined,
    width: undefined
  }
};
var dimensions = {};
var listeners = {};

var Dimensions_Dimensions =
/*#__PURE__*/
function () {
  function Dimensions() {}

  Dimensions.get = function get(dimension) {
    invariant_default()(dimensions[dimension], "No dimension set for key " + dimension);
    return dimensions[dimension];
  };

  Dimensions.set = function set(initialDimensions) {
    if (initialDimensions) {
      if (ExecutionEnvironment["canUseDOM"]) {
        invariant_default()(false, 'Dimensions cannot be set in the browser');
      } else {
        dimensions.screen = initialDimensions.screen;
        dimensions.window = initialDimensions.window;
      }
    }
  };

  Dimensions._update = function _update() {
    dimensions.window = {
      fontScale: 1,
      height: win.innerHeight,
      scale: win.devicePixelRatio || 1,
      width: win.innerWidth
    };
    dimensions.screen = {
      fontScale: 1,
      height: win.screen.height,
      scale: win.devicePixelRatio || 1,
      width: win.screen.width
    };

    if (Array.isArray(listeners['change'])) {
      listeners['change'].forEach(function (handler) {
        return handler(dimensions);
      });
    }
  };

  Dimensions.addEventListener = function addEventListener(type, handler) {
    listeners[type] = listeners[type] || [];
    listeners[type].push(handler);
  };

  Dimensions.removeEventListener = function removeEventListener(type, handler) {
    if (Array.isArray(listeners[type])) {
      listeners[type] = listeners[type].filter(function (_handler) {
        return _handler !== handler;
      });
    }
  };

  return Dimensions;
}();



Dimensions_Dimensions._update();

if (ExecutionEnvironment["canUseDOM"]) {
  window.addEventListener('resize', debounce_default()(Dimensions_Dimensions._update, 16), false);
}
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Platform/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var Platform = {
  OS: 'web',
  select: function select(obj) {
    return 'web' in obj ? obj.web : obj.default;
  }
};
/* harmony default export */ var exports_Platform = (Platform);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/ScrollResponder/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */







/**
 * Mixin that can be integrated in order to handle scrolling that plays well
 * with `ResponderEventPlugin`. Integrate with your platform specific scroll
 * views, or even your custom built (every-frame animating) scroll views so that
 * all of these systems play well with the `ResponderEventPlugin`.
 *
 * iOS scroll event timing nuances:
 * ===============================
 *
 *
 * Scrolling without bouncing, if you touch down:
 * -------------------------------
 *
 * 1. `onMomentumScrollBegin` (when animation begins after letting up)
 *    ... physical touch starts ...
 * 2. `onTouchStartCapture`   (when you press down to stop the scroll)
 * 3. `onTouchStart`          (same, but bubble phase)
 * 4. `onResponderRelease`    (when lifting up - you could pause forever before * lifting)
 * 5. `onMomentumScrollEnd`
 *
 *
 * Scrolling with bouncing, if you touch down:
 * -------------------------------
 *
 * 1. `onMomentumScrollBegin` (when animation begins after letting up)
 *    ... bounce begins ...
 *    ... some time elapses ...
 *    ... physical touch during bounce ...
 * 2. `onMomentumScrollEnd`   (Makes no sense why this occurs first during bounce)
 * 3. `onTouchStartCapture`   (immediately after `onMomentumScrollEnd`)
 * 4. `onTouchStart`          (same, but bubble phase)
 * 5. `onTouchEnd`            (You could hold the touch start for a long time)
 * 6. `onMomentumScrollBegin` (When releasing the view starts bouncing back)
 *
 * So when we receive an `onTouchStart`, how can we tell if we are touching
 * *during* an animation (which then causes the animation to stop)? The only way
 * to tell is if the `touchStart` occurred immediately after the
 * `onMomentumScrollEnd`.
 *
 * This is abstracted out for you, so you can just call this.scrollResponderIsAnimating() if
 * necessary
 *
 * `ScrollResponder` also includes logic for blurring a currently focused input
 * if one is focused while scrolling. The `ScrollResponder` is a natural place
 * to put this logic since it can support not dismissing the keyboard while
 * scrolling, unless a recognized "tap"-like gesture has occurred.
 *
 * The public lifecycle API includes events for keyboard interaction, responder
 * interaction, and scrolling (among others). The keyboard callbacks
 * `onKeyboardWill/Did/*` are *global* events, but are invoked on scroll
 * responder's props so that you can guarantee that the scroll responder's
 * internal state has been updated accordingly (and deterministically) by
 * the time the props callbacks are invoke. Otherwise, you would always wonder
 * if the scroll responder is currently in a state where it recognizes new
 * keyboard positions etc. If coordinating scrolling with keyboard movement,
 * *always* use these hooks instead of listening to your own global keyboard
 * events.
 *
 * Public keyboard lifecycle API: (props callbacks)
 *
 * Standard Keyboard Appearance Sequence:
 *
 *   this.props.onKeyboardWillShow
 *   this.props.onKeyboardDidShow
 *
 * `onScrollResponderKeyboardDismissed` will be invoked if an appropriate
 * tap inside the scroll responder's scrollable region was responsible
 * for the dismissal of the keyboard. There are other reasons why the
 * keyboard could be dismissed.
 *
 *   this.props.onScrollResponderKeyboardDismissed
 *
 * Standard Keyboard Hide Sequence:
 *
 *   this.props.onKeyboardWillHide
 *   this.props.onKeyboardDidHide
 */

var ScrollResponder_emptyObject = {};
var IS_ANIMATING_TOUCH_START_THRESHOLD_MS = 16;
var ScrollResponderMixin = {
  // mixins: [Subscribable.Mixin],
  scrollResponderMixinGetInitialState: function scrollResponderMixinGetInitialState() {
    return {
      isTouching: false,
      lastMomentumScrollBeginTime: 0,
      lastMomentumScrollEndTime: 0,
      // Reset to false every time becomes responder. This is used to:
      // - Determine if the scroll view has been scrolled and therefore should
      // refuse to give up its responder lock.
      // - Determine if releasing should dismiss the keyboard when we are in
      // tap-to-dismiss mode (!this.props.keyboardShouldPersistTaps).
      observedScrollSinceBecomingResponder: false,
      becameResponderWhileAnimating: false
    };
  },

  /**
   * Invoke this from an `onScroll` event.
   */
  scrollResponderHandleScrollShouldSetResponder: function scrollResponderHandleScrollShouldSetResponder() {
    return this.state.isTouching;
  },

  /**
   * Merely touch starting is not sufficient for a scroll view to become the
   * responder. Being the "responder" means that the very next touch move/end
   * event will result in an action/movement.
   *
   * Invoke this from an `onStartShouldSetResponder` event.
   *
   * `onStartShouldSetResponder` is used when the next move/end will trigger
   * some UI movement/action, but when you want to yield priority to views
   * nested inside of the view.
   *
   * There may be some cases where scroll views actually should return `true`
   * from `onStartShouldSetResponder`: Any time we are detecting a standard tap
   * that gives priority to nested views.
   *
   * - If a single tap on the scroll view triggers an action such as
   *   recentering a map style view yet wants to give priority to interaction
   *   views inside (such as dropped pins or labels), then we would return true
   *   from this method when there is a single touch.
   *
   * - Similar to the previous case, if a two finger "tap" should trigger a
   *   zoom, we would check the `touches` count, and if `>= 2`, we would return
   *   true.
   *
   */
  scrollResponderHandleStartShouldSetResponder: function scrollResponderHandleStartShouldSetResponder() {
    return false;
  },

  /**
   * There are times when the scroll view wants to become the responder
   * (meaning respond to the next immediate `touchStart/touchEnd`), in a way
   * that *doesn't* give priority to nested views (hence the capture phase):
   *
   * - Currently animating.
   * - Tapping anywhere that is not the focused input, while the keyboard is
   *   up (which should dismiss the keyboard).
   *
   * Invoke this from an `onStartShouldSetResponderCapture` event.
   */
  scrollResponderHandleStartShouldSetResponderCapture: function scrollResponderHandleStartShouldSetResponderCapture(e) {
    // First see if we want to eat taps while the keyboard is up
    // var currentlyFocusedTextInput = TextInputState.currentlyFocusedField();
    // if (!this.props.keyboardShouldPersistTaps &&
    //   currentlyFocusedTextInput != null &&
    //   e.target !== currentlyFocusedTextInput) {
    //   return true;
    // }
    return this.scrollResponderIsAnimating();
  },

  /**
   * Invoke this from an `onResponderReject` event.
   *
   * Some other element is not yielding its role as responder. Normally, we'd
   * just disable the `UIScrollView`, but a touch has already began on it, the
   * `UIScrollView` will not accept being disabled after that. The easiest
   * solution for now is to accept the limitation of disallowing this
   * altogether. To improve this, find a way to disable the `UIScrollView` after
   * a touch has already started.
   */
  scrollResponderHandleResponderReject: function scrollResponderHandleResponderReject() {
    warning_default()(false, "ScrollView doesn't take rejection well - scrolls anyway");
  },

  /**
   * We will allow the scroll view to give up its lock iff it acquired the lock
   * during an animation. This is a very useful default that happens to satisfy
   * many common user experiences.
   *
   * - Stop a scroll on the left edge, then turn that into an outer view's
   *   backswipe.
   * - Stop a scroll mid-bounce at the top, continue pulling to have the outer
   *   view dismiss.
   * - However, without catching the scroll view mid-bounce (while it is
   *   motionless), if you drag far enough for the scroll view to become
   *   responder (and therefore drag the scroll view a bit), any backswipe
   *   navigation of a swipe gesture higher in the view hierarchy, should be
   *   rejected.
   */
  scrollResponderHandleTerminationRequest: function scrollResponderHandleTerminationRequest() {
    return !this.state.observedScrollSinceBecomingResponder;
  },

  /**
   * Invoke this from an `onTouchEnd` event.
   *
   * @param {SyntheticEvent} e Event.
   */
  scrollResponderHandleTouchEnd: function scrollResponderHandleTouchEnd(e) {
    var nativeEvent = e.nativeEvent;
    this.state.isTouching = nativeEvent.touches.length !== 0;
    this.props.onTouchEnd && this.props.onTouchEnd(e);
  },

  /**
   * Invoke this from an `onResponderRelease` event.
   */
  scrollResponderHandleResponderRelease: function scrollResponderHandleResponderRelease(e) {
    this.props.onResponderRelease && this.props.onResponderRelease(e); // By default scroll views will unfocus a textField
    // if another touch occurs outside of it

    var currentlyFocusedTextInput = modules_TextInputState.currentlyFocusedField();

    if (!this.props.keyboardShouldPersistTaps && currentlyFocusedTextInput != null && e.target !== currentlyFocusedTextInput && !this.state.observedScrollSinceBecomingResponder && !this.state.becameResponderWhileAnimating) {
      this.props.onScrollResponderKeyboardDismissed && this.props.onScrollResponderKeyboardDismissed(e);
      modules_TextInputState.blurTextInput(currentlyFocusedTextInput);
    }
  },
  scrollResponderHandleScroll: function scrollResponderHandleScroll(e) {
    this.state.observedScrollSinceBecomingResponder = true;
    this.props.onScroll && this.props.onScroll(e);
  },

  /**
   * Invoke this from an `onResponderGrant` event.
   */
  scrollResponderHandleResponderGrant: function scrollResponderHandleResponderGrant(e) {
    this.state.observedScrollSinceBecomingResponder = false;
    this.props.onResponderGrant && this.props.onResponderGrant(e);
    this.state.becameResponderWhileAnimating = this.scrollResponderIsAnimating();
  },

  /**
   * Unfortunately, `onScrollBeginDrag` also fires when *stopping* the scroll
   * animation, and there's not an easy way to distinguish a drag vs. stopping
   * momentum.
   *
   * Invoke this from an `onScrollBeginDrag` event.
   */
  scrollResponderHandleScrollBeginDrag: function scrollResponderHandleScrollBeginDrag(e) {
    this.props.onScrollBeginDrag && this.props.onScrollBeginDrag(e);
  },

  /**
   * Invoke this from an `onScrollEndDrag` event.
   */
  scrollResponderHandleScrollEndDrag: function scrollResponderHandleScrollEndDrag(e) {
    this.props.onScrollEndDrag && this.props.onScrollEndDrag(e);
  },

  /**
   * Invoke this from an `onMomentumScrollBegin` event.
   */
  scrollResponderHandleMomentumScrollBegin: function scrollResponderHandleMomentumScrollBegin(e) {
    this.state.lastMomentumScrollBeginTime = Date.now();
    this.props.onMomentumScrollBegin && this.props.onMomentumScrollBegin(e);
  },

  /**
   * Invoke this from an `onMomentumScrollEnd` event.
   */
  scrollResponderHandleMomentumScrollEnd: function scrollResponderHandleMomentumScrollEnd(e) {
    this.state.lastMomentumScrollEndTime = Date.now();
    this.props.onMomentumScrollEnd && this.props.onMomentumScrollEnd(e);
  },

  /**
   * Invoke this from an `onTouchStart` event.
   *
   * Since we know that the `SimpleEventPlugin` occurs later in the plugin
   * order, after `ResponderEventPlugin`, we can detect that we were *not*
   * permitted to be the responder (presumably because a contained view became
   * responder). The `onResponderReject` won't fire in that case - it only
   * fires when a *current* responder rejects our request.
   *
   * @param {SyntheticEvent} e Touch Start event.
   */
  scrollResponderHandleTouchStart: function scrollResponderHandleTouchStart(e) {
    this.state.isTouching = true;
    this.props.onTouchStart && this.props.onTouchStart(e);
  },

  /**
   * Invoke this from an `onTouchMove` event.
   *
   * Since we know that the `SimpleEventPlugin` occurs later in the plugin
   * order, after `ResponderEventPlugin`, we can detect that we were *not*
   * permitted to be the responder (presumably because a contained view became
   * responder). The `onResponderReject` won't fire in that case - it only
   * fires when a *current* responder rejects our request.
   *
   * @param {SyntheticEvent} e Touch Start event.
   */
  scrollResponderHandleTouchMove: function scrollResponderHandleTouchMove(e) {
    this.props.onTouchMove && this.props.onTouchMove(e);
  },

  /**
   * A helper function for this class that lets us quickly determine if the
   * view is currently animating. This is particularly useful to know when
   * a touch has just started or ended.
   */
  scrollResponderIsAnimating: function scrollResponderIsAnimating() {
    var now = Date.now();
    var timeSinceLastMomentumScrollEnd = now - this.state.lastMomentumScrollEndTime;
    var isAnimating = timeSinceLastMomentumScrollEnd < IS_ANIMATING_TOUCH_START_THRESHOLD_MS || this.state.lastMomentumScrollEndTime < this.state.lastMomentumScrollBeginTime;
    return isAnimating;
  },

  /**
   * Returns the node that represents native view that can be scrolled.
   * Components can pass what node to use by defining a `getScrollableNode`
   * function otherwise `this` is used.
   */
  scrollResponderGetScrollableNode: function scrollResponderGetScrollableNode() {
    return this.getScrollableNode ? this.getScrollableNode() : exports_findNodeHandle(this);
  },

  /**
   * A helper function to scroll to a specific point in the scrollview.
   * This is currently used to help focus on child textviews, but can also
   * be used to quickly scroll to any element we want to focus. Syntax:
   *
   * scrollResponderScrollTo(options: {x: number = 0; y: number = 0; animated: boolean = true})
   *
   * Note: The weird argument signature is due to the fact that, for historical reasons,
   * the function also accepts separate arguments as as alternative to the options object.
   * This is deprecated due to ambiguity (y before x), and SHOULD NOT BE USED.
   */
  scrollResponderScrollTo: function scrollResponderScrollTo(x, y, animated) {
    if (typeof x === 'number') {
      console.warn('`scrollResponderScrollTo(x, y, animated)` is deprecated. Use `scrollResponderScrollTo({x: 5, y: 5, animated: true})` instead.');
    } else {
      var _ref = x || ScrollResponder_emptyObject;

      x = _ref.x;
      y = _ref.y;
      animated = _ref.animated;
    }

    var node = this.scrollResponderGetScrollableNode();
    var left = x || 0;
    var top = y || 0;

    if (typeof node.scroll === 'function') {
      node.scroll({
        top: top,
        left: left,
        behavior: !animated ? 'auto' : 'smooth'
      });
    } else {
      node.scrollLeft = left;
      node.scrollTop = top;
    }
  },

  /**
   * Deprecated, do not use.
   */
  scrollResponderScrollWithoutAnimationTo: function scrollResponderScrollWithoutAnimationTo(offsetX, offsetY) {
    console.warn('`scrollResponderScrollWithoutAnimationTo` is deprecated. Use `scrollResponderScrollTo` instead');
    this.scrollResponderScrollTo({
      x: offsetX,
      y: offsetY,
      animated: false
    });
  },

  /**
   * A helper function to zoom to a specific rect in the scrollview. The argument has the shape
   * {x: number; y: number; width: number; height: number; animated: boolean = true}
   *
   * @platform ios
   */
  scrollResponderZoomTo: function scrollResponderZoomTo(rect, animated // deprecated, put this inside the rect argument instead
  ) {
    if (exports_Platform.OS !== 'ios') {
      invariant_default()('zoomToRect is not implemented');
    }
  },

  /**
   * Displays the scroll indicators momentarily.
   */
  scrollResponderFlashScrollIndicators: function scrollResponderFlashScrollIndicators() {},

  /**
   * This method should be used as the callback to onFocus in a TextInputs'
   * parent view. Note that any module using this mixin needs to return
   * the parent view's ref in getScrollViewRef() in order to use this method.
   * @param {any} nodeHandle The TextInput node handle
   * @param {number} additionalOffset The scroll view's top "contentInset".
   *        Default is 0.
   * @param {bool} preventNegativeScrolling Whether to allow pulling the content
   *        down to make it meet the keyboard's top. Default is false.
   */
  scrollResponderScrollNativeHandleToKeyboard: function scrollResponderScrollNativeHandleToKeyboard(nodeHandle, additionalOffset, preventNegativeScrollOffset) {
    this.additionalScrollOffset = additionalOffset || 0;
    this.preventNegativeScrollOffset = !!preventNegativeScrollOffset;
    UIManager["a" /* default */].measureLayout(nodeHandle, exports_findNodeHandle(this.getInnerViewNode()), this.scrollResponderTextInputFocusError, this.scrollResponderInputMeasureAndScrollToKeyboard);
  },

  /**
   * The calculations performed here assume the scroll view takes up the entire
   * screen - even if has some content inset. We then measure the offsets of the
   * keyboard, and compensate both for the scroll view's "contentInset".
   *
   * @param {number} left Position of input w.r.t. table view.
   * @param {number} top Position of input w.r.t. table view.
   * @param {number} width Width of the text input.
   * @param {number} height Height of the text input.
   */
  scrollResponderInputMeasureAndScrollToKeyboard: function scrollResponderInputMeasureAndScrollToKeyboard(left, top, width, height) {
    var keyboardScreenY = Dimensions_Dimensions.get('window').height;

    if (this.keyboardWillOpenTo) {
      keyboardScreenY = this.keyboardWillOpenTo.endCoordinates.screenY;
    }

    var scrollOffsetY = top - keyboardScreenY + height + this.additionalScrollOffset; // By default, this can scroll with negative offset, pulling the content
    // down so that the target component's bottom meets the keyboard's top.
    // If requested otherwise, cap the offset at 0 minimum to avoid content
    // shifting down.

    if (this.preventNegativeScrollOffset) {
      scrollOffsetY = Math.max(0, scrollOffsetY);
    }

    this.scrollResponderScrollTo({
      x: 0,
      y: scrollOffsetY,
      animated: true
    });
    this.additionalOffset = 0;
    this.preventNegativeScrollOffset = false;
  },
  scrollResponderTextInputFocusError: function scrollResponderTextInputFocusError(e) {
    console.error('Error measuring text field: ', e);
  },

  /**
   * `componentWillMount` is the closest thing to a  standard "constructor" for
   * React components.
   *
   * The `keyboardWillShow` is called before input focus.
   */
  componentWillMount: function componentWillMount() {
    this.keyboardWillOpenTo = null;
    this.additionalScrollOffset = 0; // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardWillShow', this.scrollResponderKeyboardWillShow);
    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardWillHide', this.scrollResponderKeyboardWillHide);
    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardDidShow', this.scrollResponderKeyboardDidShow);
    // this.addListenerOn(RCTDeviceEventEmitter, 'keyboardDidHide', this.scrollResponderKeyboardDidHide);
  },

  /**
   * Warning, this may be called several times for a single keyboard opening.
   * It's best to store the information in this method and then take any action
   * at a later point (either in `keyboardDidShow` or other).
   *
   * Here's the order that events occur in:
   * - focus
   * - willShow {startCoordinates, endCoordinates} several times
   * - didShow several times
   * - blur
   * - willHide {startCoordinates, endCoordinates} several times
   * - didHide several times
   *
   * The `ScrollResponder` providesModule callbacks for each of these events.
   * Even though any user could have easily listened to keyboard events
   * themselves, using these `props` callbacks ensures that ordering of events
   * is consistent - and not dependent on the order that the keyboard events are
   * subscribed to. This matters when telling the scroll view to scroll to where
   * the keyboard is headed - the scroll responder better have been notified of
   * the keyboard destination before being instructed to scroll to where the
   * keyboard will be. Stick to the `ScrollResponder` callbacks, and everything
   * will work.
   *
   * WARNING: These callbacks will fire even if a keyboard is displayed in a
   * different navigation pane. Filter out the events to determine if they are
   * relevant to you. (For example, only if you receive these callbacks after
   * you had explicitly focused a node etc).
   */
  scrollResponderKeyboardWillShow: function scrollResponderKeyboardWillShow(e) {
    this.keyboardWillOpenTo = e;
    this.props.onKeyboardWillShow && this.props.onKeyboardWillShow(e);
  },
  scrollResponderKeyboardWillHide: function scrollResponderKeyboardWillHide(e) {
    this.keyboardWillOpenTo = null;
    this.props.onKeyboardWillHide && this.props.onKeyboardWillHide(e);
  },
  scrollResponderKeyboardDidShow: function scrollResponderKeyboardDidShow(e) {
    // TODO(7693961): The event for DidShow is not available on iOS yet.
    // Use the one from WillShow and do not assign.
    if (e) {
      this.keyboardWillOpenTo = e;
    }

    this.props.onKeyboardDidShow && this.props.onKeyboardDidShow(e);
  },
  scrollResponderKeyboardDidHide: function scrollResponderKeyboardDidHide(e) {
    this.keyboardWillOpenTo = null;
    this.props.onKeyboardDidHide && this.props.onKeyboardDidHide(e);
  }
};
var ScrollResponder = {
  Mixin: ScrollResponderMixin
};
/* harmony default export */ var modules_ScrollResponder = (ScrollResponder);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/ScrollView/ScrollViewBase.js
function ScrollViewBase_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { ScrollViewBase_defineProperty(target, key, source[key]); }); } return target; }

function ScrollViewBase_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ScrollViewBase_extends() { ScrollViewBase_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ScrollViewBase_extends.apply(this, arguments); }

function ScrollViewBase_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ScrollViewBase_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */







var normalizeScrollEvent = function normalizeScrollEvent(e) {
  return {
    nativeEvent: {
      contentOffset: {
        get x() {
          return e.target.scrollLeft;
        },

        get y() {
          return e.target.scrollTop;
        }

      },
      contentSize: {
        get height() {
          return e.target.scrollHeight;
        },

        get width() {
          return e.target.scrollWidth;
        }

      },
      layoutMeasurement: {
        get height() {
          return e.target.offsetHeight;
        },

        get width() {
          return e.target.offsetWidth;
        }

      }
    },
    timeStamp: Date.now()
  };
};
/**
 * Encapsulates the Web-specific scroll throttling and disabling logic
 */


var ScrollViewBase_ScrollViewBase =
/*#__PURE__*/
function (_Component) {
  ScrollViewBase_inheritsLoose(ScrollViewBase, _Component);

  function ScrollViewBase() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this._debouncedOnScrollEnd = debounce_default()(_this._handleScrollEnd, 100);
    _this._state = {
      isScrolling: false,
      scrollLastTick: 0
    };

    _this._createPreventableScrollHandler = function (handler) {
      return function (e) {
        if (_this.props.scrollEnabled) {
          if (handler) {
            handler(e);
          }
        } else {
          // To disable scrolling in all browsers except Chrome
          e.preventDefault();
        }
      };
    };

    _this._handleScroll = function (e) {
      e.persist();
      e.stopPropagation();
      var scrollEventThrottle = _this.props.scrollEventThrottle; // A scroll happened, so the scroll bumps the debounce.

      _this._debouncedOnScrollEnd(e);

      if (_this._state.isScrolling) {
        // Scroll last tick may have changed, check if we need to notify
        if (_this._shouldEmitScrollEvent(_this._state.scrollLastTick, scrollEventThrottle)) {
          _this._handleScrollTick(e);
        }
      } else {
        // Weren't scrolling, so we must have just started
        _this._handleScrollStart(e);
      }
    };

    _this._setViewRef = function (element) {
      _this._viewRef = element;
    };

    return _this;
  }

  var _proto = ScrollViewBase.prototype;

  _proto.setNativeProps = function setNativeProps(props) {
    if (this._viewRef) {
      this._viewRef.setNativeProps(props);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        scrollEnabled = _this$props.scrollEnabled,
        style = _this$props.style,
        alwaysBounceHorizontal = _this$props.alwaysBounceHorizontal,
        alwaysBounceVertical = _this$props.alwaysBounceVertical,
        automaticallyAdjustContentInsets = _this$props.automaticallyAdjustContentInsets,
        bounces = _this$props.bounces,
        bouncesZoom = _this$props.bouncesZoom,
        canCancelContentTouches = _this$props.canCancelContentTouches,
        centerContent = _this$props.centerContent,
        contentInset = _this$props.contentInset,
        contentInsetAdjustmentBehavior = _this$props.contentInsetAdjustmentBehavior,
        contentOffset = _this$props.contentOffset,
        decelerationRate = _this$props.decelerationRate,
        directionalLockEnabled = _this$props.directionalLockEnabled,
        endFillColor = _this$props.endFillColor,
        indicatorStyle = _this$props.indicatorStyle,
        keyboardShouldPersistTaps = _this$props.keyboardShouldPersistTaps,
        maximumZoomScale = _this$props.maximumZoomScale,
        minimumZoomScale = _this$props.minimumZoomScale,
        onMomentumScrollBegin = _this$props.onMomentumScrollBegin,
        onMomentumScrollEnd = _this$props.onMomentumScrollEnd,
        onScrollBeginDrag = _this$props.onScrollBeginDrag,
        onScrollEndDrag = _this$props.onScrollEndDrag,
        overScrollMode = _this$props.overScrollMode,
        pinchGestureEnabled = _this$props.pinchGestureEnabled,
        removeClippedSubviews = _this$props.removeClippedSubviews,
        scrollEventThrottle = _this$props.scrollEventThrottle,
        scrollIndicatorInsets = _this$props.scrollIndicatorInsets,
        scrollPerfTag = _this$props.scrollPerfTag,
        scrollsToTop = _this$props.scrollsToTop,
        showsHorizontalScrollIndicator = _this$props.showsHorizontalScrollIndicator,
        showsVerticalScrollIndicator = _this$props.showsVerticalScrollIndicator,
        snapToInterval = _this$props.snapToInterval,
        snapToAlignment = _this$props.snapToAlignment,
        zoomScale = _this$props.zoomScale,
        other = ScrollViewBase_objectWithoutPropertiesLoose(_this$props, ["scrollEnabled", "style", "alwaysBounceHorizontal", "alwaysBounceVertical", "automaticallyAdjustContentInsets", "bounces", "bouncesZoom", "canCancelContentTouches", "centerContent", "contentInset", "contentInsetAdjustmentBehavior", "contentOffset", "decelerationRate", "directionalLockEnabled", "endFillColor", "indicatorStyle", "keyboardShouldPersistTaps", "maximumZoomScale", "minimumZoomScale", "onMomentumScrollBegin", "onMomentumScrollEnd", "onScrollBeginDrag", "onScrollEndDrag", "overScrollMode", "pinchGestureEnabled", "removeClippedSubviews", "scrollEventThrottle", "scrollIndicatorInsets", "scrollPerfTag", "scrollsToTop", "showsHorizontalScrollIndicator", "showsVerticalScrollIndicator", "snapToInterval", "snapToAlignment", "zoomScale"]);

    var hideScrollbar = showsHorizontalScrollIndicator === false || showsVerticalScrollIndicator === false;
    return external_react_default.a.createElement(exports_View, ScrollViewBase_extends({}, other, {
      onScroll: this._handleScroll,
      onTouchMove: this._createPreventableScrollHandler(this.props.onTouchMove),
      onWheel: this._createPreventableScrollHandler(this.props.onWheel),
      ref: this._setViewRef,
      style: [style, !scrollEnabled && ScrollViewBase_styles.scrollDisabled, hideScrollbar && ScrollViewBase_styles.hideScrollbar]
    }));
  };

  _proto._handleScrollStart = function _handleScrollStart(e) {
    this._state.isScrolling = true;
    this._state.scrollLastTick = Date.now();
  };

  _proto._handleScrollTick = function _handleScrollTick(e) {
    var onScroll = this.props.onScroll;
    this._state.scrollLastTick = Date.now();

    if (onScroll) {
      onScroll(normalizeScrollEvent(e));
    }
  };

  _proto._handleScrollEnd = function _handleScrollEnd(e) {
    var onScroll = this.props.onScroll;
    this._state.isScrolling = false;

    if (onScroll) {
      onScroll(normalizeScrollEvent(e));
    }
  };

  _proto._shouldEmitScrollEvent = function _shouldEmitScrollEvent(lastTick, eventThrottle) {
    var timeSinceLastTick = Date.now() - lastTick;
    return eventThrottle > 0 && timeSinceLastTick >= eventThrottle;
  };

  return ScrollViewBase;
}(external_react_["Component"]); // Chrome doesn't support e.preventDefault in this case; touch-action must be
// used to disable scrolling.
// https://developers.google.com/web/updates/2017/01/scrolling-intervention


ScrollViewBase_ScrollViewBase.defaultProps = {
  scrollEnabled: true,
  scrollEventThrottle: 0
};

ScrollViewBase_ScrollViewBase.propTypes =  false ? undefined : {};
var ScrollViewBase_styles = exports_StyleSheet.create({
  scrollDisabled: {
    touchAction: 'none'
  },
  hideScrollbar: {
    scrollbarWidth: 'none'
  }
});
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/ScrollView/index.js
function ScrollView_extends() { ScrollView_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ScrollView_extends.apply(this, arguments); }

function ScrollView_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ScrollView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { ScrollView_defineProperty(target, key, source[key]); }); } return target; }

function ScrollView_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */











var ScrollView_emptyObject = {};
/* eslint-disable react/prefer-es6-class, react/prop-types */

var ScrollView = create_react_class_default()({
  displayName: "ScrollView",
  propTypes: ScrollView_objectSpread({}, exports_ViewPropTypes, {
    contentContainerStyle: exports_ViewPropTypes.style,
    horizontal: external_prop_types_["bool"],
    keyboardDismissMode: Object(external_prop_types_["oneOf"])(['none', 'interactive', 'on-drag']),
    onContentSizeChange: external_prop_types_["func"],
    onScroll: external_prop_types_["func"],
    pagingEnabled: external_prop_types_["bool"],
    refreshControl: external_prop_types_["element"],
    scrollEnabled: external_prop_types_["bool"],
    scrollEventThrottle: external_prop_types_["number"],
    stickyHeaderIndices: Object(external_prop_types_["arrayOf"])(external_prop_types_["number"]),
    style: exports_ViewPropTypes.style
  }),
  mixins: [modules_ScrollResponder.Mixin],
  getInitialState: function getInitialState() {
    return this.scrollResponderMixinGetInitialState();
  },
  flashScrollIndicators: function flashScrollIndicators() {
    this.scrollResponderFlashScrollIndicators();
  },
  setNativeProps: function setNativeProps(props) {
    if (this._scrollViewRef) {
      this._scrollViewRef.setNativeProps(props);
    }
  },

  /**
   * Returns a reference to the underlying scroll responder, which supports
   * operations like `scrollTo`. All ScrollView-like components should
   * implement this method so that they can be composed while providing access
   * to the underlying scroll responder's methods.
   */
  getScrollResponder: function getScrollResponder() {
    return this;
  },
  getScrollableNode: function getScrollableNode() {
    return exports_findNodeHandle(this._scrollViewRef);
  },
  getInnerViewNode: function getInnerViewNode() {
    return exports_findNodeHandle(this._innerViewRef);
  },

  /**
   * Scrolls to a given x, y offset, either immediately or with a smooth animation.
   * Syntax:
   *
   * scrollTo(options: {x: number = 0; y: number = 0; animated: boolean = true})
   *
   * Note: The weird argument signature is due to the fact that, for historical reasons,
   * the function also accepts separate arguments as as alternative to the options object.
   * This is deprecated due to ambiguity (y before x), and SHOULD NOT BE USED.
   */
  scrollTo: function scrollTo(y, x, animated) {
    if (typeof y === 'number') {
      console.warn('`scrollTo(y, x, animated)` is deprecated. Use `scrollTo({x: 5, y: 5, animated: true})` instead.');
    } else {
      var _ref = y || ScrollView_emptyObject;

      x = _ref.x;
      y = _ref.y;
      animated = _ref.animated;
    }

    this.getScrollResponder().scrollResponderScrollTo({
      x: x || 0,
      y: y || 0,
      animated: animated !== false
    });
  },

  /**
   * If this is a vertical ScrollView scrolls to the bottom.
   * If this is a horizontal ScrollView scrolls to the right.
   *
   * Use `scrollToEnd({ animated: true })` for smooth animated scrolling,
   * `scrollToEnd({ animated: false })` for immediate scrolling.
   * If no options are passed, `animated` defaults to true.
   */
  scrollToEnd: function scrollToEnd(options) {
    // Default to true
    var animated = (options && options.animated) !== false;
    var horizontal = this.props.horizontal;
    var scrollResponder = this.getScrollResponder();
    var scrollResponderNode = scrollResponder.scrollResponderGetScrollableNode();
    var x = horizontal ? scrollResponderNode.scrollWidth : 0;
    var y = horizontal ? 0 : scrollResponderNode.scrollHeight;
    scrollResponder.scrollResponderScrollTo({
      x: x,
      y: y,
      animated: animated
    });
  },

  /**
   * Deprecated, do not use.
   */
  scrollWithoutAnimationTo: function scrollWithoutAnimationTo(y, x) {
    if (y === void 0) {
      y = 0;
    }

    if (x === void 0) {
      x = 0;
    }

    console.warn('`scrollWithoutAnimationTo` is deprecated. Use `scrollTo` instead');
    this.scrollTo({
      x: x,
      y: y,
      animated: false
    });
  },
  render: function render() {
    var _this$props = this.props,
        contentContainerStyle = _this$props.contentContainerStyle,
        horizontal = _this$props.horizontal,
        onContentSizeChange = _this$props.onContentSizeChange,
        refreshControl = _this$props.refreshControl,
        stickyHeaderIndices = _this$props.stickyHeaderIndices,
        pagingEnabled = _this$props.pagingEnabled,
        keyboardDismissMode = _this$props.keyboardDismissMode,
        onScroll = _this$props.onScroll,
        other = ScrollView_objectWithoutPropertiesLoose(_this$props, ["contentContainerStyle", "horizontal", "onContentSizeChange", "refreshControl", "stickyHeaderIndices", "pagingEnabled", "keyboardDismissMode", "onScroll"]);

    if (false) { var childLayoutProps, style; }

    var contentSizeChangeProps = {};

    if (onContentSizeChange) {
      contentSizeChangeProps = {
        onLayout: this._handleContentOnLayout
      };
    }

    var hasStickyHeaderIndices = !horizontal && Array.isArray(stickyHeaderIndices);
    var children = hasStickyHeaderIndices || pagingEnabled ? external_react_default.a.Children.map(this.props.children, function (child, i) {
      var isSticky = hasStickyHeaderIndices && stickyHeaderIndices.indexOf(i) > -1;

      if (child != null && (isSticky || pagingEnabled)) {
        return external_react_default.a.createElement(exports_View, {
          style: exports_StyleSheet.compose(isSticky && ScrollView_styles.stickyHeader, pagingEnabled && ScrollView_styles.pagingEnabledChild)
        }, child);
      } else {
        return child;
      }
    }) : this.props.children;
    var contentContainer = external_react_default.a.createElement(exports_View, ScrollView_extends({}, contentSizeChangeProps, {
      children: children,
      collapsable: false,
      ref: this._setInnerViewRef,
      style: exports_StyleSheet.compose(horizontal && ScrollView_styles.contentContainerHorizontal, contentContainerStyle)
    }));
    var baseStyle = horizontal ? ScrollView_styles.baseHorizontal : ScrollView_styles.baseVertical;
    var pagingEnabledStyle = horizontal ? ScrollView_styles.pagingEnabledHorizontal : ScrollView_styles.pagingEnabledVertical;

    var props = ScrollView_objectSpread({}, other, {
      style: [baseStyle, pagingEnabled && pagingEnabledStyle, this.props.style],
      onTouchStart: this.scrollResponderHandleTouchStart,
      onTouchMove: this.scrollResponderHandleTouchMove,
      onTouchEnd: this.scrollResponderHandleTouchEnd,
      onScrollBeginDrag: this.scrollResponderHandleScrollBeginDrag,
      onScrollEndDrag: this.scrollResponderHandleScrollEndDrag,
      onMomentumScrollBegin: this.scrollResponderHandleMomentumScrollBegin,
      onMomentumScrollEnd: this.scrollResponderHandleMomentumScrollEnd,
      onStartShouldSetResponder: this.scrollResponderHandleStartShouldSetResponder,
      onStartShouldSetResponderCapture: this.scrollResponderHandleStartShouldSetResponderCapture,
      onScrollShouldSetResponder: this.scrollResponderHandleScrollShouldSetResponder,
      onScroll: this._handleScroll,
      onResponderGrant: this.scrollResponderHandleResponderGrant,
      onResponderTerminationRequest: this.scrollResponderHandleTerminationRequest,
      onResponderTerminate: this.scrollResponderHandleTerminate,
      onResponderRelease: this.scrollResponderHandleResponderRelease,
      onResponderReject: this.scrollResponderHandleResponderReject
    });

    var ScrollViewClass = ScrollViewBase_ScrollViewBase;
    invariant_default()(ScrollViewClass !== undefined, 'ScrollViewClass must not be undefined');

    if (refreshControl) {
      return external_react_default.a.cloneElement(refreshControl, {
        style: props.style
      }, external_react_default.a.createElement(ScrollViewClass, ScrollView_extends({}, props, {
        ref: this._setScrollViewRef,
        style: baseStyle
      }), contentContainer));
    }

    return external_react_default.a.createElement(ScrollViewClass, ScrollView_extends({}, props, {
      ref: this._setScrollViewRef
    }), contentContainer);
  },
  _handleContentOnLayout: function _handleContentOnLayout(e) {
    var _e$nativeEvent$layout = e.nativeEvent.layout,
        width = _e$nativeEvent$layout.width,
        height = _e$nativeEvent$layout.height;
    this.props.onContentSizeChange(width, height);
  },
  _handleScroll: function _handleScroll(e) {
    if (false) {}

    if (this.props.keyboardDismissMode === 'on-drag') {
      modules_dismissKeyboard();
    }

    this.scrollResponderHandleScroll(e);
  },
  _setInnerViewRef: function _setInnerViewRef(component) {
    this._innerViewRef = component;
  },
  _setScrollViewRef: function _setScrollViewRef(component) {
    this._scrollViewRef = component;
  }
});
var commonStyle = {
  flexGrow: 1,
  flexShrink: 1,
  // Enable hardware compositing in modern browsers.
  // Creates a new layer with its own backing surface that can significantly
  // improve scroll performance.
  transform: [{
    translateZ: 0
  }],
  // iOS native scrolling
  WebkitOverflowScrolling: 'touch'
};
var ScrollView_styles = exports_StyleSheet.create({
  baseVertical: ScrollView_objectSpread({}, commonStyle, {
    flexDirection: 'column',
    overflowX: 'hidden',
    overflowY: 'auto'
  }),
  baseHorizontal: ScrollView_objectSpread({}, commonStyle, {
    flexDirection: 'row',
    overflowX: 'auto',
    overflowY: 'hidden'
  }),
  contentContainerHorizontal: {
    flexDirection: 'row'
  },
  stickyHeader: {
    position: 'sticky',
    top: 0,
    zIndex: 10
  },
  pagingEnabledHorizontal: {
    scrollSnapType: 'x mandatory'
  },
  pagingEnabledVertical: {
    scrollSnapType: 'y mandatory'
  },
  pagingEnabledChild: {
    scrollSnapAlign: 'start'
  }
});
/* harmony default export */ var exports_ScrollView = (ScrollView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Text/index.js
function Text_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Text_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */










var Text_Text =
/*#__PURE__*/
function (_Component) {
  Text_inheritsLoose(Text, _Component);

  function Text() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Text.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      isInAParentText: true
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        dir = _this$props.dir,
        numberOfLines = _this$props.numberOfLines,
        onPress = _this$props.onPress,
        selectable = _this$props.selectable,
        style = _this$props.style,
        adjustsFontSizeToFit = _this$props.adjustsFontSizeToFit,
        allowFontScaling = _this$props.allowFontScaling,
        ellipsizeMode = _this$props.ellipsizeMode,
        lineBreakMode = _this$props.lineBreakMode,
        maxFontSizeMultiplier = _this$props.maxFontSizeMultiplier,
        minimumFontScale = _this$props.minimumFontScale,
        onLayout = _this$props.onLayout,
        onLongPress = _this$props.onLongPress,
        pressRetentionOffset = _this$props.pressRetentionOffset,
        selectionColor = _this$props.selectionColor,
        suppressHighlighting = _this$props.suppressHighlighting,
        textBreakStrategy = _this$props.textBreakStrategy,
        tvParallaxProperties = _this$props.tvParallaxProperties,
        otherProps = Text_objectWithoutPropertiesLoose(_this$props, ["dir", "numberOfLines", "onPress", "selectable", "style", "adjustsFontSizeToFit", "allowFontScaling", "ellipsizeMode", "lineBreakMode", "maxFontSizeMultiplier", "minimumFontScale", "onLayout", "onLongPress", "pressRetentionOffset", "selectionColor", "suppressHighlighting", "textBreakStrategy", "tvParallaxProperties"]);

    var isInAParentText = this.context.isInAParentText;

    if (false) {}

    if (onPress) {
      otherProps.accessible = true;
      otherProps.onClick = this._createPressHandler(onPress);
      otherProps.onKeyDown = this._createEnterHandler(onPress);
    }

    otherProps.classList = [this.props.className, Text_classes.text, this.context.isInAParentText === true && Text_classes.textHasAncestor, numberOfLines === 1 && Text_classes.textOneLine, numberOfLines > 1 && Text_classes.textMultiLine]; // allow browsers to automatically infer the language writing direction

    otherProps.dir = dir !== undefined ? dir : 'auto';
    otherProps.style = [style, numberOfLines > 1 && {
      WebkitLineClamp: numberOfLines
    }, selectable === false && Text_styles.notSelectable, onPress && Text_styles.pressable];
    var component = isInAParentText ? 'span' : 'div';
    return exports_createElement(component, otherProps);
  };

  _proto._createEnterHandler = function _createEnterHandler(fn) {
    return function (e) {
      if (e.keyCode === 13) {
        fn && fn(e);
      }
    };
  };

  _proto._createPressHandler = function _createPressHandler(fn) {
    return function (e) {
      e.stopPropagation();
      fn && fn(e);
    };
  };

  return Text;
}(external_react_["Component"]);

Text_Text.displayName = 'Text';
Text_Text.childContextTypes = {
  isInAParentText: external_prop_types_["bool"]
};
Text_Text.contextTypes = {
  isInAParentText: external_prop_types_["bool"]
};
Text_Text.propTypes =  false ? undefined : {};
var Text_classes = StyleSheet_css.create({
  text: {
    border: '0 solid black',
    boxSizing: 'border-box',
    color: 'black',
    display: 'inline',
    font: '14px System',
    margin: 0,
    padding: 0,
    whiteSpace: 'pre-wrap',
    wordWrap: 'break-word'
  },
  textHasAncestor: {
    color: 'inherit',
    font: 'inherit',
    whiteSpace: 'inherit'
  },
  textOneLine: {
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  },
  // See #13
  textMultiLine: {
    display: '-webkit-box',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical'
  }
});
var Text_styles = exports_StyleSheet.create({
  notSelectable: {
    userSelect: 'none'
  },
  pressable: {
    cursor: 'pointer'
  }
});
/* harmony default export */ var exports_Text = (modules_applyLayout(modules_applyNativeMethods(Text_Text)));
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Animated/index.js
function Animated_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { Animated_defineProperty(target, key, source[key]); }); } return target; }

function Animated_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */






var Animated = Animated_objectSpread({}, Animated_AnimatedImplementation, {
  Image: Animated_AnimatedImplementation.createAnimatedComponent(exports_Image),
  ScrollView: Animated_AnimatedImplementation.createAnimatedComponent(exports_ScrollView),
  View: Animated_AnimatedImplementation.createAnimatedComponent(exports_View),
  Text: Animated_AnimatedImplementation.createAnimatedComponent(exports_Text)
});

/* harmony default export */ var exports_Animated = (Animated);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/AppRegistry/AppContainer.js
function AppContainer_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */





var AppContainer_AppContainer =
/*#__PURE__*/
function (_Component) {
  AppContainer_inheritsLoose(AppContainer, _Component);

  function AppContainer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      mainKey: 1
    };
    return _this;
  }

  var _proto = AppContainer.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      rootTag: this.props.rootTag
    };
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        WrapperComponent = _this$props.WrapperComponent;
    var innerView = external_react_default.a.createElement(exports_View, {
      children: children,
      key: this.state.mainKey,
      pointerEvents: "box-none",
      style: AppContainer_styles.appContainer
    });

    if (WrapperComponent) {
      innerView = external_react_default.a.createElement(WrapperComponent, null, innerView);
    }

    return external_react_default.a.createElement(exports_View, {
      pointerEvents: "box-none",
      style: AppContainer_styles.appContainer
    }, innerView);
  };

  return AppContainer;
}(external_react_["Component"]);

AppContainer_AppContainer.childContextTypes = {
  rootTag: external_prop_types_["any"]
};

AppContainer_AppContainer.propTypes =  false ? undefined : {};
var AppContainer_styles = exports_StyleSheet.create({
  appContainer: {
    flex: 1
  }
});
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/hydrate/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var hydrate = (external_react_dom_["hydrate"]);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/AppRegistry/renderApplication.js
function renderApplication_extends() { renderApplication_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return renderApplication_extends.apply(this, arguments); }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */






var renderFn =  false ? undefined : hydrate;
function renderApplication(RootComponent, initialProps, rootTag, WrapperComponent, callback) {
  invariant_default()(rootTag, 'Expect to have a valid rootTag, instead got ', rootTag);
  renderFn(external_react_default.a.createElement(AppContainer_AppContainer, {
    WrapperComponent: WrapperComponent,
    rootTag: rootTag
  }, external_react_default.a.createElement(RootComponent, initialProps)), rootTag, callback);
}
function renderApplication_getApplication(RootComponent, initialProps, WrapperComponent) {
  var element = external_react_default.a.createElement(AppContainer_AppContainer, {
    WrapperComponent: WrapperComponent,
    rootTag: {}
  }, external_react_default.a.createElement(RootComponent, initialProps)); // Don't escape CSS text

  var getStyleElement = function getStyleElement(props) {
    var sheet = StyleSheet_styleResolver.getStyleSheet();
    return external_react_default.a.createElement("style", renderApplication_extends({}, props, {
      dangerouslySetInnerHTML: {
        __html: sheet.textContent
      },
      id: sheet.id
    }));
  };

  return {
    element: element,
    getStyleElement: getStyleElement
  };
}
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/AppRegistry/index.js
function AppRegistry_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { AppRegistry_defineProperty(target, key, source[key]); }); } return target; }

function AppRegistry_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var AppRegistry_emptyObject = {};
var runnables = {};

var componentProviderInstrumentationHook = function componentProviderInstrumentationHook(component) {
  return component();
};

var wrapperComponentProvider;

/**
 * `AppRegistry` is the JS entry point to running all React Native apps.
 */
var AppRegistry_AppRegistry =
/*#__PURE__*/
function () {
  function AppRegistry() {}

  AppRegistry.getAppKeys = function getAppKeys() {
    return Object.keys(runnables);
  };

  AppRegistry.getApplication = function getApplication(appKey, appParameters) {
    invariant_default()(runnables[appKey] && runnables[appKey].getApplication, "Application " + appKey + " has not been registered. " + 'This is either due to an import error during initialization or failure to call AppRegistry.registerComponent.');
    return runnables[appKey].getApplication(appParameters);
  };

  AppRegistry.registerComponent = function registerComponent(appKey, componentProvider) {
    runnables[appKey] = {
      getApplication: function getApplication(appParameters) {
        return renderApplication_getApplication(componentProviderInstrumentationHook(componentProvider), appParameters ? appParameters.initialProps : AppRegistry_emptyObject, wrapperComponentProvider && wrapperComponentProvider(appParameters));
      },
      run: function run(appParameters) {
        return renderApplication(componentProviderInstrumentationHook(componentProvider), appParameters.initialProps || AppRegistry_emptyObject, appParameters.rootTag, wrapperComponentProvider && wrapperComponentProvider(appParameters), appParameters.callback);
      }
    };
    return appKey;
  };

  AppRegistry.registerConfig = function registerConfig(config) {
    config.forEach(function (_ref) {
      var appKey = _ref.appKey,
          component = _ref.component,
          run = _ref.run;

      if (run) {
        AppRegistry.registerRunnable(appKey, run);
      } else {
        invariant_default()(component, 'No component provider passed in');
        AppRegistry.registerComponent(appKey, component);
      }
    });
  } // TODO: fix style sheet creation when using this method
  ;

  AppRegistry.registerRunnable = function registerRunnable(appKey, run) {
    runnables[appKey] = {
      run: run
    };
    return appKey;
  };

  AppRegistry.runApplication = function runApplication(appKey, appParameters) {
    var isDevelopment =  false && false;

    if (isDevelopment) {
      var params = AppRegistry_objectSpread({}, appParameters);

      params.rootTag = "#" + params.rootTag.id;
      console.log("Running application \"" + appKey + "\" with appParams:\n", params, "\nDevelopment-level warnings: " + (isDevelopment ? 'ON' : 'OFF') + "." + ("\nPerformance optimizations: " + (isDevelopment ? 'OFF' : 'ON') + "."));
    }

    invariant_default()(runnables[appKey] && runnables[appKey].run, "Application \"" + appKey + "\" has not been registered. " + 'This is either due to an import error during initialization or failure to call AppRegistry.registerComponent.');
    runnables[appKey].run(appParameters);
  };

  AppRegistry.setComponentProviderInstrumentationHook = function setComponentProviderInstrumentationHook(hook) {
    componentProviderInstrumentationHook = hook;
  };

  AppRegistry.setWrapperComponentProvider = function setWrapperComponentProvider(provider) {
    wrapperComponentProvider = provider;
  };

  AppRegistry.unmountApplicationComponentAtRootTag = function unmountApplicationComponentAtRootTag(rootTag) {
    unmountComponentAtNode(rootTag);
  };

  return AppRegistry;
}();


// EXTERNAL MODULE: ./node_modules/array-find-index/index.js
var array_find_index = __webpack_require__(51);
var array_find_index_default = /*#__PURE__*/__webpack_require__.n(array_find_index);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/AppState/index.js
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


 // Android 4.4 browser

var isPrefixed = ExecutionEnvironment["canUseDOM"] && !document.hasOwnProperty('hidden') && document.hasOwnProperty('webkitHidden');
var EVENT_TYPES = ['change', 'memoryWarning'];
var VISIBILITY_CHANGE_EVENT = isPrefixed ? 'webkitvisibilitychange' : 'visibilitychange';
var VISIBILITY_STATE_PROPERTY = isPrefixed ? 'webkitVisibilityState' : 'visibilityState';
var AppStates = {
  BACKGROUND: 'background',
  ACTIVE: 'active'
};
var AppState_listeners = [];

var AppState_AppState =
/*#__PURE__*/
function () {
  function AppState() {}

  AppState.addEventListener = function addEventListener(type, handler) {
    if (AppState.isAvailable) {
      invariant_default()(EVENT_TYPES.indexOf(type) !== -1, 'Trying to subscribe to unknown event: "%s"', type);

      if (type === 'change') {
        var callback = function callback() {
          return handler(AppState.currentState);
        };

        AppState_listeners.push([handler, callback]);
        document.addEventListener(VISIBILITY_CHANGE_EVENT, callback, false);
      }
    }
  };

  AppState.removeEventListener = function removeEventListener(type, handler) {
    if (AppState.isAvailable) {
      invariant_default()(EVENT_TYPES.indexOf(type) !== -1, 'Trying to remove listener for unknown event: "%s"', type);

      if (type === 'change') {
        var listenerIndex = array_find_index_default()(AppState_listeners, function (pair) {
          return pair[0] === handler;
        });
        invariant_default()(listenerIndex !== -1, 'Trying to remove AppState listener for unregistered handler');
        var callback = AppState_listeners[listenerIndex][1];
        document.removeEventListener(VISIBILITY_CHANGE_EVENT, callback, false);
        AppState_listeners.splice(listenerIndex, 1);
      }
    }
  };

  _createClass(AppState, null, [{
    key: "currentState",
    get: function get() {
      if (!AppState.isAvailable) {
        return AppStates.ACTIVE;
      }

      switch (document[VISIBILITY_STATE_PROPERTY]) {
        case 'hidden':
        case 'prerender':
        case 'unloaded':
          return AppStates.BACKGROUND;

        default:
          return AppStates.ACTIVE;
      }
    }
  }]);

  return AppState;
}();

AppState_AppState.isAvailable = ExecutionEnvironment["canUseDOM"] && document[VISIBILITY_STATE_PROPERTY];

// EXTERNAL MODULE: ./node_modules/deep-assign/index.js
var deep_assign = __webpack_require__(156);
var deep_assign_default = /*#__PURE__*/__webpack_require__.n(deep_assign);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/AsyncStorage/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var AsyncStorage_mergeLocalStorageItem = function mergeLocalStorageItem(key, value) {
  var oldValue = window.localStorage.getItem(key);
  var oldObject = JSON.parse(oldValue);
  var newObject = JSON.parse(value);
  var nextValue = JSON.stringify(deep_assign_default()({}, oldObject, newObject));
  window.localStorage.setItem(key, nextValue);
};

var createPromise = function createPromise(getValue, callback) {
  return new Promise(function (resolve, reject) {
    try {
      var value = getValue();

      if (callback) {
        callback(null, value);
      }

      resolve(value);
    } catch (err) {
      if (callback) {
        callback(err);
      }

      reject(err);
    }
  });
};

var createPromiseAll = function createPromiseAll(promises, callback, processResult) {
  return Promise.all(promises).then(function (result) {
    var value = processResult ? processResult(result) : null;
    callback && callback(null, value);
    return Promise.resolve(value);
  }, function (errors) {
    callback && callback(errors);
    return Promise.reject(errors);
  });
};

var AsyncStorage =
/*#__PURE__*/
function () {
  function AsyncStorage() {}

  /**
   * Erases *all* AsyncStorage for the domain.
   */
  AsyncStorage.clear = function clear(callback) {
    return createPromise(function () {
      window.localStorage.clear();
    }, callback);
  }
  /**
   * (stub) Flushes any pending requests using a single batch call to get the data.
   */
  ;

  AsyncStorage.flushGetRequests = function flushGetRequests() {}
  /**
   * Gets *all* keys known to the app, for all callers, libraries, etc.
   */
  ;

  AsyncStorage.getAllKeys = function getAllKeys(callback) {
    return createPromise(function () {
      var numberOfKeys = window.localStorage.length;
      var keys = [];

      for (var i = 0; i < numberOfKeys; i += 1) {
        var key = window.localStorage.key(i);
        keys.push(key);
      }

      return keys;
    }, callback);
  }
  /**
   * Fetches `key` value.
   */
  ;

  AsyncStorage.getItem = function getItem(key, callback) {
    return createPromise(function () {
      return window.localStorage.getItem(key);
    }, callback);
  }
  /**
   * multiGet resolves to an array of key-value pair arrays that matches the
   * input format of multiSet.
   *
   *   multiGet(['k1', 'k2']) -> [['k1', 'val1'], ['k2', 'val2']]
   */
  ;

  AsyncStorage.multiGet = function multiGet(keys, callback) {
    var promises = keys.map(function (key) {
      return AsyncStorage.getItem(key);
    });

    var processResult = function processResult(result) {
      return result.map(function (value, i) {
        return [keys[i], value];
      });
    };

    return createPromiseAll(promises, callback, processResult);
  }
  /**
   * Sets `value` for `key`.
   */
  ;

  AsyncStorage.setItem = function setItem(key, value, callback) {
    return createPromise(function () {
      window.localStorage.setItem(key, value);
    }, callback);
  }
  /**
   * Takes an array of key-value array pairs.
   *   multiSet([['k1', 'val1'], ['k2', 'val2']])
   */
  ;

  AsyncStorage.multiSet = function multiSet(keyValuePairs, callback) {
    var promises = keyValuePairs.map(function (item) {
      return AsyncStorage.setItem(item[0], item[1]);
    });
    return createPromiseAll(promises, callback);
  }
  /**
   * Merges existing value with input value, assuming they are stringified JSON.
   */
  ;

  AsyncStorage.mergeItem = function mergeItem(key, value, callback) {
    return createPromise(function () {
      AsyncStorage_mergeLocalStorageItem(key, value);
    }, callback);
  }
  /**
   * Takes an array of key-value array pairs and merges them with existing
   * values, assuming they are stringified JSON.
   *
   *   multiMerge([['k1', 'val1'], ['k2', 'val2']])
   */
  ;

  AsyncStorage.multiMerge = function multiMerge(keyValuePairs, callback) {
    var promises = keyValuePairs.map(function (item) {
      return AsyncStorage.mergeItem(item[0], item[1]);
    });
    return createPromiseAll(promises, callback);
  }
  /**
   * Removes a `key`
   */
  ;

  AsyncStorage.removeItem = function removeItem(key, callback) {
    return createPromise(function () {
      return window.localStorage.removeItem(key);
    }, callback);
  }
  /**
   * Delete all the keys in the `keys` array.
   */
  ;

  AsyncStorage.multiRemove = function multiRemove(keys, callback) {
    var promises = keys.map(function (key) {
      return AsyncStorage.removeItem(key);
    });
    return createPromiseAll(promises, callback);
  };

  return AsyncStorage;
}();


// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/BackHandler/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
function BackHandler_emptyFunction() {}

var BackHandler = {
  exitApp: BackHandler_emptyFunction,
  addEventListener: function addEventListener() {
    return {
      remove: BackHandler_emptyFunction
    };
  },
  removeEventListener: BackHandler_emptyFunction
};
/* harmony default export */ var exports_BackHandler = (BackHandler);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Clipboard/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var clipboardAvailable;

var Clipboard =
/*#__PURE__*/
function () {
  function Clipboard() {}

  Clipboard.isAvailable = function isAvailable() {
    if (clipboardAvailable === undefined) {
      clipboardAvailable = typeof document.queryCommandSupported === 'function' && document.queryCommandSupported('copy');
    }

    return clipboardAvailable;
  };

  Clipboard.getString = function getString() {
    return Promise.resolve('');
  };

  Clipboard.setString = function setString(text) {
    var success = false;
    var body = document.body;

    if (body) {
      // add the text to a hidden node
      var node = document.createElement('span');
      node.textContent = text;
      node.style.opacity = '0';
      node.style.position = 'absolute';
      node.style.whiteSpace = 'pre-wrap';
      body.appendChild(node); // select the text

      var selection = window.getSelection();
      selection.removeAllRanges();
      var range = document.createRange();
      range.selectNodeContents(node);
      selection.addRange(range); // attempt to copy

      try {
        document.execCommand('copy');
        success = true;
      } catch (e) {} // remove selection and node


      selection.removeAllRanges();
      body.removeChild(node);
    }

    return success;
  };

  return Clipboard;
}();


// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/DeviceInfo/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var DeviceInfo = {
  Dimensions: {
    get windowPhysicalPixels() {
      var _Dimensions$get = Dimensions_Dimensions.get('window'),
          width = _Dimensions$get.width,
          height = _Dimensions$get.height,
          fontScale = _Dimensions$get.fontScale,
          scale = _Dimensions$get.scale;

      return {
        width: width * scale,
        height: height * scale,
        scale: scale,
        fontScale: fontScale
      };
    },

    get screenPhysicalPixels() {
      var _Dimensions$get2 = Dimensions_Dimensions.get('screen'),
          width = _Dimensions$get2.width,
          height = _Dimensions$get2.height,
          fontScale = _Dimensions$get2.fontScale,
          scale = _Dimensions$get2.scale;

      return {
        width: width * scale,
        height: height * scale,
        scale: scale,
        fontScale: fontScale
      };
    }

  },

  get locale() {
    if (ExecutionEnvironment["canUseDOM"]) {
      if (window.navigator.languages) {
        return window.navigator.languages[0];
      } else {
        return window.navigator.language;
      }
    }
  },

  get totalMemory() {
    return ExecutionEnvironment["canUseDOM"] ? window.navigator.deviceMemory : undefined;
  },

  get userAgent() {
    return ExecutionEnvironment["canUseDOM"] ? window.navigator.userAgent : '';
  }

};
/* harmony default export */ var exports_DeviceInfo = (DeviceInfo);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Animated/Easing.js
var Easing = __webpack_require__(50);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Easing/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var exports_Easing = (Easing["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Keyboard/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var Keyboard = {
  addListener: function addListener() {
    return {
      remove: function remove() {}
    };
  },
  dismiss: function dismiss() {
    modules_dismissKeyboard();
  },
  removeAllListeners: function removeAllListeners() {},
  removeListener: function removeListener() {}
};
/* harmony default export */ var exports_Keyboard = (Keyboard);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/exports/InteractionManager/index.js + 1 modules
var InteractionManager = __webpack_require__(24);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/LayoutAnimation/index.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var __DEV__ = "production" !== 'production';

var checkPropTypes = external_prop_types_default.a.checkPropTypes;
var Types = {
  spring: 'spring',
  linear: 'linear',
  easeInEaseOut: 'easeInEaseOut',
  easeIn: 'easeIn',
  easeOut: 'easeOut',
  keyboard: 'keyboard'
};
var Properties = {
  opacity: 'opacity',
  scaleX: 'scaleX',
  scaleY: 'scaleY',
  scaleXY: 'scaleXY'
};
var animType = external_prop_types_default.a.shape({
  duration: external_prop_types_default.a.number,
  delay: external_prop_types_default.a.number,
  springDamping: external_prop_types_default.a.number,
  initialVelocity: external_prop_types_default.a.number,
  type: external_prop_types_default.a.oneOf(Object.keys(Types)).isRequired,
  property: external_prop_types_default.a.oneOf( // Only applies to create/delete
  Object.keys(Properties))
});
var configType = external_prop_types_default.a.shape({
  duration: external_prop_types_default.a.number.isRequired,
  create: animType,
  update: animType,
  delete: animType
});

function checkConfig(config, location, name) {
  checkPropTypes({
    config: configType
  }, {
    config: config
  }, location, name);
}

function configureNext(config, onAnimationDidEnd) {
  if (__DEV__) {
    checkConfig(config, 'config', 'LayoutAnimation.configureNext');
  }

  UIManager["a" /* default */].configureNextLayoutAnimation(config, onAnimationDidEnd || function () {}, function () {
    /* unused */
  });
}

function LayoutAnimation_create(duration, type, creationProp) {
  return {
    duration: duration,
    create: {
      type: type,
      property: creationProp
    },
    update: {
      type: type
    },
    delete: {
      type: type,
      property: creationProp
    }
  };
}

var Presets = {
  easeInEaseOut: LayoutAnimation_create(300, Types.easeInEaseOut, Properties.opacity),
  linear: LayoutAnimation_create(500, Types.linear, Properties.opacity),
  spring: {
    duration: 700,
    create: {
      type: Types.linear,
      property: Properties.opacity
    },
    update: {
      type: Types.spring,
      springDamping: 0.4
    },
    delete: {
      type: Types.linear,
      property: Properties.opacity
    }
  }
};
/**
 * Automatically animates views to their new positions when the
 * next layout happens.
 *
 * A common way to use this API is to call it before calling `setState`.
 *
 * Note that in order to get this to work on **Android** you need to set the following flags via `UIManager`:
 *
 *     UIManager.setLayoutAnimationEnabledExperimental && UIManager.setLayoutAnimationEnabledExperimental(true);
 */

var LayoutAnimation = {
  /**
   * Schedules an animation to happen on the next layout.
   *
   * @param config Specifies animation properties:
   *
   *   - `duration` in milliseconds
   *   - `create`, config for animating in new views (see `Anim` type)
   *   - `update`, config for animating views that have been updated
   * (see `Anim` type)
   *
   * @param onAnimationDidEnd Called when the animation finished.
   * Only supported on iOS.
   * @param onError Called on error. Only supported on iOS.
   */
  configureNext: configureNext,

  /**
   * Helper for creating a config for `configureNext`.
   */
  create: LayoutAnimation_create,
  Types: Types,
  Properties: Properties,
  checkConfig: checkConfig,
  Presets: Presets,
  easeInEaseOut: configureNext.bind(null, Presets.easeInEaseOut),
  linear: configureNext.bind(null, Presets.linear),
  spring: configureNext.bind(null, Presets.spring)
};
/* harmony default export */ var react_native_LayoutAnimation = (LayoutAnimation);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/LayoutAnimation/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var exports_LayoutAnimation = (react_native_LayoutAnimation);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Linking/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var initialURL = ExecutionEnvironment["canUseDOM"] ? window.location.href : '';
var Linking = {
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  canOpenURL: function canOpenURL() {
    return Promise.resolve(true);
  },
  getInitialURL: function getInitialURL() {
    return Promise.resolve(initialURL);
  },
  openURL: function openURL(url) {
    try {
      Linking_open(url);
      return Promise.resolve();
    } catch (e) {
      return Promise.reject(e);
    }
  },
  _validateURL: function _validateURL(url) {
    invariant_default()(typeof url === 'string', 'Invalid URL: should be a string. Was: ' + url);
    invariant_default()(url, 'Invalid URL: cannot be empty');
  }
};

var Linking_open = function open(url) {
  if (ExecutionEnvironment["canUseDOM"]) {
    window.location = new URL(url, window.location).toString();
  }
};

/* harmony default export */ var exports_Linking = (Linking);
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/vendor/react-native/NativeEventEmitter/index.js
var NativeEventEmitter = __webpack_require__(64);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/NativeEventEmitter/index.js
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var exports_NativeEventEmitter = (NativeEventEmitter["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/NetInfo/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var connection = ExecutionEnvironment_default.a.canUseDOM && (window.navigator.connection || window.navigator.mozConnection || window.navigator.webkitConnection); // Prevent the underlying event handlers from leaking and include additional
// properties available in browsers

var getConnectionInfoObject = function getConnectionInfoObject() {
  var result = {
    effectiveType: 'unknown',
    type: 'unknown'
  };

  if (!connection) {
    return result;
  }

  for (var prop in connection) {
    var value = connection[prop];

    if (typeof value !== 'function' && value != null) {
      result[prop] = value;
    }
  }

  return result;
}; // Map React Native events to browser equivalents


var eventTypesMap = {
  change: 'change',
  connectionChange: 'change'
};
var eventTypes = Object.keys(eventTypesMap);
var connectionListeners = [];
var netInfoListeners = [];
/**
 * Navigator online: https://developer.mozilla.org/en-US/docs/Web/API/NavigatorOnLine/onLine
 * Network Connection API: https://developer.mozilla.org/en-US/docs/Web/API/NetworkInformation
 */

var NetInfo = {
  addEventListener: function addEventListener(type, handler) {
    invariant_default()(eventTypes.indexOf(type) !== -1, 'Trying to subscribe to unknown event: "%s"', type);

    if (type === 'change') {
      console.warn('Listening to event `change` is deprecated. Use `connectionChange` instead.');
    }

    if (!connection) {
      console.error('Network Connection API is not supported. Not listening for connection type changes.');
      return {
        remove: function remove() {}
      };
    }

    var wrappedHandler = function wrappedHandler() {
      return handler(getConnectionInfoObject());
    };

    netInfoListeners.push([handler, wrappedHandler]);
    connection.addEventListener(eventTypesMap[type], wrappedHandler);
    return {
      remove: function remove() {
        return NetInfo.removeEventListener(eventTypesMap[type], handler);
      }
    };
  },
  removeEventListener: function removeEventListener(type, handler) {
    invariant_default()(eventTypes.indexOf(type) !== -1, 'Trying to unsubscribe from unknown event: "%s"', type);

    if (type === 'change') {
      console.warn('Listening to event `change` is deprecated. Use `connectionChange` instead.');
    }

    var listenerIndex = array_find_index_default()(netInfoListeners, function (pair) {
      return pair[0] === handler;
    });
    invariant_default()(listenerIndex !== -1, 'Trying to remove NetInfo listener for unregistered handler');
    var _netInfoListeners$lis = netInfoListeners[listenerIndex],
        wrappedHandler = _netInfoListeners$lis[1];
    connection.removeEventListener(eventTypesMap[type], wrappedHandler);
    netInfoListeners.splice(listenerIndex, 1);
  },
  fetch: function fetch() {
    console.warn('`fetch` is deprecated. Use `getConnectionInfo` instead.');
    return new Promise(function (resolve, reject) {
      try {
        resolve(connection.type);
      } catch (err) {
        resolve('unknown');
      }
    });
  },
  getConnectionInfo: function getConnectionInfo() {
    return new Promise(function (resolve, reject) {
      resolve(getConnectionInfoObject());
    });
  },
  isConnected: {
    addEventListener: function addEventListener(type, handler) {
      invariant_default()(eventTypes.indexOf(type) !== -1, 'Trying to subscribe to unknown event: "%s"', type);

      if (type === 'change') {
        console.warn('Listening to event `change` is deprecated. Use `connectionChange` instead.');
      }

      var onlineCallback = function onlineCallback() {
        return handler(true);
      };

      var offlineCallback = function offlineCallback() {
        return handler(false);
      };

      connectionListeners.push([handler, onlineCallback, offlineCallback]);
      window.addEventListener('online', onlineCallback, false);
      window.addEventListener('offline', offlineCallback, false);
      return {
        remove: function remove() {
          return NetInfo.isConnected.removeEventListener(eventTypesMap[type], handler);
        }
      };
    },
    removeEventListener: function removeEventListener(type, handler) {
      invariant_default()(eventTypes.indexOf(type) !== -1, 'Trying to subscribe to unknown event: "%s"', type);

      if (type === 'change') {
        console.warn('Listening to event `change` is deprecated. Use `connectionChange` instead.');
      }

      var listenerIndex = array_find_index_default()(connectionListeners, function (pair) {
        return pair[0] === handler;
      });
      invariant_default()(listenerIndex !== -1, 'Trying to remove NetInfo connection listener for unregistered handler');
      var _connectionListeners$ = connectionListeners[listenerIndex],
          onlineCallback = _connectionListeners$[1],
          offlineCallback = _connectionListeners$[2];
      window.removeEventListener('online', onlineCallback, false);
      window.removeEventListener('offline', offlineCallback, false);
      connectionListeners.splice(listenerIndex, 1);
    },
    fetch: function fetch() {
      return new Promise(function (resolve, reject) {
        try {
          resolve(window.navigator.onLine);
        } catch (err) {
          resolve(true);
        }
      });
    }
  }
};
/* harmony default export */ var exports_NetInfo = (NetInfo);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/TouchHistoryMath/index.js
var TouchHistoryMath = {
  /**
   * This code is optimized and not intended to look beautiful. This allows
   * computing of touch centroids that have moved after `touchesChangedAfter`
   * timeStamp. You can compute the current centroid involving all touches
   * moves after `touchesChangedAfter`, or you can compute the previous
   * centroid of all touches that were moved after `touchesChangedAfter`.
   *
   * @param {TouchHistoryMath} touchHistory Standard Responder touch track
   * data.
   * @param {number} touchesChangedAfter timeStamp after which moved touches
   * are considered "actively moving" - not just "active".
   * @param {boolean} isXAxis Consider `x` dimension vs. `y` dimension.
   * @param {boolean} ofCurrent Compute current centroid for actively moving
   * touches vs. previous centroid of now actively moving touches.
   * @return {number} value of centroid in specified dimension.
   */
  centroidDimension: function centroidDimension(touchHistory, touchesChangedAfter, isXAxis, ofCurrent) {
    var touchBank = touchHistory.touchBank;
    var total = 0;
    var count = 0;
    var oneTouchData = touchHistory.numberActiveTouches === 1 ? touchHistory.touchBank[touchHistory.indexOfSingleActiveTouch] : null;

    if (oneTouchData !== null) {
      if (oneTouchData.touchActive && oneTouchData.currentTimeStamp > touchesChangedAfter) {
        total += ofCurrent && isXAxis ? oneTouchData.currentPageX : ofCurrent && !isXAxis ? oneTouchData.currentPageY : !ofCurrent && isXAxis ? oneTouchData.previousPageX : oneTouchData.previousPageY;
        count = 1;
      }
    } else {
      for (var i = 0; i < touchBank.length; i++) {
        var touchTrack = touchBank[i];

        if (touchTrack !== null && touchTrack !== undefined && touchTrack.touchActive && touchTrack.currentTimeStamp >= touchesChangedAfter) {
          var toAdd = void 0; // Yuck, program temporarily in invalid state.

          if (ofCurrent && isXAxis) {
            toAdd = touchTrack.currentPageX;
          } else if (ofCurrent && !isXAxis) {
            toAdd = touchTrack.currentPageY;
          } else if (!ofCurrent && isXAxis) {
            toAdd = touchTrack.previousPageX;
          } else {
            toAdd = touchTrack.previousPageY;
          }

          total += toAdd;
          count++;
        }
      }
    }

    return count > 0 ? total / count : TouchHistoryMath.noCentroid;
  },
  currentCentroidXOfTouchesChangedAfter: function currentCentroidXOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, true, // isXAxis
    true);
  },
  currentCentroidYOfTouchesChangedAfter: function currentCentroidYOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, false, // isXAxis
    true);
  },
  previousCentroidXOfTouchesChangedAfter: function previousCentroidXOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, true, // isXAxis
    false);
  },
  previousCentroidYOfTouchesChangedAfter: function previousCentroidYOfTouchesChangedAfter(touchHistory, touchesChangedAfter) {
    return TouchHistoryMath.centroidDimension(touchHistory, touchesChangedAfter, false, // isXAxis
    false);
  },
  currentCentroidX: function currentCentroidX(touchHistory) {
    return TouchHistoryMath.centroidDimension(touchHistory, 0, // touchesChangedAfter
    true, // isXAxis
    true);
  },
  currentCentroidY: function currentCentroidY(touchHistory) {
    return TouchHistoryMath.centroidDimension(touchHistory, 0, // touchesChangedAfter
    false, // isXAxis
    true);
  },
  noCentroid: -1
};
/* harmony default export */ var react_native_TouchHistoryMath = (TouchHistoryMath);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/PanResponder/index.js
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */


var currentCentroidXOfTouchesChangedAfter = react_native_TouchHistoryMath.currentCentroidXOfTouchesChangedAfter;
var currentCentroidYOfTouchesChangedAfter = react_native_TouchHistoryMath.currentCentroidYOfTouchesChangedAfter;
var previousCentroidXOfTouchesChangedAfter = react_native_TouchHistoryMath.previousCentroidXOfTouchesChangedAfter;
var previousCentroidYOfTouchesChangedAfter = react_native_TouchHistoryMath.previousCentroidYOfTouchesChangedAfter;
var currentCentroidX = react_native_TouchHistoryMath.currentCentroidX;
var currentCentroidY = react_native_TouchHistoryMath.currentCentroidY;
/**
 * `PanResponder` reconciles several touches into a single gesture. It makes
 * single-touch gestures resilient to extra touches, and can be used to
 * recognize simple multi-touch gestures.
 *
 * By default, `PanResponder` holds an `InteractionManager` handle to block
 * long-running JS events from interrupting active gestures.
 *
 * It provides a predictable wrapper of the responder handlers provided by the
 * [gesture responder system](docs/gesture-responder-system.html).
 * For each handler, it provides a new `gestureState` object alongside the
 * native event object:
 *
 * ```
 * onPanResponderMove: (event, gestureState) => {}
 * ```
 *
 * A native event is a synthetic touch event with the following form:
 *
 *  - `nativeEvent`
 *      + `changedTouches` - Array of all touch events that have changed since the last event
 *      + `identifier` - The ID of the touch
 *      + `locationX` - The X position of the touch, relative to the element
 *      + `locationY` - The Y position of the touch, relative to the element
 *      + `pageX` - The X position of the touch, relative to the root element
 *      + `pageY` - The Y position of the touch, relative to the root element
 *      + `target` - The node id of the element receiving the touch event
 *      + `timestamp` - A time identifier for the touch, useful for velocity calculation
 *      + `touches` - Array of all current touches on the screen
 *
 * A `gestureState` object has the following:
 *
 *  - `stateID` - ID of the gestureState- persisted as long as there at least
 *     one touch on screen
 *  - `moveX` - the latest screen coordinates of the recently-moved touch
 *  - `moveY` - the latest screen coordinates of the recently-moved touch
 *  - `x0` - the screen coordinates of the responder grant
 *  - `y0` - the screen coordinates of the responder grant
 *  - `dx` - accumulated distance of the gesture since the touch started
 *  - `dy` - accumulated distance of the gesture since the touch started
 *  - `vx` - current velocity of the gesture
 *  - `vy` - current velocity of the gesture
 *  - `numberActiveTouches` - Number of touches currently on screen
 *
 * ### Basic Usage
 *
 * ```
 *   componentWillMount: function() {
 *     this._panResponder = PanResponder.create({
 *       // Ask to be the responder:
 *       onStartShouldSetPanResponder: (evt, gestureState) => true,
 *       onStartShouldSetPanResponderCapture: (evt, gestureState) => true,
 *       onMoveShouldSetPanResponder: (evt, gestureState) => true,
 *       onMoveShouldSetPanResponderCapture: (evt, gestureState) => true,
 *
 *       onPanResponderGrant: (evt, gestureState) => {
 *         // The gesture has started. Show visual feedback so the user knows
 *         // what is happening!
 *
 *         // gestureState.d{x,y} will be set to zero now
 *       },
 *       onPanResponderMove: (evt, gestureState) => {
 *         // The most recent move distance is gestureState.move{X,Y}
 *
 *         // The accumulated gesture distance since becoming responder is
 *         // gestureState.d{x,y}
 *       },
 *       onPanResponderTerminationRequest: (evt, gestureState) => true,
 *       onPanResponderRelease: (evt, gestureState) => {
 *         // The user has released all touches while this view is the
 *         // responder. This typically means a gesture has succeeded
 *       },
 *       onPanResponderTerminate: (evt, gestureState) => {
 *         // Another component has become the responder, so this gesture
 *         // should be cancelled
 *       },
 *       onShouldBlockNativeResponder: (evt, gestureState) => {
 *         // Returns whether this component should block native components from becoming the JS
 *         // responder. Returns true by default. Is currently only supported on android.
 *         return true;
 *       },
 *     });
 *   },
 *
 *   render: function() {
 *     return (
 *       <View {...this._panResponder.panHandlers} />
 *     );
 *   },
 *
 * ```
 *
 * ### Working Example
 *
 * To see it in action, try the
 * [PanResponder example in RNTester](https://github.com/facebook/react-native/blob/master/RNTester/js/PanResponderExample.js)
 */

var PanResponder = {
  /**
   *
   * A graphical explanation of the touch data flow:
   *
   * +----------------------------+             +--------------------------------+
   * | ResponderTouchHistoryStore |             |TouchHistoryMath                |
   * +----------------------------+             +----------+---------------------+
   * |Global store of touchHistory|             |Allocation-less math util       |
   * |including activeness, start |             |on touch history (centroids     |
   * |position, prev/cur position.|             |and multitouch movement etc)    |
   * |                            |             |                                |
   * +----^-----------------------+             +----^---------------------------+
   *      |                                          |
   *      | (records relevant history                |
   *      |  of touches relevant for                 |
   *      |  implementing higher level               |
   *      |  gestures)                               |
   *      |                                          |
   * +----+-----------------------+             +----|---------------------------+
   * | ResponderEventPlugin       |             |    |   Your App/Component      |
   * +----------------------------+             +----|---------------------------+
   * |Negotiates which view gets  | Low level   |    |             High level    |
   * |onResponderMove events.     | events w/   |  +-+-------+     events w/     |
   * |Also records history into   | touchHistory|  |   Pan   |     multitouch +  |
   * |ResponderTouchHistoryStore. +---------------->Responder+-----> accumulative|
   * +----------------------------+ attached to |  |         |     distance and  |
   *                                 each event |  +---------+     velocity.     |
   *                                            |                                |
   *                                            |                                |
   *                                            +--------------------------------+
   *
   *
   *
   * Gesture that calculates cumulative movement over time in a way that just
   * "does the right thing" for multiple touches. The "right thing" is very
   * nuanced. When moving two touches in opposite directions, the cumulative
   * distance is zero in each dimension. When two touches move in parallel five
   * pixels in the same direction, the cumulative distance is five, not ten. If
   * two touches start, one moves five in a direction, then stops and the other
   * touch moves fives in the same direction, the cumulative distance is ten.
   *
   * This logic requires a kind of processing of time "clusters" of touch events
   * so that two touch moves that essentially occur in parallel but move every
   * other frame respectively, are considered part of the same movement.
   *
   * Explanation of some of the non-obvious fields:
   *
   * - moveX/moveY: If no move event has been observed, then `(moveX, moveY)` is
   *   invalid. If a move event has been observed, `(moveX, moveY)` is the
   *   centroid of the most recently moved "cluster" of active touches.
   *   (Currently all move have the same timeStamp, but later we should add some
   *   threshold for what is considered to be "moving"). If a palm is
   *   accidentally counted as a touch, but a finger is moving greatly, the palm
   *   will move slightly, but we only want to count the single moving touch.
   * - x0/y0: Centroid location (non-cumulative) at the time of becoming
   *   responder.
   * - dx/dy: Cumulative touch distance - not the same thing as sum of each touch
   *   distance. Accounts for touch moves that are clustered together in time,
   *   moving the same direction. Only valid when currently responder (otherwise,
   *   it only represents the drag distance below the threshold).
   * - vx/vy: Velocity.
   */
  _initializeGestureState: function _initializeGestureState(gestureState) {
    gestureState.moveX = 0;
    gestureState.moveY = 0;
    gestureState.x0 = 0;
    gestureState.y0 = 0;
    gestureState.dx = 0;
    gestureState.dy = 0;
    gestureState.vx = 0;
    gestureState.vy = 0;
    gestureState.numberActiveTouches = 0; // All `gestureState` accounts for timeStamps up until:

    gestureState._accountsForMovesUpTo = 0;
  },

  /**
   * This is nuanced and is necessary. It is incorrect to continuously take all
   * active *and* recently moved touches, find the centroid, and track how that
   * result changes over time. Instead, we must take all recently moved
   * touches, and calculate how the centroid has changed just for those
   * recently moved touches, and append that change to an accumulator. This is
   * to (at least) handle the case where the user is moving three fingers, and
   * then one of the fingers stops but the other two continue.
   *
   * This is very different than taking all of the recently moved touches and
   * storing their centroid as `dx/dy`. For correctness, we must *accumulate
   * changes* in the centroid of recently moved touches.
   *
   * There is also some nuance with how we handle multiple moved touches in a
   * single event. With the way `ReactNativeEventEmitter` dispatches touches as
   * individual events, multiple touches generate two 'move' events, each of
   * them triggering `onResponderMove`. But with the way `PanResponder` works,
   * all of the gesture inference is performed on the first dispatch, since it
   * looks at all of the touches (even the ones for which there hasn't been a
   * native dispatch yet). Therefore, `PanResponder` does not call
   * `onResponderMove` passed the first dispatch. This diverges from the
   * typical responder callback pattern (without using `PanResponder`), but
   * avoids more dispatches than necessary.
   */
  _updateGestureStateOnMove: function _updateGestureStateOnMove(gestureState, touchHistory) {
    gestureState.numberActiveTouches = touchHistory.numberActiveTouches;
    gestureState.moveX = currentCentroidXOfTouchesChangedAfter(touchHistory, gestureState._accountsForMovesUpTo);
    gestureState.moveY = currentCentroidYOfTouchesChangedAfter(touchHistory, gestureState._accountsForMovesUpTo);
    var movedAfter = gestureState._accountsForMovesUpTo;
    var prevX = previousCentroidXOfTouchesChangedAfter(touchHistory, movedAfter);
    var x = currentCentroidXOfTouchesChangedAfter(touchHistory, movedAfter);
    var prevY = previousCentroidYOfTouchesChangedAfter(touchHistory, movedAfter);
    var y = currentCentroidYOfTouchesChangedAfter(touchHistory, movedAfter);
    var nextDX = gestureState.dx + (x - prevX);
    var nextDY = gestureState.dy + (y - prevY); // TODO: This must be filtered intelligently.

    var dt = touchHistory.mostRecentTimeStamp - gestureState._accountsForMovesUpTo;
    gestureState.vx = (nextDX - gestureState.dx) / dt;
    gestureState.vy = (nextDY - gestureState.dy) / dt;
    gestureState.dx = nextDX;
    gestureState.dy = nextDY;
    gestureState._accountsForMovesUpTo = touchHistory.mostRecentTimeStamp;
  },

  /**
   * @param {object} config Enhanced versions of all of the responder callbacks
   * that provide not only the typical `ResponderSyntheticEvent`, but also the
   * `PanResponder` gesture state.  Simply replace the word `Responder` with
   * `PanResponder` in each of the typical `onResponder*` callbacks. For
   * example, the `config` object would look like:
   *
   *  - `onMoveShouldSetPanResponder: (e, gestureState) => {...}`
   *  - `onMoveShouldSetPanResponderCapture: (e, gestureState) => {...}`
   *  - `onStartShouldSetPanResponder: (e, gestureState) => {...}`
   *  - `onStartShouldSetPanResponderCapture: (e, gestureState) => {...}`
   *  - `onPanResponderReject: (e, gestureState) => {...}`
   *  - `onPanResponderGrant: (e, gestureState) => {...}`
   *  - `onPanResponderStart: (e, gestureState) => {...}`
   *  - `onPanResponderEnd: (e, gestureState) => {...}`
   *  - `onPanResponderRelease: (e, gestureState) => {...}`
   *  - `onPanResponderMove: (e, gestureState) => {...}`
   *  - `onPanResponderTerminate: (e, gestureState) => {...}`
   *  - `onPanResponderTerminationRequest: (e, gestureState) => {...}`
   *  - `onShouldBlockNativeResponder: (e, gestureState) => {...}`
   *
   *  In general, for events that have capture equivalents, we update the
   *  gestureState once in the capture phase and can use it in the bubble phase
   *  as well.
   *
   *  Be careful with onStartShould* callbacks. They only reflect updated
   *  `gestureState` for start/end events that bubble/capture to the Node.
   *  Once the node is the responder, you can rely on every start/end event
   *  being processed by the gesture and `gestureState` being updated
   *  accordingly. (numberActiveTouches) may not be totally accurate unless you
   *  are the responder.
   */
  create: function create(config) {
    var interactionState = {
      handle: null
    };
    var gestureState = {
      // Useful for debugging
      stateID: Math.random()
    };

    PanResponder._initializeGestureState(gestureState);

    var panHandlers = {
      onStartShouldSetResponder: function onStartShouldSetResponder(e) {
        return config.onStartShouldSetPanResponder === undefined ? false : config.onStartShouldSetPanResponder(e, gestureState);
      },
      onMoveShouldSetResponder: function onMoveShouldSetResponder(e) {
        return config.onMoveShouldSetPanResponder === undefined ? false : config.onMoveShouldSetPanResponder(e, gestureState);
      },
      onStartShouldSetResponderCapture: function onStartShouldSetResponderCapture(e) {
        // TODO: Actually, we should reinitialize the state any time
        // touches.length increases from 0 active to > 0 active.
        if (e.nativeEvent.touches.length === 1) {
          PanResponder._initializeGestureState(gestureState);
        }

        gestureState.numberActiveTouches = e.touchHistory.numberActiveTouches;
        return config.onStartShouldSetPanResponderCapture !== undefined ? config.onStartShouldSetPanResponderCapture(e, gestureState) : false;
      },
      onMoveShouldSetResponderCapture: function onMoveShouldSetResponderCapture(e) {
        var touchHistory = e.touchHistory; // Responder system incorrectly dispatches should* to current responder
        // Filter out any touch moves past the first one - we would have
        // already processed multi-touch geometry during the first event.

        if (gestureState._accountsForMovesUpTo === touchHistory.mostRecentTimeStamp) {
          return false;
        }

        PanResponder._updateGestureStateOnMove(gestureState, touchHistory);

        return config.onMoveShouldSetPanResponderCapture ? config.onMoveShouldSetPanResponderCapture(e, gestureState) : false;
      },
      onResponderGrant: function onResponderGrant(e) {
        if (!interactionState.handle) {
          interactionState.handle = InteractionManager["a" /* default */].createInteractionHandle();
        }

        gestureState.x0 = currentCentroidX(e.touchHistory);
        gestureState.y0 = currentCentroidY(e.touchHistory);
        gestureState.dx = 0;
        gestureState.dy = 0;

        if (config.onPanResponderGrant) {
          config.onPanResponderGrant(e, gestureState);
        } // TODO: t7467124 investigate if this can be removed


        return config.onShouldBlockNativeResponder === undefined ? true : config.onShouldBlockNativeResponder();
      },
      onResponderReject: function onResponderReject(e) {
        clearInteractionHandle(interactionState, config.onPanResponderReject, e, gestureState);
      },
      onResponderRelease: function onResponderRelease(e) {
        clearInteractionHandle(interactionState, config.onPanResponderRelease, e, gestureState);

        PanResponder._initializeGestureState(gestureState);
      },
      onResponderStart: function onResponderStart(e) {
        var touchHistory = e.touchHistory;
        gestureState.numberActiveTouches = touchHistory.numberActiveTouches;

        if (config.onPanResponderStart) {
          config.onPanResponderStart(e, gestureState);
        }
      },
      onResponderMove: function onResponderMove(e) {
        var touchHistory = e.touchHistory; // Guard against the dispatch of two touch moves when there are two
        // simultaneously changed touches.

        if (gestureState._accountsForMovesUpTo === touchHistory.mostRecentTimeStamp) {
          return;
        } // Filter out any touch moves past the first one - we would have
        // already processed multi-touch geometry during the first event.


        PanResponder._updateGestureStateOnMove(gestureState, touchHistory);

        if (config.onPanResponderMove) {
          config.onPanResponderMove(e, gestureState);
        }
      },
      onResponderEnd: function onResponderEnd(e) {
        var touchHistory = e.touchHistory;
        gestureState.numberActiveTouches = touchHistory.numberActiveTouches;
        clearInteractionHandle(interactionState, config.onPanResponderEnd, e, gestureState);
      },
      onResponderTerminate: function onResponderTerminate(e) {
        clearInteractionHandle(interactionState, config.onPanResponderTerminate, e, gestureState);

        PanResponder._initializeGestureState(gestureState);
      },
      onResponderTerminationRequest: function onResponderTerminationRequest(e) {
        return config.onPanResponderTerminationRequest === undefined ? true : config.onPanResponderTerminationRequest(e, gestureState);
      }
    };
    return {
      panHandlers: panHandlers,
      getInteractionHandle: function getInteractionHandle() {
        return interactionState.handle;
      }
    };
  }
};

function clearInteractionHandle(interactionState, callback, event, gestureState) {
  if (interactionState.handle) {
    InteractionManager["a" /* default */].clearInteractionHandle(interactionState.handle);
    interactionState.handle = null;
  }

  if (callback) {
    callback(event, gestureState);
  }
}

/* harmony default export */ var react_native_PanResponder = (PanResponder);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/PanResponder/index.js

/* harmony default export */ var exports_PanResponder = (react_native_PanResponder);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/PixelRatio/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * PixelRatio gives access to the device pixel density.
 */

var PixelRatio_PixelRatio =
/*#__PURE__*/
function () {
  function PixelRatio() {}

  /**
   * Returns the device pixel density.
   */
  PixelRatio.get = function get() {
    return Dimensions_Dimensions.get('window').scale;
  }
  /**
   * No equivalent for Web
   */
  ;

  PixelRatio.getFontScale = function getFontScale() {
    return Dimensions_Dimensions.get('window').fontScale || PixelRatio.get();
  }
  /**
   * Converts a layout size (dp) to pixel size (px).
   * Guaranteed to return an integer number.
   */
  ;

  PixelRatio.getPixelSizeForLayoutSize = function getPixelSizeForLayoutSize(layoutSize) {
    return Math.round(layoutSize * PixelRatio.get());
  }
  /**
   * Rounds a layout size (dp) to the nearest layout size that corresponds to
   * an integer number of pixels. For example, on a device with a PixelRatio
   * of 3, `PixelRatio.roundToNearestPixel(8.4) = 8.33`, which corresponds to
   * exactly (8.33 * 3) = 25 pixels.
   */
  ;

  PixelRatio.roundToNearestPixel = function roundToNearestPixel(layoutSize) {
    var ratio = PixelRatio.get();
    return Math.round(layoutSize * ratio) / ratio;
  };

  return PixelRatio;
}();


// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Share/index.js
function Share_defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function Share_createClass(Constructor, protoProps, staticProps) { if (protoProps) Share_defineProperties(Constructor.prototype, protoProps); if (staticProps) Share_defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var Share_Share =
/*#__PURE__*/
function () {
  function Share() {}

  Share.share = function share(content, options) {
    if (options === void 0) {
      options = {};
    }

    invariant_default()(typeof content === 'object' && content !== null, 'Content to share must be a valid object');
    invariant_default()(typeof content.url === 'string' || typeof content.message === 'string', 'At least one of URL and message is required');
    invariant_default()(typeof options === 'object' && options !== null, 'Options must be a valid object');
    invariant_default()(!content.title || typeof content.title === 'string', 'Invalid title: title should be a string.');

    if (window.navigator.share !== undefined) {
      return window.navigator.share({
        title: content.title,
        text: content.message,
        url: content.url
      });
    } else {
      return Promise.reject(new Error('Share is not supported in this browser'));
    }
  }
  /**
   * The content was successfully shared.
   */
  ;

  Share_createClass(Share, null, [{
    key: "sharedAction",
    get: function get() {
      return 'sharedAction';
    }
    /**
     * The dialog has been dismissed.
     * @platform ios
     */

  }, {
    key: "dismissedAction",
    get: function get() {
      return 'dismissedAction';
    }
  }]);

  return Share;
}();

/* harmony default export */ var exports_Share = (Share_Share);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Vibration/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */
var _vibrate = function vibrate(pattern) {
  if ('vibrate' in window.navigator) {
    window.navigator.vibrate(pattern);
  }
};

var Vibration = {
  cancel: function cancel() {
    _vibrate(0);
  },
  vibrate: function vibrate(pattern) {
    if (pattern === void 0) {
      pattern = 400;
    }

    _vibrate(pattern);
  }
};
/* harmony default export */ var exports_Vibration = (Vibration);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/ActivityIndicator/index.js
function ActivityIndicator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { ActivityIndicator_defineProperty(target, key, source[key]); }); } return target; }

function ActivityIndicator_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ActivityIndicator_extends() { ActivityIndicator_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ActivityIndicator_extends.apply(this, arguments); }

function ActivityIndicator_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ActivityIndicator_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */







var ActivityIndicator_createSvgCircle = function createSvgCircle(style) {
  return external_react_default.a.createElement("circle", {
    cx: "16",
    cy: "16",
    fill: "none",
    r: "14",
    strokeWidth: "4",
    style: style
  });
};

var ActivityIndicator_ActivityIndicator =
/*#__PURE__*/
function (_Component) {
  ActivityIndicator_inheritsLoose(ActivityIndicator, _Component);

  function ActivityIndicator() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = ActivityIndicator.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        animating = _this$props.animating,
        color = _this$props.color,
        hidesWhenStopped = _this$props.hidesWhenStopped,
        size = _this$props.size,
        style = _this$props.style,
        other = ActivityIndicator_objectWithoutPropertiesLoose(_this$props, ["animating", "color", "hidesWhenStopped", "size", "style"]);

    var svg = external_react_default.a.createElement("svg", {
      height: "100%",
      viewBox: "0 0 32 32",
      width: "100%"
    }, ActivityIndicator_createSvgCircle({
      stroke: color,
      opacity: 0.2
    }), ActivityIndicator_createSvgCircle({
      stroke: color,
      strokeDasharray: 80,
      strokeDashoffset: 60
    }));
    return external_react_default.a.createElement(exports_View, ActivityIndicator_extends({}, other, {
      accessibilityRole: "progressbar",
      "aria-valuemax": "1",
      "aria-valuemin": "0",
      style: [ActivityIndicator_styles.container, style]
    }), external_react_default.a.createElement(exports_View, {
      children: svg,
      style: [typeof size === 'number' ? {
        height: size,
        width: size
      } : indicatorSizes[size], ActivityIndicator_styles.animation, !animating && ActivityIndicator_styles.animationPause, !animating && hidesWhenStopped && ActivityIndicator_styles.hidesWhenStopped]
    }));
  };

  return ActivityIndicator;
}(external_react_["Component"]);

ActivityIndicator_ActivityIndicator.displayName = 'ActivityIndicator';
ActivityIndicator_ActivityIndicator.defaultProps = {
  animating: true,
  color: '#1976D2',
  hidesWhenStopped: true,
  size: 'small'
};
ActivityIndicator_ActivityIndicator.propTypes =  false ? undefined : {};
var ActivityIndicator_styles = exports_StyleSheet.create({
  container: {
    alignItems: 'center',
    justifyContent: 'center'
  },
  hidesWhenStopped: {
    visibility: 'hidden'
  },
  animation: {
    animationDuration: '0.75s',
    animationKeyframes: [{
      '0%': {
        transform: [{
          rotate: '0deg'
        }]
      },
      '100%': {
        transform: [{
          rotate: '360deg'
        }]
      }
    }],
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite'
  },
  animationPause: {
    animationPlayState: 'paused'
  }
});
var indicatorSizes = exports_StyleSheet.create({
  small: {
    width: 20,
    height: 20
  },
  large: {
    width: 36,
    height: 36
  }
});
/* harmony default export */ var exports_ActivityIndicator = (modules_applyNativeMethods(ActivityIndicator_ActivityIndicator));
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Touchable/ensurePositiveDelayProps.js
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var ensurePositiveDelayProps_ensurePositiveDelayProps = function ensurePositiveDelayProps(props) {
  invariant_default()(!(props.delayPressIn < 0 || props.delayPressOut < 0 || props.delayLongPress < 0), 'Touchable components cannot have negative delay properties');
};

/* harmony default export */ var Touchable_ensurePositiveDelayProps = (ensurePositiveDelayProps_ensurePositiveDelayProps);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/PooledClass/index.js
/* eslint-disable */

/**
 * Copyright 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * From React 16.0.0
 */


var twoArgumentPooler = function twoArgumentPooler(a1, a2) {
  var Klass = this;

  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var standardReleaser = function standardReleaser(instance) {
  var Klass = this;
  instance.destructor();

  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = twoArgumentPooler;
/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */

var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;

  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }

  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  twoArgumentPooler: twoArgumentPooler
};
/* harmony default export */ var react_native_PooledClass = (PooledClass);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Touchable/BoundingDimensions.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var BoundingDimensions_twoArgumentPooler = react_native_PooledClass.twoArgumentPooler;
/**
 * PooledClass representing the bounding rectangle of a region.
 */

function BoundingDimensions(width, height) {
  this.width = width;
  this.height = height;
}

BoundingDimensions.prototype.destructor = function () {
  this.width = null;
  this.height = null;
};

BoundingDimensions.getPooledFromElement = function (element) {
  return BoundingDimensions.getPooled(element.offsetWidth, element.offsetHeight);
};

react_native_PooledClass.addPoolingTo(BoundingDimensions, BoundingDimensions_twoArgumentPooler);
/* harmony default export */ var Touchable_BoundingDimensions = (BoundingDimensions);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Touchable/Position.js
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

var Position_twoArgumentPooler = react_native_PooledClass.twoArgumentPooler;

function Position(left, top) {
  this.left = left;
  this.top = top;
}

Position.prototype.destructor = function () {
  this.left = null;
  this.top = null;
};

react_native_PooledClass.addPoolingTo(Position, Position_twoArgumentPooler);
/* harmony default export */ var Touchable_Position = (Position);
// EXTERNAL MODULE: ./node_modules/react-native-web/node_modules/fbjs/lib/TouchEventUtils.js
var TouchEventUtils = __webpack_require__(87);
var TouchEventUtils_default = /*#__PURE__*/__webpack_require__.n(TouchEventUtils);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Touchable/index.js
function Touchable_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { Touchable_defineProperty(target, key, source[key]); }); } return target; }

function Touchable_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable react/prop-types */

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */










/**
 * `Touchable`: Taps done right.
 *
 * You hook your `ResponderEventPlugin` events into `Touchable`. `Touchable`
 * will measure time/geometry and tells you when to give feedback to the user.
 *
 * ====================== Touchable Tutorial ===============================
 * The `Touchable` mixin helps you handle the "press" interaction. It analyzes
 * the geometry of elements, and observes when another responder (scroll view
 * etc) has stolen the touch lock. It notifies your component when it should
 * give feedback to the user. (bouncing/highlighting/unhighlighting).
 *
 * - When a touch was activated (typically you highlight)
 * - When a touch was deactivated (typically you unhighlight)
 * - When a touch was "pressed" - a touch ended while still within the geometry
 *   of the element, and no other element (like scroller) has "stolen" touch
 *   lock ("responder") (Typically you bounce the element).
 *
 * A good tap interaction isn't as simple as you might think. There should be a
 * slight delay before showing a highlight when starting a touch. If a
 * subsequent touch move exceeds the boundary of the element, it should
 * unhighlight, but if that same touch is brought back within the boundary, it
 * should rehighlight again. A touch can move in and out of that boundary
 * several times, each time toggling highlighting, but a "press" is only
 * triggered if that touch ends while within the element's boundary and no
 * scroller (or anything else) has stolen the lock on touches.
 *
 * To create a new type of component that handles interaction using the
 * `Touchable` mixin, do the following:
 *
 * - Initialize the `Touchable` state.
 *
 *   getInitialState: function() {
 *     return merge(this.touchableGetInitialState(), yourComponentState);
 *   }
 *
 * - Choose the rendered component who's touches should start the interactive
 *   sequence. On that rendered node, forward all `Touchable` responder
 *   handlers. You can choose any rendered node you like. Choose a node whose
 *   hit target you'd like to instigate the interaction sequence:
 *
 *   // In render function:
 *   return (
 *     <View
 *       onStartShouldSetResponder={this.touchableHandleStartShouldSetResponder}
 *       onResponderTerminationRequest={this.touchableHandleResponderTerminationRequest}
 *       onResponderGrant={this.touchableHandleResponderGrant}
 *       onResponderMove={this.touchableHandleResponderMove}
 *       onResponderRelease={this.touchableHandleResponderRelease}
 *       onResponderTerminate={this.touchableHandleResponderTerminate}>
 *       <View>
 *         Even though the hit detection/interactions are triggered by the
 *         wrapping (typically larger) node, we usually end up implementing
 *         custom logic that highlights this inner one.
 *       </View>
 *     </View>
 *   );
 *
 * - You may set up your own handlers for each of these events, so long as you
 *   also invoke the `touchable*` handlers inside of your custom handler.
 *
 * - Implement the handlers on your component class in order to provide
 *   feedback to the user. See documentation for each of these class methods
 *   that you should implement.
 *
 *   touchableHandlePress: function() {
 *      this.performBounceAnimation();  // or whatever you want to do.
 *   },
 *   touchableHandleActivePressIn: function() {
 *     this.beginHighlighting(...);  // Whatever you like to convey activation
 *   },
 *   touchableHandleActivePressOut: function() {
 *     this.endHighlighting(...);  // Whatever you like to convey deactivation
 *   },
 *
 * - There are more advanced methods you can implement (see documentation below):
 *   touchableGetHighlightDelayMS: function() {
 *     return 20;
 *   }
 *   // In practice, *always* use a predeclared constant (conserve memory).
 *   touchableGetPressRectOffset: function() {
 *     return {top: 20, left: 20, right: 20, bottom: 100};
 *   }
 */

/**
 * Touchable states.
 */
var States = {
  NOT_RESPONDER: 'NOT_RESPONDER',
  // Not the responder
  RESPONDER_INACTIVE_PRESS_IN: 'RESPONDER_INACTIVE_PRESS_IN',
  // Responder, inactive, in the `PressRect`
  RESPONDER_INACTIVE_PRESS_OUT: 'RESPONDER_INACTIVE_PRESS_OUT',
  // Responder, inactive, out of `PressRect`
  RESPONDER_ACTIVE_PRESS_IN: 'RESPONDER_ACTIVE_PRESS_IN',
  // Responder, active, in the `PressRect`
  RESPONDER_ACTIVE_PRESS_OUT: 'RESPONDER_ACTIVE_PRESS_OUT',
  // Responder, active, out of `PressRect`
  RESPONDER_ACTIVE_LONG_PRESS_IN: 'RESPONDER_ACTIVE_LONG_PRESS_IN',
  // Responder, active, in the `PressRect`, after long press threshold
  RESPONDER_ACTIVE_LONG_PRESS_OUT: 'RESPONDER_ACTIVE_LONG_PRESS_OUT',
  // Responder, active, out of `PressRect`, after long press threshold
  ERROR: 'ERROR'
};
/**
 * Quick lookup map for states that are considered to be "active"
 */

var IsActive = {
  RESPONDER_ACTIVE_PRESS_OUT: true,
  RESPONDER_ACTIVE_PRESS_IN: true
};
/**
 * Quick lookup for states that are considered to be "pressing" and are
 * therefore eligible to result in a "selection" if the press stops.
 */

var IsPressingIn = {
  RESPONDER_INACTIVE_PRESS_IN: true,
  RESPONDER_ACTIVE_PRESS_IN: true,
  RESPONDER_ACTIVE_LONG_PRESS_IN: true
};
var IsLongPressingIn = {
  RESPONDER_ACTIVE_LONG_PRESS_IN: true
};
/**
 * Inputs to the state machine.
 */

var Signals = {
  DELAY: 'DELAY',
  RESPONDER_GRANT: 'RESPONDER_GRANT',
  RESPONDER_RELEASE: 'RESPONDER_RELEASE',
  RESPONDER_TERMINATED: 'RESPONDER_TERMINATED',
  ENTER_PRESS_RECT: 'ENTER_PRESS_RECT',
  LEAVE_PRESS_RECT: 'LEAVE_PRESS_RECT',
  LONG_PRESS_DETECTED: 'LONG_PRESS_DETECTED'
};
/**
 * Mapping from States x Signals => States
 */

var Transitions = {
  NOT_RESPONDER: {
    DELAY: States.ERROR,
    RESPONDER_GRANT: States.RESPONDER_INACTIVE_PRESS_IN,
    RESPONDER_RELEASE: States.ERROR,
    RESPONDER_TERMINATED: States.ERROR,
    ENTER_PRESS_RECT: States.ERROR,
    LEAVE_PRESS_RECT: States.ERROR,
    LONG_PRESS_DETECTED: States.ERROR
  },
  RESPONDER_INACTIVE_PRESS_IN: {
    DELAY: States.RESPONDER_ACTIVE_PRESS_IN,
    RESPONDER_GRANT: States.ERROR,
    RESPONDER_RELEASE: States.NOT_RESPONDER,
    RESPONDER_TERMINATED: States.NOT_RESPONDER,
    ENTER_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_IN,
    LEAVE_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_OUT,
    LONG_PRESS_DETECTED: States.ERROR
  },
  RESPONDER_INACTIVE_PRESS_OUT: {
    DELAY: States.RESPONDER_ACTIVE_PRESS_OUT,
    RESPONDER_GRANT: States.ERROR,
    RESPONDER_RELEASE: States.NOT_RESPONDER,
    RESPONDER_TERMINATED: States.NOT_RESPONDER,
    ENTER_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_IN,
    LEAVE_PRESS_RECT: States.RESPONDER_INACTIVE_PRESS_OUT,
    LONG_PRESS_DETECTED: States.ERROR
  },
  RESPONDER_ACTIVE_PRESS_IN: {
    DELAY: States.ERROR,
    RESPONDER_GRANT: States.ERROR,
    RESPONDER_RELEASE: States.NOT_RESPONDER,
    RESPONDER_TERMINATED: States.NOT_RESPONDER,
    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_IN,
    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_OUT,
    LONG_PRESS_DETECTED: States.RESPONDER_ACTIVE_LONG_PRESS_IN
  },
  RESPONDER_ACTIVE_PRESS_OUT: {
    DELAY: States.ERROR,
    RESPONDER_GRANT: States.ERROR,
    RESPONDER_RELEASE: States.NOT_RESPONDER,
    RESPONDER_TERMINATED: States.NOT_RESPONDER,
    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_IN,
    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_PRESS_OUT,
    LONG_PRESS_DETECTED: States.ERROR
  },
  RESPONDER_ACTIVE_LONG_PRESS_IN: {
    DELAY: States.ERROR,
    RESPONDER_GRANT: States.ERROR,
    RESPONDER_RELEASE: States.NOT_RESPONDER,
    RESPONDER_TERMINATED: States.NOT_RESPONDER,
    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_IN,
    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_OUT,
    LONG_PRESS_DETECTED: States.RESPONDER_ACTIVE_LONG_PRESS_IN
  },
  RESPONDER_ACTIVE_LONG_PRESS_OUT: {
    DELAY: States.ERROR,
    RESPONDER_GRANT: States.ERROR,
    RESPONDER_RELEASE: States.NOT_RESPONDER,
    RESPONDER_TERMINATED: States.NOT_RESPONDER,
    ENTER_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_IN,
    LEAVE_PRESS_RECT: States.RESPONDER_ACTIVE_LONG_PRESS_OUT,
    LONG_PRESS_DETECTED: States.ERROR
  },
  error: {
    DELAY: States.NOT_RESPONDER,
    RESPONDER_GRANT: States.RESPONDER_INACTIVE_PRESS_IN,
    RESPONDER_RELEASE: States.NOT_RESPONDER,
    RESPONDER_TERMINATED: States.NOT_RESPONDER,
    ENTER_PRESS_RECT: States.NOT_RESPONDER,
    LEAVE_PRESS_RECT: States.NOT_RESPONDER,
    LONG_PRESS_DETECTED: States.NOT_RESPONDER
  }
}; // ==== Typical Constants for integrating into UI components ====
// var HIT_EXPAND_PX = 20;
// var HIT_VERT_OFFSET_PX = 10;

var HIGHLIGHT_DELAY_MS = 130;
var PRESS_EXPAND_PX = 20;
var LONG_PRESS_THRESHOLD = 500;
var LONG_PRESS_DELAY_MS = LONG_PRESS_THRESHOLD - HIGHLIGHT_DELAY_MS;
var LONG_PRESS_ALLOWED_MOVEMENT = 10; // Default amount "active" region protrudes beyond box

/**
 * By convention, methods prefixed with underscores are meant to be @private,
 * and not @protected. Mixers shouldn't access them - not even to provide them
 * as callback handlers.
 *
 *
 * ========== Geometry =========
 * `Touchable` only assumes that there exists a `HitRect` node. The `PressRect`
 * is an abstract box that is extended beyond the `HitRect`.
 *
 *  +--------------------------+
 *  |                          | - "Start" events in `HitRect` cause `HitRect`
 *  |  +--------------------+  |   to become the responder.
 *  |  |  +--------------+  |  | - `HitRect` is typically expanded around
 *  |  |  |              |  |  |   the `VisualRect`, but shifted downward.
 *  |  |  |  VisualRect  |  |  | - After pressing down, after some delay,
 *  |  |  |              |  |  |   and before letting up, the Visual React
 *  |  |  +--------------+  |  |   will become "active". This makes it eligible
 *  |  |     HitRect        |  |   for being highlighted (so long as the
 *  |  +--------------------+  |   press remains in the `PressRect`).
 *  |        PressRect     o   |
 *  +----------------------|---+
 *           Out Region    |
 *                         +-----+ This gap between the `HitRect` and
 *                                 `PressRect` allows a touch to move far away
 *                                 from the original hit rect, and remain
 *                                 highlighted, and eligible for a "Press".
 *                                 Customize this via
 *                                 `touchableGetPressRectOffset()`.
 *
 *
 *
 * ======= State Machine =======
 *
 * +-------------+ <---+ RESPONDER_RELEASE
 * |NOT_RESPONDER|
 * +-------------+ <---+ RESPONDER_TERMINATED
 *     +
 *     | RESPONDER_GRANT (HitRect)
 *     v
 * +---------------------------+  DELAY   +-------------------------+  T + DELAY     +------------------------------+
 * |RESPONDER_INACTIVE_PRESS_IN|+-------->|RESPONDER_ACTIVE_PRESS_IN| +------------> |RESPONDER_ACTIVE_LONG_PRESS_IN|
 * +---------------------------+          +-------------------------+                +------------------------------+
 *     +            ^                         +           ^                                 +           ^
 *     |LEAVE_      |ENTER_                   |LEAVE_     |ENTER_                           |LEAVE_     |ENTER_
 *     |PRESS_RECT  |PRESS_RECT               |PRESS_RECT |PRESS_RECT                       |PRESS_RECT |PRESS_RECT
 *     |            |                         |           |                                 |           |
 *     v            +                         v           +                                 v           +
 * +----------------------------+  DELAY  +--------------------------+               +-------------------------------+
 * |RESPONDER_INACTIVE_PRESS_OUT|+------->|RESPONDER_ACTIVE_PRESS_OUT|               |RESPONDER_ACTIVE_LONG_PRESS_OUT|
 * +----------------------------+         +--------------------------+               +-------------------------------+
 *
 * T + DELAY => LONG_PRESS_DELAY_MS + DELAY
 *
 * Not drawn are the side effects of each transition. The most important side
 * effect is the `touchableHandlePress` abstract method invocation that occurs
 * when a responder is released while in either of the "Press" states.
 *
 * The other important side effects are the highlight abstract method
 * invocations (internal callbacks) to be implemented by the mixer.
 *
 *
 * @lends Touchable.prototype
 */

var TouchableMixin = {
  // HACK (part 1): basic support for touchable interactions using a keyboard
  componentDidMount: function componentDidMount() {
    var _this = this;

    this._touchableNode = exports_findNodeHandle(this);

    if (this._touchableNode && this._touchableNode.addEventListener) {
      this._touchableBlurListener = function (e) {
        if (_this._isTouchableKeyboardActive) {
          if (_this.state.touchable.touchState && _this.state.touchable.touchState !== States.NOT_RESPONDER) {
            _this.touchableHandleResponderTerminate({
              nativeEvent: e
            });
          }

          _this._isTouchableKeyboardActive = false;
        }
      };

      this._touchableNode.addEventListener('blur', this._touchableBlurListener);
    }
  },

  /**
   * Clear all timeouts on unmount
   */
  componentWillUnmount: function componentWillUnmount() {
    if (this._touchableNode && this._touchableNode.addEventListener) {
      this._touchableNode.removeEventListener('blur', this._touchableBlurListener);
    }

    this.touchableDelayTimeout && clearTimeout(this.touchableDelayTimeout);
    this.longPressDelayTimeout && clearTimeout(this.longPressDelayTimeout);
    this.pressOutDelayTimeout && clearTimeout(this.pressOutDelayTimeout);
  },

  /**
   * It's prefer that mixins determine state in this way, having the class
   * explicitly mix the state in the one and only `getInitialState` method.
   *
   * @return {object} State object to be placed inside of
   * `this.state.touchable`.
   */
  touchableGetInitialState: function touchableGetInitialState() {
    return {
      touchable: {
        touchState: undefined,
        responderID: null
      }
    };
  },
  // ==== Hooks to Gesture Responder system ====

  /**
   * Must return true if embedded in a native platform scroll view.
   */
  touchableHandleResponderTerminationRequest: function touchableHandleResponderTerminationRequest() {
    return !this.props.rejectResponderTermination;
  },

  /**
   * Must return true to start the process of `Touchable`.
   */
  touchableHandleStartShouldSetResponder: function touchableHandleStartShouldSetResponder() {
    return !this.props.disabled;
  },

  /**
   * Return true to cancel press on long press.
   */
  touchableLongPressCancelsPress: function touchableLongPressCancelsPress() {
    return true;
  },

  /**
   * Place as callback for a DOM element's `onResponderGrant` event.
   */
  touchableHandleResponderGrant: function touchableHandleResponderGrant(e) {
    var dispatchID = e.currentTarget; // Since e is used in a callback invoked on another event loop
    // (as in setTimeout etc), we need to call e.persist() on the
    // event to make sure it doesn't get reused in the event object pool.

    e.persist();
    this.pressOutDelayTimeout && clearTimeout(this.pressOutDelayTimeout);
    this.pressOutDelayTimeout = null;
    this.state.touchable.touchState = States.NOT_RESPONDER;
    this.state.touchable.responderID = dispatchID;

    this._receiveSignal(Signals.RESPONDER_GRANT, e);

    var delayMS = this.touchableGetHighlightDelayMS !== undefined ? Math.max(this.touchableGetHighlightDelayMS(), 0) : HIGHLIGHT_DELAY_MS;
    delayMS = isNaN(delayMS) ? HIGHLIGHT_DELAY_MS : delayMS;

    if (delayMS !== 0) {
      this.touchableDelayTimeout = setTimeout(this._handleDelay.bind(this, e), delayMS);
    } else {
      this.state.touchable.positionOnActivate = null;

      this._handleDelay(e);
    }

    var longDelayMS = this.touchableGetLongPressDelayMS !== undefined ? Math.max(this.touchableGetLongPressDelayMS(), 10) : LONG_PRESS_DELAY_MS;
    longDelayMS = isNaN(longDelayMS) ? LONG_PRESS_DELAY_MS : longDelayMS;
    this.longPressDelayTimeout = setTimeout(this._handleLongDelay.bind(this, e), longDelayMS + delayMS);
  },

  /**
   * Place as callback for a DOM element's `onResponderRelease` event.
   */
  touchableHandleResponderRelease: function touchableHandleResponderRelease(e) {
    this._receiveSignal(Signals.RESPONDER_RELEASE, e);
  },

  /**
   * Place as callback for a DOM element's `onResponderTerminate` event.
   */
  touchableHandleResponderTerminate: function touchableHandleResponderTerminate(e) {
    this._receiveSignal(Signals.RESPONDER_TERMINATED, e);
  },

  /**
   * Place as callback for a DOM element's `onResponderMove` event.
   */
  touchableHandleResponderMove: function touchableHandleResponderMove(e) {
    // Not enough time elapsed yet, wait for highlight -
    // this is just a perf optimization.
    if (this.state.touchable.touchState === States.RESPONDER_INACTIVE_PRESS_IN) {
      return;
    } // Measurement may not have returned yet.


    if (!this.state.touchable.positionOnActivate) {
      return;
    }

    var positionOnActivate = this.state.touchable.positionOnActivate;
    var dimensionsOnActivate = this.state.touchable.dimensionsOnActivate;
    var pressRectOffset = this.touchableGetPressRectOffset ? this.touchableGetPressRectOffset() : {
      left: PRESS_EXPAND_PX,
      right: PRESS_EXPAND_PX,
      top: PRESS_EXPAND_PX,
      bottom: PRESS_EXPAND_PX
    };
    var pressExpandLeft = pressRectOffset.left;
    var pressExpandTop = pressRectOffset.top;
    var pressExpandRight = pressRectOffset.right;
    var pressExpandBottom = pressRectOffset.bottom;
    var hitSlop = this.touchableGetHitSlop ? this.touchableGetHitSlop() : null;

    if (hitSlop) {
      pressExpandLeft += hitSlop.left;
      pressExpandTop += hitSlop.top;
      pressExpandRight += hitSlop.right;
      pressExpandBottom += hitSlop.bottom;
    }

    var touch = TouchEventUtils_default.a.extractSingleTouch(e.nativeEvent);
    var pageX = touch && touch.pageX;
    var pageY = touch && touch.pageY;

    if (this.pressInLocation) {
      var movedDistance = this._getDistanceBetweenPoints(pageX, pageY, this.pressInLocation.pageX, this.pressInLocation.pageY);

      if (movedDistance > LONG_PRESS_ALLOWED_MOVEMENT) {
        this._cancelLongPressDelayTimeout();
      }
    }

    var isTouchWithinActive = pageX > positionOnActivate.left - pressExpandLeft && pageY > positionOnActivate.top - pressExpandTop && pageX < positionOnActivate.left + dimensionsOnActivate.width + pressExpandRight && pageY < positionOnActivate.top + dimensionsOnActivate.height + pressExpandBottom;

    if (isTouchWithinActive) {
      this._receiveSignal(Signals.ENTER_PRESS_RECT, e);

      var curState = this.state.touchable.touchState;

      if (curState === States.RESPONDER_INACTIVE_PRESS_IN) {
        // fix for t7967420
        this._cancelLongPressDelayTimeout();
      }
    } else {
      this._cancelLongPressDelayTimeout();

      this._receiveSignal(Signals.LEAVE_PRESS_RECT, e);
    }
  },
  // ==== Abstract Application Callbacks ====

  /**
   * Invoked when the item should be highlighted. Mixers should implement this
   * to visually distinguish the `VisualRect` so that the user knows that
   * releasing a touch will result in a "selection" (analog to click).
   *
   * @abstract
   * touchableHandleActivePressIn: function,
   */

  /**
   * Invoked when the item is "active" (in that it is still eligible to become
   * a "select") but the touch has left the `PressRect`. Usually the mixer will
   * want to unhighlight the `VisualRect`. If the user (while pressing) moves
   * back into the `PressRect` `touchableHandleActivePressIn` will be invoked
   * again and the mixer should probably highlight the `VisualRect` again. This
   * event will not fire on an `touchEnd/mouseUp` event, only move events while
   * the user is depressing the mouse/touch.
   *
   * @abstract
   * touchableHandleActivePressOut: function
   */

  /**
   * Invoked when the item is "selected" - meaning the interaction ended by
   * letting up while the item was either in the state
   * `RESPONDER_ACTIVE_PRESS_IN` or `RESPONDER_INACTIVE_PRESS_IN`.
   *
   * @abstract
   * touchableHandlePress: function
   */

  /**
   * Invoked when the item is long pressed - meaning the interaction ended by
   * letting up while the item was in `RESPONDER_ACTIVE_LONG_PRESS_IN`. If
   * `touchableHandleLongPress` is *not* provided, `touchableHandlePress` will
   * be called as it normally is. If `touchableHandleLongPress` is provided, by
   * default any `touchableHandlePress` callback will not be invoked. To
   * override this default behavior, override `touchableLongPressCancelsPress`
   * to return false. As a result, `touchableHandlePress` will be called when
   * lifting up, even if `touchableHandleLongPress` has also been called.
   *
   * @abstract
   * touchableHandleLongPress: function
   */

  /**
   * Returns the number of millis to wait before triggering a highlight.
   *
   * @abstract
   * touchableGetHighlightDelayMS: function
   */

  /**
   * Returns the amount to extend the `HitRect` into the `PressRect`. Positive
   * numbers mean the size expands outwards.
   *
   * @abstract
   * touchableGetPressRectOffset: function
   */
  // ==== Internal Logic ====

  /**
   * Measures the `HitRect` node on activation. The Bounding rectangle is with
   * respect to viewport - not page, so adding the `pageXOffset/pageYOffset`
   * should result in points that are in the same coordinate system as an
   * event's `globalX/globalY` data values.
   *
   * - Consider caching this for the lifetime of the component, or possibly
   *   being able to share this cache between any `ScrollMap` view.
   *
   * @sideeffects
   * @private
   */
  _remeasureMetricsOnActivation: function _remeasureMetricsOnActivation() {
    var tag = this.state.touchable.responderID;

    if (tag == null) {
      return;
    }

    UIManager["a" /* default */].measure(tag, this._handleQueryLayout);
  },
  _handleQueryLayout: function _handleQueryLayout(x, y, width, height, globalX, globalY) {
    // don't do anything if UIManager failed to measure node
    if (!x && !y && !width && !height && !globalX && !globalY) {
      return;
    }

    this.state.touchable.positionOnActivate && Touchable_Position.release(this.state.touchable.positionOnActivate);
    this.state.touchable.dimensionsOnActivate && // $FlowFixMe
    Touchable_BoundingDimensions.release(this.state.touchable.dimensionsOnActivate);
    this.state.touchable.positionOnActivate = Touchable_Position.getPooled(globalX, globalY); // $FlowFixMe

    this.state.touchable.dimensionsOnActivate = Touchable_BoundingDimensions.getPooled(width, height);
  },
  _handleDelay: function _handleDelay(e) {
    this.touchableDelayTimeout = null;

    this._receiveSignal(Signals.DELAY, e);
  },
  _handleLongDelay: function _handleLongDelay(e) {
    this.longPressDelayTimeout = null;
    var curState = this.state.touchable.touchState;

    if (curState !== States.RESPONDER_ACTIVE_PRESS_IN && curState !== States.RESPONDER_ACTIVE_LONG_PRESS_IN) {
      console.error('Attempted to transition from state `' + curState + '` to `' + States.RESPONDER_ACTIVE_LONG_PRESS_IN + '`, which is not supported. This is ' + 'most likely due to `Touchable.longPressDelayTimeout` not being cancelled.');
    } else {
      this._receiveSignal(Signals.LONG_PRESS_DETECTED, e);
    }
  },

  /**
   * Receives a state machine signal, performs side effects of the transition
   * and stores the new state. Validates the transition as well.
   *
   * @param {Signals} signal State machine signal.
   * @throws Error if invalid state transition or unrecognized signal.
   * @sideeffects
   */
  _receiveSignal: function _receiveSignal(signal, e) {
    var responderID = this.state.touchable.responderID;
    var curState = this.state.touchable.touchState;
    var nextState = Transitions[curState] && Transitions[curState][signal];

    if (!responderID && signal === Signals.RESPONDER_RELEASE) {
      return;
    }

    if (!nextState) {
      throw new Error('Unrecognized signal `' + signal + '` or state `' + curState + '` for Touchable responder `' + responderID + '`');
    }

    if (nextState === States.ERROR) {
      throw new Error('Touchable cannot transition from `' + curState + '` to `' + signal + '` for responder `' + responderID + '`');
    }

    if (curState !== nextState) {
      this._performSideEffectsForTransition(curState, nextState, signal, e);

      this.state.touchable.touchState = nextState;
    }
  },
  _cancelLongPressDelayTimeout: function _cancelLongPressDelayTimeout() {
    this.longPressDelayTimeout && clearTimeout(this.longPressDelayTimeout);
    this.longPressDelayTimeout = null;
  },
  _isHighlight: function _isHighlight(state) {
    return state === States.RESPONDER_ACTIVE_PRESS_IN || state === States.RESPONDER_ACTIVE_LONG_PRESS_IN;
  },
  _savePressInLocation: function _savePressInLocation(e) {
    var touch = TouchEventUtils_default.a.extractSingleTouch(e.nativeEvent);
    var pageX = touch && touch.pageX;
    var pageY = touch && touch.pageY;
    this.pressInLocation = {
      pageX: pageX,
      pageY: pageY,

      get locationX() {
        return touch && touch.locationX;
      },

      get locationY() {
        return touch && touch.locationY;
      }

    };
  },
  _getDistanceBetweenPoints: function _getDistanceBetweenPoints(aX, aY, bX, bY) {
    var deltaX = aX - bX;
    var deltaY = aY - bY;
    return Math.sqrt(deltaX * deltaX + deltaY * deltaY);
  },

  /**
   * Will perform a transition between touchable states, and identify any
   * highlighting or unhighlighting that must be performed for this particular
   * transition.
   *
   * @param {States} curState Current Touchable state.
   * @param {States} nextState Next Touchable state.
   * @param {Signal} signal Signal that triggered the transition.
   * @param {Event} e Native event.
   * @sideeffects
   */
  _performSideEffectsForTransition: function _performSideEffectsForTransition(curState, nextState, signal, e) {
    var curIsHighlight = this._isHighlight(curState);

    var newIsHighlight = this._isHighlight(nextState);

    var isFinalSignal = signal === Signals.RESPONDER_TERMINATED || signal === Signals.RESPONDER_RELEASE;

    if (isFinalSignal) {
      this._cancelLongPressDelayTimeout();
    }

    if (!IsActive[curState] && IsActive[nextState]) {
      this._remeasureMetricsOnActivation();
    }

    if (IsPressingIn[curState] && signal === Signals.LONG_PRESS_DETECTED) {
      this.touchableHandleLongPress && this.touchableHandleLongPress(e);
    }

    if (newIsHighlight && !curIsHighlight) {
      this._startHighlight(e);
    } else if (!newIsHighlight && curIsHighlight) {
      this._endHighlight(e);
    }

    if (IsPressingIn[curState] && signal === Signals.RESPONDER_RELEASE) {
      var hasLongPressHandler = !!this.props.onLongPress;
      var pressIsLongButStillCallOnPress = IsLongPressingIn[curState] && ( // We *are* long pressing..
      !hasLongPressHandler || // But either has no long handler
      !this.touchableLongPressCancelsPress()); // or we're told to ignore it.

      var shouldInvokePress = !IsLongPressingIn[curState] || pressIsLongButStillCallOnPress;

      if (shouldInvokePress && this.touchableHandlePress) {
        if (!newIsHighlight && !curIsHighlight) {
          // we never highlighted because of delay, but we should highlight now
          this._startHighlight(e);

          this._endHighlight(e);
        }

        this.touchableHandlePress(e);
      }
    }

    this.touchableDelayTimeout && clearTimeout(this.touchableDelayTimeout);
    this.touchableDelayTimeout = null;
  },
  _startHighlight: function _startHighlight(e) {
    this._savePressInLocation(e);

    this.touchableHandleActivePressIn && this.touchableHandleActivePressIn(e);
  },
  _endHighlight: function _endHighlight(e) {
    var _this2 = this;

    if (this.touchableHandleActivePressOut) {
      if (this.touchableGetPressOutDelayMS && this.touchableGetPressOutDelayMS()) {
        this.pressOutDelayTimeout = setTimeout(function () {
          _this2.touchableHandleActivePressOut(e);
        }, this.touchableGetPressOutDelayMS());
      } else {
        this.touchableHandleActivePressOut(e);
      }
    }
  },
  // HACK (part 2): basic support for touchable interactions using a keyboard (including
  // delays and longPress)
  touchableHandleKeyEvent: function touchableHandleKeyEvent(e) {
    var ENTER = 13;
    var SPACE = 32;
    var type = e.type,
        which = e.which;

    if (which === ENTER || which === SPACE) {
      if (type === 'keydown') {
        if (!this._isTouchableKeyboardActive) {
          if (!this.state.touchable.touchState || this.state.touchable.touchState === States.NOT_RESPONDER) {
            this.touchableHandleResponderGrant(e);
            this._isTouchableKeyboardActive = true;
          }
        }
      } else if (type === 'keyup') {
        if (this._isTouchableKeyboardActive) {
          if (this.state.touchable.touchState && this.state.touchable.touchState !== States.NOT_RESPONDER) {
            this.touchableHandleResponderRelease(e);
            this._isTouchableKeyboardActive = false;
          }
        }
      }

      e.stopPropagation(); // prevent the default behaviour unless the Touchable functions as a link
      // and Enter is pressed

      if (!(which === ENTER && modules_AccessibilityUtil.propsToAriaRole(this.props) === 'link')) {
        e.preventDefault();
      }
    }
  }
};
var Touchable = {
  Mixin: TouchableMixin,
  TOUCH_TARGET_DEBUG: false,
  // Highlights all touchable targets. Toggle with Inspector.

  /**
   * Renders a debugging overlay to visualize touch target with hitSlop (might not work on Android).
   */
  renderDebugView: function renderDebugView(_ref) {
    var color = _ref.color,
        hitSlop = _ref.hitSlop;

    if (false) { var hexColor, key, debugHitSlopStyle; }
  }
};
/* harmony default export */ var exports_Touchable = (Touchable);
// EXTERNAL MODULE: ./node_modules/react-timer-mixin/TimerMixin.js
var TimerMixin = __webpack_require__(29);
var TimerMixin_default = /*#__PURE__*/__webpack_require__.n(TimerMixin);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/TouchableWithoutFeedback/index.js
function TouchableWithoutFeedback_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { TouchableWithoutFeedback_defineProperty(target, key, source[key]); }); } return target; }

function TouchableWithoutFeedback_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function TouchableWithoutFeedback_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Copyright (c) 2016-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */










var PRESS_RETENTION_OFFSET = {
  top: 20,
  left: 20,
  right: 20,
  bottom: 30
};
/**
 * Do not use unless you have a very good reason. All elements that
 * respond to press should have a visual feedback when touched.
 *
 * TouchableWithoutFeedback supports only one child.
 * If you wish to have several child components, wrap them in a View.
 */

/* eslint-disable react/prefer-es6-class, react/prop-types */

var TouchableWithoutFeedback = create_react_class_default()({
  displayName: 'TouchableWithoutFeedback',
  mixins: [TimerMixin_default.a, exports_Touchable.Mixin],
  propTypes: {
    accessibilityComponentType: exports_ViewPropTypes.accessibilityComponentType,
    accessibilityLabel: external_prop_types_["string"],
    accessibilityRole: exports_ViewPropTypes.accessibilityRole,
    accessibilityTraits: exports_ViewPropTypes.accessibilityTraits,
    accessible: external_prop_types_["bool"],
    children: external_prop_types_["any"],

    /**
     * Delay in ms, from onPressIn, before onLongPress is called.
     */
    delayLongPress: external_prop_types_["number"],

    /**
     * Delay in ms, from the start of the touch, before onPressIn is called.
     */
    delayPressIn: external_prop_types_["number"],

    /**
     * Delay in ms, from the release of the touch, before onPressOut is called.
     */
    delayPressOut: external_prop_types_["number"],

    /**
     * If true, disable all interactions for this component.
     */
    disabled: external_prop_types_["bool"],

    /**
     * This defines how far your touch can start away from the button. This is
     * added to `pressRetentionOffset` when moving off of the button.
     */
    // $FlowFixMe(>=0.41.0)
    hitSlop: exports_EdgeInsetsPropType,

    /**
     * Invoked on mount and layout changes with
     *
     *   `{nativeEvent: {layout: {x, y, width, height}}}`
     */
    onLayout: external_prop_types_["func"],
    onLongPress: external_prop_types_["func"],

    /**
     * Called when the touch is released, but not if cancelled (e.g. by a scroll
     * that steals the responder lock).
     */
    onPress: external_prop_types_["func"],
    onPressIn: external_prop_types_["func"],
    onPressOut: external_prop_types_["func"],

    /**
     * When the scroll view is disabled, this defines how far your touch may
     * move off of the button, before deactivating the button. Once deactivated,
     * try moving it back and you'll see that the button is once again
     * reactivated! Move it back and forth several times while the scroll view
     * is disabled. Ensure you pass in a constant to reduce memory allocations.
     */
    // $FlowFixMe
    pressRetentionOffset: exports_EdgeInsetsPropType,
    testID: external_prop_types_["string"]
  },
  getInitialState: function getInitialState() {
    return this.touchableGetInitialState();
  },
  componentDidMount: function componentDidMount() {
    Touchable_ensurePositiveDelayProps(this.props);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    Touchable_ensurePositiveDelayProps(nextProps);
  },

  /**
   * `Touchable.Mixin` self callbacks. The mixin will invoke these if they are
   * defined on your component.
   */
  touchableHandlePress: function touchableHandlePress(e) {
    this.props.onPress && this.props.onPress(e);
  },
  touchableHandleActivePressIn: function touchableHandleActivePressIn(e) {
    this.props.onPressIn && this.props.onPressIn(e);
  },
  touchableHandleActivePressOut: function touchableHandleActivePressOut(e) {
    this.props.onPressOut && this.props.onPressOut(e);
  },
  touchableHandleLongPress: function touchableHandleLongPress(e) {
    this.props.onLongPress && this.props.onLongPress(e);
  },
  touchableGetPressRectOffset: function touchableGetPressRectOffset() {
    return this.props.pressRetentionOffset || PRESS_RETENTION_OFFSET;
  },
  touchableGetHitSlop: function touchableGetHitSlop() {
    return this.props.hitSlop;
  },
  touchableGetHighlightDelayMS: function touchableGetHighlightDelayMS() {
    return this.props.delayPressIn || 0;
  },
  touchableGetLongPressDelayMS: function touchableGetLongPressDelayMS() {
    return this.props.delayLongPress === 0 ? 0 : this.props.delayLongPress || 500;
  },
  touchableGetPressOutDelayMS: function touchableGetPressOutDelayMS() {
    return this.props.delayPressOut || 0;
  },
  render: function render() {
    var _this$props = this.props,
        delayLongPress = _this$props.delayLongPress,
        delayPressIn = _this$props.delayPressIn,
        delayPressOut = _this$props.delayPressOut,
        onLongPress = _this$props.onLongPress,
        onPress = _this$props.onPress,
        onPressIn = _this$props.onPressIn,
        onPressOut = _this$props.onPressOut,
        pressRetentionOffset = _this$props.pressRetentionOffset,
        other = TouchableWithoutFeedback_objectWithoutPropertiesLoose(_this$props, ["delayLongPress", "delayPressIn", "delayPressOut", "onLongPress", "onPress", "onPressIn", "onPressOut", "pressRetentionOffset"]); // Note(avik): remove dynamic typecast once Flow has been upgraded
    // $FlowFixMe


    var child = external_react_default.a.Children.only(this.props.children);
    var children = child.props.children;
    warning_default()(!child.type || child.type.displayName !== 'Text', 'TouchableWithoutFeedback does not work well with Text children. Wrap children in a View instead. See ' + (child._owner && child._owner.getName && child._owner.getName() || '<unknown>'));

    if (false) {}

    var style = exports_Touchable.TOUCH_TARGET_DEBUG && child.type && child.type.displayName === 'Text' ? [!this.props.disabled && TouchableWithoutFeedback_styles.actionable, child.props.style, {
      color: 'red'
    }] : [!this.props.disabled && TouchableWithoutFeedback_styles.actionable, child.props.style];
    return external_react_default.a.cloneElement(child, TouchableWithoutFeedback_objectSpread({}, other, {
      accessible: this.props.accessible !== false,
      children: children,
      onKeyDown: this.touchableHandleKeyEvent,
      onKeyUp: this.touchableHandleKeyEvent,
      onResponderGrant: this.touchableHandleResponderGrant,
      onResponderMove: this.touchableHandleResponderMove,
      onResponderRelease: this.touchableHandleResponderRelease,
      onResponderTerminate: this.touchableHandleResponderTerminate,
      onResponderTerminationRequest: this.touchableHandleResponderTerminationRequest,
      onStartShouldSetResponder: this.touchableHandleStartShouldSetResponder,
      style: style
    }));
  }
});
var TouchableWithoutFeedback_styles = exports_StyleSheet.create({
  actionable: {
    cursor: 'pointer',
    touchAction: 'manipulation'
  }
});
/* harmony default export */ var exports_TouchableWithoutFeedback = (TouchableWithoutFeedback);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/TouchableOpacity/index.js
function TouchableOpacity_extends() { TouchableOpacity_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return TouchableOpacity_extends.apply(this, arguments); }

function TouchableOpacity_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TouchableOpacity_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { TouchableOpacity_defineProperty(target, key, source[key]); }); } return target; }

function TouchableOpacity_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */









var TouchableOpacity_flattenStyle = exports_StyleSheet.flatten;
var TouchableOpacity_PRESS_RETENTION_OFFSET = {
  top: 20,
  left: 20,
  right: 20,
  bottom: 30
};
/**
 * A wrapper for making views respond properly to touches.
 * On press down, the opacity of the wrapped view is decreased, dimming it.
 *
 * Opacity is controlled by wrapping the children in a View, which is
 * added to the view hiearchy. Be aware that this can affect layout.
 *
 * Example:
 *
 * ```
 * renderButton: function() {
 *   return (
 *     <TouchableOpacity onPress={this._onPressButton}>
 *       <Image
 *         style={styles.button}
 *         source={require('./myButton.png')}
 *       />
 *     </TouchableOpacity>
 *   );
 * },
 * ```
 */

/* eslint-disable react/prefer-es6-class */

var TouchableOpacity = create_react_class_default()({
  displayName: 'TouchableOpacity',
  mixins: [exports_Touchable.Mixin],
  propTypes: TouchableOpacity_objectSpread({}, exports_TouchableWithoutFeedback.propTypes, {
    /**
     * Determines what the opacity of the wrapped view should be when touch is
     * active.
     */
    activeOpacity: external_prop_types_["number"],
    focusedOpacity: external_prop_types_["number"]
  }),
  getDefaultProps: function getDefaultProps() {
    return {
      activeOpacity: 0.2,
      focusedOpacity: 0.7
    };
  },
  getInitialState: function getInitialState() {
    return this.touchableGetInitialState();
  },
  componentDidMount: function componentDidMount() {
    Touchable_ensurePositiveDelayProps(this.props);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    Touchable_ensurePositiveDelayProps(nextProps);
  },

  /**
   * Animate the touchable to a new opacity.
   */
  setOpacityTo: function setOpacityTo(value, duration) {
    this.setNativeProps({
      style: {
        opacity: value,
        transitionDuration: duration ? duration / 1000 + "s" : '0s'
      }
    });
  },

  /**
   * `Touchable.Mixin` self callbacks. The mixin will invoke these if they are
   * defined on your component.
   */
  touchableHandleActivePressIn: function touchableHandleActivePressIn(e) {
    if (e.dispatchConfig.registrationName === 'onResponderGrant') {
      this._opacityActive(0);
    } else {
      this._opacityActive(150);
    }

    this.props.onPressIn && this.props.onPressIn(e);
  },
  touchableHandleActivePressOut: function touchableHandleActivePressOut(e) {
    this._opacityInactive(250);

    this.props.onPressOut && this.props.onPressOut(e);
  },
  touchableHandlePress: function touchableHandlePress(e) {
    this.props.onPress && this.props.onPress(e);
  },
  touchableHandleLongPress: function touchableHandleLongPress(e) {
    this.props.onLongPress && this.props.onLongPress(e);
  },
  touchableGetPressRectOffset: function touchableGetPressRectOffset() {
    return this.props.pressRetentionOffset || TouchableOpacity_PRESS_RETENTION_OFFSET;
  },
  touchableGetHitSlop: function touchableGetHitSlop() {
    return this.props.hitSlop;
  },
  touchableGetHighlightDelayMS: function touchableGetHighlightDelayMS() {
    return this.props.delayPressIn || 0;
  },
  touchableGetLongPressDelayMS: function touchableGetLongPressDelayMS() {
    return this.props.delayLongPress === 0 ? 0 : this.props.delayLongPress || 500;
  },
  touchableGetPressOutDelayMS: function touchableGetPressOutDelayMS() {
    return this.props.delayPressOut;
  },
  _opacityActive: function _opacityActive(duration) {
    this.setOpacityTo(this.props.activeOpacity, duration);
  },
  _opacityInactive: function _opacityInactive(duration) {
    this.setOpacityTo(this._getChildStyleOpacityWithDefault(), duration);
  },
  _opacityFocused: function _opacityFocused() {
    this.setOpacityTo(this.props.focusedOpacity);
  },
  _getChildStyleOpacityWithDefault: function _getChildStyleOpacityWithDefault() {
    var childStyle = TouchableOpacity_flattenStyle(this.props.style) || {};
    return childStyle.opacity === undefined ? 1 : childStyle.opacity;
  },
  render: function render() {
    var _this$props = this.props,
        activeOpacity = _this$props.activeOpacity,
        focusedOpacity = _this$props.focusedOpacity,
        delayLongPress = _this$props.delayLongPress,
        delayPressIn = _this$props.delayPressIn,
        delayPressOut = _this$props.delayPressOut,
        onLongPress = _this$props.onLongPress,
        onPress = _this$props.onPress,
        onPressIn = _this$props.onPressIn,
        onPressOut = _this$props.onPressOut,
        pressRetentionOffset = _this$props.pressRetentionOffset,
        other = TouchableOpacity_objectWithoutPropertiesLoose(_this$props, ["activeOpacity", "focusedOpacity", "delayLongPress", "delayPressIn", "delayPressOut", "onLongPress", "onPress", "onPressIn", "onPressOut", "pressRetentionOffset"]);

    return external_react_default.a.createElement(exports_View, TouchableOpacity_extends({}, other, {
      accessible: this.props.accessible !== false,
      onKeyDown: this.touchableHandleKeyEvent,
      onKeyUp: this.touchableHandleKeyEvent,
      onResponderGrant: this.touchableHandleResponderGrant,
      onResponderMove: this.touchableHandleResponderMove,
      onResponderRelease: this.touchableHandleResponderRelease,
      onResponderTerminate: this.touchableHandleResponderTerminate,
      onResponderTerminationRequest: this.touchableHandleResponderTerminationRequest,
      onStartShouldSetResponder: this.touchableHandleStartShouldSetResponder,
      style: [TouchableOpacity_styles.root, !this.props.disabled && TouchableOpacity_styles.actionable, this.props.style]
    }), this.props.children, exports_Touchable.renderDebugView({
      color: 'blue',
      hitSlop: this.props.hitSlop
    }));
  }
});
var TouchableOpacity_styles = exports_StyleSheet.create({
  root: {
    transitionProperty: 'opacity',
    transitionDuration: '0.15s',
    userSelect: 'none'
  },
  actionable: {
    cursor: 'pointer',
    touchAction: 'manipulation'
  }
});
/* harmony default export */ var exports_TouchableOpacity = (modules_applyNativeMethods(TouchableOpacity));
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Button/index.js
function Button_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */







var Button_Button =
/*#__PURE__*/
function (_Component) {
  Button_inheritsLoose(Button, _Component);

  function Button() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = Button.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        accessibilityLabel = _this$props.accessibilityLabel,
        color = _this$props.color,
        disabled = _this$props.disabled,
        onPress = _this$props.onPress,
        testID = _this$props.testID,
        title = _this$props.title;
    return external_react_default.a.createElement(exports_TouchableOpacity, {
      accessibilityLabel: accessibilityLabel,
      accessibilityRole: "button",
      disabled: disabled,
      onPress: onPress,
      style: [Button_styles.button, color && {
        backgroundColor: color
      }, disabled && Button_styles.buttonDisabled],
      testID: testID
    }, external_react_default.a.createElement(exports_Text, {
      style: [Button_styles.text, disabled && Button_styles.textDisabled]
    }, title));
  };

  return Button;
}(external_react_["Component"]);

Button_Button.propTypes =  false ? undefined : {};
var Button_styles = exports_StyleSheet.create({
  button: {
    backgroundColor: '#2196F3',
    borderRadius: 2
  },
  text: {
    color: '#fff',
    fontWeight: '500',
    padding: 8,
    textAlign: 'center',
    textTransform: 'uppercase'
  },
  buttonDisabled: {
    backgroundColor: '#dfdfdf'
  },
  textDisabled: {
    color: '#a1a1a1'
  }
});
/* harmony default export */ var exports_Button = (Button_Button);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/CheckBox/index.js
function CheckBox_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { CheckBox_defineProperty(target, key, source[key]); }); } return target; }

function CheckBox_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function CheckBox_extends() { CheckBox_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return CheckBox_extends.apply(this, arguments); }

function CheckBox_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function CheckBox_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */










var CheckBox_CheckBox =
/*#__PURE__*/
function (_Component) {
  CheckBox_inheritsLoose(CheckBox, _Component);

  function CheckBox() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this._handleChange = function (event) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onValueChange = _this$props.onValueChange;
      var value = event.nativeEvent.target.checked;
      event.nativeEvent.value = value;
      onChange && onChange(event);
      onValueChange && onValueChange(value);
    };

    _this._setCheckboxRef = function (element) {
      _this._checkboxElement = element;
    };

    return _this;
  }

  var _proto = CheckBox.prototype;

  _proto.blur = function blur() {
    UIManager["a" /* default */].blur(this._checkboxElement);
  };

  _proto.focus = function focus() {
    UIManager["a" /* default */].focus(this._checkboxElement);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        color = _this$props2.color,
        disabled = _this$props2.disabled,
        onChange = _this$props2.onChange,
        onValueChange = _this$props2.onValueChange,
        style = _this$props2.style,
        value = _this$props2.value,
        other = CheckBox_objectWithoutPropertiesLoose(_this$props2, ["color", "disabled", "onChange", "onValueChange", "style", "value"]);

    var fakeControl = external_react_default.a.createElement(exports_View, {
      style: [CheckBox_styles.fakeControl, value && CheckBox_styles.fakeControlChecked, // custom color
      value && color && {
        backgroundColor: color,
        borderColor: color
      }, disabled && CheckBox_styles.fakeControlDisabled, value && disabled && CheckBox_styles.fakeControlCheckedAndDisabled]
    });
    var nativeControl = exports_createElement('input', {
      checked: value,
      disabled: disabled,
      onChange: this._handleChange,
      ref: this._setCheckboxRef,
      style: [CheckBox_styles.nativeControl, CheckBox_styles.cursorInherit],
      type: 'checkbox'
    });
    return external_react_default.a.createElement(exports_View, CheckBox_extends({}, other, {
      style: [CheckBox_styles.root, style, disabled && CheckBox_styles.cursorDefault]
    }), fakeControl, nativeControl);
  };

  return CheckBox;
}(external_react_["Component"]);

CheckBox_CheckBox.displayName = 'CheckBox';
CheckBox_CheckBox.defaultProps = {
  disabled: false,
  value: false
};
CheckBox_CheckBox.propTypes =  false ? undefined : {};
var CheckBox_styles = exports_StyleSheet.create({
  root: {
    cursor: 'pointer',
    height: 16,
    userSelect: 'none',
    width: 16
  },
  cursorDefault: {
    cursor: 'default'
  },
  cursorInherit: {
    cursor: 'inherit'
  },
  fakeControl: {
    alignItems: 'center',
    backgroundColor: '#fff',
    borderColor: '#657786',
    borderRadius: 2,
    borderStyle: 'solid',
    borderWidth: 2,
    height: '100%',
    justifyContent: 'center',
    width: '100%'
  },
  fakeControlChecked: {
    backgroundColor: '#009688',
    backgroundImage: 'url("data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIgogICB4bWxuczpjYz0iaHR0cDovL2NyZWF0aXZlY29tbW9ucy5vcmcvbnMjIgogICB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiCiAgIHhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgdmVyc2lvbj0iMS4xIgogICB2aWV3Qm94PSIwIDAgMSAxIgogICBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWluWU1pbiBtZWV0Ij4KICA8cGF0aAogICAgIGQ9Ik0gMC4wNDAzODA1OSwwLjYyNjc3NjcgMC4xNDY0NDY2MSwwLjUyMDcxMDY4IDAuNDI5Mjg5MzIsMC44MDM1NTMzOSAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IE0gMC4yMTcxNTcyOSwwLjgwMzU1MzM5IDAuODUzNTUzMzksMC4xNjcxNTcyOSAwLjk1OTYxOTQxLDAuMjczMjIzMyAwLjMyMzIyMzMsMC45MDk2MTk0MSB6IgogICAgIGlkPSJyZWN0Mzc4MCIKICAgICBzdHlsZT0iZmlsbDojZmZmZmZmO2ZpbGwtb3BhY2l0eToxO3N0cm9rZTpub25lIiAvPgo8L3N2Zz4K")',
    backgroundRepeat: 'no-repeat',
    borderColor: '#009688'
  },
  fakeControlDisabled: {
    borderColor: '#CCD6DD'
  },
  fakeControlCheckedAndDisabled: {
    backgroundColor: '#AAB8C2',
    borderColor: '#AAB8C2'
  },
  nativeControl: CheckBox_objectSpread({}, exports_StyleSheet.absoluteFillObject, {
    height: '100%',
    margin: 0,
    opacity: 0,
    padding: 0,
    width: '100%'
  })
});
/* harmony default export */ var exports_CheckBox = (modules_applyNativeMethods(CheckBox_CheckBox));
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/UnimplementedView/index.js
function UnimplementedView_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * Common implementation for a simple stubbed view.
 */

/* eslint-disable react/prop-types */

var UnimplementedView_UnimplementedView =
/*#__PURE__*/
function (_Component) {
  UnimplementedView_inheritsLoose(UnimplementedView, _Component);

  function UnimplementedView() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = UnimplementedView.prototype;

  _proto.setNativeProps = function setNativeProps() {// Do nothing.
    // This method is required in order to use this view as a Touchable* child.
    // See ensureComponentIsNative.js for more info
  };

  _proto.render = function render() {
    return external_react_default.a.createElement(exports_View, {
      style: [unimplementedViewStyles, this.props.style]
    }, this.props.children);
  };

  return UnimplementedView;
}(external_react_["Component"]);

var unimplementedViewStyles =  false ? undefined : {};
/* harmony default export */ var modules_UnimplementedView = (UnimplementedView_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/Batchinator/index.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/**
 * A simple class for batching up invocations of a low-pri callback. A timeout is set to run the
 * callback once after a delay, no matter how many times it's scheduled. Once the delay is reached,
 * InteractionManager.runAfterInteractions is used to invoke the callback after any hi-pri
 * interactions are done running.
 *
 * Make sure to cleanup with dispose().  Example:
 *
 *   class Widget extends React.Component {
 *     _batchedSave: new Batchinator(() => this._saveState, 1000);
 *     _saveSate() {
 *       // save this.state to disk
 *     }
 *     componentDidUpdate() {
 *       this._batchedSave.schedule();
 *     }
 *     componentWillUnmount() {
 *       this._batchedSave.dispose();
 *     }
 *     ...
 *   }
 */

var Batchinator_Batchinator =
/*#__PURE__*/
function () {
  function Batchinator(callback, delayMS) {
    this._delay = delayMS;
    this._callback = callback;
  }
  /*
   * Cleanup any pending tasks.
   *
   * By default, if there is a pending task the callback is run immediately. Set the option abort to
   * true to not call the callback if it was pending.
   */


  var _proto = Batchinator.prototype;

  _proto.dispose = function dispose(options) {
    if (options === void 0) {
      options = {
        abort: false
      };
    }

    if (this._taskHandle) {
      this._taskHandle.cancel();

      if (!options.abort) {
        this._callback();
      }

      this._taskHandle = null;
    }
  };

  _proto.schedule = function schedule() {
    var _this = this;

    if (this._taskHandle) {
      return;
    }

    var timeoutHandle = setTimeout(function () {
      _this._taskHandle = InteractionManager["a" /* default */].runAfterInteractions(function () {
        // Note that we clear the handle before invoking the callback so that if the callback calls
        // schedule again, it will actually schedule another task.
        _this._taskHandle = null;

        _this._callback();
      });
    }, this._delay);
    this._taskHandle = {
      cancel: function cancel() {
        return clearTimeout(timeoutHandle);
      }
    };
  };

  return Batchinator;
}();

/* harmony default export */ var react_native_Batchinator = (Batchinator_Batchinator);
// EXTERNAL MODULE: ./node_modules/react-native-web/node_modules/fbjs/lib/performanceNow.js
var performanceNow = __webpack_require__(69);
var performanceNow_default = /*#__PURE__*/__webpack_require__.n(performanceNow);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/FillRateHelper/index.js
function FillRateHelper_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { FillRateHelper_defineProperty(target, key, source[key]); }); } return target; }

function FillRateHelper_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */



var Info = function Info() {
  this.any_blank_count = 0;
  this.any_blank_ms = 0;
  this.any_blank_speed_sum = 0;
  this.mostly_blank_count = 0;
  this.mostly_blank_ms = 0;
  this.pixels_blank = 0;
  this.pixels_sampled = 0;
  this.pixels_scrolled = 0;
  this.total_time_spent = 0;
  this.sample_count = 0;
};

var DEBUG = false;
var _listeners = [];
var _minSampleCount = 10;

var _sampleRate = DEBUG ? 1 : null;
/**
 * A helper class for detecting when the maximem fill rate of `VirtualizedList` is exceeded.
 * By default the sampling rate is set to zero and this will do nothing. If you want to collect
 * samples (e.g. to log them), make sure to call `FillRateHelper.setSampleRate(0.0-1.0)`.
 *
 * Listeners and sample rate are global for all `VirtualizedList`s - typical usage will combine with
 * `SceneTracker.getActiveScene` to determine the context of the events.
 */


var FillRateHelper_FillRateHelper =
/*#__PURE__*/
function () {
  FillRateHelper.addListener = function addListener(callback) {
    warning_default()(_sampleRate !== null, 'Call `FillRateHelper.setSampleRate` before `addListener`.');

    _listeners.push(callback);

    return {
      remove: function remove() {
        _listeners = _listeners.filter(function (listener) {
          return callback !== listener;
        });
      }
    };
  };

  FillRateHelper.setSampleRate = function setSampleRate(sampleRate) {
    _sampleRate = sampleRate;
  };

  FillRateHelper.setMinSampleCount = function setMinSampleCount(minSampleCount) {
    _minSampleCount = minSampleCount;
  };

  function FillRateHelper(getFrameMetrics) {
    this._anyBlankStartTime = null;
    this._enabled = false;
    this._info = new Info();
    this._mostlyBlankStartTime = null;
    this._samplesStartTime = null;
    this._getFrameMetrics = getFrameMetrics;
    this._enabled = (_sampleRate || 0) > Math.random();

    this._resetData();
  }

  var _proto = FillRateHelper.prototype;

  _proto.activate = function activate() {
    if (this._enabled && this._samplesStartTime == null) {
      DEBUG && console.debug('FillRateHelper: activate');
      this._samplesStartTime = performanceNow_default()();
    }
  };

  _proto.deactivateAndFlush = function deactivateAndFlush() {
    if (!this._enabled) {
      return;
    }

    var start = this._samplesStartTime; // const for flow

    if (start == null) {
      DEBUG && console.debug('FillRateHelper: bail on deactivate with no start time');
      return;
    }

    if (this._info.sample_count < _minSampleCount) {
      // Don't bother with under-sampled events.
      this._resetData();

      return;
    }

    var total_time_spent = performanceNow_default()() - start;

    var info = FillRateHelper_objectSpread({}, this._info, {
      total_time_spent: total_time_spent
    });

    if (DEBUG) {
      var derived = {
        avg_blankness: this._info.pixels_blank / this._info.pixels_sampled,
        avg_speed: this._info.pixels_scrolled / (total_time_spent / 1000),
        avg_speed_when_any_blank: this._info.any_blank_speed_sum / this._info.any_blank_count,
        any_blank_per_min: this._info.any_blank_count / (total_time_spent / 1000 / 60),
        any_blank_time_frac: this._info.any_blank_ms / total_time_spent,
        mostly_blank_per_min: this._info.mostly_blank_count / (total_time_spent / 1000 / 60),
        mostly_blank_time_frac: this._info.mostly_blank_ms / total_time_spent
      };

      for (var key in derived) {
        derived[key] = Math.round(1000 * derived[key]) / 1000;
      }

      console.debug('FillRateHelper deactivateAndFlush: ', {
        derived: derived,
        info: info
      });
    }

    _listeners.forEach(function (listener) {
      return listener(info);
    });

    this._resetData();
  };

  _proto.computeBlankness = function computeBlankness(props, state, scrollMetrics) {
    if (!this._enabled || props.getItemCount(props.data) === 0 || this._samplesStartTime == null) {
      return 0;
    }

    var dOffset = scrollMetrics.dOffset,
        offset = scrollMetrics.offset,
        velocity = scrollMetrics.velocity,
        visibleLength = scrollMetrics.visibleLength; // Denominator metrics that we track for all events - most of the time there is no blankness and
    // we want to capture that.

    this._info.sample_count++;
    this._info.pixels_sampled += Math.round(visibleLength);
    this._info.pixels_scrolled += Math.round(Math.abs(dOffset));
    var scrollSpeed = Math.round(Math.abs(velocity) * 1000); // px / sec
    // Whether blank now or not, record the elapsed time blank if we were blank last time.

    var now = performanceNow_default()();

    if (this._anyBlankStartTime != null) {
      this._info.any_blank_ms += now - this._anyBlankStartTime;
    }

    this._anyBlankStartTime = null;

    if (this._mostlyBlankStartTime != null) {
      this._info.mostly_blank_ms += now - this._mostlyBlankStartTime;
    }

    this._mostlyBlankStartTime = null;
    var blankTop = 0;
    var first = state.first;

    var firstFrame = this._getFrameMetrics(first);

    while (first <= state.last && (!firstFrame || !firstFrame.inLayout)) {
      firstFrame = this._getFrameMetrics(first);
      first++;
    } // Only count blankTop if we aren't rendering the first item, otherwise we will count the header
    // as blank.


    if (firstFrame && first > 0) {
      blankTop = Math.min(visibleLength, Math.max(0, firstFrame.offset - offset));
    }

    var blankBottom = 0;
    var last = state.last;

    var lastFrame = this._getFrameMetrics(last);

    while (last >= state.first && (!lastFrame || !lastFrame.inLayout)) {
      lastFrame = this._getFrameMetrics(last);
      last--;
    } // Only count blankBottom if we aren't rendering the last item, otherwise we will count the
    // footer as blank.


    if (lastFrame && last < props.getItemCount(props.data) - 1) {
      var bottomEdge = lastFrame.offset + lastFrame.length;
      blankBottom = Math.min(visibleLength, Math.max(0, offset + visibleLength - bottomEdge));
    }

    var pixels_blank = Math.round(blankTop + blankBottom);
    var blankness = pixels_blank / visibleLength;

    if (blankness > 0) {
      this._anyBlankStartTime = now;
      this._info.any_blank_speed_sum += scrollSpeed;
      this._info.any_blank_count++;
      this._info.pixels_blank += pixels_blank;

      if (blankness > 0.5) {
        this._mostlyBlankStartTime = now;
        this._info.mostly_blank_count++;
      }
    } else if (scrollSpeed < 0.01 || Math.abs(dOffset) < 1) {
      this.deactivateAndFlush();
    }

    return blankness;
  };

  _proto.enabled = function enabled() {
    return this._enabled;
  };

  _proto._resetData = function _resetData() {
    this._anyBlankStartTime = null;
    this._info = new Info();
    this._mostlyBlankStartTime = null;
    this._samplesStartTime = null;
  };

  return FillRateHelper;
}();

/* harmony default export */ var react_native_FillRateHelper = (FillRateHelper_FillRateHelper);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/RefreshControl/index.js
function RefreshControl_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { RefreshControl_defineProperty(target, key, source[key]); }); } return target; }

function RefreshControl_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function RefreshControl_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function RefreshControl_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */






var RefreshControl_RefreshControl =
/*#__PURE__*/
function (_Component) {
  RefreshControl_inheritsLoose(RefreshControl, _Component);

  function RefreshControl() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = RefreshControl.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        colors = _this$props.colors,
        enabled = _this$props.enabled,
        onRefresh = _this$props.onRefresh,
        progressBackgroundColor = _this$props.progressBackgroundColor,
        progressViewOffset = _this$props.progressViewOffset,
        refreshing = _this$props.refreshing,
        size = _this$props.size,
        tintColor = _this$props.tintColor,
        title = _this$props.title,
        titleColor = _this$props.titleColor,
        rest = RefreshControl_objectWithoutPropertiesLoose(_this$props, ["colors", "enabled", "onRefresh", "progressBackgroundColor", "progressViewOffset", "refreshing", "size", "tintColor", "title", "titleColor"]);

    return external_react_default.a.createElement(exports_View, rest);
  };

  return RefreshControl;
}(external_react_["Component"]);

RefreshControl_RefreshControl.propTypes =  false ? undefined : {};
/* harmony default export */ var exports_RefreshControl = (RefreshControl_RefreshControl);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/ViewabilityHelper/index.js
function ViewabilityHelper_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { ViewabilityHelper_defineProperty(target, key, source[key]); }); } return target; }

function ViewabilityHelper_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


/**
 * A Utility class for calculating viewable items based on current metrics like scroll position and
 * layout.
 *
 * An item is said to be in a "viewable" state when any of the following
 * is true for longer than `minimumViewTime` milliseconds (after an interaction if `waitForInteraction`
 * is true):
 *
 * - Occupying >= `viewAreaCoveragePercentThreshold` of the view area XOR fraction of the item
 *   visible in the view area >= `itemVisiblePercentThreshold`.
 * - Entirely visible on screen
 */
var ViewabilityHelper_ViewabilityHelper =
/*#__PURE__*/
function () {
  /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an error
   * found when Flow v0.63 was deployed. To see the error delete this comment
   * and run Flow. */
  function ViewabilityHelper(config) {
    if (config === void 0) {
      config = {
        viewAreaCoveragePercentThreshold: 0
      };
    }

    this._hasInteracted = false;
    this._timers = new Set();
    this._viewableIndices = [];
    this._viewableItems = new Map();
    this._config = config;
  }
  /**
   * Cleanup, e.g. on unmount. Clears any pending timers.
   */


  var _proto = ViewabilityHelper.prototype;

  _proto.dispose = function dispose() {
    this._timers.forEach(clearTimeout);
  }
  /**
   * Determines which items are viewable based on the current metrics and config.
   */
  ;

  _proto.computeViewableItems = function computeViewableItems(itemCount, scrollOffset, viewportHeight, getFrameMetrics, renderRange) {
    var _this$_config = this._config,
        itemVisiblePercentThreshold = _this$_config.itemVisiblePercentThreshold,
        viewAreaCoveragePercentThreshold = _this$_config.viewAreaCoveragePercentThreshold;
    var viewAreaMode = viewAreaCoveragePercentThreshold != null;
    var viewablePercentThreshold = viewAreaMode ? viewAreaCoveragePercentThreshold : itemVisiblePercentThreshold;
    invariant_default()(viewablePercentThreshold != null && itemVisiblePercentThreshold != null !== (viewAreaCoveragePercentThreshold != null), 'Must set exactly one of itemVisiblePercentThreshold or viewAreaCoveragePercentThreshold');
    var viewableIndices = [];

    if (itemCount === 0) {
      return viewableIndices;
    }

    var firstVisible = -1;

    var _ref = renderRange || {
      first: 0,
      last: itemCount - 1
    },
        first = _ref.first,
        last = _ref.last;

    invariant_default()(last < itemCount, 'Invalid render range ' + JSON.stringify({
      renderRange: renderRange,
      itemCount: itemCount
    }));

    for (var idx = first; idx <= last; idx++) {
      var metrics = getFrameMetrics(idx);

      if (!metrics) {
        continue;
      }

      var top = metrics.offset - scrollOffset;
      var bottom = top + metrics.length;

      if (top < viewportHeight && bottom > 0) {
        firstVisible = idx;

        if (_isViewable(viewAreaMode, viewablePercentThreshold, top, bottom, viewportHeight, metrics.length)) {
          viewableIndices.push(idx);
        }
      } else if (firstVisible >= 0) {
        break;
      }
    }

    return viewableIndices;
  }
  /**
   * Figures out which items are viewable and how that has changed from before and calls
   * `onViewableItemsChanged` as appropriate.
   */
  ;

  _proto.onUpdate = function onUpdate(itemCount, scrollOffset, viewportHeight, getFrameMetrics, createViewToken, onViewableItemsChanged, renderRange) {
    var _this = this;

    if (this._config.waitForInteraction && !this._hasInteracted || itemCount === 0 || !getFrameMetrics(0)) {
      return;
    }

    var viewableIndices = [];

    if (itemCount) {
      viewableIndices = this.computeViewableItems(itemCount, scrollOffset, viewportHeight, getFrameMetrics, renderRange);
    }

    if (this._viewableIndices.length === viewableIndices.length && this._viewableIndices.every(function (v, ii) {
      return v === viewableIndices[ii];
    })) {
      // We might get a lot of scroll events where visibility doesn't change and we don't want to do
      // extra work in those cases.
      return;
    }

    this._viewableIndices = viewableIndices;

    if (this._config.minimumViewTime) {
      var handle = setTimeout(function () {
        _this._timers.delete(handle);

        _this._onUpdateSync(viewableIndices, onViewableItemsChanged, createViewToken);
      }, this._config.minimumViewTime);

      this._timers.add(handle);
    } else {
      this._onUpdateSync(viewableIndices, onViewableItemsChanged, createViewToken);
    }
  }
  /**
   * clean-up cached _viewableIndices to evaluate changed items on next update
   */
  ;

  _proto.resetViewableIndices = function resetViewableIndices() {
    this._viewableIndices = [];
  }
  /**
   * Records that an interaction has happened even if there has been no scroll.
   */
  ;

  _proto.recordInteraction = function recordInteraction() {
    this._hasInteracted = true;
  };

  _proto._onUpdateSync = function _onUpdateSync(viewableIndicesToCheck, onViewableItemsChanged, createViewToken) {
    var _this2 = this;

    // Filter out indices that have gone out of view since this call was scheduled.
    viewableIndicesToCheck = viewableIndicesToCheck.filter(function (ii) {
      return _this2._viewableIndices.includes(ii);
    });
    var prevItems = this._viewableItems;
    var nextItems = new Map(viewableIndicesToCheck.map(function (ii) {
      var viewable = createViewToken(ii, true);
      return [viewable.key, viewable];
    }));
    var changed = [];

    for (var _iterator = nextItems, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref2;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref2 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref2 = _i.value;
      }

      var _ref4 = _ref2,
          key = _ref4[0],
          viewable = _ref4[1];

      if (!prevItems.has(key)) {
        changed.push(viewable);
      }
    }

    for (var _iterator2 = prevItems, _isArray2 = Array.isArray(_iterator2), _i2 = 0, _iterator2 = _isArray2 ? _iterator2 : _iterator2[Symbol.iterator]();;) {
      var _ref3;

      if (_isArray2) {
        if (_i2 >= _iterator2.length) break;
        _ref3 = _iterator2[_i2++];
      } else {
        _i2 = _iterator2.next();
        if (_i2.done) break;
        _ref3 = _i2.value;
      }

      var _ref5 = _ref3,
          key = _ref5[0],
          viewable = _ref5[1];

      if (!nextItems.has(key)) {
        changed.push(ViewabilityHelper_objectSpread({}, viewable, {
          isViewable: false
        }));
      }
    }

    if (changed.length > 0) {
      this._viewableItems = nextItems;
      onViewableItemsChanged({
        viewableItems: Array.from(nextItems.values()),
        changed: changed,
        viewabilityConfig: this._config
      });
    }
  };

  return ViewabilityHelper;
}();

function _isViewable(viewAreaMode, viewablePercentThreshold, top, bottom, viewportHeight, itemLength) {
  if (_isEntirelyVisible(top, bottom, viewportHeight)) {
    return true;
  } else {
    var pixels = _getPixelsVisible(top, bottom, viewportHeight);

    var percent = 100 * (viewAreaMode ? pixels / viewportHeight : pixels / itemLength);
    return percent >= viewablePercentThreshold;
  }
}

function _getPixelsVisible(top, bottom, viewportHeight) {
  var visibleHeight = Math.min(bottom, viewportHeight) - Math.max(top, 0);
  return Math.max(0, visibleHeight);
}

function _isEntirelyVisible(top, bottom, viewportHeight) {
  return top >= 0 && bottom <= viewportHeight && bottom > top;
}

/* harmony default export */ var react_native_ViewabilityHelper = (ViewabilityHelper_ViewabilityHelper);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/VirtualizeUtils/index.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */

/**
 * Used to find the indices of the frames that overlap the given offsets. Useful for finding the
 * items that bound different windows of content, such as the visible area or the buffered overscan
 * area.
 */

function elementsThatOverlapOffsets(offsets, itemCount, getFrameMetrics) {
  var out = [];
  var outLength = 0;

  for (var ii = 0; ii < itemCount; ii++) {
    var frame = getFrameMetrics(ii);
    var trailingOffset = frame.offset + frame.length;

    for (var kk = 0; kk < offsets.length; kk++) {
      if (out[kk] == null && trailingOffset >= offsets[kk]) {
        out[kk] = ii;
        outLength++;

        if (kk === offsets.length - 1) {
          invariant_default()(outLength === offsets.length, 'bad offsets input, should be in increasing order: %s', JSON.stringify(offsets));
          return out;
        }
      }
    }
  }

  return out;
}
/**
 * Computes the number of elements in the `next` range that are new compared to the `prev` range.
 * Handy for calculating how many new items will be rendered when the render window changes so we
 * can restrict the number of new items render at once so that content can appear on the screen
 * faster.
 */


function newRangeCount(prev, next) {
  return next.last - next.first + 1 - Math.max(0, 1 + Math.min(next.last, prev.last) - Math.max(next.first, prev.first));
}
/**
 * Custom logic for determining which items should be rendered given the current frame and scroll
 * metrics, as well as the previous render state. The algorithm may evolve over time, but generally
 * prioritizes the visible area first, then expands that with overscan regions ahead and behind,
 * biased in the direction of scroll.
 */


function computeWindowedRenderLimits(props, prev, getFrameMetricsApprox, scrollMetrics) {
  var data = props.data,
      getItemCount = props.getItemCount,
      maxToRenderPerBatch = props.maxToRenderPerBatch,
      windowSize = props.windowSize;
  var itemCount = getItemCount(data);

  if (itemCount === 0) {
    return prev;
  }

  var offset = scrollMetrics.offset,
      velocity = scrollMetrics.velocity,
      visibleLength = scrollMetrics.visibleLength; // Start with visible area, then compute maximum overscan region by expanding from there, biased
  // in the direction of scroll. Total overscan area is capped, which should cap memory consumption
  // too.

  var visibleBegin = Math.max(0, offset);
  var visibleEnd = visibleBegin + visibleLength;
  var overscanLength = (windowSize - 1) * visibleLength; // Considering velocity seems to introduce more churn than it's worth.

  var leadFactor = 0.5; // Math.max(0, Math.min(1, velocity / 25 + 0.5));

  var fillPreference = velocity > 1 ? 'after' : velocity < -1 ? 'before' : 'none';
  var overscanBegin = Math.max(0, visibleBegin - (1 - leadFactor) * overscanLength);
  var overscanEnd = Math.max(0, visibleEnd + leadFactor * overscanLength);
  var lastItemOffset = getFrameMetricsApprox(itemCount - 1).offset;

  if (lastItemOffset < overscanBegin) {
    // Entire list is before our overscan window
    return {
      first: Math.max(0, itemCount - 1 - maxToRenderPerBatch),
      last: itemCount - 1
    };
  } // Find the indices that correspond to the items at the render boundaries we're targeting.


  var _elementsThatOverlapO = elementsThatOverlapOffsets([overscanBegin, visibleBegin, visibleEnd, overscanEnd], props.getItemCount(props.data), getFrameMetricsApprox),
      overscanFirst = _elementsThatOverlapO[0],
      first = _elementsThatOverlapO[1],
      last = _elementsThatOverlapO[2],
      overscanLast = _elementsThatOverlapO[3];

  overscanFirst = overscanFirst == null ? 0 : overscanFirst;
  first = first == null ? Math.max(0, overscanFirst) : first;
  overscanLast = overscanLast == null ? itemCount - 1 : overscanLast;
  last = last == null ? Math.min(overscanLast, first + maxToRenderPerBatch - 1) : last;
  var visible = {
    first: first,
    last: last
  }; // We want to limit the number of new cells we're rendering per batch so that we can fill the
  // content on the screen quickly. If we rendered the entire overscan window at once, the user
  // could be staring at white space for a long time waiting for a bunch of offscreen content to
  // render.

  var newCellCount = newRangeCount(prev, visible);

  while (true) {
    if (first <= overscanFirst && last >= overscanLast) {
      // If we fill the entire overscan range, we're done.
      break;
    }

    var maxNewCells = newCellCount >= maxToRenderPerBatch;
    var firstWillAddMore = first <= prev.first || first > prev.last;
    var firstShouldIncrement = first > overscanFirst && (!maxNewCells || !firstWillAddMore);
    var lastWillAddMore = last >= prev.last || last < prev.first;
    var lastShouldIncrement = last < overscanLast && (!maxNewCells || !lastWillAddMore);

    if (maxNewCells && !firstShouldIncrement && !lastShouldIncrement) {
      // We only want to stop if we've hit maxNewCells AND we cannot increment first or last
      // without rendering new items. This let's us preserve as many already rendered items as
      // possible, reducing render churn and keeping the rendered overscan range as large as
      // possible.
      break;
    }

    if (firstShouldIncrement && !(fillPreference === 'after' && lastShouldIncrement && lastWillAddMore)) {
      if (firstWillAddMore) {
        newCellCount++;
      }

      first--;
    }

    if (lastShouldIncrement && !(fillPreference === 'before' && firstShouldIncrement && firstWillAddMore)) {
      if (lastWillAddMore) {
        newCellCount++;
      }

      last++;
    }
  }

  if (!(last >= first && first >= 0 && last < itemCount && first >= overscanFirst && last <= overscanLast && first <= visible.first && last >= visible.last)) {
    throw new Error('Bad window calculation ' + JSON.stringify({
      first: first,
      last: last,
      itemCount: itemCount,
      overscanFirst: overscanFirst,
      overscanLast: overscanLast,
      visible: visible
    }));
  }

  return {
    first: first,
    last: last
  };
}


var VirtualizeUtils = {
  computeWindowedRenderLimits: computeWindowedRenderLimits,
  elementsThatOverlapOffsets: elementsThatOverlapOffsets,
  newRangeCount: newRangeCount
};
/* harmony default export */ var react_native_VirtualizeUtils = (VirtualizeUtils);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/infoLog/index.js
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Intentional info-level logging for clear separation from ad-hoc console debug logging.
 */

function infoLog() {
  var _console;

  return (_console = console).log.apply(_console, arguments);
}

/* harmony default export */ var react_native_infoLog = (infoLog);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/VirtualizedList/index.js
function VirtualizedList_extends() { VirtualizedList_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return VirtualizedList_extends.apply(this, arguments); }

function VirtualizedList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { VirtualizedList_defineProperty(target, key, source[key]); }); } return target; }

function VirtualizedList_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function VirtualizedList_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function VirtualizedList_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */















var VirtualizedList_flattenStyle = exports_StyleSheet.flatten;

var VirtualizedList_DEV_ = "production" !== 'production';

var _usedIndexForKey = false;

/**
 * Base implementation for the more convenient [`<FlatList>`](/react-native/docs/flatlist.html)
 * and [`<SectionList>`](/react-native/docs/sectionlist.html) components, which are also better
 * documented. In general, this should only really be used if you need more flexibility than
 * `FlatList` provides, e.g. for use with immutable data instead of plain arrays.
 *
 * Virtualization massively improves memory consumption and performance of large lists by
 * maintaining a finite render window of active items and replacing all items outside of the render
 * window with appropriately sized blank space. The window adapts to scrolling behavior, and items
 * are rendered incrementally with low-pri (after any running interactions) if they are far from the
 * visible area, or with hi-pri otherwise to minimize the potential of seeing blank space.
 *
 * Some caveats:
 *
 * - Internal state is not preserved when content scrolls out of the render window. Make sure all
 *   your data is captured in the item data or external stores like Flux, Redux, or Relay.
 * - This is a `PureComponent` which means that it will not re-render if `props` remain shallow-
 *   equal. Make sure that everything your `renderItem` function depends on is passed as a prop
 *   (e.g. `extraData`) that is not `===` after updates, otherwise your UI may not update on
 *   changes. This includes the `data` prop and parent component state.
 * - In order to constrain memory and enable smooth scrolling, content is rendered asynchronously
 *   offscreen. This means it's possible to scroll faster than the fill rate ands momentarily see
 *   blank content. This is a tradeoff that can be adjusted to suit the needs of each application,
 *   and we are working on improving it behind the scenes.
 * - By default, the list looks for a `key` prop on each item and uses that for the React key.
 *   Alternatively, you can provide a custom `keyExtractor` prop.
 *
 */
var VirtualizedList_VirtualizedList =
/*#__PURE__*/
function (_React$PureComponent) {
  VirtualizedList_inheritsLoose(VirtualizedList, _React$PureComponent);

  var _proto = VirtualizedList.prototype;

  // scrollToEnd may be janky without getItemLayout prop
  _proto.scrollToEnd = function scrollToEnd(params) {
    var animated = params ? params.animated : true;
    var veryLast = this.props.getItemCount(this.props.data) - 1;

    var frame = this._getFrameMetricsApprox(veryLast);

    var offset = Math.max(0, frame.offset + frame.length + this._footerLength - this._scrollMetrics.visibleLength);
    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
     * suppresses an error when upgrading Flow's support for React. To see the
     * error delete this comment and run Flow. */

    this._scrollRef.scrollTo(
    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This
     * comment suppresses an error when upgrading Flow's support for React.
     * To see the error delete this comment and run Flow. */
    this.props.horizontal ? {
      x: offset,
      animated: animated
    } : {
      y: offset,
      animated: animated
    });
  } // scrollToIndex may be janky without getItemLayout prop
  ;

  _proto.scrollToIndex = function scrollToIndex(params) {
    var _this$props = this.props,
        data = _this$props.data,
        horizontal = _this$props.horizontal,
        getItemCount = _this$props.getItemCount,
        getItemLayout = _this$props.getItemLayout,
        onScrollToIndexFailed = _this$props.onScrollToIndexFailed;
    var animated = params.animated,
        index = params.index,
        viewOffset = params.viewOffset,
        viewPosition = params.viewPosition;
    invariant_default()(index >= 0 && index < getItemCount(data), "scrollToIndex out of range: " + index + " vs " + (getItemCount(data) - 1));

    if (!getItemLayout && index > this._highestMeasuredFrameIndex) {
      invariant_default()(!!onScrollToIndexFailed, 'scrollToIndex should be used in conjunction with getItemLayout or onScrollToIndexFailed, ' + 'otherwise there is no way to know the location of offscreen indices or handle failures.');
      onScrollToIndexFailed({
        averageItemLength: this._averageCellLength,
        highestMeasuredFrameIndex: this._highestMeasuredFrameIndex,
        index: index
      });
      return;
    }

    var frame = this._getFrameMetricsApprox(index);

    var offset = Math.max(0, frame.offset - (viewPosition || 0) * (this._scrollMetrics.visibleLength - frame.length)) - (viewOffset || 0);
    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
     * suppresses an error when upgrading Flow's support for React. To see the
     * error delete this comment and run Flow. */

    this._scrollRef.scrollTo(
    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This
     * comment suppresses an error when upgrading Flow's support for React.
     * To see the error delete this comment and run Flow. */
    horizontal ? {
      x: offset,
      animated: animated
    } : {
      y: offset,
      animated: animated
    });
  } // scrollToItem may be janky without getItemLayout prop. Required linear scan through items -
  // use scrollToIndex instead if possible.
  ;

  _proto.scrollToItem = function scrollToItem(params) {
    var item = params.item;
    var _this$props2 = this.props,
        data = _this$props2.data,
        getItem = _this$props2.getItem,
        getItemCount = _this$props2.getItemCount;
    var itemCount = getItemCount(data);

    for (var _index = 0; _index < itemCount; _index++) {
      if (getItem(data, _index) === item) {
        this.scrollToIndex(VirtualizedList_objectSpread({}, params, {
          index: _index
        }));
        break;
      }
    }
  }
  /**
   * Scroll to a specific content pixel offset in the list.
   *
   * Param `offset` expects the offset to scroll to.
   * In case of `horizontal` is true, the offset is the x-value,
   * in any other case the offset is the y-value.
   *
   * Param `animated` (`true` by default) defines whether the list
   * should do an animation while scrolling.
   */
  ;

  _proto.scrollToOffset = function scrollToOffset(params) {
    var animated = params.animated,
        offset = params.offset;
    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
     * suppresses an error when upgrading Flow's support for React. To see the
     * error delete this comment and run Flow. */

    this._scrollRef.scrollTo(
    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This
     * comment suppresses an error when upgrading Flow's support for React.
     * To see the error delete this comment and run Flow. */
    this.props.horizontal ? {
      x: offset,
      animated: animated
    } : {
      y: offset,
      animated: animated
    });
  };

  _proto.recordInteraction = function recordInteraction() {
    this._nestedChildLists.forEach(function (childList) {
      childList.ref && childList.ref.recordInteraction();
    });

    this._viewabilityTuples.forEach(function (t) {
      t.viewabilityHelper.recordInteraction();
    });

    this._updateViewableItems(this.props.data);
  };

  _proto.flashScrollIndicators = function flashScrollIndicators() {
    /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
     * suppresses an error when upgrading Flow's support for React. To see the
     * error delete this comment and run Flow. */
    this._scrollRef.flashScrollIndicators();
  }
  /**
   * Provides a handle to the underlying scroll responder.
   * Note that `this._scrollRef` might not be a `ScrollView`, so we
   * need to check that it responds to `getScrollResponder` before calling it.
   */
  ;

  _proto.getScrollResponder = function getScrollResponder() {
    if (this._scrollRef && this._scrollRef.getScrollResponder) {
      return this._scrollRef.getScrollResponder();
    }
  };

  _proto.getScrollableNode = function getScrollableNode() {
    if (this._scrollRef && this._scrollRef.getScrollableNode) {
      return this._scrollRef.getScrollableNode();
    } else {
      return exports_findNodeHandle(this._scrollRef);
    }
  };

  _proto.setNativeProps = function setNativeProps(props) {
    if (this._scrollRef) {
      this._scrollRef.setNativeProps(props);
    }
  };

  _proto.getChildContext = function getChildContext() {
    return {
      virtualizedList: {
        getScrollMetrics: this._getScrollMetrics,
        horizontal: this.props.horizontal,
        getOutermostParentListRef: this._getOutermostParentListRef,
        getNestedChildState: this._getNestedChildState,
        registerAsNestedChild: this._registerAsNestedChild,
        unregisterAsNestedChild: this._unregisterAsNestedChild
      }
    };
  };

  _proto._getCellKey = function _getCellKey() {
    return this.context.virtualizedCell && this.context.virtualizedCell.cellKey || 'rootList';
  };

  _proto.hasMore = function hasMore() {
    return this._hasMore;
  };

  function VirtualizedList(_props, context) {
    var _this;

    _this = _React$PureComponent.call(this, _props, context) || this;

    _this._getScrollMetrics = function () {
      return _this._scrollMetrics;
    };

    _this._getOutermostParentListRef = function () {
      if (_this._isNestedWithSameOrientation()) {
        return _this.context.virtualizedList.getOutermostParentListRef();
      } else {
        return VirtualizedList_assertThisInitialized(VirtualizedList_assertThisInitialized(_this));
      }
    };

    _this._getNestedChildState = function (key) {
      var existingChildData = _this._nestedChildLists.get(key);

      return existingChildData && existingChildData.state;
    };

    _this._registerAsNestedChild = function (childList) {
      // Register the mapping between this child key and the cellKey for its cell
      var childListsInCell = _this._cellKeysToChildListKeys.get(childList.cellKey) || new Set();
      childListsInCell.add(childList.key);

      _this._cellKeysToChildListKeys.set(childList.cellKey, childListsInCell);

      var existingChildData = _this._nestedChildLists.get(childList.key);

      invariant_default()(!(existingChildData && existingChildData.ref !== null), 'A VirtualizedList contains a cell which itself contains ' + 'more than one VirtualizedList of the same orientation as the parent ' + 'list. You must pass a unique listKey prop to each sibling list.');

      _this._nestedChildLists.set(childList.key, {
        ref: childList.ref,
        state: null
      });

      if (_this._hasInteracted) {
        childList.ref.recordInteraction();
      }
    };

    _this._unregisterAsNestedChild = function (childList) {
      _this._nestedChildLists.set(childList.key, {
        ref: null,
        state: childList.state
      });
    };

    _this._onUpdateSeparators = function (keys, newProps) {
      keys.forEach(function (key) {
        var ref = key != null && _this._cellRefs[key];
        ref && ref.updateSeparatorProps(newProps);
      });
    };

    _this._averageCellLength = 0;
    _this._cellKeysToChildListKeys = new Map();
    _this._cellRefs = {};
    _this._frames = {};
    _this._footerLength = 0;
    _this._hasDataChangedSinceEndReached = true;
    _this._hasInteracted = false;
    _this._hasMore = false;
    _this._hasWarned = {};
    _this._highestMeasuredFrameIndex = 0;
    _this._headerLength = 0;
    _this._indicesToKeys = new Map();
    _this._hasDoneInitialScroll = false;
    _this._nestedChildLists = new Map();
    _this._offsetFromParentVirtualizedList = 0;
    _this._prevParentOffset = 0;
    _this._scrollMetrics = {
      contentLength: 0,
      dOffset: 0,
      dt: 10,
      offset: 0,
      timestamp: 0,
      velocity: 0,
      visibleLength: 0
    };
    _this._scrollRef = null;
    _this._sentEndForContentLength = 0;
    _this._totalCellLength = 0;
    _this._totalCellsMeasured = 0;
    _this._viewabilityTuples = [];

    _this._captureScrollRef = function (ref) {
      _this._scrollRef = ref;
    };

    _this._defaultRenderScrollComponent = function (props) {
      if (_this._isNestedWithSameOrientation()) {
        return external_react_default.a.createElement(exports_View, props);
      } else if (props.onRefresh) {
        invariant_default()(typeof props.refreshing === 'boolean', '`refreshing` prop must be set as a boolean in order to use `onRefresh`, but got `' + JSON.stringify(props.refreshing) + '`');
        return external_react_default.a.createElement(exports_ScrollView, VirtualizedList_extends({}, props, {
          refreshControl:
          /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This
           * comment suppresses an error when upgrading Flow's support for
           * React. To see the error delete this comment and run Flow. */
          external_react_default.a.createElement(exports_RefreshControl, {
            refreshing: props.refreshing,
            onRefresh: props.onRefresh,
            progressViewOffset: props.progressViewOffset
          })
        }));
      } else {
        return external_react_default.a.createElement(exports_ScrollView, props);
      }
    };

    _this._onCellUnmount = function (cellKey) {
      var curr = _this._frames[cellKey];

      if (curr) {
        _this._frames[cellKey] = VirtualizedList_objectSpread({}, curr, {
          inLayout: false
        });
      }
    };

    _this._onLayout = function (e) {
      if (_this._isNestedWithSameOrientation()) {
        // Need to adjust our scroll metrics to be relative to our containing
        // VirtualizedList before we can make claims about list item viewability
        _this._measureLayoutRelativeToContainingList();
      } else {
        _this._scrollMetrics.visibleLength = _this._selectLength(e.nativeEvent.layout);
      }

      _this.props.onLayout && _this.props.onLayout(e);

      _this._scheduleCellsToRenderUpdate();

      _this._maybeCallOnEndReached();
    };

    _this._onLayoutEmpty = function (e) {
      _this.props.onLayout && _this.props.onLayout(e);
    };

    _this._onLayoutFooter = function (e) {
      _this._footerLength = _this._selectLength(e.nativeEvent.layout);
    };

    _this._onLayoutHeader = function (e) {
      _this._headerLength = _this._selectLength(e.nativeEvent.layout);
    };

    _this._onContentSizeChange = function (width, height) {
      if (width > 0 && height > 0 && _this.props.initialScrollIndex != null && _this.props.initialScrollIndex > 0 && !_this._hasDoneInitialScroll) {
        _this.scrollToIndex({
          animated: false,
          index: _this.props.initialScrollIndex
        });

        _this._hasDoneInitialScroll = true;
      }

      if (_this.props.onContentSizeChange) {
        _this.props.onContentSizeChange(width, height);
      }

      _this._scrollMetrics.contentLength = _this._selectLength({
        height: height,
        width: width
      });

      _this._scheduleCellsToRenderUpdate();

      _this._maybeCallOnEndReached();
    };

    _this._convertParentScrollMetrics = function (metrics) {
      // Offset of the top of the nested list relative to the top of its parent's viewport
      var offset = metrics.offset - _this._offsetFromParentVirtualizedList; // Child's visible length is the same as its parent's

      var visibleLength = metrics.visibleLength;
      var dOffset = offset - _this._scrollMetrics.offset;
      var contentLength = _this._scrollMetrics.contentLength;
      return {
        visibleLength: visibleLength,
        contentLength: contentLength,
        offset: offset,
        dOffset: dOffset
      };
    };

    _this._onScroll = function (e) {
      _this._nestedChildLists.forEach(function (childList) {
        childList.ref && childList.ref._onScroll(e);
      });

      if (_this.props.onScroll) {
        _this.props.onScroll(e);
      }

      var timestamp = e.timeStamp;

      var visibleLength = _this._selectLength(e.nativeEvent.layoutMeasurement);

      var contentLength = _this._selectLength(e.nativeEvent.contentSize);

      var offset = _this._selectOffset(e.nativeEvent.contentOffset);

      var dOffset = offset - _this._scrollMetrics.offset;

      if (_this._isNestedWithSameOrientation()) {
        if (_this._scrollMetrics.contentLength === 0) {
          // Ignore scroll events until onLayout has been called and we
          // know our offset from our offset from our parent
          return;
        }

        var _this$_convertParentS = _this._convertParentScrollMetrics({
          visibleLength: visibleLength,
          offset: offset
        });

        visibleLength = _this$_convertParentS.visibleLength;
        contentLength = _this$_convertParentS.contentLength;
        offset = _this$_convertParentS.offset;
        dOffset = _this$_convertParentS.dOffset;
      }

      var dt = _this._scrollMetrics.timestamp ? Math.max(1, timestamp - _this._scrollMetrics.timestamp) : 1;
      var velocity = dOffset / dt;

      if (dt > 500 && _this._scrollMetrics.dt > 500 && contentLength > 5 * visibleLength && !_this._hasWarned.perf) {
        react_native_infoLog('VirtualizedList: You have a large list that is slow to update - make sure your ' + 'renderItem function renders components that follow React performance best practices ' + 'like PureComponent, shouldComponentUpdate, etc.', {
          dt: dt,
          prevDt: _this._scrollMetrics.dt,
          contentLength: contentLength
        });
        _this._hasWarned.perf = true;
      }

      _this._scrollMetrics = {
        contentLength: contentLength,
        dt: dt,
        dOffset: dOffset,
        offset: offset,
        timestamp: timestamp,
        velocity: velocity,
        visibleLength: visibleLength
      };

      _this._updateViewableItems(_this.props.data);

      if (!_this.props) {
        return;
      }

      _this._maybeCallOnEndReached();

      if (velocity !== 0) {
        _this._fillRateHelper.activate();
      }

      _this._computeBlankness();

      _this._scheduleCellsToRenderUpdate();
    };

    _this._onScrollBeginDrag = function (e) {
      _this._nestedChildLists.forEach(function (childList) {
        childList.ref && childList.ref._onScrollBeginDrag(e);
      });

      _this._viewabilityTuples.forEach(function (tuple) {
        tuple.viewabilityHelper.recordInteraction();
      });

      _this._hasInteracted = true;
      _this.props.onScrollBeginDrag && _this.props.onScrollBeginDrag(e);
    };

    _this._onScrollEndDrag = function (e) {
      var velocity = e.nativeEvent.velocity;

      if (velocity) {
        _this._scrollMetrics.velocity = _this._selectOffset(velocity);
      }

      _this._computeBlankness();

      _this.props.onScrollEndDrag && _this.props.onScrollEndDrag(e);
    };

    _this._onMomentumScrollEnd = function (e) {
      _this._scrollMetrics.velocity = 0;

      _this._computeBlankness();

      _this.props.onMomentumScrollEnd && _this.props.onMomentumScrollEnd(e);
    };

    _this._updateCellsToRender = function () {
      var _this$props3 = _this.props,
          data = _this$props3.data,
          getItemCount = _this$props3.getItemCount,
          onEndReachedThreshold = _this$props3.onEndReachedThreshold;

      var isVirtualizationDisabled = _this._isVirtualizationDisabled();

      _this._updateViewableItems(data);

      if (!data) {
        return;
      }

      _this.setState(function (state) {
        var newState;

        if (!isVirtualizationDisabled) {
          // If we run this with bogus data, we'll force-render window {first: 0, last: 0},
          // and wipe out the initialNumToRender rendered elements.
          // So let's wait until the scroll view metrics have been set up. And until then,
          // we will trust the initialNumToRender suggestion
          if (_this._scrollMetrics.visibleLength) {
            // If we have a non-zero initialScrollIndex and run this before we've scrolled,
            // we'll wipe out the initialNumToRender rendered elements starting at initialScrollIndex.
            // So let's wait until we've scrolled the view to the right place. And until then,
            // we will trust the initialScrollIndex suggestion.
            if (!_this.props.initialScrollIndex || _this._scrollMetrics.offset) {
              newState = computeWindowedRenderLimits(_this.props, state, _this._getFrameMetricsApprox, _this._scrollMetrics);
            }
          }
        } else {
          var _this$_scrollMetrics = _this._scrollMetrics,
              contentLength = _this$_scrollMetrics.contentLength,
              offset = _this$_scrollMetrics.offset,
              visibleLength = _this$_scrollMetrics.visibleLength;
          var distanceFromEnd = contentLength - visibleLength - offset;
          var renderAhead =
          /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses
           * an error found when Flow v0.63 was deployed. To see the error
           * delete this comment and run Flow. */
          distanceFromEnd < onEndReachedThreshold * visibleLength ? _this.props.maxToRenderPerBatch : 0;
          newState = {
            first: 0,
            last: Math.min(state.last + renderAhead, getItemCount(data) - 1)
          };
        }

        if (newState && _this._nestedChildLists.size > 0) {
          var newFirst = newState.first;
          var newLast = newState.last; // If some cell in the new state has a child list in it, we should only render
          // up through that item, so that we give that list a chance to render.
          // Otherwise there's churn from multiple child lists mounting and un-mounting
          // their items.

          for (var ii = newFirst; ii <= newLast; ii++) {
            var cellKeyForIndex = _this._indicesToKeys.get(ii);

            var childListKeys = cellKeyForIndex && _this._cellKeysToChildListKeys.get(cellKeyForIndex);

            if (!childListKeys) {
              continue;
            }

            var someChildHasMore = false; // For each cell, need to check whether any child list in it has more elements to render

            for (var _iterator = childListKeys, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
              var _ref;

              if (_isArray) {
                if (_i >= _iterator.length) break;
                _ref = _iterator[_i++];
              } else {
                _i = _iterator.next();
                if (_i.done) break;
                _ref = _i.value;
              }

              var childKey = _ref;

              var childList = _this._nestedChildLists.get(childKey);

              if (childList && childList.ref && childList.ref.hasMore()) {
                someChildHasMore = true;
                break;
              }
            }

            if (someChildHasMore) {
              newState.last = ii;
              break;
            }
          }
        }

        return newState;
      });
    };

    _this._createViewToken = function (index, isViewable) {
      var _this$props4 = _this.props,
          data = _this$props4.data,
          getItem = _this$props4.getItem,
          keyExtractor = _this$props4.keyExtractor;
      var item = getItem(data, index);
      return {
        index: index,
        item: item,
        key: keyExtractor(item, index),
        isViewable: isViewable
      };
    };

    _this._getFrameMetricsApprox = function (index) {
      var frame = _this._getFrameMetrics(index);

      if (frame && frame.index === index) {
        // check for invalid frames due to row re-ordering
        return frame;
      } else {
        var getItemLayout = _this.props.getItemLayout;
        invariant_default()(!getItemLayout, 'Should not have to estimate frames when a measurement metrics function is provided');
        return {
          length: _this._averageCellLength,
          offset: _this._averageCellLength * index
        };
      }
    };

    _this._getFrameMetrics = function (index) {
      var _this$props5 = _this.props,
          data = _this$props5.data,
          getItem = _this$props5.getItem,
          getItemCount = _this$props5.getItemCount,
          getItemLayout = _this$props5.getItemLayout,
          keyExtractor = _this$props5.keyExtractor;
      invariant_default()(getItemCount(data) > index, 'Tried to get frame for out of range index ' + index);
      var item = getItem(data, index);

      var frame = item && _this._frames[keyExtractor(item, index)];

      if (!frame || frame.index !== index) {
        if (getItemLayout) {
          frame = getItemLayout(data, index);

          if (VirtualizedList_DEV_) {
            var frameType = external_prop_types_default.a.shape({
              length: external_prop_types_default.a.number.isRequired,
              offset: external_prop_types_default.a.number.isRequired,
              index: external_prop_types_default.a.number.isRequired
            }).isRequired;
            external_prop_types_default.a.checkPropTypes({
              frame: frameType
            }, {
              frame: frame
            }, 'frame', 'VirtualizedList.getItemLayout');
          }
        }
      }
      /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
       * error found when Flow v0.63 was deployed. To see the error delete this
       * comment and run Flow. */


      return frame;
    };

    invariant_default()(!_props.onScroll || !_props.onScroll.__isNative, 'Components based on VirtualizedList must be wrapped with Animated.createAnimatedComponent ' + 'to support native onScroll events with useNativeDriver');
    invariant_default()(_props.windowSize > 0, 'VirtualizedList: The windowSize prop must be present and set to a value greater than 0.');
    _this._fillRateHelper = new react_native_FillRateHelper(_this._getFrameMetrics);
    _this._updateCellsToRenderBatcher = new react_native_Batchinator(_this._updateCellsToRender, _this.props.updateCellsBatchingPeriod);

    if (_this.props.viewabilityConfigCallbackPairs) {
      _this._viewabilityTuples = _this.props.viewabilityConfigCallbackPairs.map(function (pair) {
        return {
          viewabilityHelper: new react_native_ViewabilityHelper(pair.viewabilityConfig),
          onViewableItemsChanged: pair.onViewableItemsChanged
        };
      });
    } else if (_this.props.onViewableItemsChanged) {
      _this._viewabilityTuples.push({
        viewabilityHelper: new react_native_ViewabilityHelper(_this.props.viewabilityConfig),
        onViewableItemsChanged: _this.props.onViewableItemsChanged
      });
    }

    var initialState = {
      first: _this.props.initialScrollIndex || 0,
      last: Math.min(_this.props.getItemCount(_this.props.data), (_this.props.initialScrollIndex || 0) + _this.props.initialNumToRender) - 1
    };

    if (_this._isNestedWithSameOrientation()) {
      var storedState = _this.context.virtualizedList.getNestedChildState(_this.props.listKey || _this._getCellKey());

      if (storedState) {
        initialState = storedState;
        _this.state = storedState;
        _this._frames = storedState.frames;
      }
    }

    _this.state = initialState;
    return _this;
  }

  _proto.componentDidMount = function componentDidMount() {
    if (this._isNestedWithSameOrientation()) {
      this.context.virtualizedList.registerAsNestedChild({
        cellKey: this._getCellKey(),
        key: this.props.listKey || this._getCellKey(),
        ref: this
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this._isNestedWithSameOrientation()) {
      this.context.virtualizedList.unregisterAsNestedChild({
        key: this.props.listKey || this._getCellKey(),
        state: {
          first: this.state.first,
          last: this.state.last,
          frames: this._frames
        }
      });
    }

    this._updateViewableItems(null);

    this._updateCellsToRenderBatcher.dispose({
      abort: true
    });

    this._viewabilityTuples.forEach(function (tuple) {
      tuple.viewabilityHelper.dispose();
    });

    this._fillRateHelper.deactivateAndFlush();
  };

  VirtualizedList.getDerivedStateFromProps = function getDerivedStateFromProps(newProps, prevState) {
    var data = newProps.data,
        extraData = newProps.extraData,
        getItemCount = newProps.getItemCount,
        maxToRenderPerBatch = newProps.maxToRenderPerBatch; // first and last could be stale (e.g. if a new, shorter items props is passed in), so we make
    // sure we're rendering a reasonable range here.

    return {
      first: Math.max(0, Math.min(prevState.first, getItemCount(data) - 1 - maxToRenderPerBatch)),
      last: Math.max(0, Math.min(prevState.last, getItemCount(data) - 1))
    };
  };

  _proto._pushCells = function _pushCells(cells, stickyHeaderIndices, stickyIndicesFromProps, first, last, inversionStyle) {
    var _this2 = this;

    var _this$props6 = this.props,
        CellRendererComponent = _this$props6.CellRendererComponent,
        ItemSeparatorComponent = _this$props6.ItemSeparatorComponent,
        data = _this$props6.data,
        getItem = _this$props6.getItem,
        getItemCount = _this$props6.getItemCount,
        horizontal = _this$props6.horizontal,
        keyExtractor = _this$props6.keyExtractor;
    var stickyOffset = this.props.ListHeaderComponent ? 1 : 0;
    var end = getItemCount(data) - 1;
    var prevCellKey;
    last = Math.min(end, last);

    var _loop = function _loop(ii) {
      var item = getItem(data, ii);
      var key = keyExtractor(item, ii);

      _this2._indicesToKeys.set(ii, key);

      if (stickyIndicesFromProps.has(ii + stickyOffset)) {
        stickyHeaderIndices.push(cells.length);
      }

      cells.push(external_react_default.a.createElement(VirtualizedList_CellRenderer, {
        CellRendererComponent: CellRendererComponent,
        ItemSeparatorComponent: ii < end ? ItemSeparatorComponent : undefined,
        cellKey: key,
        fillRateHelper: _this2._fillRateHelper,
        horizontal: horizontal,
        index: ii,
        inversionStyle: inversionStyle,
        item: item,
        key: key,
        prevCellKey: prevCellKey,
        onUpdateSeparators: _this2._onUpdateSeparators,
        onLayout: function onLayout(e) {
          return _this2._onCellLayout(e, key, ii);
        },
        onUnmount: _this2._onCellUnmount,
        parentProps: _this2.props,
        ref: function ref(_ref2) {
          _this2._cellRefs[key] = _ref2;
        }
      }));
      prevCellKey = key;
    };

    for (var ii = first; ii <= last; ii++) {
      _loop(ii);
    }
  };

  _proto._isVirtualizationDisabled = function _isVirtualizationDisabled() {
    return this.props.disableVirtualization;
  };

  _proto._isNestedWithSameOrientation = function _isNestedWithSameOrientation() {
    var nestedContext = this.context.virtualizedList;
    return !!(nestedContext && !!nestedContext.horizontal === !!this.props.horizontal);
  };

  _proto.render = function render() {
    if (VirtualizedList_DEV_) {
      var flatStyles = VirtualizedList_flattenStyle(this.props.contentContainerStyle);
      warning_default()(flatStyles == null || flatStyles.flexWrap !== 'wrap', '`flexWrap: `wrap`` is not supported with the `VirtualizedList` components.' + 'Consider using `numColumns` with `FlatList` instead.');
    }

    var _this$props7 = this.props,
        ListEmptyComponent = _this$props7.ListEmptyComponent,
        ListFooterComponent = _this$props7.ListFooterComponent,
        ListHeaderComponent = _this$props7.ListHeaderComponent;
    var _this$props8 = this.props,
        data = _this$props8.data,
        horizontal = _this$props8.horizontal;

    var isVirtualizationDisabled = this._isVirtualizationDisabled();

    var inversionStyle = this.props.inverted ? this.props.horizontal ? VirtualizedList_styles.horizontallyInverted : VirtualizedList_styles.verticallyInverted : null;
    var cells = [];
    var stickyIndicesFromProps = new Set(this.props.stickyHeaderIndices);
    var stickyHeaderIndices = [];

    if (ListHeaderComponent) {
      if (stickyIndicesFromProps.has(0)) {
        stickyHeaderIndices.push(0);
      }

      var element = external_react_default.a.isValidElement(ListHeaderComponent) ? ListHeaderComponent : // $FlowFixMe
      external_react_default.a.createElement(ListHeaderComponent, null);
      cells.push(external_react_default.a.createElement(VirtualizedCellWrapper, {
        cellKey: this._getCellKey() + '-header',
        key: "$header"
      }, external_react_default.a.createElement(exports_View, {
        onLayout: this._onLayoutHeader,
        style: inversionStyle
      }, element)));
    }

    var itemCount = this.props.getItemCount(data);

    if (itemCount > 0) {
      _usedIndexForKey = false;
      var spacerKey = !horizontal ? 'height' : 'width';
      var lastInitialIndex = this.props.initialScrollIndex ? -1 : this.props.initialNumToRender - 1;
      var _this$state = this.state,
          first = _this$state.first,
          last = _this$state.last;

      this._pushCells(cells, stickyHeaderIndices, stickyIndicesFromProps, 0, lastInitialIndex, inversionStyle);

      var firstAfterInitial = Math.max(lastInitialIndex + 1, first);

      if (!isVirtualizationDisabled && first > lastInitialIndex + 1) {
        var insertedStickySpacer = false;

        if (stickyIndicesFromProps.size > 0) {
          var stickyOffset = ListHeaderComponent ? 1 : 0; // See if there are any sticky headers in the virtualized space that we need to render.

          for (var ii = firstAfterInitial - 1; ii > lastInitialIndex; ii--) {
            if (stickyIndicesFromProps.has(ii + stickyOffset)) {
              var _ref3, _ref4;

              var initBlock = this._getFrameMetricsApprox(lastInitialIndex);

              var stickyBlock = this._getFrameMetricsApprox(ii);

              var leadSpace = stickyBlock.offset - (initBlock.offset + initBlock.length);
              cells.push(external_react_default.a.createElement(exports_View, {
                key: "$sticky_lead",
                style: (_ref3 = {}, _ref3[spacerKey] = leadSpace, _ref3)
              }));

              this._pushCells(cells, stickyHeaderIndices, stickyIndicesFromProps, ii, ii, inversionStyle);

              var trailSpace = this._getFrameMetricsApprox(first).offset - (stickyBlock.offset + stickyBlock.length);
              cells.push(external_react_default.a.createElement(exports_View, {
                key: "$sticky_trail",
                style: (_ref4 = {}, _ref4[spacerKey] = trailSpace, _ref4)
              }));
              insertedStickySpacer = true;
              break;
            }
          }
        }

        if (!insertedStickySpacer) {
          var _ref5;

          var _initBlock = this._getFrameMetricsApprox(lastInitialIndex);

          var firstSpace = this._getFrameMetricsApprox(first).offset - (_initBlock.offset + _initBlock.length);

          cells.push(external_react_default.a.createElement(exports_View, {
            key: "$lead_spacer",
            style: (_ref5 = {}, _ref5[spacerKey] = firstSpace, _ref5)
          }));
        }
      }

      this._pushCells(cells, stickyHeaderIndices, stickyIndicesFromProps, firstAfterInitial, last, inversionStyle);

      if (!this._hasWarned.keys && _usedIndexForKey) {
        console.warn('VirtualizedList: missing keys for items, make sure to specify a key property on each ' + 'item or provide a custom keyExtractor.');
        this._hasWarned.keys = true;
      }

      if (!isVirtualizationDisabled && last < itemCount - 1) {
        var _ref6;

        var lastFrame = this._getFrameMetricsApprox(last); // Without getItemLayout, we limit our tail spacer to the _highestMeasuredFrameIndex to
        // prevent the user for hyperscrolling into un-measured area because otherwise content will
        // likely jump around as it renders in above the viewport.


        var end = this.props.getItemLayout ? itemCount - 1 : Math.min(itemCount - 1, this._highestMeasuredFrameIndex);

        var endFrame = this._getFrameMetricsApprox(end);

        var tailSpacerLength = endFrame.offset + endFrame.length - (lastFrame.offset + lastFrame.length);
        cells.push(external_react_default.a.createElement(exports_View, {
          key: "$tail_spacer",
          style: (_ref6 = {}, _ref6[spacerKey] = tailSpacerLength, _ref6)
        }));
      }
    } else if (ListEmptyComponent) {
      var _element = external_react_default.a.isValidElement(ListEmptyComponent) ? ListEmptyComponent : // $FlowFixMe
      external_react_default.a.createElement(ListEmptyComponent, null);

      cells.push(external_react_default.a.createElement(exports_View, {
        key: "$empty",
        onLayout: this._onLayoutEmpty,
        style: inversionStyle
      }, _element));
    }

    if (ListFooterComponent) {
      var _element2 = external_react_default.a.isValidElement(ListFooterComponent) ? ListFooterComponent : // $FlowFixMe
      external_react_default.a.createElement(ListFooterComponent, null);

      cells.push(external_react_default.a.createElement(VirtualizedCellWrapper, {
        cellKey: this._getCellKey() + '-footer',
        key: "$footer"
      }, external_react_default.a.createElement(exports_View, {
        onLayout: this._onLayoutFooter,
        style: inversionStyle
      }, _element2)));
    }

    var scrollProps = VirtualizedList_objectSpread({}, this.props, {
      onContentSizeChange: this._onContentSizeChange,
      onLayout: this._onLayout,
      onScroll: this._onScroll,
      onScrollBeginDrag: this._onScrollBeginDrag,
      onScrollEndDrag: this._onScrollEndDrag,
      onMomentumScrollEnd: this._onMomentumScrollEnd,
      scrollEventThrottle: this.props.scrollEventThrottle,
      // TODO: Android support
      invertStickyHeaders: this.props.invertStickyHeaders !== undefined ? this.props.invertStickyHeaders : this.props.inverted,
      stickyHeaderIndices: stickyHeaderIndices
    });

    if (inversionStyle) {
      scrollProps.style = [inversionStyle, this.props.style];
    }

    this._hasMore = this.state.last < this.props.getItemCount(this.props.data) - 1;
    var ret = external_react_default.a.cloneElement((this.props.renderScrollComponent || this._defaultRenderScrollComponent)(scrollProps), {
      ref: this._captureScrollRef
    }, cells);

    if (this.props.debug) {
      return external_react_default.a.createElement(exports_View, {
        style: {
          flex: 1
        }
      }, ret, this._renderDebugOverlay());
    } else {
      return ret;
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props9 = this.props,
        data = _this$props9.data,
        extraData = _this$props9.extraData;

    if (data !== prevProps.data || extraData !== prevProps.extraData) {
      this._hasDataChangedSinceEndReached = true; // clear the viewableIndices cache to also trigger
      // the onViewableItemsChanged callback with the new data

      this._viewabilityTuples.forEach(function (tuple) {
        tuple.viewabilityHelper.resetViewableIndices();
      });
    }

    this._scheduleCellsToRenderUpdate();
  };

  _proto._computeBlankness = function _computeBlankness() {
    this._fillRateHelper.computeBlankness(this.props, this.state, this._scrollMetrics);
  };

  _proto._onCellLayout = function _onCellLayout(e, cellKey, index) {
    var layout = e.nativeEvent.layout;
    var next = {
      offset: this._selectOffset(layout),
      length: this._selectLength(layout),
      index: index,
      inLayout: true
    };
    var curr = this._frames[cellKey];

    if (!curr || next.offset !== curr.offset || next.length !== curr.length || index !== curr.index) {
      this._totalCellLength += next.length - (curr ? curr.length : 0);
      this._totalCellsMeasured += curr ? 0 : 1;
      this._averageCellLength = this._totalCellLength / this._totalCellsMeasured;
      this._frames[cellKey] = next;
      this._highestMeasuredFrameIndex = Math.max(this._highestMeasuredFrameIndex, index);

      this._scheduleCellsToRenderUpdate();
    } else {
      this._frames[cellKey].inLayout = true;
    }

    this._computeBlankness();
  };

  _proto._measureLayoutRelativeToContainingList = function _measureLayoutRelativeToContainingList() {
    var _this3 = this;

    UIManager["a" /* default */].measureLayout(exports_findNodeHandle(this), exports_findNodeHandle(this.context.virtualizedList.getOutermostParentListRef()), function (error) {
      console.warn("VirtualizedList: Encountered an error while measuring a list's" + ' offset from its containing VirtualizedList.');
    }, function (x, y, width, height) {
      _this3._offsetFromParentVirtualizedList = _this3._selectOffset({
        x: x,
        y: y
      });
      _this3._scrollMetrics.contentLength = _this3._selectLength({
        width: width,
        height: height
      });

      var scrollMetrics = _this3._convertParentScrollMetrics(_this3.context.virtualizedList.getScrollMetrics());

      _this3._scrollMetrics.visibleLength = scrollMetrics.visibleLength;
      _this3._scrollMetrics.offset = scrollMetrics.offset;
    });
  };

  _proto._renderDebugOverlay = function _renderDebugOverlay() {
    var normalize = this._scrollMetrics.visibleLength / this._scrollMetrics.contentLength;
    var framesInLayout = [];
    var itemCount = this.props.getItemCount(this.props.data);

    for (var ii = 0; ii < itemCount; ii++) {
      var frame = this._getFrameMetricsApprox(ii);

      if (frame.inLayout) {
        framesInLayout.push(frame);
      }
    }

    var windowTop = this._getFrameMetricsApprox(this.state.first).offset;

    var frameLast = this._getFrameMetricsApprox(this.state.last);

    var windowLen = frameLast.offset + frameLast.length - windowTop;
    var visTop = this._scrollMetrics.offset;
    var visLen = this._scrollMetrics.visibleLength;
    var baseStyle = {
      position: 'absolute',
      top: 0,
      right: 0
    };
    return external_react_default.a.createElement(exports_View, {
      style: VirtualizedList_objectSpread({}, baseStyle, {
        bottom: 0,
        width: 20,
        borderColor: 'blue',
        borderWidth: 1
      })
    }, framesInLayout.map(function (f, ii) {
      return external_react_default.a.createElement(exports_View, {
        key: 'f' + ii,
        style: VirtualizedList_objectSpread({}, baseStyle, {
          left: 0,
          top: f.offset * normalize,
          height: f.length * normalize,
          backgroundColor: 'orange'
        })
      });
    }), external_react_default.a.createElement(exports_View, {
      style: VirtualizedList_objectSpread({}, baseStyle, {
        left: 0,
        top: windowTop * normalize,
        height: windowLen * normalize,
        borderColor: 'green',
        borderWidth: 2
      })
    }), external_react_default.a.createElement(exports_View, {
      style: VirtualizedList_objectSpread({}, baseStyle, {
        left: 0,
        top: visTop * normalize,
        height: visLen * normalize,
        borderColor: 'red',
        borderWidth: 2
      })
    }));
  };

  _proto._selectLength = function _selectLength(metrics) {
    return !this.props.horizontal ? metrics.height : metrics.width;
  };

  _proto._selectOffset = function _selectOffset(metrics) {
    return !this.props.horizontal ? metrics.y : metrics.x;
  };

  _proto._maybeCallOnEndReached = function _maybeCallOnEndReached() {
    var _this$props10 = this.props,
        data = _this$props10.data,
        getItemCount = _this$props10.getItemCount,
        onEndReached = _this$props10.onEndReached,
        onEndReachedThreshold = _this$props10.onEndReachedThreshold;
    var _this$_scrollMetrics2 = this._scrollMetrics,
        contentLength = _this$_scrollMetrics2.contentLength,
        visibleLength = _this$_scrollMetrics2.visibleLength,
        offset = _this$_scrollMetrics2.offset;
    var distanceFromEnd = contentLength - visibleLength - offset;

    if (onEndReached && this.state.last === getItemCount(data) - 1 &&
    /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
     * error found when Flow v0.63 was deployed. To see the error delete this
     * comment and run Flow. */
    distanceFromEnd < onEndReachedThreshold * visibleLength && (this._hasDataChangedSinceEndReached || this._scrollMetrics.contentLength !== this._sentEndForContentLength)) {
      // Only call onEndReached once for a given dataset + content length.
      this._hasDataChangedSinceEndReached = false;
      this._sentEndForContentLength = this._scrollMetrics.contentLength;
      onEndReached({
        distanceFromEnd: distanceFromEnd
      });
    }
  };

  _proto._scheduleCellsToRenderUpdate = function _scheduleCellsToRenderUpdate() {
    var _this$state2 = this.state,
        first = _this$state2.first,
        last = _this$state2.last;
    var _this$_scrollMetrics3 = this._scrollMetrics,
        offset = _this$_scrollMetrics3.offset,
        visibleLength = _this$_scrollMetrics3.visibleLength,
        velocity = _this$_scrollMetrics3.velocity;
    var itemCount = this.props.getItemCount(this.props.data);
    var hiPri = false;

    if (first > 0 || last < itemCount - 1) {
      var distTop = offset - this._getFrameMetricsApprox(first).offset;

      var distBottom = this._getFrameMetricsApprox(last).offset - (offset + visibleLength);
      var scrollingThreshold =
      /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
       * error found when Flow v0.63 was deployed. To see the error delete
       * this comment and run Flow. */
      this.props.onEndReachedThreshold * visibleLength / 2;
      hiPri = Math.min(distTop, distBottom) < 0 || velocity < -2 && distTop < scrollingThreshold || velocity > 2 && distBottom < scrollingThreshold;
    } // Only trigger high-priority updates if we've actually rendered cells,
    // and with that size estimate, accurately compute how many cells we should render.
    // Otherwise, it would just render as many cells as it can (of zero dimension),
    // each time through attempting to render more (limited by maxToRenderPerBatch),
    // starving the renderer from actually laying out the objects and computing _averageCellLength.


    if (hiPri && this._averageCellLength) {
      // Don't worry about interactions when scrolling quickly; focus on filling content as fast
      // as possible.
      this._updateCellsToRenderBatcher.dispose({
        abort: true
      });

      this._updateCellsToRender();

      return;
    } else {
      this._updateCellsToRenderBatcher.schedule();
    }
  };

  _proto._updateViewableItems = function _updateViewableItems(data) {
    var _this4 = this;

    var getItemCount = this.props.getItemCount;

    this._viewabilityTuples.forEach(function (tuple) {
      tuple.viewabilityHelper.onUpdate(getItemCount(data), _this4._scrollMetrics.offset, _this4._scrollMetrics.visibleLength, _this4._getFrameMetrics, _this4._createViewToken, tuple.onViewableItemsChanged, _this4.state);
    });
  };

  return VirtualizedList;
}(external_react_default.a.PureComponent);

VirtualizedList_VirtualizedList.defaultProps = {
  disableVirtualization: "production" === 'test',
  horizontal: false,
  initialNumToRender: 10,
  keyExtractor: function keyExtractor(item, index) {
    if (item.key != null) {
      return item.key;
    }

    _usedIndexForKey = true;
    return String(index);
  },
  maxToRenderPerBatch: 10,
  onEndReachedThreshold: 2,
  // multiples of length
  scrollEventThrottle: 50,
  updateCellsBatchingPeriod: 50,
  windowSize: 21 // multiples of length

};
VirtualizedList_VirtualizedList.contextTypes = {
  virtualizedCell: external_prop_types_default.a.shape({
    cellKey: external_prop_types_default.a.string
  }),
  virtualizedList: external_prop_types_default.a.shape({
    getScrollMetrics: external_prop_types_default.a.func,
    horizontal: external_prop_types_default.a.bool,
    getOutermostParentListRef: external_prop_types_default.a.func,
    getNestedChildState: external_prop_types_default.a.func,
    registerAsNestedChild: external_prop_types_default.a.func,
    unregisterAsNestedChild: external_prop_types_default.a.func
  })
};
VirtualizedList_VirtualizedList.childContextTypes = {
  virtualizedList: external_prop_types_default.a.shape({
    getScrollMetrics: external_prop_types_default.a.func,
    horizontal: external_prop_types_default.a.bool,
    getOutermostParentListRef: external_prop_types_default.a.func,
    getNestedChildState: external_prop_types_default.a.func,
    registerAsNestedChild: external_prop_types_default.a.func,
    unregisterAsNestedChild: external_prop_types_default.a.func
  })
};

var VirtualizedList_CellRenderer =
/*#__PURE__*/
function (_React$Component) {
  VirtualizedList_inheritsLoose(CellRenderer, _React$Component);

  function CellRenderer() {
    var _this5;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this5 = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this5.state = {
      separatorProps: {
        highlighted: false,
        leadingItem: _this5.props.item
      }
    };
    _this5._separators = {
      highlight: function highlight() {
        var _this5$props = _this5.props,
            cellKey = _this5$props.cellKey,
            prevCellKey = _this5$props.prevCellKey;

        _this5.props.onUpdateSeparators([cellKey, prevCellKey], {
          highlighted: true
        });
      },
      unhighlight: function unhighlight() {
        var _this5$props2 = _this5.props,
            cellKey = _this5$props2.cellKey,
            prevCellKey = _this5$props2.prevCellKey;

        _this5.props.onUpdateSeparators([cellKey, prevCellKey], {
          highlighted: false
        });
      },
      updateProps: function updateProps(select, newProps) {
        var _this5$props3 = _this5.props,
            cellKey = _this5$props3.cellKey,
            prevCellKey = _this5$props3.prevCellKey;

        _this5.props.onUpdateSeparators([select === 'leading' ? prevCellKey : cellKey], newProps);
      }
    };
    return _this5;
  }

  var _proto2 = CellRenderer.prototype;

  _proto2.getChildContext = function getChildContext() {
    return {
      virtualizedCell: {
        cellKey: this.props.cellKey
      }
    };
  } // TODO: consider factoring separator stuff out of VirtualizedList into FlatList since it's not
  // reused by SectionList and we can keep VirtualizedList simpler.
  ;

  _proto2.updateSeparatorProps = function updateSeparatorProps(newProps) {
    this.setState(function (state) {
      return {
        separatorProps: VirtualizedList_objectSpread({}, state.separatorProps, newProps)
      };
    });
  };

  _proto2.componentWillUnmount = function componentWillUnmount() {
    this.props.onUnmount(this.props.cellKey);
  };

  _proto2.render = function render() {
    var _this$props11 = this.props,
        CellRendererComponent = _this$props11.CellRendererComponent,
        ItemSeparatorComponent = _this$props11.ItemSeparatorComponent,
        fillRateHelper = _this$props11.fillRateHelper,
        horizontal = _this$props11.horizontal,
        item = _this$props11.item,
        index = _this$props11.index,
        inversionStyle = _this$props11.inversionStyle,
        parentProps = _this$props11.parentProps;
    var renderItem = parentProps.renderItem,
        getItemLayout = parentProps.getItemLayout;
    invariant_default()(renderItem, 'no renderItem!');
    var element = renderItem({
      item: item,
      index: index,
      separators: this._separators
    });
    var onLayout = getItemLayout && !parentProps.debug && !fillRateHelper.enabled() ? undefined : this.props.onLayout; // NOTE: that when this is a sticky header, `onLayout` will get automatically extracted and
    // called explicitly by `ScrollViewStickyHeader`.

    var itemSeparator = ItemSeparatorComponent && external_react_default.a.createElement(ItemSeparatorComponent, this.state.separatorProps);
    var cellStyle = inversionStyle ? horizontal ? [VirtualizedList_styles.rowReverse, inversionStyle] : [VirtualizedList_styles.columnReverse, inversionStyle] : horizontal ? [VirtualizedList_styles.row, inversionStyle] : inversionStyle;

    if (!CellRendererComponent) {
      return external_react_default.a.createElement(exports_View, {
        style: cellStyle,
        onLayout: onLayout
      }, element, itemSeparator);
    }

    return external_react_default.a.createElement(CellRendererComponent, VirtualizedList_extends({}, this.props, {
      style: cellStyle,
      onLayout: onLayout
    }), element, itemSeparator);
  };

  return CellRenderer;
}(external_react_default.a.Component);

VirtualizedList_CellRenderer.childContextTypes = {
  virtualizedCell: external_prop_types_default.a.shape({
    cellKey: external_prop_types_default.a.string
  })
};

var VirtualizedCellWrapper =
/*#__PURE__*/
function (_React$Component2) {
  VirtualizedList_inheritsLoose(VirtualizedCellWrapper, _React$Component2);

  function VirtualizedCellWrapper() {
    return _React$Component2.apply(this, arguments) || this;
  }

  var _proto3 = VirtualizedCellWrapper.prototype;

  _proto3.getChildContext = function getChildContext() {
    return {
      virtualizedCell: {
        cellKey: this.props.cellKey
      }
    };
  };

  _proto3.render = function render() {
    return this.props.children;
  };

  return VirtualizedCellWrapper;
}(external_react_default.a.Component);

VirtualizedCellWrapper.childContextTypes = {
  virtualizedCell: external_prop_types_default.a.shape({
    cellKey: external_prop_types_default.a.string
  })
};
var VirtualizedList_styles = exports_StyleSheet.create({
  verticallyInverted: {
    transform: [{
      scaleY: -1
    }]
  },
  horizontallyInverted: {
    transform: [{
      scaleX: -1
    }]
  },
  row: {
    flexDirection: 'row'
  },
  rowReverse: {
    flexDirection: 'row-reverse'
  },
  columnReverse: {
    flexDirection: 'column-reverse'
  }
});
/* harmony default export */ var react_native_VirtualizedList = (VirtualizedList_VirtualizedList);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/FlatList/index.js
function FlatList_extends() { FlatList_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return FlatList_extends.apply(this, arguments); }

function FlatList_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function FlatList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { FlatList_defineProperty(target, key, source[key]); }); } return target; }

function FlatList_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */






var defaultProps = FlatList_objectSpread({}, react_native_VirtualizedList.defaultProps, {
  numColumns: 1
});

/**
 * A performant interface for rendering simple, flat lists, supporting the most handy features:
 *
 *  - Fully cross-platform.
 *  - Optional horizontal mode.
 *  - Configurable viewability callbacks.
 *  - Header support.
 *  - Footer support.
 *  - Separator support.
 *  - Pull to Refresh.
 *  - Scroll loading.
 *  - ScrollToIndex support.
 *
 * If you need section support, use [`<SectionList>`](docs/sectionlist.html).
 *
 * Minimal Example:
 *
 *     <FlatList
 *       data={[{key: 'a'}, {key: 'b'}]}
 *       renderItem={({item}) => <Text>{item.key}</Text>}
 *     />
 *
 * More complex, multi-select example demonstrating `PureComponent` usage for perf optimization and avoiding bugs.
 *
 * - By binding the `onPressItem` handler, the props will remain `===` and `PureComponent` will
 *   prevent wasteful re-renders unless the actual `id`, `selected`, or `title` props change, even
 *   if the components rendered in `MyListItem` did not have such optimizations.
 * - By passing `extraData={this.state}` to `FlatList` we make sure `FlatList` itself will re-render
 *   when the `state.selected` changes. Without setting this prop, `FlatList` would not know it
 *   needs to re-render any items because it is also a `PureComponent` and the prop comparison will
 *   not show any changes.
 * - `keyExtractor` tells the list to use the `id`s for the react keys instead of the default `key` property.
 *
 *
 *     class MyListItem extends React.PureComponent {
 *       _onPress = () => {
 *         this.props.onPressItem(this.props.id);
 *       };
 *
 *       render() {
 *         const textColor = this.props.selected ? "red" : "black";
 *         return (
 *           <TouchableOpacity onPress={this._onPress}>
 *             <View>
 *               <Text style={{ color: textColor }}>
 *                 {this.props.title}
 *               </Text>
 *             </View>
 *           </TouchableOpacity>
 *         );
 *       }
 *     }
 *
 *     class MultiSelectList extends React.PureComponent {
 *       state = {selected: (new Map(): Map<string, boolean>)};
 *
 *       _keyExtractor = (item, index) => item.id;
 *
 *       _onPressItem = (id: string) => {
 *         // updater functions are preferred for transactional updates
 *         this.setState((state) => {
 *           // copy the map rather than modifying state.
 *           const selected = new Map(state.selected);
 *           selected.set(id, !selected.get(id)); // toggle
 *           return {selected};
 *         });
 *       };
 *
 *       _renderItem = ({item}) => (
 *         <MyListItem
 *           id={item.id}
 *           onPressItem={this._onPressItem}
 *           selected={!!this.state.selected.get(item.id)}
 *           title={item.title}
 *         />
 *       );
 *
 *       render() {
 *         return (
 *           <FlatList
 *             data={this.props.data}
 *             extraData={this.state}
 *             keyExtractor={this._keyExtractor}
 *             renderItem={this._renderItem}
 *           />
 *         );
 *       }
 *     }
 *
 * This is a convenience wrapper around [`<VirtualizedList>`](docs/virtualizedlist.html),
 * and thus inherits its props (as well as those of `ScrollView`) that aren't explicitly listed
 * here, along with the following caveats:
 *
 * - Internal state is not preserved when content scrolls out of the render window. Make sure all
 *   your data is captured in the item data or external stores like Flux, Redux, or Relay.
 * - This is a `PureComponent` which means that it will not re-render if `props` remain shallow-
 *   equal. Make sure that everything your `renderItem` function depends on is passed as a prop
 *   (e.g. `extraData`) that is not `===` after updates, otherwise your UI may not update on
 *   changes. This includes the `data` prop and parent component state.
 * - In order to constrain memory and enable smooth scrolling, content is rendered asynchronously
 *   offscreen. This means it's possible to scroll faster than the fill rate ands momentarily see
 *   blank content. This is a tradeoff that can be adjusted to suit the needs of each application,
 *   and we are working on improving it behind the scenes.
 * - By default, the list looks for a `key` prop on each item and uses that for the React key.
 *   Alternatively, you can provide a custom `keyExtractor` prop.
 *
 * Also inherits [ScrollView Props](docs/scrollview.html#props), unless it is nested in another FlatList of same orientation.
 */
var FlatList_FlatList =
/*#__PURE__*/
function (_React$PureComponent) {
  FlatList_inheritsLoose(FlatList, _React$PureComponent);

  var _proto = FlatList.prototype;

  /**
   * Scrolls to the end of the content. May be janky without `getItemLayout` prop.
   */
  _proto.scrollToEnd = function scrollToEnd(params) {
    if (this._listRef) {
      this._listRef.scrollToEnd(params);
    }
  }
  /**
   * Scrolls to the item at the specified index such that it is positioned in the viewable area
   * such that `viewPosition` 0 places it at the top, 1 at the bottom, and 0.5 centered in the
   * middle. `viewOffset` is a fixed number of pixels to offset the final target position.
   *
   * Note: cannot scroll to locations outside the render window without specifying the
   * `getItemLayout` prop.
   */
  ;

  _proto.scrollToIndex = function scrollToIndex(params) {
    if (this._listRef) {
      this._listRef.scrollToIndex(params);
    }
  }
  /**
   * Requires linear scan through data - use `scrollToIndex` instead if possible.
   *
   * Note: cannot scroll to locations outside the render window without specifying the
   * `getItemLayout` prop.
   */
  ;

  _proto.scrollToItem = function scrollToItem(params) {
    if (this._listRef) {
      this._listRef.scrollToItem(params);
    }
  }
  /**
   * Scroll to a specific content pixel offset in the list.
   *
   * Check out [scrollToOffset](docs/virtualizedlist.html#scrolltooffset) of VirtualizedList
   */
  ;

  _proto.scrollToOffset = function scrollToOffset(params) {
    if (this._listRef) {
      this._listRef.scrollToOffset(params);
    }
  }
  /**
   * Tells the list an interaction has occurred, which should trigger viewability calculations, e.g.
   * if `waitForInteractions` is true and the user has not scrolled. This is typically called by
   * taps on items or by navigation actions.
   */
  ;

  _proto.recordInteraction = function recordInteraction() {
    if (this._listRef) {
      this._listRef.recordInteraction();
    }
  }
  /**
   * Displays the scroll indicators momentarily.
   *
   * @platform ios
   */
  ;

  _proto.flashScrollIndicators = function flashScrollIndicators() {
    if (this._listRef) {
      this._listRef.flashScrollIndicators();
    }
  }
  /**
   * Provides a handle to the underlying scroll responder.
   */
  ;

  _proto.getScrollResponder = function getScrollResponder() {
    if (this._listRef) {
      return this._listRef.getScrollResponder();
    }
  };

  _proto.getScrollableNode = function getScrollableNode() {
    if (this._listRef) {
      return this._listRef.getScrollableNode();
    }
  };

  _proto.setNativeProps = function setNativeProps(props) {
    if (this._listRef) {
      this._listRef.setNativeProps(props);
    }
  };

  _proto.UNSAFE_componentWillMount = function UNSAFE_componentWillMount() {
    this._checkProps(this.props);
  };

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    invariant_default()(nextProps.numColumns === this.props.numColumns, 'Changing numColumns on the fly is not supported. Change the key prop on FlatList when ' + 'changing the number of columns to force a fresh render of the component.');
    invariant_default()(nextProps.onViewableItemsChanged === this.props.onViewableItemsChanged, 'Changing onViewableItemsChanged on the fly is not supported');
    invariant_default()(nextProps.viewabilityConfig === this.props.viewabilityConfig, 'Changing viewabilityConfig on the fly is not supported');
    invariant_default()(nextProps.viewabilityConfigCallbackPairs === this.props.viewabilityConfigCallbackPairs, 'Changing viewabilityConfigCallbackPairs on the fly is not supported');

    this._checkProps(nextProps);
  };

  function FlatList(props) {
    var _this;

    _this = _React$PureComponent.call(this, props) || this;
    _this._hasWarnedLegacy = false;
    _this._virtualizedListPairs = [];

    _this._captureRef = function (ref) {
      _this._listRef = ref;
    };

    _this._getItem = function (data, index) {
      var numColumns = _this.props.numColumns;

      if (numColumns > 1) {
        var ret = [];

        for (var kk = 0; kk < numColumns; kk++) {
          var _item = data[index * numColumns + kk];
          _item && ret.push(_item);
        }

        return ret;
      } else {
        return data[index];
      }
    };

    _this._getItemCount = function (data) {
      return data ? Math.ceil(data.length / _this.props.numColumns) : 0;
    };

    _this._keyExtractor = function (items, index) {
      var _this$props = _this.props,
          keyExtractor = _this$props.keyExtractor,
          numColumns = _this$props.numColumns;

      if (numColumns > 1) {
        invariant_default()(Array.isArray(items), 'FlatList: Encountered internal consistency error, expected each item to consist of an ' + 'array with 1-%s columns; instead, received a single item.', numColumns);
        return items.map(function (it, kk) {
          return keyExtractor(it, index * numColumns + kk);
        }).join(':');
      } else {
        /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
         * error found when Flow v0.63 was deployed. To see the error delete this
         * comment and run Flow. */
        return keyExtractor(items, index);
      }
    };

    _this._renderItem = function (info) {
      var _this$props2 = _this.props,
          renderItem = _this$props2.renderItem,
          numColumns = _this$props2.numColumns,
          columnWrapperStyle = _this$props2.columnWrapperStyle;

      if (numColumns > 1) {
        var _item2 = info.item,
            _index = info.index;
        invariant_default()(Array.isArray(_item2), 'Expected array of items with numColumns > 1');
        return external_react_default.a.createElement(exports_View, {
          style: [{
            flexDirection: 'row'
          }, columnWrapperStyle]
        }, _item2.map(function (it, kk) {
          var element = renderItem({
            item: it,
            index: _index * numColumns + kk,
            separators: info.separators
          });
          return element && external_react_default.a.cloneElement(element, {
            key: kk
          });
        }));
      } else {
        return renderItem(info);
      }
    };

    if (_this.props.viewabilityConfigCallbackPairs) {
      _this._virtualizedListPairs = _this.props.viewabilityConfigCallbackPairs.map(function (pair) {
        return {
          viewabilityConfig: pair.viewabilityConfig,
          onViewableItemsChanged: _this._createOnViewableItemsChanged(pair.onViewableItemsChanged)
        };
      });
    } else if (_this.props.onViewableItemsChanged) {
      /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
       * error found when Flow v0.63 was deployed. To see the error delete this
       * comment and run Flow. */
      _this._virtualizedListPairs.push({
        viewabilityConfig: _this.props.viewabilityConfig,
        onViewableItemsChanged: _this._createOnViewableItemsChanged(_this.props.onViewableItemsChanged)
      });
    }

    return _this;
  }

  _proto._checkProps = function _checkProps(props) {
    var getItem = props.getItem,
        getItemCount = props.getItemCount,
        horizontal = props.horizontal,
        legacyImplementation = props.legacyImplementation,
        numColumns = props.numColumns,
        columnWrapperStyle = props.columnWrapperStyle,
        onViewableItemsChanged = props.onViewableItemsChanged,
        viewabilityConfigCallbackPairs = props.viewabilityConfigCallbackPairs;
    invariant_default()(!getItem && !getItemCount, 'FlatList does not support custom data formats.');

    if (numColumns > 1) {
      invariant_default()(!horizontal, 'numColumns does not support horizontal.');
    } else {
      invariant_default()(!columnWrapperStyle, 'columnWrapperStyle not supported for single column lists');
    }

    if (legacyImplementation) {
      invariant_default()(numColumns === 1, 'Legacy list does not support multiple columns.'); // Warning: may not have full feature parity and is meant more for debugging and performance
      // comparison.

      if (!this._hasWarnedLegacy) {
        console.warn('FlatList: Using legacyImplementation - some features not supported and performance ' + 'may suffer');
        this._hasWarnedLegacy = true;
      }
    }

    invariant_default()(!(onViewableItemsChanged && viewabilityConfigCallbackPairs), 'FlatList does not support setting both onViewableItemsChanged and ' + 'viewabilityConfigCallbackPairs.');
  };

  _proto._pushMultiColumnViewable = function _pushMultiColumnViewable(arr, v) {
    var _this$props3 = this.props,
        numColumns = _this$props3.numColumns,
        keyExtractor = _this$props3.keyExtractor;
    v.item.forEach(function (item, ii) {
      invariant_default()(v.index != null, 'Missing index!');
      var index = v.index * numColumns + ii;
      arr.push(FlatList_objectSpread({}, v, {
        item: item,
        key: keyExtractor(item, index),
        index: index
      }));
    });
  };

  _proto._createOnViewableItemsChanged = function _createOnViewableItemsChanged(onViewableItemsChanged) {
    var _this2 = this;

    return function (info) {
      var numColumns = _this2.props.numColumns;

      if (onViewableItemsChanged) {
        if (numColumns > 1) {
          var changed = [];
          var viewableItems = [];
          info.viewableItems.forEach(function (v) {
            return _this2._pushMultiColumnViewable(viewableItems, v);
          });
          info.changed.forEach(function (v) {
            return _this2._pushMultiColumnViewable(changed, v);
          });
          onViewableItemsChanged({
            viewableItems: viewableItems,
            changed: changed
          });
        } else {
          onViewableItemsChanged(info);
        }
      }
    };
  };

  _proto.render = function render() {
    if (this.props.legacyImplementation) {
      return (
        /* $FlowFixMe(>=0.66.0 site=react_native_fb) This comment suppresses an
         * error found when Flow v0.66 was deployed. To see the error delete
         * this comment and run Flow. */
        external_react_default.a.createElement(modules_UnimplementedView, FlatList_extends({}, this.props, {
          /* $FlowFixMe(>=0.66.0 site=react_native_fb) This comment suppresses
           * an error found when Flow v0.66 was deployed. To see the error
           * delete this comment and run Flow. */
          items: this.props.data,
          ref: this._captureRef
        }))
      );
    } else {
      return external_react_default.a.createElement(react_native_VirtualizedList, FlatList_extends({}, this.props, {
        renderItem: this._renderItem,
        getItem: this._getItem,
        getItemCount: this._getItemCount,
        keyExtractor: this._keyExtractor,
        ref: this._captureRef,
        viewabilityConfigCallbackPairs: this._virtualizedListPairs
      }));
    }
  };

  return FlatList;
}(external_react_default.a.PureComponent);

FlatList_FlatList.defaultProps = defaultProps;
/* harmony default export */ var react_native_FlatList = (FlatList_FlatList);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/FlatList/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var exports_FlatList = (react_native_FlatList);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/modules/ensureComponentIsNative/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var ensureComponentIsNative_ensureComponentIsNative = function ensureComponentIsNative(component) {
  invariant_default()(component && typeof component.setNativeProps === 'function', 'Touchable child must either be native or forward setNativeProps to a native component');
};

/* harmony default export */ var modules_ensureComponentIsNative = (ensureComponentIsNative_ensureComponentIsNative);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/ImageBackground/index.js
function ImageBackground_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { ImageBackground_defineProperty(target, key, source[key]); }); } return target; }

function ImageBackground_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ImageBackground_extends() { ImageBackground_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ImageBackground_extends.apply(this, arguments); }

function ImageBackground_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ImageBackground_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */






var ImageBackground_emptyObject = {};
/**
 * Very simple drop-in replacement for <Image> which supports nesting views.
 */

var ImageBackground_ImageBackground =
/*#__PURE__*/
function (_Component) {
  ImageBackground_inheritsLoose(ImageBackground, _Component);

  function ImageBackground() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this._viewRef = null;

    _this._captureRef = function (ref) {
      _this._viewRef = ref;
    };

    return _this;
  }

  var _proto = ImageBackground.prototype;

  _proto.setNativeProps = function setNativeProps(props) {
    // Work-around flow
    var viewRef = this._viewRef;

    if (viewRef) {
      modules_ensureComponentIsNative(viewRef);
      viewRef.setNativeProps(props);
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        style = _this$props.style,
        imageStyle = _this$props.imageStyle,
        imageRef = _this$props.imageRef,
        props = ImageBackground_objectWithoutPropertiesLoose(_this$props, ["children", "style", "imageStyle", "imageRef"]);

    return external_react_default.a.createElement(exports_View, {
      ref: this._captureRef,
      style: style
    }, external_react_default.a.createElement(exports_Image, ImageBackground_extends({}, props, {
      ref: imageRef,
      style: [exports_StyleSheet.absoluteFill, {
        // Temporary Workaround:
        // Current (imperfect yet) implementation of <Image> overwrites width and height styles
        // (which is not quite correct), and these styles conflict with explicitly set styles
        // of <ImageBackground> and with our internal layout model here.
        // So, we have to proxy/reapply these styles explicitly for actual <Image> component.
        // This workaround should be removed after implementing proper support of
        // intrinsic content size of the <Image>.
        width: style.width,
        height: style.height,
        zIndex: -1
      }, imageStyle]
    })), children);
  };

  return ImageBackground;
}(external_react_["Component"]);

ImageBackground_ImageBackground.defaultProps = {
  style: ImageBackground_emptyObject
};
ImageBackground_ImageBackground.propTypes =  false ? undefined : {};
/* harmony default export */ var exports_ImageBackground = (ImageBackground_ImageBackground);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/KeyboardAvoidingView/index.js
function KeyboardAvoidingView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { KeyboardAvoidingView_defineProperty(target, key, source[key]); }); } return target; }

function KeyboardAvoidingView_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function KeyboardAvoidingView_extends() { KeyboardAvoidingView_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return KeyboardAvoidingView_extends.apply(this, arguments); }

function KeyboardAvoidingView_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function KeyboardAvoidingView_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */





var KeyboardAvoidingView_KeyboardAvoidingView =
/*#__PURE__*/
function (_Component) {
  KeyboardAvoidingView_inheritsLoose(KeyboardAvoidingView, _Component);

  function KeyboardAvoidingView() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.frame = null;

    _this.onLayout = function (event) {
      _this.frame = event.nativeEvent.layout;
    };

    return _this;
  }

  var _proto = KeyboardAvoidingView.prototype;

  _proto.relativeKeyboardHeight = function relativeKeyboardHeight(keyboardFrame) {
    var frame = this.frame;

    if (!frame || !keyboardFrame) {
      return 0;
    }

    var keyboardY = keyboardFrame.screenY - this.props.keyboardVerticalOffset;
    return Math.max(frame.y + frame.height - keyboardY, 0);
  };

  _proto.onKeyboardChange = function onKeyboardChange(event) {};

  _proto.render = function render() {
    var _this$props = this.props,
        behavior = _this$props.behavior,
        contentContainerStyle = _this$props.contentContainerStyle,
        keyboardVerticalOffset = _this$props.keyboardVerticalOffset,
        rest = KeyboardAvoidingView_objectWithoutPropertiesLoose(_this$props, ["behavior", "contentContainerStyle", "keyboardVerticalOffset"]);

    return external_react_default.a.createElement(exports_View, KeyboardAvoidingView_extends({
      onLayout: this.onLayout
    }, rest));
  };

  return KeyboardAvoidingView;
}(external_react_["Component"]);

KeyboardAvoidingView_KeyboardAvoidingView.defaultProps = {
  keyboardVerticalOffset: 0
};
KeyboardAvoidingView_KeyboardAvoidingView.propTypes =  false ? undefined : {};
/* harmony default export */ var exports_KeyboardAvoidingView = (KeyboardAvoidingView_KeyboardAvoidingView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/isEmpty/index.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule isEmpty
 */

/**
 * Mimics empty from PHP.
 */

function isEmpty(obj) {
  if (Array.isArray(obj)) {
    return obj.length === 0;
  } else if (typeof obj === 'object') {
    for (var i in obj) {
      return false;
    }

    return true;
  } else {
    return !obj;
  }
}

/* harmony default export */ var react_native_isEmpty = (isEmpty);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/ListView/ListViewDataSource.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule ListViewDataSource
 * 
 * @format
 */






function defaultGetRowData(dataBlob, sectionID, rowID) {
  return dataBlob[sectionID][rowID];
}

function defaultGetSectionHeaderData(dataBlob, sectionID) {
  return dataBlob[sectionID];
}

/**
 * Provides efficient data processing and access to the
 * `ListView` component.  A `ListViewDataSource` is created with functions for
 * extracting data from the input blob, and comparing elements (with default
 * implementations for convenience).  The input blob can be as simple as an
 * array of strings, or an object with rows nested inside section objects.
 *
 * To update the data in the datasource, use `cloneWithRows` (or
 * `cloneWithRowsAndSections` if you care about sections).  The data in the
 * data source is immutable, so you can't modify it directly.  The clone methods
 * suck in the new data and compute a diff for each row so ListView knows
 * whether to re-render it or not.
 *
 * In this example, a component receives data in chunks, handled by
 * `_onDataArrived`, which concats the new data onto the old data and updates the
 * data source.  We use `concat` to create a new array - mutating `this._data`,
 * e.g. with `this._data.push(newRowData)`, would be an error. `_rowHasChanged`
 * understands the shape of the row data and knows how to efficiently compare
 * it.
 *
 * ```
 * getInitialState: function() {
 *   var ds = new ListView.DataSource({rowHasChanged: this._rowHasChanged});
 *   return {ds};
 * },
 * _onDataArrived(newData) {
 *   this._data = this._data.concat(newData);
 *   this.setState({
 *     ds: this.state.ds.cloneWithRows(this._data)
 *   });
 * }
 * ```
 */
var ListViewDataSource_ListViewDataSource =
/*#__PURE__*/
function () {
  /**
   * You can provide custom extraction and `hasChanged` functions for section
   * headers and rows.  If absent, data will be extracted with the
   * `defaultGetRowData` and `defaultGetSectionHeaderData` functions.
   *
   * The default extractor expects data of one of the following forms:
   *
   *      { sectionID_1: { rowID_1: <rowData1>, ... }, ... }
   *
   *    or
   *
   *      { sectionID_1: [ <rowData1>, <rowData2>, ... ], ... }
   *
   *    or
   *
   *      [ [ <rowData1>, <rowData2>, ... ], ... ]
   *
   * The constructor takes in a params argument that can contain any of the
   * following:
   *
   * - getRowData(dataBlob, sectionID, rowID);
   * - getSectionHeaderData(dataBlob, sectionID);
   * - rowHasChanged(prevRowData, nextRowData);
   * - sectionHeaderHasChanged(prevSectionData, nextSectionData);
   */
  function ListViewDataSource(params) {
    invariant_default()(params && typeof params.rowHasChanged === 'function', 'Must provide a rowHasChanged function.');
    this._rowHasChanged = params.rowHasChanged;
    this._getRowData = params.getRowData || defaultGetRowData;
    this._sectionHeaderHasChanged = params.sectionHeaderHasChanged;
    this._getSectionHeaderData = params.getSectionHeaderData || defaultGetSectionHeaderData;
    this._dataBlob = null;
    this._dirtyRows = [];
    this._dirtySections = [];
    this._cachedRowCount = 0; // These two private variables are accessed by outsiders because ListView
    // uses them to iterate over the data in this class.

    this.rowIdentities = [];
    this.sectionIdentities = [];
  }
  /**
   * Clones this `ListViewDataSource` with the specified `dataBlob` and
   * `rowIdentities`. The `dataBlob` is just an arbitrary blob of data. At
   * construction an extractor to get the interesting information was defined
   * (or the default was used).
   *
   * The `rowIdentities` is a 2D array of identifiers for rows.
   * ie. [['a1', 'a2'], ['b1', 'b2', 'b3'], ...].  If not provided, it's
   * assumed that the keys of the section data are the row identities.
   *
   * Note: This function does NOT clone the data in this data source. It simply
   * passes the functions defined at construction to a new data source with
   * the data specified. If you wish to maintain the existing data you must
   * handle merging of old and new data separately and then pass that into
   * this function as the `dataBlob`.
   */


  var _proto = ListViewDataSource.prototype;

  _proto.cloneWithRows = function cloneWithRows(dataBlob, rowIdentities) {
    var rowIds = rowIdentities ? [[].concat(rowIdentities)] : null;

    if (!this._sectionHeaderHasChanged) {
      this._sectionHeaderHasChanged = function () {
        return false;
      };
    }

    return this.cloneWithRowsAndSections({
      s1: dataBlob
    }, ['s1'], rowIds);
  }
  /**
   * This performs the same function as the `cloneWithRows` function but here
   * you also specify what your `sectionIdentities` are. If you don't care
   * about sections you should safely be able to use `cloneWithRows`.
   *
   * `sectionIdentities` is an array of identifiers for sections.
   * ie. ['s1', 's2', ...].  The identifiers should correspond to the keys or array indexes
   * of the data you wish to include.  If not provided, it's assumed that the
   * keys of dataBlob are the section identities.
   *
   * Note: this returns a new object!
   *
   * ```
   * const dataSource = ds.cloneWithRowsAndSections({
   *   addresses: ['row 1', 'row 2'],
   *   phone_numbers: ['data 1', 'data 2'],
   * }, ['phone_numbers']);
   * ```
   */
  ;

  _proto.cloneWithRowsAndSections = function cloneWithRowsAndSections(dataBlob, sectionIdentities, rowIdentities) {
    invariant_default()(typeof this._sectionHeaderHasChanged === 'function', 'Must provide a sectionHeaderHasChanged function with section data.');
    invariant_default()(!sectionIdentities || !rowIdentities || sectionIdentities.length === rowIdentities.length, 'row and section ids lengths must be the same');
    var newSource = new ListViewDataSource({
      getRowData: this._getRowData,
      getSectionHeaderData: this._getSectionHeaderData,
      rowHasChanged: this._rowHasChanged,
      sectionHeaderHasChanged: this._sectionHeaderHasChanged
    });
    newSource._dataBlob = dataBlob;

    if (sectionIdentities) {
      newSource.sectionIdentities = sectionIdentities;
    } else {
      newSource.sectionIdentities = Object.keys(dataBlob);
    }

    if (rowIdentities) {
      newSource.rowIdentities = rowIdentities;
    } else {
      newSource.rowIdentities = [];
      newSource.sectionIdentities.forEach(function (sectionID) {
        newSource.rowIdentities.push(Object.keys(dataBlob[sectionID]));
      });
    }

    newSource._cachedRowCount = countRows(newSource.rowIdentities);

    newSource._calculateDirtyArrays(this._dataBlob, this.sectionIdentities, this.rowIdentities);

    return newSource;
  }
  /**
   * Returns the total number of rows in the data source.
   *
   * If you are specifying the rowIdentities or sectionIdentities, then `getRowCount` will return the number of rows in the filtered data source.
   */
  ;

  _proto.getRowCount = function getRowCount() {
    return this._cachedRowCount;
  }
  /**
   * Returns the total number of rows in the data source (see `getRowCount` for how this is calculated) plus the number of sections in the data.
   *
   * If you are specifying the rowIdentities or sectionIdentities, then `getRowAndSectionCount` will return the number of rows & sections in the filtered data source.
   */
  ;

  _proto.getRowAndSectionCount = function getRowAndSectionCount() {
    return this._cachedRowCount + this.sectionIdentities.length;
  }
  /**
   * Returns if the row is dirtied and needs to be rerendered
   */
  ;

  _proto.rowShouldUpdate = function rowShouldUpdate(sectionIndex, rowIndex) {
    var needsUpdate = this._dirtyRows[sectionIndex][rowIndex];
    warning_default()(needsUpdate !== undefined, 'missing dirtyBit for section, row: ' + sectionIndex + ', ' + rowIndex);
    return needsUpdate;
  }
  /**
   * Gets the data required to render the row.
   */
  ;

  _proto.getRowData = function getRowData(sectionIndex, rowIndex) {
    var sectionID = this.sectionIdentities[sectionIndex];
    var rowID = this.rowIdentities[sectionIndex][rowIndex];
    warning_default()(sectionID !== undefined && rowID !== undefined, 'rendering invalid section, row: ' + sectionIndex + ', ' + rowIndex);
    return this._getRowData(this._dataBlob, sectionID, rowID);
  }
  /**
   * Gets the rowID at index provided if the dataSource arrays were flattened,
   * or null of out of range indexes.
   */
  ;

  _proto.getRowIDForFlatIndex = function getRowIDForFlatIndex(index) {
    var accessIndex = index;

    for (var ii = 0; ii < this.sectionIdentities.length; ii++) {
      if (accessIndex >= this.rowIdentities[ii].length) {
        accessIndex -= this.rowIdentities[ii].length;
      } else {
        return this.rowIdentities[ii][accessIndex];
      }
    }

    return null;
  }
  /**
   * Gets the sectionID at index provided if the dataSource arrays were flattened,
   * or null for out of range indexes.
   */
  ;

  _proto.getSectionIDForFlatIndex = function getSectionIDForFlatIndex(index) {
    var accessIndex = index;

    for (var ii = 0; ii < this.sectionIdentities.length; ii++) {
      if (accessIndex >= this.rowIdentities[ii].length) {
        accessIndex -= this.rowIdentities[ii].length;
      } else {
        return this.sectionIdentities[ii];
      }
    }

    return null;
  }
  /**
   * Returns an array containing the number of rows in each section
   */
  ;

  _proto.getSectionLengths = function getSectionLengths() {
    var results = [];

    for (var ii = 0; ii < this.sectionIdentities.length; ii++) {
      results.push(this.rowIdentities[ii].length);
    }

    return results;
  }
  /**
   * Returns if the section header is dirtied and needs to be rerendered
   */
  ;

  _proto.sectionHeaderShouldUpdate = function sectionHeaderShouldUpdate(sectionIndex) {
    var needsUpdate = this._dirtySections[sectionIndex];
    warning_default()(needsUpdate !== undefined, 'missing dirtyBit for section: ' + sectionIndex);
    return needsUpdate;
  }
  /**
   * Gets the data required to render the section header
   */
  ;

  _proto.getSectionHeaderData = function getSectionHeaderData(sectionIndex) {
    if (!this._getSectionHeaderData) {
      return null;
    }

    var sectionID = this.sectionIdentities[sectionIndex];
    warning_default()(sectionID !== undefined, 'renderSection called on invalid section: ' + sectionIndex);
    return this._getSectionHeaderData(this._dataBlob, sectionID);
  }
  /**
   * Private members and methods.
   */
  ;

  _proto._calculateDirtyArrays = function _calculateDirtyArrays(prevDataBlob, prevSectionIDs, prevRowIDs) {
    // construct a hashmap of the existing (old) id arrays
    var prevSectionsHash = keyedDictionaryFromArray(prevSectionIDs);
    var prevRowsHash = {};

    for (var ii = 0; ii < prevRowIDs.length; ii++) {
      var sectionID = prevSectionIDs[ii];
      warning_default()(!prevRowsHash[sectionID], 'SectionID appears more than once: ' + sectionID);
      prevRowsHash[sectionID] = keyedDictionaryFromArray(prevRowIDs[ii]);
    } // compare the 2 identity array and get the dirtied rows


    this._dirtySections = [];
    this._dirtyRows = [];
    var dirty;

    for (var sIndex = 0; sIndex < this.sectionIdentities.length; sIndex++) {
      var sectionID = this.sectionIdentities[sIndex]; // dirty if the sectionHeader is new or _sectionHasChanged is true

      dirty = !prevSectionsHash[sectionID];
      var sectionHeaderHasChanged = this._sectionHeaderHasChanged;

      if (!dirty && sectionHeaderHasChanged) {
        dirty = sectionHeaderHasChanged(this._getSectionHeaderData(prevDataBlob, sectionID), this._getSectionHeaderData(this._dataBlob, sectionID));
      }

      this._dirtySections.push(!!dirty);

      this._dirtyRows[sIndex] = [];

      for (var rIndex = 0; rIndex < this.rowIdentities[sIndex].length; rIndex++) {
        var rowID = this.rowIdentities[sIndex][rIndex]; // dirty if the section is new, row is new or _rowHasChanged is true

        dirty = !prevSectionsHash[sectionID] || !prevRowsHash[sectionID][rowID] || this._rowHasChanged(this._getRowData(prevDataBlob, sectionID, rowID), this._getRowData(this._dataBlob, sectionID, rowID));

        this._dirtyRows[sIndex].push(!!dirty);
      }
    }
  };

  return ListViewDataSource;
}();

function countRows(allRowIDs) {
  var totalRows = 0;

  for (var sectionIdx = 0; sectionIdx < allRowIDs.length; sectionIdx++) {
    var rowIDs = allRowIDs[sectionIdx];
    totalRows += rowIDs.length;
  }

  return totalRows;
}

function keyedDictionaryFromArray(arr) {
  if (react_native_isEmpty(arr)) {
    return {};
  }

  var result = {};

  for (var ii = 0; ii < arr.length; ii++) {
    var key = arr[ii];
    warning_default()(!result[key], 'Value appears more than once in array: ' + key);
    result[key] = true;
  }

  return result;
}

/* harmony default export */ var ListView_ListViewDataSource = (ListViewDataSource_ListViewDataSource);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/StaticRenderer/index.js
function StaticRenderer_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) 2015-present, Nicolas Gallagher.
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * Renders static content efficiently by allowing React to short-circuit the
 * reconciliation process. This component should be used when you know that a
 * subtree of components will never need to be updated.
 *
 *   const someValue = ...; // We know for certain this value will never change.
 *   return (
 *     <StaticRenderer render={() => <MyComponent value={someValue} />} />
 *   );
 *
 * Typically, you will not need to use this component and should opt for normal
 * React reconciliation.
 */

var StaticRenderer =
/*#__PURE__*/
function (_Component) {
  StaticRenderer_inheritsLoose(StaticRenderer, _Component);

  function StaticRenderer() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = StaticRenderer.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    return nextProps.shouldUpdate;
  };

  _proto.render = function render() {
    return this.props.render();
  };

  return StaticRenderer;
}(external_react_["Component"]);


StaticRenderer.propTypes =  false ? undefined : {};
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/ListView/cloneReferencedElement.js


function cloneReferencedElement_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { cloneReferencedElement_defineProperty(target, key, source[key]); }); } return target; }

function cloneReferencedElement_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var cloneReferencedElement_DEV_ = "production" !== 'production';

function cloneReferencedElement(element, config) {
  var cloneRef = config.ref;
  var originalRef = element.ref;

  for (var _len = arguments.length, children = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    children[_key - 2] = arguments[_key];
  }

  if (originalRef == null || cloneRef == null) {
    return external_react_default.a.cloneElement.apply(external_react_default.a, [element, config].concat(children));
  }

  if (typeof originalRef !== 'function') {
    if (cloneReferencedElement_DEV_) {
      console.warn('Cloning an element with a ref that will be overwritten because it ' + 'is not a function. Use a composable callback-style ref instead. ' + 'Ignoring ref: ' + originalRef);
    }

    return external_react_default.a.cloneElement.apply(external_react_default.a, [element, config].concat(children));
  }

  return external_react_default.a.cloneElement.apply(external_react_default.a, [element, cloneReferencedElement_objectSpread({}, config, {
    ref: function ref(component) {
      cloneRef(component);
      originalRef(component);
    }
  })].concat(children));
}

/* harmony default export */ var ListView_cloneReferencedElement = (cloneReferencedElement);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/ListView/index.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule ListView
 * 
 * @format
 */


function ListView_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ListView_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { ListView_defineProperty(target, key, source[key]); }); } return target; }

function ListView_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
















var merge = function merge() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return Object.assign.apply(Object, [{}].concat(args));
};

var RCTScrollViewManager = NativeModules["a" /* default */].ScrollViewManager;
var DEFAULT_PAGE_SIZE = 1;
var DEFAULT_INITIAL_ROWS = 10;
var DEFAULT_SCROLL_RENDER_AHEAD = 1000;
var DEFAULT_END_REACHED_THRESHOLD = 1000;
var DEFAULT_SCROLL_CALLBACK_THROTTLE = 50;
/**
 * DEPRECATED - use one of the new list components, such as [`FlatList`](docs/flatlist.html)
 * or [`SectionList`](docs/sectionlist.html) for bounded memory use, fewer bugs,
 * better performance, an easier to use API, and more features. Check out this
 * [blog post](https://facebook.github.io/react-native/blog/2017/03/13/better-list-views.html)
 * for more details.
 *
 * ListView - A core component designed for efficient display of vertically
 * scrolling lists of changing data. The minimal API is to create a
 * [`ListView.DataSource`](docs/listviewdatasource.html), populate it with a simple
 * array of data blobs, and instantiate a `ListView` component with that data
 * source and a `renderRow` callback which takes a blob from the data array and
 * returns a renderable component.
 *
 * Minimal example:
 *
 * ```
 * class MyComponent extends Component {
 *   constructor() {
 *     super();
 *     const ds = new ListView.DataSource({rowHasChanged: (r1, r2) => r1 !== r2});
 *     this.state = {
 *       dataSource: ds.cloneWithRows(['row 1', 'row 2']),
 *     };
 *   }
 *
 *   render() {
 *     return (
 *       <ListView
 *         dataSource={this.state.dataSource}
 *         renderRow={(rowData) => <Text>{rowData}</Text>}
 *       />
 *     );
 *   }
 * }
 * ```
 *
 * ListView also supports more advanced features, including sections with sticky
 * section headers, header and footer support, callbacks on reaching the end of
 * the available data (`onEndReached`) and on the set of rows that are visible
 * in the device viewport change (`onChangeVisibleRows`), and several
 * performance optimizations.
 *
 * There are a few performance operations designed to make ListView scroll
 * smoothly while dynamically loading potentially very large (or conceptually
 * infinite) data sets:
 *
 *  * Only re-render changed rows - the rowHasChanged function provided to the
 *    data source tells the ListView if it needs to re-render a row because the
 *    source data has changed - see ListViewDataSource for more details.
 *
 *  * Rate-limited row rendering - By default, only one row is rendered per
 *    event-loop (customizable with the `pageSize` prop). This breaks up the
 *    work into smaller chunks to reduce the chance of dropping frames while
 *    rendering rows.
 */

var ListView = create_react_class_default()({
  displayName: 'ListView',
  _childFrames: [],
  _sentEndForContentLength: null,
  _scrollComponent: null,
  _prevRenderedRowsCount: 0,
  _visibleRows: {},
  scrollProperties: {},
  mixins: [modules_ScrollResponder.Mixin, TimerMixin_default.a],
  statics: {
    DataSource: ListView_ListViewDataSource
  },

  /**
   * You must provide a renderRow function. If you omit any of the other render
   * functions, ListView will simply skip rendering them.
   *
   * - renderRow(rowData, sectionID, rowID, highlightRow);
   * - renderSectionHeader(sectionData, sectionID);
   */
  propTypes: ListView_objectSpread({}, exports_ScrollView.propTypes, {
    /**
     * An instance of [ListView.DataSource](docs/listviewdatasource.html) to use
     */
    dataSource: external_prop_types_default.a.instanceOf(ListView_ListViewDataSource).isRequired,

    /**
     * (sectionID, rowID, adjacentRowHighlighted) => renderable
     *
     * If provided, a renderable component to be rendered as the separator
     * below each row but not the last row if there is a section header below.
     * Take a sectionID and rowID of the row above and whether its adjacent row
     * is highlighted.
     */
    renderSeparator: external_prop_types_default.a.func,

    /**
     * (rowData, sectionID, rowID, highlightRow) => renderable
     *
     * Takes a data entry from the data source and its ids and should return
     * a renderable component to be rendered as the row. By default the data
     * is exactly what was put into the data source, but it's also possible to
     * provide custom extractors. ListView can be notified when a row is
     * being highlighted by calling `highlightRow(sectionID, rowID)`. This
     * sets a boolean value of adjacentRowHighlighted in renderSeparator, allowing you
     * to control the separators above and below the highlighted row. The highlighted
     * state of a row can be reset by calling highlightRow(null).
     */
    renderRow: external_prop_types_default.a.func.isRequired,

    /**
     * How many rows to render on initial component mount. Use this to make
     * it so that the first screen worth of data appears at one time instead of
     * over the course of multiple frames.
     */
    initialListSize: external_prop_types_default.a.number.isRequired,

    /**
     * Called when all rows have been rendered and the list has been scrolled
     * to within onEndReachedThreshold of the bottom. The native scroll
     * event is provided.
     */
    onEndReached: external_prop_types_default.a.func,

    /**
     * Threshold in pixels (virtual, not physical) for calling onEndReached.
     */
    onEndReachedThreshold: external_prop_types_default.a.number.isRequired,

    /**
     * Number of rows to render per event loop. Note: if your 'rows' are actually
     * cells, i.e. they don't span the full width of your view (as in the
     * ListViewGridLayoutExample), you should set the pageSize to be a multiple
     * of the number of cells per row, otherwise you're likely to see gaps at
     * the edge of the ListView as new pages are loaded.
     */
    pageSize: external_prop_types_default.a.number.isRequired,

    /**
     * () => renderable
     *
     * The header and footer are always rendered (if these props are provided)
     * on every render pass. If they are expensive to re-render, wrap them
     * in StaticContainer or other mechanism as appropriate. Footer is always
     * at the bottom of the list, and header at the top, on every render pass.
     * In a horizontal ListView, the header is rendered on the left and the
     * footer on the right.
     */
    renderFooter: external_prop_types_default.a.func,
    renderHeader: external_prop_types_default.a.func,

    /**
     * (sectionData, sectionID) => renderable
     *
     * If provided, a header is rendered for this section.
     */
    renderSectionHeader: external_prop_types_default.a.func,

    /**
     * (props) => renderable
     *
     * A function that returns the scrollable component in which the list rows
     * are rendered. Defaults to returning a ScrollView with the given props.
     */
    renderScrollComponent: external_prop_types_default.a.func.isRequired,

    /**
     * How early to start rendering rows before they come on screen, in
     * pixels.
     */
    scrollRenderAheadDistance: external_prop_types_default.a.number.isRequired,

    /**
     * (visibleRows, changedRows) => void
     *
     * Called when the set of visible rows changes. `visibleRows` maps
     * { sectionID: { rowID: true }} for all the visible rows, and
     * `changedRows` maps { sectionID: { rowID: true | false }} for the rows
     * that have changed their visibility, with true indicating visible, and
     * false indicating the view has moved out of view.
     */
    onChangeVisibleRows: external_prop_types_default.a.func,

    /**
     * A performance optimization for improving scroll perf of
     * large lists, used in conjunction with overflow: 'hidden' on the row
     * containers. This is enabled by default.
     */
    removeClippedSubviews: external_prop_types_default.a.bool,

    /**
     * Makes the sections headers sticky. The sticky behavior means that it
     * will scroll with the content at the top of the section until it reaches
     * the top of the screen, at which point it will stick to the top until it
     * is pushed off the screen by the next section header. This property is
     * not supported in conjunction with `horizontal={true}`. Only enabled by
     * default on iOS because of typical platform standards.
     */
    stickySectionHeadersEnabled: external_prop_types_default.a.bool,

    /**
     * An array of child indices determining which children get docked to the
     * top of the screen when scrolling. For example, passing
     * `stickyHeaderIndices={[0]}` will cause the first child to be fixed to the
     * top of the scroll view. This property is not supported in conjunction
     * with `horizontal={true}`.
     */
    stickyHeaderIndices: external_prop_types_default.a.arrayOf(external_prop_types_default.a.number).isRequired,

    /**
     * Flag indicating whether empty section headers should be rendered. In the future release
     * empty section headers will be rendered by default, and the flag will be deprecated.
     * If empty sections are not desired to be rendered their indices should be excluded from sectionID object.
     */
    enableEmptySections: external_prop_types_default.a.bool
  }),

  /**
   * Exports some data, e.g. for perf investigations or analytics.
   */
  getMetrics: function getMetrics() {
    return {
      contentLength: this.scrollProperties.contentLength,
      totalRows: this.props.enableEmptySections ? this.props.dataSource.getRowAndSectionCount() : this.props.dataSource.getRowCount(),
      renderedRows: this.state.curRenderedRowsCount,
      visibleRows: Object.keys(this._visibleRows).length
    };
  },

  /**
   * Provides a handle to the underlying scroll responder.
   * Note that `this._scrollComponent` might not be a `ScrollView`, so we
   * need to check that it responds to `getScrollResponder` before calling it.
   */
  getScrollResponder: function getScrollResponder() {
    if (this._scrollComponent && this._scrollComponent.getScrollResponder) {
      return this._scrollComponent.getScrollResponder();
    }
  },
  getScrollableNode: function getScrollableNode() {
    if (this._scrollComponent && this._scrollComponent.getScrollableNode) {
      return this._scrollComponent.getScrollableNode();
    } else {
      return exports_findNodeHandle(this._scrollComponent);
    }
  },

  /**
   * Scrolls to a given x, y offset, either immediately or with a smooth animation.
   *
   * See `ScrollView#scrollTo`.
   */
  scrollTo: function scrollTo() {
    if (this._scrollComponent && this._scrollComponent.scrollTo) {
      var _this$_scrollComponen;

      (_this$_scrollComponen = this._scrollComponent).scrollTo.apply(_this$_scrollComponen, arguments);
    }
  },

  /**
   * If this is a vertical ListView scrolls to the bottom.
   * If this is a horizontal ListView scrolls to the right.
   *
   * Use `scrollToEnd({animated: true})` for smooth animated scrolling,
   * `scrollToEnd({animated: false})` for immediate scrolling.
   * If no options are passed, `animated` defaults to true.
   *
   * See `ScrollView#scrollToEnd`.
   */
  scrollToEnd: function scrollToEnd(options) {
    if (this._scrollComponent) {
      if (this._scrollComponent.scrollToEnd) {
        this._scrollComponent.scrollToEnd(options);
      } else {
        console.warn('The scroll component used by the ListView does not support ' + 'scrollToEnd. Check the renderScrollComponent prop of your ListView.');
      }
    }
  },

  /**
   * Displays the scroll indicators momentarily.
   *
   * @platform ios
   */
  flashScrollIndicators: function flashScrollIndicators() {
    if (this._scrollComponent && this._scrollComponent.flashScrollIndicators) {
      this._scrollComponent.flashScrollIndicators();
    }
  },
  setNativeProps: function setNativeProps(props) {
    if (this._scrollComponent) {
      this._scrollComponent.setNativeProps(props);
    }
  },

  /**
   * React life cycle hooks.
   */
  getDefaultProps: function getDefaultProps() {
    return {
      initialListSize: DEFAULT_INITIAL_ROWS,
      pageSize: DEFAULT_PAGE_SIZE,
      renderScrollComponent: function renderScrollComponent(props) {
        return external_react_default.a.createElement(exports_ScrollView, props);
      },
      scrollRenderAheadDistance: DEFAULT_SCROLL_RENDER_AHEAD,
      onEndReachedThreshold: DEFAULT_END_REACHED_THRESHOLD,
      stickySectionHeadersEnabled: exports_Platform.OS === 'ios' || exports_Platform.OS === 'web',
      stickyHeaderIndices: []
    };
  },
  getInitialState: function getInitialState() {
    return {
      curRenderedRowsCount: this.props.initialListSize,
      highlightedRow: {}
    };
  },
  getInnerViewNode: function getInnerViewNode() {
    return this._scrollComponent.getInnerViewNode();
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    // this data should never trigger a render pass, so don't put in state
    this.scrollProperties = {
      visibleLength: null,
      contentLength: null,
      offset: 0
    };
    this._childFrames = [];
    this._visibleRows = {};
    this._prevRenderedRowsCount = 0;
    this._sentEndForContentLength = null;
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    // do this in animation frame until componentDidMount actually runs after
    // the component is laid out
    this.requestAnimationFrame(function () {
      _this._measureAndUpdateScrollProps();
    });
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    var _this2 = this;

    if (this.props.dataSource !== nextProps.dataSource || this.props.initialListSize !== nextProps.initialListSize) {
      this.setState(function (state, props) {
        _this2._prevRenderedRowsCount = 0;
        return {
          curRenderedRowsCount: Math.min(Math.max(state.curRenderedRowsCount, props.initialListSize), props.enableEmptySections ? props.dataSource.getRowAndSectionCount() : props.dataSource.getRowCount())
        };
      }, function () {
        return _this2._renderMoreRowsIfNeeded();
      });
    }
  },
  componentDidUpdate: function componentDidUpdate() {
    var _this3 = this;

    this.requestAnimationFrame(function () {
      _this3._measureAndUpdateScrollProps();
    });
  },
  _onRowHighlighted: function _onRowHighlighted(sectionID, rowID) {
    this.setState({
      highlightedRow: {
        sectionID: sectionID,
        rowID: rowID
      }
    });
  },
  render: function render() {
    var bodyComponents = [];
    var dataSource = this.props.dataSource;
    var allRowIDs = dataSource.rowIdentities;
    var rowCount = 0;
    var stickySectionHeaderIndices = [];
    var renderSectionHeader = this.props.renderSectionHeader;
    var header = this.props.renderHeader && this.props.renderHeader();
    var footer = this.props.renderFooter && this.props.renderFooter();
    var totalIndex = header ? 1 : 0;

    for (var sectionIdx = 0; sectionIdx < allRowIDs.length; sectionIdx++) {
      var sectionID = dataSource.sectionIdentities[sectionIdx];
      var rowIDs = allRowIDs[sectionIdx];

      if (rowIDs.length === 0) {
        if (this.props.enableEmptySections === undefined) {
          /* $FlowFixMe(>=0.54.0 site=react_native_oss) This comment suppresses
           * an error found when Flow v0.54 was deployed. To see the error
           * delete this comment and run Flow. */
          var warning = __webpack_require__(15);

          warning(false, 'In next release empty section headers will be rendered.' + " In this release you can use 'enableEmptySections' flag to render empty section headers.");
          continue;
        } else {
          var invariant = __webpack_require__(3);

          invariant(this.props.enableEmptySections, "In next release 'enableEmptySections' flag will be deprecated, empty section headers will always be rendered." + ' If empty section headers are not desirable their indices should be excluded from sectionIDs object.' + " In this release 'enableEmptySections' may only have value 'true' to allow empty section headers rendering.");
        }
      }

      if (renderSectionHeader) {
        var element = renderSectionHeader(dataSource.getSectionHeaderData(sectionIdx), sectionID);

        if (element) {
          bodyComponents.push(external_react_default.a.cloneElement(element, {
            key: 's_' + sectionID
          }));

          if (this.props.stickySectionHeadersEnabled) {
            stickySectionHeaderIndices.push(totalIndex);
          }

          totalIndex++;
        }
      }

      for (var rowIdx = 0; rowIdx < rowIDs.length; rowIdx++) {
        var rowID = rowIDs[rowIdx];
        var comboID = sectionID + '_' + rowID;
        var shouldUpdateRow = rowCount >= this._prevRenderedRowsCount && dataSource.rowShouldUpdate(sectionIdx, rowIdx);
        var row = external_react_default.a.createElement(StaticRenderer, {
          key: 'r_' + comboID,
          shouldUpdate: !!shouldUpdateRow,
          render: this.props.renderRow.bind(null, dataSource.getRowData(sectionIdx, rowIdx), sectionID, rowID, this._onRowHighlighted)
        });
        bodyComponents.push(row);
        totalIndex++;

        if (this.props.renderSeparator && (rowIdx !== rowIDs.length - 1 || sectionIdx === allRowIDs.length - 1)) {
          var adjacentRowHighlighted = this.state.highlightedRow.sectionID === sectionID && (this.state.highlightedRow.rowID === rowID || this.state.highlightedRow.rowID === rowIDs[rowIdx + 1]);
          var separator = this.props.renderSeparator(sectionID, rowID, adjacentRowHighlighted);

          if (separator) {
            bodyComponents.push(external_react_default.a.createElement(exports_View, {
              key: 's_' + comboID
            }, separator));
            totalIndex++;
          }
        }

        if (++rowCount === this.state.curRenderedRowsCount) {
          break;
        }
      }

      if (rowCount >= this.state.curRenderedRowsCount) {
        break;
      }
    }

    var _this$props = this.props,
        renderScrollComponent = _this$props.renderScrollComponent,
        props = ListView_objectWithoutPropertiesLoose(_this$props, ["renderScrollComponent"]);

    if (!props.scrollEventThrottle) {
      props.scrollEventThrottle = DEFAULT_SCROLL_CALLBACK_THROTTLE;
    }

    if (props.removeClippedSubviews === undefined) {
      props.removeClippedSubviews = true;
    }

    Object.assign(props, {
      onScroll: this._onScroll,
      stickyHeaderIndices: this.props.stickyHeaderIndices.concat(stickySectionHeaderIndices),
      // Do not pass these events downstream to ScrollView since they will be
      // registered in ListView's own ScrollResponder.Mixin
      onKeyboardWillShow: undefined,
      onKeyboardWillHide: undefined,
      onKeyboardDidShow: undefined,
      onKeyboardDidHide: undefined
    });
    return ListView_cloneReferencedElement(renderScrollComponent(props), {
      ref: this._setScrollComponentRef,
      onContentSizeChange: this._onContentSizeChange,
      onLayout: this._onLayout,
      DEPRECATED_sendUpdatedChildFrames: typeof props.onChangeVisibleRows !== undefined
    }, header, bodyComponents, footer);
  },

  /**
   * Private methods
   */
  _measureAndUpdateScrollProps: function _measureAndUpdateScrollProps() {
    var scrollComponent = this.getScrollResponder();

    if (!scrollComponent || !scrollComponent.getInnerViewNode) {
      return;
    } // RCTScrollViewManager.calculateChildFrames is not available on
    // every platform


    RCTScrollViewManager && RCTScrollViewManager.calculateChildFrames && RCTScrollViewManager.calculateChildFrames(exports_findNodeHandle(scrollComponent), this._updateVisibleRows);
  },
  _setScrollComponentRef: function _setScrollComponentRef(scrollComponent) {
    this._scrollComponent = scrollComponent;
  },
  _onContentSizeChange: function _onContentSizeChange(width, height) {
    var contentLength = !this.props.horizontal ? height : width;

    if (contentLength !== this.scrollProperties.contentLength) {
      this.scrollProperties.contentLength = contentLength;

      this._updateVisibleRows();

      this._renderMoreRowsIfNeeded();
    }

    this.props.onContentSizeChange && this.props.onContentSizeChange(width, height);
  },
  _onLayout: function _onLayout(event) {
    var _event$nativeEvent$la = event.nativeEvent.layout,
        width = _event$nativeEvent$la.width,
        height = _event$nativeEvent$la.height;
    var visibleLength = !this.props.horizontal ? height : width;

    if (visibleLength !== this.scrollProperties.visibleLength) {
      this.scrollProperties.visibleLength = visibleLength;

      this._updateVisibleRows();

      this._renderMoreRowsIfNeeded();
    }

    this.props.onLayout && this.props.onLayout(event);
  },
  _maybeCallOnEndReached: function _maybeCallOnEndReached(event) {
    if (this.props.onEndReached && this.scrollProperties.contentLength !== this._sentEndForContentLength && this._getDistanceFromEnd(this.scrollProperties) < this.props.onEndReachedThreshold && this.state.curRenderedRowsCount === (this.props.enableEmptySections ? this.props.dataSource.getRowAndSectionCount() : this.props.dataSource.getRowCount())) {
      this._sentEndForContentLength = this.scrollProperties.contentLength;
      this.props.onEndReached(event);
      return true;
    }

    return false;
  },
  _renderMoreRowsIfNeeded: function _renderMoreRowsIfNeeded() {
    if (this.scrollProperties.contentLength === null || this.scrollProperties.visibleLength === null || this.state.curRenderedRowsCount === (this.props.enableEmptySections ? this.props.dataSource.getRowAndSectionCount() : this.props.dataSource.getRowCount())) {
      this._maybeCallOnEndReached();

      return;
    }

    var distanceFromEnd = this._getDistanceFromEnd(this.scrollProperties);

    if (distanceFromEnd < this.props.scrollRenderAheadDistance) {
      this._pageInNewRows();
    }
  },
  _pageInNewRows: function _pageInNewRows() {
    var _this4 = this;

    this.setState(function (state, props) {
      var rowsToRender = Math.min(state.curRenderedRowsCount + props.pageSize, props.enableEmptySections ? props.dataSource.getRowAndSectionCount() : props.dataSource.getRowCount());
      _this4._prevRenderedRowsCount = state.curRenderedRowsCount;
      return {
        curRenderedRowsCount: rowsToRender
      };
    }, function () {
      _this4._measureAndUpdateScrollProps();

      _this4._prevRenderedRowsCount = _this4.state.curRenderedRowsCount;
    });
  },
  _getDistanceFromEnd: function _getDistanceFromEnd(scrollProperties) {
    return scrollProperties.contentLength - scrollProperties.visibleLength - scrollProperties.offset;
  },
  _updateVisibleRows: function _updateVisibleRows(updatedFrames) {
    var _this5 = this;

    if (!this.props.onChangeVisibleRows) {
      return; // No need to compute visible rows if there is no callback
    }

    if (updatedFrames) {
      updatedFrames.forEach(function (newFrame) {
        _this5._childFrames[newFrame.index] = merge(newFrame);
      });
    }

    var isVertical = !this.props.horizontal;
    var dataSource = this.props.dataSource;
    var visibleMin = this.scrollProperties.offset;
    var visibleMax = visibleMin + this.scrollProperties.visibleLength;
    var allRowIDs = dataSource.rowIdentities;
    var header = this.props.renderHeader && this.props.renderHeader();
    var totalIndex = header ? 1 : 0;
    var visibilityChanged = false;
    var changedRows = {};

    for (var sectionIdx = 0; sectionIdx < allRowIDs.length; sectionIdx++) {
      var rowIDs = allRowIDs[sectionIdx];

      if (rowIDs.length === 0) {
        continue;
      }

      var sectionID = dataSource.sectionIdentities[sectionIdx];

      if (this.props.renderSectionHeader) {
        totalIndex++;
      }

      var visibleSection = this._visibleRows[sectionID];

      if (!visibleSection) {
        visibleSection = {};
      }

      for (var rowIdx = 0; rowIdx < rowIDs.length; rowIdx++) {
        var rowID = rowIDs[rowIdx];
        var frame = this._childFrames[totalIndex];
        totalIndex++;

        if (this.props.renderSeparator && (rowIdx !== rowIDs.length - 1 || sectionIdx === allRowIDs.length - 1)) {
          totalIndex++;
        }

        if (!frame) {
          break;
        }

        var rowVisible = visibleSection[rowID];
        var min = isVertical ? frame.y : frame.x;
        var max = min + (isVertical ? frame.height : frame.width);

        if (!min && !max || min === max) {
          break;
        }

        if (min > visibleMax || max < visibleMin) {
          if (rowVisible) {
            visibilityChanged = true;
            delete visibleSection[rowID];

            if (!changedRows[sectionID]) {
              changedRows[sectionID] = {};
            }

            changedRows[sectionID][rowID] = false;
          }
        } else if (!rowVisible) {
          visibilityChanged = true;
          visibleSection[rowID] = true;

          if (!changedRows[sectionID]) {
            changedRows[sectionID] = {};
          }

          changedRows[sectionID][rowID] = true;
        }
      }

      if (!react_native_isEmpty(visibleSection)) {
        this._visibleRows[sectionID] = visibleSection;
      } else if (this._visibleRows[sectionID]) {
        delete this._visibleRows[sectionID];
      }
    }

    visibilityChanged && this.props.onChangeVisibleRows(this._visibleRows, changedRows);
  },
  _onScroll: function _onScroll(e) {
    var isVertical = !this.props.horizontal;
    this.scrollProperties.visibleLength = e.nativeEvent.layoutMeasurement[isVertical ? 'height' : 'width'];
    this.scrollProperties.contentLength = e.nativeEvent.contentSize[isVertical ? 'height' : 'width'];
    this.scrollProperties.offset = e.nativeEvent.contentOffset[isVertical ? 'y' : 'x'];

    this._updateVisibleRows(e.nativeEvent.updatedChildFrames);

    if (!this._maybeCallOnEndReached(e)) {
      this._renderMoreRowsIfNeeded();
    }

    if (this.props.onEndReached && this._getDistanceFromEnd(this.scrollProperties) > this.props.onEndReachedThreshold) {
      // Scrolled out of the end zone, so it should be able to trigger again.
      this._sentEndForContentLength = null;
    }

    this.props.onScroll && this.props.onScroll(e);
  }
});
/* harmony default export */ var react_native_ListView = (ListView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/ListView/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var exports_ListView = (react_native_ListView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Modal/index.js

/* harmony default export */ var Modal = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Picker/PickerItem.js
function PickerItem_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */





var PickerItem_PickerItem =
/*#__PURE__*/
function (_Component) {
  PickerItem_inheritsLoose(PickerItem, _Component);

  function PickerItem() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = PickerItem.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        color = _this$props.color,
        label = _this$props.label,
        testID = _this$props.testID,
        value = _this$props.value;
    var style = {
      color: color
    };
    return exports_createElement('option', {
      style: style,
      testID: testID,
      value: value
    }, label);
  };

  return PickerItem;
}(external_react_["Component"]);


PickerItem_PickerItem.propTypes =  false ? undefined : {};
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Picker/index.js
function Picker_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { Picker_defineProperty(target, key, source[key]); }); } return target; }

function Picker_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Picker_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Picker_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */










var pickerStyleType =  false ? undefined : {};

var Picker_Picker =
/*#__PURE__*/
function (_Component) {
  Picker_inheritsLoose(Picker, _Component);

  function Picker() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this._handleChange = function (e) {
      var onValueChange = _this.props.onValueChange;
      var _e$target = e.target,
          selectedIndex = _e$target.selectedIndex,
          value = _e$target.value;

      if (onValueChange) {
        onValueChange(value, selectedIndex);
      }
    };

    return _this;
  }

  var _proto = Picker.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        children = _this$props.children,
        enabled = _this$props.enabled,
        selectedValue = _this$props.selectedValue,
        style = _this$props.style,
        testID = _this$props.testID,
        itemStyle = _this$props.itemStyle,
        mode = _this$props.mode,
        prompt = _this$props.prompt,
        onValueChange = _this$props.onValueChange,
        otherProps = Picker_objectWithoutPropertiesLoose(_this$props, ["children", "enabled", "selectedValue", "style", "testID", "itemStyle", "mode", "prompt", "onValueChange"]);

    return exports_createElement('select', Picker_objectSpread({
      children: children,
      disabled: enabled === false ? true : undefined,
      onChange: this._handleChange,
      style: [Picker_styles.initial, style],
      testID: testID,
      value: selectedValue
    }, otherProps));
  };

  return Picker;
}(external_react_["Component"]);

Picker_Picker.Item = PickerItem_PickerItem;
Picker_Picker.propTypes =  false ? undefined : {};
var Picker_styles = exports_StyleSheet.create({
  initial: {
    fontFamily: 'System',
    fontSize: 'inherit',
    margin: 0
  }
});
/* harmony default export */ var exports_Picker = (modules_applyNativeMethods(Picker_Picker));
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/ProgressBar/index.js
function ProgressBar_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { ProgressBar_defineProperty(target, key, source[key]); }); } return target; }

function ProgressBar_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function ProgressBar_extends() { ProgressBar_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return ProgressBar_extends.apply(this, arguments); }

function ProgressBar_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function ProgressBar_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */








var ProgressBar_ProgressBar =
/*#__PURE__*/
function (_Component) {
  ProgressBar_inheritsLoose(ProgressBar, _Component);

  function ProgressBar() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this._setProgressRef = function (element) {
      _this._progressElement = element;
    };

    _this._updateProgressWidth = function () {
      var _this$props = _this.props,
          indeterminate = _this$props.indeterminate,
          progress = _this$props.progress;
      var percentageProgress = indeterminate ? 50 : progress * 100;
      var width = indeterminate ? '25%' : percentageProgress + "%";

      if (_this._progressElement) {
        _this._progressElement.setNativeProps({
          style: {
            width: width
          }
        });
      }
    };

    return _this;
  }

  var _proto = ProgressBar.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._updateProgressWidth();
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    this._updateProgressWidth();
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        color = _this$props2.color,
        indeterminate = _this$props2.indeterminate,
        progress = _this$props2.progress,
        trackColor = _this$props2.trackColor,
        style = _this$props2.style,
        other = ProgressBar_objectWithoutPropertiesLoose(_this$props2, ["color", "indeterminate", "progress", "trackColor", "style"]);

    var percentageProgress = progress * 100;
    return external_react_default.a.createElement(exports_View, ProgressBar_extends({}, other, {
      accessibilityRole: "progressbar",
      "aria-valuemax": "100",
      "aria-valuemin": "0",
      "aria-valuenow": indeterminate ? null : percentageProgress,
      style: [ProgressBar_styles.track, style, {
        backgroundColor: trackColor
      }]
    }), external_react_default.a.createElement(exports_View, {
      ref: this._setProgressRef,
      style: [ProgressBar_styles.progress, indeterminate && ProgressBar_styles.animation, {
        backgroundColor: color
      }]
    }));
  };

  return ProgressBar;
}(external_react_["Component"]);

ProgressBar_ProgressBar.displayName = 'ProgressBar';
ProgressBar_ProgressBar.defaultProps = {
  color: '#1976D2',
  indeterminate: false,
  progress: 0,
  trackColor: 'transparent'
};
ProgressBar_ProgressBar.propTypes =  false ? undefined : {};
var ProgressBar_styles = exports_StyleSheet.create({
  track: {
    height: 5,
    overflow: 'hidden',
    userSelect: 'none',
    zIndex: 0
  },
  progress: {
    height: '100%',
    zIndex: -1
  },
  animation: {
    animationDuration: '1s',
    animationKeyframes: [{
      '0%': {
        transform: [{
          translateX: '-100%'
        }]
      },
      '100%': {
        transform: [{
          translateX: '400%'
        }]
      }
    }],
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite'
  }
});
/* harmony default export */ var exports_ProgressBar = (modules_applyNativeMethods(ProgressBar_ProgressBar));
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/SafeAreaView/index.js
function SafeAreaView_extends() { SafeAreaView_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return SafeAreaView_extends.apply(this, arguments); }

function SafeAreaView_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */




var SafeAreaView = external_react_default.a.forwardRef(function (props, ref) {
  var style = props.style,
      rest = SafeAreaView_objectWithoutPropertiesLoose(props, ["style"]);

  return external_react_default.a.createElement(exports_View, SafeAreaView_extends({}, rest, {
    ref: ref,
    style: exports_StyleSheet.compose(SafeAreaView_styles.root, style)
  }));
});
SafeAreaView.displayName = 'SafeAreaView';

var cssFunction = function () {
  if (ExecutionEnvironment["canUseDOM"] && window.CSS && window.CSS.supports && window.CSS.supports('top: constant(safe-area-inset-top)')) {
    return 'constant';
  }

  return 'env';
}();

var SafeAreaView_styles = exports_StyleSheet.create({
  root: {
    paddingTop: cssFunction + "(safe-area-inset-top)",
    paddingRight: cssFunction + "(safe-area-inset-right)",
    paddingBottom: cssFunction + "(safe-area-inset-bottom)",
    paddingLeft: cssFunction + "(safe-area-inset-left)"
  }
});
/* harmony default export */ var exports_SafeAreaView = (SafeAreaView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/VirtualizedSectionList/index.js
function VirtualizedSectionList_extends() { VirtualizedSectionList_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return VirtualizedSectionList_extends.apply(this, arguments); }

function VirtualizedSectionList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { VirtualizedSectionList_defineProperty(target, key, source[key]); }); } return target; }

function VirtualizedSectionList_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function VirtualizedSectionList_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function VirtualizedSectionList_assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */





/**
 * Right now this just flattens everything into one list and uses VirtualizedList under the
 * hood. The only operation that might not scale well is concatting the data arrays of all the
 * sections when new props are received, which should be plenty fast for up to ~10,000 items.
 */
var VirtualizedSectionList_VirtualizedSectionList =
/*#__PURE__*/
function (_React$PureComponent) {
  VirtualizedSectionList_inheritsLoose(VirtualizedSectionList, _React$PureComponent);

  var _proto = VirtualizedSectionList.prototype;

  _proto.scrollToLocation = function scrollToLocation(params) {
    var index = params.itemIndex + 1;

    for (var ii = 0; ii < params.sectionIndex; ii++) {
      index += this.props.sections[ii].data.length + 2;
    }

    var toIndexParams = VirtualizedSectionList_objectSpread({}, params, {
      index: index
    });

    this._listRef.scrollToIndex(toIndexParams);
  };

  _proto.getListRef = function getListRef() {
    return this._listRef;
  };

  _proto._subExtractor = function _subExtractor(index) {
    var itemIndex = index;
    var defaultKeyExtractor = this.props.keyExtractor;

    for (var ii = 0; ii < this.props.sections.length; ii++) {
      var section = this.props.sections[ii];
      var key = section.key || String(ii);
      itemIndex -= 1; // The section adds an item for the header

      if (itemIndex >= section.data.length + 1) {
        itemIndex -= section.data.length + 1; // The section adds an item for the footer.
      } else if (itemIndex === -1) {
        return {
          section: section,
          key: key + ':header',
          index: null,
          header: true,
          trailingSection: this.props.sections[ii + 1]
        };
      } else if (itemIndex === section.data.length) {
        return {
          section: section,
          key: key + ':footer',
          index: null,
          header: false,
          trailingSection: this.props.sections[ii + 1]
        };
      } else {
        var keyExtractor = section.keyExtractor || defaultKeyExtractor;
        return {
          section: section,
          key: key + ':' + keyExtractor(section.data[itemIndex], itemIndex),
          index: itemIndex,
          leadingItem: section.data[itemIndex - 1],
          leadingSection: this.props.sections[ii - 1],
          trailingItem: section.data[itemIndex + 1],
          trailingSection: this.props.sections[ii + 1]
        };
      }
    }
  };

  _proto._getSeparatorComponent = function _getSeparatorComponent(index, info) {
    info = info || this._subExtractor(index);

    if (!info) {
      return null;
    }

    var ItemSeparatorComponent = info.section.ItemSeparatorComponent || this.props.ItemSeparatorComponent;
    var SectionSeparatorComponent = this.props.SectionSeparatorComponent;
    var isLastItemInList = index === this.state.childProps.getItemCount() - 1;
    var isLastItemInSection = info.index === info.section.data.length - 1;

    if (SectionSeparatorComponent && isLastItemInSection) {
      return SectionSeparatorComponent;
    }

    if (ItemSeparatorComponent && !isLastItemInSection && !isLastItemInList) {
      return ItemSeparatorComponent;
    }

    return null;
  };

  _proto._computeState = function _computeState(props) {
    var offset = props.ListHeaderComponent ? 1 : 0;
    var stickyHeaderIndices = [];
    var itemCount = props.sections.reduce(function (v, section) {
      stickyHeaderIndices.push(v + offset);
      return v + section.data.length + 2; // Add two for the section header and footer.
    }, 0);
    return {
      childProps: VirtualizedSectionList_objectSpread({}, props, {
        renderItem: this._renderItem,
        ItemSeparatorComponent: undefined,
        // Rendered with renderItem
        data: props.sections,
        getItemCount: function getItemCount() {
          return itemCount;
        },
        getItem: VirtualizedSectionList_getItem,
        keyExtractor: this._keyExtractor,
        onViewableItemsChanged: props.onViewableItemsChanged ? this._onViewableItemsChanged : undefined,
        stickyHeaderIndices: props.stickySectionHeadersEnabled ? stickyHeaderIndices : undefined
      })
    };
  };

  function VirtualizedSectionList(props, context) {
    var _this;

    _this = _React$PureComponent.call(this, props, context) || this;

    _this._keyExtractor = function (item, index) {
      var info = _this._subExtractor(index);

      return info && info.key || String(index);
    };

    _this._convertViewable = function (viewable) {
      invariant_default()(viewable.index != null, 'Received a broken ViewToken');

      var info = _this._subExtractor(viewable.index);

      if (!info) {
        return null;
      }

      var keyExtractor = info.section.keyExtractor || _this.props.keyExtractor;
      return VirtualizedSectionList_objectSpread({}, viewable, {
        index: info.index,

        /* $FlowFixMe(>=0.63.0 site=react_native_fb) This comment suppresses an
         * error found when Flow v0.63 was deployed. To see the error delete this
         * comment and run Flow. */
        key: keyExtractor(viewable.item, info.index),
        section: info.section
      });
    };

    _this._onViewableItemsChanged = function (_ref) {
      var viewableItems = _ref.viewableItems,
          changed = _ref.changed;

      if (_this.props.onViewableItemsChanged) {
        _this.props.onViewableItemsChanged({
          viewableItems: viewableItems.map(_this._convertViewable, VirtualizedSectionList_assertThisInitialized(VirtualizedSectionList_assertThisInitialized(_this))).filter(Boolean),
          changed: changed.map(_this._convertViewable, VirtualizedSectionList_assertThisInitialized(VirtualizedSectionList_assertThisInitialized(_this))).filter(Boolean)
        });
      }
    };

    _this._renderItem = function (_ref2) {
      var item = _ref2.item,
          index = _ref2.index;

      var info = _this._subExtractor(index);

      if (!info) {
        return null;
      }

      var infoIndex = info.index;

      if (infoIndex == null) {
        var section = info.section;

        if (info.header === true) {
          var renderSectionHeader = _this.props.renderSectionHeader;
          return renderSectionHeader ? renderSectionHeader({
            section: section
          }) : null;
        } else {
          var renderSectionFooter = _this.props.renderSectionFooter;
          return renderSectionFooter ? renderSectionFooter({
            section: section
          }) : null;
        }
      } else {
        var renderItem = info.section.renderItem || _this.props.renderItem;

        var SeparatorComponent = _this._getSeparatorComponent(index, info);

        invariant_default()(renderItem, 'no renderItem!');
        return external_react_default.a.createElement(VirtualizedSectionList_ItemWithSeparator, {
          SeparatorComponent: SeparatorComponent,
          LeadingSeparatorComponent: infoIndex === 0 ? _this.props.SectionSeparatorComponent : undefined,
          cellKey: info.key,
          index: infoIndex,
          item: item,
          leadingItem: info.leadingItem,
          leadingSection: info.leadingSection,
          onUpdateSeparator: _this._onUpdateSeparator,
          prevCellKey: (_this._subExtractor(index - 1) || {}).key,
          ref: function ref(_ref3) {
            _this._cellRefs[info.key] = _ref3;
          },
          renderItem: renderItem,
          section: info.section,
          trailingItem: info.trailingItem,
          trailingSection: info.trailingSection
        });
      }
    };

    _this._onUpdateSeparator = function (key, newProps) {
      var ref = _this._cellRefs[key];
      ref && ref.updateSeparatorProps(newProps);
    };

    _this._cellRefs = {};

    _this._captureRef = function (ref) {
      /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
       * suppresses an error when upgrading Flow's support for React. To see the
       * error delete this comment and run Flow. */
      _this._listRef = ref;
    };

    _this.state = _this._computeState(props);
    return _this;
  }

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState(this._computeState(nextProps));
  };

  _proto.render = function render() {
    return external_react_default.a.createElement(react_native_VirtualizedList, VirtualizedSectionList_extends({}, this.state.childProps, {
      ref: this._captureRef
    }));
  };

  return VirtualizedSectionList;
}(external_react_default.a.PureComponent);

VirtualizedSectionList_VirtualizedSectionList.defaultProps = VirtualizedSectionList_objectSpread({}, react_native_VirtualizedList.defaultProps, {
  data: []
});

var VirtualizedSectionList_ItemWithSeparator =
/*#__PURE__*/
function (_React$Component) {
  VirtualizedSectionList_inheritsLoose(ItemWithSeparator, _React$Component);

  function ItemWithSeparator() {
    var _this2;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this2 = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this2.state = {
      separatorProps: {
        highlighted: false,
        leadingItem: _this2.props.item,
        leadingSection: _this2.props.leadingSection,
        section: _this2.props.section,
        trailingItem: _this2.props.trailingItem,
        trailingSection: _this2.props.trailingSection
      },
      leadingSeparatorProps: {
        highlighted: false,
        leadingItem: _this2.props.leadingItem,
        leadingSection: _this2.props.leadingSection,
        section: _this2.props.section,
        trailingItem: _this2.props.item,
        trailingSection: _this2.props.trailingSection
      }
    };
    _this2._separators = {
      highlight: function highlight() {
        ['leading', 'trailing'].forEach(function (s) {
          return _this2._separators.updateProps(s, {
            highlighted: true
          });
        });
      },
      unhighlight: function unhighlight() {
        ['leading', 'trailing'].forEach(function (s) {
          return _this2._separators.updateProps(s, {
            highlighted: false
          });
        });
      },
      updateProps: function updateProps(select, newProps) {
        var _this2$props = _this2.props,
            LeadingSeparatorComponent = _this2$props.LeadingSeparatorComponent,
            cellKey = _this2$props.cellKey,
            prevCellKey = _this2$props.prevCellKey;

        if (select === 'leading' && LeadingSeparatorComponent) {
          _this2.setState(function (state) {
            return {
              leadingSeparatorProps: VirtualizedSectionList_objectSpread({}, state.leadingSeparatorProps, newProps)
            };
          });
        } else {
          _this2.props.onUpdateSeparator(select === 'leading' && prevCellKey || cellKey, newProps);
        }
      }
    };
    return _this2;
  }

  var _proto2 = ItemWithSeparator.prototype;

  _proto2.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(props) {
    var _this3 = this;

    this.setState(function (state) {
      return {
        separatorProps: VirtualizedSectionList_objectSpread({}, _this3.state.separatorProps, {
          leadingItem: props.item,
          leadingSection: props.leadingSection,
          section: props.section,
          trailingItem: props.trailingItem,
          trailingSection: props.trailingSection
        }),
        leadingSeparatorProps: VirtualizedSectionList_objectSpread({}, _this3.state.leadingSeparatorProps, {
          leadingItem: props.leadingItem,
          leadingSection: props.leadingSection,
          section: props.section,
          trailingItem: props.item,
          trailingSection: props.trailingSection
        })
      };
    });
  };

  _proto2.updateSeparatorProps = function updateSeparatorProps(newProps) {
    this.setState(function (state) {
      return {
        separatorProps: VirtualizedSectionList_objectSpread({}, state.separatorProps, newProps)
      };
    });
  };

  _proto2.render = function render() {
    var _this$props = this.props,
        LeadingSeparatorComponent = _this$props.LeadingSeparatorComponent,
        SeparatorComponent = _this$props.SeparatorComponent,
        item = _this$props.item,
        index = _this$props.index,
        section = _this$props.section;
    var element = this.props.renderItem({
      item: item,
      index: index,
      section: section,
      separators: this._separators
    });
    var leadingSeparator = LeadingSeparatorComponent && external_react_default.a.createElement(LeadingSeparatorComponent, this.state.leadingSeparatorProps);
    var separator = SeparatorComponent && external_react_default.a.createElement(SeparatorComponent, this.state.separatorProps);
    return leadingSeparator || separator ? external_react_default.a.createElement(exports_View, null, leadingSeparator, element, separator) : element;
  };

  return ItemWithSeparator;
}(external_react_default.a.Component);

function VirtualizedSectionList_getItem(sections, index) {
  if (!sections) {
    return null;
  }

  var itemIdx = index - 1;

  for (var ii = 0; ii < sections.length; ii++) {
    if (itemIdx === -1 || itemIdx === sections[ii].data.length) {
      // We intend for there to be overflow by one on both ends of the list.
      // This will be for headers and footers. When returning a header or footer
      // item the section itself is the item.
      return sections[ii];
    } else if (itemIdx < sections[ii].data.length) {
      // If we are in the bounds of the list's data then return the item.
      return sections[ii].data[itemIdx];
    } else {
      itemIdx -= sections[ii].data.length + 2; // Add two for the header and footer
    }
  }

  return null;
}

/* harmony default export */ var react_native_VirtualizedSectionList = (VirtualizedSectionList_VirtualizedSectionList);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/SectionList/index.js
function SectionList_extends() { SectionList_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return SectionList_extends.apply(this, arguments); }

function SectionList_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

function SectionList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { SectionList_defineProperty(target, key, source[key]); }); } return target; }

function SectionList_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */






var SectionList_defaultProps = SectionList_objectSpread({}, react_native_VirtualizedSectionList.defaultProps, {
  stickySectionHeadersEnabled: exports_Platform.OS === 'ios'
});

/**
 * A performant interface for rendering sectioned lists, supporting the most handy features:
 *
 *  - Fully cross-platform.
 *  - Configurable viewability callbacks.
 *  - List header support.
 *  - List footer support.
 *  - Item separator support.
 *  - Section header support.
 *  - Section separator support.
 *  - Heterogeneous data and item rendering support.
 *  - Pull to Refresh.
 *  - Scroll loading.
 *
 * If you don't need section support and want a simpler interface, use
 * [`<FlatList>`](/react-native/docs/flatlist.html).
 *
 * Simple Examples:
 *
 *     <SectionList
 *       renderItem={({item}) => <ListItem title={item} />}
 *       renderSectionHeader={({section}) => <Header title={section.title} />}
 *       sections={[ // homogeneous rendering between sections
 *         {data: [...], title: ...},
 *         {data: [...], title: ...},
 *         {data: [...], title: ...},
 *       ]}
 *     />
 *
 *     <SectionList
 *       sections={[ // heterogeneous rendering between sections
 *         {data: [...], renderItem: ...},
 *         {data: [...], renderItem: ...},
 *         {data: [...], renderItem: ...},
 *       ]}
 *     />
 *
 * This is a convenience wrapper around [`<VirtualizedList>`](docs/virtualizedlist.html),
 * and thus inherits its props (as well as those of `ScrollView`) that aren't explicitly listed
 * here, along with the following caveats:
 *
 * - Internal state is not preserved when content scrolls out of the render window. Make sure all
 *   your data is captured in the item data or external stores like Flux, Redux, or Relay.
 * - This is a `PureComponent` which means that it will not re-render if `props` remain shallow-
 *   equal. Make sure that everything your `renderItem` function depends on is passed as a prop
 *   (e.g. `extraData`) that is not `===` after updates, otherwise your UI may not update on
 *   changes. This includes the `data` prop and parent component state.
 * - In order to constrain memory and enable smooth scrolling, content is rendered asynchronously
 *   offscreen. This means it's possible to scroll faster than the fill rate and momentarily see
 *   blank content. This is a tradeoff that can be adjusted to suit the needs of each application,
 *   and we are working on improving it behind the scenes.
 * - By default, the list looks for a `key` prop on each item and uses that for the React key.
 *   Alternatively, you can provide a custom `keyExtractor` prop.
 *
 */
var SectionList_SectionList =
/*#__PURE__*/
function (_React$PureComponent) {
  SectionList_inheritsLoose(SectionList, _React$PureComponent);

  function SectionList() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$PureComponent.call.apply(_React$PureComponent, [this].concat(args)) || this;

    _this._captureRef = function (ref) {
      /* $FlowFixMe(>=0.53.0 site=react_native_fb,react_native_oss) This comment
       * suppresses an error when upgrading Flow's support for React. To see the
       * error delete this comment and run Flow. */
      _this._wrapperListRef = ref;
    };

    return _this;
  }

  var _proto = SectionList.prototype;

  /**
   * Scrolls to the item at the specified `sectionIndex` and `itemIndex` (within the section)
   * positioned in the viewable area such that `viewPosition` 0 places it at the top (and may be
   * covered by a sticky header), 1 at the bottom, and 0.5 centered in the middle. `viewOffset` is a
   * fixed number of pixels to offset the final target position, e.g. to compensate for sticky
   * headers.
   *
   * Note: cannot scroll to locations outside the render window without specifying the
   * `getItemLayout` prop.
   */
  _proto.scrollToLocation = function scrollToLocation(params) {
    this._wrapperListRef.scrollToLocation(params);
  }
  /**
   * Tells the list an interaction has occurred, which should trigger viewability calculations, e.g.
   * if `waitForInteractions` is true and the user has not scrolled. This is typically called by
   * taps on items or by navigation actions.
   */
  ;

  _proto.recordInteraction = function recordInteraction() {
    var listRef = this._wrapperListRef && this._wrapperListRef.getListRef();

    listRef && listRef.recordInteraction();
  }
  /**
   * Displays the scroll indicators momentarily.
   *
   * @platform ios
   */
  ;

  _proto.flashScrollIndicators = function flashScrollIndicators() {
    var listRef = this._wrapperListRef && this._wrapperListRef.getListRef();

    listRef && listRef.flashScrollIndicators();
  }
  /**
   * Provides a handle to the underlying scroll responder.
   */
  ;

  _proto.getScrollResponder = function getScrollResponder() {
    var listRef = this._wrapperListRef && this._wrapperListRef.getListRef();

    if (listRef) {
      return listRef.getScrollResponder();
    }
  };

  _proto.getScrollableNode = function getScrollableNode() {
    var listRef = this._wrapperListRef && this._wrapperListRef.getListRef();

    if (listRef) {
      return listRef.getScrollableNode();
    }
  };

  _proto.setNativeProps = function setNativeProps(props) {
    var listRef = this._wrapperListRef && this._wrapperListRef.getListRef();

    if (listRef) {
      listRef.setNativeProps(props);
    }
  };

  _proto.render = function render() {
    var List = this.props.legacyImplementation ? modules_UnimplementedView : react_native_VirtualizedSectionList;
    /* $FlowFixMe(>=0.66.0 site=react_native_fb) This comment suppresses an
     * error found when Flow v0.66 was deployed. To see the error delete this
     * comment and run Flow. */

    return external_react_default.a.createElement(List, SectionList_extends({}, this.props, {
      ref: this._captureRef
    }));
  };

  return SectionList;
}(external_react_default.a.PureComponent);

SectionList_SectionList.defaultProps = SectionList_defaultProps;
/* harmony default export */ var react_native_SectionList = (SectionList_SectionList);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/SectionList/index.js
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var exports_SectionList = (react_native_SectionList);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Slider/index.js

/* harmony default export */ var Slider = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StatusBar/index.js
function StatusBar_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var StatusBar =
/*#__PURE__*/
function (_Component) {
  StatusBar_inheritsLoose(StatusBar, _Component);

  function StatusBar() {
    return _Component.apply(this, arguments) || this;
  }

  StatusBar.setBackgroundColor = function setBackgroundColor() {};

  StatusBar.setBarStyle = function setBarStyle() {};

  StatusBar.setHidden = function setHidden() {};

  StatusBar.setNetworkActivityIndicatorVisible = function setNetworkActivityIndicatorVisible() {};

  StatusBar.setTranslucent = function setTranslucent() {};

  var _proto = StatusBar.prototype;

  _proto.render = function render() {
    return null;
  };

  return StatusBar;
}(external_react_["Component"]);


// EXTERNAL MODULE: ./node_modules/react-native-web/node_modules/fbjs/lib/emptyFunction.js
var lib_emptyFunction = __webpack_require__(26);
var emptyFunction_default = /*#__PURE__*/__webpack_require__.n(lib_emptyFunction);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/SwipeableRow/index.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule SwipeableRow
 * 
 */








/* $FlowFixMe(>=0.54.0 site=react_native_oss) This comment suppresses an error
 * found when Flow v0.54 was deployed. To see the error delete this comment and
 * run Flow. */






var SwipeableRow_isRTL = function isRTL() {
  return exports_I18nManager.isRTL;
}; // NOTE: Eventually convert these consts to an input object of configurations
// Position of the left of the swipable item when closed


var CLOSED_LEFT_POSITION = 0; // Minimum swipe distance before we recognize it as such

var HORIZONTAL_SWIPE_DISTANCE_THRESHOLD = 10; // Minimum swipe speed before we fully animate the user's action (open/close)

var HORIZONTAL_FULL_SWIPE_SPEED_THRESHOLD = 0.3; // Factor to divide by to get slow speed; i.e. 4 means 1/4 of full speed

var SLOW_SPEED_SWIPE_FACTOR = 4; // Time, in milliseconds, of how long the animated swipe should be

var SWIPE_DURATION = 300;
/**
 * On SwipeableListView mount, the 1st item will bounce to show users it's
 * possible to swipe
 */

var ON_MOUNT_BOUNCE_DELAY = 700;
var ON_MOUNT_BOUNCE_DURATION = 400; // Distance left of closed position to bounce back when right-swiping from closed

var RIGHT_SWIPE_BOUNCE_BACK_DISTANCE = 30;
var RIGHT_SWIPE_BOUNCE_BACK_DURATION = 300;
/**
 * Max distance of right swipe to allow (right swipes do functionally nothing).
 * Must be multiplied by SLOW_SPEED_SWIPE_FACTOR because gestureState.dx tracks
 * how far the finger swipes, and not the actual animation distance.
*/

var RIGHT_SWIPE_THRESHOLD = 30 * SLOW_SPEED_SWIPE_FACTOR;
/**
 * Creates a swipable row that allows taps on the main item and a custom View
 * on the item hidden behind the row. Typically this should be used in
 * conjunction with SwipeableListView for additional functionality, but can be
 * used in a normal ListView. See the renderRow for SwipeableListView to see how
 * to use this component separately.
 */

var SwipeableRow = create_react_class_default()({
  displayName: 'SwipeableRow',
  _panResponder: {},
  _previousLeft: CLOSED_LEFT_POSITION,
  mixins: [TimerMixin_default.a],
  propTypes: {
    children: external_prop_types_default.a.any,
    isOpen: external_prop_types_default.a.bool,
    preventSwipeRight: external_prop_types_default.a.bool,
    maxSwipeDistance: external_prop_types_default.a.number.isRequired,
    onOpen: external_prop_types_default.a.func.isRequired,
    onClose: external_prop_types_default.a.func.isRequired,
    onSwipeEnd: external_prop_types_default.a.func.isRequired,
    onSwipeStart: external_prop_types_default.a.func.isRequired,
    // Should bounce the row on mount
    shouldBounceOnMount: external_prop_types_default.a.bool,

    /**
     * A ReactElement that is unveiled when the user swipes
     */
    slideoutView: external_prop_types_default.a.node.isRequired,

    /**
     * The minimum swipe distance required before fully animating the swipe. If
     * the user swipes less than this distance, the item will return to its
     * previous (open/close) position.
     */
    swipeThreshold: external_prop_types_default.a.number.isRequired
  },
  getInitialState: function getInitialState() {
    return {
      currentLeft: new exports_Animated.Value(this._previousLeft),

      /**
       * In order to render component A beneath component B, A must be rendered
       * before B. However, this will cause "flickering", aka we see A briefly
       * then B. To counter this, _isSwipeableViewRendered flag is used to set
       * component A to be transparent until component B is loaded.
       */
      isSwipeableViewRendered: false,
      rowHeight: null
    };
  },
  getDefaultProps: function getDefaultProps() {
    return {
      isOpen: false,
      preventSwipeRight: false,
      maxSwipeDistance: 0,
      onOpen: emptyFunction_default.a,
      onClose: emptyFunction_default.a,
      onSwipeEnd: emptyFunction_default.a,
      onSwipeStart: emptyFunction_default.a,
      swipeThreshold: 30
    };
  },
  UNSAFE_componentWillMount: function UNSAFE_componentWillMount() {
    this._panResponder = exports_PanResponder.create({
      onMoveShouldSetPanResponderCapture: this._handleMoveShouldSetPanResponderCapture,
      onPanResponderGrant: this._handlePanResponderGrant,
      onPanResponderMove: this._handlePanResponderMove,
      onPanResponderRelease: this._handlePanResponderEnd,
      onPanResponderTerminationRequest: this._onPanResponderTerminationRequest,
      onPanResponderTerminate: this._handlePanResponderEnd,
      onShouldBlockNativeResponder: function onShouldBlockNativeResponder(event, gestureState) {
        return false;
      }
    });
  },
  componentDidMount: function componentDidMount() {
    var _this = this;

    if (this.props.shouldBounceOnMount) {
      /**
       * Do the on mount bounce after a delay because if we animate when other
       * components are loading, the animation will be laggy
       */
      this.setTimeout(function () {
        _this._animateBounceBack(ON_MOUNT_BOUNCE_DURATION);
      }, ON_MOUNT_BOUNCE_DELAY);
    }
  },
  UNSAFE_componentWillReceiveProps: function UNSAFE_componentWillReceiveProps(nextProps) {
    /**
     * We do not need an "animateOpen(noCallback)" because this animation is
     * handled internally by this component.
     */
    if (this.props.isOpen && !nextProps.isOpen) {
      this._animateToClosedPosition();
    }
  },
  render: function render() {
    // The view hidden behind the main view
    var slideOutView;

    if (this.state.isSwipeableViewRendered && this.state.rowHeight) {
      slideOutView = external_react_default.a.createElement(exports_View, {
        style: [SwipeableRow_styles.slideOutContainer, {
          height: this.state.rowHeight
        }]
      }, this.props.slideoutView);
    } // The swipeable item


    var swipeableView = external_react_default.a.createElement(exports_Animated.View, {
      onLayout: this._onSwipeableViewLayout,
      style: {
        transform: [{
          translateX: this.state.currentLeft
        }]
      }
    }, this.props.children);
    return external_react_default.a.createElement(exports_View, this._panResponder.panHandlers, slideOutView, swipeableView);
  },
  close: function close() {
    this.props.onClose();

    this._animateToClosedPosition();
  },
  _onSwipeableViewLayout: function _onSwipeableViewLayout(event) {
    this.setState({
      isSwipeableViewRendered: true,
      rowHeight: event.nativeEvent.layout.height
    });
  },
  _handleMoveShouldSetPanResponderCapture: function _handleMoveShouldSetPanResponderCapture(event, gestureState) {
    // Decides whether a swipe is responded to by this component or its child
    return gestureState.dy < 10 && this._isValidSwipe(gestureState);
  },
  _handlePanResponderGrant: function _handlePanResponderGrant(event, gestureState) {},
  _handlePanResponderMove: function _handlePanResponderMove(event, gestureState) {
    if (this._isSwipingExcessivelyRightFromClosedPosition(gestureState)) {
      return;
    }

    this.props.onSwipeStart();

    if (this._isSwipingRightFromClosed(gestureState)) {
      this._swipeSlowSpeed(gestureState);
    } else {
      this._swipeFullSpeed(gestureState);
    }
  },
  _isSwipingRightFromClosed: function _isSwipingRightFromClosed(gestureState) {
    var gestureStateDx = SwipeableRow_isRTL() ? -gestureState.dx : gestureState.dx;
    return this._previousLeft === CLOSED_LEFT_POSITION && gestureStateDx > 0;
  },
  _swipeFullSpeed: function _swipeFullSpeed(gestureState) {
    this.state.currentLeft.setValue(this._previousLeft + gestureState.dx);
  },
  _swipeSlowSpeed: function _swipeSlowSpeed(gestureState) {
    this.state.currentLeft.setValue(this._previousLeft + gestureState.dx / SLOW_SPEED_SWIPE_FACTOR);
  },
  _isSwipingExcessivelyRightFromClosedPosition: function _isSwipingExcessivelyRightFromClosedPosition(gestureState) {
    /**
     * We want to allow a BIT of right swipe, to allow users to know that
     * swiping is available, but swiping right does not do anything
     * functionally.
     */
    var gestureStateDx = SwipeableRow_isRTL() ? -gestureState.dx : gestureState.dx;
    return this._isSwipingRightFromClosed(gestureState) && gestureStateDx > RIGHT_SWIPE_THRESHOLD;
  },
  _onPanResponderTerminationRequest: function _onPanResponderTerminationRequest(event, gestureState) {
    return false;
  },
  _animateTo: function _animateTo(toValue, duration, callback) {
    var _this2 = this;

    if (duration === void 0) {
      duration = SWIPE_DURATION;
    }

    if (callback === void 0) {
      callback = emptyFunction_default.a;
    }

    exports_Animated.timing(this.state.currentLeft, {
      duration: duration,
      toValue: toValue,
      useNativeDriver: true
    }).start(function () {
      _this2._previousLeft = toValue;
      callback();
    });
  },
  _animateToOpenPosition: function _animateToOpenPosition() {
    var maxSwipeDistance = SwipeableRow_isRTL() ? -this.props.maxSwipeDistance : this.props.maxSwipeDistance;

    this._animateTo(-maxSwipeDistance);
  },
  _animateToOpenPositionWith: function _animateToOpenPositionWith(speed, distMoved) {
    /**
     * Ensure the speed is at least the set speed threshold to prevent a slow
     * swiping animation
     */
    speed = speed > HORIZONTAL_FULL_SWIPE_SPEED_THRESHOLD ? speed : HORIZONTAL_FULL_SWIPE_SPEED_THRESHOLD;
    /**
     * Calculate the duration the row should take to swipe the remaining distance
     * at the same speed the user swiped (or the speed threshold)
     */

    var duration = Math.abs((this.props.maxSwipeDistance - Math.abs(distMoved)) / speed);
    var maxSwipeDistance = SwipeableRow_isRTL() ? -this.props.maxSwipeDistance : this.props.maxSwipeDistance;

    this._animateTo(-maxSwipeDistance, duration);
  },
  _animateToClosedPosition: function _animateToClosedPosition(duration) {
    if (duration === void 0) {
      duration = SWIPE_DURATION;
    }

    this._animateTo(CLOSED_LEFT_POSITION, duration);
  },
  _animateToClosedPositionDuringBounce: function _animateToClosedPositionDuringBounce() {
    this._animateToClosedPosition(RIGHT_SWIPE_BOUNCE_BACK_DURATION);
  },
  _animateBounceBack: function _animateBounceBack(duration) {
    /**
     * When swiping right, we want to bounce back past closed position on release
     * so users know they should swipe right to get content.
     */
    var swipeBounceBackDistance = SwipeableRow_isRTL() ? -RIGHT_SWIPE_BOUNCE_BACK_DISTANCE : RIGHT_SWIPE_BOUNCE_BACK_DISTANCE;

    this._animateTo(-swipeBounceBackDistance, duration, this._animateToClosedPositionDuringBounce);
  },
  // Ignore swipes due to user's finger moving slightly when tapping
  _isValidSwipe: function _isValidSwipe(gestureState) {
    if (this.props.preventSwipeRight && this._previousLeft === CLOSED_LEFT_POSITION && gestureState.dx > 0) {
      return false;
    }

    return Math.abs(gestureState.dx) > HORIZONTAL_SWIPE_DISTANCE_THRESHOLD;
  },
  _shouldAnimateRemainder: function _shouldAnimateRemainder(gestureState) {
    /**
     * If user has swiped past a certain distance, animate the rest of the way
     * if they let go
     */
    return Math.abs(gestureState.dx) > this.props.swipeThreshold || gestureState.vx > HORIZONTAL_FULL_SWIPE_SPEED_THRESHOLD;
  },
  _handlePanResponderEnd: function _handlePanResponderEnd(event, gestureState) {
    var horizontalDistance = SwipeableRow_isRTL() ? -gestureState.dx : gestureState.dx;

    if (this._isSwipingRightFromClosed(gestureState)) {
      this.props.onOpen();

      this._animateBounceBack(RIGHT_SWIPE_BOUNCE_BACK_DURATION);
    } else if (this._shouldAnimateRemainder(gestureState)) {
      if (horizontalDistance < 0) {
        // Swiped left
        this.props.onOpen();

        this._animateToOpenPositionWith(gestureState.vx, horizontalDistance);
      } else {
        // Swiped right
        this.props.onClose();

        this._animateToClosedPosition();
      }
    } else {
      if (this._previousLeft === CLOSED_LEFT_POSITION) {
        this._animateToClosedPosition();
      } else {
        this._animateToOpenPosition();
      }
    }

    this.props.onSwipeEnd();
  }
});
var SwipeableRow_styles = exports_StyleSheet.create({
  slideOutContainer: {
    bottom: 0,
    left: 0,
    position: 'absolute',
    right: 0,
    top: 0
  }
});
/* harmony default export */ var react_native_SwipeableRow = (SwipeableRow);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/SwipeableFlatList/index.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule SwipeableFlatList
 * 
 * @format
 */


function SwipeableFlatList_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { SwipeableFlatList_defineProperty(target, key, source[key]); }); } return target; }

function SwipeableFlatList_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function SwipeableFlatList_extends() { SwipeableFlatList_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return SwipeableFlatList_extends.apply(this, arguments); }

function SwipeableFlatList_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }






/**
 * A container component that renders multiple SwipeableRow's in a FlatList
 * implementation. This is designed to be a drop-in replacement for the
 * standard React Native `FlatList`, so use it as if it were a FlatList, but
 * with extra props, i.e.
 *
 * <SwipeableListView renderRow={..} renderQuickActions={..} {..FlatList props} />
 *
 * SwipeableRow can be used independently of this component, but the main
 * benefit of using this component is
 *
 * - It ensures that at most 1 row is swiped open (auto closes others)
 * - It can bounce the 1st row of the list so users know it's swipeable
 * - Increase performance on iOS by locking list swiping when row swiping is occurring
 * - More to come
 */
var SwipeableFlatList_SwipeableFlatList =
/*#__PURE__*/
function (_React$Component) {
  SwipeableFlatList_inheritsLoose(SwipeableFlatList, _React$Component);

  function SwipeableFlatList(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this._flatListRef = null;
    _this._shouldBounceFirstRowOnMount = false;

    _this._onScroll = function (e) {
      // Close any opens rows on ListView scroll
      if (_this.state.openRowKey) {
        _this.setState({
          openRowKey: null
        });
      }

      _this.props.onScroll && _this.props.onScroll(e);
    };

    _this._renderItem = function (info) {
      var slideoutView = _this.props.renderQuickActions(info);

      var key = _this.props.keyExtractor(info.item, info.index); // If renderQuickActions is unspecified or returns falsey, don't allow swipe


      if (!slideoutView) {
        return _this.props.renderItem(info);
      }

      var shouldBounceOnMount = false;

      if (_this._shouldBounceFirstRowOnMount) {
        _this._shouldBounceFirstRowOnMount = false;
        shouldBounceOnMount = true;
      }

      return external_react_default.a.createElement(react_native_SwipeableRow, {
        slideoutView: slideoutView,
        isOpen: key === _this.state.openRowKey,
        maxSwipeDistance: _this._getMaxSwipeDistance(info),
        onOpen: function onOpen() {
          return _this._onOpen(key);
        },
        onClose: function onClose() {
          return _this._onClose(key);
        },
        shouldBounceOnMount: shouldBounceOnMount,
        onSwipeEnd: _this._setListViewScrollable,
        onSwipeStart: _this._setListViewNotScrollable
      }, _this.props.renderItem(info));
    };

    _this._setListViewScrollable = function () {
      _this._setListViewScrollableTo(true);
    };

    _this._setListViewNotScrollable = function () {
      _this._setListViewScrollableTo(false);
    };

    _this.state = {
      openRowKey: null
    };
    _this._shouldBounceFirstRowOnMount = _this.props.bounceFirstRowOnMount;
    return _this;
  }

  var _proto = SwipeableFlatList.prototype;

  _proto.render = function render() {
    var _this2 = this;

    return external_react_default.a.createElement(react_native_FlatList, SwipeableFlatList_extends({}, this.props, {
      ref: function ref(_ref) {
        _this2._flatListRef = _ref;
      },
      onScroll: this._onScroll,
      renderItem: this._renderItem
    }));
  };

  // This enables rows having variable width slideoutView.
  _proto._getMaxSwipeDistance = function _getMaxSwipeDistance(info) {
    if (typeof this.props.maxSwipeDistance === 'function') {
      return this.props.maxSwipeDistance(info);
    }

    return this.props.maxSwipeDistance;
  };

  _proto._setListViewScrollableTo = function _setListViewScrollableTo(value) {
    if (this._flatListRef) {
      this._flatListRef.setNativeProps({
        scrollEnabled: value
      });
    }
  };

  _proto._onOpen = function _onOpen(key) {
    this.setState({
      openRowKey: key
    });
  };

  _proto._onClose = function _onClose(key) {
    this.setState({
      openRowKey: null
    });
  };

  return SwipeableFlatList;
}(external_react_default.a.Component);

SwipeableFlatList_SwipeableFlatList.defaultProps = SwipeableFlatList_objectSpread({}, react_native_FlatList.defaultProps, {
  bounceFirstRowOnMount: true,
  renderQuickActions: function renderQuickActions() {
    return null;
  }
});
SwipeableFlatList_SwipeableFlatList.propTypes =  false ? undefined : {};
/* harmony default export */ var react_native_SwipeableFlatList = (SwipeableFlatList_SwipeableFlatList);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/SwipeableFlatList/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var exports_SwipeableFlatList = (react_native_SwipeableFlatList);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/SwipeableListView/SwipeableListViewDataSource.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule SwipeableListViewDataSource
 */



/**
 * Data source wrapper around ListViewDataSource to allow for tracking of
 * which row is swiped open and close opened row(s) when another row is swiped
 * open.
 *
 * See https://github.com/facebook/react-native/pull/5602 for why
 * ListViewDataSource is not subclassed.
 */

var SwipeableListViewDataSource_SwipeableListViewDataSource =
/*#__PURE__*/
function () {
  function SwipeableListViewDataSource(params) {
    var _this = this;

    this._dataSource = new ListView_ListViewDataSource({
      getRowData: params.getRowData,
      getSectionHeaderData: params.getSectionHeaderData,
      rowHasChanged: function rowHasChanged(row1, row2) {
        /**
         * Row needs to be re-rendered if its swiped open/close status is
         * changed, or its data blob changed.
         */
        return row1.id !== _this._previousOpenRowID && row2.id === _this._openRowID || row1.id === _this._previousOpenRowID && row2.id !== _this._openRowID || params.rowHasChanged(row1, row2);
      },
      sectionHeaderHasChanged: params.sectionHeaderHasChanged
    });
  }

  var _proto = SwipeableListViewDataSource.prototype;

  _proto.cloneWithRowsAndSections = function cloneWithRowsAndSections(dataBlob, sectionIdentities, rowIdentities) {
    this._dataSource = this._dataSource.cloneWithRowsAndSections(dataBlob, sectionIdentities, rowIdentities);
    this._dataBlob = dataBlob;
    this.rowIdentities = this._dataSource.rowIdentities;
    this.sectionIdentities = this._dataSource.sectionIdentities;
    return this;
  } // For the actual ListView to use
  ;

  _proto.getDataSource = function getDataSource() {
    return this._dataSource;
  };

  _proto.getOpenRowID = function getOpenRowID() {
    return this._openRowID;
  };

  _proto.getFirstRowID = function getFirstRowID() {
    /**
     * If rowIdentities is specified, find the first data row from there since
     * we don't want to attempt to bounce section headers. If unspecified, find
     * the first data row from _dataBlob.
     */
    if (this.rowIdentities) {
      return this.rowIdentities[0] && this.rowIdentities[0][0];
    }

    return Object.keys(this._dataBlob)[0];
  };

  _proto.getLastRowID = function getLastRowID() {
    if (this.rowIdentities && this.rowIdentities.length) {
      var lastSection = this.rowIdentities[this.rowIdentities.length - 1];

      if (lastSection && lastSection.length) {
        return lastSection[lastSection.length - 1];
      }
    }

    return Object.keys(this._dataBlob)[this._dataBlob.length - 1];
  };

  _proto.setOpenRowID = function setOpenRowID(rowID) {
    this._previousOpenRowID = this._openRowID;
    this._openRowID = rowID;
    this._dataSource = this._dataSource.cloneWithRowsAndSections(this._dataBlob, this.sectionIdentities, this.rowIdentities);
    return this;
  };

  return SwipeableListViewDataSource;
}();

/* harmony default export */ var SwipeableListView_SwipeableListViewDataSource = (SwipeableListViewDataSource_SwipeableListViewDataSource);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/vendor/react-native/SwipeableListView/index.js
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule SwipeableListView
 * 
 */


function SwipeableListView_extends() { SwipeableListView_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return SwipeableListView_extends.apply(this, arguments); }

function SwipeableListView_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }







/**
 * A container component that renders multiple SwipeableRow's in a ListView
 * implementation. This is designed to be a drop-in replacement for the
 * standard React Native `ListView`, so use it as if it were a ListView, but
 * with extra props, i.e.
 *
 * let ds = SwipeableListView.getNewDataSource();
 * ds.cloneWithRowsAndSections(dataBlob, ?sectionIDs, ?rowIDs);
 * // ..
 * <SwipeableListView renderRow={..} renderQuickActions={..} {..ListView props} />
 *
 * SwipeableRow can be used independently of this component, but the main
 * benefit of using this component is
 *
 * - It ensures that at most 1 row is swiped open (auto closes others)
 * - It can bounce the 1st row of the list so users know it's swipeable
 * - More to come
 */
var SwipeableListView_SwipeableListView =
/*#__PURE__*/
function (_React$Component) {
  SwipeableListView_inheritsLoose(SwipeableListView, _React$Component);

  SwipeableListView.getNewDataSource = function getNewDataSource() {
    return new SwipeableListView_SwipeableListViewDataSource({
      getRowData: function getRowData(data, sectionID, rowID) {
        return data[sectionID][rowID];
      },
      getSectionHeaderData: function getSectionHeaderData(data, sectionID) {
        return data[sectionID];
      },
      rowHasChanged: function rowHasChanged(row1, row2) {
        return row1 !== row2;
      },
      sectionHeaderHasChanged: function sectionHeaderHasChanged(s1, s2) {
        return s1 !== s2;
      }
    });
  };

  function SwipeableListView(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    _this._listViewRef = null;
    _this._shouldBounceFirstRowOnMount = false;

    _this._onScroll = function (e) {
      // Close any opens rows on ListView scroll
      if (_this.props.dataSource.getOpenRowID()) {
        _this.setState({
          dataSource: _this.state.dataSource.setOpenRowID(null)
        });
      }

      _this.props.onScroll && _this.props.onScroll(e);
    };

    _this._renderRow = function (rowData, sectionID, rowID) {
      var slideoutView = _this.props.renderQuickActions(rowData, sectionID, rowID); // If renderQuickActions is unspecified or returns falsey, don't allow swipe


      if (!slideoutView) {
        return _this.props.renderRow(rowData, sectionID, rowID);
      }

      var shouldBounceOnMount = false;

      if (_this._shouldBounceFirstRowOnMount) {
        _this._shouldBounceFirstRowOnMount = false;
        shouldBounceOnMount = rowID === _this.props.dataSource.getFirstRowID();
      }

      return external_react_default.a.createElement(react_native_SwipeableRow, {
        slideoutView: slideoutView,
        isOpen: rowData.id === _this.props.dataSource.getOpenRowID(),
        maxSwipeDistance: _this._getMaxSwipeDistance(rowData, sectionID, rowID),
        key: rowID,
        onOpen: function onOpen() {
          return _this._onOpen(rowData.id);
        },
        onClose: function onClose() {
          return _this._onClose(rowData.id);
        },
        onSwipeEnd: function onSwipeEnd() {
          return _this._setListViewScrollable(true);
        },
        onSwipeStart: function onSwipeStart() {
          return _this._setListViewScrollable(false);
        },
        shouldBounceOnMount: shouldBounceOnMount
      }, _this.props.renderRow(rowData, sectionID, rowID));
    };

    _this._shouldBounceFirstRowOnMount = _this.props.bounceFirstRowOnMount;
    _this.state = {
      dataSource: _this.props.dataSource
    };
    return _this;
  }

  var _proto = SwipeableListView.prototype;

  _proto.UNSAFE_componentWillReceiveProps = function UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.dataSource.getDataSource() !== nextProps.dataSource.getDataSource()) {
      this.setState({
        dataSource: nextProps.dataSource
      });
    }
  };

  _proto.render = function render() {
    var _this2 = this;

    return external_react_default.a.createElement(react_native_ListView, SwipeableListView_extends({}, this.props, {
      ref: function ref(_ref) {
        _this2._listViewRef = _ref;
      },
      dataSource: this.state.dataSource.getDataSource(),
      onScroll: this._onScroll,
      renderRow: this._renderRow
    }));
  };

  /**
   * This is a work-around to lock vertical `ListView` scrolling on iOS and
   * mimic Android behaviour. Locking vertical scrolling when horizontal
   * scrolling is active allows us to significantly improve framerates
   * (from high 20s to almost consistently 60 fps)
   */
  _proto._setListViewScrollable = function _setListViewScrollable(value) {
    if (this._listViewRef && typeof this._listViewRef.setNativeProps === 'function') {
      this._listViewRef.setNativeProps({
        scrollEnabled: value
      });
    }
  } // Passing through ListView's getScrollResponder() function
  ;

  _proto.getScrollResponder = function getScrollResponder() {
    if (this._listViewRef && typeof this._listViewRef.getScrollResponder === 'function') {
      return this._listViewRef.getScrollResponder();
    }
  } // This enables rows having variable width slideoutView.
  ;

  _proto._getMaxSwipeDistance = function _getMaxSwipeDistance(rowData, sectionID, rowID) {
    if (typeof this.props.maxSwipeDistance === 'function') {
      return this.props.maxSwipeDistance(rowData, sectionID, rowID);
    }

    return this.props.maxSwipeDistance;
  };

  _proto._onOpen = function _onOpen(rowID) {
    this.setState({
      dataSource: this.state.dataSource.setOpenRowID(rowID)
    });
  };

  _proto._onClose = function _onClose(rowID) {
    this.setState({
      dataSource: this.state.dataSource.setOpenRowID(null)
    });
  };

  return SwipeableListView;
}(external_react_default.a.Component);

SwipeableListView_SwipeableListView.defaultProps = {
  bounceFirstRowOnMount: false,
  renderQuickActions: function renderQuickActions() {
    return null;
  }
};
SwipeableListView_SwipeableListView.propTypes =  false ? undefined : {};
/* harmony default export */ var react_native_SwipeableListView = (SwipeableListView_SwipeableListView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/SwipeableListView/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var exports_SwipeableListView = (react_native_SwipeableListView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Switch/index.js
function Switch_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { Switch_defineProperty(target, key, source[key]); }); } return target; }

function Switch_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Switch_extends() { Switch_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return Switch_extends.apply(this, arguments); }

function Switch_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function Switch_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */










var Switch_emptyObject = {};
var thumbDefaultBoxShadow = '0px 1px 3px rgba(0,0,0,0.5)';
var thumbFocusedBoxShadow = thumbDefaultBoxShadow + ", 0 0 0 10px rgba(0,0,0,0.1)";

var Switch_Switch =
/*#__PURE__*/
function (_Component) {
  Switch_inheritsLoose(Switch, _Component);

  function Switch() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this._handleChange = function (event) {
      var onValueChange = _this.props.onValueChange;
      onValueChange && onValueChange(event.nativeEvent.target.checked);
    };

    _this._handleFocusState = function (event) {
      var isFocused = event.nativeEvent.type === 'focus';
      var boxShadow = isFocused ? thumbFocusedBoxShadow : thumbDefaultBoxShadow;

      if (_this._thumbElement) {
        _this._thumbElement.setNativeProps({
          style: {
            boxShadow: boxShadow
          }
        });
      }
    };

    _this._setCheckboxRef = function (element) {
      _this._checkboxElement = element;
    };

    _this._setThumbRef = function (element) {
      _this._thumbElement = element;
    };

    return _this;
  }

  var _proto = Switch.prototype;

  _proto.blur = function blur() {
    UIManager["a" /* default */].blur(this._checkboxElement);
  };

  _proto.focus = function focus() {
    UIManager["a" /* default */].focus(this._checkboxElement);
  };

  _proto.render = function render() {
    var _this$props = this.props,
        accessibilityLabel = _this$props.accessibilityLabel,
        activeThumbColor = _this$props.activeThumbColor,
        activeTrackColor = _this$props.activeTrackColor,
        disabled = _this$props.disabled,
        onValueChange = _this$props.onValueChange,
        style = _this$props.style,
        thumbColor = _this$props.thumbColor,
        trackColor = _this$props.trackColor,
        value = _this$props.value,
        onTintColor = _this$props.onTintColor,
        thumbTintColor = _this$props.thumbTintColor,
        tintColor = _this$props.tintColor,
        other = Switch_objectWithoutPropertiesLoose(_this$props, ["accessibilityLabel", "activeThumbColor", "activeTrackColor", "disabled", "onValueChange", "style", "thumbColor", "trackColor", "value", "onTintColor", "thumbTintColor", "tintColor"]);

    var _StyleSheet$flatten = exports_StyleSheet.flatten(style),
        styleHeight = _StyleSheet$flatten.height,
        styleWidth = _StyleSheet$flatten.width;

    var height = styleHeight || 20;
    var minWidth = modules_multiplyStyleLengthValue(height, 2);
    var width = styleWidth > minWidth ? styleWidth : minWidth;
    var trackBorderRadius = modules_multiplyStyleLengthValue(height, 0.5);
    var trackCurrentColor = value ? onTintColor || activeTrackColor : tintColor || trackColor;
    var thumbCurrentColor = value ? activeThumbColor : thumbTintColor || thumbColor;
    var thumbHeight = height;
    var thumbWidth = thumbHeight;
    var rootStyle = [Switch_styles.root, style, {
      height: height,
      width: width
    }, disabled && Switch_styles.cursorDefault];
    var trackStyle = [Switch_styles.track, {
      backgroundColor: trackCurrentColor,
      borderRadius: trackBorderRadius
    }, disabled && Switch_styles.disabledTrack];
    var thumbStyle = [Switch_styles.thumb, {
      backgroundColor: thumbCurrentColor,
      height: thumbHeight,
      width: thumbWidth
    }, disabled && Switch_styles.disabledThumb];
    var nativeControl = exports_createElement('input', {
      accessibilityLabel: accessibilityLabel,
      checked: value,
      disabled: disabled,
      onBlur: this._handleFocusState,
      onChange: this._handleChange,
      onFocus: this._handleFocusState,
      ref: this._setCheckboxRef,
      style: [Switch_styles.nativeControl, Switch_styles.cursorInherit],
      type: 'checkbox'
    });
    return external_react_default.a.createElement(exports_View, Switch_extends({}, other, {
      style: rootStyle
    }), external_react_default.a.createElement(exports_View, {
      style: trackStyle
    }), external_react_default.a.createElement(exports_View, {
      ref: this._setThumbRef,
      style: [thumbStyle, value && Switch_styles.thumbOn, {
        marginStart: value ? modules_multiplyStyleLengthValue(thumbWidth, -1) : 0
      }]
    }), nativeControl);
  };

  return Switch;
}(external_react_["Component"]);

Switch_Switch.displayName = 'Switch';
Switch_Switch.defaultProps = {
  activeThumbColor: '#009688',
  activeTrackColor: '#A3D3CF',
  disabled: false,
  style: Switch_emptyObject,
  thumbColor: '#FAFAFA',
  trackColor: '#939393',
  value: false
};
Switch_Switch.propTypes =  false ? undefined : {};
var Switch_styles = exports_StyleSheet.create({
  root: {
    cursor: 'pointer',
    userSelect: 'none'
  },
  cursorDefault: {
    cursor: 'default'
  },
  cursorInherit: {
    cursor: 'inherit'
  },
  track: Switch_objectSpread({}, exports_StyleSheet.absoluteFillObject, {
    height: '70%',
    margin: 'auto',
    transitionDuration: '0.1s',
    width: '100%'
  }),
  disabledTrack: {
    backgroundColor: '#D5D5D5'
  },
  thumb: {
    alignSelf: 'flex-start',
    borderRadius: '100%',
    boxShadow: thumbDefaultBoxShadow,
    start: '0%',
    transform: [{
      translateZ: 0
    }],
    transitionDuration: '0.1s'
  },
  thumbOn: {
    start: '100%'
  },
  disabledThumb: {
    backgroundColor: '#BDBDBD'
  },
  nativeControl: Switch_objectSpread({}, exports_StyleSheet.absoluteFillObject, {
    height: '100%',
    margin: 0,
    opacity: 0,
    padding: 0,
    width: '100%'
  })
});
/* harmony default export */ var exports_Switch = (modules_applyNativeMethods(Switch_Switch));
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/TextInput/index.js
function TextInput_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { TextInput_defineProperty(target, key, source[key]); }); } return target; }

function TextInput_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function TextInput_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TextInput_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */













var isAndroid = ExecutionEnvironment["canUseDOM"] && /Android/i.test(navigator && navigator.userAgent);
var TextInput_emptyObject = {};
/**
 * React Native events differ from W3C events.
 */

var normalizeEventHandler = function normalizeEventHandler(handler) {
  return function (e) {
    if (handler) {
      e.nativeEvent.text = e.target.value;
      return handler(e);
    }
  };
};
/**
 * Determines whether a 'selection' prop differs from a node's existing
 * selection state.
 */


var isSelectionStale = function isSelectionStale(node, selection) {
  if (node && selection) {
    var selectionEnd = node.selectionEnd,
        selectionStart = node.selectionStart;
    var start = selection.start,
        end = selection.end;
    return start !== selectionStart || end !== selectionEnd;
  }

  return false;
};
/**
 * Certain input types do no support 'selectSelectionRange' and will throw an
 * error.
 */


var setSelection = function setSelection(node, selection) {
  try {
    if (isSelectionStale(node, selection)) {
      var start = selection.start,
          end = selection.end; // workaround for Blink on Android: see https://github.com/text-mask/text-mask/issues/300

      if (isAndroid) {
        setTimeout(function () {
          return node.setSelectionRange(start, end || start);
        }, 10);
      } else {
        node.setSelectionRange(start, end || start);
      }
    }
  } catch (e) {}
};

var TextInput_TextInput =
/*#__PURE__*/
function (_Component) {
  TextInput_inheritsLoose(TextInput, _Component);

  function TextInput() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;

    _this._handleBlur = function (e) {
      var onBlur = _this.props.onBlur;
      modules_TextInputState._currentlyFocusedNode = null;

      if (onBlur) {
        onBlur(e);
      }
    };

    _this._handleContentSizeChange = function () {
      var _this$props = _this.props,
          onContentSizeChange = _this$props.onContentSizeChange,
          multiline = _this$props.multiline;

      if (multiline && onContentSizeChange) {
        var newHeight = _this._node.scrollHeight;
        var newWidth = _this._node.scrollWidth;

        if (newHeight !== _this._nodeHeight || newWidth !== _this._nodeWidth) {
          _this._nodeHeight = newHeight;
          _this._nodeWidth = newWidth;
          onContentSizeChange({
            nativeEvent: {
              contentSize: {
                height: _this._nodeHeight,
                width: _this._nodeWidth
              }
            }
          });
        }
      }
    };

    _this._handleChange = function (e) {
      var _this$props2 = _this.props,
          onChange = _this$props2.onChange,
          onChangeText = _this$props2.onChangeText;
      var text = e.nativeEvent.text;

      _this._handleContentSizeChange();

      if (onChange) {
        onChange(e);
      }

      if (onChangeText) {
        onChangeText(text);
      }

      _this._handleSelectionChange(e);
    };

    _this._handleFocus = function (e) {
      var _this$props3 = _this.props,
          clearTextOnFocus = _this$props3.clearTextOnFocus,
          onFocus = _this$props3.onFocus,
          selectTextOnFocus = _this$props3.selectTextOnFocus;
      var node = _this._node;
      modules_TextInputState._currentlyFocusedNode = _this._node;

      if (onFocus) {
        onFocus(e);
      }

      if (clearTextOnFocus) {
        _this.clear();
      }

      if (selectTextOnFocus) {
        node && node.select();
      }
    };

    _this._handleKeyDown = function (e) {
      // Prevent key events bubbling (see #612)
      e.stopPropagation(); // Backspace, Escape, Tab, Cmd+Enter, and Arrow keys only fire 'keydown'
      // DOM events

      if (e.key === 'ArrowLeft' || e.key === 'ArrowUp' || e.key === 'ArrowRight' || e.key === 'ArrowDown' || e.key === 'Backspace' || e.key === 'Escape' || e.key === 'Enter' && e.metaKey || e.key === 'Tab') {
        _this._handleKeyPress(e);
      }
    };

    _this._handleKeyPress = function (e) {
      var _this$props4 = _this.props,
          blurOnSubmit = _this$props4.blurOnSubmit,
          multiline = _this$props4.multiline,
          onKeyPress = _this$props4.onKeyPress,
          onSubmitEditing = _this$props4.onSubmitEditing;
      var blurOnSubmitDefault = !multiline;
      var shouldBlurOnSubmit = blurOnSubmit == null ? blurOnSubmitDefault : blurOnSubmit;

      if (onKeyPress) {
        var keyValue = e.key;

        if (keyValue) {
          e.nativeEvent = {
            altKey: e.altKey,
            ctrlKey: e.ctrlKey,
            key: keyValue,
            metaKey: e.metaKey,
            shiftKey: e.shiftKey,
            target: e.target
          };
          onKeyPress(e);
        }
      }

      if (!e.isDefaultPrevented() && e.key === 'Enter' && !e.shiftKey) {
        if ((blurOnSubmit || !multiline) && onSubmitEditing) {
          // prevent "Enter" from inserting a newline
          e.preventDefault();
          e.nativeEvent = {
            target: e.target,
            text: e.target.value
          };
          onSubmitEditing(e);
        }

        if (shouldBlurOnSubmit) {
          // $FlowFixMe
          _this.blur();
        }
      }
    };

    _this._handleSelectionChange = function (e) {
      var _this$props5 = _this.props,
          onSelectionChange = _this$props5.onSelectionChange,
          _this$props5$selectio = _this$props5.selection,
          selection = _this$props5$selectio === void 0 ? TextInput_emptyObject : _this$props5$selectio;

      if (onSelectionChange) {
        try {
          var node = e.target;

          if (isSelectionStale(node, selection)) {
            var selectionStart = node.selectionStart,
                selectionEnd = node.selectionEnd;
            e.nativeEvent.selection = {
              start: selectionStart,
              end: selectionEnd
            };
            onSelectionChange(e);
          }
        } catch (e) {}
      }
    };

    _this._setNode = function (component) {
      _this._node = exports_findNodeHandle(component);

      if (_this._node) {
        _this._handleContentSizeChange();
      }
    };

    return _this;
  }

  var _proto = TextInput.prototype;

  _proto.clear = function clear() {
    this._node.value = '';
  };

  _proto.isFocused = function isFocused() {
    return modules_TextInputState.currentlyFocusedField() === this._node;
  };

  _proto.componentDidMount = function componentDidMount() {
    setSelection(this._node, this.props.selection);

    if (document.activeElement === this._node) {
      modules_TextInputState._currentlyFocusedNode = this._node;
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate() {
    setSelection(this._node, this.props.selection);
  };

  _proto.render = function render() {
    var _this$props6 = this.props,
        autoComplete = _this$props6.autoComplete,
        autoCorrect = _this$props6.autoCorrect,
        editable = _this$props6.editable,
        keyboardType = _this$props6.keyboardType,
        multiline = _this$props6.multiline,
        numberOfLines = _this$props6.numberOfLines,
        returnKeyType = _this$props6.returnKeyType,
        secureTextEntry = _this$props6.secureTextEntry,
        blurOnSubmit = _this$props6.blurOnSubmit,
        clearTextOnFocus = _this$props6.clearTextOnFocus,
        onChangeText = _this$props6.onChangeText,
        onLayout = _this$props6.onLayout,
        onSelectionChange = _this$props6.onSelectionChange,
        onSubmitEditing = _this$props6.onSubmitEditing,
        selection = _this$props6.selection,
        selectTextOnFocus = _this$props6.selectTextOnFocus,
        spellCheck = _this$props6.spellCheck,
        accessibilityViewIsModal = _this$props6.accessibilityViewIsModal,
        allowFontScaling = _this$props6.allowFontScaling,
        caretHidden = _this$props6.caretHidden,
        clearButtonMode = _this$props6.clearButtonMode,
        dataDetectorTypes = _this$props6.dataDetectorTypes,
        disableFullscreenUI = _this$props6.disableFullscreenUI,
        enablesReturnKeyAutomatically = _this$props6.enablesReturnKeyAutomatically,
        hitSlop = _this$props6.hitSlop,
        inlineImageLeft = _this$props6.inlineImageLeft,
        inlineImagePadding = _this$props6.inlineImagePadding,
        inputAccessoryViewID = _this$props6.inputAccessoryViewID,
        keyboardAppearance = _this$props6.keyboardAppearance,
        maxFontSizeMultiplier = _this$props6.maxFontSizeMultiplier,
        needsOffscreenAlphaCompositing = _this$props6.needsOffscreenAlphaCompositing,
        onAccessibilityTap = _this$props6.onAccessibilityTap,
        onContentSizeChange = _this$props6.onContentSizeChange,
        onEndEditing = _this$props6.onEndEditing,
        onMagicTap = _this$props6.onMagicTap,
        onScroll = _this$props6.onScroll,
        removeClippedSubviews = _this$props6.removeClippedSubviews,
        renderToHardwareTextureAndroid = _this$props6.renderToHardwareTextureAndroid,
        returnKeyLabel = _this$props6.returnKeyLabel,
        scrollEnabled = _this$props6.scrollEnabled,
        selectionColor = _this$props6.selectionColor,
        selectionState = _this$props6.selectionState,
        shouldRasterizeIOS = _this$props6.shouldRasterizeIOS,
        textBreakStrategy = _this$props6.textBreakStrategy,
        textContentType = _this$props6.textContentType,
        underlineColorAndroid = _this$props6.underlineColorAndroid,
        otherProps = TextInput_objectWithoutPropertiesLoose(_this$props6, ["autoComplete", "autoCorrect", "editable", "keyboardType", "multiline", "numberOfLines", "returnKeyType", "secureTextEntry", "blurOnSubmit", "clearTextOnFocus", "onChangeText", "onLayout", "onSelectionChange", "onSubmitEditing", "selection", "selectTextOnFocus", "spellCheck", "accessibilityViewIsModal", "allowFontScaling", "caretHidden", "clearButtonMode", "dataDetectorTypes", "disableFullscreenUI", "enablesReturnKeyAutomatically", "hitSlop", "inlineImageLeft", "inlineImagePadding", "inputAccessoryViewID", "keyboardAppearance", "maxFontSizeMultiplier", "needsOffscreenAlphaCompositing", "onAccessibilityTap", "onContentSizeChange", "onEndEditing", "onMagicTap", "onScroll", "removeClippedSubviews", "renderToHardwareTextureAndroid", "returnKeyLabel", "scrollEnabled", "selectionColor", "selectionState", "shouldRasterizeIOS", "textBreakStrategy", "textContentType", "underlineColorAndroid"]);

    var type;

    switch (keyboardType) {
      case 'email-address':
        type = 'email';
        break;

      case 'number-pad':
      case 'numeric':
        type = 'number';
        break;

      case 'phone-pad':
        type = 'tel';
        break;

      case 'search':
      case 'web-search':
        type = 'search';
        break;

      case 'url':
        type = 'url';
        break;

      default:
        type = 'text';
    }

    if (secureTextEntry) {
      type = 'password';
    }

    var component = multiline ? 'textarea' : 'input';
    Object.assign(otherProps, {
      // Browser's treat autocomplete "off" as "on"
      // https://bugs.chromium.org/p/chromium/issues/detail?id=468153#c164
      autoComplete: autoComplete === 'off' ? 'noop' : autoComplete,
      autoCorrect: autoCorrect ? 'on' : 'off',
      classList: [TextInput_classes.textinput],
      dir: 'auto',
      enterkeyhint: returnKeyType,
      onBlur: normalizeEventHandler(this._handleBlur),
      onChange: normalizeEventHandler(this._handleChange),
      onFocus: normalizeEventHandler(this._handleFocus),
      onKeyDown: this._handleKeyDown,
      onKeyPress: this._handleKeyPress,
      onSelect: normalizeEventHandler(this._handleSelectionChange),
      readOnly: !editable,
      ref: this._setNode,
      spellCheck: spellCheck != null ? spellCheck : autoCorrect
    });

    if (multiline) {
      otherProps.rows = numberOfLines;
    } else {
      otherProps.type = type;
    }

    return exports_createElement(component, otherProps);
  };

  return TextInput;
}(external_react_["Component"]);

TextInput_TextInput.displayName = 'TextInput';
TextInput_TextInput.defaultProps = {
  autoCapitalize: 'sentences',
  autoComplete: 'on',
  autoCorrect: true,
  editable: true,
  keyboardType: 'default',
  multiline: false,
  numberOfLines: 1,
  secureTextEntry: false
};
TextInput_TextInput.State = modules_TextInputState;
TextInput_TextInput.propTypes =  false ? undefined : {};
var TextInput_classes = StyleSheet_css.create({
  textinput: {
    MozAppearance: 'textfield',
    WebkitAppearance: 'none',
    backgroundColor: 'transparent',
    border: '0 solid black',
    borderRadius: 0,
    boxSizing: 'border-box',
    font: '14px System',
    padding: 0,
    resize: 'none'
  }
});
/* harmony default export */ var exports_TextInput = (modules_applyLayout(modules_applyNativeMethods(TextInput_TextInput)));
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/TouchableHighlight/index.js
function TouchableHighlight_extends() { TouchableHighlight_extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return TouchableHighlight_extends.apply(this, arguments); }

function TouchableHighlight_objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function TouchableHighlight_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { TouchableHighlight_defineProperty(target, key, source[key]); }); } return target; }

function TouchableHighlight_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */













var DEFAULT_PROPS = {
  activeOpacity: 0.85,
  underlayColor: 'black'
};
var TouchableHighlight_PRESS_RETENTION_OFFSET = {
  top: 20,
  left: 20,
  right: 20,
  bottom: 30
};
/**
 * A wrapper for making views respond properly to touches.
 * On press down, the opacity of the wrapped view is decreased, which allows
 * the underlay color to show through, darkening or tinting the view.
 *
 * The underlay comes from wrapping the child in a new View, which can affect
 * layout, and sometimes cause unwanted visual artifacts if not used correctly,
 * for example if the backgroundColor of the wrapped view isn't explicitly set
 * to an opaque color.
 *
 * TouchableHighlight must have one child (not zero or more than one).
 * If you wish to have several child components, wrap them in a View.
 *
 * Example:
 *
 * ```
 * renderButton: function() {
 *   return (
 *     <TouchableHighlight onPress={this._onPressButton}>
 *       <Image
 *         style={styles.button}
 *         source={require('./myButton.png')}
 *       />
 *     </TouchableHighlight>
 *   );
 * },
 * ```
 */

/* eslint-disable react/prefer-es6-class */

var TouchableHighlight = create_react_class_default()({
  displayName: 'TouchableHighlight',
  propTypes: TouchableHighlight_objectSpread({}, exports_TouchableWithoutFeedback.propTypes, {
    /**
     * Determines what the opacity of the wrapped view should be when touch is
     * active.
     */
    activeOpacity: external_prop_types_["number"],

    /**
     * Called immediately after the underlay is hidden
     */
    onHideUnderlay: external_prop_types_["func"],

    /**
     * Called immediately after the underlay is shown
     */
    onShowUnderlay: external_prop_types_["func"],
    style: exports_ViewPropTypes.style,

    /**
     * The color of the underlay that will show through when the touch is
     * active.
     */
    underlayColor: exports_ColorPropType
  }),
  mixins: [TimerMixin_default.a, exports_Touchable.Mixin],
  getDefaultProps: function getDefaultProps() {
    return DEFAULT_PROPS;
  },
  // Performance optimization to avoid constantly re-generating these objects.
  _computeSyntheticState: function _computeSyntheticState(props) {
    return {
      activeProps: {
        style: {
          opacity: props.activeOpacity
        }
      },
      activeUnderlayProps: {
        style: {
          backgroundColor: props.underlayColor
        }
      },
      underlayStyle: [INACTIVE_UNDERLAY_PROPS.style, props.style]
    };
  },
  getInitialState: function getInitialState() {
    this._isMounted = false;
    return TouchableHighlight_objectSpread({}, this.touchableGetInitialState(), this._computeSyntheticState(this.props));
  },
  componentDidMount: function componentDidMount() {
    this._isMounted = true;
    Touchable_ensurePositiveDelayProps(this.props);
    modules_ensureComponentIsNative(this._childRef);
  },
  componentWillUnmount: function componentWillUnmount() {
    this._isMounted = false;
  },
  componentDidUpdate: function componentDidUpdate() {
    modules_ensureComponentIsNative(this._childRef);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
    Touchable_ensurePositiveDelayProps(nextProps);

    if (nextProps.activeOpacity !== this.props.activeOpacity || nextProps.underlayColor !== this.props.underlayColor || nextProps.style !== this.props.style) {
      this.setState(this._computeSyntheticState(nextProps));
    }
  },

  /**
   * `Touchable.Mixin` self callbacks. The mixin will invoke these if they are
   * defined on your component.
   */
  touchableHandleActivePressIn: function touchableHandleActivePressIn(e) {
    this.clearTimeout(this._hideTimeout);
    this._hideTimeout = null;

    this._showUnderlay();

    this.props.onPressIn && this.props.onPressIn(e);
  },
  touchableHandleActivePressOut: function touchableHandleActivePressOut(e) {
    if (!this._hideTimeout) {
      this._hideUnderlay();
    }

    this.props.onPressOut && this.props.onPressOut(e);
  },
  touchableHandlePress: function touchableHandlePress(e) {
    this.clearTimeout(this._hideTimeout);

    this._showUnderlay();

    this._hideTimeout = this.setTimeout(this._hideUnderlay, this.props.delayPressOut || 100);
    this.props.onPress && this.props.onPress(e);
  },
  touchableHandleLongPress: function touchableHandleLongPress(e) {
    this.props.onLongPress && this.props.onLongPress(e);
  },
  touchableGetPressRectOffset: function touchableGetPressRectOffset() {
    return this.props.pressRetentionOffset || TouchableHighlight_PRESS_RETENTION_OFFSET;
  },
  touchableGetHitSlop: function touchableGetHitSlop() {
    return this.props.hitSlop;
  },
  touchableGetHighlightDelayMS: function touchableGetHighlightDelayMS() {
    return this.props.delayPressIn;
  },
  touchableGetLongPressDelayMS: function touchableGetLongPressDelayMS() {
    return this.props.delayLongPress;
  },
  touchableGetPressOutDelayMS: function touchableGetPressOutDelayMS() {
    return this.props.delayPressOut;
  },
  _showUnderlay: function _showUnderlay() {
    if (!this._isMounted || !this._hasPressHandler()) {
      return;
    }

    this._underlayRef.setNativeProps(this.state.activeUnderlayProps);

    this._childRef.setNativeProps(this.state.activeProps);

    this.props.onShowUnderlay && this.props.onShowUnderlay();
  },
  _hideUnderlay: function _hideUnderlay() {
    this.clearTimeout(this._hideTimeout);
    this._hideTimeout = null;

    if (this._hasPressHandler() && this._underlayRef) {
      this._childRef.setNativeProps(INACTIVE_CHILD_PROPS);

      this._underlayRef.setNativeProps(TouchableHighlight_objectSpread({}, INACTIVE_UNDERLAY_PROPS, {
        style: this.state.underlayStyle
      }));

      this.props.onHideUnderlay && this.props.onHideUnderlay();
    }
  },
  _hasPressHandler: function _hasPressHandler() {
    return !!(this.props.onPress || this.props.onPressIn || this.props.onPressOut || this.props.onLongPress);
  },
  _setChildRef: function _setChildRef(node) {
    this._childRef = node;
  },
  _setUnderlayRef: function _setUnderlayRef(node) {
    this._underlayRef = node;
  },
  render: function render() {
    var _this$props = this.props,
        activeOpacity = _this$props.activeOpacity,
        onHideUnderlay = _this$props.onHideUnderlay,
        onShowUnderlay = _this$props.onShowUnderlay,
        underlayColor = _this$props.underlayColor,
        delayLongPress = _this$props.delayLongPress,
        delayPressIn = _this$props.delayPressIn,
        delayPressOut = _this$props.delayPressOut,
        onLongPress = _this$props.onLongPress,
        onPress = _this$props.onPress,
        onPressIn = _this$props.onPressIn,
        onPressOut = _this$props.onPressOut,
        pressRetentionOffset = _this$props.pressRetentionOffset,
        other = TouchableHighlight_objectWithoutPropertiesLoose(_this$props, ["activeOpacity", "onHideUnderlay", "onShowUnderlay", "underlayColor", "delayLongPress", "delayPressIn", "delayPressOut", "onLongPress", "onPress", "onPressIn", "onPressOut", "pressRetentionOffset"]);

    return external_react_default.a.createElement(exports_View, TouchableHighlight_extends({}, other, {
      accessible: this.props.accessible !== false,
      onKeyDown: this.touchableHandleKeyEvent,
      onKeyUp: this.touchableHandleKeyEvent,
      onResponderGrant: this.touchableHandleResponderGrant,
      onResponderMove: this.touchableHandleResponderMove,
      onResponderRelease: this.touchableHandleResponderRelease,
      onResponderTerminate: this.touchableHandleResponderTerminate,
      onResponderTerminationRequest: this.touchableHandleResponderTerminationRequest,
      onStartShouldSetResponder: this.touchableHandleStartShouldSetResponder,
      ref: this._setUnderlayRef,
      style: [TouchableHighlight_styles.root, !this.props.disabled && TouchableHighlight_styles.actionable, this.state.underlayStyle]
    }), external_react_default.a.cloneElement(external_react_default.a.Children.only(this.props.children), {
      ref: this._setChildRef
    }), exports_Touchable.renderDebugView({
      color: 'green',
      hitSlop: this.props.hitSlop
    }));
  }
});
var INACTIVE_CHILD_PROPS = {
  style: exports_StyleSheet.create({
    x: {
      opacity: 1.0
    }
  }).x
};
var INACTIVE_UNDERLAY_PROPS = {
  style: exports_StyleSheet.create({
    x: {
      backgroundColor: 'transparent'
    }
  }).x
};
var TouchableHighlight_styles = exports_StyleSheet.create({
  root: {
    userSelect: 'none'
  },
  actionable: {
    cursor: 'pointer',
    touchAction: 'manipulation'
  }
});
/* harmony default export */ var exports_TouchableHighlight = (modules_applyNativeMethods(TouchableHighlight));
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/TouchableNativeFeedback/index.js
/**
 * Copyright (c) Nicolas Gallagher.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var TouchableNativeFeedback = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/VirtualizedList/index.js
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

/* harmony default export */ var exports_VirtualizedList = (react_native_VirtualizedList);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/YellowBox/index.js
function YellowBox_inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

/**
 * Copyright (c) Nicolas Gallagher.
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var YellowBox_YellowBox =
/*#__PURE__*/
function (_React$Component) {
  YellowBox_inheritsLoose(YellowBox, _React$Component);

  function YellowBox() {
    return _React$Component.apply(this, arguments) || this;
  }

  YellowBox.ignoreWarnings = function ignoreWarnings() {};

  var _proto = YellowBox.prototype;

  _proto.render = function render() {
    return external_react_default.a.createElement(modules_UnimplementedView, this.props);
  };

  return YellowBox;
}(external_react_default.a.Component);

/* harmony default export */ var exports_YellowBox = (YellowBox_YellowBox);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/PointPropType/index.js
/**
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


var PointPropType = modules_createStrictShapeTypeChecker({
  x: external_prop_types_["number"],
  y: external_prop_types_["number"]
});
/* harmony default export */ var exports_PointPropType = (PointPropType);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/DatePickerIOS/index.js

/* harmony default export */ var DatePickerIOS = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/DrawerLayoutAndroid/index.js

/* harmony default export */ var DrawerLayoutAndroid = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/ImageEditor/index.js

/* harmony default export */ var ImageEditor = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/ImageStore/index.js

/* harmony default export */ var ImageStore = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/InputAccessoryView/index.js

/* harmony default export */ var InputAccessoryView = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/MaskedViewIOS/index.js

/* harmony default export */ var MaskedViewIOS = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/NavigatorIOS/index.js

/* harmony default export */ var NavigatorIOS = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/PickerIOS/index.js

/* harmony default export */ var PickerIOS = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/ProgressBarAndroid/index.js

/* harmony default export */ var ProgressBarAndroid = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/ProgressViewIOS/index.js

/* harmony default export */ var ProgressViewIOS = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/SegmentedControlIOS/index.js

/* harmony default export */ var SegmentedControlIOS = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/SnapshotViewIOS/index.js

/* harmony default export */ var SnapshotViewIOS = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/TabBarIOS/index.js

/* harmony default export */ var TabBarIOS = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/ToastAndroid/index.js

/* harmony default export */ var ToastAndroid = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/ToolbarAndroid/index.js

/* harmony default export */ var ToolbarAndroid = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/ViewPagerAndroid/index.js

/* harmony default export */ var ViewPagerAndroid = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/WebView/index.js

/* harmony default export */ var WebView = (modules_UnimplementedView);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/ActionSheetIOS/index.js
/* harmony default export */ var ActionSheetIOS = ({});
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/AlertIOS/index.js
/* harmony default export */ var AlertIOS = ({});
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/CameraRoll/index.js
/* harmony default export */ var CameraRoll = ({});
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/DatePickerAndroid/index.js
/* harmony default export */ var DatePickerAndroid = ({});
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/ImagePickerIOS/index.js
/* harmony default export */ var ImagePickerIOS = ({});
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/PermissionsAndroid/index.js
/* harmony default export */ var PermissionsAndroid = ({});
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/PushNotificationIOS/index.js
/* harmony default export */ var PushNotificationIOS = ({});
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Settings/index.js
/* harmony default export */ var Settings = ({});
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/StatusBarIOS/index.js
/* harmony default export */ var StatusBarIOS = ({});
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/Systrace/index.js
/* harmony default export */ var Systrace = ({});
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/TimePickerAndroid/index.js
/* harmony default export */ var TimePickerAndroid = ({});
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/TVEventHandler/index.js
/* harmony default export */ var TVEventHandler = ({});
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/VibrationIOS/index.js
/* harmony default export */ var VibrationIOS = ({});
// EXTERNAL MODULE: ./node_modules/react-native-web/dist/vendor/react-native/NativeEventEmitter/RCTDeviceEventEmitter.js
var RCTDeviceEventEmitter = __webpack_require__(65);

// CONCATENATED MODULE: ./node_modules/react-native-web/dist/exports/DeviceEventEmitter/index.js

/* harmony default export */ var DeviceEventEmitter = (RCTDeviceEventEmitter["a" /* default */]);
// CONCATENATED MODULE: ./node_modules/react-native-web/dist/index.js







 // APIs

























 // components






























 // propTypes



 // compat (components)

















 // compat (apis)













 // plugins




/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var _Animation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37);
/* harmony import */ var _SpringConfig__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85);
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3);
/* harmony import */ var fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }








function withDefault(value, defaultValue) {
  if (value === undefined || value === null) {
    return defaultValue;
  }

  return value;
}

var SpringAnimation =
/*#__PURE__*/
function (_Animation) {
  _inheritsLoose(SpringAnimation, _Animation);

  function SpringAnimation(config) {
    var _this;

    _this = _Animation.call(this) || this;
    _this._overshootClamping = withDefault(config.overshootClamping, false);
    _this._restDisplacementThreshold = withDefault(config.restDisplacementThreshold, 0.001);
    _this._restSpeedThreshold = withDefault(config.restSpeedThreshold, 0.001);
    _this._initialVelocity = withDefault(config.velocity, 0);
    _this._lastVelocity = withDefault(config.velocity, 0);
    _this._toValue = config.toValue;
    _this._delay = withDefault(config.delay, 0);
    _this._useNativeDriver = Object(_NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_3__[/* shouldUseNativeDriver */ "c"])(config);
    _this.__isInteraction = config.isInteraction !== undefined ? config.isInteraction : true;
    _this.__iterations = config.iterations !== undefined ? config.iterations : 1;

    if (config.stiffness !== undefined || config.damping !== undefined || config.mass !== undefined) {
      fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_2___default()(config.bounciness === undefined && config.speed === undefined && config.tension === undefined && config.friction === undefined, 'You can define one of bounciness/speed, tension/friction, or stiffness/damping/mass, but not more than one');
      _this._stiffness = withDefault(config.stiffness, 100);
      _this._damping = withDefault(config.damping, 10);
      _this._mass = withDefault(config.mass, 1);
    } else if (config.bounciness !== undefined || config.speed !== undefined) {
      // Convert the origami bounciness/speed values to stiffness/damping
      // We assume mass is 1.
      fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_2___default()(config.tension === undefined && config.friction === undefined && config.stiffness === undefined && config.damping === undefined && config.mass === undefined, 'You can define one of bounciness/speed, tension/friction, or stiffness/damping/mass, but not more than one');
      var springConfig = _SpringConfig__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].fromBouncinessAndSpeed(withDefault(config.bounciness, 8), withDefault(config.speed, 12));
      _this._stiffness = springConfig.stiffness;
      _this._damping = springConfig.damping;
      _this._mass = 1;
    } else {
      // Convert the origami tension/friction values to stiffness/damping
      // We assume mass is 1.
      var _springConfig = _SpringConfig__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].fromOrigamiTensionAndFriction(withDefault(config.tension, 40), withDefault(config.friction, 7));

      _this._stiffness = _springConfig.stiffness;
      _this._damping = _springConfig.damping;
      _this._mass = 1;
    }

    fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_2___default()(_this._stiffness > 0, 'Stiffness value must be greater than 0');
    fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_2___default()(_this._damping > 0, 'Damping value must be greater than 0');
    fbjs_lib_invariant__WEBPACK_IMPORTED_MODULE_2___default()(_this._mass > 0, 'Mass value must be greater than 0');
    return _this;
  }

  var _proto = SpringAnimation.prototype;

  _proto.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
    return {
      type: 'spring',
      overshootClamping: this._overshootClamping,
      restDisplacementThreshold: this._restDisplacementThreshold,
      restSpeedThreshold: this._restSpeedThreshold,
      stiffness: this._stiffness,
      damping: this._damping,
      mass: this._mass,
      initialVelocity: withDefault(this._initialVelocity, this._lastVelocity),
      toValue: this._toValue,
      iterations: this.__iterations
    };
  };

  _proto.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
    var _this2 = this;

    this.__active = true;
    this._startPosition = fromValue;
    this._lastPosition = this._startPosition;
    this._onUpdate = onUpdate;
    this.__onEnd = onEnd;
    this._lastTime = Date.now();
    this._frameTime = 0.0;

    if (previousAnimation instanceof SpringAnimation) {
      var internalState = previousAnimation.getInternalState();
      this._lastPosition = internalState.lastPosition;
      this._lastVelocity = internalState.lastVelocity; // Set the initial velocity to the last velocity

      this._initialVelocity = this._lastVelocity;
      this._lastTime = internalState.lastTime;
    }

    var start = function start() {
      if (_this2._useNativeDriver) {
        _this2.__startNativeAnimation(animatedValue);
      } else {
        _this2.onUpdate();
      }
    }; //  If this._delay is more than 0, we start after the timeout.


    if (this._delay) {
      this._timeout = setTimeout(start, this._delay);
    } else {
      start();
    }
  };

  _proto.getInternalState = function getInternalState() {
    return {
      lastPosition: this._lastPosition,
      lastVelocity: this._lastVelocity,
      lastTime: this._lastTime
    };
  }
  /**
   * This spring model is based off of a damped harmonic oscillator
   * (https://en.wikipedia.org/wiki/Harmonic_oscillator#Damped_harmonic_oscillator).
   *
   * We use the closed form of the second order differential equation:
   *
   * x'' + (2ζ⍵_0)x' + ⍵^2x = 0
   *
   * where
   *    ⍵_0 = √(k / m) (undamped angular frequency of the oscillator),
   *    ζ = c / 2√mk (damping ratio),
   *    c = damping constant
   *    k = stiffness
   *    m = mass
   *
   * The derivation of the closed form is described in detail here:
   * http://planetmath.org/sites/default/files/texpdf/39745.pdf
   *
   * This algorithm happens to match the algorithm used by CASpringAnimation,
   * a QuartzCore (iOS) API that creates spring animations.
   */
  ;

  _proto.onUpdate = function onUpdate() {
    // If for some reason we lost a lot of frames (e.g. process large payload or
    // stopped in the debugger), we only advance by 4 frames worth of
    // computation and will continue on the next frame. It's better to have it
    // running at faster speed than jumping to the end.
    var MAX_STEPS = 64;
    var now = Date.now();

    if (now > this._lastTime + MAX_STEPS) {
      now = this._lastTime + MAX_STEPS;
    }

    var deltaTime = (now - this._lastTime) / 1000;
    this._frameTime += deltaTime;
    var c = this._damping;
    var m = this._mass;
    var k = this._stiffness;
    var v0 = -this._initialVelocity;
    var zeta = c / (2 * Math.sqrt(k * m)); // damping ratio

    var omega0 = Math.sqrt(k / m); // undamped angular frequency of the oscillator (rad/ms)

    var omega1 = omega0 * Math.sqrt(1.0 - zeta * zeta); // exponential decay

    var x0 = this._toValue - this._startPosition; // calculate the oscillation from x0 = 1 to x = 0

    var position = 0.0;
    var velocity = 0.0;
    var t = this._frameTime;

    if (zeta < 1) {
      // Under damped
      var envelope = Math.exp(-zeta * omega0 * t);
      position = this._toValue - envelope * ((v0 + zeta * omega0 * x0) / omega1 * Math.sin(omega1 * t) + x0 * Math.cos(omega1 * t)); // This looks crazy -- it's actually just the derivative of the
      // oscillation function

      velocity = zeta * omega0 * envelope * (Math.sin(omega1 * t) * (v0 + zeta * omega0 * x0) / omega1 + x0 * Math.cos(omega1 * t)) - envelope * (Math.cos(omega1 * t) * (v0 + zeta * omega0 * x0) - omega1 * x0 * Math.sin(omega1 * t));
    } else {
      // Critically damped
      var _envelope = Math.exp(-omega0 * t);

      position = this._toValue - _envelope * (x0 + (v0 + omega0 * x0) * t);
      velocity = _envelope * (v0 * (t * omega0 - 1) + t * x0 * (omega0 * omega0));
    }

    this._lastTime = now;
    this._lastPosition = position;
    this._lastVelocity = velocity;

    this._onUpdate(position);

    if (!this.__active) {
      // a listener might have stopped us in _onUpdate
      return;
    } // Conditions for stopping the spring animation


    var isOvershooting = false;

    if (this._overshootClamping && this._stiffness !== 0) {
      if (this._startPosition < this._toValue) {
        isOvershooting = position > this._toValue;
      } else {
        isOvershooting = position < this._toValue;
      }
    }

    var isVelocity = Math.abs(velocity) <= this._restSpeedThreshold;

    var isDisplacement = true;

    if (this._stiffness !== 0) {
      isDisplacement = Math.abs(this._toValue - position) <= this._restDisplacementThreshold;
    }

    if (isOvershooting || isVelocity && isDisplacement) {
      if (this._stiffness !== 0) {
        // Ensure that we end up with a round value
        this._lastPosition = this._toValue;
        this._lastVelocity = 0;

        this._onUpdate(this._toValue);
      }

      this.__debouncedOnEnd({
        finished: true
      });

      return;
    }

    this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
  };

  _proto.stop = function stop() {
    _Animation.prototype.stop.call(this);

    this.__active = false;
    clearTimeout(this._timeout);
    global.cancelAnimationFrame(this._animationFrame);

    this.__debouncedOnEnd({
      finished: false
    });
  };

  return SpringAnimation;
}(_Animation__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* harmony default export */ __webpack_exports__["a"] = (SpringAnimation);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(52)))

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fromOrigamiTensionAndFriction */
/* unused harmony export fromBouncinessAndSpeed */
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


function stiffnessFromOrigamiValue(oValue) {
  return (oValue - 30) * 3.62 + 194;
}

function dampingFromOrigamiValue(oValue) {
  return (oValue - 8) * 3 + 25;
}

function fromOrigamiTensionAndFriction(tension, friction) {
  return {
    stiffness: stiffnessFromOrigamiValue(tension),
    damping: dampingFromOrigamiValue(friction)
  };
}

function fromBouncinessAndSpeed(bounciness, speed) {
  function normalize(value, startValue, endValue) {
    return (value - startValue) / (endValue - startValue);
  }

  function projectNormal(n, start, end) {
    return start + n * (end - start);
  }

  function linearInterpolation(t, start, end) {
    return t * end + (1 - t) * start;
  }

  function quadraticOutInterpolation(t, start, end) {
    return linearInterpolation(2 * t - t * t, start, end);
  }

  function b3Friction1(x) {
    return 0.0007 * Math.pow(x, 3) - 0.031 * Math.pow(x, 2) + 0.64 * x + 1.28;
  }

  function b3Friction2(x) {
    return 0.000044 * Math.pow(x, 3) - 0.006 * Math.pow(x, 2) + 0.36 * x + 2;
  }

  function b3Friction3(x) {
    return 0.00000045 * Math.pow(x, 3) - 0.000332 * Math.pow(x, 2) + 0.1078 * x + 5.84;
  }

  function b3Nobounce(tension) {
    if (tension <= 18) {
      return b3Friction1(tension);
    } else if (tension > 18 && tension <= 44) {
      return b3Friction2(tension);
    } else {
      return b3Friction3(tension);
    }
  }

  var b = normalize(bounciness / 1.7, 0, 20);
  b = projectNormal(b, 0, 0.8);
  var s = normalize(speed / 1.7, 0, 20);
  var bouncyTension = projectNormal(s, 0.5, 200);
  var bouncyFriction = quadraticOutInterpolation(b, b3Nobounce(bouncyTension), 0.01);
  return {
    stiffness: stiffnessFromOrigamiValue(bouncyTension),
    damping: dampingFromOrigamiValue(bouncyFriction)
  };
}


/* harmony default export */ __webpack_exports__["a"] = ({
  fromOrigamiTensionAndFriction: fromOrigamiTensionAndFriction,
  fromBouncinessAndSpeed: fromBouncinessAndSpeed
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var _Animation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37);
/* harmony import */ var _Easing__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50);
/* harmony import */ var _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }







var _easeInOut;

function easeInOut() {
  if (!_easeInOut) {
    _easeInOut = _Easing__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].inOut(_Easing__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"].ease);
  }

  return _easeInOut;
}

var TimingAnimation =
/*#__PURE__*/
function (_Animation) {
  _inheritsLoose(TimingAnimation, _Animation);

  function TimingAnimation(config) {
    var _this;

    _this = _Animation.call(this) || this;
    _this._toValue = config.toValue;
    _this._easing = config.easing !== undefined ? config.easing : easeInOut();
    _this._duration = config.duration !== undefined ? config.duration : 500;
    _this._delay = config.delay !== undefined ? config.delay : 0;
    _this.__iterations = config.iterations !== undefined ? config.iterations : 1;
    _this.__isInteraction = config.isInteraction !== undefined ? config.isInteraction : true;
    _this._useNativeDriver = Object(_NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_2__[/* shouldUseNativeDriver */ "c"])(config);
    return _this;
  }

  var _proto = TimingAnimation.prototype;

  _proto.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
    var frameDuration = 1000.0 / 60.0;
    var frames = [];

    for (var dt = 0.0; dt < this._duration; dt += frameDuration) {
      frames.push(this._easing(dt / this._duration));
    }

    frames.push(this._easing(1));
    return {
      type: 'frames',
      frames: frames,
      toValue: this._toValue,
      iterations: this.__iterations
    };
  };

  _proto.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
    var _this2 = this;

    this.__active = true;
    this._fromValue = fromValue;
    this._onUpdate = onUpdate;
    this.__onEnd = onEnd;

    var start = function start() {
      // Animations that sometimes have 0 duration and sometimes do not
      // still need to use the native driver when duration is 0 so as to
      // not cause intermixed JS and native animations.
      if (_this2._duration === 0 && !_this2._useNativeDriver) {
        _this2._onUpdate(_this2._toValue);

        _this2.__debouncedOnEnd({
          finished: true
        });
      } else {
        _this2._startTime = Date.now();

        if (_this2._useNativeDriver) {
          _this2.__startNativeAnimation(animatedValue);
        } else {
          _this2._animationFrame = requestAnimationFrame(_this2.onUpdate.bind(_this2));
        }
      }
    };

    if (this._delay) {
      this._timeout = setTimeout(start, this._delay);
    } else {
      start();
    }
  };

  _proto.onUpdate = function onUpdate() {
    var now = Date.now();

    if (now >= this._startTime + this._duration) {
      if (this._duration === 0) {
        this._onUpdate(this._toValue);
      } else {
        this._onUpdate(this._fromValue + this._easing(1) * (this._toValue - this._fromValue));
      }

      this.__debouncedOnEnd({
        finished: true
      });

      return;
    }

    this._onUpdate(this._fromValue + this._easing((now - this._startTime) / this._duration) * (this._toValue - this._fromValue));

    if (this.__active) {
      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
    }
  };

  _proto.stop = function stop() {
    _Animation.prototype.stop.call(this);

    this.__active = false;
    clearTimeout(this._timeout);
    global.cancelAnimationFrame(this._animationFrame);

    this.__debouncedOnEnd({
      finished: false
    });
  };

  return TimingAnimation;
}(_Animation__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* harmony default export */ __webpack_exports__["a"] = (TimingAnimation);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(52)))

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
var TouchEventUtils = {
  /**
   * Utility function for common case of extracting out the primary touch from a
   * touch event.
   * - `touchEnd` events usually do not have the `touches` property.
   *   http://stackoverflow.com/questions/3666929/
   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
   *
   * @param {Event} nativeEvent Native event that may or may not be a touch.
   * @return {TouchesObject?} an object with pageX and pageY or null.
   */
  extractSingleTouch: function extractSingleTouch(nativeEvent) {
    var touches = nativeEvent.touches;
    var changedTouches = nativeEvent.changedTouches;
    var hasTouches = touches && touches.length > 0;
    var hasChangedTouches = changedTouches && changedTouches.length > 0;
    return !hasTouches && hasChangedTouches ? changedTouches[0] : hasTouches ? touches[0] : nativeEvent;
  }
};
module.exports = TouchEventUtils;

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__88__;

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const spacers = {
    S: '4px',
    M: '8px',
    L: '16px',
    XL: '24px',
    XXL: '32px',
};
exports.default = spacers;


/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const typography = {
    TinyParagraph: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '12px',
        fontWeight: 500,
        lineHeight: '17px',
        letterSpacing: 'normal',
    },
    Paragraph: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '16px',
        fontWeight: 500,
        lineHeight: '27px',
        letterSpacing: 'normal',
    },
    LargeParagraph: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '24px',
        fontWeight: 400,
        lineHeight: '35px',
        letterSpacing: 'normal',
    },
    SmallCapsHeadline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '12px',
        fontWeight: 800,
        lineHeight: '15px',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
    },
    SmallHeadline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '16px',
        fontWeight: 800,
        lineHeight: '19px',
        letterSpacing: 'normal',
    },
    Subheadline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '24px',
        fontWeight: 800,
        lineHeight: '26px',
        letterSpacing: 'normal',
    },
    Headline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '36px',
        fontWeight: 800,
        lineHeight: '39px',
        letterSpacing: '-0.01em',
    },
    SuperHeadline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '48px',
        fontWeight: 800,
        lineHeight: '52px',
        letterSpacing: '-0.01em',
    },
    HugeHeadline: {
        fontFamily: 'Inter, sans-serif',
        fontSize: '80px',
        fontWeight: 900,
        lineHeight: '77px',
        letterSpacing: '-0.03em',
    },
};
exports.default = typography;


/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
const brandColors = {
    Primary_Red_120: '#BA264D',
    Primary_Red_100: '#FE1251',
    Primary_Red_75: '#FE4D7C',
    Primary_Red_50: '#FE88A8',
    Primary_Red_25: '#FFC4D3',
    Primary_Red_7: '#FFEEF3',
    Primary_Red_7D: '#5F2836',
    Primary_Blue_120: '#64B0BF',
    Primary_Blue_100: '#59DEF3',
    Primary_Blue_75: '#82E6F6',
    Primary_Blue_50: '#ACEEF9',
    Primary_Blue_25: '#E3F7FC',
    Primary_Blue_7: '#F3FDFE',
    Primary_Blue_140: '#358592',
    Primary_Blue_160: '#245961',
    Primary_Green_120: '#54A494',
    Primary_Green_100: '#3ACFB9',
    Primary_Green_75: '#6BDBCA',
    Primary_Green_50: '#9CE7DC',
    Primary_Green_25: '#CEF3ED',
    Primary_Green_7: '#EBFAF8',
    Primary_Green_140: '#1D685D',
    Primary_Green_160: '#29524A',
};
exports.default = brandColors;


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetgroverButton; });
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(160);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_index_scss__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bem_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);
/* harmony import */ var react_bem_classes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_bem_classes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(0);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
var _dec, _class, _class2, _temp; /* eslint-disable */




let
















GetgroverButton = (_dec = react_bem_classes__WEBPACK_IMPORTED_MODULE_2___default()({ block: 'getgroverButton', modifiers: ['primary', 'primaryOutline', 'small', 'arrow', 'arrowWhite', 'white', 'loading', 'centred', 'fullWidth', 'disabled'] }), _dec(_class = (_temp = _class2 = class GetgroverButton extends react__WEBPACK_IMPORTED_MODULE_1__["Component"] {












  render() {
    const {
      type,
      loading,
      onClick,
      style,
      children } =
    this.props;
    return /*#__PURE__*/(
      react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("button", {
        className: this.block(),
        type: type,
        onClick: loading ? () => {} : onClick }, /*#__PURE__*/

      react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: this.element('wrap'), style: style }, /*#__PURE__*/
      react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: this.element('arrow') }),
      children)));



  }}, _class2.propTypes = { type: prop_types__WEBPACK_IMPORTED_MODULE_3__["string"], loading: prop_types__WEBPACK_IMPORTED_MODULE_3__["bool"], onClick: prop_types__WEBPACK_IMPORTED_MODULE_3__["func"], children: prop_types__WEBPACK_IMPORTED_MODULE_3__["node"], style: prop_types__WEBPACK_IMPORTED_MODULE_3__["object"] }, _class2.defaultTypes = { type: 'button', onClick: () => {} }, _temp)) || _class);

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetgroverFormInput; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(0);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bem_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);
/* harmony import */ var react_bem_classes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_bem_classes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28);
/* harmony import */ var react_input_mask__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(163);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_scss__WEBPACK_IMPORTED_MODULE_5__);
var _dec, _class, _class2, _temp;function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);} /* eslint-disable */






let







GetgroverFormInput = (_dec = react_bem_classes__WEBPACK_IMPORTED_MODULE_2___default()({ block: 'getgroverFormInput', modifiers: ['eye'] }), _dec(_class = (_temp = _class2 = class GetgroverFormInput extends react__WEBPACK_IMPORTED_MODULE_0__["Component"] {























  constructor(props) {
    super(props);

    this.state = {
      active: false,
      activeEye: false,
      inputType: props.input.type };


    this.changeInputType = this.changeInputType.bind(this);
    this.renderEye = this.renderEye.bind(this);
  }

  changeInputType() {
    const
    { inputType, activeEye } = this.state,
    textType = 'text',
    passwordType = 'password';

    this.setState({
      inputType: inputType === passwordType ? textType : passwordType,
      activeEye: !activeEye });

  }

  renderEye() {
    const
    { eye } = this.props,
    { activeEye } = this.state;

    return !eye ? null : /*#__PURE__*/
    react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: this.element('eye', { active: activeEye }), onClick: this.changeInputType });
  }

  render() {
    const
    { active, inputType } = this.state,
    { input, label, error } = this.props,
    { name, value, mask, onFocus, onBlur } = input;

    return /*#__PURE__*/(
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_box__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
        inputName: name,
        active: active || !!value,
        label: label,
        error: error }, /*#__PURE__*/

      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", { className: this.block() },
      this.renderEye(),
      mask ? /*#__PURE__*/
      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react_input_mask__WEBPACK_IMPORTED_MODULE_4__[/* default */ "a"], input) : /*#__PURE__*/

      react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("input", _extends({
        autoComplete: "off" },
      input, {
        type: inputType,
        onFocus: e => {
          this.setState({ active: true });
          onFocus && onFocus(e);
        },
        onBlur: e => {
          this.setState({ active: false });
          onBlur && onBlur(e);
        } })))));





  }}, _class2.propTypes = { eye: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, input: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.object, label: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string, error: prop_types__WEBPACK_IMPORTED_MODULE_1___default.a.string }, _class2.defaultProps = { label: 'Email address:', error: '', input: { type: 'text', name: 'input', value: 'anytext@gmail.com', onChange: () => {}, onClick: () => {}, onFocus: () => {}, onBlur: () => {}, mask: '', placeholderChar: ' ', formatCharacters: {} } }, _temp)) || _class);

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetgroverFormSelect; });
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(164);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_index_scss__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bem_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);
/* harmony import */ var react_bem_classes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_bem_classes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
var _dec, _class, _class2, _temp; /* eslint-disable */





let




GetgroverFormSelect = (_dec = react_bem_classes__WEBPACK_IMPORTED_MODULE_2___default()({ block: 'getgroverFormSelect' }), _dec(_class = (_temp = _class2 = class GetgroverFormSelect extends react__WEBPACK_IMPORTED_MODULE_1__["Component"] {




























  constructor(props) {
    super(props);

    this.state = {
      active: false };

  }

  render() {
    const
    { active } = this.state,
    { input, label, error } = this.props,
    { name, value, options, onChange, onFocus, onBlur, onClick } = input;

    return /*#__PURE__*/(
      react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_box__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
        inputName: name,
        active: active || !!value,
        label: label,
        error: error }, /*#__PURE__*/
      react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: this.block() }, /*#__PURE__*/
      react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: this.element('down') }), /*#__PURE__*/
      react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("select", {
        name: name,
        value: value,
        autoComplete: "off",
        onFocus: e => {
          this.setState({ active: true });
          onFocus && onFocus(e);
        },
        onBlur: e => {
          this.setState({ active: false });
          onBlur && onBlur(e);
        },
        onChange: onChange,
        onClick: onClick }, /*#__PURE__*/
      react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("option", { value: null }, " "),
      options.map((option, i) => /*#__PURE__*/
      react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("option", { key: i, value: option.value }, option.text))))));





  }}, _class2.propTypes = { label: prop_types__WEBPACK_IMPORTED_MODULE_4__["string"], input: prop_types__WEBPACK_IMPORTED_MODULE_4__["object"], error: prop_types__WEBPACK_IMPORTED_MODULE_4__["string"] }, _class2.defaultProps = { label: 'Email address:', error: '', input: { name: 'select', value: '', options: [{ text: 'First option', value: 1 }, { text: 'Second option', value: 2 }], onChange: () => {}, onClick: () => {}, onFocus: () => {}, onBlur: () => {} } }, _temp)) || _class);

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetgroverFormCheckbox; });
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(166);
/* harmony import */ var _index_scss__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_index_scss__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_bem_classes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14);
/* harmony import */ var react_bem_classes__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_bem_classes__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _box__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(28);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(0);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_4__);
var _dec, _class, _class2, _temp; /* eslint-disable */




let




GetgroverFormCheckbox = (_dec = react_bem_classes__WEBPACK_IMPORTED_MODULE_2___default()({ block: 'getgroverFormCheckbox' }), _dec(_class = (_temp = _class2 = class GetgroverFormCheckbox extends react__WEBPACK_IMPORTED_MODULE_1__["Component"] {















  render() {
    const
    { input, error, autoHeight, noBorder } = this.props,
    { name, value, onChange, onFocus, onBlur, onClick } = input;

    return /*#__PURE__*/(
      react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_box__WEBPACK_IMPORTED_MODULE_3__[/* default */ "a"], {
        autoHeight: autoHeight,
        noBorder: noBorder,
        inputName: name,
        error: error }, /*#__PURE__*/
      react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("label", { className: this.block({ active: value, autoHeight }) }, /*#__PURE__*/
      react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: this.element('box') }, /*#__PURE__*/
      react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: this.element('dot') }), /*#__PURE__*/
      react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", { className: this.element('label') },
      this.props.children, /*#__PURE__*/
      react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("input", {
        type: "checkbox",
        name: name,
        checked: value,
        autoComplete: "off",
        onChange: onChange,
        onFocus: onFocus,
        onBlur: onBlur,
        onClick: onClick }))))));






  }}, _class2.defaultProps = { autoHeight: true, noBorder: true, error: '', input: { name: 'checkbox', value: true, onChange: () => {}, onClick: () => {}, onFocus: () => {}, onBlur: () => {} } }, _temp)) || _class);



GetgroverFormCheckbox.propTypes = {
  input: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object,
  error: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.string,
  autoHeight: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,
  noBorder: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.bool,
  children: prop_types__WEBPACK_IMPORTED_MODULE_4___default.a.object.isRequired };

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = capitalizeString;
function capitalizeString(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponents = void 0;
function getComponents(defaultComponents, overrides) {
    const result = {};
    const componentNames = Object.keys(defaultComponents);
    componentNames.forEach((componentName) => {
        const { component: overridesComponent, props: overridesProps = {} } = (overrides[componentName] || {});
        result[componentName] = {
            component: overridesComponent || defaultComponents[componentName],
            props: { ...overridesProps },
        };
    });
    return result;
}
exports.getComponents = getComponents;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var If_1 = __webpack_require__(194);
Object.defineProperty(exports, "default", { enumerable: true, get: function () { return If_1.default; } });


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Heart = void 0;
const react_1 = __importDefault(__webpack_require__(1));
exports.Heart = ({ className, size = '30px', color = '#333333', background = 'transparent', }) => (react_1.default.createElement("svg", { className: className, width: size, height: size, fill: background },
    react_1.default.createElement("path", { d: "M9.24282 3.49861L10.0003 4.37747L10.7578 3.49861C11.5964 2.52562 12.6571 1.48187 14.511 1.48187C16.7283 1.48187 18.5406 3.33234 18.5406 5.61718C18.5406 7.91108 16.9301 10.2047 14.8214 12.2571C13.7919 13.2591 12.6947 14.1554 11.7186 14.9154C11.3815 15.1779 11.0491 15.4312 10.7374 15.6688C10.4738 15.8699 10.2248 16.0596 10.0003 16.2341C9.77574 16.0596 9.52682 15.8699 9.26314 15.6688C8.95144 15.4312 8.61911 15.1779 8.28199 14.9154C7.30593 14.1554 6.20866 13.2591 5.17918 12.2571C3.07046 10.2047 1.46002 7.91108 1.46002 5.61718C1.46002 3.30202 3.30199 1.48187 5.48962 1.48187C7.34351 1.48187 8.40422 2.52562 9.24282 3.49861Z", fill: background, stroke: color, strokeWidth: "2" })));


/***/ }),
/* 101 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  RESISTANCE_COEF: 0.6,
  // This value is closed to what browsers are using internally to
  // trigger a native scroll.
  UNCERTAINTY_THRESHOLD: 3 // px

};
exports.default = _default;

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
const react_1 = __importStar(__webpack_require__(1));
const Icons_1 = __webpack_require__(17);
const styles_1 = __webpack_require__(241);
exports.Input = ({ isDisabled = false, type = 'text', error, value, label, name, placeholder, isPassword, onChange, maskProps, className, ...rest }) => {
    const [val, setVal] = react_1.useState(value);
    const [inputType, setInputType] = react_1.useState(isPassword ? 'password' : type);
    const [showPass, setShowPass] = react_1.useState(false);
    react_1.useEffect(() => {
        if (value && value !== val) {
            setVal(value);
        }
    }, [val, value, setVal]);
    const inputChange = react_1.useCallback((e) => {
        if (onChange) {
            onChange(e);
        }
        setVal(e.target.value);
    }, [onChange]);
    const handlePass = react_1.useCallback(() => {
        setShowPass(!showPass);
        setInputType(showPass ? 'password' : 'text');
    }, [showPass]);
    const isMaskedInput = Boolean(maskProps && maskProps.mask);
    return (react_1.default.createElement(styles_1.InputWrapper, { className: className },
        react_1.default.createElement(styles_1.StyledInput, { className: className && `${className}-container`, isDisabled: isDisabled, error: error },
            react_1.default.createElement(styles_1.InputField, Object.assign({ className: className && `${className}-input`, name: name, role: "textbox", "aria-invalid": !!error, type: inputType, disabled: isDisabled, placeholder: placeholder, value: val, onChange: inputChange, isMask: isMaskedInput }, maskProps, rest)),
            !!label && (react_1.default.createElement(styles_1.InputLabel, { htmlFor: name, className: className && `${className}-label`, active: !!val }, label)),
            isPassword && (react_1.default.createElement(styles_1.InputIcon, { className: className && `${className}-passIcon`, "aria-label": showPass ? 'Hide password' : 'Show password', onClick: handlePass }, showPass ? react_1.default.createElement(Icons_1.IconEye, null) : react_1.default.createElement(Icons_1.IconEyeOff, null)))),
        !!error && (react_1.default.createElement(styles_1.InputError, { className: className && `${className}-error`, role: "alert" }, error))));
};


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Radio = void 0;
const react_1 = __importStar(__webpack_require__(1));
const isFunction_1 = __importDefault(__webpack_require__(40));
const styles_1 = __webpack_require__(242);
exports.Radio = ({ className, name, id, label, onClick, disabled, borderColor, dotColor, checked, }) => {
    const handleChange = react_1.useCallback((event) => {
        if (onClick && isFunction_1.default(onClick)) {
            onClick(event);
        }
    }, [onClick]);
    return (react_1.default.createElement(styles_1.Container, { className: className, disabled: disabled },
        react_1.default.createElement(styles_1.Label, { htmlFor: id },
            react_1.default.createElement(styles_1.RadioInput, { type: "radio", id: id, name: name, onClick: handleChange, disabled: disabled, dotColor: dotColor, checked: checked }),
            react_1.default.createElement(styles_1.Dot, { borderColor: borderColor }),
            label && react_1.default.createElement(styles_1.Text, null, label))));
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const react_1 = __importStar(__webpack_require__(1));
const styles_1 = __webpack_require__(243);
exports.Checkbox = ({ className, accentColor, name, children, defaultState, onClick, }) => {
    const [active, setActive] = react_1.useState(defaultState);
    const handleChange = () => {
        setActive(!active);
    };
    return (react_1.default.createElement(styles_1.CheckboxWrapper, null,
        react_1.default.createElement(styles_1.BoxWrapper, null,
            react_1.default.createElement(styles_1.CheckboxInput, { type: "checkbox", checked: active, className: className, onChange: handleChange, name: name, onClick: onClick }),
            active && react_1.default.createElement(styles_1.Check, { "data-testid": "checkmark", accentColor: accentColor })),
        children));
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DropDown = void 0;
const react_1 = __importStar(__webpack_require__(1));
const isFunction_1 = __importDefault(__webpack_require__(40));
const useOverrides_1 = __webpack_require__(32);
const styles_1 = __webpack_require__(244);
const defaultComponents = {
    List: styles_1.List,
    ListElement: styles_1.ListElement,
    Container: styles_1.Container,
    SelectedItem: styles_1.SelectedItem,
    Placeholder: styles_1.Placeholder,
    ItemText: styles_1.ItemText,
    IconWrap: styles_1.IconWrap,
};
const DefaultProps = {
    overrides: {},
    onChange: () => null,
    onClose: () => null,
    onOpen: () => null,
    options: [],
};
exports.DropDown = ({ className, defaultValue, placeholder, options = DefaultProps.options, onOpen = DefaultProps.onOpen, onChange = DefaultProps.onChange, onClose = DefaultProps.onClose, overrides = DefaultProps.overrides, }) => {
    const rootRef = react_1.useRef(null);
    const [isOpen, setIsOpen] = react_1.useState(false);
    const isMultiple = Array.isArray(options) && options.length > 1;
    const [selectedValue, setSelectedValue] = react_1.useState(null);
    react_1.useEffect(() => {
        if (defaultValue && isMultiple) {
            const findedOption = options.find((o) => o.value === defaultValue.value && o.label === defaultValue.label) || null;
            setSelectedValue(findedOption);
        }
        else if (options.length === 1) {
            setSelectedValue(options[0]);
        }
        else {
            setSelectedValue(null);
        }
    }, [defaultValue, isMultiple]);
    const handleOpen = react_1.useCallback(() => {
        setIsOpen(true);
        if (onOpen && isFunction_1.default(onOpen)) {
            onOpen();
        }
    }, [onOpen]);
    const handleClose = react_1.useCallback(() => {
        setIsOpen(false);
        if (onClose && isFunction_1.default(onClose)) {
            onClose();
        }
    }, [onClose]);
    const getChangeCallback = react_1.useCallback((element) => () => {
        setSelectedValue(element);
        if (onChange && isFunction_1.default(onChange)) {
            onChange(element);
        }
        handleClose();
    }, [handleClose, onChange]);
    const handleClickOutside = react_1.useCallback((event) => {
        if (event &&
            rootRef &&
            rootRef.current &&
            !rootRef.current.contains(event.target) &&
            isOpen) {
            handleClose();
        }
    }, [handleClose, isOpen]);
    const { Container: { component: Container }, List: { component: List }, ListElement: { component: ListElement }, SelectedItem: { component: SelectedItem }, Placeholder: { component: Placeholder }, ItemText: { component: ItemText }, IconWrap: { component: IconWrap }, } = useOverrides_1.useOverrides(defaultComponents, overrides);
    react_1.useEffect(() => {
        if (!isMultiple) {
            return () => null;
        }
        window.addEventListener('click', handleClickOutside, true);
        return function cleanup() {
            window.removeEventListener('click', handleClickOutside, true);
        };
    }, [handleClickOutside, isMultiple]);
    return (react_1.default.createElement(Container, { className: className, "data-testid": "dropdown-root-test-id", ref: rootRef },
        react_1.default.createElement(SelectedItem, { onClick: isMultiple ? handleOpen : null, "data-testid": "dropdown-selected-item-test-id", isMultiple: isMultiple },
            selectedValue && selectedValue.icon && react_1.default.createElement(IconWrap, null, selectedValue.icon),
            react_1.default.createElement(ItemText, null,
                selectedValue && selectedValue.label,
                !selectedValue && placeholder && react_1.default.createElement(Placeholder, null, placeholder)),
            isMultiple && react_1.default.createElement(styles_1.Chevron, null)),
        isMultiple && (react_1.default.createElement(List, { isOpen: isOpen, "data-testid": "dropdown-list-test-id" }, options.map((o) => (react_1.default.createElement(ListElement, { key: o.label + o.value, onClick: getChangeCallback(o) },
            o.icon && react_1.default.createElement(IconWrap, null, o.icon),
            react_1.default.createElement(ItemText, null, o.label))))))));
};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BtnIcon = exports.BtnText = exports.BtnContent = exports.Btn = void 0;
const styled_components_1 = __importDefault(__webpack_require__(2));
const colorHelper_1 = __webpack_require__(247);
const btnSize = (small) => {
    return small ? '32px' : '48px';
};
const getButtonPadding = (iconBtn, small, hasChildren) => {
    if (iconBtn && !hasChildren) {
        if (small) {
            return '8px';
        }
        return '14px';
    }
    if (iconBtn) {
        if (small) {
            return '2px 8px';
        }
        return '14px 16px';
    }
    if (small) {
        return '6px 16px';
    }
    return '14px 24px';
};
exports.Btn = styled_components_1.default.button `
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${({ iconBtn, small, hasChildren }) => getButtonPadding(iconBtn, small, hasChildren)};
    height: ${({ small }) => btnSize(small)};
    min-width: ${({ small }) => btnSize(small)};
    width: ${({ fullWidth }) => (fullWidth ? '100%' : 'fit-content')};

    color: ${({ theme, color, outlined }) => outlined
    ? colorHelper_1.mapColors({
        theme,
        color: color === 'grey' || color === 'white' ? theme.colors.Foreground : color,
    })
    : ((color === 'grey' || color === 'white') && theme.colors.Foreground) ||
        theme.colors.Background};
    background-color: ${({ theme, outlined, color }) => outlined ? 'transparent' : colorHelper_1.mapColors({ theme, color })};
    border: 2px solid
        ${({ theme, outlined, borderColor }) => outlined ? borderColor || theme.colors['Level 1'] : 'transparent'};
    border-radius: 88px;
    box-sizing: border-box;
    outline: transparent;
    overflow: hidden;
    cursor: pointer;
    transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.3s;

    &:disabled {
        color: ${({ theme }) => theme.colors['Level 1']};
        background-color: ${({ theme }) => theme.colors['Level 1']};
        border-color: transparent;
        cursor: not-allowed;
    }

    &:hover,
    &:active {
        &:not(:disabled) {
            color: ${({ theme, color }) => color === 'black' || color === 'grey' || color === 'white'
    ? theme.colors.Foreground
    : theme.colors.Background};
            background-color: ${({ theme, color, outlined }) => outlined ? colorHelper_1.mapColors({ theme, color }) : colorHelper_1.mapColorsHover({ theme, color })};
            border-color: transparent;
        }
    }
`;
exports.BtnContent = styled_components_1.default.div `
    ${({ theme }) => theme.typography.SmallHeadline};
    display: flex;
    align-items: center;
    overflow: hidden;
    max-width: 100%;
`;
exports.BtnText = styled_components_1.default.span `
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
exports.BtnIcon = styled_components_1.default.span `
    display: inline-flex;
    align-self: center;
    color: currentColor;
    fill: currentColor;
    max-width: ${({ small }) => (small ? '20px' : '24px')};

    &:only-child {
        justify-self: center;
    }

    &:not(:only-child) {
        margin-right: 8px;
    }
`;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleDismissButton = void 0;
const react_1 = __importStar(__webpack_require__(1));
const styled_components_1 = __webpack_require__(2);
const Icons_1 = __webpack_require__(17);
const DismissingCardContext_1 = __webpack_require__(55);
const styles_1 = __webpack_require__(42);
exports.CircleDismissButton = ({ className, position, }) => {
    const { dismiss } = react_1.useContext(DismissingCardContext_1.DismissingCardContext);
    const theme = react_1.useContext(styled_components_1.ThemeContext);
    return (react_1.default.createElement(styles_1.CircleDismissButton, { small: true, onClick: dismiss, "aria-label": "Dismiss", className: className, icon: react_1.default.createElement(Icons_1.Close, { color: theme.colors['Level 5'] }), "$position": position }));
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeedbackCard = void 0;
const react_1 = __importStar(__webpack_require__(1));
const function_1 = __webpack_require__(74);
const DismissingCard_1 = __webpack_require__(31);
const types_1 = __webpack_require__(43);
const context_1 = __importDefault(__webpack_require__(56));
const steps_1 = __importDefault(__webpack_require__(256));
exports.FeedbackCard = ({ className, copyConfig, onSubmit, onDismiss, reasonRequired = false, hasTimeout = true, hasDismissButton = true, hasUndoButton = true, }) => {
    var _a;
    const [reason, setReason] = react_1.useState('');
    const [step, setStep] = react_1.useState(types_1.Steps.Emoji);
    const [feedback, setFeedback] = react_1.useState(types_1.Feedback.Horrible);
    const resetState = react_1.useCallback(() => {
        setFeedback(types_1.Feedback.Horrible);
        setReason('');
    }, []);
    const handleFeedback = react_1.useCallback((newFeedback) => {
        setFeedback(newFeedback);
        setStep(types_1.Steps.Reason);
    }, []);
    const handleSubmit = react_1.useCallback(() => {
        onSubmit({ feedback, reason });
        setStep(types_1.Steps.Conclusion);
        resetState();
    }, [feedback, reason, onSubmit, resetState]);
    const handleDismiss = react_1.useCallback(() => {
        if (function_1.isFunction(onDismiss)) {
            onDismiss();
        }
    }, [onDismiss]);
    return (react_1.default.createElement(context_1.default.Provider, { value: {
            feedback,
            reason,
            setReason,
            copyConfig,
            reasonRequired,
            handleFeedback,
            handleDismiss,
            handleSubmit,
        } },
        react_1.default.createElement(DismissingCard_1.DismissingCard, { className: className, hasTimeout: hasTimeout, hasCircleButton: hasDismissButton, hasUndo: hasUndoButton, undoButtonText: copyConfig.undoButtonText, onDismiss: handleDismiss, dismissedText: (_a = copyConfig.dismissedText) !== null && _a !== void 0 ? _a : '' },
            react_1.default.createElement(steps_1.default, { step: step }))));
};


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MarketingCard = void 0;
const react_1 = __importStar(__webpack_require__(1));
const styled_components_1 = __webpack_require__(2);
const DismissingCard_1 = __webpack_require__(31);
const MarkdownParser_1 = __webpack_require__(57);
const colorKeyMap_1 = __webpack_require__(262);
const styles_1 = __webpack_require__(264);
exports.MarketingCard = ({ className, imageUrl, bodyTemplate, actions, hasCircleDismissButton, onDismiss, dismissedText, undoButtonText, hasLargeImage, colorFunction, }) => {
    const theme = react_1.useContext(styled_components_1.ThemeContext);
    const Img = hasLargeImage ? styles_1.LargeImage : styles_1.Image;
    const circleButtonPosition = react_1.useMemo(() => {
        if (hasLargeImage) {
            return { top: 24, right: 24 };
        }
        if (!imageUrl) {
            return { top: 8, right: 8 };
        }
        return undefined;
    }, [hasLargeImage, imageUrl]);
    return (react_1.default.createElement(DismissingCard_1.DismissingCard, { className: className, onDismiss: onDismiss, hasCircleButton: hasCircleDismissButton, dismissedText: dismissedText, undoButtonText: undoButtonText, circleButtonPosition: circleButtonPosition, hasTimeout: true, backgroundColor: colorFunction
            ? theme.colors[colorKeyMap_1.BackgroundColorKeyMap[colorFunction]]
            : theme.colors.ElementBackground, borderColor: colorFunction
            ? theme.colors[colorKeyMap_1.BackgroundColorKeyMap[colorFunction]]
            : theme.colors['Level 1'] },
        imageUrl && (react_1.default.createElement(styles_1.MarketingHeader, null,
            react_1.default.createElement(Img, { src: imageUrl, alt: "MarketingImage" }))),
        react_1.default.createElement(MarkdownParser_1.MarkdownParser, { titleColor: colorFunction
                ? theme.colors[colorKeyMap_1.TextColorKeyMap[colorFunction]]
                : theme.colors.Foreground, paragraphColor: colorFunction
                ? theme.colors[colorKeyMap_1.TextColorKeyMap[colorFunction]]
                : theme.colors['Level 5'] }, bodyTemplate),
        react_1.default.createElement(react_1.default.Fragment, null, actions)));
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionBadge = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const MarkdownParser_1 = __webpack_require__(57);
const DismissButton_1 = __webpack_require__(265);
const styles_1 = __webpack_require__(113);
exports.SubscriptionBadge = ({ className, onClick, onDismiss, children, icon, bodyTemplate, dismissedText, undoButtonText, }) => (react_1.default.createElement(styles_1.Container, { className: className },
    react_1.default.createElement(styles_1.BadgeDismissingCard, { dismissedText: dismissedText, undoButtonText: undoButtonText, onDismiss: onDismiss },
        react_1.default.createElement(styles_1.BadgeContainer, null,
            react_1.default.createElement(styles_1.Wrap, { onClick: onClick },
                icon,
                react_1.default.createElement(styles_1.Text, null,
                    react_1.default.createElement(MarkdownParser_1.MarkdownParser, null, bodyTemplate))),
            react_1.default.createElement(DismissButton_1.DismissButton, null))),
    children));


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleDismissButton = exports.BadgeDismissingCard = exports.Text = exports.Wrap = exports.BadgeContainer = exports.Container = void 0;
const styled_components_1 = __importDefault(__webpack_require__(2));
const Button_1 = __webpack_require__(33);
const DismissingCard_1 = __webpack_require__(31);
exports.Container = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    border-radius: 8px;
    background-color: ${(props) => props.theme.colors.secondaryBackground};
`;
exports.BadgeContainer = styled_components_1.default.div `
    padding: 6px 0;
    display: flex;
    flex-direction: row;
`;
exports.Wrap = styled_components_1.default.div `
    flex: 1 1 auto;
    display: flex;
    flex-direction: row;
    cursor: pointer;
`;
exports.Text = styled_components_1.default.p `
    flex: 1 1 auto;
    line-height: 24px;
    margin: 0 0 0 10px;
    color: ${(props) => props.theme.colors.secondary};
    ${({ theme }) => theme.typography.Paragraph}
`;
exports.BadgeDismissingCard = styled_components_1.default(DismissingCard_1.DismissingCard) `
    background-color: transparent;
    padding: 0;
    margin: 0;
    border: none;
    padding: 8px 14px;
`;
exports.CircleDismissButton = styled_components_1.default(Button_1.Button) `
    margin-left: 10px;
    width: 24px;
    height: 24px;
    border: none;
    border-radius: 12px;
    padding: 0;
    min-width: auto;
    background-color: transparent;
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
`;


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductCard = exports.CardTypeEnum = void 0;
const react_1 = __importStar(__webpack_require__(1));
const styled_components_1 = __webpack_require__(2);
const function_1 = __webpack_require__(74);
const Chip_1 = __webpack_require__(76);
const Icons_1 = __webpack_require__(17);
const styles_1 = __webpack_require__(267);
var CardTypeEnum;
(function (CardTypeEnum) {
    CardTypeEnum["tall"] = "tall";
    CardTypeEnum["wide"] = "wide";
})(CardTypeEnum = exports.CardTypeEnum || (exports.CardTypeEnum = {}));
exports.ProductCard = ({ id = '', slug, className, cardType = CardTypeEnum.tall, onCardClick, image, chips, isFavorite = false, onFavoriteClick, title, description, priceBlock, ...rest }) => {
    const theme = react_1.useContext(styled_components_1.ThemeContext);
    const [favorite, setFavorite] = react_1.useState(isFavorite);
    const [shouldAnimate, setShouldAnimate] = react_1.useState(false);
    if (!title || !image) {
        return null;
    }
    const toggleFavorite = () => {
        setFavorite(!favorite);
        setShouldAnimate(!favorite);
        if (onFavoriteClick && function_1.isFunction(onFavoriteClick)) {
            onFavoriteClick({ id, slug, state: favorite });
        }
    };
    return (react_1.default.createElement(styles_1.ProductCardWrapper, Object.assign({ "data-testid": "product-card-id", className: className, cardType: cardType, onClick: onCardClick }, rest),
        react_1.default.createElement(styles_1.ImgWrapper, { cardType: cardType }, typeof image === 'string' ? react_1.default.createElement(styles_1.Img, { src: image, alt: title }) : image),
        react_1.default.createElement(styles_1.FavoriteWrapper, { onClick: toggleFavorite },
            react_1.default.createElement(Icons_1.FavoriteBtn, { isActive: favorite, shouldAnimate: shouldAnimate, color: favorite ? 'transparent' : theme.colors['Level 3'], background: favorite ? theme.colors.Color1 : 'transparent' })),
        react_1.default.createElement(styles_1.TitleWrapper, null,
            Array.isArray(chips) && chips.length && (react_1.default.createElement(styles_1.ChipList, { cardType: cardType }, chips.filter(Boolean).map((i) => {
                var _a, _b;
                return (react_1.default.createElement(Chip_1.Chip, { key: `chip-${(i.label ? i.label : i).toString()}`, label: (_a = i === null || i === void 0 ? void 0 : i.label) !== null && _a !== void 0 ? _a : i, "$background": (_b = i === null || i === void 0 ? void 0 : i.background) !== null && _b !== void 0 ? _b : '' }));
            }))),
            react_1.default.createElement(styles_1.Title, { cardType: cardType }, title)),
        description && react_1.default.createElement(styles_1.Desc, { cardType: cardType }, description),
        priceBlock && react_1.default.createElement(styles_1.PriceWrapper, null, priceBlock)));
};


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var RadioBox_1 = __webpack_require__(268);
Object.defineProperty(exports, "RadioBox", { enumerable: true, get: function () { return RadioBox_1.RadioBox; } });
var RadioBoxGroup_1 = __webpack_require__(269);
Object.defineProperty(exports, "RadioBoxGroup", { enumerable: true, get: function () { return RadioBoxGroup_1.RadioBoxGroup; } });


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GroupContainer = exports.Text = exports.Label = exports.RadioButton = exports.Input = void 0;
const styled_components_1 = __importStar(__webpack_require__(2));
const elevation_1 = __webpack_require__(11);
exports.Input = styled_components_1.default.input `
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    margin: 0;
    opacity: 0;
    width: 100%;
    height: 100%;
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    cursor: pointer;
    z-index: 1;
`;
exports.RadioButton = styled_components_1.default.button `
    position: relative;
    max-width: 100%;
    flex: 0 0 auto;
    height: 40px;
    padding: 6px;
    margin-right: 8px;
    margin-bottom: 8px;
    border-radius: 8px;
    transition: all cubic-bezier(0.4, 0, 0.2, 1) 0.3s;
    -webkit-tap-highlight-color: transparent;
    outline: 0;
    border-style: solid;
    border-width: 2px;
    border-color: ${(props) => props.theme.colors['Level 1']};
    color: ${(props) => props.theme.colors['Level 5']};
    background-color: ${(props) => props.theme.colors.ElementBackground};

    :hover,
    :focus {
        border-color: transparent;
        ${elevation_1.elevation(2, true)}
    }

    ${(props) => props.isChecked &&
    styled_components_1.css `
            color: white;
            border-color: transparent;
            background-color: ${props.theme.colors.secondary};
        `}
`;
exports.Label = styled_components_1.default.label `
    display: flex;
    justify-content: center;
    align-items: center;
    color: inherit;
    overflow: hidden;
`;
exports.Text = styled_components_1.default.span `
    ${(props) => props.theme.typography.Paragraph}
    color: inherit;
    text-align: center;
    line-height: 24px;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
`;
exports.GroupContainer = styled_components_1.default.div `
    max-width: 100%;
    display: flex;
    flex-wrap: wrap;

    margin-right: -8px;
    margin-bottom: -8px;
`;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DismissButton = exports.DismissibleHintContent = exports.DismissibleHintContainer = exports.Text = exports.IconWrap = exports.Container = void 0;
const react_native_1 = __webpack_require__(83);
const styled_components_1 = __importStar(__webpack_require__(2));
const CircleDismissButton_1 = __webpack_require__(109);
exports.Container = styled_components_1.default.div `
    width: 100%;
    display: flex;
    border: none;
    border-radius: 8px;
    max-width: ${({ isFullWidth }) => (isFullWidth ? 'unset' : '448px')};
    padding: ${(props) => props.theme.spacers.M};
    background-color: ${(props) => { var _a; return (_a = props.backgroundColor) !== null && _a !== void 0 ? _a : 'rgba(255, 199, 0, 0.1)'; }};
`;
exports.IconWrap = styled_components_1.default(react_native_1.View) `
    flex-shrink: 0;
    margin-right: ${(props) => props.theme.spacers.M};
    height: 20px;
`;
exports.Text = styled_components_1.default(react_native_1.Text) `
    color: ${(props) => { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : props.theme.colors['Level 5']; }};
    ${(props) => styled_components_1.css(props.theme.typography.TinyParagraph)};
    align-self: center;
`;
exports.DismissibleHintContainer = styled_components_1.default(exports.Container) `
    display: block;
`;
exports.DismissibleHintContent = styled_components_1.default(react_native_1.View) `
    display: flex;
    flex-direction: row;
    margin-right: 22px;
`;
exports.DismissButton = styled_components_1.default(CircleDismissButton_1.CircleDismissButton) `
    background-color: transparent;
    width: 20px;
    height: 20px;
`;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Toggle = void 0;
const react_1 = __importStar(__webpack_require__(1));
const isFunction_1 = __importDefault(__webpack_require__(40));
const styles_1 = __webpack_require__(272);
const defaultProps = {
    className: '',
    disabled: false,
    color: '#fff',
    onChange: () => { },
    intermediate: false,
};
const Toggle = ({ id, className, color = defaultProps.color, disabled = defaultProps.disabled, onChange = defaultProps.onChange, intermediate = defaultProps.intermediate, checked, }) => {
    const [value, setValue] = react_1.useState(Boolean(checked) || false);
    const handleChange = react_1.useCallback(() => {
        if (disabled)
            return;
        if (isFunction_1.default(onChange)) {
            onChange(!value);
        }
        setValue((v) => !v);
    }, [onChange, value, disabled]);
    return (react_1.default.createElement(styles_1.Container, { className: className, "data-testid": "toggle-id", disabled: disabled },
        react_1.default.createElement(styles_1.Input, { "data-testid": "toggle-input-id", id: id, type: "checkbox", checked: checked, disabled: disabled, accentColor: color, onChange: handleChange, intermediate: intermediate }),
        react_1.default.createElement(styles_1.Label, { htmlFor: id, "data-testid": "toggle-label-id" })));
};
exports.Toggle = Toggle;


/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RentalPlanSelector = void 0;
const react_1 = __importStar(__webpack_require__(1));
const react_draggable_1 = __importDefault(__webpack_require__(81));
const constants_1 = __webpack_require__(120);
const styles_1 = __webpack_require__(273);
exports.RentalPlanSelector = ({ points, pointAccentColors, defaultPointIndex, pointIndex, onPointSelected, isHoverable = false, isDraggable = false, isDisabled = false, hasPlusLabel = false, }) => {
    var _a, _b;
    const startingPoint = typeof pointIndex === 'number' ? pointIndex : defaultPointIndex;
    const containerRef = react_1.default.useRef(null);
    const isShortVersion = points.length <= 2;
    const backgroundColor = (_a = pointAccentColors === null || pointAccentColors === void 0 ? void 0 : pointAccentColors.backgroundColor) !== null && _a !== void 0 ? _a : '';
    const textColor = (_b = pointAccentColors === null || pointAccentColors === void 0 ? void 0 : pointAccentColors.textColor) !== null && _b !== void 0 ? _b : '';
    const [isInitialized, setIsInitialized] = react_1.useState(false);
    const [currentPointIndex, setCurrentPointIndex] = react_1.useState(startingPoint);
    const [currentPoint, setCurrentPoint] = react_1.useState(points[startingPoint]);
    const [isDragging, setIsDragging] = react_1.useState(false);
    const [planSectionWidth, setPlanSectionWidth] = react_1.useState(constants_1.planSectionMinimalWidth);
    const [knobShift, setKnobShift] = react_1.useState(constants_1.knobShift);
    const [forcedPosition, setForcedPosition] = react_1.useState({ x: 0, y: 0 });
    const [allPointsHaveAccentColor, setAllPointsHaveAccentColor] = react_1.useState(false);
    const calculateKnobPosition = react_1.useCallback((updatedPointIndex, updatedKnobShift, updatedPlanSectionWidth) => {
        const result = { x: 0, y: 0 };
        if (updatedPointIndex !== 0) {
            if (isShortVersion) {
                result.x = updatedPlanSectionWidth * 2 - constants_1.trackPaddingSize * 2;
                return result;
            }
            result.x =
                updatedKnobShift +
                    updatedPlanSectionWidth / 2 +
                    constants_1.trackPaddingSize +
                    (updatedPointIndex - 1) * updatedPlanSectionWidth;
        }
        return result;
    }, [isShortVersion]);
    const calculateSizeState = react_1.useCallback((updatedPointIndex, updatePoints) => {
        var _a, _b;
        if (containerRef.current !== null) {
            const containerWidth = (_b = (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) !== null && _b !== void 0 ? _b : null;
            const numberOfPoints = (updatePoints || []).length;
            let newPlanSectionWidth;
            let newKnobShift;
            if (isShortVersion) {
                newPlanSectionWidth = containerWidth / Math.max(numberOfPoints, 1);
                newPlanSectionWidth = Math.max(newPlanSectionWidth, constants_1.planSectionMinimalWidth);
                newKnobShift = (newPlanSectionWidth - constants_1.knobDiamiter) / 2;
            }
            else {
                newPlanSectionWidth =
                    (containerWidth - 2 * constants_1.trackPaddingSize) / Math.max(numberOfPoints - 1, 1);
                newPlanSectionWidth = Math.max(newPlanSectionWidth, constants_1.planSectionMinimalWidth);
                newKnobShift = (newPlanSectionWidth - constants_1.knobDiamiter) / 2;
            }
            setPlanSectionWidth(newPlanSectionWidth);
            setKnobShift(newKnobShift);
            const newKnobPosition = calculateKnobPosition(updatedPointIndex, knobShift, planSectionWidth);
            setForcedPosition(newKnobPosition);
        }
    }, [calculateKnobPosition, isShortVersion, knobShift, planSectionWidth]);
    const calculateSizeCallback = react_1.useCallback(() => {
        calculateSizeState(currentPointIndex, points);
    }, [calculateSizeState, currentPointIndex, points]);
    const checkAllPointsHaveAccentColor = react_1.useCallback((currentPoints) => {
        const pointColors = currentPoints.reduce((result, point) => result && point.hasAccentColors, true);
        setAllPointsHaveAccentColor(pointColors);
    }, []);
    react_1.useEffect(() => {
        setIsInitialized(true);
        checkAllPointsHaveAccentColor(points);
    }, [checkAllPointsHaveAccentColor, points]);
    react_1.useEffect(() => {
        calculateSizeState(currentPointIndex, points);
    }, [calculateSizeState, currentPointIndex, points]);
    react_1.useEffect(() => {
        window.addEventListener('resize', calculateSizeCallback, true);
        return function cleanup() {
            window.removeEventListener('resize', calculateSizeCallback, true);
        };
    }, [calculateSizeCallback]);
    const selectNewPoint = react_1.useCallback((point) => {
        if (point !== currentPoint && !isDisabled) {
            if (onPointSelected) {
                onPointSelected(point);
            }
            setCurrentPoint(point);
            setCurrentPointIndex(points.indexOf(point));
        }
    }, [currentPoint, isDisabled, onPointSelected, points]);
    const selectNewPointIfHoverable = react_1.useCallback((point) => {
        if (isHoverable && !isDragging) {
            selectNewPoint(point);
        }
    }, [isDragging, isHoverable, selectNewPoint]);
    const getDraggableBounds = react_1.useCallback(() => {
        const right = isShortVersion
            ? points.length * planSectionWidth - constants_1.knobDiamiter
            : (points.length - 1) * planSectionWidth;
        return {
            top: 0,
            left: 0,
            right,
            bottom: 0,
        };
    }, [isShortVersion, planSectionWidth, points.length]);
    const draggableBounds = react_1.useMemo(() => getDraggableBounds(), [getDraggableBounds]);
    const getCurrentPointIndex = react_1.useCallback((x) => {
        const currentIndex = points.findIndex((point) => {
            if (isShortVersion) {
                return x < (points.indexOf(point) + 1) * planSectionWidth;
            }
            return x < points.indexOf(point) * planSectionWidth + planSectionWidth / 2;
        });
        return Math.max(currentIndex, 0);
    }, [isShortVersion, planSectionWidth, points]);
    const dragSetHandler = react_1.useCallback((dragStatus) => setIsDragging(dragStatus), []);
    const dragHandler = react_1.useCallback((data) => {
        const oldPointIndex = currentPointIndex;
        const newPointIndex = getCurrentPointIndex(data.x);
        setCurrentPointIndex(newPointIndex);
        setCurrentPoint(points[newPointIndex]);
        if (onPointSelected && oldPointIndex !== newPointIndex) {
            onPointSelected(currentPoint);
        }
    }, [currentPoint, currentPointIndex, getCurrentPointIndex, onPointSelected, points]);
    return (react_1.default.createElement(styles_1.Selector, { "data-testid": "rental-plan-selector" },
        react_1.default.createElement(styles_1.Container, { ref: containerRef },
            react_1.default.createElement(styles_1.Track, { isShortVersion: isShortVersion }, points &&
                points.map((point) => (react_1.default.createElement(styles_1.PointSection, { key: point.value, onClick: () => selectNewPoint(point), onMouseOver: () => selectNewPointIfHoverable(point), onFocus: () => selectNewPointIfHoverable(point), isShortVersion: isShortVersion },
                    react_1.default.createElement(styles_1.Point, { hasAccentColors: Boolean(point.hasAccentColors) && !allPointsHaveAccentColor, backgroundColor: backgroundColor, isShortVersion: isShortVersion, isDisabled: isDisabled },
                        react_1.default.createElement(styles_1.TrackValue, { hasAccentColors: Boolean(point.hasAccentColors) &&
                                !allPointsHaveAccentColor, textColor: textColor, isDisabled: isDisabled },
                            point.value,
                            hasPlusLabel && react_1.default.createElement(styles_1.TrackValuePlus, null, "+"))))))),
            isInitialized && (react_1.default.createElement(react_draggable_1.default, { axis: "x", bounds: draggableBounds, position: forcedPosition, onStart: () => dragSetHandler(true), onDrag: dragHandler, onStop: () => dragSetHandler(false), disabled: !isDraggable },
                react_1.default.createElement(styles_1.KnobContainer, { animated: !isDragging },
                    react_1.default.createElement(styles_1.Knob, { isPressed: !isHoverable && !isDragging, hasAccentColors: Boolean(currentPoint.hasAccentColors), backgroundColor: backgroundColor, isDisabled: isDisabled },
                        react_1.default.createElement(styles_1.KnobValue, { hasAccentColors: Boolean(currentPoint.hasAccentColors), textColor: textColor, isDisabled: isDisabled },
                            currentPoint.value,
                            hasPlusLabel && react_1.default.createElement(styles_1.KnobValuePlus, null, "+")),
                        react_1.default.createElement(styles_1.Label, { hasAccentColors: Boolean(currentPoint.hasAccentColors), textColor: textColor, isDisabled: isDisabled }, currentPoint.label))))))));
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.trackPaddingSize = exports.knobShift = exports.planContainerHeight = exports.planContainerWidth = exports.planSectionHeight = exports.planSectionMinimalWidth = exports.planSectionWidth = exports.knobDiamiter = void 0;
exports.knobDiamiter = 64;
exports.planSectionWidth = 83;
exports.planSectionMinimalWidth = 50;
exports.planSectionHeight = 48;
exports.planContainerWidth = 30;
exports.planContainerHeight = 30;
exports.knobShift = (exports.planSectionWidth - exports.knobDiamiter) / 2;
exports.trackPaddingSize = exports.knobDiamiter / 2;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SatisfactionCard = void 0;
const react_1 = __importStar(__webpack_require__(1));
const styled_components_1 = __webpack_require__(2);
const SonntagIcon_1 = __importDefault(__webpack_require__(25));
const SonntagButtonV2_1 = __importDefault(__webpack_require__(27));
const DismissingCard_1 = __webpack_require__(31);
const ThumbsIcons_1 = __webpack_require__(274);
const styles_1 = __webpack_require__(275);
exports.SatisfactionCard = ({ className, hasCircleDismissButton, onDismiss, dismissedText, undoButtonText, copy, preventThumbsUp, preventThumbsDown, onThumbsUpClick, onThumbsDownClick, onSubmitComment, handleChange, feedbackMessage, }) => {
    const theme = react_1.useContext(styled_components_1.ThemeContext);
    const [step, setStep] = react_1.useState(1);
    const [vote, setVote] = react_1.useState('');
    const recordPositiveOutcome = react_1.useCallback(() => {
        if (!preventThumbsUp) {
            setVote('up');
            setStep(step + 1);
        }
        onThumbsUpClick();
    }, [step, onThumbsUpClick, preventThumbsUp]);
    const recordNegativeOutcome = react_1.useCallback(() => {
        if (!preventThumbsDown) {
            setVote('down');
            setStep(step + 1);
        }
        onThumbsDownClick();
    }, [step, onThumbsDownClick, preventThumbsDown]);
    const sendFeedback = react_1.useCallback(() => {
        onSubmitComment();
        setStep(step + 1);
    }, [step, onSubmitComment]);
    const renderContent = () => {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (step === 1) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(styles_1.Title, null, (_a = copy === null || copy === void 0 ? void 0 : copy.voteStep) === null || _a === void 0 ? void 0 : _a.title),
                react_1.default.createElement(styles_1.Paragraph, null, (_b = copy === null || copy === void 0 ? void 0 : copy.voteStep) === null || _b === void 0 ? void 0 : _b.body),
                react_1.default.createElement(styles_1.IconsWrap, null,
                    react_1.default.createElement(styles_1.IconContainer, { onClick: recordPositiveOutcome },
                        react_1.default.createElement(styles_1.Circle, null,
                            react_1.default.createElement(styles_1.CircleBackground, null),
                            react_1.default.createElement(SonntagIcon_1.default, { iconPath: ThumbsIcons_1.thumbsUpIconPath, size: 28, color: theme.colors.Color2_75 }))),
                    react_1.default.createElement(styles_1.IconContainer, { onClick: recordNegativeOutcome },
                        react_1.default.createElement(styles_1.Circle, null,
                            react_1.default.createElement(styles_1.CircleBackground, null),
                            react_1.default.createElement(SonntagIcon_1.default, { iconPath: ThumbsIcons_1.thumbsDownIconPath, size: 28, color: theme.colors.Color2_75 }))))));
        }
        if (step === 2) {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(styles_1.Title, null, (_c = copy === null || copy === void 0 ? void 0 : copy.commentStep) === null || _c === void 0 ? void 0 : _c.title),
                react_1.default.createElement(styles_1.Paragraph, null, (_d = copy === null || copy === void 0 ? void 0 : copy.commentStep) === null || _d === void 0 ? void 0 : _d.body),
                react_1.default.createElement(styles_1.StyledTextArea, { id: "feedback-text-area", name: "textarea", value: feedbackMessage, onChange: handleChange }),
                react_1.default.createElement(SonntagButtonV2_1.default, { type: "submit", size: "small", onClick: sendFeedback }, (_e = copy === null || copy === void 0 ? void 0 : copy.commentStep) === null || _e === void 0 ? void 0 : _e.buttonLabel)));
        }
        if (step === 3 && vote === 'up') {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(styles_1.Title, null, (_f = copy === null || copy === void 0 ? void 0 : copy.positiveOutcome) === null || _f === void 0 ? void 0 : _f.title),
                react_1.default.createElement(styles_1.Paragraph, null, (_g = copy === null || copy === void 0 ? void 0 : copy.positiveOutcome) === null || _g === void 0 ? void 0 : _g.body)));
        }
        if (step === 3 && vote === 'down') {
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(styles_1.Title, null, (_h = copy === null || copy === void 0 ? void 0 : copy.negativeOutcome) === null || _h === void 0 ? void 0 : _h.title),
                react_1.default.createElement(styles_1.Paragraph, null, (_j = copy === null || copy === void 0 ? void 0 : copy.negativeOutcome) === null || _j === void 0 ? void 0 : _j.body)));
        }
        return null;
    };
    return (react_1.default.createElement(DismissingCard_1.DismissingCard, { className: className, onDismiss: onDismiss, hasCircleButton: hasCircleDismissButton, dismissedText: dismissedText, undoButtonText: undoButtonText, hasTimeout: true }, renderContent()));
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionSection = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const styled_1 = __webpack_require__(276);
function SubscriptionSection({ title, subtitle, buttonText, children, onButtonClick, className, hasButton, }) {
    return (react_1.default.createElement(styled_1.Main, { "data-testid": "SubscriptionSection", className: className },
        react_1.default.createElement(styled_1.Info, null,
            react_1.default.createElement("span", null, title),
            react_1.default.createElement("span", null, subtitle)),
        react_1.default.createElement(styled_1.Content, null, children),
        hasButton && (react_1.default.createElement(styled_1.Button, { size: "small", onClick: onButtonClick }, buttonText))));
}
exports.SubscriptionSection = SubscriptionSection;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Stack = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const styled_1 = __webpack_require__(277);
function Stack({ noteData, img, color, isSubdued = false, quantity, title, className, onClick, }) {
    return (react_1.default.createElement(styled_1.Main, { className: className, onClick: onClick, "data-testid": "Stack" },
        react_1.default.createElement(styled_1.NextCard, null),
        react_1.default.createElement(styled_1.StyledSubscription, { subdued: isSubdued, img: react_1.default.createElement(react_1.default.Fragment, null,
                !isSubdued && (react_1.default.createElement(styled_1.QuantityIndicator, { "$color": color }, quantity)),
                img), noteData: noteData, title: title })));
}
exports.Stack = Stack;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountMenu = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const Actions_1 = __webpack_require__(281);
const TopSection_1 = __webpack_require__(282);
const styles_1 = __webpack_require__(125);
exports.AccountMenu = ({ actionsProps, unreadMessages, userName, accountEmail, isAccountVerified, isAccountIncomplete, profileButtonText, hasTopSection = true, hintText, }) => {
    return (react_1.default.createElement(styles_1.Container, null,
        hasTopSection && (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(TopSection_1.TopSection, { actionProps: actionsProps.YourProfile, userName: userName, accountEmail: accountEmail, isAccountVerified: isAccountVerified, isAccountIncomplete: isAccountIncomplete, profileButtonText: profileButtonText }),
            hintText && react_1.default.createElement(styles_1.StyledHint, { text: hintText }),
            react_1.default.createElement(styles_1.Delimiter, null))),
        react_1.default.createElement(Actions_1.AccountActions, { actionsProps: actionsProps, unreadMessages: unreadMessages })));
};


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleAttentionIcon = exports.CircleTickIcon = exports.StyledHint = exports.Delimiter = exports.Container = void 0;
const styled_components_1 = __importDefault(__webpack_require__(2));
const Icons_1 = __webpack_require__(17);
const Hint_1 = __webpack_require__(77);
exports.Container = styled_components_1.default.div `
    padding: 4px 16px;
    display: flex;
    flex-direction: column;
    background-color: ${(props) => props.theme.colors.Background};
`;
exports.Delimiter = styled_components_1.default.div `
    background-color: ${(props) => props.theme.colors['Level 1']};
    height: 2px;
    margin-top: 10px;
    margin-bottom: 12px;
`;
exports.StyledHint = styled_components_1.default(Hint_1.Hint) `
    width: initial;
`;
exports.CircleTickIcon = styled_components_1.default(Icons_1.CircleTick) `
    transform: scale(1.2);
`;
exports.CircleAttentionIcon = styled_components_1.default(Icons_1.CircleAttention) `
    transform: scale(1.2);
`;


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ ShimmingCard_ShimmingCard; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "react-resize-detector"
var external_react_resize_detector_ = __webpack_require__(82);
var external_react_resize_detector_default = /*#__PURE__*/__webpack_require__.n(external_react_resize_detector_);

// EXTERNAL MODULE: ./src/hooks/useOverrides/index.ts
var useOverrides = __webpack_require__(32);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: ./src/components/icon/index.js + 7 modules
var icon = __webpack_require__(21);

// CONCATENATED MODULE: ./src/components/ShimmingCard/ErrorScreen/ErrorScreen.styles.js


const ErrorScreen_styles_Container = external_styled_components_default.a.div.withConfig({ displayName: "ErrorScreenstyles__Container", componentId: "sc-1l8cv32-0" })(["padding:", ";display:flex;flex-direction:column;justify-content:center;align-items:center;"],
({ theme }) => `${theme.spacers.L} ${theme.spacers.M}`);







const ErrorScreen_styles_Title = external_styled_components_default.a.h5.withConfig({ displayName: "ErrorScreenstyles__Title", componentId: "sc-1l8cv32-1" })(["margin:0;", " text-align:center;line-height:24px;color:", ";padding-top:", ";cursor:default;"],

props => Object(external_styled_components_["css"])(props.theme.typography.Paragraph),


props => props.theme.colors['Level 4'],
props => props.theme.spacers.XL);



const ErrorScreen_styles_Message = external_styled_components_default.a.p.withConfig({ displayName: "ErrorScreenstyles__Message", componentId: "sc-1l8cv32-2" })(["margin:0;", " text-align:center;color:", ";padding:12px 0;cursor:default;"],

props => Object(external_styled_components_["css"])(props.theme.typography.TinyParagraph),

props => props.theme.colors['Level 4']);




const ErrorScreen_styles_ContactButton = external_styled_components_default.a.button.attrs({ type: 'button' }).withConfig({ displayName: "ErrorScreenstyles__ContactButton", componentId: "sc-1l8cv32-3" })(["border:none;margin:0;padding:0;width:auto;overflow:visible;background:transparent;font:inherit;line-height:normal;-webkit-font-smoothing:inherit;-moz-osx-font-smoothing:inherit;-webkit-appearance:none;&::-moz-focus-inner{border:0;padding:0;}:focus{outline-style:none;box-shadow:none;border:none;}", " color:", ";text-decoration:underline;:hover{cursor:pointer !important;color:", ";}"],























props => Object(external_styled_components_["css"])(props.theme.typography.TinyParagraph),
props => props.theme.colors['Level 4'],




props => props.theme.colors['Level 3']);
// CONCATENATED MODULE: ./src/components/ShimmingCard/ErrorScreen/ErrorScreen.jsx
function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);} /* eslint-disable react/jsx-props-no-spreading */










const defaultComponents = {
  ContactButton: ErrorScreen_styles_ContactButton,
  Container: ErrorScreen_styles_Container,
  Title: ErrorScreen_styles_Title,
  Message: ErrorScreen_styles_Message };


const ErrorScreen_ErrorScreen = ({
  className,
  theme,
  title,
  message,
  contactButtonText,
  onContactButtonClick,
  overrides }) =>
{
  const {
    Container: { component: Container, props: containerProps },
    Title: { component: Title, props: titleProps },
    Message: { component: Message, props: messageProps },
    ContactButton: { component: ContactButton, props: contactButtonProps } } =
  Object(useOverrides["useOverrides"])(defaultComponents, overrides);

  return /*#__PURE__*/(
    external_react_default.a.createElement(Container, _extends({ className: className }, containerProps), /*#__PURE__*/
    external_react_default.a.createElement(icon["g" /* StraightFace */], { color: theme.colors['Level 4'] }), /*#__PURE__*/

    external_react_default.a.createElement(Title, titleProps, title), /*#__PURE__*/
    external_react_default.a.createElement(Message, messageProps, message), /*#__PURE__*/
    external_react_default.a.createElement(ContactButton, _extends({ onClick: onContactButtonClick }, contactButtonProps),
    contactButtonText)));



};

ErrorScreen_ErrorScreen.propTypes = {
  theme: external_prop_types_default.a.shape({
    colors: external_prop_types_default.a.shape({
      'Level 4': external_prop_types_default.a.string.isRequired }) }).

  isRequired,
  className: external_prop_types_default.a.string,
  title: external_prop_types_default.a.node,
  message: external_prop_types_default.a.node,
  contactButtonText: external_prop_types_default.a.node,
  onContactButtonClick: external_prop_types_default.a.func };


ErrorScreen_ErrorScreen.defaultProps = {
  className: '',
  title: 'Error title',
  message: 'Error message',
  contactButtonText: 'Contact us button',
  onContactButtonClick: () => {},
  overrides: {} };


/* harmony default export */ var ShimmingCard_ErrorScreen_ErrorScreen = (Object(external_styled_components_["withTheme"])(ErrorScreen_ErrorScreen));
// CONCATENATED MODULE: ./src/components/ShimmingCard/ErrorScreen/index.js

// EXTERNAL MODULE: ./packages/Card/index.tsx
var Card = __webpack_require__(22);

// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(36);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);

// CONCATENATED MODULE: ./src/components/FadeInOut/ClassNameInjector.jsx
/* eslint-disable */




const ClassNameInjector = ({
  className,
  children,
  onAnimationEnd }) =>
external_react_default.a.cloneElement(
external_react_["Children"].only(children),
{
  className: classnames_default()(children.props.className, className),
  onAnimationEnd });



ClassNameInjector.propTypes = {
  className: external_prop_types_default.a.string.isRequired,
  children: external_prop_types_default.a.node.isRequired,
  onAnimationEnd: external_prop_types_default.a.func.isRequired };


/* harmony default export */ var FadeInOut_ClassNameInjector = (ClassNameInjector);
// CONCATENATED MODULE: ./src/components/FadeInOut/FadeInOut.styles.js
/* eslint-disable */




const fadeInAnimation = Object(external_styled_components_["keyframes"])(["from{opacity:0;}to{opacity:1;}"]);








const fadeOutAnimation = Object(external_styled_components_["keyframes"])(["from{opacity:1;}to{opacity:0;}"]);








const FadeInOutAnimation = external_styled_components_default()(FadeInOut_ClassNameInjector).withConfig({ displayName: "FadeInOutstyles__FadeInOutAnimation", componentId: "sc-179q3ai-0" })(
({ active, animationDurationInMs }) => {
  if (active) {
    return Object(external_styled_components_["css"])(["animation-name:", ";animation-timing-function:", ";animation-duration:", "ms;"],
    fadeInAnimation,
    'ease-in',
    animationDurationInMs || 300);

  }

  if (!active) {
    return Object(external_styled_components_["css"])(["animation-name:", ";animation-timing-function:", ";animation-duration:", "ms;"],
    fadeOutAnimation,
    'ease-out',
    animationDurationInMs || 300);

  }
});
// CONCATENATED MODULE: ./src/components/FadeInOut/FadeInOut.jsx
/* eslint-disable */





class FadeInOut_FadeInOut extends external_react_["Component"] {
  constructor(props) {
    super(props);this.
















    handleAnimationEnd = () => {
      const { active } = this.props;

      if (!active) {
        this.setState({ isRendered: false });
      }
    };this.state = { isRendered: Boolean(props.active) };}componentDidUpdate(prevProps) {const { active } = this.props;if (active && active !== prevProps.active) {this.setState({ isRendered: active });}}

  render() {
    const {
      active,
      className,
      animationDurationInMs,
      children } =
    this.props;

    const { isRendered } = this.state;

    if (!isRendered) {
      return null;
    }

    return /*#__PURE__*/(
      external_react_default.a.createElement(FadeInOutAnimation, {
        className: className,
        active: active,
        animationDurationInMs: animationDurationInMs,
        onAnimationEnd: this.handleAnimationEnd,
        fadeIn: true,
        fadeOut: true },

      children));


  }}


FadeInOut_FadeInOut.propTypes = {
  active: external_prop_types_default.a.bool,
  className: external_prop_types_default.a.string,
  animationDurationInMs: external_prop_types_default.a.number,
  children: external_prop_types_default.a.node.isRequired };


FadeInOut_FadeInOut.defaultProps = {
  active: false,
  className: '',
  animationDurationInMs: 300 };


/* harmony default export */ var components_FadeInOut_FadeInOut = (FadeInOut_FadeInOut);
// CONCATENATED MODULE: ./src/components/FadeInOut/index.js

// EXTERNAL MODULE: ./src/theme/lightBaseTheme.ts
var lightBaseTheme = __webpack_require__(63);
var lightBaseTheme_default = /*#__PURE__*/__webpack_require__.n(lightBaseTheme);

// CONCATENATED MODULE: ./src/components/ShimmerEffect/ShimmerEffect.styles.js




const bannerTemplate = Object(external_styled_components_["css"])(["position:absolute;top:0;left:0;right:0;bottom:0;"]);







const shimmerTransition = Object(external_styled_components_["keyframes"])(["from{transform:translate3d(-100%,0,0);}to{transform:translate3d(100%,0,0);}"]);








const animationRule = Object(external_styled_components_["css"])(["", " 2000ms infinite linear;"],
shimmerTransition);


function getTransparentColor(theme) {
  const lightModeTransparent = 'rgba(255, 255, 255, 0)';
  const darkModeTransparent = 'rgba(0, 0, 0, 0)';

  if (theme.colors.Background === lightBaseTheme_default.a.colors.Background) {
    return lightModeTransparent;
  }

  return darkModeTransparent;
}

const ShimmerContainer = external_styled_components_default.a.div.withConfig({ displayName: "ShimmerEffectstyles__ShimmerContainer", componentId: "sc-1vdqbsy-0" })(["", " overflow:hidden;-webkit-mask-image:-webkit-radial-gradient(white,black);", ""],
bannerTemplate,




({ theme }) => Object(external_styled_components_["css"])(["background-color:", ";:before{", " content:'';background-color:", ";}:after{", " content:'';transform:translate3d(-100%,0,0);animation:", ";background:linear-gradient( 90deg,", " 0%,", " 50%,", " 100% );}"],
theme.colors.Background,


bannerTemplate,

theme.colors['Level 1'],



bannerTemplate,


animationRule,


getTransparentColor(theme),
theme.colors.Background,
getTransparentColor(theme)));
// CONCATENATED MODULE: ./src/components/ShimmerEffect/ShimmerEffect.jsx
/* eslint-disable */







const ShimmerEffect = ({
  active,
  className,
  animationDurationInMs }) => /*#__PURE__*/

external_react_default.a.createElement(components_FadeInOut_FadeInOut, {
  active: active,
  animationDurationInMs: animationDurationInMs }, /*#__PURE__*/

external_react_default.a.createElement(ShimmerContainer, { className: className }));



ShimmerEffect.propTypes = {
  active: external_prop_types_default.a.bool,
  className: external_prop_types_default.a.string,
  animationDurationInMs: external_prop_types_default.a.number };


ShimmerEffect.defaultProps = {
  active: false,
  className: '',
  animationDurationInMs: 300 };


/* harmony default export */ var ShimmerEffect_ShimmerEffect = (ShimmerEffect);
// CONCATENATED MODULE: ./src/components/ShimmerEffect/index.js

// CONCATENATED MODULE: ./src/components/ShimmingCard/ShimmingCard.styles.js





const ShimmingCard_styles_Container = external_styled_components_default()(Card["Card"]).withConfig({ displayName: "ShimmingCardstyles__Container", componentId: "sc-1qtxsly-0" })(["position:relative;overflow:hidden;padding:0px;", " height:", ";"],




({ loading }) => loading && Object(external_styled_components_["css"])(["border-width:0px;padding:2px;"]),




({ height }) => typeof height === 'number' ? `${height}px` : 'auto');


const ShimmingCard_styles_Content = external_styled_components_default.a.div.withConfig({ displayName: "ShimmingCardstyles__Content", componentId: "sc-1qtxsly-1" })(["padding:16px;transition:opacity 0.3s cubic-bezier(0.4,0.0,0.2,1);opacity:", ";"],


props => props.opacity || 1);


const ShimmingCard_styles_ShimmerEffect = external_styled_components_default()(ShimmerEffect_ShimmerEffect).withConfig({ displayName: "ShimmingCardstyles__ShimmerEffect", componentId: "sc-1qtxsly-2" })(["border-radius:8px;"]);
// CONCATENATED MODULE: ./src/components/ShimmingCard/ShimmingCard.jsx
function ShimmingCard_extends() {ShimmingCard_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return ShimmingCard_extends.apply(this, arguments);} /* eslint-disable react/jsx-props-no-spreading */










const ShimmingCard_defaultComponents = {
  Content: ShimmingCard_styles_Content,
  Container: ShimmingCard_styles_Container,
  ErrorScreen: ShimmingCard_ErrorScreen_ErrorScreen };


const ShimmingCard = ({
  className,
  loading,
  children,
  defaultHoverBehavior,
  elevated,
  hasError,
  errorTitle,
  errorMessage,
  contactButtonText,
  onContactButtonClick,
  staticHeight,
  overrides }) =>
{
  const [height, setHeight] = Object(external_react_["useState"])(null);
  const [opacity, setOpacity] = Object(external_react_["useState"])(1);
  const content = Object(external_react_["useRef"])(null);
  const container = Object(external_react_["useRef"])(null);

  const createContentRef = Object(external_react_["useCallback"])(element => {
    content.current = element;

    if (element) {
      const contentHeight = element.offsetHeight;
      setHeight(contentHeight);
    }
  }, []);

  const createContainerRef = Object(external_react_["useCallback"])(element => {
    container.current = element;
  }, []);

  const animateHeight = Object(external_react_["useCallback"])(() => {
    if (!container.current || !content.current) {
      return;
    }

    const contentHeight = content.current.offsetHeight;
    const newContentHeight = loading ? staticHeight : contentHeight;

    setHeight(newContentHeight);
  }, [loading, staticHeight]);

  Object(external_react_["useEffect"])(() => {
    animateHeight();
    setOpacity(loading ? 0 : 1);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);

  const {
    Container: { component: Container, props: containerProps },
    Content: { component: Content, props: contentProps },
    ErrorScreen: { component: ErrorScreen, props: errorScreenProps } } =
  Object(useOverrides["useOverrides"])(ShimmingCard_defaultComponents, overrides);

  return /*#__PURE__*/(
    external_react_default.a.createElement(Container, ShimmingCard_extends({
      containerRef: createContainerRef,
      className: className,
      defaultHoverBehavior: defaultHoverBehavior,
      elevated: elevated,
      loading: loading,
      height: height },
    containerProps), /*#__PURE__*/

    external_react_default.a.createElement(Content, ShimmingCard_extends({ ref: createContentRef }, contentProps, { opacity: opacity }),
    !hasError && children,

    hasError && /*#__PURE__*/
    external_react_default.a.createElement(ErrorScreen, ShimmingCard_extends({
      title: errorTitle,
      message: errorMessage,
      contactButtonText: contactButtonText,
      onContactButtonClick: onContactButtonClick },
    errorScreenProps)), /*#__PURE__*/



    external_react_default.a.createElement(external_react_resize_detector_default.a, {
      handleHeight: !loading,
      handleWidth: false,
      onResize: animateHeight })), /*#__PURE__*/



    external_react_default.a.createElement(ShimmingCard_styles_ShimmerEffect, { active: loading })));


};

ShimmingCard.propTypes = {
  children: external_prop_types_default.a.node,
  loading: external_prop_types_default.a.bool,
  defaultHoverBehavior: external_prop_types_default.a.bool,
  className: external_prop_types_default.a.string,
  elevated: external_prop_types_default.a.bool,
  hasError: external_prop_types_default.a.bool,
  staticHeight: external_prop_types_default.a.number,
  errorTitle: external_prop_types_default.a.node.isRequired,
  errorMessage: external_prop_types_default.a.node.isRequired,
  contactButtonText: external_prop_types_default.a.node.isRequired,
  onContactButtonClick: external_prop_types_default.a.func.isRequired };


ShimmingCard.defaultProps = {
  defaultHoverBehavior: false,
  elevated: false,
  loading: false,
  children: null,
  className: '',
  hasError: false,
  staticHeight: 150,
  overrides: {} };


ShimmingCard.defaultComponents = ShimmingCard_defaultComponents;

/* harmony default export */ var ShimmingCard_ShimmingCard = (ShimmingCard);
// CONCATENATED MODULE: ./src/components/ShimmingCard/index.js


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ progressBar_ProgressBar; });

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// CONCATENATED MODULE: ./src/components/progressBar/helpers.js
/* eslint-disable */
/**
                      * @param {number} paymentsCount - same as completed payments dot count
                      * @returns {number} number of dot's areas
                      * @description lets define: every dot which is not corner has 2 areas, the corner ones has 1,
                      * in other words this is number of places where indicator line may be placed, relative to the dot
                      * This function in particular is responsible to calculate numbers of dots' areas (indicator positions), represented as completed payments
                      */
const paymentsCountToAreasLeft = (paymentsCount) =>
Math.max(paymentsCount - 1, 0) * 2 + Math.min(paymentsCount, 1);

/**
                                                                  * @param {number} paymentsCount - same as all available dot count
                                                                  * @returns {number} number of dot's areas
                                                                  * @description
                                                                  * This function is responsible to calculate numbers of all of dots' areas (all available indicator positions)
                                                                  */
const paymentsCountToAreasTotal = (paymentsCount) =>
Math.max(paymentsCount - 2, 0) * 2 + Math.min(paymentsCount, 2);

const normalizePercentage = x => Math.min(Math.max(x, 0), 100);


/**
                                                                        * @param {number} paymentsCompleted - amount of completed payments | 1..n, n ∈ N
                                                                        * @param {number} paymentsRemaining - ... | 0..k, k ∈ N
                                                                        * @returns {number} | 0 < x <= 100
                                                                        * @description The main concept is to calculate progressBar's value width in percentage with conditions:
                                                                        * indicator line should be precisely in between two dots on progressBar in case the value is not equals 100
                                                                        * indicator line should be hidden when value is equals 100 (No payments remaining)
                                                                        * if returns value is not equals 100 indicator will be right in the middle between some of 2 dots. This is achievable
                                                                        * by using paymentsCountToAreasLeft, paymentsCountToAreasTotal helpers
                                                                        */
const calculateLineValue = (paymentsCompleted, paymentsRemaining) =>
normalizePercentage(paymentsCountToAreasLeft(paymentsCompleted) /
paymentsCountToAreasTotal(paymentsCompleted + paymentsRemaining) * 100);
// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// CONCATENATED MODULE: ./src/components/progressBar/styles.js
/* eslint-disable */


/** distance from start of the progressBar to the middle of the first value dot
                                         * symmetrically: distance from the last value dot to the end of progressBar
                                         * for calculation convenience ^ this is actual start and end position for gradient line
                                         * */
const cornerGap = 7;
const indicatorTextWidth = 40;

const Root = external_styled_components_default.a.div.withConfig({ displayName: "styles__Root", componentId: "l2enum-0" })(["position:relative;display:flex;flex-direction:column;font-family:Inter,sans-serif;font-style:normal;font-weight:bold;line-height:normal;color:#ffffff;background:#333333;min-width:100px;"]);












const LineWrapper = external_styled_components_default.a.div.withConfig({ displayName: "styles__LineWrapper", componentId: "l2enum-1" })(["position:relative;height:42px;display:flex;flex-direction:column;justify-content:flex-end;min-width:100px;"]);








const Line = external_styled_components_default.a.div.withConfig({ displayName: "styles__Line", componentId: "l2enum-2" })(["position:relative;height:16px;min-width:100px;border-radius:7.5px;overflow:hidden;"]);








const BlankLine = external_styled_components_default.a.div.withConfig({ displayName: "styles__BlankLine", componentId: "l2enum-3" })(["border:2px solid rgba(151,151,151,0.34);border-radius:7.5px;display:flex;justify-content:space-between;align-items:center;position:absolute;top:0;right:0;bottom:0;left:0;padding:0 2px;"]);













const Dot = external_styled_components_default.a.span.withConfig({ displayName: "styles__Dot", componentId: "l2enum-4" })(["width:6px;height:6px;border-radius:50%;background:rgba(255,255,255,0.25);"]);






const Gradient = external_styled_components_default.a.div.withConfig({ displayName: "styles__Gradient", componentId: "l2enum-5" })(["position:absolute;top:0;left:0;margin-left:-", "px;bottom:0;width:calc(", "% + ", "px);background:", ";"],



cornerGap,

({ width }) => width, ({ width }) => width === 100 ? 2 * cornerGap : cornerGap,
({ valueBackground }) => valueBackground);


const IndicatorsWrapper = external_styled_components_default.a.div.withConfig({ displayName: "styles__IndicatorsWrapper", componentId: "l2enum-6" })(["position:absolute;top:0;left:", "px;right:", "px;bottom:0;"],


cornerGap,
cornerGap);



const IndicatorLineWrap = external_styled_components_default.a.div.withConfig({ displayName: "styles__IndicatorLineWrap", componentId: "l2enum-7" })(["position:absolute;display:", ";top:0;left:0;bottom:0;min-width:", "px;max-width:100%;width:", "%;"],

({ width }) => width === 100 ? 'none' : 'block',



cornerGap,

({ width }) => width);


const IndicatorLine = external_styled_components_default.a.div.withConfig({ displayName: "styles__IndicatorLine", componentId: "l2enum-8" })(["position:absolute;bottom:0;right:-1px;width:2px;height:26px;background:#ffffff;"]);








const IndicatorTextWrap = external_styled_components_default.a.div.withConfig({ displayName: "styles__IndicatorTextWrap", componentId: "l2enum-9" })(["position:absolute;display:", ";top:0;left:0;bottom:0;max-width:100%;min-width:", "px;width:calc(", "% + ", "px);"],

({ width }) => width === 100 ? 'none' : 'block',




indicatorTextWidth,
({ width }) => width, indicatorTextWidth / 2);


const IndicatorText = external_styled_components_default.a.div.withConfig({ displayName: "styles__IndicatorText", componentId: "l2enum-10" })(["position:absolute;bottom:26px;right:0;width:", "px;text-align:center;height:17px;font-size:14px;"],



indicatorTextWidth);





const DateWrap = external_styled_components_default.a.div.withConfig({ displayName: "styles__DateWrap", componentId: "l2enum-11" })(["min-width:100px;display:flex;justify-content:space-between;margin-top:10px;font-size:12px;"]);
// CONCATENATED MODULE: ./src/components/progressBar/index.jsx
/* eslint-disable */






class progressBar_ProgressBar extends external_react_["PureComponent"] {





















  render() {
    const { paymentsCompleted: paymentsCompletedActual, paymentsRemaining, startDate, endDate, valueBackground,
      indicatorText } = this.props;
    if (isNaN(paymentsCompletedActual) || isNaN(paymentsRemaining) ||
    paymentsCompletedActual < 0 || paymentsRemaining < 0) return null;
    const paymentDone = Math.max(paymentsCompletedActual, 1);
    const dotsArray = Array.from({ length: paymentDone + paymentsRemaining }, () => /*#__PURE__*/external_react_default.a.createElement(Dot, null));
    const gradientWidth = calculateLineValue(paymentDone, paymentsRemaining);
    return /*#__PURE__*/(
      external_react_default.a.createElement(Root, null, /*#__PURE__*/
      external_react_default.a.createElement(LineWrapper, null, /*#__PURE__*/
      external_react_default.a.createElement(Line, null, /*#__PURE__*/
      external_react_default.a.createElement(BlankLine, null,
      dotsArray), /*#__PURE__*/

      external_react_default.a.createElement(IndicatorsWrapper, null, /*#__PURE__*/
      external_react_default.a.createElement(Gradient, { valueBackground: valueBackground, width: gradientWidth }))), /*#__PURE__*/


      external_react_default.a.createElement(IndicatorsWrapper, null, /*#__PURE__*/
      external_react_default.a.createElement(IndicatorLineWrap, { width: gradientWidth }, /*#__PURE__*/
      external_react_default.a.createElement(IndicatorLine, null)), /*#__PURE__*/

      external_react_default.a.createElement(IndicatorTextWrap, { width: gradientWidth }, /*#__PURE__*/
      external_react_default.a.createElement(IndicatorText, null, indicatorText)))), /*#__PURE__*/



      external_react_default.a.createElement(DateWrap, null, /*#__PURE__*/
      external_react_default.a.createElement("span", null, startDate), /*#__PURE__*/
      external_react_default.a.createElement("span", null, endDate))));



  }}progressBar_ProgressBar.propTypes = { /** 1..n, n ∈ N */paymentsCompleted: external_prop_types_default.a.number.isRequired, /** 0..k, k ∈ N */paymentsRemaining: external_prop_types_default.a.number.isRequired, startDate: external_prop_types_default.a.string.isRequired, endDate: external_prop_types_default.a.string.isRequired, valueBackground: external_prop_types_default.a.string, indicatorText: external_prop_types_default.a.string };progressBar_ProgressBar.defaultProps = { paymentsCompleted: 6, paymentsRemaining: 3, startDate: '16 Nov 2017', endDate: '16 Feb 2019', valueBackground: 'linear-gradient(90.25deg, #3D02FF 1.15%, #FF0047 96.2%)', indicatorText: 'Today' };

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: ./src/components/Buttons/SonntagButtonV2/index.js + 2 modules
var SonntagButtonV2 = __webpack_require__(27);

// CONCATENATED MODULE: ./src/components/Buttons/BadgeButton/styled.js



const StyledSonntagButton = external_styled_components_default()(SonntagButtonV2["default"]).withConfig({ displayName: "styled__StyledSonntagButton", componentId: "sc-19lpvg1-0" })(["", ";background-color:", ";border-color:", ";background-clip:", ";"],
props => Object(external_styled_components_["css"])(props.theme.typography.Paragraph),
({ blue, theme }) => blue && theme.colors.Color2_07,
({ blue, theme }) => blue && theme.colors.Color2_07,
({ blue }) => blue ? 'border-box' : 'padding-box');
// CONCATENATED MODULE: ./src/components/Buttons/BadgeButton/BadgeButton.jsx
function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);} /* eslint-disable react/no-children-prop */
/* eslint-disable react/jsx-props-no-spreading */





const BadgeButton = ({ className, blue, iconPath, iconSvgCode, children, disabled, ...props }) => {
  const theme = Object(external_react_["useContext"])(external_styled_components_["ThemeContext"]);
  return /*#__PURE__*/(
    external_react_default.a.createElement(StyledSonntagButton, _extends({
      className: className,
      blue: blue,
      iconPath: iconPath,
      iconSvgCode: iconSvgCode,
      disabled: disabled,
      accentColor: blue && theme.colors.Color2_75,
      children: children,
      size: "small" },
    props)));


};

/* harmony default export */ var BadgeButton_BadgeButton = (BadgeButton);
// CONCATENATED MODULE: ./src/components/Buttons/BadgeButton/index.js


/* harmony default export */ var Buttons_BadgeButton = __webpack_exports__["a"] = (BadgeButton_BadgeButton);

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "animejs"
var external_animejs_ = __webpack_require__(88);
var external_animejs_default = /*#__PURE__*/__webpack_require__.n(external_animejs_);

// EXTERNAL MODULE: ./src/hooks/useOverrides/index.ts
var useOverrides = __webpack_require__(32);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: ./src/helpers/elevation/index.web.js
var index_web = __webpack_require__(11);

// CONCATENATED MODULE: ./src/components/Sheet/styled.js




const styled_Container = external_styled_components_default.a.div.withConfig({ displayName: "styled__Container", componentId: "omw81q-0" })(["top:0;left:0;right:0;bottom:0;position:fixed;z-index:3;overflow-y:auto;", ""],







Object(index_web["elevation"])(3, false));


const styled_Shadow = external_styled_components_default.a.div.withConfig({ displayName: "styled__Shadow", componentId: "omw81q-1" })(["position:fixed;top:0;left:0;right:0;bottom:0;z-index:2;pointer-events:none;background-color:rgba(0,0,0,0.8);"]);










const styled_HeaderWrapper = external_styled_components_default.a.div.withConfig({ displayName: "styled__HeaderWrapper", componentId: "omw81q-2" })(["position:relative;"]);



const styled_Content = external_styled_components_default.a.div.withConfig({ displayName: "styled__Content", componentId: "omw81q-3" })(["position:relative;overflow-y:auto;"]);





// CONCATENATED MODULE: ./src/components/Sheet/Sheet.jsx








const defaultComponents = {
  Container: styled_Container,
  Shadow: styled_Shadow,
  HeaderWrapper: styled_HeaderWrapper,
  Content: styled_Content };


class Sheet_Sheet extends external_react_["Component"] {
  constructor(props) {
    super(props);this.







































    calculateSizeCallback = () => {
      const { thresholdPercent, width } = this.state;
      const { shouldOpen } = this.props;
      const newWidth = window.innerWidth;
      if (newWidth === width) {
        return;
      }
      const swipeThreshold = Math.ceil(newWidth * thresholdPercent);
      this.setState({
        width: newWidth,
        sheetOffset: !shouldOpen ? newWidth : 0,
        swipeThreshold });

    };this.

    updateSheet = targets => {
      const { width } = this.state;
      const { sheetOffset: newSheetOffset } = targets;

      this.setState({
        sheetOffset: newSheetOffset,
        percentageDragged: newSheetOffset / width });

    };this.

    completeSheet = () => {
      const { onCloseSheet } = this.props;
      this.setState({ open: false }, onCloseSheet);
    };this.

    resetSheet = () => {
      const { sheetOffset } = this.state;
      const targets = { sheetOffset };

      external_animejs_default()({
        targets,
        sheetOffset: 0,
        duration: 400,
        round: 1,
        easing: 'easeInOutQuad',
        update: this.updateSheet.bind(this, targets) });

    };this.

    closeSheet = () => {
      const { width, sheetOffset } = this.state;
      const targets = { sheetOffset };

      external_animejs_default()({
        targets,
        sheetOffset: width,
        duration: 400,
        round: 1,
        easing: 'easeInOutQuad',
        update: this.updateSheet.bind(this, targets),
        complete: this.completeSheet });

    };this.

    openSheet = () => {
      const { onOpenSheet } = this.props;

      this.setState(
      {
        open: true },

      () => {
        onOpenSheet();
        this.resetSheet();
      });

    };this.

    handleTouchStart = event => {
      const { clientX } = event.targetTouches[0];

      this.setState({
        dragStartX: clientX });

    };this.

    handleTouchMove = event => {
      const { sheetOffset, dragStartX, width, swipeThreshold, avgVelocity } = this.state;

      if (dragStartX > swipeThreshold) return;
      const newClientX = event.targetTouches[0].clientX;

      const calc = -(dragStartX - newClientX);
      const newOffset = calc > 0 ? calc : 0;
      const direction = sheetOffset > newOffset ? 'left' : 'right';
      const velocity = Math.abs(sheetOffset - newOffset);
      const percentage = newOffset / width;
      const percentageDragged = percentage < 1 ? percentage : 1;

      this.setState({
        direction,
        sheetOffset: newOffset,
        percentageDragged,
        avgVelocity: (avgVelocity + velocity) / 2 });

    };this.

    handleTouchEnd = () => {
      const { percentageDragged, direction, thresholdPercent, avgVelocity } = this.state;

      const shouldClose =
      direction === 'right' && (percentageDragged > thresholdPercent || avgVelocity > 1);

      const { shouldOpen } = this.props;

      if (shouldClose || !shouldOpen) {
        this.closeSheet();
      } else if (avgVelocity && percentageDragged) {
        this.resetSheet();
      }

      this.setState({
        dragStartX: 0,
        direction: '' });

    };const { shouldOpen: _shouldOpen, thresholdPercent: _thresholdPercent } = props;this.state = { open: _shouldOpen, sheetOffset: null, dragStartX: 0, direction: '', width: 0, thresholdPercent: _thresholdPercent || 0.2, swipeThreshold: 0, avgVelocity: 0, percentageDragged: !_shouldOpen ? 1 : 0 };}componentDidMount() {this.calculateSizeCallback();window.addEventListener('resize', this.calculateSizeCallback);}componentDidUpdate(prevProps) {const { shouldOpen } = this.props;const { open } = this.state;const prevShouldOpen = prevProps.shouldOpen;if (shouldOpen !== prevShouldOpen && shouldOpen !== open) {if (!open) {this.openSheet();} else {this.closeSheet();}}}componentWillUnmount() {window.removeEventListener('resize', this.calculateSizeCallback);}

  render() {
    const { header, children, overrides } = this.props;

    const { percentageDragged, open, sheetOffset, width } = this.state;

    const shadowOpacity = 0.8 - percentageDragged;
    const translateX = open ? `translateX(${sheetOffset}px)` : `translateX(${width}px)`;

    const {
      Shadow: { component: Shadow },
      Container: { component: Container },
      HeaderWrapper: { component: HeaderWrapper },
      Content: { component: Content } } =
    Object(useOverrides["getComponents"])(defaultComponents, overrides);

    return /*#__PURE__*/(
      external_react_default.a.createElement(external_react_default.a.Fragment, null, /*#__PURE__*/
      external_react_default.a.createElement(Shadow, {
        style: {
          opacity: shadowOpacity,
          display: open ? 'initial' : 'none' } }), /*#__PURE__*/


      external_react_default.a.createElement(Container, {
        ref: element => {
          this.myElement = element;
        },
        onTouchEnd: this.handleTouchEnd,
        onTouchMove: this.handleTouchMove,
        onTouchStart: this.handleTouchStart,
        style: {
          transform: translateX } }, /*#__PURE__*/


      external_react_default.a.createElement(HeaderWrapper, null, header), /*#__PURE__*/
      external_react_default.a.createElement(Content, null, children))));



  }}


Sheet_Sheet.propTypes = {
  shouldOpen: external_prop_types_default.a.bool,
  header: external_prop_types_default.a.node,
  children: external_prop_types_default.a.node,
  thresholdPercent: external_prop_types_default.a.number,
  onOpenSheet: external_prop_types_default.a.func,
  onCloseSheet: external_prop_types_default.a.func };


Sheet_Sheet.defaultProps = {
  shouldOpen: false,
  header: null,
  children: null,
  thresholdPercent: 0.2,
  onOpenSheet: () => {},
  onCloseSheet: () => {},
  overrides: {} };


/* harmony default export */ var components_Sheet_Sheet = (Sheet_Sheet);
// CONCATENATED MODULE: ./src/components/Sheet/index.js


/* harmony default export */ var components_Sheet = __webpack_exports__["a"] = (components_Sheet_Sheet);

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* reexport */ FilterButton_FilterButton; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: ./src/hocs/withRipple/index.web.tsx
var index_web = __webpack_require__(20);
var index_web_default = /*#__PURE__*/__webpack_require__.n(index_web);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: ./packages/Card/index.tsx
var Card = __webpack_require__(22);

// EXTERNAL MODULE: ./src/components/icon/components/arrow.jsx
var arrow = __webpack_require__(61);

// CONCATENATED MODULE: ./src/components/FilterButton/styles.js





const FilterButtonWrap = external_styled_components_default()(Card["Card"]).withConfig({ displayName: "styles__FilterButtonWrap", componentId: "sc-1tdz46r-0" })(["user-select:none;position:relative;padding:12px ", ";color:", ";", ";display:flex;justify-content:space-between;align-items:center;cursor:pointer;"],


props => props.theme.spacers.L,
props => props.theme.colors['Level 4'],
({ theme }) => Object(external_styled_components_["css"])(theme.typography.Paragraph));






const Icon = external_styled_components_default()(arrow["a" /* default */]).withConfig({ displayName: "styles__Icon", componentId: "sc-1tdz46r-1" })(["color:", ";transform:rotate(-90deg);"],
props => props.theme.colors['Level 3']);



const RippleContainer = external_styled_components_default.a.div.withConfig({ displayName: "styles__RippleContainer", componentId: "sc-1tdz46r-2" })(["border-radius:4px;width:100%;height:100%;position:absolute !important;top:0;left:0;"]);
// CONCATENATED MODULE: ./src/components/FilterButton/FilterButton.jsx
/* eslint-disable */






const FilterButton = ({ children, className, onClick }) => {
  const RippleEffect = index_web_default()(RippleContainer);

  return /*#__PURE__*/(
    external_react_default.a.createElement(FilterButtonWrap, {
      className: className,
      onClick: onClick,
      defaultHoverBehavior: true },

    children, /*#__PURE__*/
    external_react_default.a.createElement(Icon, null), /*#__PURE__*/
    external_react_default.a.createElement(RippleEffect, null)));


};

FilterButton.propTypes = {
  children: external_prop_types_default.a.node.isRequired,
  onClick: external_prop_types_default.a.func,
  className: external_prop_types_default.a.string };


FilterButton.defaultProps = {
  className: '',
  onClick: () => {} };


/* harmony default export */ var FilterButton_FilterButton = (FilterButton);
// CONCATENATED MODULE: ./src/components/FilterButton/index.js


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: ./src/helpers/elevation/index.web.js
var index_web = __webpack_require__(11);

// CONCATENATED MODULE: ./src/components/Pointer/styled.jsx
/* eslint-disable */




const Sides = {
  BOTTOM: 'BOTTOM',
  TOP: 'TOP' };


const SnapPositions = {
  LEFT: 'LEFT',
  RIGHT: 'RIGHT' };


const PositionPairs = {
  topLeft: `${Sides.TOP}-${SnapPositions.LEFT}`,
  topRight: `${Sides.TOP}-${SnapPositions.RIGHT}`,
  bottomLeft: `${Sides.BOTTOM}-${SnapPositions.LEFT}`,
  bottomRight: `${Sides.BOTTOM}-${SnapPositions.RIGHT}` };


const TriangleSVG = ({ className, fill, style }) => /*#__PURE__*/
external_react_default.a.createElement("svg", {
  style: style,
  className: className,
  width: "24",
  height: "12",
  viewBox: "0 0 24 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg" }, /*#__PURE__*/

external_react_default.a.createElement("path", { d: "M12 0L0 12H24L12 0Z", fill: fill }), /*#__PURE__*/
external_react_default.a.createElement("path", { d: "M12 0L0 12H24L12 0Z", fill: fill, fillOpacity: "0.75" }));



const Container = external_styled_components_default.a.div.withConfig({ displayName: "styled__Container", componentId: "sc-1b18s6s-0" })(["position:relative;box-sizing:border-box;display:inline-block;"]);





const ChildrenContainer = external_styled_components_default()(Container).withConfig({ displayName: "styled__ChildrenContainer", componentId: "sc-1b18s6s-1" })(["display:flex;&:hover{cursor:pointer;}"]);







const CommonTriangle = external_styled_components_default()(TriangleSVG).withConfig({ displayName: "styled__CommonTriangle", componentId: "sc-1b18s6s-2" })(["position:absolute;z-index:", ";", ""],

props => props.zIndex || 12,
(props) =>
props.side === Sides.TOP &&
`
    transform: rotate(180deg);
    ${Object(index_web["elevation"])(3, true)}
  `);


const Triangles = {
  [Sides.BOTTOM]: external_styled_components_default()(CommonTriangle).withConfig({ displayName: "styled__BOTTOM", componentId: "sc-1b18s6s-3" })(["bottom:100%;"]),


  [Sides.TOP]: external_styled_components_default()(CommonTriangle).withConfig({ displayName: "styled__TOP", componentId: "sc-1b18s6s-4" })(["top:100%;"]) };




const appear = Object(external_styled_components_["keyframes"])(["0%{opacity:0;transform:translateY(16px);}100%{opacity:1;transform:translateY(0px);}"]);










const hover = Object(external_styled_components_["keyframes"])(["0%{transform:translateY(0px);}50%{transform:translateY(4px);}100%{transform:translateY(0px);}"]);











const AnimationContainer = external_styled_components_default.a.div.withConfig({ displayName: "styled__AnimationContainer", componentId: "sc-1b18s6s-5" })(["animation:", " 3s infinite;"],
hover);


const TextContainer = external_styled_components_default()(Container).withConfig({ displayName: "styled__TextContainer", componentId: "sc-1b18s6s-6" })(["position:absolute;animation:", " 0.5s ease-out;", ""],

appear,

props => {
  switch (`${props.side}-${props.snapPosition}`) {
    case PositionPairs.topLeft:{
        return `
            bottom: ${props.verticalOffset}px;
            left: ${props.pointerOffset || 0}px;
          `;
      }

    case PositionPairs.topRight:{
        return `
            bottom: ${props.verticalOffset}px;
            right: ${props.pointerOffset || 0}px;
          `;
      }

    case PositionPairs.bottomLeft:{
        return `
            top: ${props.verticalOffset}px;
            left: ${props.pointerOffset || 0}px;
          `;
      }

    case PositionPairs.bottomRight:{
        return `
            top: ${props.verticalOffset}px;
            right: ${props.pointerOffset || 0}px;
          `;
      }

    default:
      return '';}

});


const Text = external_styled_components_default.a.p.withConfig({ displayName: "styled__Text", componentId: "sc-1b18s6s-7" })(["margin:0;color:", ";", ";"],

({ theme }) => theme.colors.Background,
props => Object(external_styled_components_["css"])(props.theme.typography.Paragraph));


const Wrap = external_styled_components_default()(Container).withConfig({ displayName: "styled__Wrap", componentId: "sc-1b18s6s-8" })(["position:relative;text-transform:none;user-select:none;pointer-events:none;min-width:", "px;max-width:384px;text-align:center;white-space:", ";padding:8px;border-radius:8px;background:", ";color:", ";z-index:", ";", ""],




props => props.width,


props => props.textWrap ? 'normal' : 'nowrap',


props => props.theme.colors.secondary,
({ theme }) => theme.colors.Background,
props => props.zIndex || 12,

Object(index_web["elevation"])(3, false));
// CONCATENATED MODULE: ./src/components/Pointer/Pointer.jsx





const triangleHeight = 12;
const triangleWidth = 24;
const expectedMargin = 8;
const maxWidthPointer = 384;

class Pointer_Pointer extends external_react_["Component"] {
  constructor(props) {
    super(props);this.





















    getViewport = () => {
      const { scrollY, scrollX, innerHeight, innerWidth } = window;
      const viewport = {
        scrollX,
        scrollY,
        innerHeight,
        innerWidth };


      return viewport;
    };this.

    setPointerPosition = () => {
      const rects = this.getRects();
      const viewport = this.getViewport();

      if (rects) {
        const pointerWidth = rects.textRect.width;
        const childrenWidth = rects.childrenRect.width;
        const requiredVerticalSpace = rects.textRect.height + triangleHeight + expectedMargin;
        const spaceLeft = rects.childrenRect.left - expectedMargin;
        const spaceRight = viewport.innerWidth - rects.childrenRect.right - expectedMargin;
        const spaceTop = rects.childrenRect.top - requiredVerticalSpace;
        const spaceBottom =
        viewport.innerHeight - rects.childrenRect.bottom - requiredVerticalSpace;
        const centeringOffset = (pointerWidth - childrenWidth) / 2;
        const shouldShowCentered =
        window.innerWidth >= pointerWidth + 2 * expectedMargin &&
        spaceLeft > centeringOffset &&
        spaceRight > centeringOffset;
        const topOffset = triangleHeight + 8;
        const bottomOffset = rects.childrenRect.height + triangleHeight + 8;
        const shouldShowChildrenOnly = pointerWidth > viewport.innerWidth;

        const snapPosition = spaceLeft > spaceRight ? SnapPositions.RIGHT : SnapPositions.LEFT;

        const shouldShowOnTop = spaceTop > spaceBottom;

        const pointerOffset = shouldShowCentered ? -centeringOffset : 0;
        const verticalOffset = shouldShowOnTop ? topOffset : bottomOffset;
        const arrowOffset = Math.abs(pointerOffset) + (childrenWidth - triangleWidth) / 2;

        const pointerLeftDistance = rects.childrenRect.left - Math.abs(pointerOffset);
        const roundedPointerwidth = Math.round(pointerWidth);
        const sizePointerSpace = roundedPointerwidth + pointerLeftDistance;
        if (sizePointerSpace >= window.innerWidth) {
          const availableWidth = window.innerWidth - 3 * expectedMargin - pointerLeftDistance;
          this.setState({ calculatedPointerWidth: availableWidth });
        } else {
          this.setState({ calculatedPointerWidth: roundedPointerwidth });
        }

        const textWrap = !!(
        sizePointerSpace >= window.innerWidth || sizePointerSpace >= maxWidthPointer);


        this.setState({
          pointerOffset,
          verticalOffset,
          arrowOffset,
          snapPosition,
          side: shouldShowOnTop ? Sides.TOP : Sides.BOTTOM,
          shouldShowChildrenOnly,
          textWrap });

      }
    };this.

    getRects = () => {
      const { childrenContainerRef, textContainerRef } = this;

      if (childrenContainerRef.current && textContainerRef.current) {
        const [childrenContainer, tipContainer] = [
        childrenContainerRef.current,
        textContainerRef.current];

        const childrenRect = childrenContainer.getBoundingClientRect();
        const textRect = tipContainer.getBoundingClientRect();

        return { childrenRect, textRect };
      }

      return false;
    };this.

    setRects = () => {
      const rects = this.getRects();

      if (rects) {
        this.setState(rects);
      }
    };this.childrenContainerRef = Object(external_react_["createRef"])();this.textContainerRef = Object(external_react_["createRef"])();this.state = { shouldShowChildrenOnly: false, side: Sides.TOP, snapPosition: SnapPositions.LEFT, pointerOffset: 0, verticalOffset: 0, arrowOffset: 0, textWrap: false, calculatedPointerWidth: 0 };}componentDidMount() {this.setRects();this.setPointerPosition();}

  render() {
    const { children, text, theme, zIndex } = this.props;
    const {
      side,
      pointerOffset,
      arrowOffset,
      snapPosition,
      verticalOffset,
      shouldShowChildrenOnly,
      textWrap,
      calculatedPointerWidth } =
    this.state;

    const Triangle = Triangles[side];

    return shouldShowChildrenOnly ?
    children : /*#__PURE__*/

    external_react_default.a.createElement(Container, null, /*#__PURE__*/
    external_react_default.a.createElement(AnimationContainer, null, /*#__PURE__*/
    external_react_default.a.createElement(TextContainer, {
      snapPosition: snapPosition,
      side: side,
      pointerOffset: pointerOffset,
      verticalOffset: verticalOffset,
      ref: this.textContainerRef }, /*#__PURE__*/

    external_react_default.a.createElement(Wrap, { zIndex: zIndex, width: calculatedPointerWidth, textWrap: textWrap }, /*#__PURE__*/
    external_react_default.a.createElement(Text, null, text), /*#__PURE__*/
    external_react_default.a.createElement(Triangle, {
      style: {
        [snapPosition === SnapPositions.RIGHT ?
        'right' :
        'left']: arrowOffset },

      side: side,
      fill: theme.colors.secondary,
      zIndex: zIndex })))), /*#__PURE__*/




    external_react_default.a.createElement(ChildrenContainer, { ref: this.childrenContainerRef }, children));


  }}


/* harmony default export */ var components_Pointer_Pointer = (Object(external_styled_components_["withTheme"])(Pointer_Pointer));
// CONCATENATED MODULE: ./src/components/Pointer/index.js


/* harmony default export */ var components_Pointer = __webpack_exports__["a"] = (components_Pointer_Pointer);

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: ./node_modules/react-swipeable-bottom-sheet/lib/SwipeableBottomSheet.js
var SwipeableBottomSheet = __webpack_require__(157);
var SwipeableBottomSheet_default = /*#__PURE__*/__webpack_require__.n(SwipeableBottomSheet);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// CONCATENATED MODULE: ./src/components/BottomSheet/styled.js


const Title = external_styled_components_default.a.div.withConfig({ displayName: "styled__Title", componentId: "i8a9xu-0" })(["", ";min-height:", "px;"],
props => Object(external_styled_components_["css"])(props.theme.typography[props.typography] || props.theme.typography.Paragraph),
({ minHeight }) => minHeight);
// CONCATENATED MODULE: ./src/components/BottomSheet/BottomSheet.jsx






const BottomSheet = ({
  className,
  overflowHeight,
  open,
  defaultOpen,
  onChange,
  onTransitionEnd,
  fullScreen,
  marginTop,
  shadowTip,
  topShadow,
  overlay,
  scrollTopAtClose,
  swipeableViewsProps,
  rootStyle,
  bodyStyle,
  overlayStyle,
  title,
  titleStyle,
  titleTypography,
  children }) =>
{
  return /*#__PURE__*/(
    external_react_default.a.createElement(SwipeableBottomSheet_default.a, {
      className: className,
      overflowHeight: overflowHeight,
      open: open,
      defaultOpen: defaultOpen,
      onChange: onChange,
      onTransitionEnd: onTransitionEnd,
      fullScreen: fullScreen,
      marginTop: marginTop,
      shadowTip: shadowTip,
      topShadow: topShadow,
      overlay: overlay,
      scrollTopAtClose: scrollTopAtClose,
      style: rootStyle,
      bodyStyle: bodyStyle,
      overlayStyle: open && overlayStyle,
      swipeableViewsProps: swipeableViewsProps }, /*#__PURE__*/

    external_react_default.a.createElement(Title, { typography: titleTypography, minHeight: overflowHeight, style: titleStyle },
    title),

    children));


};

BottomSheet.propTypes = {
  className: external_prop_types_default.a.string,
  overflowHeight: external_prop_types_default.a.number,
  // eslint-disable-next-line react/require-default-props
  open: external_prop_types_default.a.bool,
  defaultOpen: external_prop_types_default.a.bool,
  onChange: external_prop_types_default.a.func,
  onTransitionEnd: external_prop_types_default.a.func,
  fullScreen: external_prop_types_default.a.bool,
  marginTop: external_prop_types_default.a.number,
  shadowTip: external_prop_types_default.a.bool,
  topShadow: external_prop_types_default.a.bool,
  overlay: external_prop_types_default.a.bool,
  scrollTopAtClose: external_prop_types_default.a.bool,
  swipeableViewsProps: external_prop_types_default.a.shape({}),
  rootStyle: external_prop_types_default.a.shape({}),
  bodyStyle: external_prop_types_default.a.shape({}),
  overlayStyle: external_prop_types_default.a.shape({}),
  title: external_prop_types_default.a.string,
  titleStyle: external_prop_types_default.a.shape({}),
  titleTypography: external_prop_types_default.a.string,
  children: external_prop_types_default.a.node };


BottomSheet.defaultProps = {
  className: '',
  overflowHeight: 0,
  defaultOpen: false,
  onChange: () => {},
  onTransitionEnd: () => {},
  fullScreen: false,
  marginTop: 0,
  shadowTip: true,
  topShadow: true,
  overlay: true,
  scrollTopAtClose: true,
  swipeableViewsProps: {},
  rootStyle: {},
  bodyStyle: {},
  overlayStyle: {},
  title: '',
  titleStyle: {},
  titleTypography: '',
  children: null };


/* harmony default export */ var BottomSheet_BottomSheet = (BottomSheet);
// CONCATENATED MODULE: ./src/components/BottomSheet/index.js


/* harmony default export */ var components_BottomSheet = __webpack_exports__["a"] = (BottomSheet_BottomSheet);

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ textarea_GetgroverFormTextarea; });

// EXTERNAL MODULE: ./src/components/form/textarea/index.scss
var form_textarea = __webpack_require__(165);

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: ./node_modules/react-bem-classes/index.js
var react_bem_classes = __webpack_require__(14);
var react_bem_classes_default = /*#__PURE__*/__webpack_require__.n(react_bem_classes);

// CONCATENATED MODULE: ./node_modules/react-textarea-autosize/es/index.js



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var isIE = isBrowser ? !!document.documentElement.currentStyle : false;
var hiddenTextarea = isBrowser && document.createElement('textarea');
var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};
var SIZING_STYLE = ['letter-spacing', 'line-height', 'font-family', 'font-weight', 'font-size', 'font-style', 'tab-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width', 'box-sizing'];
var computedStyleCache = {};
function calculateNodeHeight(uiTextNode, uid, useCache, minRows, maxRows) {
  if (useCache === void 0) {
    useCache = false;
  }

  if (minRows === void 0) {
    minRows = null;
  }

  if (maxRows === void 0) {
    maxRows = null;
  }

  if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  } // Copy all CSS properties that have an impact on the height of the content in
  // the textbox


  var nodeStyling = calculateNodeStyling(uiTextNode, uid, useCache);

  if (nodeStyling === null) {
    return null;
  }

  var paddingSize = nodeStyling.paddingSize,
      borderSize = nodeStyling.borderSize,
      boxSizing = nodeStyling.boxSizing,
      sizingStyle = nodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content

  Object.keys(sizingStyle).forEach(function (key) {
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
    hiddenTextarea.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || 'x';
  var minHeight = -Infinity;
  var maxHeight = Infinity;
  var height = hiddenTextarea.scrollHeight;

  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height = height - paddingSize;
  } // measure height of a textarea with a single row


  hiddenTextarea.value = 'x';
  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

  if (minRows !== null || maxRows !== null) {
    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;

      if (boxSizing === 'border-box') {
        minHeight = minHeight + paddingSize + borderSize;
      }

      height = Math.max(minHeight, height);
    }

    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;

      if (boxSizing === 'border-box') {
        maxHeight = maxHeight + paddingSize + borderSize;
      }

      height = Math.min(maxHeight, height);
    }
  }

  var rowCount = Math.floor(height / singleRowHeight);
  return {
    height: height,
    minHeight: minHeight,
    maxHeight: maxHeight,
    rowCount: rowCount
  };
}

function calculateNodeStyling(node, uid, useCache) {
  if (useCache === void 0) {
    useCache = false;
  }

  if (useCache && computedStyleCache[uid]) {
    return computedStyleCache[uid];
  }

  var style = window.getComputedStyle(node);

  if (style === null) {
    return null;
  }

  var sizingStyle = SIZING_STYLE.reduce(function (obj, name) {
    obj[name] = style.getPropertyValue(name);
    return obj;
  }, {});
  var boxSizing = sizingStyle['box-sizing']; // IE (Edge has already correct behaviour) returns content width as computed width
  // so we need to add manually padding and border widths

  if (isIE && boxSizing === 'border-box') {
    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(style['border-right-width']) + parseFloat(style['border-left-width']) + parseFloat(style['padding-right']) + parseFloat(style['padding-left']) + 'px';
  }

  var paddingSize = parseFloat(sizingStyle['padding-bottom']) + parseFloat(sizingStyle['padding-top']);
  var borderSize = parseFloat(sizingStyle['border-bottom-width']) + parseFloat(sizingStyle['border-top-width']);
  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };

  if (useCache) {
    computedStyleCache[uid] = nodeInfo;
  }

  return nodeInfo;
}

var purgeCache = function purgeCache(uid) {
  return delete computedStyleCache[uid];
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

/**
 * <TextareaAutosize />
 */
var noop = function noop() {}; // IE11 has a problem with eval source maps, can be reproduced with:
// eval('"use strict"; var onNextFrame = window.cancelAnimationFrame; onNextFrame(4);')
// so we bind window as context in dev modes


var _ref = isBrowser && window.requestAnimationFrame ?  true ? [window.requestAnimationFrame, window.cancelAnimationFrame] : undefined : [setTimeout, clearTimeout];
var onNextFrame = _ref[0];
var clearNextFrameAction = _ref[1];

var es_TextareaAutosize =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TextareaAutosize, _React$Component);

  function TextareaAutosize(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._resizeLock = false;

    _this._onRootDOMNode = function (node) {
      _this._rootDOMNode = node;

      if (_this.props.inputRef) {
        _this.props.inputRef(node);
      }
    };

    _this._onChange = function (event) {
      if (!_this._controlled) {
        _this._resizeComponent();
      }

      _this.props.onChange(event);
    };

    _this._resizeComponent = function (callback) {
      if (callback === void 0) {
        callback = noop;
      }

      if (typeof _this._rootDOMNode === 'undefined') {
        callback();
        return;
      }

      var nodeHeight = calculateNodeHeight(_this._rootDOMNode, _this._uid, _this.props.useCacheForDOMMeasurements, _this.props.minRows, _this.props.maxRows);

      if (nodeHeight === null) {
        callback();
        return;
      }

      var height = nodeHeight.height,
          minHeight = nodeHeight.minHeight,
          maxHeight = nodeHeight.maxHeight,
          rowCount = nodeHeight.rowCount;
      _this.rowCount = rowCount;

      if (_this.state.height !== height || _this.state.minHeight !== minHeight || _this.state.maxHeight !== maxHeight) {
        _this.setState({
          height: height,
          minHeight: minHeight,
          maxHeight: maxHeight
        }, callback);

        return;
      }

      callback();
    };

    _this.state = {
      height: props.style && props.style.height || 0,
      minHeight: -Infinity,
      maxHeight: Infinity
    };
    _this._uid = uid();
    _this._controlled = typeof props.value === 'string';
    return _this;
  }

  var _proto = TextareaAutosize.prototype;

  _proto.render = function render() {
    var _props = this.props,
        _minRows = _props.minRows,
        _maxRows = _props.maxRows,
        _onHeightChange = _props.onHeightChange,
        _useCacheForDOMMeasurements = _props.useCacheForDOMMeasurements,
        _inputRef = _props.inputRef,
        props = _objectWithoutProperties(_props, ["minRows", "maxRows", "onHeightChange", "useCacheForDOMMeasurements", "inputRef"]);
    props.style = _extends({}, props.style, {
      height: this.state.height
    });
    var maxHeight = Math.max(props.style.maxHeight || Infinity, this.state.maxHeight);

    if (maxHeight < this.state.height) {
      props.style.overflow = 'hidden';
    }

    return external_react_default.a.createElement("textarea", _extends({}, props, {
      onChange: this._onChange,
      ref: this._onRootDOMNode
    }));
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this._resizeComponent(); // Working around Firefox bug which runs resize listeners even when other JS is running at the same moment
    // causing competing rerenders (due to setState in the listener) in React.
    // More can be found here - facebook/react#6324


    this._resizeListener = function () {
      if (_this2._resizeLock) {
        return;
      }

      _this2._resizeLock = true;

      _this2._resizeComponent(function () {
        return _this2._resizeLock = false;
      });
    };

    window.addEventListener('resize', this._resizeListener);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps() {
    var _this3 = this;

    this._clearNextFrame();

    this._onNextFrameActionId = onNextFrame(function () {
      return _this3._resizeComponent();
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.state.height !== prevState.height) {
      this.props.onHeightChange(this.state.height, this);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._clearNextFrame();

    window.removeEventListener('resize', this._resizeListener);
    purgeCache(this._uid);
  };

  _proto._clearNextFrame = function _clearNextFrame() {
    clearNextFrameAction(this._onNextFrameActionId);
  };

  return TextareaAutosize;
}(external_react_default.a.Component);

es_TextareaAutosize.propTypes = {
  value: external_prop_types_default.a.string,
  onChange: external_prop_types_default.a.func,
  onHeightChange: external_prop_types_default.a.func,
  useCacheForDOMMeasurements: external_prop_types_default.a.bool,
  minRows: external_prop_types_default.a.number,
  maxRows: external_prop_types_default.a.number,
  inputRef: external_prop_types_default.a.func
};
es_TextareaAutosize.defaultProps = {
  onChange: noop,
  onHeightChange: noop,
  useCacheForDOMMeasurements: false
};

/* harmony default export */ var es = (es_TextareaAutosize);

// EXTERNAL MODULE: ./src/components/form/_box/index.js
var _box = __webpack_require__(28);

// CONCATENATED MODULE: ./src/components/form/textarea/index.js
var _dec, _class, _class2, _temp; /* eslint-disable */






let




textarea_GetgroverFormTextarea = (_dec = react_bem_classes_default()({ block: 'getgroverFormTextarea' }), _dec(_class = (_temp = _class2 = class GetgroverFormTextarea extends external_react_["Component"] {




















  constructor(props) {
    super(props);

    this.state = {
      active: false };

  }

  render() {
    const
    { active } = this.state,
    { input, label, error, minRows } = this.props,
    { name, value, onChange, onFocus, onBlur, onClick } = input;
    return /*#__PURE__*/(
      external_react_default.a.createElement(_box["a" /* default */], {
        inputName: name,
        autoHeight: true,
        active: active || !!value,
        label: label,
        error: error }, /*#__PURE__*/

      external_react_default.a.createElement("div", { className: this.block() }, /*#__PURE__*/
      external_react_default.a.createElement(es, {
        minRows: minRows,
        name: name,
        value: value,
        autoComplete: "off",
        onFocus: e => {
          this.setState({ active: true });
          onFocus && onFocus(e);
        },
        onBlur: e => {
          this.setState({ active: false });
          onBlur && onBlur(e);
        },
        onChange: onChange,
        onClick: onClick }))));




  }}, _class2.propTypes = { input: external_prop_types_default.a.object, minRows: external_prop_types_default.a.number, label: external_prop_types_default.a.string, error: external_prop_types_default.a.string }, _class2.defaultProps = { label: 'Textarea label:', error: '', minRows: 3, input: { name: 'textarea', value: 'anytext@gmail.com', onChange: () => {}, onClick: () => {}, onFocus: () => {}, onBlur: () => {} } }, _temp)) || _class);

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ input_Input; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: ./node_modules/react-input-mask/es/index.js + 5 modules
var es = __webpack_require__(39);

// EXTERNAL MODULE: ./src/theme/index.js + 1 modules
var theme = __webpack_require__(12);

// EXTERNAL MODULE: ./src/helpers/index.js + 2 modules
var helpers = __webpack_require__(16);

// CONCATENATED MODULE: ./src/components/input/styles.jsx
/* eslint-disable */







const ErrorMessage = external_styled_components_default.a.span.withConfig({ displayName: "styles__ErrorMessage", componentId: "sc-179kyte-0" })(["display:inline-block;height:16px;margin-top:", ";color:#f44336;font-family:inherit;font-style:italic;font-weight:bold;line-height:normal;font-size:0.833em;letter-spacing:0.02em;"],


props => props.theme.spacers.M);









ErrorMessage.defaultProps = {
  theme: theme["b" /* defaultTheme */] };


const Label = external_styled_components_default()(Object(helpers["omitProps"])("active", "theme")("span")).withConfig({ displayName: "styles__Label", componentId: "sc-179kyte-1" })(["position:absolute;top:", ";left:0;user-select:none;color:", ";height:12px;white-space:nowrap;transition:all 0.2s;transition-timing-function:cubic-bezier(0.4,0,0.2,1);pointer-events:none;", ""],

({ active }) => active ? "0px" : "18px",


props => props.theme.colors["Level 4"],






props => Object(external_styled_components_["css"])(props.theme.typography.SmallCapsHeadline));


Label.defaultProps = {
  theme: theme["b" /* defaultTheme */] };


const Container = external_styled_components_default.a.label.withConfig({ displayName: "styles__Container", componentId: "sc-179kyte-2" })(["display:inline-block;position:relative;color:", ";", ""],


props => props.theme.colors.Foreground,

({ debug }) =>
debug &&
Object(external_styled_components_["css"])(["&::after,&::before{content:\"\";display:block;position:absolute;box-sizing:border-box;width:48px;height:24px;background-color:tomato;border:1px solid;opacity:0.55;left:-1px;top:1px;}&::before{top:25px;}"]));





















Container.defaultProps = {
  theme: theme["b" /* defaultTheme */] };


const InputComponent = ({ isMask, ...props }) => {
  if (isMask) {
    return /*#__PURE__*/external_react_default.a.createElement(es["a" /* default */], props);
  }

  return /*#__PURE__*/external_react_default.a.createElement("input", props);
};

InputComponent.propTypes = {
  isMask: external_prop_types_default.a.bool,
  ref: external_prop_types_default.a.func };


const StyledInput = external_styled_components_default()(
Object(helpers["omitProps"])("withIconRight", "theme")(InputComponent)).withConfig({ displayName: "styles__StyledInput", componentId: "sc-179kyte-3" })(["", " line-height:18px;box-sizing:border-box;width:100%;padding:24px 0 6px;outline:none;background:transparent;border:none;border-bottom:2px solid ", ";color:inherit;", " &:focus ~ ", "{top:0px;}&:invalid,:-moz-submit-invalid,:-moz-ui-invalid{box-shadow:none;}&:disabled{color:", ";}"],

props => Object(external_styled_components_["css"])(props.theme.typography.Paragraph),







props => props.theme.colors["Level 4"],


({ withIconRight }) =>
withIconRight &&
Object(external_styled_components_["css"])(["padding-right:36px;"]),



Label,










props => props.theme.colors["Level 3"]);



StyledInput.defaultProps = {
  theme: theme["b" /* defaultTheme */] };


const IconContainer = external_styled_components_default()(Object(helpers["omitProps"])("active")("span")).withConfig({ displayName: "styles__IconContainer", componentId: "sc-179kyte-4" })(["position:absolute;right:0;top:6px;padding:12px 0 0 12px;opacity:", ";cursor:pointer;outline:none;"],




({ active }) => active ? 1 : 0.65);
// EXTERNAL MODULE: ./src/components/icon/index.js + 7 modules
var icon = __webpack_require__(21);

// CONCATENATED MODULE: ./src/components/input/index.jsx
function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);} /* eslint-disable */





class input_Input extends external_react_default.a.Component {
















































  constructor(props) {
    super(props);this.

















































































    handleChange = event => {
      const { inputProps = {}, onChange } = this.props;
      const { value } = event.target;

      this.setState({ withValue: Boolean(value) });

      if (inputProps.onChange) {
        inputProps.onChange(event);
      } else if (onChange) {
        onChange(event);
      }
    };this.

    handleClickPasswordIcon = () => {
      if (this.props.passwordWithIcon) {
        this.setState(state => ({
          inputType: state.inputType === "password" ? "text" : "password" }));

      }
    };this.inputNode = null;const { inputProps: _inputProps = {}, passwordWithIcon } = props;this.state = { withValue: Boolean(_inputProps.value) || Boolean(_inputProps.initialValue), inputType: passwordWithIcon ? "password" : _inputProps.type || "text" };}render() {const { label, error, inputProps = {}, maskProps, width, disabled, passwordWithIcon, style, className, classNames = {}, // NOTE: this trick to filtering props
      // TODO: configure eslint to disable unused-vars with spread operator
      // eslint-disable-next-line no-unused-vars
      onChange, ...props } = this.props;const { inputType } = this.state;const isMaskedInput = Boolean(maskProps && maskProps.mask);const { placeholder } = inputProps;return /*#__PURE__*/external_react_default.a.createElement(Container, _extends({ style: { width, ...style }, className: `${className || ""} ${classNames.container || ""}` }, props), /*#__PURE__*/external_react_default.a.createElement(StyledInput, _extends({ isMask: isMaskedInput, disabled: disabled }, maskProps, inputProps, { placeholder: label ? undefined : placeholder, type: inputType, onChange: this.handleChange, withIconRight: passwordWithIcon, className: classNames.input })), passwordWithIcon && /*#__PURE__*/external_react_default.a.createElement(IconContainer, { active: this.state.inputType === "text", onClick: this.handleClickPasswordIcon, className: classNames.iconContainer }, this.state.inputType === "text" ? /*#__PURE__*/external_react_default.a.createElement(icon["c" /* IconEye */], null) : /*#__PURE__*/external_react_default.a.createElement(icon["d" /* IconEyeOff */], null)), label && /*#__PURE__*/external_react_default.a.createElement(Label, { className: `${classNames.label}`, active: this.state.withValue }, label), error && /*#__PURE__*/external_react_default.a.createElement(ErrorMessage, { className: classNames.error }, error));}}input_Input.propTypes = { /** ReactNode with error message */error: external_prop_types_default.a.node, /** Label */label: external_prop_types_default.a.node, /** Handler of change event */onChange: external_prop_types_default.a.func, /** All props from React.HTMLAttributes<HTMLInputElement> are support */inputProps: external_prop_types_default.a.shape({}), /** All props from ReactInputMask are support */maskProps: external_prop_types_default.a.shape({ mask: external_prop_types_default.a.string.isRequired, maskChar: external_prop_types_default.a.string, formatChars: external_prop_types_default.a.objectOf(external_prop_types_default.a.string), alwaysShowMask: external_prop_types_default.a.bool }), /** Width pass into the Container */width: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.number]), disabled: external_prop_types_default.a.bool, /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * Password mode with eye icon
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  * NOTE: pass inputProp={{ type: "password" }} for render password input without icon
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                  */passwordWithIcon: external_prop_types_default.a.bool, style: external_prop_types_default.a.objectOf(external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.number])), /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * className prop for root node
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             */className: external_prop_types_default.a.string, /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             * Shape of class names uses for customization
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                             */classNames: external_prop_types_default.a.shape({ container: external_prop_types_default.a.string, input: external_prop_types_default.a.string, iconContainer: external_prop_types_default.a.string, label: external_prop_types_default.a.string, error: external_prop_types_default.a.string }), placeholder: external_prop_types_default.a.string };input_Input.defaultProps = { inputProps: {} };

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: ./src/theme/index.js + 1 modules
var theme = __webpack_require__(12);

// CONCATENATED MODULE: ./src/components/checkbox/styles.js
/* eslint-disable */




const Container = external_styled_components_default.a.label.withConfig({ displayName: "styles__Container", componentId: "sc-1g3zqgs-0" })(["display:inline-flex;align-items:center;user-select:none;"]);





const HiddenInput = external_styled_components_default.a.input.attrs({
  type: "checkbox" }).withConfig({ displayName: "styles__HiddenInput", componentId: "sc-1g3zqgs-1" })(["opacity:0;width:0;height:0;z-index:-1;margin:0;"]);








const Label = external_styled_components_default.a.span.withConfig({ displayName: "styles__Label", componentId: "sc-1g3zqgs-2" })(["margin-left:16px;color:", ";", ""],

props => props.theme.colors.Foreground,
props => Object(external_styled_components_["css"])(props.theme.typography.SmallCapsHeadline));


Label.defaultProps = {
  theme: theme["b" /* defaultTheme */] };


const IconBox = external_styled_components_default.a.span.withConfig({ displayName: "styles__IconBox", componentId: "sc-1g3zqgs-3" })(["cursor:pointer;display:flex;align-items:center;justify-content:center;box-sizing:border-box;padding:3px;width:24px;height:24px;color:", ";border:2px solid ", ";border-radius:4px;text-align:center;flex-shrink:0;transition:border 0.2s;", " ~ &::before{content:\"\";display:inline-block;color:inherit;border:5px solid;border-radius:2px;opacity:0;transition:all 0.2s;}", ":checked ~ &::before{opacity:1;border:7px solid;color:", ";}"],








props => props.theme.colors["Level 2"],
props => props.theme.colors["Level 2"],





HiddenInput,









HiddenInput,


(props) =>
props.accentColor ?
props.accentColor :
props.theme.colors["Foreground"]);



IconBox.propTypes = {
  theme: external_prop_types_default.a.shape({
    checkbox: external_prop_types_default.a.shape({
      checkedColor: external_prop_types_default.a.string,
      borderColor: external_prop_types_default.a.string,
      borderColorFocus: external_prop_types_default.a.string,
      borderColorChecked: external_prop_types_default.a.string }) }) };




IconBox.defaultProps = {
  theme: theme["b" /* defaultTheme */] };
// CONCATENATED MODULE: ./src/components/checkbox/index.jsx
/* eslint-disable */





/**
                                         * Simple Checkbox component supports any React.ReactChild as label
                                         * All props from React.HTMLAttributes<HTMLInputElement> are support.
                                         */
class checkbox_Checkbox extends external_react_default.a.Component {










  render() {
    const { className, style, children, accentColor, ...props } = this.props;

    return /*#__PURE__*/(
      external_react_default.a.createElement(Container, { className: className, style: style }, /*#__PURE__*/
      external_react_default.a.createElement(HiddenInput, props), /*#__PURE__*/
      external_react_default.a.createElement(IconBox, { accentColor: accentColor }), /*#__PURE__*/
      external_react_default.a.createElement(Label, null, children)));


  }}checkbox_Checkbox.propTypes = { /** React.ReactChild */children: external_prop_types_default.a.node, /** className passes to Container */className: external_prop_types_default.a.string, /** React.CSSProperties passes to Container */style: external_prop_types_default.a.shape({}), accentColor: external_prop_types_default.a.string };


/* harmony default export */ var components_checkbox = __webpack_exports__["a"] = (external_styled_components_default()(checkbox_Checkbox).withConfig({ displayName: "checkbox", componentId: "qb7sb6-0" })([""]));

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: ./src/components/typography/index.js
var typography = __webpack_require__(60);

// EXTERNAL MODULE: ./src/internalComponents/clickable/index.jsx
var clickable = __webpack_require__(67);

// EXTERNAL MODULE: ./src/theme/index.js + 1 modules
var theme = __webpack_require__(12);

// EXTERNAL MODULE: ./src/helpers/index.js + 2 modules
var helpers = __webpack_require__(16);

// EXTERNAL MODULE: ./src/helpers/elevation/index.web.js
var index_web = __webpack_require__(11);

// CONCATENATED MODULE: ./src/components/sonntagButton/styles.js
/* eslint-disable */










const modifier = modifierName => ({
  css: (...args) => props => props[modifierName] && Object(external_styled_components_["css"])(...args) });


const getPadding = size => {
  if (size === "small") {
    return 16;
  }

  return 32;
};

const getMinWidth = size => {
  if (size === "small") {
    return 96;
  }

  return 192;
};

const getSizeProp = propertyName => ({ theme, size }) => {
  const sizeProperties = theme.button.size;

  switch (propertyName) {
    case "height":
      return sizeProperties[size];

    case "padding":
      return getPadding(size);

    case "minWidth":
      return getMinWidth(size);

    default:
      return 0;}

};

const getVariantProp = propertyName => ({ theme, variant, transparent }) => {
  const variantProperties =
  theme.button.variant[variant] || theme.button.variant.default;
  if (!variantProperties) {
    return;
  }

  switch (propertyName) {
    case "backgroundColor":{
        if (transparent) {
          return "transparent";
        }
        return variantProperties.backgroundColor;
      }

    case "borderColor":
      return variantProperties.backgroundColor;

    case "borderColorHovered":
    case "backgroundColorHovered":
      return variantProperties.backgroundColorHovered;

    case "color":
      return variantProperties.color;

    default:
      break;}

};

const getBorderRadius = props => {
  const height = getSizeProp("height")(props);

  return height / 2 || 0;
};

const ButtonView = Object(helpers["omitProps"])(
"fullWidth",
"transparent",
"size",
"variant",
"theme")(
clickable["a" /* default */]);

const StyledButton = external_styled_components_default()(ButtonView).withConfig({ displayName: "styles__StyledButton", componentId: "sc-1m3ryux-0" })(["", " line-height:16px;display:", ";", " box-sizing:border-box;height:", "px;padding:0 ", "px;background-color:", ";background-clip:padding-box;border-radius:", "px;border:2px solid ", ";min-width:", "px;overflow:hidden;text-align:center;color:", ";outline:none;", " &:hover:not(:disabled){cursor:pointer;background-color:", ";border-color:", ";", "}&:active:not(:disabled){text-decoration:none;", " transition-duration:0s;}&:visited{text-decoration:none;}&:disabled{transition:none;transform:none;opacity:0.4;cursor:default;}"],
props => Object(external_styled_components_["css"])(props.theme.typography.SmallHeadline),

({ fullWidth }) => fullWidth ? "block" : "inline-block",
({ fullWidth }) =>
fullWidth &&
Object(external_styled_components_["css"])(["width:100%;"]),



getSizeProp("height"),
getSizeProp("padding"),
getVariantProp("backgroundColor"),

getBorderRadius,
getVariantProp("borderColor"),
getSizeProp("minWidth"),


getVariantProp("color"),


index_web["elevationTransition"],



getVariantProp("backgroundColorHovered"),
getVariantProp("borderColorHovered"),
Object(index_web["elevation"])(2, false),




Object(index_web["elevation"])(1, false));















StyledButton.defaultProps = {
  size: "medium",
  theme: theme["b" /* defaultTheme */] };


const ButtonTypography = external_styled_components_default()(typography["a" /* default */]).withConfig({ displayName: "styles__ButtonTypography", componentId: "sc-1m3ryux-1" })(["color:#333333;", ""],


modifier("dark").css`
        color: white;
    `);



// CONCATENATED MODULE: ./src/components/sonntagButton/index.jsx
/* eslint-disable */




const SonntagButton = props => /*#__PURE__*/external_react_default.a.createElement(StyledButton, props);

SonntagButton.propTypes = {
  size: external_prop_types_default.a.oneOf(["small", "medium"]),
  varaint: external_prop_types_default.a.oneOf(["default"]),
  fullWidth: external_prop_types_default.a.bool,
  borderOnly: external_prop_types_default.a.bool };


SonntagButton.defaultProps = {
  variant: "default",
  size: "medium" };


/* harmony default export */ var sonntagButton = __webpack_exports__["a"] = (SonntagButton);

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);

// EXTERNAL MODULE: ./src/components/Buttons/SonntagButtonV2/index.js + 2 modules
var SonntagButtonV2 = __webpack_require__(27);

// CONCATENATED MODULE: ./src/components/Buttons/CtaButton/CtaButton.jsx
function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);} /* eslint-disable react/no-children-prop */
/* eslint-disable react/jsx-props-no-spreading */




const Cta = ({
  className,
  size,
  fullWidth,
  iconPath,
  iconSvgCode,
  children,
  disabled,
  ...props }) =>
{
  const theme = Object(external_react_["useContext"])(external_styled_components_["ThemeContext"]);
  return /*#__PURE__*/(
    external_react_default.a.createElement(SonntagButtonV2["default"], _extends({
      className: className,
      iconPath: iconPath,
      iconSvgCode: iconSvgCode,
      disabled: disabled,
      fullWidth: fullWidth,
      size: size,
      solid: true,
      accentColor: theme.colors.Color1,
      children: children },
    props)));


};

/* harmony default export */ var CtaButton = (Cta);
// CONCATENATED MODULE: ./src/components/Buttons/CtaButton/index.js


/* harmony default export */ var Buttons_CtaButton = __webpack_exports__["a"] = (CtaButton);

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: ./src/theme/index.js + 1 modules
var theme = __webpack_require__(12);

// CONCATENATED MODULE: ./src/components/sectionHead/styles.js
/* eslint-disable */



const SectionHeadWrapper = external_styled_components_default.a.div.withConfig({ displayName: "styles__SectionHeadWrapper", componentId: "x98tgc-0" })(["display:flex;height:24px;"]);




const StyledSectionHead = external_styled_components_default.a.div.withConfig({ displayName: "styles__StyledSectionHead", componentId: "x98tgc-1" })(["", " color:", ";display:flex;flex:1;display:flex;align-items:center;&::after{background-color:", ";content:\"\";height:4px;flex:1;border-radius:2px;margin-left:", ";}"],
props => Object(external_styled_components_["css"])(props.theme.typography.SmallCapsHeadline),
props => props.theme.colors["Level 5"],






props => props.theme.colors["Level 1"],




props => props.theme.spacers.M);



StyledSectionHead.defaultProps = {
  theme: theme["b" /* defaultTheme */] };


const IconContainer = external_styled_components_default()("span").withConfig({ displayName: "styles__IconContainer", componentId: "x98tgc-2" })(["margin-right:4px;color:", ";"],

props => props.theme.colors["Level 5"]);


IconContainer.defaultProps = {
  theme: theme["b" /* defaultTheme */] };
// CONCATENATED MODULE: ./src/components/sectionHead/index.jsx
/* eslint-disable */




const SectionHead = ({ title, icon, classNames }) => {
  return /*#__PURE__*/(
    external_react_default.a.createElement(SectionHeadWrapper, null,
    icon && /*#__PURE__*/
    external_react_default.a.createElement(IconContainer, {
      className: classNames.iconContainer },

    icon), /*#__PURE__*/


    external_react_default.a.createElement(StyledSectionHead, { className: classNames.sectionHead },
    title)));



};

SectionHead.propTypes = {
  title: external_prop_types_default.a.node,
  icon: external_prop_types_default.a.node,
  classNames: external_prop_types_default.a.shape({
    iconContainer: external_prop_types_default.a.string,
    sectionHead: external_prop_types_default.a.string }) };



SectionHead.defaultProps = {
  title: "Section Head",
  icon: null,
  classNames: {} };


/* harmony default export */ var sectionHead = __webpack_exports__["a"] = (SectionHead);

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, "a", function() { return /* binding */ inputSelect_InputSelect; });

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: ./src/theme/index.js + 1 modules
var theme = __webpack_require__(12);

// EXTERNAL MODULE: ./src/helpers/index.js + 2 modules
var helpers = __webpack_require__(16);

// CONCATENATED MODULE: ./src/components/inputSelect/styles.jsx
/* eslint-disable */






const Label = external_styled_components_default()(Object(helpers["omitProps"])("theme")("span")).withConfig({ displayName: "styles__Label", componentId: "sc-1ncpbo3-0" })(["", " position:absolute;top:0;left:0;user-select:none;color:", ";height:12px;white-space:nowrap;transition:all 0.2s;transition-timing-function:cubic-bezier(0.4,0,0.2,1);pointer-events:none;"],
props => Object(external_styled_components_["css"])(props.theme.typography.SmallCapsHeadline),




props => props.theme.colors["Level 4"]);







Label.defaultProps = {
  theme: theme["b" /* defaultTheme */] };


const Container = external_styled_components_default.a.label.withConfig({ displayName: "styles__Container", componentId: "sc-1ncpbo3-1" })(["display:inline-block;position:relative;z-index:0;color:", ";"],



props => props.theme.colors.Foreground);


Container.defaultProps = {
  theme: theme["b" /* defaultTheme */] };


const InputSelectComponent = ({ children, ...props }) => {
  return /*#__PURE__*/external_react_default.a.createElement("select", props, children);
};

InputSelectComponent.propTypes = {
  children: external_prop_types_default.a.node };


const StyledInputSelect = external_styled_components_default()(
Object(helpers["omitProps"])("theme")(InputSelectComponent)).withConfig({ displayName: "styles__StyledInputSelect", componentId: "sc-1ncpbo3-2" })(["", " line-height:18px;box-sizing:border-box;width:100%;padding:24px 30px 6px 0;outline:none;background:transparent;border:none;border-radius:0;border-bottom:2px solid ", ";color:", ";appearance:none;cursor:pointer;text-shadow:0 0 0 #000;"],

props => Object(external_styled_components_["css"])(props.theme.typography.Paragraph),








props => props.theme.colors["Level 4"],
props => props.theme.colors.Foreground);





StyledInputSelect.defaultProps = {
  theme: theme["b" /* defaultTheme */] };


const IconContainer = external_styled_components_default()("span").withConfig({ displayName: "styles__IconContainer", componentId: "sc-1ncpbo3-3" })(["z-index:-1;position:absolute;right:0;padding:24px 0 0 6px;cursor:pointer;outline:none;color:", ";"],






props => props.theme.colors["Level 4"]);


IconContainer.defaultProps = {
  theme: theme["b" /* defaultTheme */] };
// EXTERNAL MODULE: ./src/components/icon/index.js + 7 modules
var icon = __webpack_require__(21);

// CONCATENATED MODULE: ./src/components/inputSelect/index.jsx
function _extends() {_extends = Object.assign || function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);} /* eslint-disable */





class inputSelect_InputSelect extends external_react_default.a.Component {












































  render() {
    const {
      label,
      inputProps,
      width,
      style,
      className,
      classNames = {},
      ...props } =
    this.props;

    const
    { name, value, options, onChange, onFocus, onBlur, onClick } = inputProps;

    return /*#__PURE__*/(
      external_react_default.a.createElement(Container, _extends({
        style: { width, ...style },
        className: `${className || ""} ${classNames.container || ""}` },
      props), /*#__PURE__*/

      external_react_default.a.createElement(StyledInputSelect, {
        className: classNames.input,
        name: name,
        value: value,
        onFocus: onFocus,
        onBlur: onBlur,
        onChange: onChange,
        onClick: onClick },

      options.map((option, i) => /*#__PURE__*/
      external_react_default.a.createElement("option", { key: i, value: option.value }, option.text))), /*#__PURE__*/


      external_react_default.a.createElement(IconContainer, { className: classNames.iconContainer }, /*#__PURE__*/
      external_react_default.a.createElement(icon["a" /* IconArrow */], null)),

      label && /*#__PURE__*/
      external_react_default.a.createElement(Label, { className: `${classNames.label}` },
      label)));




  }}inputSelect_InputSelect.propTypes = { label: external_prop_types_default.a.node, inputProps: external_prop_types_default.a.shape({}), /** Width pass into the Container */width: external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.number]), style: external_prop_types_default.a.objectOf(external_prop_types_default.a.oneOfType([external_prop_types_default.a.string, external_prop_types_default.a.number])), /**
                                                                                                                                                                                                                                                                                   * className prop for root node
                                                                                                                                                                                                                                                                                   */className: external_prop_types_default.a.string, /**
                                                                                                                                                                                                                                                                                                                   * Shape of class names uses for customization
                                                                                                                                                                                                                                                                                                                   */classNames: external_prop_types_default.a.shape({ container: external_prop_types_default.a.string, input: external_prop_types_default.a.string, label: external_prop_types_default.a.string }) };inputSelect_InputSelect.defaultProps = { label: '', inputProps: { name: 'select', value: '', options: [{ text: 'First option', value: 1 }, { text: 'Second option', value: 2 }], onChange: () => {}, onClick: () => {}, onFocus: () => {}, onBlur: () => {} } };

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXTERNAL MODULE: external "react"
var external_react_ = __webpack_require__(1);
var external_react_default = /*#__PURE__*/__webpack_require__.n(external_react_);

// EXTERNAL MODULE: external "prop-types"
var external_prop_types_ = __webpack_require__(0);
var external_prop_types_default = /*#__PURE__*/__webpack_require__.n(external_prop_types_);

// EXTERNAL MODULE: external "styled-components"
var external_styled_components_ = __webpack_require__(2);
var external_styled_components_default = /*#__PURE__*/__webpack_require__.n(external_styled_components_);

// EXTERNAL MODULE: ./src/theme/index.js + 1 modules
var theme = __webpack_require__(12);

// CONCATENATED MODULE: ./src/components/compactPaymentDisplay/styles.js



const CompactPaymentWrapper = external_styled_components_default()('div').withConfig({ displayName: "styles__CompactPaymentWrapper", componentId: "wvi3s9-0" })(["display:flex;height:29px;"]);




const IconWrapper = external_styled_components_default()('span').withConfig({ displayName: "styles__IconWrapper", componentId: "wvi3s9-1" })(["color:", ";align-self:center;height:24px;"],
props => props.theme.colors.Foreground);




IconWrapper.defaultProps = {
  theme: theme["b" /* defaultTheme */] };


const DefaultWrapper = external_styled_components_default()('div').withConfig({ displayName: "styles__DefaultWrapper", componentId: "wvi3s9-2" })(["", " color:", ";padding-left:", ";align-self:center;"],
props => Object(external_styled_components_["css"])(props.theme.typography.Subheadline),
props => props.theme.colors.Foreground,
props => props.theme.spacers.L);



const TightFitWrapper = external_styled_components_default()(DefaultWrapper).withConfig({ displayName: "styles__TightFitWrapper", componentId: "wvi3s9-3" })(["font-size:16px;line-height:19px;"]);




DefaultWrapper.defaultProps = {
  theme: theme["b" /* defaultTheme */] };
// EXTERNAL MODULE: ./src/components/icon/index.js + 7 modules
var icon = __webpack_require__(21);

// CONCATENATED MODULE: ./src/components/compactPaymentDisplay/index.jsx
/* eslint-disable */





const mapTypeToContent = ({
  type = '',
  identifier,
  classNames = {} }) =>
{
  const maskedIdentifier = identifier.
  replace(/.(?=.{4})/g, '•').
  match(/(.{1,4})/g).
  join(' ');
  let normalizedType = '';

  if (typeof type === 'string') {
    normalizedType = type.toLowerCase();
  }

  switch (normalizedType) {
    case 'card':
      return {
        extensionClassName: classNames.cardWrapper,
        WrapperComponent: DefaultWrapper,
        IconComponent: icon["b" /* IconCard */],
        paymentIdentifier: maskedIdentifier };

    case 'paypal':
      return {
        extensionClassName: classNames.payPalWrapper,
        WrapperComponent: TightFitWrapper,
        IconComponent: icon["e" /* IconPayPal */],
        paymentIdentifier: identifier };


    case 'sepa':
      return {
        extensionClassName: classNames.sepaWrapper,
        WrapperComponent: TightFitWrapper,
        IconComponent: icon["f" /* IconSepa */],
        paymentIdentifier: identifier };


    default:
      return {
        WrapperComponent: TightFitWrapper,
        icon: null,
        paymentIdentifier: identifier };}


};

const CompactPaymentDisplay = ({
  className, classNames, type, identifier }) =>
{
  const {
    paymentIdentifier, IconComponent, WrapperComponent, extensionClassName } =
  mapTypeToContent({
    type,
    identifier,
    classNames });

  return /*#__PURE__*/(
    external_react_default.a.createElement(CompactPaymentWrapper, { className: className }, /*#__PURE__*/
    external_react_default.a.createElement(IconWrapper, { className: classNames.iconWrapper },
    IconComponent ? /*#__PURE__*/external_react_default.a.createElement(IconComponent, null) : null), /*#__PURE__*/


    external_react_default.a.createElement(WrapperComponent, { className: extensionClassName },
    paymentIdentifier)));



};

CompactPaymentDisplay.propTypes = {
  className: external_prop_types_default.a.string,
  classNames: external_prop_types_default.a.shape({
    iconWrapper: external_prop_types_default.a.string,
    cardWrapper: external_prop_types_default.a.string,
    payPalWrapper: external_prop_types_default.a.string,
    sepaWrapper: external_prop_types_default.a.string }),

  type: external_prop_types_default.a.string.isRequired,
  identifier: external_prop_types_default.a.string };


CompactPaymentDisplay.defaultProps = {
  className: undefined,
  classNames: {},
  identifier: '' };


/* harmony default export */ var compactPaymentDisplay = __webpack_exports__["a"] = (CompactPaymentDisplay);

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createPrefixer;

var _prefixProperty = __webpack_require__(170);

var _prefixProperty2 = _interopRequireDefault(_prefixProperty);

var _prefixValue = __webpack_require__(171);

var _prefixValue2 = _interopRequireDefault(_prefixValue);

var _addNewValuesOnly = __webpack_require__(172);

var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);

var _isObject = __webpack_require__(173);

var _isObject2 = _interopRequireDefault(_isObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createPrefixer(_ref) {
  var prefixMap = _ref.prefixMap,
      plugins = _ref.plugins;

  return function prefix(style) {
    for (var property in style) {
      var value = style[property];

      // handle nested objects
      if ((0, _isObject2.default)(value)) {
        style[property] = prefix(value);
        // handle array values
      } else if (Array.isArray(value)) {
        var combinedValue = [];

        for (var i = 0, len = value.length; i < len; ++i) {
          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
        }

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (combinedValue.length > 0) {
          style[property] = combinedValue;
        }
      } else {
        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);

        // only modify the value if it was touched
        // by any plugin to prevent unnecessary mutations
        if (_processedValue) {
          style[property] = _processedValue;
        }

        style = (0, _prefixProperty2.default)(prefixMap, property, style);
      }
    }

    return style;
  };
}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = backgroundClip;

// https://developer.mozilla.org/en-US/docs/Web/CSS/background-clip#Browser_compatibility
function backgroundClip(property, value) {
  if (typeof value === 'string' && value === 'text') {
    return ['-webkit-text', 'text'];
  }
}

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = crossFade;

var _isPrefixedValue = __webpack_require__(41);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#search=cross-fade
var prefixes = ['-webkit-', ''];
function crossFade(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('cross-fade(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/cross-fade\(/g, prefix + 'cross-fade(');
    });
  }
}

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cursor;
var prefixes = ['-webkit-', '-moz-', ''];

var values = {
  'zoom-in': true,
  'zoom-out': true,
  grab: true,
  grabbing: true
};

function cursor(property, value) {
  if (property === 'cursor' && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = filter;

var _isPrefixedValue = __webpack_require__(41);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-filter-function
var prefixes = ['-webkit-', ''];
function filter(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('filter(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/filter\(/g, prefix + 'filter(');
    });
  }
}

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flex;
var values = {
  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
};

function flex(property, value) {
  if (property === 'display' && values.hasOwnProperty(value)) {
    return values[value];
  }
}

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxIE;
var alternativeValues = {
  'space-around': 'distribute',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end'
};
var alternativeProps = {
  alignContent: 'msFlexLinePack',
  alignSelf: 'msFlexItemAlign',
  alignItems: 'msFlexAlign',
  justifyContent: 'msFlexPack',
  order: 'msFlexOrder',
  flexGrow: 'msFlexPositive',
  flexShrink: 'msFlexNegative',
  flexBasis: 'msFlexPreferredSize'
  // Full expanded syntax is flex-grow | flex-shrink | flex-basis.
};var flexShorthandMappings = {
  auto: '1 1 auto',
  inherit: 'inherit',
  initial: '0 1 auto',
  none: '0 0 auto',
  unset: 'unset'
};
var isUnitlessNumber = /^\d+(\.\d+)?$/;

function flexboxIE(property, value, style) {
  if (Object.prototype.hasOwnProperty.call(alternativeProps, property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
  if (property === 'flex') {
    // For certain values we can do straight mappings based on the spec
    // for the expansions.
    if (Object.prototype.hasOwnProperty.call(flexShorthandMappings, value)) {
      style.msFlex = flexShorthandMappings[value];
      return;
    }
    // Here we have no direct mapping, so we favor looking for a
    // unitless positive number as that will be the most common use-case.
    if (isUnitlessNumber.test(value)) {
      style.msFlex = value + ' 1 0%';
      return;
    }

    // The next thing we can look for is if there are multiple values.
    var flexValues = value.split(/\s/);
    // If we only have a single value that wasn't a positive unitless
    // or a pre-mapped value, then we can assume it is a unit value.
    switch (flexValues.length) {
      case 1:
        style.msFlex = '1 1 ' + value;
        return;
      case 2:
        // If we have 2 units, then we expect that the first will
        // always be a unitless number and represents flex-grow.
        // The second unit will represent flex-shrink for a unitless
        // value, or flex-basis otherwise.
        if (isUnitlessNumber.test(flexValues[1])) {
          style.msFlex = flexValues[0] + ' ' + flexValues[1] + ' 0%';
        } else {
          style.msFlex = flexValues[0] + ' 1 ' + flexValues[1];
        }
        return;
      default:
        style.msFlex = value;
    }
  }
}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flexboxOld;
var alternativeValues = {
  'space-around': 'justify',
  'space-between': 'justify',
  'flex-start': 'start',
  'flex-end': 'end',
  'wrap-reverse': 'multiple',
  wrap: 'multiple'
};

var alternativeProps = {
  alignItems: 'WebkitBoxAlign',
  justifyContent: 'WebkitBoxPack',
  flexWrap: 'WebkitBoxLines',
  flexGrow: 'WebkitBoxFlex'
};

function flexboxOld(property, value, style) {
  if (property === 'flexDirection' && typeof value === 'string') {
    if (value.indexOf('column') > -1) {
      style.WebkitBoxOrient = 'vertical';
    } else {
      style.WebkitBoxOrient = 'horizontal';
    }
    if (value.indexOf('reverse') > -1) {
      style.WebkitBoxDirection = 'reverse';
    } else {
      style.WebkitBoxDirection = 'normal';
    }
  }
  if (alternativeProps.hasOwnProperty(property)) {
    style[alternativeProps[property]] = alternativeValues[value] || value;
  }
}

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = gradient;

var _isPrefixedValue = __webpack_require__(41);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var prefixes = ['-webkit-', '-moz-', ''];

var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/gi;

function gradient(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
    return prefixes.map(function (prefix) {
      return value.replace(values, function (grad) {
        return prefix + grad;
      });
    });
  }
}

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = imageSet;

var _isPrefixedValue = __webpack_require__(41);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// http://caniuse.com/#feat=css-image-set
var prefixes = ['-webkit-', ''];
function imageSet(property, value) {
  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('image-set(') > -1) {
    return prefixes.map(function (prefix) {
      return value.replace(/image-set\(/g, prefix + 'image-set(');
    });
  }
}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = position;
function position(property, value) {
  if (property === 'position' && value === 'sticky') {
    return ['-webkit-sticky', 'sticky'];
  }
}

/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = sizing;
var prefixes = ['-webkit-', '-moz-', ''];

var properties = {
  maxHeight: true,
  maxWidth: true,
  width: true,
  height: true,
  columnWidth: true,
  minWidth: true,
  minHeight: true
};
var values = {
  'min-content': true,
  'max-content': true,
  'fill-available': true,
  'fit-content': true,
  'contain-floats': true
};

function sizing(property, value) {
  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
    return prefixes.map(function (prefix) {
      return prefix + value;
    });
  }
}

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = transition;

var _hyphenateProperty = __webpack_require__(174);

var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);

var _isPrefixedValue = __webpack_require__(41);

var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);

var _capitalizeString = __webpack_require__(97);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var properties = {
  transition: true,
  transitionProperty: true,
  WebkitTransition: true,
  WebkitTransitionProperty: true,
  MozTransition: true,
  MozTransitionProperty: true
};


var prefixMapping = {
  Webkit: '-webkit-',
  Moz: '-moz-',
  ms: '-ms-'
};

function prefixValue(value, propertyPrefixMap) {
  if ((0, _isPrefixedValue2.default)(value)) {
    return value;
  }

  // only split multi values, not cubic beziers
  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);

  for (var i = 0, len = multipleValues.length; i < len; ++i) {
    var singleValue = multipleValues[i];
    var values = [singleValue];
    for (var property in propertyPrefixMap) {
      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);

      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
        var prefixes = propertyPrefixMap[property];
        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
          // join all prefixes and create a new value
          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
        }
      }
    }

    multipleValues[i] = values.join(',');
  }

  return multipleValues.join(',');
}

function transition(property, value, style, propertyPrefixMap) {
  // also check for already prefixed transitions
  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
    var outputValue = prefixValue(value, propertyPrefixMap);
    // if the property is already prefixed
    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-moz-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Webkit') > -1) {
      return webkitOutput;
    }

    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
      return !/-webkit-|-ms-/.test(val);
    }).join(',');

    if (property.indexOf('Moz') > -1) {
      return mozOutput;
    }

    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
    return outputValue;
  }
}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * BezierEasing - use bezier curve for transition easing function
 * https://github.com/gre/bezier-easing
 *
 * @copyright 2014-2015 Gaëtan Renaudeau. MIT License.
 * 
 */
 // These values are established by empiricism with tests (tradeoff: performance VS precision)

var NEWTON_ITERATIONS = 4;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;
var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
var float32ArraySupported = typeof Float32Array === 'function';

function A(aA1, aA2) {
  return 1.0 - 3.0 * aA2 + 3.0 * aA1;
}

function B(aA1, aA2) {
  return 3.0 * aA2 - 6.0 * aA1;
}

function C(aA1) {
  return 3.0 * aA1;
} // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.


function calcBezier(aT, aA1, aA2) {
  return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
} // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.


function getSlope(aT, aA1, aA2) {
  return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
}

function binarySubdivide(aX, aA, aB, mX1, mX2) {
  var currentX,
      currentT,
      i = 0;

  do {
    currentT = aA + (aB - aA) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - aX;

    if (currentX > 0.0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

  return currentT;
}

function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
  for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
    var currentSlope = getSlope(aGuessT, mX1, mX2);

    if (currentSlope === 0.0) {
      return aGuessT;
    }

    var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
    aGuessT -= currentX / currentSlope;
  }

  return aGuessT;
}

module.exports = function bezier(mX1, mY1, mX2, mY2) {
  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
    // eslint-disable-line yoda
    throw new Error('bezier x values must be in [0, 1] range');
  } // Precompute samples table


  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);

  if (mX1 !== mY1 || mX2 !== mY2) {
    for (var i = 0; i < kSplineTableSize; ++i) {
      sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
    }
  }

  function getTForX(aX) {
    var intervalStart = 0.0;
    var currentSample = 1;
    var lastSample = kSplineTableSize - 1;

    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }

    --currentSample; // Interpolate to provide an initial guess for t

    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    var guessForT = intervalStart + dist * kSampleStepSize;
    var initialSlope = getSlope(guessForT, mX1, mX2);

    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0.0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }

  return function BezierEasing(x) {
    if (mX1 === mY1 && mX2 === mY2) {
      return x; // linear
    } // Because JavaScript number are imprecise, we should guarantee the extremes are right.


    if (x === 0) {
      return 0;
    }

    if (x === 1) {
      return 1;
    }

    return calcBezier(getTForX(x), mY1, mY2);
  };
};

/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var _Animation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37);
/* harmony import */ var _NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5);
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 * @format
 */


function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }




var DecayAnimation =
/*#__PURE__*/
function (_Animation) {
  _inheritsLoose(DecayAnimation, _Animation);

  function DecayAnimation(config) {
    var _this;

    _this = _Animation.call(this) || this;
    _this._deceleration = config.deceleration !== undefined ? config.deceleration : 0.998;
    _this._velocity = config.velocity;
    _this._useNativeDriver = Object(_NativeAnimatedHelper__WEBPACK_IMPORTED_MODULE_1__[/* shouldUseNativeDriver */ "c"])(config);
    _this.__isInteraction = config.isInteraction !== undefined ? config.isInteraction : true;
    _this.__iterations = config.iterations !== undefined ? config.iterations : 1;
    return _this;
  }

  var _proto = DecayAnimation.prototype;

  _proto.__getNativeAnimationConfig = function __getNativeAnimationConfig() {
    return {
      type: 'decay',
      deceleration: this._deceleration,
      velocity: this._velocity,
      iterations: this.__iterations
    };
  };

  _proto.start = function start(fromValue, onUpdate, onEnd, previousAnimation, animatedValue) {
    this.__active = true;
    this._lastValue = fromValue;
    this._fromValue = fromValue;
    this._onUpdate = onUpdate;
    this.__onEnd = onEnd;
    this._startTime = Date.now();

    if (this._useNativeDriver) {
      this.__startNativeAnimation(animatedValue);
    } else {
      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
    }
  };

  _proto.onUpdate = function onUpdate() {
    var now = Date.now();
    var value = this._fromValue + this._velocity / (1 - this._deceleration) * (1 - Math.exp(-(1 - this._deceleration) * (now - this._startTime)));

    this._onUpdate(value);

    if (Math.abs(this._lastValue - value) < 0.1) {
      this.__debouncedOnEnd({
        finished: true
      });

      return;
    }

    this._lastValue = value;

    if (this.__active) {
      this._animationFrame = requestAnimationFrame(this.onUpdate.bind(this));
    }
  };

  _proto.stop = function stop() {
    _Animation.prototype.stop.call(this);

    this.__active = false;
    global.cancelAnimationFrame(this._animationFrame);

    this.__debouncedOnEnd({
      finished: false
    });
  };

  return DecayAnimation;
}(_Animation__WEBPACK_IMPORTED_MODULE_0__[/* default */ "a"]);

/* harmony default export */ __webpack_exports__["a"] = (DecayAnimation);
/* WEBPACK VAR INJECTION */}.call(this, __webpack_require__(52)))

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var isObj = __webpack_require__(178);
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Sources cannot be null or undefined');
	}

	return Object(val);
}

function assignKey(to, from, key) {
	var val = from[key];

	if (val === undefined || val === null) {
		return;
	}

	if (hasOwnProperty.call(to, key)) {
		if (to[key] === undefined || to[key] === null) {
			throw new TypeError('Cannot convert undefined or null to object (' + key + ')');
		}
	}

	if (!hasOwnProperty.call(to, key) || !isObj(val)) {
		to[key] = val;
	} else {
		to[key] = assign(Object(to[key]), from[key]);
	}
}

function assign(to, from) {
	if (to === from) {
		return to;
	}

	from = Object(from);

	for (var key in from) {
		if (hasOwnProperty.call(from, key)) {
			assignKey(to, from, key);
		}
	}

	if (Object.getOwnPropertySymbols) {
		var symbols = Object.getOwnPropertySymbols(from);

		for (var i = 0; i < symbols.length; i++) {
			if (propIsEnumerable.call(from, symbols[i])) {
				assignKey(to, from, symbols[i]);
			}
		}
	}

	return to;
}

module.exports = function deepAssign(target) {
	target = toObject(target);

	for (var s = 1; s < arguments.length; s++) {
		assign(target, arguments[s]);
	}

	return target;
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSwipeableViews = __webpack_require__(218);

var _reactSwipeableViews2 = _interopRequireDefault(_reactSwipeableViews);

var _HeightUpdater = __webpack_require__(239);

var _HeightUpdater2 = _interopRequireDefault(_HeightUpdater);

var _ScrollToTop = __webpack_require__(240);

var _ScrollToTop2 = _interopRequireDefault(_ScrollToTop);

var SwipeableBottomSheet = (function (_Component) {
	_inherits(SwipeableBottomSheet, _Component);

	function SwipeableBottomSheet(props) {
		_classCallCheck(this, SwipeableBottomSheet);

		_get(Object.getPrototypeOf(SwipeableBottomSheet.prototype), 'constructor', this).call(this, props);

		this.onHeightChange = this.onHeightChange.bind(this);
		this.onChangeIndex = this.onChangeIndex.bind(this);
		this.onTransitionEnd = this.onTransitionEnd.bind(this);

		this.state = {
			open: props.defaultOpen,
			height: window.innerHeight
		};
	}

	_createClass(SwipeableBottomSheet, [{
		key: 'onHeightChange',
		value: function onHeightChange(height) {
			this.setState({ height: height });
		}
	}, {
		key: 'onChangeIndex',
		value: function onChangeIndex(index) {
			var open = index === 1;
			if (this.props.open === undefined) {
				this.setState({ open: open });
			}
			if (this.props.onChange !== undefined) {
				this.props.onChange(open);
			}
		}
	}, {
		key: 'onTransitionEnd',
		value: function onTransitionEnd() {
			var _props = this.props;
			var overflowHeight = _props.overflowHeight;
			var swipeableViewsProps = _props.swipeableViewsProps;

			if (overflowHeight === 0) {
				this.bodyElt.scrollTop = 0;
			}
			if (swipeableViewsProps.onTransitionEnd) {
				swipeableViewsProps.onTransitionEnd();
			}
		}
	}, {
		key: 'render',
		value: function render() {
			var _this = this;

			var _props2 = this.props;
			var overflowHeight = _props2.overflowHeight;
			var fullScreen = _props2.fullScreen;
			var marginTop = _props2.marginTop;
			var open = _props2.open;
			var topShadow = _props2.topShadow;
			var shadowTip = _props2.shadowTip;
			var overlay = _props2.overlay;
			var swipeableViewsProps = _props2.swipeableViewsProps;
			var scrollTopAtClose = _props2.scrollTopAtClose;

			var hiddenWhenClosed = overflowHeight === 0;
			var isControlled = open !== undefined;
			var isOpen = isControlled ? open : this.state.open;
			var hideShadows = hiddenWhenClosed && !isOpen;
			var index = isOpen ? 1 : 0;
			var maxHeight = this.state.height - marginTop;

			var styles = {
				root: _extends({
					height: overflowHeight,
					position: 'fixed',
					bottom: 0,
					right: 0,
					left: 0
				}, this.props.style),
				swiper: {
					root: _extends({
						overflowY: 'initial',
						boxSizing: 'border-box'
					}, swipeableViewsProps.style),
					container: _extends({
						boxSizing: 'border-box'
					}, topShadow && !hideShadows && {
						boxShadow: 'rgba(0, 0, 0, 0.156863) 0px -6px 5px'
					}, swipeableViewsProps.containerStyle),
					slide: _extends({
						boxSizing: 'border-box',
						overflow: 'visible',
						marginBottom: -overflowHeight
					}, swipeableViewsProps.slideStyle),
					bottomSlide: {
						marginBottom: overflowHeight
					},
					body: _extends({
						overflow: isOpen ? 'auto' : 'hidden',
						backgroundColor: 'white',
						height: fullScreen ? maxHeight : 'initial',
						maxHeight: maxHeight
					}, this.props.bodyStyle)
				},
				overlay: _extends({
					position: 'fixed',
					top: 0,
					right: 0,
					left: 0,
					height: this.state.height,
					transition: 'opacity 450ms',
					pointerEvents: 'none',
					backgroundColor: 'black',
					opacity: 0
				}, isOpen && {
					opacity: 0.54,
					pointerEvents: 'auto'
				}, this.props.overlayStyle),
				shadowTip: {
					position: 'fixed',
					height: 60,
					width: '200%',
					bottom: -60,
					left: '-50%',
					boxShadow: 'rgba(0, 0, 0, 0.7) 0px 0px 30px',
					transition: 'transform 450ms',
					transform: isOpen ? 'translateY(50px)' : 'translateY(0)'
				}
			};

			return _react2['default'].createElement(
				'div',
				{ style: styles.root },
				_react2['default'].createElement(_HeightUpdater2['default'], {
					height: this.state.height,
					onHeightChange: this.onHeightChange
				}),
				overlay && _react2['default'].createElement('div', { style: styles.overlay, onClick: function () {
						return _this.onChangeIndex(0);
					} }),
				_react2['default'].createElement(
					_reactSwipeableViews2['default'],
					_extends({
						index: index,
						axis: 'y',
						enableMouseEvents: true,
						onChangeIndex: this.onChangeIndex
					}, this.props.swipeableViewsProps, {
						onTransitionEnd: this.onTransitionEnd,
						style: styles.swiper.root,
						containerStyle: styles.swiper.container,
						slideStyle: styles.swiper.slide
					}),
					_react2['default'].createElement(
						'div',
						{
							ref: function (elt) {
								return _this.bodyElt = elt;
							},
							style: styles.swiper.body,
							className: 'ReactSwipeableBottomSheet--' + (isOpen ? 'open' : 'closed')
						},
						this.props.children
					),
					_react2['default'].createElement('div', { style: styles.swiper.bottomSlide })
				),
				shadowTip && !hideShadows && _react2['default'].createElement('div', { style: styles.shadowTip }),
				!isOpen && scrollTopAtClose && !hiddenWhenClosed && _react2['default'].createElement(_ScrollToTop2['default'], { element: function () {
						return _this.bodyElt;
					} })
			);
		}
	}]);

	return SwipeableBottomSheet;
})(_react.Component);

;

SwipeableBottomSheet.propTypes = {
	bodyStyle: _propTypes2['default'].object,
	children: _propTypes2['default'].node.isRequired,
	defaultOpen: _propTypes2['default'].bool,
	fullScreen: _propTypes2['default'].bool,
	marginTop: _propTypes2['default'].number,
	onChange: _propTypes2['default'].func,
	onTransitionEnd: _propTypes2['default'].func,
	open: _propTypes2['default'].bool,
	overflowHeight: _propTypes2['default'].number,
	overlay: _propTypes2['default'].bool,
	overlayStyle: _propTypes2['default'].object,
	scrollTopAtClose: _propTypes2['default'].bool,
	shadowTip: _propTypes2['default'].bool,
	style: _propTypes2['default'].object,
	swipeableViewsProps: _propTypes2['default'].object,
	topShadow: _propTypes2['default'].bool
};

SwipeableBottomSheet.defaultProps = {
	defaultOpen: false,
	fullScreen: false,
	marginTop: 0,
	overflowHeight: 0,
	overlay: true,
	scrollTopAtClose: true,
	shadowTip: true,
	swipeableViewsProps: {},
	topShadow: true
};

exports['default'] = SwipeableBottomSheet;
module.exports = exports['default'];

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(159);


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var src_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(12);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "darkBaseTheme", function() { return src_theme__WEBPACK_IMPORTED_MODULE_0__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "lightBaseTheme", function() { return src_theme__WEBPACK_IMPORTED_MODULE_0__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "defaultTheme", function() { return src_theme__WEBPACK_IMPORTED_MODULE_0__["b"]; });

/* harmony import */ var src_components_Radio__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Radio", function() { return src_components_Radio__WEBPACK_IMPORTED_MODULE_1__["b"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Icon", function() { return src_components_Radio__WEBPACK_IMPORTED_MODULE_1__["a"]; });

/* harmony import */ var src_components_button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(92);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Button", function() { return src_components_button__WEBPACK_IMPORTED_MODULE_2__["a"]; });

/* harmony import */ var src_components_typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Text", function() { return src_components_typography__WEBPACK_IMPORTED_MODULE_3__["a"]; });

/* harmony import */ var src_components_form_input__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormInput", function() { return src_components_form_input__WEBPACK_IMPORTED_MODULE_4__["a"]; });

/* harmony import */ var src_components_form_select__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(94);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormSelect", function() { return src_components_form_select__WEBPACK_IMPORTED_MODULE_5__["a"]; });

/* harmony import */ var src_components_form_textarea__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(133);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormTextarea", function() { return src_components_form_textarea__WEBPACK_IMPORTED_MODULE_6__["a"]; });

/* harmony import */ var src_components_form_checkbox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(95);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FormCheckbox", function() { return src_components_form_checkbox__WEBPACK_IMPORTED_MODULE_7__["a"]; });

/* harmony import */ var src_components_progressBar__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(127);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProgressBar", function() { return src_components_progressBar__WEBPACK_IMPORTED_MODULE_8__["a"]; });

/* harmony import */ var src_components_rentalPlanSelector__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Knob", function() { return src_components_rentalPlanSelector__WEBPACK_IMPORTED_MODULE_9__["c"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Track", function() { return src_components_rentalPlanSelector__WEBPACK_IMPORTED_MODULE_9__["e"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BasicSelector", function() { return src_components_rentalPlanSelector__WEBPACK_IMPORTED_MODULE_9__["d"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Selector", function() { return src_components_rentalPlanSelector__WEBPACK_IMPORTED_MODULE_9__["a"]; });

/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AccentSelectorPoints", function() { return src_components_rentalPlanSelector__WEBPACK_IMPORTED_MODULE_9__["b"]; });

/* harmony import */ var src_components_input__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(134);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Input", function() { return src_components_input__WEBPACK_IMPORTED_MODULE_10__["a"]; });

/* harmony import */ var src_components_checkbox__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(135);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Checkbox", function() { return src_components_checkbox__WEBPACK_IMPORTED_MODULE_11__["a"]; });

/* harmony import */ var src_components_sonntagButton__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(136);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SonntagButton", function() { return src_components_sonntagButton__WEBPACK_IMPORTED_MODULE_12__["a"]; });

/* harmony import */ var src_components_Buttons_SonntagButtonV2__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SonntagButtonV2", function() { return src_components_Buttons_SonntagButtonV2__WEBPACK_IMPORTED_MODULE_13__["default"]; });

/* harmony import */ var src_components_Buttons_CtaButton__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(137);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CtaButton", function() { return src_components_Buttons_CtaButton__WEBPACK_IMPORTED_MODULE_14__["a"]; });

/* harmony import */ var src_components_Buttons_BadgeButton__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(128);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BadgeButton", function() { return src_components_Buttons_BadgeButton__WEBPACK_IMPORTED_MODULE_15__["a"]; });

/* harmony import */ var src_components_SonntagIcon__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(25);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SonntagIcon", function() { return src_components_SonntagIcon__WEBPACK_IMPORTED_MODULE_16__["default"]; });

/* harmony import */ var src_components_sectionHead__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(138);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SectionHead", function() { return src_components_sectionHead__WEBPACK_IMPORTED_MODULE_17__["a"]; });

/* harmony import */ var src_components_inputSelect__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(139);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputSelect", function() { return src_components_inputSelect__WEBPACK_IMPORTED_MODULE_18__["a"]; });

/* harmony import */ var src_components_compactPaymentDisplay__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(140);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CompactPaymentDisplay", function() { return src_components_compactPaymentDisplay__WEBPACK_IMPORTED_MODULE_19__["a"]; });

/* harmony import */ var src_components_Sheet__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(129);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Sheet", function() { return src_components_Sheet__WEBPACK_IMPORTED_MODULE_20__["a"]; });

/* harmony import */ var src_components_Subscription__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(80);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Subscription", function() { return src_components_Subscription__WEBPACK_IMPORTED_MODULE_21__["default"]; });

/* harmony import */ var src_components_ShimmingCard__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(126);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ShimmingCard", function() { return src_components_ShimmingCard__WEBPACK_IMPORTED_MODULE_22__["a"]; });

/* harmony import */ var src_hocs_withRipple__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(20);
/* harmony import */ var src_hocs_withRipple__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(src_hocs_withRipple__WEBPACK_IMPORTED_MODULE_23__);
/* harmony reexport (default from non-harmony) */ __webpack_require__.d(__webpack_exports__, "withRipple", function() { return src_hocs_withRipple__WEBPACK_IMPORTED_MODULE_23___default.a; });
/* harmony import */ var src_components_FilterButton__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(130);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FilterButton", function() { return src_components_FilterButton__WEBPACK_IMPORTED_MODULE_24__["a"]; });

/* harmony import */ var src_components_Pointer__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(131);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Pointer", function() { return src_components_Pointer__WEBPACK_IMPORTED_MODULE_25__["a"]; });

/* harmony import */ var src_components_BottomSheet__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(132);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BottomSheet", function() { return src_components_BottomSheet__WEBPACK_IMPORTED_MODULE_26__["a"]; });

/* harmony import */ var packages_Input__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(104);
/* harmony import */ var packages_Input__WEBPACK_IMPORTED_MODULE_27___default = /*#__PURE__*/__webpack_require__.n(packages_Input__WEBPACK_IMPORTED_MODULE_27__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputV2", function() { return packages_Input__WEBPACK_IMPORTED_MODULE_27__["Input"]; });

/* harmony import */ var packages_Radio__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(105);
/* harmony import */ var packages_Radio__WEBPACK_IMPORTED_MODULE_28___default = /*#__PURE__*/__webpack_require__.n(packages_Radio__WEBPACK_IMPORTED_MODULE_28__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RadioV2", function() { return packages_Radio__WEBPACK_IMPORTED_MODULE_28__["Radio"]; });

/* harmony import */ var packages_Checkbox__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(106);
/* harmony import */ var packages_Checkbox__WEBPACK_IMPORTED_MODULE_29___default = /*#__PURE__*/__webpack_require__.n(packages_Checkbox__WEBPACK_IMPORTED_MODULE_29__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CheckboxV2", function() { return packages_Checkbox__WEBPACK_IMPORTED_MODULE_29__["Checkbox"]; });

/* harmony import */ var packages_DropDown__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(107);
/* harmony import */ var packages_DropDown__WEBPACK_IMPORTED_MODULE_30___default = /*#__PURE__*/__webpack_require__.n(packages_DropDown__WEBPACK_IMPORTED_MODULE_30__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropDown", function() { return packages_DropDown__WEBPACK_IMPORTED_MODULE_30__["DropDown"]; });

/* harmony import */ var packages_DismissingCard__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(31);
/* harmony import */ var packages_DismissingCard__WEBPACK_IMPORTED_MODULE_31___default = /*#__PURE__*/__webpack_require__.n(packages_DismissingCard__WEBPACK_IMPORTED_MODULE_31__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DismissingCard", function() { return packages_DismissingCard__WEBPACK_IMPORTED_MODULE_31__["DismissingCard"]; });

/* harmony import */ var packages_FeedbackCard__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(110);
/* harmony import */ var packages_FeedbackCard__WEBPACK_IMPORTED_MODULE_32___default = /*#__PURE__*/__webpack_require__.n(packages_FeedbackCard__WEBPACK_IMPORTED_MODULE_32__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FeedbackCard", function() { return packages_FeedbackCard__WEBPACK_IMPORTED_MODULE_32__["FeedbackCard"]; });

/* harmony import */ var packages_MarketingCard__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(111);
/* harmony import */ var packages_MarketingCard__WEBPACK_IMPORTED_MODULE_33___default = /*#__PURE__*/__webpack_require__.n(packages_MarketingCard__WEBPACK_IMPORTED_MODULE_33__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MarketingCard", function() { return packages_MarketingCard__WEBPACK_IMPORTED_MODULE_33__["MarketingCard"]; });

/* harmony import */ var packages_MarkdownParser__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(57);
/* harmony import */ var packages_MarkdownParser__WEBPACK_IMPORTED_MODULE_34___default = /*#__PURE__*/__webpack_require__.n(packages_MarkdownParser__WEBPACK_IMPORTED_MODULE_34__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MarkdownParser", function() { return packages_MarkdownParser__WEBPACK_IMPORTED_MODULE_34__["MarkdownParser"]; });

/* harmony import */ var packages_SubscriptionBadge__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(112);
/* harmony import */ var packages_SubscriptionBadge__WEBPACK_IMPORTED_MODULE_35___default = /*#__PURE__*/__webpack_require__.n(packages_SubscriptionBadge__WEBPACK_IMPORTED_MODULE_35__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SubscriptionBadge", function() { return packages_SubscriptionBadge__WEBPACK_IMPORTED_MODULE_35__["SubscriptionBadge"]; });

/* harmony import */ var packages_Button__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(33);
/* harmony import */ var packages_Button__WEBPACK_IMPORTED_MODULE_36___default = /*#__PURE__*/__webpack_require__.n(packages_Button__WEBPACK_IMPORTED_MODULE_36__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonV2", function() { return packages_Button__WEBPACK_IMPORTED_MODULE_36__["Button"]; });

/* harmony import */ var packages_ProductCard__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(114);
/* harmony import */ var packages_ProductCard__WEBPACK_IMPORTED_MODULE_37___default = /*#__PURE__*/__webpack_require__.n(packages_ProductCard__WEBPACK_IMPORTED_MODULE_37__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProductCard", function() { return packages_ProductCard__WEBPACK_IMPORTED_MODULE_37__["ProductCard"]; });

/* harmony import */ var packages_Chip__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(76);
/* harmony import */ var packages_Chip__WEBPACK_IMPORTED_MODULE_38___default = /*#__PURE__*/__webpack_require__.n(packages_Chip__WEBPACK_IMPORTED_MODULE_38__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Chip", function() { return packages_Chip__WEBPACK_IMPORTED_MODULE_38__["Chip"]; });

/* harmony import */ var packages_RadioBox__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(115);
/* harmony import */ var packages_RadioBox__WEBPACK_IMPORTED_MODULE_39___default = /*#__PURE__*/__webpack_require__.n(packages_RadioBox__WEBPACK_IMPORTED_MODULE_39__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in packages_RadioBox__WEBPACK_IMPORTED_MODULE_39__) if(["Radio","Icon","Button","Text","FormInput","FormSelect","FormTextarea","FormCheckbox","ProgressBar","Knob","Track","BasicSelector","Selector","AccentSelectorPoints","Input","Checkbox","SonntagButton","SonntagButtonV2","CtaButton","BadgeButton","SonntagIcon","SectionHead","InputSelect","CompactPaymentDisplay","Sheet","Subscription","ShimmingCard","withRipple","FilterButton","Pointer","BottomSheet","InputV2","RadioV2","CheckboxV2","DropDown","DismissingCard","FeedbackCard","MarketingCard","MarkdownParser","SubscriptionBadge","ButtonV2","ProductCard","Chip","Toggle","RentalPlanSelector","SatisfactionCard","Note","Card","ProgressRing","SubscriptionSection","Action","AccountMenu","darkBaseTheme","lightBaseTheme","defaultTheme","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return packages_RadioBox__WEBPACK_IMPORTED_MODULE_39__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var packages_Hint__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(77);
/* harmony import */ var packages_Hint__WEBPACK_IMPORTED_MODULE_40___default = /*#__PURE__*/__webpack_require__.n(packages_Hint__WEBPACK_IMPORTED_MODULE_40__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in packages_Hint__WEBPACK_IMPORTED_MODULE_40__) if(["Radio","Icon","Button","Text","FormInput","FormSelect","FormTextarea","FormCheckbox","ProgressBar","Knob","Track","BasicSelector","Selector","AccentSelectorPoints","Input","Checkbox","SonntagButton","SonntagButtonV2","CtaButton","BadgeButton","SonntagIcon","SectionHead","InputSelect","CompactPaymentDisplay","Sheet","Subscription","ShimmingCard","withRipple","FilterButton","Pointer","BottomSheet","InputV2","RadioV2","CheckboxV2","DropDown","DismissingCard","FeedbackCard","MarketingCard","MarkdownParser","SubscriptionBadge","ButtonV2","ProductCard","Chip","Toggle","RentalPlanSelector","SatisfactionCard","Note","Card","ProgressRing","SubscriptionSection","Action","AccountMenu","darkBaseTheme","lightBaseTheme","defaultTheme","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return packages_Hint__WEBPACK_IMPORTED_MODULE_40__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var packages_Toggle__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(118);
/* harmony import */ var packages_Toggle__WEBPACK_IMPORTED_MODULE_41___default = /*#__PURE__*/__webpack_require__.n(packages_Toggle__WEBPACK_IMPORTED_MODULE_41__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Toggle", function() { return packages_Toggle__WEBPACK_IMPORTED_MODULE_41__["Toggle"]; });

/* harmony import */ var packages_RentalPlanSelector__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(119);
/* harmony import */ var packages_RentalPlanSelector__WEBPACK_IMPORTED_MODULE_42___default = /*#__PURE__*/__webpack_require__.n(packages_RentalPlanSelector__WEBPACK_IMPORTED_MODULE_42__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RentalPlanSelector", function() { return packages_RentalPlanSelector__WEBPACK_IMPORTED_MODULE_42__["RentalPlanSelector"]; });

/* harmony import */ var packages_SatisfactionCard__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(121);
/* harmony import */ var packages_SatisfactionCard__WEBPACK_IMPORTED_MODULE_43___default = /*#__PURE__*/__webpack_require__.n(packages_SatisfactionCard__WEBPACK_IMPORTED_MODULE_43__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SatisfactionCard", function() { return packages_SatisfactionCard__WEBPACK_IMPORTED_MODULE_43__["SatisfactionCard"]; });

/* harmony import */ var packages_Note__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(62);
/* harmony import */ var packages_Note__WEBPACK_IMPORTED_MODULE_44___default = /*#__PURE__*/__webpack_require__.n(packages_Note__WEBPACK_IMPORTED_MODULE_44__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Note", function() { return packages_Note__WEBPACK_IMPORTED_MODULE_44__["Note"]; });

/* harmony import */ var packages_Card__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(22);
/* harmony import */ var packages_Card__WEBPACK_IMPORTED_MODULE_45___default = /*#__PURE__*/__webpack_require__.n(packages_Card__WEBPACK_IMPORTED_MODULE_45__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Card", function() { return packages_Card__WEBPACK_IMPORTED_MODULE_45__["Card"]; });

/* harmony import */ var packages_Icons_ProgressRing__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(54);
/* harmony import */ var packages_Icons_ProgressRing__WEBPACK_IMPORTED_MODULE_46___default = /*#__PURE__*/__webpack_require__.n(packages_Icons_ProgressRing__WEBPACK_IMPORTED_MODULE_46__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProgressRing", function() { return packages_Icons_ProgressRing__WEBPACK_IMPORTED_MODULE_46__["ProgressRing"]; });

/* harmony import */ var packages_SubscriptionSection__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(122);
/* harmony import */ var packages_SubscriptionSection__WEBPACK_IMPORTED_MODULE_47___default = /*#__PURE__*/__webpack_require__.n(packages_SubscriptionSection__WEBPACK_IMPORTED_MODULE_47__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SubscriptionSection", function() { return packages_SubscriptionSection__WEBPACK_IMPORTED_MODULE_47__["SubscriptionSection"]; });

/* harmony import */ var packages_Stack__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(123);
/* harmony import */ var packages_Stack__WEBPACK_IMPORTED_MODULE_48___default = /*#__PURE__*/__webpack_require__.n(packages_Stack__WEBPACK_IMPORTED_MODULE_48__);
/* harmony reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in packages_Stack__WEBPACK_IMPORTED_MODULE_48__) if(["Radio","Icon","Button","Text","FormInput","FormSelect","FormTextarea","FormCheckbox","ProgressBar","Knob","Track","BasicSelector","Selector","AccentSelectorPoints","Input","Checkbox","SonntagButton","SonntagButtonV2","CtaButton","BadgeButton","SonntagIcon","SectionHead","InputSelect","CompactPaymentDisplay","Sheet","Subscription","ShimmingCard","withRipple","FilterButton","Pointer","BottomSheet","InputV2","RadioV2","CheckboxV2","DropDown","DismissingCard","FeedbackCard","MarketingCard","MarkdownParser","SubscriptionBadge","ButtonV2","ProductCard","Chip","Toggle","RentalPlanSelector","SatisfactionCard","Note","Card","ProgressRing","SubscriptionSection","Action","AccountMenu","darkBaseTheme","lightBaseTheme","defaultTheme","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return packages_Stack__WEBPACK_IMPORTED_MODULE_48__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var packages_Action__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(58);
/* harmony import */ var packages_Action__WEBPACK_IMPORTED_MODULE_49___default = /*#__PURE__*/__webpack_require__.n(packages_Action__WEBPACK_IMPORTED_MODULE_49__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Action", function() { return packages_Action__WEBPACK_IMPORTED_MODULE_49__["Action"]; });

/* harmony import */ var packages_AccountMenu__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(124);
/* harmony import */ var packages_AccountMenu__WEBPACK_IMPORTED_MODULE_50___default = /*#__PURE__*/__webpack_require__.n(packages_AccountMenu__WEBPACK_IMPORTED_MODULE_50__);
/* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AccountMenu", function() { return packages_AccountMenu__WEBPACK_IMPORTED_MODULE_50__["AccountMenu"]; });























































/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-dom-unstable-native-dependencies.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var h=__webpack_require__(23),k=__webpack_require__(96);function m(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}var n=null,q=null,r=null;
function t(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))throw Error(m(103));a.currentTarget=b?r(c):null;b=b?b(a):null;a.currentTarget=null;a._dispatchListeners=null;a._dispatchInstances=null;return b}function u(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function v(a,b,c){for(var f=[];a;)f.push(a),a=u(a);for(a=f.length;0<a--;)b(f[a],"captured",c);for(a=0;a<f.length;a++)b(f[a],"bubbled",c)}
function w(a,b){var c=a.stateNode;if(!c)return null;var f=n(c);if(!f)return null;c=f[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(f=!f.disabled)||(a=a.type,f=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!f;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(m(231,
b,typeof c));return c}function x(a,b){if(null==b)throw Error(m(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function y(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}function z(a,b,c){if(b=w(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=x(c._dispatchListeners,b),c._dispatchInstances=x(c._dispatchInstances,a)}
function A(a){a&&a.dispatchConfig.phasedRegistrationNames&&v(a._targetInst,z,a)}function aa(a){if(a&&a.dispatchConfig.phasedRegistrationNames){var b=a._targetInst;b=b?u(b):null;v(b,z,a)}}function B(a){if(a&&a.dispatchConfig.registrationName){var b=a._targetInst;if(b&&a&&a.dispatchConfig.registrationName){var c=w(b,a.dispatchConfig.registrationName);c&&(a._dispatchListeners=x(a._dispatchListeners,c),a._dispatchInstances=x(a._dispatchInstances,b))}}}function C(){return!0}function D(){return!1}
function E(a,b,c,f){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var d in a)a.hasOwnProperty(d)&&((b=a[d])?this[d]=b(c):"target"===d?this.target=f:this[d]=c[d]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?C:D;this.isPropagationStopped=D;return this}
k(E.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=C)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=C)},persist:function(){this.isPersistent=C},isPersistent:D,destructor:function(){var a=this.constructor.Interface,b;for(b in a)this[b]=
null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=D;this._dispatchInstances=this._dispatchListeners=null}});E.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
E.extend=function(a){function b(){}function c(){return f.apply(this,arguments)}var f=this;b.prototype=f.prototype;var d=new b;k(d,c.prototype);c.prototype=d;c.prototype.constructor=c;c.Interface=k({},f.Interface,a);c.extend=f.extend;F(c);return c};F(E);function ba(a,b,c,f){if(this.eventPool.length){var d=this.eventPool.pop();this.call(d,a,b,c,f);return d}return new this(a,b,c,f)}
function ca(a){if(!(a instanceof this))throw Error(m(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function F(a){a.eventPool=[];a.getPooled=ba;a.release=ca}var G=E.extend({touchHistory:function(){return null}});function H(a){return"touchstart"===a||"mousedown"===a}function I(a){return"touchmove"===a||"mousemove"===a}function J(a){return"touchend"===a||"touchcancel"===a||"mouseup"===a}
var K=["touchstart","mousedown"],L=["touchmove","mousemove"],N=["touchcancel","touchend","mouseup"],O=[],P={touchBank:O,numberActiveTouches:0,indexOfSingleActiveTouch:-1,mostRecentTimeStamp:0};function Q(a){return a.timeStamp||a.timestamp}function R(a){a=a.identifier;if(null==a)throw Error(m(138));return a}
function da(a){var b=R(a),c=O[b];c?(c.touchActive=!0,c.startPageX=a.pageX,c.startPageY=a.pageY,c.startTimeStamp=Q(a),c.currentPageX=a.pageX,c.currentPageY=a.pageY,c.currentTimeStamp=Q(a),c.previousPageX=a.pageX,c.previousPageY=a.pageY,c.previousTimeStamp=Q(a)):(c={touchActive:!0,startPageX:a.pageX,startPageY:a.pageY,startTimeStamp:Q(a),currentPageX:a.pageX,currentPageY:a.pageY,currentTimeStamp:Q(a),previousPageX:a.pageX,previousPageY:a.pageY,previousTimeStamp:Q(a)},O[b]=c);P.mostRecentTimeStamp=Q(a)}
function ea(a){var b=O[R(a)];b&&(b.touchActive=!0,b.previousPageX=b.currentPageX,b.previousPageY=b.currentPageY,b.previousTimeStamp=b.currentTimeStamp,b.currentPageX=a.pageX,b.currentPageY=a.pageY,b.currentTimeStamp=Q(a),P.mostRecentTimeStamp=Q(a))}function fa(a){var b=O[R(a)];b&&(b.touchActive=!1,b.previousPageX=b.currentPageX,b.previousPageY=b.currentPageY,b.previousTimeStamp=b.currentTimeStamp,b.currentPageX=a.pageX,b.currentPageY=a.pageY,b.currentTimeStamp=Q(a),P.mostRecentTimeStamp=Q(a))}
var S={recordTouchTrack:function(a,b){if(I(a))b.changedTouches.forEach(ea);else if(H(a))b.changedTouches.forEach(da),P.numberActiveTouches=b.touches.length,1===P.numberActiveTouches&&(P.indexOfSingleActiveTouch=b.touches[0].identifier);else if(J(a)&&(b.changedTouches.forEach(fa),P.numberActiveTouches=b.touches.length,1===P.numberActiveTouches))for(a=0;a<O.length;a++)if(b=O[a],null!=b&&b.touchActive){P.indexOfSingleActiveTouch=a;break}},touchHistory:P};
function T(a,b){if(null==b)throw Error(m(334));return null==a?b:Array.isArray(a)?a.concat(b):Array.isArray(b)?[a].concat(b):[a,b]}var U=null,V=0;function W(a,b){var c=U;U=a;if(null!==X.GlobalResponderHandler)X.GlobalResponderHandler.onChange(c,a,b)}
var Y={startShouldSetResponder:{phasedRegistrationNames:{bubbled:"onStartShouldSetResponder",captured:"onStartShouldSetResponderCapture"},dependencies:K},scrollShouldSetResponder:{phasedRegistrationNames:{bubbled:"onScrollShouldSetResponder",captured:"onScrollShouldSetResponderCapture"},dependencies:["scroll"]},selectionChangeShouldSetResponder:{phasedRegistrationNames:{bubbled:"onSelectionChangeShouldSetResponder",captured:"onSelectionChangeShouldSetResponderCapture"},dependencies:["selectionchange"]},
moveShouldSetResponder:{phasedRegistrationNames:{bubbled:"onMoveShouldSetResponder",captured:"onMoveShouldSetResponderCapture"},dependencies:L},responderStart:{registrationName:"onResponderStart",dependencies:K},responderMove:{registrationName:"onResponderMove",dependencies:L},responderEnd:{registrationName:"onResponderEnd",dependencies:N},responderRelease:{registrationName:"onResponderRelease",dependencies:N},responderTerminationRequest:{registrationName:"onResponderTerminationRequest",dependencies:[]},
responderGrant:{registrationName:"onResponderGrant",dependencies:[]},responderReject:{registrationName:"onResponderReject",dependencies:[]},responderTerminate:{registrationName:"onResponderTerminate",dependencies:[]}},X={_getResponder:function(){return U},eventTypes:Y,extractEvents:function(a,b,c,f){if(H(a))V+=1;else if(J(a))if(0<=V)--V;else return null;S.recordTouchTrack(a,c);if(b&&("scroll"===a&&!c.responderIgnoreScroll||0<V&&"selectionchange"===a||H(a)||I(a))){var d=H(a)?Y.startShouldSetResponder:
I(a)?Y.moveShouldSetResponder:"selectionchange"===a?Y.selectionChangeShouldSetResponder:Y.scrollShouldSetResponder;if(U)b:{var e=U;for(var g=0,p=e;p;p=u(p))g++;p=0;for(var M=b;M;M=u(M))p++;for(;0<g-p;)e=u(e),g--;for(;0<p-g;)b=u(b),p--;for(;g--;){if(e===b||e===b.alternate)break b;e=u(e);b=u(b)}e=null}else e=b;b=e===U;e=G.getPooled(d,e,c,f);e.touchHistory=S.touchHistory;b?y(e,aa):y(e,A);b:{d=e._dispatchListeners;b=e._dispatchInstances;if(Array.isArray(d))for(g=0;g<d.length&&!e.isPropagationStopped();g++){if(d[g](e,
b[g])){d=b[g];break b}}else if(d&&d(e,b)){d=b;break b}d=null}e._dispatchInstances=null;e._dispatchListeners=null;e.isPersistent()||e.constructor.release(e);if(d&&d!==U)if(e=G.getPooled(Y.responderGrant,d,c,f),e.touchHistory=S.touchHistory,y(e,B),b=!0===t(e),U)if(g=G.getPooled(Y.responderTerminationRequest,U,c,f),g.touchHistory=S.touchHistory,y(g,B),p=!g._dispatchListeners||t(g),g.isPersistent()||g.constructor.release(g),p){g=G.getPooled(Y.responderTerminate,U,c,f);g.touchHistory=S.touchHistory;y(g,
B);var l=T(l,[e,g]);W(d,b)}else d=G.getPooled(Y.responderReject,d,c,f),d.touchHistory=S.touchHistory,y(d,B),l=T(l,d);else l=T(l,e),W(d,b);else l=null}else l=null;d=U&&H(a);e=U&&I(a);b=U&&J(a);if(d=d?Y.responderStart:e?Y.responderMove:b?Y.responderEnd:null)d=G.getPooled(d,U,c,f),d.touchHistory=S.touchHistory,y(d,B),l=T(l,d);d=U&&"touchcancel"===a;if(a=U&&!d&&J(a))a:{if((a=c.touches)&&0!==a.length)for(e=0;e<a.length;e++)if(b=a[e].target,null!==b&&void 0!==b&&0!==b){g=q(b);b:{for(b=U;g;){if(b===g||b===
g.alternate){b=!0;break b}g=u(g)}b=!1}if(b){a=!1;break a}}a=!0}if(a=d?Y.responderTerminate:a?Y.responderRelease:null)c=G.getPooled(a,U,c,f),c.touchHistory=S.touchHistory,y(c,B),l=T(l,c),W(null);return l},GlobalResponderHandler:null,injection:{injectGlobalResponderHandler:function(a){X.GlobalResponderHandler=a}}},Z=h.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.Events,ha=Z[3],ia=Z[0],ja=Z[1];n=Z[2];q=ia;r=ja;module.exports={__proto__:null,ResponderEventPlugin:X,ResponderTouchHistoryStore:S,injectEventPluginsByName:ha};


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixProperty;

var _capitalizeString = __webpack_require__(97);

var _capitalizeString2 = _interopRequireDefault(_capitalizeString);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function prefixProperty(prefixProperties, property, style) {
  if (prefixProperties.hasOwnProperty(property)) {
    var newStyle = {};
    var requiredPrefixes = prefixProperties[property];
    var capitalizedProperty = (0, _capitalizeString2.default)(property);
    var keys = Object.keys(style);
    for (var i = 0; i < keys.length; i++) {
      var styleProperty = keys[i];
      if (styleProperty === property) {
        for (var j = 0; j < requiredPrefixes.length; j++) {
          newStyle[requiredPrefixes[j] + capitalizedProperty] = style[property];
        }
      }
      newStyle[styleProperty] = style[styleProperty];
    }
    return newStyle;
  }
  return style;
}

/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = prefixValue;
function prefixValue(plugins, property, value, style, metaData) {
  for (var i = 0, len = plugins.length; i < len; ++i) {
    var processedValue = plugins[i](property, value, style, metaData);

    // we can stop processing if a value is returned
    // as all plugin criteria are unique
    if (processedValue) {
      return processedValue;
    }
  }
}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addNewValuesOnly;
function addIfNew(list, value) {
  if (list.indexOf(value) === -1) {
    list.push(value);
  }
}

function addNewValuesOnly(list, values) {
  if (Array.isArray(values)) {
    for (var i = 0, len = values.length; i < len; ++i) {
      addIfNew(list, values[i]);
    }
  } else {
    addIfNew(list, values);
  }
}

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isObject;
function isObject(value) {
  return value instanceof Object && !Array.isArray(value);
}

/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = hyphenateProperty;

var _hyphenateStyleName = __webpack_require__(45);

var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function hyphenateProperty(property) {
  return (0, _hyphenateStyleName2.default)(property);
}
module.exports = exports['default'];

/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(96);

var emptyObject = __webpack_require__(176);
var _invariant = __webpack_require__(177);

if (false) { var warning; }

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {}
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {}
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {}
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {}
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) { var isMixinValid, typeofSpec; }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {}
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) { var _bind, componentName; }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {}
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {}

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {}
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {}

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {}

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {}

module.exports = emptyObject;

/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = function (x) {
	var type = typeof x;
	return x !== null && (type === 'object' || type === 'function');
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */


var ExecutionEnvironment = __webpack_require__(4);

var performance;

if (ExecutionEnvironment.canUseDOM) {
  performance = window.performance || window.msPerformance || window.webkitPerformance;
}

module.exports = performance || {};

/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RippleEffect = exports.RippleSurface = exports.ANIMATION_DURATION_IN_MS = void 0;
const styled_components_1 = __importStar(__webpack_require__(2));
exports.ANIMATION_DURATION_IN_MS = 1000;
const animation = styled_components_1.keyframes `
    to {
        opacity: 0;
        transform: scale(2);
    }
`;
const animationRule = styled_components_1.css `
    animation: ${animation} ${exports.ANIMATION_DURATION_IN_MS}ms;
    animation-iteration-count: 1;
`;
exports.RippleSurface = styled_components_1.default.div `
    overflow: hidden;
    position: relative;
`;
exports.RippleEffect = styled_components_1.default.div `
    position: absolute;
    top: ${(props) => props.y}px;
    left: ${(props) => props.x}px;
    width: ${(props) => props.size}px;
    height: ${(props) => props.size}px;
    border-radius: 50%;

    opacity: 1;
    transform: scale(0);

    background-color: ${(props) => { var _a; return (_a = props.color) !== null && _a !== void 0 ? _a : props.theme.colors['Level 2']; }};

    ${animationRule};
`;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRipples = void 0;
const react_1 = __webpack_require__(1);
const shortid_1 = __importDefault(__webpack_require__(182));
function useRipples() {
    const [ripples, setRipples] = react_1.useState({});
    const removeRippleEffect = react_1.useCallback((key) => {
        const { [key]: removedRipple, ...restRipples } = ripples;
        setRipples({ ...restRipples });
    }, [ripples]);
    const addRippleEffect = react_1.useCallback(({ x, y, size }) => {
        const key = shortid_1.default.generate();
        const newRipple = {
            x,
            y,
            key,
            size,
        };
        setRipples({ ...ripples, [key]: newRipple });
    }, [ripples]);
    return { ripples, removeRippleEffect, addRippleEffect };
}
exports.useRipples = useRipples;


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(183);


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(53);
var build = __webpack_require__(185);
var isValid = __webpack_require__(189);

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var clusterWorkerId = __webpack_require__(190) || 0;

/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */
function seed(seedValue) {
    alphabet.seed(seedValue);
    return module.exports;
}

/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */
function worker(workerId) {
    clusterWorkerId = workerId;
    return module.exports;
}

/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */
function characters(newCharacters) {
    if (newCharacters !== undefined) {
        alphabet.characters(newCharacters);
    }

    return alphabet.shuffled();
}

/**
 * Generate unique id
 * Returns string id
 */
function generate() {
  return build(clusterWorkerId);
}

// Export all other functions as properties of the generate function
module.exports = generate;
module.exports.generate = generate;
module.exports.seed = seed;
module.exports.worker = worker;
module.exports.characters = characters;
module.exports.isValid = isValid;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)

var seed = 1;

/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */
function getNextValue() {
    seed = (seed * 9301 + 49297) % 233280;
    return seed/(233280.0);
}

function setSeed(_seed_) {
    seed = _seed_;
}

module.exports = {
    nextValue: getNextValue,
    seed: setSeed
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var generate = __webpack_require__(186);
var alphabet = __webpack_require__(53);

// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var REDUCE_TIME = 1567752802062;

// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var version = 7;

// Counter is used when shortid is called multiple times in one second.
var counter;

// Remember the last time shortid was called in case counter is needed.
var previousSeconds;

/**
 * Generate unique id
 * Returns string id
 */
function build(clusterWorkerId) {
    var str = '';

    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);

    if (seconds === previousSeconds) {
        counter++;
    } else {
        counter = 0;
        previousSeconds = seconds;
    }

    str = str + generate(version);
    str = str + generate(clusterWorkerId);
    if (counter > 0) {
        str = str + generate(counter);
    }
    str = str + generate(seconds);
    return str;
}

module.exports = build;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(53);
var random = __webpack_require__(187);
var format = __webpack_require__(188);

function generate(number) {
    var loopCounter = 0;
    var done;

    var str = '';

    while (!done) {
        str = str + format(random, alphabet.get(), 1);
        done = number < (Math.pow(16, loopCounter + 1 ) );
        loopCounter++;
    }
    return str;
}

module.exports = generate;


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

var randomByte;

if (!crypto || !crypto.getRandomValues) {
    randomByte = function(size) {
        var bytes = [];
        for (var i = 0; i < size; i++) {
            bytes.push(Math.floor(Math.random() * 256));
        }
        return bytes;
    };
} else {
    randomByte = function(size) {
        return crypto.getRandomValues(new Uint8Array(size));
    };
}

module.exports = randomByte;


/***/ }),
/* 188 */
/***/ (function(module, exports) {

// This file replaces `format.js` in bundlers like webpack or Rollup,
// according to `browser` config in `package.json`.

module.exports = function (random, alphabet, size) {
  // We can’t use bytes bigger than the alphabet. To make bytes values closer
  // to the alphabet, we apply bitmask on them. We look for the closest
  // `2 ** x - 1` number, which will be bigger than alphabet size. If we have
  // 30 symbols in the alphabet, we will take 31 (00011111).
  // We do not use faster Math.clz32, because it is not available in browsers.
  var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1
  // Bitmask is not a perfect solution (in our example it will pass 31 bytes,
  // which is bigger than the alphabet). As a result, we will need more bytes,
  // than ID size, because we will refuse bytes bigger than the alphabet.

  // Every hardware random generator call is costly,
  // because we need to wait for entropy collection. This is why often it will
  // be faster to ask for few extra bytes in advance, to avoid additional calls.

  // Here we calculate how many random bytes should we call in advance.
  // It depends on ID length, mask / alphabet size and magic number 1.6
  // (which was selected according benchmarks).

  // -~f => Math.ceil(f) if n is float number
  // -~i => i + 1 if n is integer number
  var step = -~(1.6 * mask * size / alphabet.length)
  var id = ''

  while (true) {
    var bytes = random(step)
    // Compact alternative for `for (var i = 0; i < step; i++)`
    var i = step
    while (i--) {
      // If random byte is bigger than alphabet even after bitmask,
      // we refuse it by `|| ''`.
      id += alphabet[bytes[i] & mask] || ''
      // More compact than `id.length + 1 === size`
      if (id.length === +size) return id
    }
  }
}


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__(53);

function isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6 ) {
        return false;
    }

    var nonAlphabetic = new RegExp('[^' +
      alphabet.get().replace(/[|\\{}()[\]^$+*?.-]/g, '\\$&') +
    ']');
    return !nonAlphabetic.test(id);
}

module.exports = isShortId;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = 0;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.useOverrides = void 0;
const react_1 = __webpack_require__(1);
const getComponents_1 = __webpack_require__(98);
function useOverrides(defaultComponents, overrides) {
    const components = react_1.useMemo(() => getComponents_1.getComponents(defaultComponents, overrides), [
        defaultComponents,
        overrides,
    ]);
    return components;
}
exports.useOverrides = useOverrides;


/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.mergeOverrides = void 0;
function mergeOverrides(firstOverrides, secondOverrides) {
    const firstOverrideKeys = Object.keys(firstOverrides);
    const secondOverrideKeys = Object.keys(secondOverrides);
    const componentNames = [...new Set([...firstOverrideKeys, ...secondOverrideKeys])];
    const result = {};
    componentNames.forEach((componentName) => {
        const { component: firstComponent, props: firstProps = {} } = (firstOverrides[componentName] || {});
        const { component: secondComponent, props: secondProps = {} } = (secondOverrides[componentName] || {});
        result[componentName] = {
            component: secondComponent || firstComponent,
            props: {
                ...firstProps,
                ...secondProps,
            },
        };
    });
    return result;
}
exports.mergeOverrides = mergeOverrides;


/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(__webpack_require__(1));
const If = ({ children, condition }) => {
    if (!condition) {
        return null;
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.default = If;


/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.isNextPaymentNote = exports.isTextNote = exports.PaymentMethod = exports.NoteType = void 0;
var NoteType;
(function (NoteType) {
    NoteType["NextPayment"] = "nextPayment";
    NoteType["Processing"] = "processing";
    NoteType["Ended"] = "ended";
    NoteType["Paused"] = "paused";
    NoteType["Attention"] = "attention";
    NoteType["Text"] = "text";
})(NoteType = exports.NoteType || (exports.NoteType = {}));
var PaymentMethod;
(function (PaymentMethod) {
    PaymentMethod["Card"] = "Card";
    PaymentMethod["Paypal"] = "Paypal";
})(PaymentMethod = exports.PaymentMethod || (exports.PaymentMethod = {}));
function isTextNote(data) {
    return Boolean(data === null || data === void 0 ? void 0 : data.text);
}
exports.isTextNote = isTextNote;
function isNextPaymentNote(data) {
    return Boolean((data === null || data === void 0 ? void 0 : data.paymentMethod) && (data === null || data === void 0 ? void 0 : data.date));
}
exports.isNextPaymentNote = isNextPaymentNote;


/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PROCESSING = exports.ATTENTION = exports.PAYPAL = exports.CARD = exports.ENDED = exports.PAUSED = void 0;
exports.PAUSED = 'M375,375H458V625H375V375zM542,375H625V625H542V375zM500,167C316,167,167,316,167,500C167,684,316,833,500,833C684,833,833,684,833,500C833,316,684,167,500,167zM83,500C83,270,270,83,500,83C730,83,917,270,917,500C917,730,730,917,500,917C270,917,83,730,83,500z';
exports.ENDED = 'M250,500C250,477,269,458,292,458H542V333C542,310,560,292,583,292C606,292,625,310,625,333V667C625,690,606,708,583,708C560,708,542,690,542,667V542H292C269,542,250,523,250,500zM917,500C917,730,730,917,500,917C270,917,83,730,83,500C83,270,270,83,500,83C730,83,917,270,917,500zM833,500C833,316,684,167,500,167C316,167,167,316,167,500C167,684,316,833,500,833C684,833,833,684,833,500z';
exports.CARD = 'M83,250C83,204,121,167,167,167H833C879,167,917,204,917,250V750C917,796,879,833,833,833H167C121,833,83,796,83,750V250zM833,250H167V542H833V250zM833,625H167V750H833V625zM750,417C750,440,731,458,708,458H625C602,458,583,440,583,417V375C583,352,602,333,625,333H708C731,333,750,352,750,375V417z';
exports.PAYPAL = 'M228,117C233,80,266,52,303,52H548C635,52,717,70,766,126C786,149,800,175,807,205C813,227,814,250,812,273C877,325,881,412,869,475C853,556,817,615,764,653C711,690,647,704,580,704C575,704,572,704,570,704L546,856V856C544,868,539,884,527,898C515,913,496,922,474,922H346C309,922,281,889,287,853L290,835H188C149,835,120,801,126,763L228,117zM303,752L376,288V288C382,253,412,227,447,227H639C670,227,701,230,728,236C728,232,727,228,726,224C723,209,716,195,703,181M720,320C698,314,671,311,639,311H457L429,489H481C546,489,599,476,639,448C675,423,704,383,720,320zM787,383C765,441,731,485,687,517C628,558,557,573,481,573H416L374,839H464L488,689V689C492,666,503,645,525,633C544,622,565,621,580,621C636,621,682,609,715,585C748,562,774,523,787,459C792,431,793,405,787,383zM703,181C679,153,629,136,548,136H309L212,752H303M228,117C233,80,266,52,303,52H548C635,52,717,70,766,126C786,149,800,175,807,205C813,227,814,250,812,273C877,325,881,412,869,475C853,556,817,615,764,653C711,690,647,704,580,704C575,704,572,704,570,704L546,856V856C544,868,539,884,527,898C515,913,496,922,474,922H346C309,922,281,889,287,853L290,835H188C149,835,120,801,126,763L228,117zM303,752L376,288V288C382,253,412,227,447,227H639C670,227,701,230,728,236C728,232,727,228,726,224C723,209,716,195,703,181M720,320C698,314,671,311,639,311H457L429,489H481C546,489,599,476,639,448C675,423,704,383,720,320zM787,383C765,441,731,485,687,517C628,558,557,573,481,573H416L374,839H464L488,689V689C492,666,503,645,525,633C544,622,565,621,580,621C636,621,682,609,715,585C748,562,774,523,787,459C792,431,793,405,787,383zM703,181C679,153,629,136,548,136H309L212,752H303';
exports.ATTENTION = 'M917,500C917,730,730,917,500,917C270,917,83,730,83,500C83,270,270,83,500,83C730,83,917,270,917,500zM500,625C523,625,542,606,542,583V292C542,269,523,250,500,250C477,250,458,269,458,292V583C458,606,477,625,500,625zM500,750C523,750,542,731,542,708C542,685,523,667,500,667C477,667,458,685,458,708C458,731,477,750,500,750z';
exports.PROCESSING = 'M500,833C684,833,833,684,833,500C833,316,684,167,500,167C316,167,167,316,167,500C167,684,316,833,500,833zM500,917C270,917,83,730,83,500C83,270,270,83,500,83C730,83,917,270,917,500C917,730,730,917,500,917zM384,547C393,569,408,588,427,602C447,616,470,624,493,625C517,626,541,621,561,609C582,597,599,580,610,559C621,538,626,514,625,490C623,467,614,444,600,425C586,406,566,391,544,383C522,375,498,373,474,378L457,296C496,288,536,291,573,305C611,319,643,343,667,375C690,407,705,444,708,484C711,524,702,563,684,598C665,633,637,662,602,681C568,701,529,710,489,708C449,706,411,693,379,670C347,647,322,615,307,578L384,547z';


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnimatedInProgressIcon = exports.IconWrap = exports.Text = exports.Container = void 0;
const styled_components_1 = __importStar(__webpack_require__(2));
const Icons_1 = __webpack_require__(17);
const RotateAnimation = styled_components_1.keyframes `
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;
const AnimatedInProgressIcon = styled_components_1.default(Icons_1.InProgress) `
    animation: ${RotateAnimation} 2s linear infinite;
`;
exports.AnimatedInProgressIcon = AnimatedInProgressIcon;
const Container = styled_components_1.default.div `
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
`;
exports.Container = Container;
const Text = styled_components_1.default.span `
    flex: auto;
    color: ${({ color, theme }) => color || theme.colors['Level 4']};
    ${(props) => styled_components_1.css(props.theme.typography.Paragraph)}
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
`;
exports.Text = Text;
const IconWrap = styled_components_1.default.div `
    flex: none;
    display: flex;
    margin-right: ${(props) => props.theme.spacers.M};
`;
exports.IconWrap = IconWrap;


/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(__webpack_require__(1));
const Eye = ({ className, color = 'currentColor', size = '24px' }) => (react_1.default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
    react_1.default.createElement("path", { d: "M12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.7956 14.6839 13.5587 14.1213 14.1213C13.5587 14.6839 12.7956 15 12 15C11.2044 15 10.4413 14.6839 9.87868 14.1213C9.31607 13.5587 9 12.7956 9 12C9 11.2044 9.31607 10.4413 9.87868 9.87868C10.4413 9.31607 11.2044 9 12 9ZM12 4.5C17 4.5 21.27 7.61 23 12C21.27 16.39 17 19.5 12 19.5C7 19.5 2.73 16.39 1 12C2.73 7.61 7 4.5 12 4.5ZM3.18 12C4.83 15.36 8.24 17.5 12 17.5C15.76 17.5 19.17 15.36 20.82 12C19.17 8.64 15.76 6.5 12 6.5C8.24 6.5 4.83 8.64 3.18 12Z", fill: color })));
exports.default = Eye;


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(__webpack_require__(1));
const EyeOff = ({ className, color = 'currentColor', size = '24px' }) => (react_1.default.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none" },
    react_1.default.createElement("path", { d: "M2 5.27L3.28 4L20 20.72L18.73 22L15.65 18.92C14.5 19.3 13.28 19.5 12 19.5C7 19.5 2.73 16.39 1 12C1.69 10.24 2.79 8.69 4.19 7.46L2 5.27ZM12 9C12.7956 9 13.5587 9.31607 14.1213 9.87868C14.6839 10.4413 15 11.2044 15 12C15 12.35 14.94 12.69 14.83 13L11 9.17C11.31 9.06 11.65 9 12 9ZM12 4.5C17 4.5 21.27 7.61 23 12C22.18 14.08 20.79 15.88 19 17.19L17.58 15.76C18.94 14.82 20.06 13.54 20.82 12C19.17 8.64 15.76 6.5 12 6.5C10.91 6.5 9.84 6.68 8.84 7L7.3 5.47C8.74 4.85 10.33 4.5 12 4.5ZM3.18 12C4.83 15.36 8.24 17.5 12 17.5C12.69 17.5 13.37 17.43 14 17.29L11.72 15C10.29 14.85 9.15 13.71 9 12.28L5.6 8.87C4.61 9.72 3.78 10.78 3.18 12Z", fill: color })));
exports.default = EyeOff;


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(__webpack_require__(1));
const react_native_svg_1 = __webpack_require__(9);
const IconDefaultProps = {
    size: '24px',
    color: '#333333',
};
const ChevronIcon = ({ className, size = IconDefaultProps.size, color = IconDefaultProps.color, }) => (react_1.default.createElement(react_native_svg_1.Svg, { className: className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement(react_native_svg_1.Path, { fillRule: "evenodd", clipRule: "evenodd", d: "M4.29289 8.29289C4.68342 7.90237 5.31658 7.90237 5.70711 8.29289L12 14.5858L18.2929 8.29289C18.6834 7.90237 19.3166 7.90237 19.7071 8.29289C20.0976 8.68342 20.0976 9.31658 19.7071 9.70711L12 17.4142L4.29289 9.70711C3.90237 9.31658 3.90237 8.68342 4.29289 8.29289Z", fill: color })));
exports.default = ChevronIcon;


/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Close = void 0;
const react_1 = __importDefault(__webpack_require__(1));
exports.Close = ({ className, color = '#333333', size = '24px', ...restProps }) => (react_1.default.createElement("svg", Object.assign({}, restProps, { height: size, width: size, className: className, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg" }),
    react_1.default.createElement("path", { fill: color, fillRule: "evenodd", clipRule: "evenodd", d: "M6.29289 6.29289C6.68342 5.90237 7.31658 5.90237 7.70711 6.29289L12 10.5858L16.2929 6.29289C16.6834 5.90237 17.3166 5.90237 17.7071 6.29289C18.0976 6.68342 18.0976 7.31658 17.7071 7.70711L13.4142 12L17.7071 16.2929C18.0976 16.6834 18.0976 17.3166 17.7071 17.7071C17.3166 18.0976 16.6834 18.0976 16.2929 17.7071L12 13.4142L7.70711 17.7071C7.31658 18.0976 6.68342 18.0976 6.29289 17.7071C5.90237 17.3166 5.90237 16.6834 6.29289 16.2929L10.5858 12L6.29289 7.70711C5.90237 7.31658 5.90237 6.68342 6.29289 6.29289Z" })));


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Undo = void 0;
const react_1 = __importDefault(__webpack_require__(1));
exports.Undo = ({ className, color = '#333333', size = '24px' }) => (react_1.default.createElement("svg", { className: className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.09524 3.28101C9.49233 3.66486 9.50306 4.29794 9.11921 4.69502L7.35773 6.51724H15.9277C19.4587 6.51724 21.2578 10.7586 18.8036 13.2973L10.6859 21.695C10.302 22.0921 9.66895 22.1028 9.27186 21.719C8.87478 21.3351 8.86405 20.7021 9.2479 20.305L17.3657 11.9073C18.5927 10.6379 17.6932 8.51724 15.9277 8.51724H7.35773L9.11921 10.3395C9.50306 10.7365 9.49233 11.3696 9.09524 11.7535C8.69815 12.1373 8.06508 12.1266 7.68123 11.7295L3.60938 7.51724L7.68123 3.30498C8.06508 2.90789 8.69815 2.89716 9.09524 3.28101Z", fill: color })));


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoOutline = void 0;
const react_1 = __importDefault(__webpack_require__(1));
exports.InfoOutline = ({ className, color, size = '20px' }) => (react_1.default.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", className: className, width: size, height: size, viewBox: "0 0 20 20", fill: "none" },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.53541 10.3918C8.08891 10.5034 7.63646 10.2319 7.52484 9.78545C7.41322 9.33896 7.68468 8.88651 8.13118 8.77489L9.77969 8.36276C9.81813 8.35225 9.85768 8.34443 9.89813 8.3395C10.123 8.31153 10.3428 8.37722 10.5128 8.50981C10.6077 8.58378 10.6871 8.67857 10.7433 8.78953C10.7862 8.87402 10.8152 8.9668 10.8271 9.06484C10.8322 9.10525 10.8342 9.14549 10.8333 9.18531V12.5H11.6666C12.1269 12.5 12.5 12.8731 12.5 13.3333C12.5 13.7936 12.1269 14.1667 11.6666 14.1667H8.33329C7.87305 14.1667 7.49996 13.7936 7.49996 13.3333C7.49996 12.8731 7.87305 12.5 8.33329 12.5H9.16663V10.234L8.53541 10.3918Z", fill: color }),
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.0001 7.78158C9.38443 7.78158 8.88533 7.28248 8.88533 6.66681C8.88533 6.05114 9.38443 5.55205 10.0001 5.55205C10.6158 5.55205 11.1149 6.05114 11.1149 6.66681C11.1149 7.28248 10.6158 7.78158 10.0001 7.78158Z", fill: color }),
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.99996 1.66667C14.602 1.66667 18.3333 5.39796 18.3333 10C18.3333 14.6021 14.602 18.3333 9.99996 18.3333C5.39791 18.3333 1.66663 14.6021 1.66663 10C1.66663 5.39795 5.39791 1.66667 9.99996 1.66667ZM9.99996 3.33334C6.31838 3.33334 3.33329 6.31843 3.33329 10C3.33329 13.6816 6.31838 16.6667 9.99996 16.6667C13.6815 16.6667 16.6666 13.6816 16.6666 10C16.6666 6.31843 13.6815 3.33334 9.99996 3.33334Z", fill: color })));


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InProgress = void 0;
const react_1 = __importDefault(__webpack_require__(1));
exports.InProgress = ({ className, size = '24px', color = 'currentColor', }) => (react_1.default.createElement("svg", { className: className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z", fill: color }),
    react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.21928 13.126C9.43343 13.6549 9.79396 14.1117 10.2586 14.4429C10.7232 14.7741 11.2726 14.9659 11.8424 14.9959C12.4122 15.0258 12.9787 14.8927 13.4755 14.6121C13.9723 14.3314 14.3787 13.9149 14.6472 13.4115C14.9156 12.908 15.0349 12.3384 14.9911 11.7695C14.9472 11.2006 14.7421 10.656 14.3997 10.1996C14.0573 9.74324 13.5918 9.39394 13.0579 9.19273C12.524 8.99152 11.9437 8.94674 11.3853 9.06364L10.9755 7.10607C11.9063 6.91123 12.8733 6.98587 13.7632 7.32122C14.653 7.65657 15.4288 8.23873 15.9995 8.9994C16.5702 9.76008 16.9121 10.6677 16.9852 11.6159C17.0582 12.564 16.8594 13.5133 16.412 14.3524C15.9646 15.1916 15.2871 15.8857 14.4592 16.3534C13.6312 16.8211 12.687 17.043 11.7374 16.9931C10.7877 16.9432 9.87201 16.6234 9.09766 16.0715C8.32331 15.5195 7.72243 14.7581 7.3655 13.8767L9.21928 13.126Z", fill: color })));


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavoriteBtn = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const Heart_1 = __webpack_require__(100);
const styles_1 = __webpack_require__(206);
exports.FavoriteBtn = ({ className, size = '20px', color = 'currenColor', background = 'transparent', isActive = false, shouldAnimate = false, }) => (react_1.default.createElement(styles_1.FavWrapper, { isActive: isActive, shouldAnimate: shouldAnimate },
    react_1.default.createElement(Heart_1.Heart, { className: className, size: size, color: color, background: background })));


/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FavWrapper = void 0;
const styled_components_1 = __importStar(__webpack_require__(2));
const favoriteButtonHeart = styled_components_1.keyframes `
    0%, 17.5% { transform: scale(0); }
`;
const favoriteButtonBubble = styled_components_1.keyframes `
    15% {
        transform: scale(1);
        border-color: #cc8ef5;
        border-width: 2.25rem;
    }

    30%,
    100% {
        transform: scale(1);
        border-color: #cc8ef5;
        border-width: 0;
    }
`;
const favoriteButtonSparkles = styled_components_1.keyframes `
    0%,
    20% {
        opacity: 0;
    }

    25% {
        opacity: 1;
        box-shadow: 0.32476rem -2.4375rem 0 0rem #ff8080, -0.32476rem -2.0625rem 0 0rem #ffed80, 2.1082rem -1.26585rem 0 0rem #ffed80, 1.41004rem -1.53985rem 0 0rem #a4ff80, 2.30412rem 0.85901rem 0 0rem #a4ff80, 2.08305rem 0.14233rem 0 0rem #80ffc8, 0.76499rem 2.33702rem 0 0rem #80ffc8, 1.18749rem 1.71734rem 0 0rem #80c8ff, -1.35019rem 2.0552rem 0 0rem #80c8ff, -0.6022rem 1.99918rem 0 0rem #a480ff, -2.44865rem 0.22578rem 0 0rem #a480ff, -1.93686rem 0.77608rem 0 0rem #ff80ed, -1.70323rem -1.77366rem 0 0rem #ff80ed, -1.79277rem -1.02423rem 0 0rem #ff8080;
    }

    100% {
        box-shadow: 0.32476rem -3rem 0 -0.1875rem #ff8080, -0.32476rem -2.625rem 0 -0.1875rem #ffed80, 2.54798rem -1.61656rem 0 -0.1875rem #ffed80, 1.84982rem -1.89057rem 0 -0.1875rem #a4ff80, 2.85252rem 0.98418rem 0 -0.1875rem #a4ff80, 2.63145rem 0.2675rem 0 -0.1875rem #80ffc8, 1.00905rem 2.84381rem 0 -0.1875rem #80ffc8, 1.43155rem 2.22414rem 0 -0.1875rem #80c8ff, -1.59425rem 2.562rem 0 -0.1875rem #80c8ff, -0.84626rem 2.50597rem 0 -0.1875rem #a480ff, -2.99705rem 0.35095rem 0 -0.1875rem #a480ff, -2.48526rem 0.90125rem 0 -0.1875rem #ff80ed, -2.14301rem -2.12438rem 0 -0.1875rem #ff80ed, -2.23255rem -1.37495rem 0 -0.1875rem #ff8080;
    }
`;
exports.FavWrapper = styled_components_1.default.i `
    &:hover path {
        stroke: ${({ theme, isActive }) => isActive ? theme.colors.Color1 : theme.colors.Foreground};
    }

    &:before,
    &:after {
        content: '';
        position: absolute;
        z-index: -1;
        top: 50%;
        left: 50%;
        border-radius: 50%;
    }

    &:before {
        margin: -2.2rem;
        width: 4.4rem;
        height: 4.4rem;
        border: solid 2.2rem ${({ theme }) => theme.colors.Color1};
        box-sizing: border-box;
        transform: scale(0);
    }

    &:after {
        margin: -0.19rem;
        width: 0.375rem;
        height: 0.375rem;
    }

    ${({ shouldAnimate, isActive }) => shouldAnimate &&
    isActive &&
    styled_components_1.css `
            > * {
                animation-name: ${favoriteButtonHeart};
                animation-duration: 1s;
                animation-timing-function: cubic-bezier(0.17, 0.89, 0.32, 1.49);
            }

            &:before,
            &:after {
                animation-duration: 1s;
                animation-timing-function: ease-out;
            }

            &:before {
                will-change: transform, border-width, border-color;
                animation-name: ${favoriteButtonBubble};
            }

            &:after {
                will-change: opacity, box-shadow;
                animation-name: ${favoriteButtonSparkles};
            }
        `}
`;


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressCircle = void 0;
const styled_components_1 = __importDefault(__webpack_require__(2));
exports.ProgressCircle = styled_components_1.default.circle `
    transition-property: stroke-dashoffset;
    transition-duration: ${(props) => { var _a; return (_a = props.animationDuration) !== null && _a !== void 0 ? _a : 300; }}ms;
    transition-timing-function: linear;
    transform: rotate(-90deg);
    transform-origin: 50% 50%;
`;


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tick = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const react_native_svg_1 = __webpack_require__(9);
exports.Tick = ({ className, color = '#333333', size = 24 }) => (react_1.default.createElement(react_native_svg_1.Svg, { className: className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement(react_native_svg_1.Path, { fillRule: "evenodd", clipRule: "evenodd", d: "M19.7071 7.29289C20.0976 7.68342 20.0976 8.31658 19.7071 8.70711L10 18.4142L4.29289 12.7071C3.90237 12.3166 3.90237 11.6834 4.29289 11.2929C4.68342 10.9024 5.31658 10.9024 5.70711 11.2929L10 15.5858L18.2929 7.29289C18.6834 6.90237 19.3166 6.90237 19.7071 7.29289Z", fill: color })));


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleTick = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const react_native_svg_1 = __webpack_require__(9);
exports.CircleTick = ({ className, color = '#333333', size = '24px', style, }) => (react_1.default.createElement(react_native_svg_1.Svg, { className: className, style: style, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement(react_native_svg_1.Path, { fillRule: "evenodd", clipRule: "evenodd", d: "M16.7071 9.29289C17.0976 9.68342 17.0976 10.3166 16.7071 10.7071L11 16.4142L7.29289 12.7071C6.90237 12.3166 6.90237 11.6834 7.29289 11.2929C7.68342 10.9024 8.31658 10.9024 8.70711 11.2929L11 13.5858L15.2929 9.29289C15.6834 8.90237 16.3166 8.90237 16.7071 9.29289Z", fill: color }),
    react_1.default.createElement(react_native_svg_1.Path, { fillRule: "evenodd", clipRule: "evenodd", d: "M12 20C16.4184 20 20 16.4184 20 12C20 7.58157 16.4184 4 12 4C7.58157 4 4 7.58157 4 12C4 16.4184 7.58157 20 12 20ZM22 12C22 17.523 17.523 22 12 22C6.477 22 2 17.523 2 12C2 6.477 6.477 2 12 2C17.523 2 22 6.477 22 12Z", fill: color })));


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountOutlineIcon = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const react_native_svg_1 = __webpack_require__(9);
exports.AccountOutlineIcon = ({ className, color = '#333333', size = '24px', style, }) => (react_1.default.createElement(react_native_svg_1.Svg, { className: className, style: style, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement(react_native_svg_1.Path, { fillRule: "evenodd", clipRule: "evenodd", d: "M5.62698 16.8365C5.84531 17.1237 6.08261 17.3958 6.33702 17.6507C6.48405 17.3332 6.65695 17.0302 6.85303 16.7444C7.97706 15.1057 9.86253 14.0312 12 14.0312C14.1375 14.0312 16.0229 15.1057 17.147 16.7444C17.343 17.0302 17.516 17.3332 17.663 17.6507C17.9174 17.3958 18.1547 17.1237 18.373 16.8365C19.394 15.4932 20 13.8174 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 13.8174 4.60601 15.4932 5.62698 16.8365ZM15.1129 19.3718C15.3667 19.2645 15.6137 19.1445 15.8533 19.0126C15.9089 18.9819 15.9641 18.9507 16.0189 18.9187C15.9846 18.8165 15.9464 18.716 15.9047 18.6173C15.8152 18.4062 15.7091 18.2038 15.5879 18.0118C14.8372 16.8217 13.5102 16.0312 12 16.0312C10.4885 16.0312 9.16211 16.8217 8.41181 18.0116C8.29074 18.2037 8.18466 18.4061 8.09523 18.6173C8.05347 18.7159 8.01533 18.8164 7.98099 18.9187C8.03582 18.9506 8.09107 18.9819 8.14672 19.0126C8.38627 19.1445 8.63331 19.2645 8.88704 19.3717C9.84388 19.7763 10.8958 20 12 20C13.1042 20 14.1561 19.7763 15.1129 19.3718ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM11.9995 10.9229C12.6929 10.9229 13.255 10.3608 13.255 9.66751C13.255 8.97418 12.6929 8.41211 11.9995 8.41211C11.3062 8.41211 10.7441 8.97418 10.7441 9.66751C10.7441 10.3608 11.3062 10.9229 11.9995 10.9229ZM11.9995 12.9229C10.2016 12.9229 8.74414 11.4654 8.74414 9.66751C8.74414 7.8696 10.2016 6.41211 11.9995 6.41211C13.7975 6.41211 15.255 7.8696 15.255 9.66751C15.255 11.4654 13.7975 12.9229 11.9995 12.9229Z", fill: color })));


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BankIcon = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const react_native_svg_1 = __webpack_require__(9);
exports.BankIcon = ({ className, color = '#333333', size = '24px', style, }) => (react_1.default.createElement(react_native_svg_1.Svg, { className: className, style: style, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement(react_native_svg_1.Path, { d: "M12 2.84827L20 7.4197V11H4V7.4197L12 2.84827ZM6 8.58034V9.00002H18V8.58034L12 5.15177L6 8.58034ZM6 17V12H8V17H6ZM11 17V12H13V17H11ZM16 17V12H18V17H16ZM4 20V18H20V20H4Z", fill: color })));


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailIcon = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const react_native_svg_1 = __webpack_require__(9);
exports.EmailIcon = ({ className, color = '#333333', size = '24px', style, }) => (react_1.default.createElement(react_native_svg_1.Svg, { className: className, style: style, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement(react_native_svg_1.Path, { fillRule: "evenodd", clipRule: "evenodd", d: "M2 7C2 5.89543 2.89543 5 4 5H20C21.1046 5 22 5.89543 22 7V17C22 18.1046 21.1046 19 20 19H4C2.89543 19 2 18.1046 2 17V7ZM20 8.28847V15.5858L15.9739 11.5597L20 8.28847ZM18.4142 7L12 12.2115L5.58581 7L18.4142 7ZM4 8.28847V15.5858L8.02611 11.5597L4 8.28847ZM5.41421 17H18.5858L14.4134 12.8276L12 14.7885L9.58662 12.8276L5.41421 17Z", fill: color })));


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HappyFaceIcon = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const react_native_svg_1 = __webpack_require__(9);
exports.HappyFaceIcon = ({ className, color = '#333333', size = '24px', style, }) => (react_1.default.createElement(react_native_svg_1.Svg, { className: className, style: style, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement(react_native_svg_1.Path, { d: "M12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12C4 7.58172 7.58172 4 12 4ZM22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12Z", fill: color }),
    react_1.default.createElement(react_native_svg_1.Path, { d: "M14 9.5C14 10.3284 14.6716 11 15.5 11C16.3284 11 17 10.3284 17 9.5C17 8.67157 16.3284 8 15.5 8C14.6716 8 14 8.67157 14 9.5Z", fill: color }),
    react_1.default.createElement(react_native_svg_1.Path, { d: "M7 9.5C7 10.3284 7.67157 11 8.5 11C9.32843 11 10 10.3284 10 9.5C10 8.67157 9.32843 8 8.5 8C7.67157 8 7 8.67157 7 9.5Z", fill: color }),
    react_1.default.createElement(react_native_svg_1.Path, { d: "M15.7148 15.4364C16.4774 14.6283 16.8512 13.7183 16.9702 13.2425L15.0299 12.7575C14.9821 12.9483 14.7559 13.5384 14.2602 14.0636C13.7914 14.5604 13.0857 15 12 15C10.9143 15 10.2086 14.5604 9.73978 14.0636C9.24407 13.5384 9.01787 12.9483 8.97015 12.7575L7.02987 13.2425C7.14882 13.7183 7.52262 14.6283 8.28525 15.4364C9.07476 16.2729 10.2857 17 12 17C13.7143 17 14.9253 16.2729 15.7148 15.4364Z", fill: color })));


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HeartOutlineIcon = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const react_native_svg_1 = __webpack_require__(9);
exports.HeartOutlineIcon = ({ className, color = '#333333', size = '24px', style, }) => (react_1.default.createElement(react_native_svg_1.Svg, { className: className, style: style, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement(react_native_svg_1.Path, { fillRule: "evenodd", clipRule: "evenodd", d: "M12 21.35C8.35985 18.0362 2 13.9377 2 8.5C2 5.41 4.42 3 7.5 3C9.24 3 10.91 3.81 12 5.08C13.09 3.81 14.76 3 16.5 3C19.58 3 22 5.41 22 8.5C22 13.9377 15.6401 18.0362 12 21.35ZM12 18.6454C14.7015 16.1861 20 12.6565 20 8.5C20 6.51695 18.4778 5 16.5 5C14.3913 5 13.2329 6.71438 12 8.15086C10.7671 6.71438 9.60866 5 7.5 5C5.52219 5 4 6.51695 4 8.5C4 12.6571 9.29799 16.1855 12 18.6454Z", fill: color })));


/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignInIcon = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const react_native_svg_1 = __webpack_require__(9);
const IconDefaultProps = {
    size: '24px',
    color: '#333333',
};
exports.SignInIcon = ({ className, size = IconDefaultProps.size, color = IconDefaultProps.color, }) => (react_1.default.createElement(react_native_svg_1.Svg, { className: className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement(react_native_svg_1.Path, { fillRule: "evenodd", clipRule: "evenodd", d: "M15.4142 12.002L10.9666 16.4496C10.5761 16.8401 9.94292 16.8401 9.5524 16.4496C9.16188 16.059 9.16188 15.4259 9.5524 15.0354L11.5858 13.002L2 13.002V11.002L11.5858 11.002L9.5524 8.96858C9.16188 8.57806 9.16188 7.94489 9.5524 7.55437C9.94292 7.16384 10.5761 7.16384 10.9666 7.55437L15.4142 12.002Z", fill: color }),
    react_1.default.createElement(react_native_svg_1.Path, { fillRule: "evenodd", clipRule: "evenodd", d: "M19 21L11 21L11 19L19 19C19.5523 19 20 18.5523 20 18L20 6C20 5.44772 19.5523 5 19 5L11 5L11 3L19 3C20.6569 3 22 4.34315 22 6L22 18C22 19.6569 20.6569 21 19 21Z", fill: color })));


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CircleAttention = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const react_native_svg_1 = __webpack_require__(9);
exports.CircleAttention = ({ className, color = '#333333', size = '24px', style, }) => (react_1.default.createElement(react_native_svg_1.Svg, { className: className, style: style, width: size, height: size, viewBox: "-2 -2 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement(react_native_svg_1.Path, { fillRule: "evenodd", clipRule: "evenodd", d: "M10 18C14.4179 18 18 14.4179 18 10C18 5.58211 14.4179 2 10 2C5.58211 2 2 5.58211 2 10C2 14.4179 5.58211 18 10 18ZM10 20C4.47754 20 0 15.5225 0 10C0 4.47754 4.47754 0 10 0C15.5225 0 20 4.47754 20 10C20 15.5225 15.5225 20 10 20Z", fill: color }),
    react_1.default.createElement(react_native_svg_1.Path, { fillRule: "evenodd", clipRule: "evenodd", d: "M9 15C9 14.4477 9.44771 14 10 14C10.5523 14 11 14.4477 11 15C11 15.5523 10.5523 16 10 16C9.44771 16 9 15.5523 9 15Z", fill: color }),
    react_1.default.createElement(react_native_svg_1.Path, { fillRule: "evenodd", clipRule: "evenodd", d: "M9 5C9 4.44772 9.44771 4 10 4C10.5523 4 11 4.44772 11 5V12C11 12.5523 10.5523 13 10 13C9.44771 13 9 12.5523 9 12V5Z", fill: color })));


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const styled_components_1 = __importStar(__webpack_require__(2));
const elevation_1 = __webpack_require__(11);
exports.Container = styled_components_1.default.div `
    padding: 16px;
    background-color: ${(props) => props.theme.colors.Background};
    border: 2px solid ${(props) => props.borderColor || props.theme.colors['Level 1']};
    border-radius: 8px;
    ${elevation_1.elevationTransition}
    color: ${(props) => props.theme.colors.Foreground};

    ${(props) => !props.highlight &&
    props.defaultHover &&
    styled_components_1.css `
            cursor: pointer;
            &:hover {
                background-color: ${props.theme.colors.ElementBackground};
                ${elevation_1.elevation(1, true)}
            }
        `}

    ${(props) => !props.highlight &&
    props.elevated &&
    styled_components_1.css `
            background-color: ${props.theme.colors.ElementBackground};
            ${elevation_1.elevation(1, true)}
        `}

    ${(props) => props.highlight &&
    styled_components_1.css `
            background-color: ${props.theme.colors['Level 1']};
            transition: all 0.3s ease;
            border-color: transparent;
        `}
`;


/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(101);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _SwipeableViews = _interopRequireDefault(__webpack_require__(219));

var _default = _SwipeableViews.default;
exports.default = _default;

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(101);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getDomTreeShapes = getDomTreeShapes;
exports.findNativeHandler = findNativeHandler;
exports.default = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(220));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(221));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(223));

var _createClass2 = _interopRequireDefault(__webpack_require__(224));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(225));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(228));

var _inherits2 = _interopRequireDefault(__webpack_require__(229));

var _react = _interopRequireDefault(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(0));

var _warning = _interopRequireDefault(__webpack_require__(102));

var _properties = _interopRequireDefault(__webpack_require__(231));

var _on = _interopRequireDefault(__webpack_require__(232));

var _off = _interopRequireDefault(__webpack_require__(233));

var _reactSwipeableViewsCore = __webpack_require__(234);

function addEventListenerEnhanced(node, event, handler, options) {
  (0, _on.default)(node, event, handler, options);
  return {
    remove: function remove() {
      (0, _off.default)(node, event, handler, options);
    }
  };
}

var styleInjected = false; // Support old version of iOS and IE 10.
// To be deleted in 2019.

function injectStyle() {
  // Inject once for all the instances
  if (!styleInjected) {
    var style = document.createElement('style');
    style.innerHTML = "\n      .react-swipeable-view-container {\n        display: -webkit-box;\n        display: -ms-flexbox;\n      }\n      .react-swipeable-view-container > div {\n        -ms-flex-negative: 0;\n      }\n    ";

    if (document.body) {
      document.body.appendChild(style);
    }

    styleInjected = true;
  }
}

var styles = {
  container: {
    direction: 'ltr',
    display: 'flex',
    willChange: 'transform'
  },
  slide: {
    width: '100%',
    WebkitFlexShrink: 0,
    flexShrink: 0,
    overflow: 'auto'
  }
};
var axisProperties = {
  root: {
    x: {
      overflowX: 'hidden'
    },
    'x-reverse': {
      overflowX: 'hidden'
    },
    y: {
      overflowY: 'hidden'
    },
    'y-reverse': {
      overflowY: 'hidden'
    }
  },
  flexDirection: {
    x: 'row',
    'x-reverse': 'row-reverse',
    y: 'column',
    'y-reverse': 'column-reverse'
  },
  transform: {
    x: function x(translate) {
      return "translate(".concat(-translate, "%, 0)");
    },
    'x-reverse': function xReverse(translate) {
      return "translate(".concat(translate, "%, 0)");
    },
    y: function y(translate) {
      return "translate(0, ".concat(-translate, "%)");
    },
    'y-reverse': function yReverse(translate) {
      return "translate(0, ".concat(translate, "%)");
    }
  },
  length: {
    x: 'width',
    'x-reverse': 'width',
    y: 'height',
    'y-reverse': 'height'
  },
  rotationMatrix: {
    x: {
      x: [1, 0],
      y: [0, 1]
    },
    'x-reverse': {
      x: [-1, 0],
      y: [0, 1]
    },
    y: {
      x: [0, 1],
      y: [1, 0]
    },
    'y-reverse': {
      x: [0, -1],
      y: [1, 0]
    }
  },
  scrollPosition: {
    x: 'scrollLeft',
    'x-reverse': 'scrollLeft',
    y: 'scrollTop',
    'y-reverse': 'scrollTop'
  },
  scrollLength: {
    x: 'scrollWidth',
    'x-reverse': 'scrollWidth',
    y: 'scrollHeight',
    'y-reverse': 'scrollHeight'
  },
  clientLength: {
    x: 'clientWidth',
    'x-reverse': 'clientWidth',
    y: 'clientHeight',
    'y-reverse': 'clientHeight'
  }
};

function createTransition(property, options) {
  var duration = options.duration,
      easeFunction = options.easeFunction,
      delay = options.delay;
  return "".concat(property, " ").concat(duration, " ").concat(easeFunction, " ").concat(delay);
} // We are using a 2x2 rotation matrix.


function applyRotationMatrix(touch, axis) {
  var rotationMatrix = axisProperties.rotationMatrix[axis];
  return {
    pageX: rotationMatrix.x[0] * touch.pageX + rotationMatrix.x[1] * touch.pageY,
    pageY: rotationMatrix.y[0] * touch.pageX + rotationMatrix.y[1] * touch.pageY
  };
}

function adaptMouse(event) {
  event.touches = [{
    pageX: event.pageX,
    pageY: event.pageY
  }];
  return event;
}

function getDomTreeShapes(element, rootNode) {
  var domTreeShapes = [];

  while (element && element !== rootNode) {
    // We reach a Swipeable View, no need to look higher in the dom tree.
    if (element.hasAttribute('data-swipeable')) {
      break;
    }

    var style = window.getComputedStyle(element);

    if ( // Ignore the scroll children if the element is absolute positioned.
    style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
    style.getPropertyValue('overflow-x') === 'hidden') {
      domTreeShapes = [];
    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
      // Ignore the nodes that have no width.
      // Keep elements with a scroll
      domTreeShapes.push({
        element: element,
        scrollWidth: element.scrollWidth,
        scrollHeight: element.scrollHeight,
        clientWidth: element.clientWidth,
        clientHeight: element.clientHeight,
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
      });
    }

    element = element.parentNode;
  }

  return domTreeShapes;
} // We can only have one node at the time claiming ownership for handling the swipe.
// Otherwise, the UX would be confusing.
// That's why we use a singleton here.


var nodeWhoClaimedTheScroll = null;

function findNativeHandler(params) {
  var domTreeShapes = params.domTreeShapes,
      pageX = params.pageX,
      startX = params.startX,
      axis = params.axis;
  return domTreeShapes.some(function (shape) {
    // Determine if we are going backward or forward.
    var goingForward = pageX >= startX;

    if (axis === 'x' || axis === 'y') {
      goingForward = !goingForward;
    }

    var scrollPosition = shape[axisProperties.scrollPosition[axis]];
    var areNotAtStart = scrollPosition > 0;
    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];

    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
      nodeWhoClaimedTheScroll = shape.element;
      return true;
    }

    return false;
  });
}

var SwipeableViews =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(SwipeableViews, _React$Component);

  function SwipeableViews(props) {
    var _this;

    (0, _classCallCheck2.default)(this, SwipeableViews);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SwipeableViews).call(this, props));
    _this.rootNode = null;
    _this.containerNode = null;
    _this.ignoreNextScrollEvents = false;
    _this.viewLength = 0;
    _this.startX = 0;
    _this.lastX = 0;
    _this.vx = 0;
    _this.startY = 0;
    _this.isSwiping = undefined;
    _this.started = false;
    _this.startIndex = 0;
    _this.transitionListener = null;
    _this.touchMoveListener = null;
    _this.activeSlide = null;
    _this.indexCurrent = null;
    _this.firstRenderTimeout = null;

    _this.setRootNode = function (node) {
      _this.rootNode = node;
    };

    _this.setContainerNode = function (node) {
      _this.containerNode = node;
    };

    _this.setActiveSlide = function (node) {
      _this.activeSlide = node;

      _this.updateHeight();
    };

    _this.handleSwipeStart = function (event) {
      var axis = _this.props.axis;
      var touch = applyRotationMatrix(event.touches[0], axis);
      _this.viewLength = _this.rootNode.getBoundingClientRect()[axisProperties.length[axis]];
      _this.startX = touch.pageX;
      _this.lastX = touch.pageX;
      _this.vx = 0;
      _this.startY = touch.pageY;
      _this.isSwiping = undefined;
      _this.started = true;
      var computedStyle = window.getComputedStyle(_this.containerNode);
      var transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');

      if (transform && transform !== 'none') {
        var transformValues = transform.split('(')[1].split(')')[0].split(',');
        var rootStyle = window.getComputedStyle(_this.rootNode);
        var tranformNormalized = applyRotationMatrix({
          pageX: parseInt(transformValues[4], 10),
          pageY: parseInt(transformValues[5], 10)
        }, axis);
        _this.startIndex = -tranformNormalized.pageX / (_this.viewLength - parseInt(rootStyle.paddingLeft, 10) - parseInt(rootStyle.paddingRight, 10)) || 0;
      }
    };

    _this.handleSwipeMove = function (event) {
      // The touch start event can be cancel.
      // Makes sure we set a starting point.
      if (!_this.started) {
        _this.handleTouchStart(event);

        return;
      } // We are not supposed to hanlde this touch move.


      if (nodeWhoClaimedTheScroll !== null && nodeWhoClaimedTheScroll !== _this.rootNode) {
        return;
      }

      var _this$props = _this.props,
          axis = _this$props.axis,
          children = _this$props.children,
          ignoreNativeScroll = _this$props.ignoreNativeScroll,
          onSwitching = _this$props.onSwitching,
          resistance = _this$props.resistance;
      var touch = applyRotationMatrix(event.touches[0], axis); // We don't know yet.

      if (_this.isSwiping === undefined) {
        var dx = Math.abs(touch.pageX - _this.startX);
        var dy = Math.abs(touch.pageY - _this.startY);
        var isSwiping = dx > dy && dx > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD; // We let the parent handle the scroll.

        if (!resistance && (axis === 'y' || axis === 'y-reverse') && (_this.indexCurrent === 0 && _this.startX < touch.pageX || _this.indexCurrent === _react.default.Children.count(_this.props.children) - 1 && _this.startX > touch.pageX)) {
          _this.isSwiping = false;
          return;
        } // We are likely to be swiping, let's prevent the scroll event.


        if (dx > dy) {
          event.preventDefault();
        }

        if (isSwiping === true || dy > _reactSwipeableViewsCore.constant.UNCERTAINTY_THRESHOLD) {
          _this.isSwiping = isSwiping;
          _this.startX = touch.pageX; // Shift the starting point.

          return; // Let's wait the next touch event to move something.
        }
      }

      if (_this.isSwiping !== true) {
        return;
      } // We are swiping, let's prevent the scroll event.


      event.preventDefault(); // Low Pass filter.

      _this.vx = _this.vx * 0.5 + (touch.pageX - _this.lastX) * 0.5;
      _this.lastX = touch.pageX;

      var _computeIndex = (0, _reactSwipeableViewsCore.computeIndex)({
        children: children,
        resistance: resistance,
        pageX: touch.pageX,
        startIndex: _this.startIndex,
        startX: _this.startX,
        viewLength: _this.viewLength
      }),
          index = _computeIndex.index,
          startX = _computeIndex.startX; // Add support for native scroll elements.


      if (nodeWhoClaimedTheScroll === null && !ignoreNativeScroll) {
        var domTreeShapes = getDomTreeShapes(event.target, _this.rootNode);
        var hasFoundNativeHandler = findNativeHandler({
          domTreeShapes: domTreeShapes,
          startX: _this.startX,
          pageX: touch.pageX,
          axis: axis
        }); // We abort the touch move handler.

        if (hasFoundNativeHandler) {
          return;
        }
      } // We are moving toward the edges.


      if (startX) {
        _this.startX = startX;
      } else if (nodeWhoClaimedTheScroll === null) {
        nodeWhoClaimedTheScroll = _this.rootNode;
      }

      _this.setIndexCurrent(index);

      var callback = function callback() {
        if (onSwitching) {
          onSwitching(index, 'move');
        }
      };

      if (_this.state.displaySameSlide || !_this.state.isDragging) {
        _this.setState({
          displaySameSlide: false,
          isDragging: true
        }, callback);
      }

      callback();
    };

    _this.handleSwipeEnd = function () {
      nodeWhoClaimedTheScroll = null; // The touch start event can be cancel.
      // Makes sure that a starting point is set.

      if (!_this.started) {
        return;
      }

      _this.started = false;

      if (_this.isSwiping !== true) {
        return;
      }

      var indexLatest = _this.state.indexLatest;
      var indexCurrent = _this.indexCurrent;
      var delta = indexLatest - indexCurrent;
      var indexNew; // Quick movement

      if (Math.abs(_this.vx) > _this.props.threshold) {
        if (_this.vx > 0) {
          indexNew = Math.floor(indexCurrent);
        } else {
          indexNew = Math.ceil(indexCurrent);
        }
      } else if (Math.abs(delta) > _this.props.hysteresis) {
        // Some hysteresis with indexLatest.
        indexNew = delta > 0 ? Math.floor(indexCurrent) : Math.ceil(indexCurrent);
      } else {
        indexNew = indexLatest;
      }

      var indexMax = _react.default.Children.count(_this.props.children) - 1;

      if (indexNew < 0) {
        indexNew = 0;
      } else if (indexNew > indexMax) {
        indexNew = indexMax;
      }

      _this.setIndexCurrent(indexNew);

      _this.setState({
        indexLatest: indexNew,
        isDragging: false
      }, function () {
        if (_this.props.onSwitching) {
          _this.props.onSwitching(indexNew, 'end');
        }

        if (_this.props.onChangeIndex && indexNew !== indexLatest) {
          _this.props.onChangeIndex(indexNew, indexLatest, {
            reason: 'swipe'
          });
        } // Manually calling handleTransitionEnd in that case as isn't otherwise.


        if (indexCurrent === indexLatest) {
          _this.handleTransitionEnd();
        }
      });
    };

    _this.handleTouchStart = function (event) {
      if (_this.props.onTouchStart) {
        _this.props.onTouchStart(event);
      }

      _this.handleSwipeStart(event);
    };

    _this.handleTouchEnd = function (event) {
      if (_this.props.onTouchEnd) {
        _this.props.onTouchEnd(event);
      }

      _this.handleSwipeEnd(event);
    };

    _this.handleMouseDown = function (event) {
      if (_this.props.onMouseDown) {
        _this.props.onMouseDown(event);
      }

      event.persist();

      _this.handleSwipeStart(adaptMouse(event));
    };

    _this.handleMouseUp = function (event) {
      if (_this.props.onMouseUp) {
        _this.props.onMouseUp(event);
      }

      _this.handleSwipeEnd(adaptMouse(event));
    };

    _this.handleMouseLeave = function (event) {
      if (_this.props.onMouseLeave) {
        _this.props.onMouseLeave(event);
      } // Filter out events


      if (_this.started) {
        _this.handleSwipeEnd(adaptMouse(event));
      }
    };

    _this.handleMouseMove = function (event) {
      if (_this.props.onMouseMove) {
        _this.props.onMouseMove(event);
      } // Filter out events


      if (_this.started) {
        _this.handleSwipeMove(adaptMouse(event));
      }
    };

    _this.handleScroll = function (event) {
      if (_this.props.onScroll) {
        _this.props.onScroll(event);
      } // Ignore events bubbling up.


      if (event.target !== _this.rootNode) {
        return;
      }

      if (_this.ignoreNextScrollEvents) {
        _this.ignoreNextScrollEvents = false;
        return;
      }

      var indexLatest = _this.state.indexLatest;
      var indexNew = Math.ceil(event.target.scrollLeft / event.target.clientWidth) + indexLatest;
      _this.ignoreNextScrollEvents = true; // Reset the scroll position.

      event.target.scrollLeft = 0;

      if (_this.props.onChangeIndex && indexNew !== indexLatest) {
        _this.props.onChangeIndex(indexNew, indexLatest, {
          reason: 'focus'
        });
      }
    };

    _this.updateHeight = function () {
      if (_this.activeSlide !== null) {
        var child = _this.activeSlide.children[0];

        if (child !== undefined && child.offsetHeight !== undefined && _this.state.heightLatest !== child.offsetHeight) {
          _this.setState({
            heightLatest: child.offsetHeight
          });
        }
      }
    };

    if (false) {}

    _this.state = {
      indexLatest: props.index,
      // Set to true as soon as the component is swiping.
      // It's the state counter part of this.isSwiping.
      isDragging: false,
      // Help with SSR logic and lazy loading logic.
      renderOnlyActive: !props.disableLazyLoading,
      heightLatest: 0,
      // Let the render method that we are going to display the same slide than previously.
      displaySameSlide: true
    };

    _this.setIndexCurrent(props.index);

    return _this;
  }

  (0, _createClass2.default)(SwipeableViews, [{
    key: "getChildContext",
    value: function getChildContext() {
      var _this2 = this;

      return {
        swipeableViews: {
          slideUpdateHeight: function slideUpdateHeight() {
            _this2.updateHeight();
          }
        }
      };
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      // Subscribe to transition end events.
      this.transitionListener = addEventListenerEnhanced(this.containerNode, _properties.default.end, function (event) {
        if (event.target !== _this3.containerNode) {
          return;
        }

        _this3.handleTransitionEnd();
      }); // Block the thread to handle that event.

      this.touchMoveListener = addEventListenerEnhanced(this.rootNode, 'touchmove', function (event) {
        // Handling touch events is disabled.
        if (_this3.props.disabled) {
          return;
        }

        _this3.handleSwipeMove(event);
      }, {
        passive: false
      });

      if (!this.props.disableLazyLoading) {
        this.firstRenderTimeout = setTimeout(function () {
          _this3.setState({
            renderOnlyActive: false
          });
        }, 0);
      }

      injectStyle(); // Send all functions in an object if action param is set.

      if (this.props.action) {
        this.props.action({
          updateHeight: this.updateHeight
        });
      }
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var index = nextProps.index;

      if (typeof index === 'number' && index !== this.props.index) {
        if (false) {}

        this.setIndexCurrent(index);
        this.setState({
          // If true, we are going to change the children. We shoudn't animate it.
          displaySameSlide: (0, _reactSwipeableViewsCore.getDisplaySameSlide)(this.props, nextProps),
          indexLatest: index
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.transitionListener.remove();
      this.touchMoveListener.remove();
      clearTimeout(this.firstRenderTimeout);
    }
  }, {
    key: "setIndexCurrent",
    value: function setIndexCurrent(indexCurrent) {
      if (!this.props.animateTransitions && this.indexCurrent !== indexCurrent) {
        this.handleTransitionEnd();
      }

      this.indexCurrent = indexCurrent;

      if (this.containerNode) {
        var axis = this.props.axis;
        var transform = axisProperties.transform[axis](indexCurrent * 100);
        this.containerNode.style.WebkitTransform = transform;
        this.containerNode.style.transform = transform;
      }
    }
  }, {
    key: "handleTransitionEnd",
    value: function handleTransitionEnd() {
      if (!this.props.onTransitionEnd) {
        return;
      } // Filters out when changing the children


      if (this.state.displaySameSlide) {
        return;
      } // The rest callback is triggered when swiping. It's just noise.
      // We filter it out.


      if (!this.state.isDragging) {
        this.props.onTransitionEnd();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props2 = this.props,
          action = _this$props2.action,
          animateHeight = _this$props2.animateHeight,
          animateTransitions = _this$props2.animateTransitions,
          axis = _this$props2.axis,
          children = _this$props2.children,
          containerStyleProp = _this$props2.containerStyle,
          disabled = _this$props2.disabled,
          disableLazyLoading = _this$props2.disableLazyLoading,
          enableMouseEvents = _this$props2.enableMouseEvents,
          hysteresis = _this$props2.hysteresis,
          ignoreNativeScroll = _this$props2.ignoreNativeScroll,
          index = _this$props2.index,
          onChangeIndex = _this$props2.onChangeIndex,
          onSwitching = _this$props2.onSwitching,
          onTransitionEnd = _this$props2.onTransitionEnd,
          resistance = _this$props2.resistance,
          slideStyleProp = _this$props2.slideStyle,
          slideClassName = _this$props2.slideClassName,
          springConfig = _this$props2.springConfig,
          style = _this$props2.style,
          threshold = _this$props2.threshold,
          other = (0, _objectWithoutProperties2.default)(_this$props2, ["action", "animateHeight", "animateTransitions", "axis", "children", "containerStyle", "disabled", "disableLazyLoading", "enableMouseEvents", "hysteresis", "ignoreNativeScroll", "index", "onChangeIndex", "onSwitching", "onTransitionEnd", "resistance", "slideStyle", "slideClassName", "springConfig", "style", "threshold"]);
      var _this$state = this.state,
          displaySameSlide = _this$state.displaySameSlide,
          heightLatest = _this$state.heightLatest,
          indexLatest = _this$state.indexLatest,
          isDragging = _this$state.isDragging,
          renderOnlyActive = _this$state.renderOnlyActive;
      var touchEvents = !disabled ? {
        onTouchStart: this.handleTouchStart,
        onTouchEnd: this.handleTouchEnd
      } : {};
      var mouseEvents = !disabled && enableMouseEvents ? {
        onMouseDown: this.handleMouseDown,
        onMouseUp: this.handleMouseUp,
        onMouseLeave: this.handleMouseLeave,
        onMouseMove: this.handleMouseMove
      } : {}; // There is no point to animate if we are already providing a height.

       false ? undefined : void 0;
      var slideStyle = (0, _extends2.default)({}, styles.slide, slideStyleProp);
      var transition;
      var WebkitTransition;

      if (isDragging || !animateTransitions || displaySameSlide) {
        transition = 'all 0s ease 0s';
        WebkitTransition = 'all 0s ease 0s';
      } else {
        transition = createTransition('transform', springConfig);
        WebkitTransition = createTransition('-webkit-transform', springConfig);

        if (heightLatest !== 0) {
          var additionalTranstion = ", ".concat(createTransition('height', springConfig));
          transition += additionalTranstion;
          WebkitTransition += additionalTranstion;
        }
      }

      var containerStyle = {
        height: null,
        WebkitFlexDirection: axisProperties.flexDirection[axis],
        flexDirection: axisProperties.flexDirection[axis],
        WebkitTransition: WebkitTransition,
        transition: transition
      }; // Apply the styles for SSR considerations

      if (!renderOnlyActive) {
        var transform = axisProperties.transform[axis](this.indexCurrent * 100);
        containerStyle.WebkitTransform = transform;
        containerStyle.transform = transform;
      }

      if (animateHeight) {
        containerStyle.height = heightLatest;
      }

      return _react.default.createElement("div", (0, _extends2.default)({
        ref: this.setRootNode,
        style: (0, _extends2.default)({}, axisProperties.root[axis], style)
      }, other, touchEvents, mouseEvents, {
        onScroll: this.handleScroll
      }), _react.default.createElement("div", {
        ref: this.setContainerNode,
        style: (0, _extends2.default)({}, containerStyle, styles.container, containerStyleProp),
        className: "react-swipeable-view-container"
      }, _react.default.Children.map(children, function (child, indexChild) {
        if (renderOnlyActive && indexChild !== indexLatest) {
          return null;
        }

         false ? undefined : void 0;
        var ref;
        var hidden = true;

        if (indexChild === indexLatest) {
          hidden = false;

          if (animateHeight) {
            ref = _this4.setActiveSlide;
            slideStyle.overflowY = 'hidden';
          }
        }

        return _react.default.createElement("div", {
          ref: ref,
          style: slideStyle,
          className: slideClassName,
          "aria-hidden": hidden,
          "data-swipeable": "true"
        }, child);
      })));
    }
  }]);
  return SwipeableViews;
}(_react.default.Component); // Added as an ads for people using the React dev tools in production.
// So they know, the tool used to build the awesome UI they
// are looking at/retro engineering.


SwipeableViews.displayName = 'ReactSwipableView';
SwipeableViews.propTypes =  false ? undefined : {};
SwipeableViews.defaultProps = {
  animateHeight: false,
  animateTransitions: true,
  axis: 'x',
  disabled: false,
  disableLazyLoading: false,
  enableMouseEvents: false,
  hysteresis: 0.6,
  ignoreNativeScroll: false,
  index: 0,
  threshold: 5,
  springConfig: {
    duration: '0.35s',
    easeFunction: 'cubic-bezier(0.15, 0.3, 0.25, 1)',
    delay: '0s'
  },
  resistance: false
};
SwipeableViews.childContextTypes = {
  swipeableViews: _propTypes.default.shape({
    slideUpdateHeight: _propTypes.default.func
  })
};
var _default = SwipeableViews;
exports.default = _default;

/***/ }),
/* 220 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

module.exports = _extends;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(222);

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

module.exports = _objectWithoutProperties;

/***/ }),
/* 222 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;

/***/ }),
/* 223 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

module.exports = _classCallCheck;

/***/ }),
/* 224 */
/***/ (function(module, exports) {

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

module.exports = _createClass;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(226);

var assertThisInitialized = __webpack_require__(227);

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return assertThisInitialized(self);
}

module.exports = _possibleConstructorReturn;

/***/ }),
/* 226 */
/***/ (function(module, exports) {

function _typeof2(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    module.exports = _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    module.exports = _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

module.exports = _typeof;

/***/ }),
/* 227 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

module.exports = _assertThisInitialized;

/***/ }),
/* 228 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

module.exports = _getPrototypeOf;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(230);

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}

module.exports = _inherits;

/***/ }),
/* 230 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

module.exports = _setPrototypeOf;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(71);

exports.__esModule = true;
exports.default = exports.animationEnd = exports.animationDelay = exports.animationTiming = exports.animationDuration = exports.animationName = exports.transitionEnd = exports.transitionDuration = exports.transitionDelay = exports.transitionTiming = exports.transitionProperty = exports.transform = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(72));

var transform = 'transform';
exports.transform = transform;
var prefix, transitionEnd, animationEnd;
exports.animationEnd = animationEnd;
exports.transitionEnd = transitionEnd;
var transitionProperty, transitionDuration, transitionTiming, transitionDelay;
exports.transitionDelay = transitionDelay;
exports.transitionTiming = transitionTiming;
exports.transitionDuration = transitionDuration;
exports.transitionProperty = transitionProperty;
var animationName, animationDuration, animationTiming, animationDelay;
exports.animationDelay = animationDelay;
exports.animationTiming = animationTiming;
exports.animationDuration = animationDuration;
exports.animationName = animationName;

if (_inDOM.default) {
  var _getTransitionPropert = getTransitionProperties();

  prefix = _getTransitionPropert.prefix;
  exports.transitionEnd = transitionEnd = _getTransitionPropert.transitionEnd;
  exports.animationEnd = animationEnd = _getTransitionPropert.animationEnd;
  exports.transform = transform = prefix + "-" + transform;
  exports.transitionProperty = transitionProperty = prefix + "-transition-property";
  exports.transitionDuration = transitionDuration = prefix + "-transition-duration";
  exports.transitionDelay = transitionDelay = prefix + "-transition-delay";
  exports.transitionTiming = transitionTiming = prefix + "-transition-timing-function";
  exports.animationName = animationName = prefix + "-animation-name";
  exports.animationDuration = animationDuration = prefix + "-animation-duration";
  exports.animationTiming = animationTiming = prefix + "-animation-delay";
  exports.animationDelay = animationDelay = prefix + "-animation-timing-function";
}

var _default = {
  transform: transform,
  end: transitionEnd,
  property: transitionProperty,
  timing: transitionTiming,
  delay: transitionDelay,
  duration: transitionDuration
};
exports.default = _default;

function getTransitionProperties() {
  var style = document.createElement('div').style;
  var vendorMap = {
    O: function O(e) {
      return "o" + e.toLowerCase();
    },
    Moz: function Moz(e) {
      return e.toLowerCase();
    },
    Webkit: function Webkit(e) {
      return "webkit" + e;
    },
    ms: function ms(e) {
      return "MS" + e;
    }
  };
  var vendors = Object.keys(vendorMap);
  var transitionEnd, animationEnd;
  var prefix = '';

  for (var i = 0; i < vendors.length; i++) {
    var vendor = vendors[i];

    if (vendor + "TransitionProperty" in style) {
      prefix = "-" + vendor.toLowerCase();
      transitionEnd = vendorMap[vendor]('TransitionEnd');
      animationEnd = vendorMap[vendor]('AnimationEnd');
      break;
    }
  }

  if (!transitionEnd && 'transitionProperty' in style) transitionEnd = 'transitionend';
  if (!animationEnd && 'animationName' in style) animationEnd = 'animationend';
  style = null;
  return {
    animationEnd: animationEnd,
    transitionEnd: transitionEnd,
    prefix: prefix
  };
}

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(71);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(72));

var on = function on() {};

if (_inDOM.default) {
  on = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.addEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.attachEvent('on' + eventName, function (e) {
        e = e || window.event;
        e.target = e.target || e.srcElement;
        e.currentTarget = node;
        handler.call(node, e);
      });
    };
  }();
}

var _default = on;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(71);

exports.__esModule = true;
exports.default = void 0;

var _inDOM = _interopRequireDefault(__webpack_require__(72));

var off = function off() {};

if (_inDOM.default) {
  off = function () {
    if (document.addEventListener) return function (node, eventName, handler, capture) {
      return node.removeEventListener(eventName, handler, capture || false);
    };else if (document.attachEvent) return function (node, eventName, handler) {
      return node.detachEvent('on' + eventName, handler);
    };
  }();
}

var _default = off;
exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(73);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "checkIndexBounds", {
  enumerable: true,
  get: function get() {
    return _checkIndexBounds.default;
  }
});
Object.defineProperty(exports, "computeIndex", {
  enumerable: true,
  get: function get() {
    return _computeIndex.default;
  }
});
Object.defineProperty(exports, "constant", {
  enumerable: true,
  get: function get() {
    return _constant.default;
  }
});
Object.defineProperty(exports, "getDisplaySameSlide", {
  enumerable: true,
  get: function get() {
    return _getDisplaySameSlide.default;
  }
});
Object.defineProperty(exports, "mod", {
  enumerable: true,
  get: function get() {
    return _mod.default;
  }
});

var _checkIndexBounds = _interopRequireDefault(__webpack_require__(235));

var _computeIndex = _interopRequireDefault(__webpack_require__(236));

var _constant = _interopRequireDefault(__webpack_require__(103));

var _getDisplaySameSlide = _interopRequireDefault(__webpack_require__(237));

var _mod = _interopRequireDefault(__webpack_require__(238));

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(73);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(1));

var _warning = _interopRequireDefault(__webpack_require__(102));

var checkIndexBounds = function checkIndexBounds(props) {
  var index = props.index,
      children = props.children;

  var childrenCount = _react.default.Children.count(children);

   false ? undefined : void 0;
};

var _default = checkIndexBounds;
exports.default = _default;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(73);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = computeIndex;

var _react = _interopRequireDefault(__webpack_require__(1));

var _constant = _interopRequireDefault(__webpack_require__(103));

function computeIndex(params) {
  var children = params.children,
      startIndex = params.startIndex,
      startX = params.startX,
      pageX = params.pageX,
      viewLength = params.viewLength,
      resistance = params.resistance;
  var indexMax = _react.default.Children.count(children) - 1;
  var index = startIndex + (startX - pageX) / viewLength;
  var newStartX;

  if (!resistance) {
    // Reset the starting point
    if (index < 0) {
      index = 0;
      newStartX = (index - startIndex) * viewLength + pageX;
    } else if (index > indexMax) {
      index = indexMax;
      newStartX = (index - startIndex) * viewLength + pageX;
    }
  } else if (index < 0) {
    index = Math.exp(index * _constant.default.RESISTANCE_COEF) - 1;
  } else if (index > indexMax) {
    index = indexMax + 1 - Math.exp((indexMax - index) * _constant.default.RESISTANCE_COEF);
  }

  return {
    index: index,
    startX: newStartX
  };
}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var getDisplaySameSlide = function getDisplaySameSlide(props, nextProps) {
  var displaySameSlide = false;

  if (props.children.length && nextProps.children.length) {
    var oldChildren = props.children[props.index];
    var oldKey = oldChildren ? oldChildren.key : 'empty';

    if (oldKey !== null) {
      var newChildren = nextProps.children[nextProps.index];
      var newKey = newChildren ? newChildren.key : 'empty';

      if (oldKey === newKey) {
        displaySameSlide = true;
      }
    }
  }

  return displaySameSlide;
};

var _default = getDisplaySameSlide;
exports.default = _default;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

// Extended version of % with negative integer support.
function mod(n, m) {
  var q = n % m;
  return q < 0 ? q + m : q;
}

var _default = mod;
exports.default = _default;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var HeightUpdater = (function (_Component) {
	_inherits(HeightUpdater, _Component);

	function HeightUpdater(props) {
		_classCallCheck(this, HeightUpdater);

		_get(Object.getPrototypeOf(HeightUpdater.prototype), 'constructor', this).call(this, props);

		this.onWindowResize = this.onWindowResize.bind(this);
	}

	_createClass(HeightUpdater, [{
		key: 'onWindowResize',
		value: function onWindowResize() {
			var height = window.innerHeight;
			if (height !== this.props.height) {
				this.props.onHeightChange(height);
			}
		}
	}, {
		key: 'componentWillMount',
		value: function componentWillMount() {
			window.addEventListener('resize', this.onWindowResize);
		}
	}, {
		key: 'componentWillUnmount',
		value: function componentWillUnmount() {
			window.removeEventListener('resize', this.onWindowResize);
		}
	}, {
		key: 'render',
		value: function render() {
			return null;
		}
	}]);

	return HeightUpdater;
})(_react.Component);

HeightUpdater.propTypes = {
	height: _propTypes2['default'].number,
	onHeightChange: _propTypes2['default'].func
};

exports['default'] = HeightUpdater;
module.exports = exports['default'];

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', {
	value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _get = function get(_x, _x2, _x3) { var _again = true; _function: while (_again) { var object = _x, property = _x2, receiver = _x3; _again = false; if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { _x = parent; _x2 = property; _x3 = receiver; _again = true; desc = parent = undefined; continue _function; } } else if ('value' in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } } };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

function _inherits(subClass, superClass) { if (typeof superClass !== 'function' && superClass !== null) { throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var ScrollToTop = (function (_Component) {
	_inherits(ScrollToTop, _Component);

	function ScrollToTop() {
		_classCallCheck(this, ScrollToTop);

		_get(Object.getPrototypeOf(ScrollToTop.prototype), 'constructor', this).apply(this, arguments);
	}

	_createClass(ScrollToTop, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			this.props.element().scrollTop = 0;
		}
	}, {
		key: 'render',
		value: function render() {
			return null;
		}
	}]);

	return ScrollToTop;
})(_react.Component);

ScrollToTop.propTypes = {
	element: _propTypes2['default'].func.isRequired
};

exports['default'] = ScrollToTop;
module.exports = exports['default'];

/***/ }),
/* 241 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputWrapper", function() { return InputWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StyledInput", function() { return StyledInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputLabel", function() { return InputLabel; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputField", function() { return InputField; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputIcon", function() { return InputIcon; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputError", function() { return InputError; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_input_mask__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39);
/* harmony import */ var _src_helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(16);





const InputWrapper = styled_components__WEBPACK_IMPORTED_MODULE_1___default.a.div.withConfig({ displayName: "styles__InputWrapper", componentId: "baat5m-0" })(["position:relative;color:", ";"],

props => props.theme.colors.Foreground);


const StyledInput = styled_components__WEBPACK_IMPORTED_MODULE_1___default.a.div.withConfig({ displayName: "styles__StyledInput", componentId: "baat5m-1" })(["display:flex;border-bottom:2px solid ", ";"],

props => props.theme.colors['Level 4']);


const InputLabel = styled_components__WEBPACK_IMPORTED_MODULE_1___default.a.label.withConfig({ displayName: "styles__InputLabel", componentId: "baat5m-2" })(["position:absolute;top:", ";left:0;height:12px;color:", ";white-space:nowrap;pointer-events:none;user-select:none;transition:all 0.2s;transition-timing-function:cubic-bezier(0.4,0,0.2,1);", ""],

({ active }) => active ? '0px' : '18px',


props => props.theme.colors['Level 4'],






props => Object(styled_components__WEBPACK_IMPORTED_MODULE_1__["css"])(props.theme.typography.SmallCapsHeadline));


const InputComponent = ({ isMask, ...props }) => {
  if (isMask) {
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react_input_mask__WEBPACK_IMPORTED_MODULE_2__[/* default */ "a"], props);
  }

  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("input", props);
};

const InputField = styled_components__WEBPACK_IMPORTED_MODULE_1___default()(Object(_src_helpers__WEBPACK_IMPORTED_MODULE_3__["omitProps"])('withIconRight', 'theme')(InputComponent)).withConfig({ displayName: "styles__InputField", componentId: "baat5m-3" })(["padding:16px 0 4px;width:100%;line-height:18px;color:inherit;border:0;outline:transparent;background-color:transparent;box-sizing:border-box;", " &:focus ~ ", "{top:0px;}&:disabled{color:", ";}"],









props => Object(styled_components__WEBPACK_IMPORTED_MODULE_1__["css"])(props.theme.typography.Paragraph),

InputLabel,




props => props.theme.colors['Level 3']);



const InputIcon = styled_components__WEBPACK_IMPORTED_MODULE_1___default.a.span.withConfig({ displayName: "styles__InputIcon", componentId: "baat5m-4" })(["align-self:flex-end;color:", ";"],

props => props.theme.colors['Level 4']);


const InputError = styled_components__WEBPACK_IMPORTED_MODULE_1___default.a.span.withConfig({ displayName: "styles__InputError", componentId: "baat5m-5" })(["margin-top:8px;height:16px;color:#f44336;font-style:italic;font-weight:bold;font-size:0.8em;letter-spacing:0.02em;"]);

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = exports.Label = exports.Dot = exports.RadioInput = exports.Container = void 0;
const styled_components_1 = __importStar(__webpack_require__(2));
exports.Container = styled_components_1.default.div `
    ${({ disabled }) => disabled &&
    styled_components_1.css `
            opacity: 0.6;
            pointer-events: none;
        `}
`;
exports.RadioInput = styled_components_1.default.input `
    height: 0;
    width: 0;
    position: absolute;

    &:checked ~ div:after {
        position: absolute;
        content: '';
        width: 10px;
        height: 10px;
        background: ${({ theme, dotColor }) => dotColor || theme.colors.Foreground};
        border-radius: 50%;
    }
`;
exports.Dot = styled_components_1.default.div `
    position: relative;
    border: 1px solid
        ${({ theme, borderColor }) => borderColor || theme.colors['Level 2']};
    box-sizing: border-box;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
`;
exports.Label = styled_components_1.default.label `
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
`;
exports.Text = styled_components_1.default.p `
    ${(props) => styled_components_1.css(props.theme.typography.Paragraph)};
    margin-left: 8px;
`;


/***/ }),
/* 243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CheckboxWrapper", function() { return CheckboxWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BoxWrapper", function() { return BoxWrapper; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CheckboxInput", function() { return CheckboxInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Check", function() { return Check; });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(styled_components__WEBPACK_IMPORTED_MODULE_0__);


const CheckboxWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0___default.a.span.withConfig({ displayName: "styles__CheckboxWrapper", componentId: "k1qygx-0" })(["display:inline-flex;align-items:center;"]);




const BoxWrapper = styled_components__WEBPACK_IMPORTED_MODULE_0___default.a.div.withConfig({ displayName: "styles__BoxWrapper", componentId: "k1qygx-1" })(["position:relative;display:inline-block;box-sizing:border-box;width:24px;min-width:24px;max-width:24px;height:24px;min-height:24px;max-height:24px;margin:0 16px 0 0;border:2px solid;border-color:", ";border-radius:4px;"],











({ theme }) => theme.colors['Level 2']);



const CheckboxInput = styled_components__WEBPACK_IMPORTED_MODULE_0___default.a.input.withConfig({ displayName: "styles__CheckboxInput", componentId: "k1qygx-2" })(["position:relative;width:24px;height:24px;margin:0;outline:none;appearance:none;cursor:pointer;&:checked{background:none;z-index:1;}"]);













const Check = styled_components__WEBPACK_IMPORTED_MODULE_0___default.a.div.withConfig({ displayName: "styles__Check", componentId: "k1qygx-3" })(["position:absolute;left:2px;top:2px;width:16px;height:16px;border-radius:2px;background-color:", ";"],






({ accentColor, theme }) => accentColor || theme.colors.Color2);

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconWrap = exports.Placeholder = exports.ItemText = exports.SelectedItem = exports.Container = exports.Chevron = exports.ListElement = exports.List = void 0;
const styled_components_1 = __importStar(__webpack_require__(2));
const elevation_1 = __webpack_require__(11);
const Icons_1 = __webpack_require__(17);
const Container = styled_components_1.default.section `
    position: relative;
`;
exports.Container = Container;
const ItemStyles = styled_components_1.css `
    height: 48px;
    display: flex;
    align-items: center;
    padding: 0 16px;
    color: ${({ theme }) => theme.colors.Foreground};
`;
const ItemText = styled_components_1.default.div `
    flex: 1;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
`;
exports.ItemText = ItemText;
const SelectedItem = styled_components_1.default.div `
    ${ItemStyles};
    border-radius: 24px;
    border: 2px solid ${({ theme }) => theme.colors['Level 1']};
    ${(props) => props.isMultiple &&
    styled_components_1.css `
            cursor: pointer;
            ${elevation_1.getElevationTransition(true)}
            &:hover {
                ${elevation_1.elevation(3, true)}
            }
            &:active {
                ${elevation_1.elevation(1, true)}
            }
        `}
`;
exports.SelectedItem = SelectedItem;
const Placeholder = styled_components_1.default.div `
    color: ${({ theme }) => theme.colors['Level 5']};
`;
exports.Placeholder = Placeholder;
const List = styled_components_1.default.ul `
    top: -3px;
    left: -2px;
    width: 104%;
    opacity: 0;
    visibility: hidden;
    position: absolute;
    background: ${({ theme }) => theme.colors.ElementBackground};
    border-radius: 24px;
    z-index: 2;
    transition: all 0.2s cubic-bezier(0.4, 0, 1, 1);
    margin: 0;
    padding: 0;
    transform: scale(0.9);
    transform-origin: top center;
    ${elevation_1.elevation(0, false)}

    ${(props) => props.isOpen &&
    styled_components_1.css `
            width: 101%;
            opacity: 1;
            visibility: visible;
            transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);
            transform: scale(1);
            ${elevation_1.elevation(3, false)}
        `}
`;
exports.List = List;
const ListElement = styled_components_1.default.li `
    ${ItemStyles};
    cursor: pointer;
    &:hover {
        background: ${({ theme }) => theme.colors['Level 1']};
    }
    transition: background-color ease 0.3s;
    &:first-child {
        border-radius: 20px 20px 0 0;
    }
    &:last-child {
        border-radius: 0 0 20px 20px;
    }
    &:not(:last-child) {
        border-bottom: 2px solid ${({ theme }) => theme.colors['Level 1']};
    }
`;
exports.ListElement = ListElement;
const IconWrap = styled_components_1.default.div `
    margin-right: 8px;
    display: flex;
`;
exports.IconWrap = IconWrap;
const Chevron = styled_components_1.default(Icons_1.ChevronIcon) `
    height: 24px;
    width: 24px;
`;
exports.Chevron = Chevron;


/***/ }),
/* 245 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__245__;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UndoButton = void 0;
const react_1 = __importStar(__webpack_require__(1));
const styled_components_1 = __webpack_require__(2);
const Icons_1 = __webpack_require__(17);
const DismissingCardContext_1 = __webpack_require__(55);
const styles_1 = __webpack_require__(42);
exports.UndoButton = ({ className, children }) => {
    const { undo } = react_1.useContext(DismissingCardContext_1.DismissingCardContext);
    const theme = react_1.useContext(styled_components_1.ThemeContext);
    return (react_1.default.createElement(styles_1.UndoButton, { small: true, className: className, onClick: undo, icon: react_1.default.createElement(Icons_1.Undo, { color: theme.colors['Level 5'] }) }, children));
};


/***/ }),
/* 247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapColors", function() { return mapColors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapColorsHover", function() { return mapColorsHover; });
/* harmony import */ var src_theme_shared_palette__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44);
/* harmony import */ var src_theme_shared_palette__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(src_theme_shared_palette__WEBPACK_IMPORTED_MODULE_0__);


const mapColors = ({ theme, color }) => {
  return (
    color === 'grey' && theme.colors['Level 1'] ||
    color === 'blue' && theme.colors.Color2_75 ||
    color === 'red' && theme.colors.Color1 ||
    color === 'black' && theme.colors.Foreground ||
    color === 'white' && '#ffffff' ||
    color === 'yellow' && '#ffc700' ||
    theme.colors[color] ||
    color);

};

const mapColorsHover = ({ theme, color }) => {
  return (
    color === 'grey' && theme.colors['Level 3'] ||
    color === 'blue' && '#182d99' ||
    color === 'red' && '#ba264d' ||
    color === 'yellow' && '#eda210' ||
    color === 'black' && theme.colors.Background ||
    color === 'white' && src_theme_shared_palette__WEBPACK_IMPORTED_MODULE_0___default.a.grey[25] ||
    theme.colors[color] ||
    color);

};

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonColor = void 0;
var ButtonColor;
(function (ButtonColor) {
    ButtonColor["grey"] = "grey";
    ButtonColor["blue"] = "blue";
    ButtonColor["red"] = "red";
    ButtonColor["black"] = "black";
    ButtonColor["white"] = "white";
    ButtonColor["yellow"] = "yellow";
})(ButtonColor = exports.ButtonColor || (exports.ButtonColor = {}));


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimerDismissButton = void 0;
const react_1 = __importStar(__webpack_require__(1));
const styled_components_1 = __webpack_require__(2);
const Icons_1 = __webpack_require__(17);
const styles_1 = __webpack_require__(42);
const DEFAULT_TIMEOUT_IN_MS = 4000;
exports.TimerDismissButton = ({ className, onDismiss, timeout = DEFAULT_TIMEOUT_IN_MS, }) => {
    const timeoutRef = react_1.useRef(null);
    const [progress, setProgress] = react_1.useState(0);
    const theme = react_1.useContext(styled_components_1.ThemeContext);
    react_1.useEffect(() => {
        setProgress(100);
        timeoutRef.current = window.setTimeout(() => {
            onDismiss();
        }, timeout);
        return () => {
            if (timeoutRef.current) {
                clearTimeout(timeoutRef.current);
            }
        };
    }, [onDismiss, timeout]);
    return (react_1.default.createElement(styles_1.TimerDismissButton, { small: true, className: className, onClick: onDismiss, icon: react_1.default.createElement(Icons_1.Close, { color: theme.colors['Level 5'] }) },
        react_1.default.createElement(styles_1.TimerProgress, { progress: progress, diameter: 32, stroke: 2, color: theme.colors['Level 4'], animationDuration: timeout })));
};


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmCancellationButton = void 0;
const react_1 = __importStar(__webpack_require__(1));
const styled_components_1 = __webpack_require__(2);
const Icons_1 = __webpack_require__(17);
const styles_1 = __webpack_require__(42);
exports.ConfirmCancellationButton = ({ className, children, onDismiss, }) => {
    const theme = react_1.useContext(styled_components_1.ThemeContext);
    return (react_1.default.createElement(styles_1.ConfirmCancelButton, { small: true, className: className, onClick: onDismiss, icon: react_1.default.createElement(Icons_1.CircleTick, { color: theme.colors.negative }) }, children));
};


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(__webpack_require__(1));
const react_native_svg_1 = __webpack_require__(9);
const AngryFace = ({ style, className, size = '30px', color = '#333', }) => (react_1.default.createElement(react_native_svg_1.Svg, { fill: "none", width: size, height: size, style: style, viewBox: "0 0 30 31", className: className, xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement(react_native_svg_1.G, { clipPath: "url(#clip0_9146_54)" },
        react_1.default.createElement(react_native_svg_1.Path, { d: "M19.83 14.5604C20.9732 14.5604 21.9 13.6336 21.9 12.4904C21.9 11.7978 21.5599 11.1847 21.0375 10.8089L22.2348 9.61158L20.2832 7.65996L16.38 11.5632L17.8254 13.0086C18.0554 13.901 18.8657 14.5604 19.83 14.5604Z", fill: color }),
        react_1.default.createElement(react_native_svg_1.Path, { d: "M20.1264 18.0982C21.1788 19.2134 21.6947 20.4691 21.8588 21.1257L19.1812 21.7951C19.1154 21.5317 18.8032 20.7174 18.1191 19.9925C17.4722 19.307 16.4983 18.7004 15 18.7004C13.5017 18.7004 12.5279 19.307 11.8809 19.9926C11.1968 20.7174 10.8847 21.5317 10.8188 21.7951L8.14122 21.1257C8.30536 20.4691 8.8212 19.2134 9.87363 18.0982C10.9632 16.9437 12.6343 15.9404 15 15.9404C17.3657 15.9404 19.0369 16.9437 20.1264 18.0982Z", fill: color }),
        react_1.default.createElement(react_native_svg_1.Path, { d: "M1.2 15.9404C1.2 8.31885 7.37847 2.14038 15 2.14038C22.6215 2.14038 28.8 8.31885 28.8 15.9404C28.8 23.5619 22.6215 29.7404 15 29.7404C7.37847 29.7404 1.2 23.5619 1.2 15.9404ZM15 4.90038C8.90277 4.90038 3.96 9.84316 3.96 15.9404C3.96 22.0376 8.90277 26.9804 15 26.9804C21.0972 26.9804 26.04 22.0376 26.04 15.9404C26.04 9.84316 21.0972 4.90038 15 4.90038Z", fillRule: "evenodd", clipRule: "evenodd", fill: color }),
        react_1.default.createElement(react_native_svg_1.Path, { d: "M10.5461 14.5604C9.40283 14.5604 8.47606 13.6336 8.47606 12.4904C8.47606 11.7978 8.81619 11.1847 9.33853 10.8089L8.14122 9.61158L10.0928 7.65996L13.9961 11.5632L12.5507 13.0086C12.3206 13.901 11.5103 14.5604 10.5461 14.5604Z", fill: color })),
    react_1.default.createElement(react_native_svg_1.Defs, null,
        react_1.default.createElement("clipPath", { id: "clip0_9146_54" },
            react_1.default.createElement("rect", { width: "30", height: "30", fill: "white", transform: "translate(0 0.940369)" })))));
exports.default = AngryFace;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(__webpack_require__(1));
const react_native_svg_1 = __webpack_require__(9);
const SadFace = ({ style, className, size = '30px', color = '#333', }) => (react_1.default.createElement(react_native_svg_1.Svg, { fill: "none", width: size, height: size, style: style, viewBox: "0 0 30 31", className: className, xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement(react_native_svg_1.G, { clipPath: "url(#clip0_9146_64)" },
        react_1.default.createElement(react_native_svg_1.Path, { d: "M15.25 5.54037C9.50624 5.54037 4.85 10.1966 4.85 15.9404C4.85 21.6841 9.50624 26.3404 15.25 26.3404C20.9938 26.3404 25.65 21.6841 25.65 15.9404C25.65 10.1966 20.9938 5.54037 15.25 5.54037ZM2.25 15.9404C2.25 8.76067 8.0703 2.94037 15.25 2.94037C22.4297 2.94037 28.25 8.76067 28.25 15.9404C28.25 23.1201 22.4297 28.9404 15.25 28.9404C8.0703 28.9404 2.25 23.1201 2.25 15.9404Z", fill: color }),
        react_1.default.createElement(react_native_svg_1.Path, { d: "M12.65 12.6904C12.65 13.7673 11.777 14.6404 10.7 14.6404C9.62304 14.6404 8.75 13.7673 8.75 12.6904C8.75 11.6134 9.62304 10.7404 10.7 10.7404C11.777 10.7404 12.65 11.6134 12.65 12.6904Z", fill: color }),
        react_1.default.createElement(react_native_svg_1.Path, { d: "M21.75 12.6904C21.75 13.7673 20.877 14.6404 19.8 14.6404C18.723 14.6404 17.85 13.7673 17.85 12.6904C17.85 11.6134 18.723 10.7404 19.8 10.7404C20.877 10.7404 21.75 11.6134 21.75 12.6904Z", fill: color }),
        react_1.default.createElement(react_native_svg_1.Path, { d: "M20.0792 17.9731C21.0706 19.0236 21.5566 20.2065 21.7112 20.8251L19.1888 21.4557C19.1268 21.2075 18.8327 20.4405 18.1883 19.7576C17.5789 19.1118 16.6614 18.5404 15.25 18.5404C13.8386 18.5404 12.9212 19.1118 12.3117 19.7576C11.6673 20.4405 11.3732 21.2075 11.3112 21.4557L8.78883 20.8251C8.94346 20.2065 9.4294 19.0236 10.4208 17.9731C11.4472 16.8856 13.0214 15.9404 15.25 15.9404C17.4786 15.9404 19.0528 16.8856 20.0792 17.9731Z", fill: color })),
    react_1.default.createElement(react_native_svg_1.Defs, null,
        react_1.default.createElement(react_native_svg_1.ClipPath, { id: "clip0_9146_64" },
            react_1.default.createElement(react_native_svg_1.Rect, { fill: "white", width: size, height: size, transform: "translate(0.25 0.940369)" })))));
exports.default = SadFace;


/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(__webpack_require__(1));
const react_native_svg_1 = __webpack_require__(9);
const StraightFace = ({ style, className, size = '30px', color = '#333', }) => (react_1.default.createElement(react_native_svg_1.Svg, { fill: "none", width: size, height: size, style: style, viewBox: "0 0 30 31", className: className, xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement(react_native_svg_1.Path, { d: "M15.5 5.54037C9.75624 5.54037 5.1 10.1966 5.1 15.9404C5.1 21.6841 9.75624 26.3404 15.5 26.3404C21.2438 26.3404 25.9 21.6841 25.9 15.9404C25.9 10.1966 21.2438 5.54037 15.5 5.54037ZM2.5 15.9404C2.5 8.76067 8.3203 2.94037 15.5 2.94037C22.6797 2.94037 28.5 8.76067 28.5 15.9404C28.5 23.1201 22.6797 28.9404 15.5 28.9404C8.3203 28.9404 2.5 23.1201 2.5 15.9404Z", fill: color }),
    react_1.default.createElement(react_native_svg_1.Path, { d: "M12.9 12.6904C12.9 13.7673 12.027 14.6404 10.95 14.6404C9.87304 14.6404 9 13.7673 9 12.6904C9 11.6134 9.87304 10.7404 10.95 10.7404C12.027 10.7404 12.9 11.6134 12.9 12.6904Z", fill: color }),
    react_1.default.createElement(react_native_svg_1.Path, { d: "M22 12.6904C22 13.7673 21.127 14.6404 20.05 14.6404C18.973 14.6404 18.1 13.7673 18.1 12.6904C18.1 11.6134 18.973 10.7404 20.05 10.7404C21.127 10.7404 22 11.6134 22 12.6904Z", fill: color }),
    react_1.default.createElement(react_native_svg_1.Path, { d: "M20.7 19.8404H10.3V17.2404H20.7V19.8404Z", fill: color })));
exports.default = StraightFace;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(__webpack_require__(1));
const react_native_svg_1 = __webpack_require__(9);
const HappyFace = ({ style, className, size = '30px', color = '#333', }) => (react_1.default.createElement(react_native_svg_1.Svg, { fill: "none", width: size, height: size, style: style, viewBox: "0 0 30 31", className: className, xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement(react_native_svg_1.Path, { d: "M15.75 5.54037C21.4938 5.54037 26.15 10.1966 26.15 15.9404C26.15 21.6841 21.4938 26.3404 15.75 26.3404C10.0062 26.3404 5.35 21.6841 5.35 15.9404C5.35 10.1966 10.0062 5.54037 15.75 5.54037ZM28.75 15.9404C28.75 8.76067 22.9297 2.94037 15.75 2.94037C8.5703 2.94037 2.75 8.76067 2.75 15.9404C2.75 23.1201 8.5703 28.9404 15.75 28.9404C22.9297 28.9404 28.75 23.1201 28.75 15.9404Z", fill: color }),
    react_1.default.createElement(react_native_svg_1.Path, { d: "M18.35 12.6904C18.35 13.7673 19.223 14.6404 20.3 14.6404C21.377 14.6404 22.25 13.7673 22.25 12.6904C22.25 11.6134 21.377 10.7404 20.3 10.7404C19.223 10.7404 18.35 11.6134 18.35 12.6904Z", fill: color }),
    react_1.default.createElement(react_native_svg_1.Path, { d: "M9.25 12.6904C9.25 13.7673 10.123 14.6404 11.2 14.6404C12.277 14.6404 13.15 13.7673 13.15 12.6904C13.15 11.6134 12.277 10.7404 11.2 10.7404C10.123 10.7404 9.25 11.6134 9.25 12.6904Z", fill: color }),
    react_1.default.createElement(react_native_svg_1.Path, { d: "M20.5792 20.4076C21.5706 19.3571 22.0566 18.1742 22.2112 17.5557L19.6888 16.9251C19.6268 17.1732 19.3327 17.9403 18.6883 18.6231C18.0789 19.2689 17.1614 19.8404 15.75 19.8404C14.3386 19.8404 13.4212 19.2689 12.8117 18.6231C12.1673 17.9403 11.8732 17.1732 11.8112 16.9251L9.28883 17.5557C9.44346 18.1742 9.9294 19.3571 10.9208 20.4076C11.9472 21.4952 13.5214 22.4404 15.75 22.4404C17.9786 22.4404 19.5528 21.4952 20.5792 20.4076Z", fill: color })));
exports.default = HappyFace;


/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(__webpack_require__(1));
const react_native_svg_1 = __webpack_require__(9);
const StarstruckFace = ({ style, className, size = '30px', color = '#333', }) => (react_1.default.createElement(react_native_svg_1.Svg, { fill: "none", width: size, height: size, style: style, viewBox: "0 0 30 31", className: className, xmlns: "http://www.w3.org/2000/svg" },
    react_1.default.createElement(react_native_svg_1.Path, { d: "M19.8292 21.0576C20.8206 20.0071 21.3066 18.8242 21.4612 18.2057L18.9388 17.5751C18.8768 17.8232 18.5827 18.5903 17.9383 19.2731C17.3289 19.9189 16.4114 20.4904 15 20.4904C13.5886 20.4904 12.6712 19.9189 12.0617 19.2731C11.4173 18.5903 11.1232 17.8232 11.0612 17.5751L8.53883 18.2057C8.69346 18.8242 9.1794 20.0071 10.1708 21.0576C11.1972 22.1452 12.7714 23.0904 15 23.0904C17.2286 23.0904 18.8028 22.1452 19.8292 21.0576Z", fill: color }),
    react_1.default.createElement(react_native_svg_1.Path, { d: "M14.0345 11.9231L11.6521 11.6091L10.6173 9.44037L9.58238 11.6091L7.2 11.9231L8.9428 13.5775L8.50527 15.9404L10.6173 14.7941L12.7292 15.9404L12.2917 13.5775L14.0345 11.9231Z", fill: color }),
    react_1.default.createElement(react_native_svg_1.Path, { d: "M23.1345 11.9231L20.7521 11.6091L19.7173 9.44037L18.6824 11.6091L16.3 11.9231L18.0428 13.5775L17.6053 15.9404L19.7173 14.7941L21.8292 15.9404L21.3917 13.5775L23.1345 11.9231Z", fill: color }),
    react_1.default.createElement(react_native_svg_1.Path, { d: "M28 15.9404C28 8.76067 22.1797 2.94037 15 2.94037C7.8203 2.94037 2 8.76067 2 15.9404C2 23.1201 7.8203 28.9404 15 28.9404C22.1797 28.9404 28 23.1201 28 15.9404ZM15 5.54037C20.7438 5.54037 25.4 10.1966 25.4 15.9404C25.4 21.6841 20.7438 26.3404 15 26.3404C9.25624 26.3404 4.6 21.6841 4.6 15.9404C4.6 10.1966 9.25624 5.54037 15 5.54037Z", fillRule: "evenodd", clipRule: "evenodd", fill: color })));
exports.default = StarstruckFace;


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(__webpack_require__(1));
const types_1 = __webpack_require__(43);
const EmojiStep_1 = __importDefault(__webpack_require__(257));
const ReasonStep_1 = __importDefault(__webpack_require__(258));
const ConclusionStep_1 = __importDefault(__webpack_require__(259));
const StepsWrapper = ({ step }) => {
    switch (step) {
        case types_1.Steps.Emoji:
            return react_1.default.createElement(EmojiStep_1.default, null);
        case types_1.Steps.Reason:
            return react_1.default.createElement(ReasonStep_1.default, null);
        case types_1.Steps.Conclusion:
            return react_1.default.createElement(ConclusionStep_1.default, null);
        default:
            return null;
    }
};
exports.default = StepsWrapper;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(__webpack_require__(1));
const styled_components_1 = __webpack_require__(2);
const context_1 = __importDefault(__webpack_require__(56));
const types_1 = __webpack_require__(43);
const styles_1 = __webpack_require__(75);
const EmojiStep = () => {
    const theme = react_1.useContext(styled_components_1.ThemeContext);
    const { copyConfig, handleFeedback } = react_1.useContext(context_1.default);
    const stepCopy = copyConfig.steps.Emoji;
    return (react_1.default.createElement(styles_1.Container, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(styles_1.Title, null, stepCopy.title),
            react_1.default.createElement(styles_1.Paragraph, null, stepCopy.subtitle)),
        react_1.default.createElement("div", null,
            react_1.default.createElement(styles_1.EmojiRow, null, Object.values(types_1.Feedback).map((nFeedback) => {
                const Icon = types_1.feedbackIconMap[nFeedback];
                return (react_1.default.createElement(styles_1.EmojiIcon, { key: nFeedback, "data-testid": nFeedback, onClick: () => handleFeedback(nFeedback) },
                    react_1.default.createElement(Icon, { color: theme.colors['Level 5'] })));
            })),
            react_1.default.createElement(styles_1.LabelRow, null,
                react_1.default.createElement(styles_1.Paragraph, null, stepCopy.firstLabel),
                react_1.default.createElement(styles_1.Paragraph, null, stepCopy.lastLabel)))));
};
exports.default = EmojiStep;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(__webpack_require__(1));
const styled_components_1 = __webpack_require__(2);
const context_1 = __importDefault(__webpack_require__(56));
const types_1 = __webpack_require__(43);
const styles_1 = __webpack_require__(75);
const ReasonStep = () => {
    const theme = react_1.useContext(styled_components_1.ThemeContext);
    const { feedback, reason, reasonRequired, copyConfig, setReason, handleSubmit } = react_1.useContext(context_1.default);
    const Icon = types_1.feedbackIconMap[feedback];
    const stepCopy = copyConfig.steps.Reason[feedback];
    return (react_1.default.createElement(styles_1.Container, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(styles_1.Row, { style: { paddingBottom: '8px' } },
                react_1.default.createElement(Icon, { size: "16px", color: theme.colors.Foreground }),
                react_1.default.createElement(styles_1.Title, { thin: true }, stepCopy.title)),
            react_1.default.createElement(styles_1.Paragraph, null, stepCopy.subtitle)),
        react_1.default.createElement(styles_1.TextArea, { value: reason, required: reasonRequired, placeholder: stepCopy.placeholder, onChange: (e) => setReason(e.target.value) }),
        react_1.default.createElement(styles_1.PrimaryButton, { small: true, onClick: handleSubmit }, stepCopy.submitButton)));
};
exports.default = ReasonStep;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(__webpack_require__(1));
const context_1 = __importDefault(__webpack_require__(56));
const styles_1 = __webpack_require__(75);
const ConclusionStep = () => {
    const { copyConfig } = react_1.useContext(context_1.default);
    const stepCopy = copyConfig.steps.Conclusion;
    return (react_1.default.createElement(styles_1.Container, null,
        react_1.default.createElement("div", null,
            react_1.default.createElement(styles_1.Title, null, stepCopy.title),
            react_1.default.createElement(styles_1.Paragraph, null, stepCopy.subtitle))));
};
exports.default = ConclusionStep;


/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__260__;

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledParagraph = exports.StyledSmallCapsHeadline = exports.StyledSmallHeadline = exports.StyledSubHeadline = exports.StyledHeadline = void 0;
const styled_components_1 = __importDefault(__webpack_require__(2));
exports.StyledHeadline = styled_components_1.default.h1 `
    color: ${(props) => { var _a; return (_a = props.titleColor) !== null && _a !== void 0 ? _a : props.theme.colors.Foreground; }};
    padding-bottom: ${({ theme }) => theme.spacers.XXL};
    ${({ theme }) => theme.typography.Headline};
`;
exports.StyledSubHeadline = styled_components_1.default.h2 `
    color: ${(props) => { var _a; return (_a = props.titleColor) !== null && _a !== void 0 ? _a : props.theme.colors.Foreground; }};
    padding-bottom: ${({ theme }) => theme.spacers.L};
    ${({ theme }) => theme.typography.Subheadline}
`;
exports.StyledSmallHeadline = styled_components_1.default.h3 `
    color: ${(props) => { var _a; return (_a = props.titleColor) !== null && _a !== void 0 ? _a : props.theme.colors.Foreground; }};
    padding-bottom: ${({ theme }) => theme.spacers.M};
    ${({ theme }) => theme.typography.SmallHeadline}
`;
exports.StyledSmallCapsHeadline = styled_components_1.default.h4 `
    color: ${(props) => { var _a; return (_a = props.titleColor) !== null && _a !== void 0 ? _a : props.theme.colors.Foreground; }};
    padding-bottom: 12px;
    ${({ theme }) => theme.typography.SmallCapsHeadline}
`;
exports.StyledParagraph = styled_components_1.default.p `
    color: ${(props) => { var _a; return (_a = props.paragraphColor) !== null && _a !== void 0 ? _a : props.theme.colors['Level 5']; }};

    ${({ theme }) => theme.typography.Paragraph}

    > a {
        color: ${(props) => { var _a; return (_a = props.paragraphColor) !== null && _a !== void 0 ? _a : props.theme.colors['Level 5']; }};
        text-decoration: underline;
    }
`;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.BackgroundColorKeyMap = exports.TextColorKeyMap = void 0;
const types_1 = __webpack_require__(263);
exports.TextColorKeyMap = {
    [types_1.ColorFunctions.PRIMARY]: 'primary',
    [types_1.ColorFunctions.SECONDARY]: 'secondary',
    [types_1.ColorFunctions.POSITIVE]: 'positive',
    [types_1.ColorFunctions.CAUTION]: 'caution',
    [types_1.ColorFunctions.NEGATIVE]: 'negative',
};
exports.BackgroundColorKeyMap = {
    [types_1.ColorFunctions.PRIMARY]: 'primaryBackground',
    [types_1.ColorFunctions.SECONDARY]: 'secondaryBackground',
    [types_1.ColorFunctions.POSITIVE]: 'positiveBackground',
    [types_1.ColorFunctions.CAUTION]: 'cautionBackground',
    [types_1.ColorFunctions.NEGATIVE]: 'negativeBackground',
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.ColorFunctions = void 0;
var ColorFunctions;
(function (ColorFunctions) {
    ColorFunctions["PRIMARY"] = "PRIMARY";
    ColorFunctions["SECONDARY"] = "SECONDARY";
    ColorFunctions["POSITIVE"] = "POSITIVE";
    ColorFunctions["CAUTION"] = "CAUTION";
    ColorFunctions["NEGATIVE"] = "NEGATIVE";
})(ColorFunctions = exports.ColorFunctions || (exports.ColorFunctions = {}));


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LargeImage = exports.Image = exports.MarketingHeader = void 0;
const styled_components_1 = __importDefault(__webpack_require__(2));
exports.MarketingHeader = styled_components_1.default.div `
    display: flex;
    align-items: flex-start;
    margin-bottom: ${({ theme }) => theme.spacers.L};
`;
exports.Image = styled_components_1.default.img `
    height: 64px;
    width: 64px;
    display: block;
`;
exports.LargeImage = styled_components_1.default.img `
    display: block;
    overflow: hidden;
    border-radius: 4px;
    object-fit: cover;
    width: 100%;
    max-height: 256px;
`;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DismissButton = void 0;
const react_1 = __importStar(__webpack_require__(1));
const styled_components_1 = __webpack_require__(2);
const Icons_1 = __webpack_require__(17);
const DismissingCardContext_1 = __webpack_require__(55);
const styles_1 = __webpack_require__(113);
exports.DismissButton = () => {
    const theme = react_1.useContext(styled_components_1.ThemeContext);
    const { dismiss } = react_1.useContext(DismissingCardContext_1.DismissingCardContext);
    return (react_1.default.createElement(styles_1.CircleDismissButton, { onClick: dismiss, icon: react_1.default.createElement(Icons_1.Close, { color: theme.colors['Level 4'] }) }));
};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChipText = exports.ChipWrapper = void 0;
const styled_components_1 = __importDefault(__webpack_require__(2));
exports.ChipWrapper = styled_components_1.default.div `
    position: relative;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    margin: 0 8px 8px 0;
    padding: 4px 8px;
    min-height: 16px;
    min-width: 24px;
    background-color: ${({ theme, $background }) => $background || theme.colors.Color1};
    border-radius: 24px;
    box-sizing: border-box;
`;
exports.ChipText = styled_components_1.default.span `
    ${({ theme }) => theme.typography.SmallCapsHeadline};
    font-size: 8.5px;
    line-height: 10px;
    color: #ffffff;
`;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceWrapper = exports.Desc = exports.Title = exports.TitleWrapper = exports.ChipList = exports.FavoriteWrapper = exports.Img = exports.ImgWrapper = exports.ProductCardWrapper = void 0;
const styled_components_1 = __importStar(__webpack_require__(2));
const maxLines = (lines) => ({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    '-webkit-box-orient': 'vertical',
    '-webkit-line-clamp': lines.toString(),
    lineHeight: '20px',
    maxHeight: `${20 * lines}px`,
});
exports.ProductCardWrapper = styled_components_1.default.div `
    position: relative;
    display: grid;
    grid-gap: 4px 12px;
    margin: 16px;
    min-width: 220px;

    background-color: #fff;
    border: 2px solid #f1f1f1;
    border-radius: 8px;
    box-sizing: border-box;

    ${({ cardType }) => cardType &&
    styled_components_1.css `
            padding: ${cardType === 'tall' ? '16px' : '12px'};

            grid-template-areas: ${cardType === 'tall'
        ? `'img' 'title' 'desc' 'price'`
        : `'img title' 'img desc' 'img price'`};
            grid-template-rows: ${cardType === 'tall'
        ? `minmax(auto, 240px) 40px 40px 20px`
        : `auto 20px 20px`};
            grid-template-columns: ${cardType === 'tall' ? `auto` : `80px auto`};

            height: ${cardType === 'tall' && '384px'};
        `};
`;
exports.ImgWrapper = styled_components_1.default.div `
    grid-area: img;
    display: flex;
    align-items: center;
    justify-content: center;
    justify-self: center;

    ${({ cardType }) => cardType &&
    styled_components_1.css `
            margin-bottom: ${cardType === 'tall' && '12px'};
            width: ${cardType === 'tall' ? '220px' : '80px'};
            height: ${cardType === 'tall' ? '220px' : '100%'};

            > * {
                max-height: ${cardType === 'tall' ? '220px' : '80px'};
            }
        `};
`;
exports.Img = styled_components_1.default.img `
    width: 100%;
`;
exports.FavoriteWrapper = styled_components_1.default.div `
    z-index: 2;
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
`;
exports.ChipList = styled_components_1.default.div `
    display: flex;
    flex-wrap: wrap;

    ${({ cardType }) => cardType &&
    cardType === 'tall' &&
    styled_components_1.css `
            position: absolute;
            top: 16px;
            left: 16px;
            right: 40px;
        `};
`;
exports.TitleWrapper = styled_components_1.default.div `
    grid-area: title;
    align-self: flex-end;
    max-width: calc(100% - 20px);
`;
exports.Title = styled_components_1.default.span `
    ${({ theme }) => theme.typography.SmallHeadline};
    ${({ cardType }) => cardType === 'tall' && maxLines(2)};
`;
exports.Desc = styled_components_1.default.span `
    ${({ theme }) => theme.typography.TinyParagraph};
    ${({ cardType }) => maxLines(cardType === 'tall' ? 2 : 1)};
    grid-area: desc;
    align-self: flex-start;
`;
exports.PriceWrapper = styled_components_1.default.span `
    ${({ theme }) => theme.typography.TinyParagraph};
    grid-area: price;
`;


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioBox = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const darkBaseTheme_1 = __importDefault(__webpack_require__(59));
const withRipple_1 = __importDefault(__webpack_require__(20));
const styles_1 = __webpack_require__(116);
const Button = withRipple_1.default(styles_1.RadioButton);
exports.RadioBox = ({ id, name, label, value, isChecked = false, onChange, className, }) => (react_1.default.createElement(Button, { type: "button", role: "button", className: className, isChecked: isChecked, rippleColor: darkBaseTheme_1.default.colors['Level 2'] },
    react_1.default.createElement(styles_1.Label, { htmlFor: id },
        react_1.default.createElement(styles_1.Input, { id: id, type: "radio", role: "radio", "aria-checked": isChecked, name: name, value: value, checked: isChecked, onChange: onChange }),
        react_1.default.createElement(styles_1.Text, null, label))));


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioBoxGroup = void 0;
const react_1 = __importStar(__webpack_require__(1));
const styles_1 = __webpack_require__(116);
exports.RadioBoxGroup = ({ testId, name, children, defaultValue = '', onChange, className, }) => {
    const [checkedValue, setCheckedValue] = react_1.useState(defaultValue);
    const changeHandler = react_1.useCallback((event) => {
        const { value } = event.target;
        if (typeof onChange === 'function') {
            onChange(event);
        }
        setCheckedValue(value);
    }, [onChange]);
    return (react_1.default.createElement(styles_1.GroupContainer, { "data-testid": testId, className: className }, react_1.default.Children.map(children, (radioButton) => react_1.default.cloneElement(radioButton, {
        name,
        isChecked: radioButton.props.value === checkedValue,
        onChange: changeHandler,
    }))));
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Hint = void 0;
const react_1 = __importStar(__webpack_require__(1));
const styled_components_1 = __webpack_require__(2);
const Icons_1 = __webpack_require__(17);
const styles_1 = __webpack_require__(117);
exports.Hint = ({ className, text, iconColor, textColor, backgroundColor, isFullWidth, }) => {
    const theme = react_1.useContext(styled_components_1.ThemeContext);
    return (react_1.default.createElement(styles_1.Container, { className: className, backgroundColor: backgroundColor, isFullWidth: isFullWidth },
        react_1.default.createElement(styles_1.IconWrap, null,
            react_1.default.createElement(Icons_1.InfoOutline, { color: iconColor !== null && iconColor !== void 0 ? iconColor : theme.colors['Level 5'] })),
        react_1.default.createElement(styles_1.Text, { color: textColor }, text)));
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DismissibleHint = void 0;
const react_1 = __importStar(__webpack_require__(1));
const styled_components_1 = __webpack_require__(2);
const Icons_1 = __webpack_require__(17);
const DismissingCard_1 = __webpack_require__(31);
const styles_1 = __webpack_require__(117);
exports.DismissibleHint = ({ className, text, iconColor, textColor, backgroundColor, isFullWidth, onDismiss, dismissedText, undoButtonText, }) => {
    const theme = react_1.useContext(styled_components_1.ThemeContext);
    return (react_1.default.createElement(styles_1.DismissibleHintContainer, { as: DismissingCard_1.DismissingCard, className: className, backgroundColor: backgroundColor, isFullWidth: isFullWidth, onDismiss: onDismiss, dismissedText: dismissedText, undoButtonText: undoButtonText, hasTimeout: true },
        react_1.default.createElement(styles_1.DismissibleHintContent, null,
            react_1.default.createElement(styles_1.IconWrap, null,
                react_1.default.createElement(Icons_1.InfoOutline, { color: iconColor !== null && iconColor !== void 0 ? iconColor : theme.colors['Level 5'] })),
            react_1.default.createElement(styles_1.Text, { color: textColor }, text)),
        react_1.default.createElement(styles_1.DismissButton, { position: { top: 6, right: 6 } })));
};


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = exports.Input = exports.Container = void 0;
const styled_components_1 = __importDefault(__webpack_require__(2));
const omitProps_1 = __importDefault(__webpack_require__(70));
const elevation_1 = __webpack_require__(11);
exports.Container = styled_components_1.default.div `
    display: flex;
    align-items: center;

    ${({ disabled }) => disabled ? 'pointer-events: none; opacity: .5;' : ''}
`;
exports.Input = styled_components_1.default(omitProps_1.default('accentColor', 'intermediate')('input')) `
    position: absolute;
    height: 0;
    width: 0;
    visibility: hidden;
    appearance: none;

    &:checked + label {
        background: ${({ intermediate, theme }) => intermediate ? theme.colors.caution : theme.colors.positive};
        ${elevation_1.elevation(-1, false)}
    }

    &:checked + label:after {
        left: calc(100% - 4px);
        transform: translateX(-100%);
        background: ${({ theme }) => theme.colors.Background};
        ${elevation_1.elevation(1, false)}
    }
`;
exports.Label = styled_components_1.default.label `
    cursor: pointer;
    text-indent: -9999px;
    width: 48px;
    height: 24px;
    display: flex;
    align-items: center;
    border-radius: 50px;
    position: relative;
    transition: 150ms ease-out;
    background: ${({ theme }) => theme.colors['Level 1']};

    &:after {
        content: '';
        position: absolute;
        left: 4px;
        width: 16px;
        height: 16px;
        border-radius: 16px;
        transition: 150ms ease-out;
        background: ${({ theme }) => theme.colors['Level 5']};
    }

    &:active:after {
        width: 24px;
    }
`;


/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = exports.KnobValuePlus = exports.KnobValue = exports.Knob = exports.TrackValuePlus = exports.TrackValue = exports.Point = exports.PointSection = exports.Track = exports.KnobContainer = exports.Container = exports.Selector = void 0;
const styled_components_1 = __importStar(__webpack_require__(2));
const constants_1 = __webpack_require__(120);
exports.Selector = styled_components_1.default.div `
    display: flex;
    justify-content: center;
    align-items: center;
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
`;
exports.Container = styled_components_1.default.div `
    display: flex;
    position: relative;
    flex: 1 1 auto;
`;
exports.KnobContainer = styled_components_1.default.div `
    position: absolute;
    top: -10px;
    left: 0;
    transition: ${(props) => props.animated ? `transform 0.2s cubic-bezier(0.4, 0.0, 0.2, 1)` : 'none'};
    transition-delay: ${(props) => (props.animated ? '.05s' : 'none')};
`;
const minWidth = constants_1.planSectionMinimalWidth / 2;
exports.Track = styled_components_1.default.div `
    display: flex;
    overflow: hidden;
    height: ${constants_1.planSectionHeight}px;
    padding: 0 ${constants_1.trackPaddingSize}px;
    box-sizing: border-box;
    flex: 1 0 auto;
    border-radius: ${constants_1.planSectionHeight}px;
    cursor: pointer;
    letter-spacing: 0.05em;
    border: 2px solid ${({ theme }) => `${theme.colors['Level 1']}`};
`;
exports.PointSection = styled_components_1.default.div `
    flex: 1 1 auto;
    min-width: ${constants_1.planSectionMinimalWidth}px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    cursor: pointer;
    user-select: none;
    mix-blend-mode: normal;

    &:first-child,
    &:last-child {
        min-width: ${(props) => (props.isShortVersion ? 'initial' : minWidth)};
        flex-grow: ${(props) => (props.isShortVersion ? 1 : 0.5)};
        overflow: ${(props) => (props.isShortVersion ? 'initial' : 'visible')};
        justify-content: ${(props) => (props.isShortVersion ? 'center' : 'unset')};
    }

    &:first-child {
        justify-content: flex-start;
    }

    &:last-child {
        justify-content: flex-end;
    }
`;
exports.Point = styled_components_1.default.div `
    width: ${constants_1.planContainerWidth}px;
    height: ${constants_1.planContainerHeight}px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: ${({ hasAccentColors, isDisabled, backgroundColor }) => isDisabled ? 'none' : hasAccentColors ? backgroundColor : 'none'};

    &--firstChild {
        transform: ${(props) => (props.isShortVersion ? 'initial' : 'translateX(-50%)')};
    }

    &--lastChild {
        transform: ${(props) => (props.isShortVersion ? 'initial' : 'translateX(50%)')};
    }
`;
exports.TrackValue = styled_components_1.default.div `
    box-sizing: content-box;
    text-overflow: ellipsis;
    overflow: hidden;
    ${(props) => styled_components_1.css(props.theme.typography.SmallCapsHeadline)};
    line-height: 18px;
    text-align: center;
    color: ${({ hasAccentColors, isDisabled, textColor, theme }) => isDisabled
    ? theme.colors['Level 2']
    : hasAccentColors
        ? textColor
        : theme.colors['Level 4']};
`;
exports.TrackValuePlus = styled_components_1.default.span ``;
exports.Knob = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    width: ${constants_1.knobDiamiter}px;
    height: ${constants_1.knobDiamiter}px;
    background-color: ${({ hasAccentColors, isDisabled, backgroundColor, theme }) => isDisabled ? '#e0e0e0' : hasAccentColors ? backgroundColor : theme.colors.Background};
    border-radius: 50%;
    cursor: pointer;
    user-select: none;
    overflow: hidden;
    transform: ${(props) => (props.isPressed ? 'scale(1)' : 'scale(1.1)')};
    box-shadow: ${(props) => props.isPressed ? ` 0px 2px 6px rgba(0, 0, 0, 0.13)` : `0px 4px 10px rgba(0, 0, 0, 0.13)`};

    &:hover {
        box-shadow: 0px 7px 15px rgba(0, 0, 0, 0.13);
    }
`;
exports.KnobValue = styled_components_1.default.div `
    ${(props) => styled_components_1.css(props.theme.typography.Subheadline)};
    display: flex;
    margin: 0 auto;
    text-overflow: ellipsis;
    text-align: center;
    text-transform: uppercase;
    color: ${({ hasAccentColors, isDisabled, textColor, theme }) => isDisabled ? '#fff' : hasAccentColors ? textColor : theme.colors.Foreground};
    transition: color 100ms linear;
`;
exports.KnobValuePlus = styled_components_1.default.span `
    font-size: 16px;
`;
exports.Label = styled_components_1.default.div `
    display: block;
    ${(props) => styled_components_1.css(props.theme.typography.SmallCapsHeadline)};
    font-size: 8px;
    letter-spacing: 0.05em;
    text-transform: uppercase;
    font-style: normal;
    line-height: normal;
    font-weight: bold;
    text-align: center;
    color: ${({ hasAccentColors, isDisabled, textColor, theme }) => isDisabled ? '#fff' : hasAccentColors ? textColor : theme.colors['Level 4']};
    transition: color 100ms linear;
`;


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.thumbsUpIconPath = exports.thumbsDownIconPath = void 0;
exports.thumbsDownIconPath = 'M400,848C458,848,462,810,462,766C462,734,438,686,425,660C412,633,432,600,462,600H552C547,587,545,573,545,559C545,527,557,498,576,476C557,454,545,425,545,393C545,361,557,332,576,310C557,288,545,259,545,228C545,213,547,199,552,186H404C327,186,269,245,269,309C269,332,251,351,228,351C205,351,186,332,186,309C186,280,193,252,204,228H90V145H274C310,119,356,103,404,103H710C779,103,834,159,834,228C834,250,829,270,819,288C853,311,876,349,876,393C876,415,870,436,860,454C894,476,917,515,917,559C917,627,862,683,793,683C705,683,617,683,529,683C529,683,545,709,545,724V807C545,886,472,931,400,931C361,931,323,918,297,890V732L227,559H90V476H283L379,716V845C386,847,393,848,400,848zM752,434C775,434,793,416,793,393C793,370,775,352,752,352H669C646,352,628,370,628,393C628,416,646,434,669,434H752zM793,517H669C646,517,628,536,628,559C628,581,646,600,669,600H793C816,600,834,581,834,559C834,536,816,517,793,517zM669,269H710C733,269,752,250,752,228C752,205,733,186,710,186C697,186,683,186,669,186C646,186,628,205,628,228C628,250,646,269,669,269zM400,848C458,848,462,810,462,766C462,734,438,686,425,660C412,633,432,600,462,600H552C547,587,545,573,545,559C545,527,557,498,576,476C557,454,545,425,545,393C545,361,557,332,576,310C557,288,545,259,545,228C545,213,547,199,552,186H404C327,186,269,245,269,309C269,332,251,351,228,351C205,351,186,332,186,309C186,280,193,252,204,228H90V145H274C310,119,356,103,404,103H710C779,103,834,159,834,228C834,250,829,270,819,288C853,311,876,349,876,393C876,415,870,436,860,454C894,476,917,515,917,559C917,627,862,683,793,683C705,683,617,683,529,683C529,683,545,709,545,724V807C545,886,472,931,400,931C361,931,323,918,297,890V732L227,559H90V476H283L379,716V845C386,847,393,848,400,848zM752,434C775,434,793,416,793,393C793,370,775,352,752,352H669C646,352,628,370,628,393C628,416,646,434,669,434H752zM793,517H669C646,517,628,536,628,559C628,581,646,600,669,600H793C816,600,834,581,834,559C834,536,816,517,793,517zM669,269H710C733,269,752,250,752,228C752,205,733,186,710,186C697,186,683,186,669,186C646,186,628,205,628,228C628,250,646,269,669,269z';
exports.thumbsUpIconPath = 'M400,180C394,180,387,181,380,183V308L287,540H100V460H233L300,292V140C326,112,363,100,400,100C470,100,540,144,540,220V300C540,314,525,340,525,340C610,340,695,340,780,340C846,340,900,394,900,460C900,502,878,540,845,561C854,579,860,599,860,620C860,662,838,700,805,721C814,739,820,759,820,780C820,846,766,900,700,900H404C357,900,313,885,278,860H100V780H211C200,756,193,729,193,701C193,679,211,661,233,661C256,661,273,679,273,701C273,764,330,820,404,820H547C542,807,540,794,540,780C540,749,552,721,571,700C552,679,540,651,540,620C540,589,552,561,571,540C552,519,540,491,540,460C540,446,542,432,547,420H460C431,420,411,388,424,362C437,337,460,290,460,260C460,217,456,180,400,180zM740,580H660C638,580,620,598,620,620C620,642,638,660,660,660H740C762,660,780,642,780,620C780,598,762,580,740,580zM780,500C802,500,820,482,820,460C820,438,802,420,780,420H660C638,420,620,438,620,460C620,482,638,500,660,500H780zM660,740C638,740,620,758,620,780C620,802,638,820,660,820C673,820,687,820,700,820C722,820,740,802,740,780C740,758,722,740,700,740H660zM400,180C394,180,387,181,380,183V308L287,540H100V460H233L300,292V140C326,112,363,100,400,100C470,100,540,144,540,220V300C540,314,525,340,525,340C610,340,695,340,780,340C846,340,900,394,900,460C900,502,878,540,845,561C854,579,860,599,860,620C860,662,838,700,805,721C814,739,820,759,820,780C820,846,766,900,700,900H404C357,900,313,885,278,860H100V780H211C200,756,193,729,193,701C193,679,211,661,233,661C256,661,273,679,273,701C273,764,330,820,404,820H547C542,807,540,794,540,780C540,749,552,721,571,700C552,679,540,651,540,620C540,589,552,561,571,540C552,519,540,491,540,460C540,446,542,432,547,420H460C431,420,411,388,424,362C437,337,460,290,460,260C460,217,456,180,400,180zM740,580H660C638,580,620,598,620,620C620,642,638,660,660,660H740C762,660,780,642,780,620C780,598,762,580,740,580zM780,500C802,500,820,482,820,460C820,438,802,420,780,420H660C638,420,620,438,620,460C620,482,638,500,660,500H780zM660,740C638,740,620,758,620,780C620,802,638,820,660,820C673,820,687,820,700,820C722,820,740,802,740,780C740,758,722,740,700,740H660z';


/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledTextArea = exports.Paragraph = exports.Title = exports.IconContainer = exports.CircleBackground = exports.Circle = exports.IconsWrap = void 0;
const styled_components_1 = __importDefault(__webpack_require__(2));
exports.IconsWrap = styled_components_1.default.div `
    display: flex;
    margin-top: ${({ theme }) => theme.spacers.M};
`;
exports.Circle = styled_components_1.default.div `
    width: 48px;
    height: 48px;
    grid-area: icon;
    place-self: center left;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    overflow: hidden;
`;
exports.CircleBackground = styled_components_1.default.div `
    background-color: ${({ theme }) => theme.colors.Color2_75};
    opacity: 0.1;
    position: absolute;
    width: 100%;
    height: 100%;
`;
exports.IconContainer = styled_components_1.default.div `
    cursor: pointer;
    &:first-child {
        margin-right: ${({ theme }) => theme.spacers.M};
    }
`;
exports.Title = styled_components_1.default.h2 `
    ${({ theme }) => theme.typography.SmallHeadline};
    color: ${({ theme }) => theme.colors.Foreground};
    padding-bottom: ${({ theme }) => theme.spacers.M};
    padding-right: ${({ theme }) => theme.spacers.XL};
`;
exports.Paragraph = styled_components_1.default.p `
    ${({ theme }) => theme.typography.Paragraph};
    color: ${({ theme }) => theme.colors['Level 5']};
`;
exports.StyledTextArea = styled_components_1.default.textarea.attrs({ rows: 1, maxLength: 1000 }) `
    width: 100%;
    height: 92px;
    border: 1px solid ${({ theme }) => theme.colors['Level 1']};
    box-sizing: border-box;
    border-radius: 4px;
    /* resetting default styles */
    padding: 0;
    margin: 0;
    resize: none;
    overflow: hidden;
    outline: none;
    outline-offset: 0;
    box-shadow: none;
    background: none;
    color: ${({ theme }) => theme.colors['Level 5']};
    padding: ${({ theme }) => theme.spacers.M};
    ${({ theme }) => theme.typography.Paragraph};
    text-align: left;
    margin: ${({ theme }) => theme.spacers.M} 0;
`;


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = exports.Content = exports.Info = exports.Main = void 0;
const styled_components_1 = __importStar(__webpack_require__(2));
const SonntagButtonV2_1 = __importDefault(__webpack_require__(27));
exports.Main = styled_components_1.default.div `
    width: 100%;
    user-select: none;
`;
exports.Info = styled_components_1.default.div `
    display: flex;
    justify-content: space-between;

    ${(props) => styled_components_1.css `
        padding: 0 ${props.theme.spacers.M} ${props.theme.spacers.L} ${props.theme.spacers.M};
        color: ${props.theme.colors['Level 4']};
    `}

    ${(props) => styled_components_1.css(props.theme.typography.SmallCapsHeadline)}
`;
exports.Content = styled_components_1.default.div `
    display: grid;
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: auto;
    grid-row-gap: ${(props) => props.theme.spacers.M};
`;
exports.Button = styled_components_1.default(SonntagButtonV2_1.default) `
    margin-top: ${(props) => props.theme.spacers.L};
`;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QuantityIndicator = exports.Main = exports.NextCard = exports.StyledSubscription = void 0;
const styled_components_1 = __importStar(__webpack_require__(2));
const Card_1 = __webpack_require__(22);
const Subscription_1 = __importDefault(__webpack_require__(80));
exports.StyledSubscription = styled_components_1.default(Subscription_1.default) `
    position: relative;
    z-index: 1;

    ${(props) => styled_components_1.css `
        margin-bottom: ${props.theme.spacers.M};
    `}
`;
exports.NextCard = styled_components_1.default(Card_1.Card) `
    position: absolute;
    pointer-events: none;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    transition: all 0.2s;

    ${(props) => styled_components_1.css `
        top: ${props.theme.spacers.M};
    `}
`;
exports.Main = styled_components_1.default.div `
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;

    ${(props) => styled_components_1.css `
        &:hover {
            ${exports.NextCard} {
                left: ${props.theme.spacers.M};
                right: ${props.theme.spacers.M};
            }
        }
    `}
`;
exports.QuantityIndicator = styled_components_1.default.div `
    ${(props) => styled_components_1.css(props.theme.typography.SmallHeadline)};
    height: 32px;
    width: 32px;
    border-radius: 16px;
    background-color: ${({ theme, $color }) => $color !== null && $color !== void 0 ? $color : theme.colors.secondary};
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${(props) => props.theme.colors.Background};
`;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Circle = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const styles_1 = __webpack_require__(78);
exports.Circle = ({ icon, borderColor, color, hasBadge, badgeColor, badgeBorderColor, badgeIcon, badgeText, badgeTextColor, isTransparent, }) => (react_1.default.createElement(styles_1.CircleContainer, { isTransparent: isTransparent },
    react_1.default.createElement(styles_1.Circle, { borderColor: borderColor, backgroundColor: color }, icon),
    hasBadge && (react_1.default.createElement(styles_1.CircleBadge, { borderColor: badgeBorderColor, backgroundColor: badgeColor },
        badgeIcon && badgeIcon,
        badgeText && react_1.default.createElement(styles_1.CircleBadgeText, { color: badgeTextColor }, badgeText)))));


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowRightIcon = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const react_native_svg_1 = __webpack_require__(9);
exports.ArrowRightIcon = ({ className, size = 24, color, ...restProps }) => (react_1.default.createElement(react_native_svg_1.Svg, Object.assign({}, restProps, { className: className, width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }),
    react_1.default.createElement(react_native_svg_1.Path, { fillRule: "evenodd", clipRule: "evenodd", d: "M9.29289 16.7071C8.90237 16.3166 8.90237 15.6834 9.29289 15.2929L12.5858 12L9.29289 8.70711C8.90237 8.31658 8.90237 7.68342 9.29289 7.29289C9.68342 6.90237 10.3166 6.90237 10.7071 7.29289L15.4142 12L10.7071 16.7071C10.3166 17.0976 9.68342 17.0976 9.29289 16.7071Z", fill: color })));


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
const react_1 = __importDefault(__webpack_require__(1));
const styles_web_1 = __webpack_require__(78);
exports.Container = ({ className, children, onClick, href, disabled, target, }) => {
    if (disabled || !href) {
        return (react_1.default.createElement(styles_web_1.FunctionalButton, { className: className, disabled: disabled, onClick: onClick }, children));
    }
    return (react_1.default.createElement(styles_web_1.Link, { className: className, onClick: onClick, href: href, target: target }, children));
};


/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountActions = void 0;
const react_1 = __importStar(__webpack_require__(1));
const styled_components_1 = __webpack_require__(2);
const Action_1 = __webpack_require__(58);
const Icons_1 = __webpack_require__(17);
exports.AccountActions = ({ actionsProps, unreadMessages, }) => {
    const theme = react_1.useContext(styled_components_1.ThemeContext);
    const { Wishlist, YourPayments, ReferralCode, ContactUs, SignIn } = actionsProps;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        Wishlist && !Wishlist.isHidden && (react_1.default.createElement(Action_1.Action, Object.assign({}, Wishlist, { icon: react_1.default.createElement(Icons_1.HeartOutlineIcon, { color: theme.colors.secondary, size: "24px" }) }))),
        YourPayments && !YourPayments.isHidden && (react_1.default.createElement(Action_1.Action, Object.assign({}, YourPayments, { icon: react_1.default.createElement(Icons_1.BankIcon, { color: theme.colors.secondary, size: "24px" }) }))),
        ReferralCode && !ReferralCode.isHidden && (react_1.default.createElement(Action_1.Action, Object.assign({}, ReferralCode, { icon: react_1.default.createElement(Icons_1.HappyFaceIcon, { color: theme.colors.secondary, size: "24px" }) }))),
        ContactUs && !ContactUs.isHidden && (react_1.default.createElement(Action_1.Action, Object.assign({}, ContactUs, { icon: react_1.default.createElement(Icons_1.EmailIcon, { color: theme.colors.secondary, size: "24px" }), textColor: unreadMessages > 0 ? theme.colors.secondary : undefined, descriptionColor: unreadMessages > 0 ? theme.colors.secondary : undefined, hasCircleBadge: unreadMessages > 0, circleBadgeText: unreadMessages, circleBadgeColor: theme.colors.negative, circleBadgeBorderColor: theme.colors.ElementBackground, circleBadgeTextColor: theme.colors.Background }))),
        SignIn && !SignIn.isHidden && (react_1.default.createElement(Action_1.Action, Object.assign({}, SignIn, { icon: react_1.default.createElement(Icons_1.SignInIcon, { color: theme.colors.secondary, size: "24px" }) })))));
};


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TopSection = void 0;
const react_1 = __importStar(__webpack_require__(1));
const styled_components_1 = __webpack_require__(2);
const palette_1 = __importDefault(__webpack_require__(44));
const Action_1 = __webpack_require__(58);
const Icons_1 = __webpack_require__(17);
const styles_1 = __webpack_require__(125);
exports.TopSection = ({ actionProps, userName, accountEmail, isAccountVerified, isAccountIncomplete, profileButtonText, }) => {
    const theme = react_1.useContext(styled_components_1.ThemeContext);
    const circleBadgeProps = react_1.useMemo(() => {
        if (isAccountIncomplete) {
            return {
                hasCircleBadge: true,
                circleBadgeColor: theme.colors.ElementBackground,
                circleBadgeIcon: react_1.default.createElement(styles_1.CircleAttentionIcon, { size: 20, color: theme.colors.caution }),
                circleBorderColor: palette_1.default.yolk[50],
            };
        }
        if (isAccountVerified) {
            return {
                hasCircleBadge: true,
                circleBadgeColor: theme.colors.ElementBackground,
                circleBadgeIcon: react_1.default.createElement(styles_1.CircleTickIcon, { size: 20, color: theme.colors.positive }),
                circleBorderColor: palette_1.default.broccoli[25],
            };
        }
        return undefined;
    }, [isAccountVerified, isAccountIncomplete]);
    return (react_1.default.createElement(Action_1.Action, Object.assign({}, actionProps, circleBadgeProps, { icon: react_1.default.createElement(Icons_1.AccountOutlineIcon, { color: theme.colors.secondary }), title: userName, description: accountEmail, hasAdditionalButton: true, additionalButtonText: profileButtonText })));
};


/***/ })
/******/ ]);
});